/*!
 * "Very, Very, Very Restricted License"
 * 
 * Copyright (c) 2016 BAMTech
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 * 
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["bam-hls"] = factory();
	else
		root["bam-hls"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _HlsStream = __webpack_require__(105);
	
	var _HlsStream2 = _interopRequireDefault(_HlsStream);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _HlsStream2.default;
	
	/*if (process.env.device_family === 'browser' &&
	  process.env.device_family === 'browser' &&
	  process.env.application_runtime === 'es5') {
	  // This line of code will be the runtime for browser
	} else {
	  // Everything else
	}*/
	/**
	* @private
	*/

	module.exports = exports['default'];

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function noop() {}
	
	var fakeLogger = {
		trace: noop,
		debug: noop,
		log: noop,
		warn: noop,
		info: noop,
		error: noop
	};
	
	var exportedLogger = fakeLogger;
	
	/*globals self: false */
	
	//let lastCallTime;
	// function formatMsgWithTimeInfo(type, msg) {
	//   const now = Date.now();
	//   const diff = lastCallTime ? '+' + (now - lastCallTime) : '0';
	//   lastCallTime = now;
	//   msg = (new Date(now)).toISOString() + ' | [' +  type + '] > ' + msg + ' ( ' + diff + ' ms )';
	//   return msg;
	// }
	
	function formatMsg(type, msg) {
		var myMsg = '[' + type + '] > ' + msg;
	
		return myMsg;
	}
	
	function consolePrintFn(type) {
		var func = self.console[type];
		if (func) {
			return function () {
				for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
					args[_key] = arguments[_key];
				}
	
				if (args[0]) {
					args[0] = formatMsg(type, args[0]);
				}
				func.apply(self.console, args);
			};
		}
		return noop;
	}
	
	function exportLoggerFunctions(debugConfig) {
		for (var _len2 = arguments.length, functions = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
			functions[_key2 - 1] = arguments[_key2];
		}
	
		functions.forEach(function (type) {
			exportedLogger[type] = debugConfig[type] ? debugConfig[type].bind(debugConfig) : consolePrintFn(type);
		});
	}
	
	var enableLogs = exports.enableLogs = function enableLogs(debugConfig) {
		if (debugConfig === true || (typeof debugConfig === 'undefined' ? 'undefined' : _typeof(debugConfig)) === 'object') {
			exportLoggerFunctions(debugConfig,
	
			// Remove out from list here to hard-disable a log-level
			//'trace',
			'debug', 'log', 'info', 'warn', 'error');
			// Some browsers don't allow to use bind on console object anyway
			// fallback to default if needed
			try {
				exportedLogger.log();
			} catch (e) {
				exportedLogger = fakeLogger;
			}
		} else {
			exportedLogger = fakeLogger;
		}
	};
	
	var logger = exports.logger = exportedLogger;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(8);
	var core = __webpack_require__(18);
	var hide = __webpack_require__(25);
	var redefine = __webpack_require__(30);
	var ctx = __webpack_require__(19);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 3 */
/***/ (function(module, exports) {

	'use strict';
	
	var _module$exports;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	module.exports = (_module$exports = {
	  // fired before MediaSource is attaching to media element - data: { media }
	  MEDIA_ATTACHING: 'hlsMediaAttaching',
	  // fired when MediaSource has been succesfully attached to media element - data: { }
	  MEDIA_ATTACHED: 'hlsMediaAttached',
	  // fired before detaching MediaSource from media element - data: { }
	  MEDIA_DETACHING: 'hlsMediaDetaching',
	  // fired when MediaSource has been detached from media element - data: { }
	  MEDIA_DETACHED: 'hlsMediaDetached',
	  // fired when we buffer is going to be resetted
	  BUFFER_RESET: 'hlsBufferReset',
	  // fired when we know about the codecs that we need buffers for to push into - data: {tracks : { container, codec, levelCodec, initSegment, metadata }}
	  BUFFER_CODECS: 'hlsBufferCodecs',
	  // fired when sourcebuffers have been created data: { tracks : tracks}
	  BUFFER_CREATED: 'hlsBufferCreated',
	  // fired when we append a segment to the buffer - data: { segment: segment object }
	  BUFFER_APPENDING: 'hlsBufferAppending',
	  // fired when we are done with appending a media segment to the buffer data : { parent : segment parent that triggered BUFFER_APPENDING , pending : nb of segments waiting for appending for this segment parent}
	  BUFFER_APPENDED: 'hlsBufferAppended',
	  // fired when the stream is finished and we want to notify the media buffer that there will be no more data
	  BUFFER_EOS: 'hlsBufferEos',
	  // fired when the media buffer should be flushed - data {startOffset, endOffset}
	  BUFFER_FLUSHING: 'hlsBufferFlushing',
	  // fired when the media has been flushed
	  BUFFER_FLUSHED: 'hlsBufferFlushed',
	  // fired to signal that a manifest loading starts - data: { url : manifestURL}
	  BUFFER_SOURCE_SEEKING: 'hlsBufferSourceSeeking'
	}, _defineProperty(_module$exports, 'BUFFER_SOURCE_SEEKING', 'hlsBufferSourceSeeking'), _defineProperty(_module$exports, 'BUFFER_WAIT', 'hlsBufferWait'), _defineProperty(_module$exports, 'MANIFEST_LOADING', 'hlsManifestLoading'), _defineProperty(_module$exports, 'MANIFEST_LOADED', 'hlsManifestLoaded'), _defineProperty(_module$exports, 'MANIFEST_PARSED', 'hlsManifestParsed'), _defineProperty(_module$exports, 'LEVEL_SWITCHING', 'hlsLevelSwitching'), _defineProperty(_module$exports, 'LEVEL_LOADING', 'hlsLevelLoading'), _defineProperty(_module$exports, 'LEVEL_LOADED', 'hlsLevelLoaded'), _defineProperty(_module$exports, 'LEVEL_UPDATED', 'hlsLevelUpdated'), _defineProperty(_module$exports, 'LEVEL_PTS_UPDATED', 'hlsLevelPtsUpdated'), _defineProperty(_module$exports, 'LEVEL_DURATION_UPDATED', 'hlsLevelDurationUpdated'), _defineProperty(_module$exports, 'AUDIO_TRACKS_UPDATED', 'hlsAudioTracksUpdated'), _defineProperty(_module$exports, 'AUDIO_TRACK_SWITCH', 'hlsAudioTrackSwitch'), _defineProperty(_module$exports, 'AUDIO_TRACK_SWITCHING', 'hlsAudioTrackSwitching'), _defineProperty(_module$exports, 'AUDIO_TRACK_SWITCHED', 'hlsAudioTrackSwitched'), _defineProperty(_module$exports, 'AUDIO_TRACK_LOADING', 'hlsAudioTrackLoading'), _defineProperty(_module$exports, 'AUDIO_TRACK_LOADED', 'hlsAudioTrackLoaded'), _defineProperty(_module$exports, 'SUBTITLE_TRACKS_UPDATED', 'hlsSubtitleTracksUpdated'), _defineProperty(_module$exports, 'SUBTITLE_TRACK_SWITCH', 'hlsSubtitleTrackSwitch'), _defineProperty(_module$exports, 'SUBTITLE_TRACK_LOADING', 'hlsSubtitleTrackLoading'), _defineProperty(_module$exports, 'SUBTITLE_TRACK_LOADED', 'hlsSubtitleTrackLoaded'), _defineProperty(_module$exports, 'SUBTITLE_FRAG_PROCESSED', 'hlsSubtitleFragProcessed'), _defineProperty(_module$exports, 'INIT_PTS_FOUND', 'hlsInitPtsFound'), _defineProperty(_module$exports, 'FRAG_LOADING', 'hlsFragLoading'), _defineProperty(_module$exports, 'FRAG_LOAD_PROGRESS', 'hlsFragLoadProgress'), _defineProperty(_module$exports, 'FRAG_LOAD_EMERGENCY_ABORTED', 'hlsFragLoadEmergencyAborted'), _defineProperty(_module$exports, 'FRAG_LOADED', 'hlsFragLoaded'), _defineProperty(_module$exports, 'FRAG_DECRYPTED', 'hlsFragDecrypted'), _defineProperty(_module$exports, 'FRAG_PARSING_INIT_SEGMENT', 'hlsFragParsingInitSegment'), _defineProperty(_module$exports, 'FRAG_PARSING_USERDATA', 'hlsFragParsingUserdata'), _defineProperty(_module$exports, 'FRAG_PARSING_METADATA', 'hlsFragParsingMetadata'), _defineProperty(_module$exports, 'FRAG_PARSING_DATA', 'hlsFragParsingData'), _defineProperty(_module$exports, 'FRAG_PARSED', 'hlsFragParsed'), _defineProperty(_module$exports, 'FRAG_BUFFERED', 'hlsFragBuffered'), _defineProperty(_module$exports, 'FPS_DROP', 'hlsFpsDrop'), _defineProperty(_module$exports, 'FPS_DROP_LEVEL_CAPPING', 'hlsFpsDropLevelCapping'), _defineProperty(_module$exports, 'ERROR', 'hlsError'), _defineProperty(_module$exports, 'DESTROYING', 'hlsDestroying'), _defineProperty(_module$exports, 'KEY_LOADING', 'hlsKeyLoading'), _defineProperty(_module$exports, 'KEY_LOADED', 'hlsKeyLoaded'), _defineProperty(_module$exports, 'TEXT_TRACK_ADDED', 'hlsTextTrackAdded'), _defineProperty(_module$exports, 'TEXT_TRACK_CHANGED', 'hlsTextTrackChanged'), _defineProperty(_module$exports, 'START_POSITION_SET', 'hlsStartPositionSet'), _defineProperty(_module$exports, 'LOGTUBE_LOG', 'hlsLogtubeLog'), _defineProperty(_module$exports, 'FRAG_DATERANGE_UPDATE', 'hlsFragDaterangeUpdate'), _defineProperty(_module$exports, 'STREAM_STATE_TRANSITION', 'hlsStreamStateTransition'), _defineProperty(_module$exports, 'STREAM_ALL_LEVELS_PARSED', 'hlsStreamAllLevelsParsed'), _defineProperty(_module$exports, 'STREAM_ALL_LEVELS_LOADED', 'hlsStreamAllLevelsLoaded'), _defineProperty(_module$exports, 'STREAM_LIVETIME_CHANGED', 'hlsStreamLivetimeChanged'), _defineProperty(_module$exports, 'STREAM_BASEPDT_FOUND', 'hlsStreamBasepdtFound'), _defineProperty(_module$exports, 'STREAM_DESYNC', 'hlsStreamDesync'), _defineProperty(_module$exports, 'AUDIO_TRACK_UPDATED', 'hlsAudioTrackUpdated'), _defineProperty(_module$exports, 'SUBTITLE_TRACK_UPDATED', 'hlsSubtitleTrackUpdated'), _defineProperty(_module$exports, 'BITRATE_ESTIMATE_UPDATED', 'hlsBitrateEstimateUpdated'), _defineProperty(_module$exports, 'LEVEL_SELECTION_FINISHED', 'hlsLevelSelectionFinished'), _defineProperty(_module$exports, 'FRAG_START_FOUND', 'hlsFragStartFound'), _defineProperty(_module$exports, 'SEEK_READY', 'hlsSeekReady'), _module$exports);

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var ErrorTypes = exports.ErrorTypes = {
		// Identifier for a network error (loading error / timeout ...)
		NETWORK_ERROR: 'networkError',
		// Identifier for a media Error (video/parsing/mediasource error)
		MEDIA_ERROR: 'mediaError',
		// Identifier for a mux Error (demuxing/remuxing)
		MUX_ERROR: 'muxError',
		// Identifier for all other errors
		OTHER_ERROR: 'otherError'
	};
	
	var ErrorDetails = exports.ErrorDetails = {
		// Identifier for a manifest load error - data: { url : faulty URL, response : { code: error code, text: error text }}
		MANIFEST_LOAD_ERROR: 'manifestLoadError',
		// Identifier for a manifest load timeout - data: { url : faulty URL, response : { code: error code, text: error text }}
		MANIFEST_LOAD_TIMEOUT: 'manifestLoadTimeOut',
		// Identifier for a manifest parsing error - data: { url : faulty URL, reason : error reason}
		MANIFEST_PARSING_ERROR: 'manifestParsingError',
		// Identifier for a manifest with only incompatible codecs error - data: { url : faulty URL, reason : error reason}
		MANIFEST_INCOMPATIBLE_CODECS_ERROR: 'manifestIncompatibleCodecsError',
		// Identifier for a level load error - data: { url : faulty URL, response : { code: error code, text: error text }}
		LEVEL_LOAD_ERROR: 'levelLoadError',
		// Identifier for a level load timeout - data: { url : faulty URL, response : { code: error code, text: error text }}
		LEVEL_LOAD_TIMEOUT: 'levelLoadTimeOut',
		// Identifier for a level switch error - data: { level : faulty level Id, event : error description}
		LEVEL_SWITCH_ERROR: 'levelSwitchError',
		// Identifier for unexpected level pdt gaps
		LEVEL_UNEXPECTED_GAP_ERROR: 'levelUnexpectedGapError',
		// Identifier for an audio track load error - data: { url : faulty URL, response : { code: error code, text: error text }}
		AUDIO_TRACK_LOAD_ERROR: 'audioTrackLoadError',
		// Identifier for an audio track load timeout - data: { url : faulty URL, response : { code: error code, text: error text }}
		AUDIO_TRACK_LOAD_TIMEOUT: 'audioTrackLoadTimeOut',
		// Identifier for fragment load error - data: { frag : fragment object, response : { code: error code, text: error text }}
		FRAG_LOAD_ERROR: 'fragLoadError',
		// Identifier for fragment loop loading error - data: { frag : fragment object}
		FRAG_LOOP_LOADING_ERROR: 'fragLoopLoadingError',
		// Identifier for fragment load timeout error - data: { frag : fragment object}
		FRAG_LOAD_TIMEOUT: 'fragLoadTimeOut',
		// Identifier for a fragment decryption error event - data: {id : demuxer Id,frag: fragment object, reason : parsing error description }
		FRAG_DECRYPT_ERROR: 'fragDecryptError',
		// Identifier for a fragment parsing error event - data: { id : demuxer Id, reason : parsing error description }
		// will be renamed DEMUX_PARSING_ERROR and switched to MUX_ERROR in the next major release
		FRAG_PARSING_ERROR: 'fragParsingError',
		// Identifier for a remux alloc error event - data: { id : demuxer Id, frag : fragment object, bytes : nb of bytes on which allocation failed , reason : error text }
		REMUX_ALLOC_ERROR: 'remuxAllocError',
		// Triggered when the demuxer is supposed to operate via worker but fails to create the worker
		DEMUX_WORKER_ALLOC_ERROR: 'demuxWorkerAllocError',
		//Mactrix additions end
		// Identifier for decrypt key load error - data: { frag : fragment object, response : { code: error code, text: error text }}
		KEY_LOAD_ERROR: 'keyLoadError',
		// Identifier for decrypt key load timeout error - data: { frag : fragment object}
		KEY_LOAD_TIMEOUT: 'keyLoadTimeOut',
		// Triggered when an exception occurs while adding a sourceBuffer to MediaSource - data : {  err : exception , mimeType : mimeType }
		BUFFER_ADD_CODEC_ERROR: 'bufferAddCodecError',
		// Identifier for a buffer append error - data: append error description
		BUFFER_APPEND_ERROR: 'bufferAppendError',
		// Identifier for a buffer appending error event - data: appending error description
		BUFFER_APPENDING_ERROR: 'bufferAppendingError',
		// Identifier for a buffer stalled error event
		BUFFER_STALLED_ERROR: 'bufferStalledError',
		// Identifier for a buffer full event
		BUFFER_FULL_ERROR: 'bufferFullError',
		// Identifier for a buffer seek over hole event
		BUFFER_SEEK_OVER_HOLE: 'bufferSeekOverHole',
		// Identifier for a buffer nudge on stall (playback is stuck although currentTime is in a buffered area)
		BUFFER_NUDGE_ON_STALL: 'bufferNudgeOnStall',
		// Identifier for an internal exception happening inside hls.js while handling an event
		INTERNAL_EXCEPTION: 'internalException',
		// Malformed WebVTT contents
		WEBVTT_EXCEPTION: 'webVTTException',
		//Mactrix additions start
		// emitted when output chunks are not in sync
		STREAM_SYNC_FAILED: 'streamSyncFailed',
		// media.play() failed
		MEDIA_PLAY_FAILED: 'mediaPlayFailed',
		// stream has hit a buffer stall and more than the allowed time between chunk loads has passed
		STREAM_TIMEOUT: 'streamTimeout',
		//Mactrix additions end
		// Active promise implementation does not match native implementation
		PROMISE_IS_OVERLOADED: 'promiseIsOverloaded',
		//emitted when there is an error with the eme
		DRM_ERROR: 'drmError'
	};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     * All objects in the event handling chain should inherit from this class
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     */
	
	var _logger = __webpack_require__(1);
	
	var _errors = __webpack_require__(4);
	
	var _events = __webpack_require__(3);
	
	var _events2 = _interopRequireDefault(_events);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EventHandler = function () {
	  function EventHandler(hls) {
	    _classCallCheck(this, EventHandler);
	
	    this.hls = hls;
	    this.onEvent = this.onEvent.bind(this);
	
	    for (var _len = arguments.length, events = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      events[_key - 1] = arguments[_key];
	    }
	
	    this.handledEvents = events;
	    this.useGenericHandler = true;
	
	    this.registerListeners();
	  }
	
	  _createClass(EventHandler, [{
	    key: 'destroy',
	    value: function destroy() {
	      this.unregisterListeners();
	      this.onEvent = null; //Mactrix line added, memory clean up
	    }
	  }, {
	    key: 'isEventHandler',
	    value: function isEventHandler() {
	      return _typeof(this.handledEvents) === 'object' && this.handledEvents.length && typeof this.onEvent === 'function';
	    }
	  }, {
	    key: 'registerListeners',
	    value: function registerListeners() {
	      if (this.isEventHandler()) {
	        this.handledEvents.forEach(function (event) {
	          if (event === 'hlsEventGeneric') {
	            throw new Error('Forbidden event name: ' + event);
	          }
	          this.hls.on(event, this.onEvent);
	        }.bind(this));
	      }
	    }
	  }, {
	    key: 'unregisterListeners',
	    value: function unregisterListeners() {
	      if (this.isEventHandler()) {
	        this.handledEvents.forEach(function (event) {
	          this.hls.off(event, this.onEvent);
	        }.bind(this));
	        this.handledEvents = null; //Mactrix line added, memory clean up
	      }
	    }
	
	    /**
	     * arguments: event (string), data (any)
	     */
	
	  }, {
	    key: 'onEvent',
	    value: function onEvent(event, data) {
	      this.onEventGeneric(event, data);
	    }
	  }, {
	    key: 'onEventGeneric',
	    value: function onEventGeneric(event, data) {
	      var eventToFunction = function eventToFunction(event, data) {
	        var funcName = 'on' + event.replace('hls', '');
	        if (typeof this[funcName] !== 'function') {
	          throw new Error('Event ' + event + ' has no generic handler in this ' + this.constructor.name + ' class (tried ' + funcName + ')');
	        }
	        return this[funcName].bind(this, data);
	      };
	      try {
	        eventToFunction.call(this, event, data).call();
	      } catch (err) {
	        _logger.logger.error('internal error happened while processing ' + event + ':' + err.message);
	        this.hls.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.OTHER_ERROR, details: _errors.ErrorDetails.INTERNAL_EXCEPTION, fatal: false, event: event, err: err });
	      }
	    }
	  }]);
	
	  return EventHandler;
	}();
	
	exports.default = EventHandler;
	module.exports = exports['default'];

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Utils - Various utility functions
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	var _logger = __webpack_require__(1);
	
	var _HlsEvents = __webpack_require__(14);
	
	var _HlsEvents2 = _interopRequireDefault(_HlsEvents);
	
	var _detectBrowser = __webpack_require__(47);
	
	var _detectBrowser2 = _interopRequireDefault(_detectBrowser);
	
	var _semver = __webpack_require__(99);
	
	var _semver2 = _interopRequireDefault(_semver);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	* @access internal
	*/
	var Utils = function () {
		function Utils() {
			_classCallCheck(this, Utils);
		}
	
		_createClass(Utils, null, [{
			key: 'isFunction',
			value: function isFunction(func) {
				return typeof func === 'function';
			}
		}, {
			key: 'isObject',
			value: function isObject(obj) {
				return obj && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';
			}
		}, {
			key: 'isArray',
			value: function isArray(array) {
				return Array.isArray(array);
			}
		}, {
			key: 'isEmptyArray',
			value: function isEmptyArray(array) {
				return Utils.isArray(array) && array.length === 0;
			}
		}, {
			key: 'isString',
			value: function isString(str) {
				return typeof str === 'string';
			}
		}, {
			key: 'isNull',
			value: function isNull(value) {
				return value === null;
			}
		}, {
			key: 'isDefined',
			value: function isDefined(value) {
				return value !== undefined;
			}
		}, {
			key: 'isPhantom',
			value: function isPhantom() {
				return Utils.isBrowser() && _detectBrowser2.default.name === 'phantom';
			}
		}, {
			key: 'isChrome',
			value: function isChrome() {
				return Utils.isBrowser() && _detectBrowser2.default.name === 'chrome';
			}
		}, {
			key: 'isOpera',
			value: function isOpera() {
				return Utils.isBrowser() && _detectBrowser2.default.name === 'opera';
			}
		}, {
			key: 'isChromium',
			value: function isChromium() {
				return Utils.isBrowser() && (_detectBrowser2.default.name === 'chrome' || _detectBrowser2.default.name === 'opera');
			}
		}, {
			key: 'isEdge',
			value: function isEdge() {
				return Utils.isBrowser() && _detectBrowser2.default.name === 'edge';
			}
		}, {
			key: 'isIE',
			value: function isIE() {
				return Utils.isBrowser() && _detectBrowser2.default.name === 'ie';
			}
		}, {
			key: 'isElectron',
			value: function isElectron() {
				return Utils.isBrowser() && _detectBrowser2.default.name === 'electron';
			}
		}, {
			key: 'isSafari',
			value: function isSafari() {
				return Utils.isBrowser() && _detectBrowser2.default.name === 'safari';
			}
		}, {
			key: 'isFirefox',
			value: function isFirefox() {
				return Utils.isBrowser() && _detectBrowser2.default.name === 'firefox';
			}
		}, {
			key: 'isTizen',
			value: function isTizen() {
				return Utils.isBrowser() && _detectBrowser2.default.name === 'tizen';
			}
		}, {
			key: 'isTizen2',
			value: function isTizen2() {
				return Utils.isTizen() && _semver2.default.satisfies(_detectBrowser2.default.version, '2.x.x');
			}
		}, {
			key: 'isTizen3',
			value: function isTizen3() {
				return Utils.isTizen() && _semver2.default.satisfies(_detectBrowser2.default.version, '>=3.x.x');
			}
		}, {
			key: 'isWebOS',
			value: function isWebOS() {
				return Utils.isBrowser() && _detectBrowser2.default.name === 'webos';
			}
		}, {
			key: 'isMacOS',
			value: function isMacOS() {
				return _detectBrowser2.default.platform === 'macintosh';
			}
		}, {
			key: 'isWin8Point1',
			value: function isWin8Point1() {
				return _detectBrowser2.default.platform === 'windows' && _detectBrowser2.default.platformVersion !== 'unknown' && _semver2.default.satisfies(_detectBrowser2.default.platformVersion, '6.3.0');
			}
		}, {
			key: 'isFirefoxMacOS',
			value: function isFirefoxMacOS() {
				return Utils.isFirefox() && Utils.isMacOS();
			}
		}, {
			key: 'isFirefoxBadWorker',
			value: function isFirefoxBadWorker() {
				//versions of Firefox for MacOS earlier than version 54 could cause browser crashes when workers were enabled
				//this has also been fixed in ESR 52.2 but we can't differentiate between 52.2 and 52.0
				return Utils.isFirefoxMacOS() && _semver2.default.satisfies(_detectBrowser2.default.version, '<54.0.0');
			}
		}, {
			key: 'isIEWin8Point1',
			value: function isIEWin8Point1() {
				return Utils.isIE() && Utils.isWin8Point1();
			}
		}, {
			key: 'isBrowser',
			value: function isBrowser() {
				return typeof navigator !== 'undefined';
			}
		}, {
			key: 'isChromiumMacOS',
			value: function isChromiumMacOS() {
				return Utils.isChromium() && Utils.isMacOS();
			}
		}, {
			key: 'areFunctionsDifferentiated',
			value: function areFunctionsDifferentiated() {
				var testFunction1 = function testFunction() {
					this._testFunctionProperty = 'TESTING';
				};
				var testFunction2 = function testFunction() {
					this._testFunctionProperty = 'TESTING';
				};
	
				// if the functions are differentiated, ie due to code coverage tools. this will pick it up.
				return testFunction1 !== testFunction2;
			}
		}, {
			key: 'isWallaby',
			value: function isWallaby() {
				/*
	   	wallaby is a dynamic test runner. It runs tests in either PhantomJS or Electron (ie Chromium)
	   	if it is present the wallaby global will be.
	   		This matters because wallaby instruments functions, and if they're instrumented they can be
	   	differentiated, which affects tests.
	    */
				return typeof wallaby !== 'undefined';
			}
		}, {
			key: 'isWebpack',
			value: function isWebpack() {
				/*
	   	webpack and browserify require different packages to run workers. This may affect functionality, and also
	   	requires some tests to be written to adapt to both possibilities.
	   */
				return typeof __webpack_require__.m !== 'undefined'; //eslint-disable-line camelcase
			}
		}, {
			key: 'hasWorker',
			value: function hasWorker() {
				//TODO: should this return false if we're forcibly disabling workers (like in Firefox for Mac)?
				return typeof Worker !== 'undefined';
			}
	
			// property has to exist in the object's prototype, and be settable.
	
		}, {
			key: 'isPropertySettable',
			value: function isPropertySettable(classInstance, prop) {
				var settable = false;
	
				// if the property exists in the class instance
				if (prop in classInstance) {
					// get the property descriptor for this property from our prototype (which is the class definition)
					var propDescriptor = Object.getOwnPropertyDescriptor(Object.getPrototypeOf(classInstance), prop);
	
					// if there is a set function for the property, then it a setter
					if (propDescriptor.set !== undefined) {
						settable = true;
					}
				}
	
				return settable;
			}
		}, {
			key: 'getClassName',
			value: function getClassName(classInstance) {
				// in ES6, the name of the constructor function is the same as the class.
				return classInstance.constructor.name;
			}
		}, {
			key: 'getClassPropertyName',
			value: function getClassPropertyName(classInstance, propetyName) {
				return Utils.getClassName(classInstance) + '.' + propetyName;
			}
		}, {
			key: 'applyValueToSetter',
			value: function applyValueToSetter(classInstance, prop, value) {
				if (Utils.isPropertySettable(classInstance, prop)) {
					_logger.logger.log('applyValueToSetter: ' + Utils.getClassPropertyName(classInstance, prop) + ' = ' + value);
					classInstance[prop] = value;
				} else {
					_logger.logger.log('applyValueToSetter: ' + Utils.getClassPropertyName(classInstance, prop) + ' is not settable (' + value + ')');
				}
			}
		}, {
			key: 'applyConfig',
			value: function applyConfig(classInstance) {
				var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
				// for all properties in the config
				for (var prop in config) {
	
					if (config.hasOwnProperty(prop)) {
						// applies the config property if the same property exists in class and is settable.
						Utils.applyValueToSetter(classInstance, prop, config[prop]);
					}
				}
			}
		}, {
			key: 'throwIfNotEvent',
			value: function throwIfNotEvent(event) {
				if (_HlsEvents2.default[event] === undefined) {
					throw new Error('event: ' + event + ' is not a known Event');
				}
			}
		}, {
			key: 'propertyCanNotBeThrow',
			value: function propertyCanNotBeThrow(value, canNotBe, propertyName) {
				throw new Error(propertyName + ' can not be ' + canNotBe + ', ( ' + value + ' )');
			}
		}, {
			key: 'propertyCanNotBeWarn',
			value: function propertyCanNotBeWarn(value, canNotBe, propertyName) {
				_logger.logger.warn(propertyName + ' can not be ' + canNotBe + ', ( ' + value + ' ), the value will be adjusted accordingly');
			}
		}, {
			key: 'propertyMustBeThrow',
			value: function propertyMustBeThrow(value, mustBe, propertyName) {
				throw new Error(propertyName + ' must be ' + mustBe + ', ( ' + value + ' )');
			}
		}, {
			key: 'checkLessThanMinusOneAndThrow',
			value: function checkLessThanMinusOneAndThrow(value, propertyName) {
				if (value < -1) {
					Utils.propertyCanNotBeThrow(value, 'less than -1', propertyName);
				}
			}
		}, {
			key: 'checkLessThanZeroPointZeroAndThrow',
			value: function checkLessThanZeroPointZeroAndThrow(value, propertyName) {
				if (value < 0.0) {
					Utils.propertyCanNotBeThrow(value, 'less than 0.0', propertyName);
				}
			}
		}, {
			key: 'checkLessThanZeroPointZeroAndWarn',
			value: function checkLessThanZeroPointZeroAndWarn(value, propertyName) {
				if (value < 0.0) {
					Utils.propertyCanNotBeWarn(value, 'less than 0.0', propertyName);
				}
			}
		}, {
			key: 'checkEqualToZeroPointZeroAndThrow',
			value: function checkEqualToZeroPointZeroAndThrow(value, propertyName) {
				if (value === 0.0) {
					Utils.propertyCanNotBeThrow(value, 'equal to 0.0', propertyName);
				}
			}
		}, {
			key: 'checkMoreThanOnePointZeroAndThrow',
			value: function checkMoreThanOnePointZeroAndThrow(value, propertyName) {
				if (value > 1.0) {
					Utils.propertyCanNotBeThrow(value, 'more than 1.0', propertyName);
				}
			}
		}, {
			key: 'checkLessThanOnePointZeroAndThrow',
			value: function checkLessThanOnePointZeroAndThrow(value, propertyName) {
				if (value < 1.0) {
					Utils.propertyCanNotBeThrow(value, 'less than 1.0', propertyName);
				}
			}
		}, {
			key: 'checkNotIntegerAndThrow',
			value: function checkNotIntegerAndThrow(value, propertyName) {
				if (!Number.isInteger) {
					if (typeof value !== 'number') {
						Utils.propertyMustBeThrow(value, 'an integer', propertyName);
					}
					if (!isFinite(value)) {
						Utils.propertyMustBeThrow(value, 'an integer', propertyName);
					}
					if (value % 1 !== 0) {
						Utils.propertyMustBeThrow(value, 'an integer', propertyName);
					}
				} else {
					if (!Number.isInteger(value)) {
						Utils.propertyMustBeThrow(value, 'an integer', propertyName);
					}
				}
			}
		}, {
			key: 'checkNotFiniteAndThrow',
			value: function checkNotFiniteAndThrow(value, propertyName) {
				if (!Number.isFinite) {
					if (typeof value !== 'number') {
						Utils.propertyMustBeThrow(value, 'a finite number', propertyName);
					}
					if (!isFinite(value)) {
						Utils.propertyMustBeThrow(value, 'a finite number', propertyName);
					}
				} else {
					if (!Number.isFinite(value)) {
						Utils.propertyMustBeThrow(value, 'a finite number', propertyName);
					}
				}
			}
		}, {
			key: 'checkNotNumberAndThrow',
			value: function checkNotNumberAndThrow(value, propertyName) {
				if (typeof value !== 'number') {
					Utils.propertyMustBeThrow(value, 'a number', propertyName);
				}
			}
		}, {
			key: 'checkNotFunctionAndThrow',
			value: function checkNotFunctionAndThrow(value, propertyName) {
				if (!Utils.isFunction(value)) {
					Utils.propertyMustBeThrow(value, 'a function', propertyName);
				}
			}
		}, {
			key: 'checkNotNullableFunctionAndThrow',
			value: function checkNotNullableFunctionAndThrow(value, propertyName) {
				if (!Utils.isFunction(value) && Utils.isDefined(value) && !Utils.isNull(value)) {
					Utils.propertyMustBeThrow(value, 'a function, undefined, or null', propertyName);
				}
			}
		}, {
			key: 'isValidDate',
			value: function isValidDate(date) {
				var validDate = false;
	
				if (Object.prototype.toString.call(date) === '[object Date]') {
					if (!isNaN(date.getTime())) {
						validDate = true;
					}
				}
	
				return validDate;
			}
		}, {
			key: 'msErrToHex',
			value: function msErrToHex(errCode) {
				//convert given microsoft error number into its hex format
				return '0x' + (errCode >>> 0).toString(16).toUpperCase();
			}
		}, {
			key: 'getTimeForPdt',
			value: function getTimeForPdt(pdt) {
				if (Utils.isValidDate(pdt)) {
					return pdt.getTime() / 1000;
				} else {
					return 0;
				}
			}
		}, {
			key: 'getPdtForTime',
			value: function getPdtForTime(time) {
				return new Date(time * 1000);
			}
		}, {
			key: 'isPromiseOverloaded',
			value: function isPromiseOverloaded() {
				var result = false;
	
				//https://github.com/DefinitelyTyped/DefinitelyTyped/issues/10801
				// native fetch API returns a native Promise, if implemented (on Chrome/Safari)
				//let fetchPromise = fetch("");
				//if (Object.getPrototypeOf(fetch("")) !== Promise.prototype) {
				/*
	   				let promiseProto = Promise.prototype;
	   				let promiseProto2 = Object.getPrototypeOf(Promise.resolve());
	   				let fetchPromiseProto = Object.getPrototypeOf(fetchPromise);
	   
	   				let fetchInstanceOfPromise = !!(fetchPromise instanceof Promise);
	   				let fetchPromiseType = typeof fetchPromise;
	   				let fetchPromiseTypeName = type(fetchPromise);
	   
	   				let test = Object.getOwnPropertyNames( fetchPromiseProto );
	   */
	
				try {
					// We execute a fetch request, which returns a native Promise. Then we can
					// detect if Promise has been overidden, because it would differ to the native version.
					//
					// 'data:,' is the bare minimum data url we can request. '' is an alternative, but
					// that would result in a repeated request for the current origin, which in some pages
					// might result in undesired behaviour, eg, 403s
					//
					// browsers that this test is valid: Chrome, Safari 11
					// browsers that this test is invalid: Firefox, Edge, older Safari versions
					// browsers that throw: IE
					result = Utils.isChrome() && !(fetch('data:,') instanceof Promise);
				} catch (e) {}
	
				return result;
			}
		}, {
			key: 'version',
			get: function get() {
				return '__VERSION__';
			}
		}]);
	
		return Utils;
	}();
	
	exports.default = Utils;
	module.exports = exports['default'];

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(93)('wks');
	var uid = __webpack_require__(59);
	var Symbol = __webpack_require__(8).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 8 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(31);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(24);
	
	module.exports = function (method, arg) {
	  return !!method && fails(function () {
	    // eslint-disable-next-line no-useless-call
	    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
	  });
	};


/***/ }),
/* 11 */
/***/ (function(module, exports) {

	/**
	 * mux.js
	 *
	 * Copyright (c) 2014 Brightcove
	 * All rights reserved.
	 *
	 * A lightweight readable stream implemention that handles event dispatching.
	 * Objects that inherit from streams should call init in their constructors.
	 */
	'use strict';
	
	var Stream = function Stream() {
	  this.init = function () {
	    var listeners = {};
	    /**
	     * Add a listener for a specified event type.
	     * @param type {string} the event name
	     * @param listener {function} the callback to be invoked when an event of
	     * the specified type occurs
	     */
	    this.on = function (type, listener) {
	      if (!listeners[type]) {
	        listeners[type] = [];
	      }
	      listeners[type] = listeners[type].concat(listener);
	    };
	    /**
	     * Remove a listener for a specified event type.
	     * @param type {string} the event name
	     * @param listener {function} a function previously registered for this
	     * type of event through `on`
	     */
	    this.off = function (type, listener) {
	      var index;
	      if (!listeners[type]) {
	        return false;
	      }
	      index = listeners[type].indexOf(listener);
	      listeners[type] = listeners[type].slice();
	      listeners[type].splice(index, 1);
	      return index > -1;
	    };
	    /**
	     * Trigger an event of the specified type on this stream. Any additional
	     * arguments to this function are passed as parameters to event listeners.
	     * @param type {string} the event name
	     */
	    this.trigger = function (type) {
	      var callbacks, i, length, args;
	      callbacks = listeners[type];
	      if (!callbacks) {
	        return;
	      }
	      // Slicing the arguments on every invocation of this method
	      // can add a significant amount of overhead. Avoid the
	      // intermediate object creation for the common case of a
	      // single callback argument
	      if (arguments.length === 2) {
	        length = callbacks.length;
	        for (i = 0; i < length; ++i) {
	          callbacks[i].call(this, arguments[1]);
	        }
	      } else {
	        args = [];
	        i = arguments.length;
	        for (i = 1; i < arguments.length; ++i) {
	          args.push(arguments[i]);
	        }
	        length = callbacks.length;
	        for (i = 0; i < length; ++i) {
	          callbacks[i].apply(this, args);
	        }
	      }
	    };
	    /**
	     * Destroys the stream and cleans up.
	     */
	    this.dispose = function () {
	      listeners = {};
	    };
	  };
	};
	
	/**
	 * Forwards all `data` events on this stream to the destination stream. The
	 * destination stream should provide a method `push` to receive the data
	 * events as they arrive.
	 * @param destination {stream} the stream that will receive all `data` events
	 * @param autoFlush {boolean} if false, we will not call `flush` on the destination
	 *                            when the current stream emits a 'done' event
	 * @see http://nodejs.org/api/stream.html#stream_readable_pipe_destination_options
	 */
	Stream.prototype.pipe = function (destination) {
	  this.on('data', function (data) {
	    destination.push(data);
	  });
	
	  this.on('done', function (flushSource) {
	    destination.flush(flushSource);
	  });
	
	  return destination;
	};
	
	// Default stream functions that are expected to be overridden to perform
	// actual work. These are provided by the prototype as a sort of no-op
	// implementation so that we don't have to check for their existence in the
	// `pipe` function above.
	Stream.prototype.push = function (data) {
	  this.trigger('data', data);
	};
	
	Stream.prototype.flush = function (flushSource) {
	  this.trigger('done', flushSource);
	};
	
	module.exports = Stream;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(51);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(7)('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(25)(ArrayProto, UNSCOPABLES, {});
	module.exports = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};


/***/ }),
/* 14 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	/**
	* @public
	*/
	var HlsEvents = {
	
		STREAM_ERROR: 'STREAM_ERROR',
	
		// player states
		STREAM_UNLOADED: 'STREAM_UNLOADED',
		STREAM_LOADING: 'STREAM_LOADING',
		STREAM_LOADED: 'STREAM_LOADED',
		STREAM_FETCHING: 'STREAM_FETCHING',
		STREAM_PLAYBACK: 'STREAM_PLAYBACK', /*	the playbackState will now
	                                     reflect the state of playback */
	
		// playback states
		PLAYBACK_NOTREADY: 'PLAYBACK_NOTREADY',
		PLAYBACK_PAUSED: 'PLAYBACK_PAUSED',
		PLAYBACK_BUFFERING: 'PLAYBACK_BUFFERING',
		PLAYBACK_PLAYING: 'PLAYBACK_PLAYING',
		PLAYBACK_SEEKING: 'PLAYBACK_SEEKING',
		PLAYBACK_ENDED: 'PLAYBACK_ENDED',
	
		// MediaState transition events
		MEDIA_WIRING: 'MEDIA_WIRING',
		MEDIA_WIRED: 'MEDIA_WIRED',
		MEDIA_ATTACHING: 'MEDIA_ATTACHING',
		MEDIA_ATTACHED: 'MEDIA_ATTACHED',
		MEDIA_DETACHING: 'MEDIA_DETACHING',
		MEDIA_DETACHED: 'MEDIA_DETACHED', // initial state
	
		// pre-requisite has been met to progress to another state
		STREAM_CANPLAY: 'STREAM_CANPLAY',
		STREAM_CANPLAYTHROUGH: 'STREAM_CANPLAYTHROUGH',
		STREAM_BUFFERING_STARTED: 'STREAM_BUFFERING_STARTED',
		STREAM_BUFFERING_FINISHED: 'STREAM_BUFFERING_FINISHED',
		STREAM_SEEKING_FINISHED: 'STREAM_SEEKING_FINISHED',
		STREAM_STARTPOSITION_SET: 'STREAM_STARTPOSITION_SET',
	
		// commands
		STREAM_PREFETCH: 'STREAM_PREFETCH',
		STREAM_PAUSE: 'STREAM_PAUSE',
		STREAM_PLAY: 'STREAM_PLAY',
	
		// property change events
		STREAM_STATE_CHANGED: 'STREAM_STATE_CHANGED',
		STREAM_PLAYBACKSTATE_CHANGED: 'STREAM_PLAYBACKSTATE_CHANGED',
		STREAM_MEDIASTATE_CHANGED: 'STREAM_MEDIASTATE_CHANGED',
		STREAM_VARIANTS_CHANGED: 'STREAM_VARIANTS_CHANGED',
		STREAM_ISLIVE_CHANGED: 'STREAM_ISLIVE_CHANGED',
		STREAM_LIVETIME_CHANGED: 'STREAM_LIVETIME_CHANGED',
		STREAM_ISSLIDINGWINDOW_CHANGED: 'STREAM_ISSLIDINGWINDOW_CHANGED',
		STREAM_ISAUDIOONLY_CHANGED: 'STREAM_ISAUDIOONLY_CHANGED',
		STREAM_ISMULTITHREADED_CHANGED: 'STREAM_ISMULTITHREADED_CHANGED',
		STREAM_MEDIA_CHANGED: 'STREAM_MEDIA_CHANGED',
		STREAM_CHOSENVARIANT_CHANGED: 'STREAM_CHOSENVARIANT_CHANGED',
		STREAM_CHOSENBITRATE_CHANGED: 'STREAM_CHOSENBITRATE_CHANGED',
		STREAM_NETWORKMETRICS_CHANGED: 'STREAM_NETWORKMETRICS_CHANGED',
		STREAM_DURATION_CHANGED: 'STREAM_DURATION_CHANGED',
		STREAM_BASEPDT_CHANGED: 'STREAM_BASEPDT_CHANGED',
		STREAM_SUBTITLERENDITIONS_CHANGED: 'STREAM_SUBTITLERENDITIONS_CHANGED',
		STREAM_SUBTITLERENDITION_CHANGED: 'STREAM_SUBTITLERENDITION_CHANGED',
		STREAM_AUDIORENDITIONS_CHANGED: 'STREAM_AUDIORENDITIONS_CHANGED',
		STREAM_AUDIORENDITION_CHANGED: 'STREAM_AUDIORENDITION_CHANGED',
		STREAM_TIMEUPDATE: 'STREAM_TIMEUPDATE',
		STREAM_PLAYHEAD_BEHIND_SLIDING_WINDOW: 'STREAM_PLAYHEAD_BEHIND_SLIDING_WINDOW',
		STREAM_PLAYBACKRATE_CHANGED: 'STREAM_PLAYBACKRATE_CHANGED',
	
		STREAM_DISPOSING: 'STREAM_DISPOSING',
		STREAM_DISPOSED: 'STREAM_DISPOSED',
		STREAM_DATERANGE_UPDATE: 'STREAM_DATERANGE_UPDATE',
	
		TIMED_METADATA_UPDATE: 'TIMED_METADATA_UPDATE',
		TIMED_METADATA_PTS_REACHED: 'TIMED_METADATA_PTS_REACHED',
	
		/**
	  * INTERNAL EVENTS BELOW THIS POINT - NOT INTENDED FOR USE BY CLIENTS
	  */
		// MediaController events - these are really for internal use only.
		MEDIA_CANPLAY: 'MEDIA_CANPLAY',
		MEDIA_CANPLAYTHROUGH: 'MEDIA_CANPLAYTHROUGH',
		MEDIA_PAUSE: 'MEDIA_PAUSE',
		MEDIA_PLAY: 'MEDIA_PLAY',
		MEDIA_SEEKING: 'MEDIA_SEEKING',
		MEDIA_SEEKED: 'MEDIA_SEEKED',
		MEDIA_ENDED: 'MEDIA_ENDED',
		MEDIA_DURATIONCHANGE: 'MEDIA_DURATIONCHANGE',
		MEDIA_LOADEDDATA: 'MEDIA_LOADEDDATA',
		MEDIA_RATECHANGE: 'MEDIA_RATECHANGE',
		MEDIA_VOLUMECHANGE: 'MEDIA_VOLUMECHANGE',
		MEDIA_TIMEUPDATE: 'MEDIA_TIMEUPDATE',
	
		MEDIA_CONTROLLER_WIRED: 'MEDIA_CONTROLLER_WIRED',
		MEDIA_CONTROLLER_UNWIRED: 'MEDIA_CONTROLLER_UNWIRED',
		// a fatal error in the media controller.
		MEDIA_CONTROLLER_ERROR: 'MEDIA_CONTROLLER_ERROR',
		MEDIA_ELEMENT_ERROR: 'MEDIA_ELEMENT_ERROR',
	
		// fired after manifest has been parsed - data: { }
		HLSJS_ERROR: 'HLSJS_ERROR',
		HLSJS_MEDIA_ATTACHED: 'HLSJS_MEDIA_ATTACHED',
		HLSJS_MEDIA_DETACHED: 'HLSJS_MEDIA_DETACHED',
		HLSJS_SEEK_READY: 'HLSJS_SEEK_READY',
		MANIFEST_LOADED: 'MANIFEST_LOADED',
		MANIFEST_PARSED: 'MANIFEST_PARSED',
		VARIANT_LOADED: 'VARIANT_LOADED',
		VARIANT_UPDATED: 'VARIANT_UPDATED',
		VARIANT_DURATION_UPDATED: 'VARIANT_DURATION_UPDATED',
		CHUNK_LOADED: 'CHUNK_LOADED',
		CHUNK_BUFFERED: 'CHUNK_BUFFERED',
		BUFFER_FLUSHED: 'BUFFER_FLUSHED',
	
		//Internal logging tunnel
		LOGTUBE_LOG: 'LOGTUBE_LOG',
	
		// internal test event - HlsController listens
		TEST_EVENT_INTERNAL: 'TEST_EVENT_INTERNAL',
	
		// used by unit tests - no-one listens
		TEST_EVENT: 'TEST_EVENT'
	};
	
	exports.default = HlsEvents;
	module.exports = exports['default'];

/***/ }),
/* 15 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(20);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx = __webpack_require__(19);
	var IObject = __webpack_require__(38);
	var toObject = __webpack_require__(12);
	var toLength = __webpack_require__(9);
	var asc = __webpack_require__(49);
	module.exports = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || asc;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IObject(O);
	    var f = ctx(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      val = self[index];
	      res = f(val, index, O);
	      if (TYPE) {
	        if (IS_MAP) result[index] = res;   // map
	        else if (res) switch (TYPE) {
	          case 3: return true;             // some
	          case 5: return val;              // find
	          case 6: return index;            // findIndex
	          case 2: result.push(val);        // filter
	        } else if (IS_EVERY) return false; // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};


/***/ }),
/* 18 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.5.4' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(15);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 20 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeDetect = __webpack_require__(216);
	
	var _typeDetect2 = _interopRequireDefault(_typeDetect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ArrayHelper = function () {
		function ArrayHelper() {
			_classCallCheck(this, ArrayHelper);
		}
	
		_createClass(ArrayHelper, null, [{
			key: 'makeUint8Array',
	
			/**
	   * makeUint8Array - converts input array into a Uint8Array
	   * Will only make a change for an ArrayBuffer, otherwise
	   * the return value is unmodified
	   */
			value: function makeUint8Array(array) {
				var result = array;
				var arrayType = (0, _typeDetect2.default)(result);
	
				if (arrayType !== 'Uint8Array') {
	
					if (arrayType === 'ArrayBuffer' /*|| arrayType === 'Array'*/) {
							result = new Uint8Array(result);
						}
	
						// can add other typed arrays as || here
					else if (arrayType === 'Int32Array') {
							result = new Uint8Array(result.buffer, result.byteOffset, result.byteLength);
						}
	
						// TODO: add other formats here
	
						else {
								throw new Error('ArrayHelper.makeUint8Array unhandled array type ' + arrayType);
							}
				}
	
				return result;
			}
	
			/**
	   * makeModulo16 - truncates a uint8Array to modulo-16
	   *
	   * Returns obj with { data,truncated }, where truncated
	   * is a bool indicating if truncation occurred
	   *
	   * input must be Uint8Array.
	   */
	
		}, {
			key: 'makeModulo16',
			value: function makeModulo16(data) {
				if ((0, _typeDetect2.default)(data) !== 'Uint8Array') {
					throw new Error('ArrayHelper.makeModulo16 data must be Uint8Array {' + (0, _typeDetect2.default)(data) + '}');
				}
	
				var myData = data;
				var truncated = false;
	
				var len = data.length;
				var lenMod16 = len % 16;
	
				if (lenMod16 !== 0) {
					myData = myData.subarray(0, len - lenMod16);
	
					// we need to add padding because we truncated.
					truncated = true;
				}
	
				return { data: myData, truncated: truncated };
			}
		}]);
	
		return ArrayHelper;
	}();
	
	exports.default = ArrayHelper;
	module.exports = exports['default'];

/***/ }),
/* 22 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Buffer Helper utils, providing methods dealing buffer length retrieval
	*/
	
	var BufferHelper = {
		isBuffered: function isBuffered(media, position) {
			if (media) {
				var buffered = media.buffered;
				for (var i = 0; i < buffered.length; i++) {
					if (position >= buffered.start(i) && position <= buffered.end(i)) {
						return true;
					}
				}
			}
			return false;
		},
	
		bufferInfo: function bufferInfo(media, pos, maxHoleDuration) {
			try {
				//Mactrix line added, catch error if buffer has been detached
				if (media) {
					var vbuffered = media.buffered;
					var buffered = [];
					var i = void 0;
	
					for (i = 0; i < vbuffered.length; i++) {
						buffered.push({ start: vbuffered.start(i), end: vbuffered.end(i) });
					}
					return this.bufferedInfo(buffered, pos, maxHoleDuration);
				} else {
					return { len: 0, start: pos, end: pos, nextStart: undefined };
				}
				//Mactrix additions start, catch error if buffer has been detached
			} catch (err) {
				return { len: 0, start: pos, end: pos, nextStart: undefined };
			}
			//Mactrix additions end
		},
	
		bufferedInfo: function bufferedInfo(buffered, pos, maxHoleDuration) {
			var buffered2 = [];
			// bufferStart and bufferEnd are buffer boundaries around current video position
			var bufferLen = void 0;
			var bufferStart = void 0;
			var bufferEnd = void 0;
			var bufferStartNext = void 0;
			var i = void 0;
			// sort on buffer.start/smaller end (IE does not always return sorted buffered range)
			buffered.sort(function (a, b) {
				var diff = a.start - b.start;
				if (diff) {
					return diff;
				} else {
					return b.end - a.end;
				}
			});
			// there might be some small holes between buffer time range
			// consider that holes smaller than maxHoleDuration are irrelevant and build another
			// buffer time range representations that discards those holes
			for (i = 0; i < buffered.length; i++) {
				var buf2len = buffered2.length;
				if (buf2len) {
					var buf2end = buffered2[buf2len - 1].end;
					// if small hole (value between 0 or maxHoleDuration ) or overlapping (negative)
					if (buffered[i].start - buf2end < maxHoleDuration) {
						// merge overlapping time ranges
						// update lastRange.end only if smaller than item.end
						// e.g.  [ 1, 15] with  [ 2,8] => [ 1,15] (no need to modify lastRange.end)
						// whereas [ 1, 8] with  [ 2,15] => [ 1,15] ( lastRange should switch from [1,8] to [1,15])
						if (buffered[i].end > buf2end) {
							buffered2[buf2len - 1].end = buffered[i].end;
						}
					} else {
						// big hole
						buffered2.push(buffered[i]);
					}
				} else {
					// first value
					buffered2.push(buffered[i]);
				}
			}
			for (i = 0, bufferLen = 0, bufferStart = bufferEnd = pos; i < buffered2.length; i++) {
				var start = buffered2[i].start;
				var end = buffered2[i].end;
	
				//logger.log('buf start/end:' + buffered.start(i) + '/' + buffered.end(i));
				if (pos + maxHoleDuration >= start && pos < end) {
					// play position is inside this buffer TimeRange, retrieve end of buffer position and buffer length
					bufferStart = start;
					bufferEnd = end;
					bufferLen = bufferEnd - pos;
				} else if (pos + maxHoleDuration < start) {
					bufferStartNext = start;
					break;
				}
			}
			return { len: bufferLen, start: bufferStart, end: bufferEnd, nextStart: bufferStartNext };
		}
	};
	
	module.exports = BufferHelper;

/***/ }),
/* 23 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 24 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(29);
	var createDesc = __webpack_require__(56);
	module.exports = __webpack_require__(27) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 26 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  H264_STREAM_TYPE: 0x1B,
	  ADTS_STREAM_TYPE: 0x0F,
	  METADATA_STREAM_TYPE: 0x15
	};

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(24)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 28 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(16);
	var IE8_DOM_DEFINE = __webpack_require__(175);
	var toPrimitive = __webpack_require__(186);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(27) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(8);
	var hide = __webpack_require__(25);
	var has = __webpack_require__(37);
	var SRC = __webpack_require__(59)('src');
	var TO_STRING = 'toString';
	var $toString = Function[TO_STRING];
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(18).inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});


/***/ }),
/* 31 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(38);
	var defined = __webpack_require__(51);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * EventEmitter2
	 * https://github.com/hij1nx/EventEmitter2
	 *
	 * Copyright (c) 2013 hij1nx
	 * Licensed under the MIT license.
	 */
	;!function(undefined) {
	
	  var isArray = Array.isArray ? Array.isArray : function _isArray(obj) {
	    return Object.prototype.toString.call(obj) === "[object Array]";
	  };
	  var defaultMaxListeners = 10;
	
	  function init() {
	    this._events = {};
	    if (this._conf) {
	      configure.call(this, this._conf);
	    }
	  }
	
	  function configure(conf) {
	    if (conf) {
	      this._conf = conf;
	
	      conf.delimiter && (this.delimiter = conf.delimiter);
	      this._events.maxListeners = conf.maxListeners !== undefined ? conf.maxListeners : defaultMaxListeners;
	      conf.wildcard && (this.wildcard = conf.wildcard);
	      conf.newListener && (this.newListener = conf.newListener);
	      conf.verboseMemoryLeak && (this.verboseMemoryLeak = conf.verboseMemoryLeak);
	
	      if (this.wildcard) {
	        this.listenerTree = {};
	      }
	    } else {
	      this._events.maxListeners = defaultMaxListeners;
	    }
	  }
	
	  function logPossibleMemoryLeak(count, eventName) {
	    var errorMsg = '(node) warning: possible EventEmitter memory ' +
	        'leak detected. %d listeners added. ' +
	        'Use emitter.setMaxListeners() to increase limit.';
	
	    if(this.verboseMemoryLeak){
	      errorMsg += ' Event name: %s.';
	      console.error(errorMsg, count, eventName);
	    } else {
	      console.error(errorMsg, count);
	    }
	
	    if (console.trace){
	      console.trace();
	    }
	  }
	
	  function EventEmitter(conf) {
	    this._events = {};
	    this.newListener = false;
	    this.verboseMemoryLeak = false;
	    configure.call(this, conf);
	  }
	  EventEmitter.EventEmitter2 = EventEmitter; // backwards compatibility for exporting EventEmitter property
	
	  //
	  // Attention, function return type now is array, always !
	  // It has zero elements if no any matches found and one or more
	  // elements (leafs) if there are matches
	  //
	  function searchListenerTree(handlers, type, tree, i) {
	    if (!tree) {
	      return [];
	    }
	    var listeners=[], leaf, len, branch, xTree, xxTree, isolatedBranch, endReached,
	        typeLength = type.length, currentType = type[i], nextType = type[i+1];
	    if (i === typeLength && tree._listeners) {
	      //
	      // If at the end of the event(s) list and the tree has listeners
	      // invoke those listeners.
	      //
	      if (typeof tree._listeners === 'function') {
	        handlers && handlers.push(tree._listeners);
	        return [tree];
	      } else {
	        for (leaf = 0, len = tree._listeners.length; leaf < len; leaf++) {
	          handlers && handlers.push(tree._listeners[leaf]);
	        }
	        return [tree];
	      }
	    }
	
	    if ((currentType === '*' || currentType === '**') || tree[currentType]) {
	      //
	      // If the event emitted is '*' at this part
	      // or there is a concrete match at this patch
	      //
	      if (currentType === '*') {
	        for (branch in tree) {
	          if (branch !== '_listeners' && tree.hasOwnProperty(branch)) {
	            listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i+1));
	          }
	        }
	        return listeners;
	      } else if(currentType === '**') {
	        endReached = (i+1 === typeLength || (i+2 === typeLength && nextType === '*'));
	        if(endReached && tree._listeners) {
	          // The next element has a _listeners, add it to the handlers.
	          listeners = listeners.concat(searchListenerTree(handlers, type, tree, typeLength));
	        }
	
	        for (branch in tree) {
	          if (branch !== '_listeners' && tree.hasOwnProperty(branch)) {
	            if(branch === '*' || branch === '**') {
	              if(tree[branch]._listeners && !endReached) {
	                listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], typeLength));
	              }
	              listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
	            } else if(branch === nextType) {
	              listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i+2));
	            } else {
	              // No match on this one, shift into the tree but not in the type array.
	              listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
	            }
	          }
	        }
	        return listeners;
	      }
	
	      listeners = listeners.concat(searchListenerTree(handlers, type, tree[currentType], i+1));
	    }
	
	    xTree = tree['*'];
	    if (xTree) {
	      //
	      // If the listener tree will allow any match for this part,
	      // then recursively explore all branches of the tree
	      //
	      searchListenerTree(handlers, type, xTree, i+1);
	    }
	
	    xxTree = tree['**'];
	    if(xxTree) {
	      if(i < typeLength) {
	        if(xxTree._listeners) {
	          // If we have a listener on a '**', it will catch all, so add its handler.
	          searchListenerTree(handlers, type, xxTree, typeLength);
	        }
	
	        // Build arrays of matching next branches and others.
	        for(branch in xxTree) {
	          if(branch !== '_listeners' && xxTree.hasOwnProperty(branch)) {
	            if(branch === nextType) {
	              // We know the next element will match, so jump twice.
	              searchListenerTree(handlers, type, xxTree[branch], i+2);
	            } else if(branch === currentType) {
	              // Current node matches, move into the tree.
	              searchListenerTree(handlers, type, xxTree[branch], i+1);
	            } else {
	              isolatedBranch = {};
	              isolatedBranch[branch] = xxTree[branch];
	              searchListenerTree(handlers, type, { '**': isolatedBranch }, i+1);
	            }
	          }
	        }
	      } else if(xxTree._listeners) {
	        // We have reached the end and still on a '**'
	        searchListenerTree(handlers, type, xxTree, typeLength);
	      } else if(xxTree['*'] && xxTree['*']._listeners) {
	        searchListenerTree(handlers, type, xxTree['*'], typeLength);
	      }
	    }
	
	    return listeners;
	  }
	
	  function growListenerTree(type, listener) {
	
	    type = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
	
	    //
	    // Looks for two consecutive '**', if so, don't add the event at all.
	    //
	    for(var i = 0, len = type.length; i+1 < len; i++) {
	      if(type[i] === '**' && type[i+1] === '**') {
	        return;
	      }
	    }
	
	    var tree = this.listenerTree;
	    var name = type.shift();
	
	    while (name !== undefined) {
	
	      if (!tree[name]) {
	        tree[name] = {};
	      }
	
	      tree = tree[name];
	
	      if (type.length === 0) {
	
	        if (!tree._listeners) {
	          tree._listeners = listener;
	        }
	        else {
	          if (typeof tree._listeners === 'function') {
	            tree._listeners = [tree._listeners];
	          }
	
	          tree._listeners.push(listener);
	
	          if (
	            !tree._listeners.warned &&
	            this._events.maxListeners > 0 &&
	            tree._listeners.length > this._events.maxListeners
	          ) {
	            tree._listeners.warned = true;
	            logPossibleMemoryLeak.call(this, tree._listeners.length, name);
	          }
	        }
	        return true;
	      }
	      name = type.shift();
	    }
	    return true;
	  }
	
	  // By default EventEmitters will print a warning if more than
	  // 10 listeners are added to it. This is a useful default which
	  // helps finding memory leaks.
	  //
	  // Obviously not all Emitters should be limited to 10. This function allows
	  // that to be increased. Set to zero for unlimited.
	
	  EventEmitter.prototype.delimiter = '.';
	
	  EventEmitter.prototype.setMaxListeners = function(n) {
	    if (n !== undefined) {
	      this._events || init.call(this);
	      this._events.maxListeners = n;
	      if (!this._conf) this._conf = {};
	      this._conf.maxListeners = n;
	    }
	  };
	
	  EventEmitter.prototype.event = '';
	
	  EventEmitter.prototype.once = function(event, fn) {
	    this.many(event, 1, fn);
	    return this;
	  };
	
	  EventEmitter.prototype.many = function(event, ttl, fn) {
	    var self = this;
	
	    if (typeof fn !== 'function') {
	      throw new Error('many only accepts instances of Function');
	    }
	
	    function listener() {
	      if (--ttl === 0) {
	        self.off(event, listener);
	      }
	      fn.apply(this, arguments);
	    }
	
	    listener._origin = fn;
	
	    this.on(event, listener);
	
	    return self;
	  };
	
	  EventEmitter.prototype.emit = function() {
	
	    this._events || init.call(this);
	
	    var type = arguments[0];
	
	    if (type === 'newListener' && !this.newListener) {
	      if (!this._events.newListener) {
	        return false;
	      }
	    }
	
	    var al = arguments.length;
	    var args,l,i,j;
	    var handler;
	
	    if (this._all && this._all.length) {
	      handler = this._all.slice();
	      if (al > 3) {
	        args = new Array(al);
	        for (j = 0; j < al; j++) args[j] = arguments[j];
	      }
	
	      for (i = 0, l = handler.length; i < l; i++) {
	        this.event = type;
	        switch (al) {
	        case 1:
	          handler[i].call(this, type);
	          break;
	        case 2:
	          handler[i].call(this, type, arguments[1]);
	          break;
	        case 3:
	          handler[i].call(this, type, arguments[1], arguments[2]);
	          break;
	        default:
	          handler[i].apply(this, args);
	        }
	      }
	    }
	
	    if (this.wildcard) {
	      handler = [];
	      var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
	      searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
	    } else {
	      handler = this._events[type];
	      if (typeof handler === 'function') {
	        this.event = type;
	        switch (al) {
	        case 1:
	          handler.call(this);
	          break;
	        case 2:
	          handler.call(this, arguments[1]);
	          break;
	        case 3:
	          handler.call(this, arguments[1], arguments[2]);
	          break;
	        default:
	          args = new Array(al - 1);
	          for (j = 1; j < al; j++) args[j - 1] = arguments[j];
	          handler.apply(this, args);
	        }
	        return true;
	      } else if (handler) {
	        // need to make copy of handlers because list can change in the middle
	        // of emit call
	        handler = handler.slice();
	      }
	    }
	
	    if (handler && handler.length) {
	      if (al > 3) {
	        args = new Array(al - 1);
	        for (j = 1; j < al; j++) args[j - 1] = arguments[j];
	      }
	      for (i = 0, l = handler.length; i < l; i++) {
	        this.event = type;
	        switch (al) {
	        case 1:
	          handler[i].call(this);
	          break;
	        case 2:
	          handler[i].call(this, arguments[1]);
	          break;
	        case 3:
	          handler[i].call(this, arguments[1], arguments[2]);
	          break;
	        default:
	          handler[i].apply(this, args);
	        }
	      }
	      return true;
	    } else if (!this._all && type === 'error') {
	      if (arguments[1] instanceof Error) {
	        throw arguments[1]; // Unhandled 'error' event
	      } else {
	        throw new Error("Uncaught, unspecified 'error' event.");
	      }
	      return false;
	    }
	
	    return !!this._all;
	  };
	
	  EventEmitter.prototype.emitAsync = function() {
	
	    this._events || init.call(this);
	
	    var type = arguments[0];
	
	    if (type === 'newListener' && !this.newListener) {
	        if (!this._events.newListener) { return Promise.resolve([false]); }
	    }
	
	    var promises= [];
	
	    var al = arguments.length;
	    var args,l,i,j;
	    var handler;
	
	    if (this._all) {
	      if (al > 3) {
	        args = new Array(al);
	        for (j = 1; j < al; j++) args[j] = arguments[j];
	      }
	      for (i = 0, l = this._all.length; i < l; i++) {
	        this.event = type;
	        switch (al) {
	        case 1:
	          promises.push(this._all[i].call(this, type));
	          break;
	        case 2:
	          promises.push(this._all[i].call(this, type, arguments[1]));
	          break;
	        case 3:
	          promises.push(this._all[i].call(this, type, arguments[1], arguments[2]));
	          break;
	        default:
	          promises.push(this._all[i].apply(this, args));
	        }
	      }
	    }
	
	    if (this.wildcard) {
	      handler = [];
	      var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
	      searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
	    } else {
	      handler = this._events[type];
	    }
	
	    if (typeof handler === 'function') {
	      this.event = type;
	      switch (al) {
	      case 1:
	        promises.push(handler.call(this));
	        break;
	      case 2:
	        promises.push(handler.call(this, arguments[1]));
	        break;
	      case 3:
	        promises.push(handler.call(this, arguments[1], arguments[2]));
	        break;
	      default:
	        args = new Array(al - 1);
	        for (j = 1; j < al; j++) args[j - 1] = arguments[j];
	        promises.push(handler.apply(this, args));
	      }
	    } else if (handler && handler.length) {
	      if (al > 3) {
	        args = new Array(al - 1);
	        for (j = 1; j < al; j++) args[j - 1] = arguments[j];
	      }
	      for (i = 0, l = handler.length; i < l; i++) {
	        this.event = type;
	        switch (al) {
	        case 1:
	          promises.push(handler[i].call(this));
	          break;
	        case 2:
	          promises.push(handler[i].call(this, arguments[1]));
	          break;
	        case 3:
	          promises.push(handler[i].call(this, arguments[1], arguments[2]));
	          break;
	        default:
	          promises.push(handler[i].apply(this, args));
	        }
	      }
	    } else if (!this._all && type === 'error') {
	      if (arguments[1] instanceof Error) {
	        return Promise.reject(arguments[1]); // Unhandled 'error' event
	      } else {
	        return Promise.reject("Uncaught, unspecified 'error' event.");
	      }
	    }
	
	    return Promise.all(promises);
	  };
	
	  EventEmitter.prototype.on = function(type, listener) {
	    if (typeof type === 'function') {
	      this.onAny(type);
	      return this;
	    }
	
	    if (typeof listener !== 'function') {
	      throw new Error('on only accepts instances of Function');
	    }
	    this._events || init.call(this);
	
	    // To avoid recursion in the case that type == "newListeners"! Before
	    // adding it to the listeners, first emit "newListeners".
	    this.emit('newListener', type, listener);
	
	    if (this.wildcard) {
	      growListenerTree.call(this, type, listener);
	      return this;
	    }
	
	    if (!this._events[type]) {
	      // Optimize the case of one listener. Don't need the extra array object.
	      this._events[type] = listener;
	    }
	    else {
	      if (typeof this._events[type] === 'function') {
	        // Change to array.
	        this._events[type] = [this._events[type]];
	      }
	
	      // If we've already got an array, just append.
	      this._events[type].push(listener);
	
	      // Check for listener leak
	      if (
	        !this._events[type].warned &&
	        this._events.maxListeners > 0 &&
	        this._events[type].length > this._events.maxListeners
	      ) {
	        this._events[type].warned = true;
	        logPossibleMemoryLeak.call(this, this._events[type].length, type);
	      }
	    }
	
	    return this;
	  };
	
	  EventEmitter.prototype.onAny = function(fn) {
	    if (typeof fn !== 'function') {
	      throw new Error('onAny only accepts instances of Function');
	    }
	
	    if (!this._all) {
	      this._all = [];
	    }
	
	    // Add the function to the event listener collection.
	    this._all.push(fn);
	    return this;
	  };
	
	  EventEmitter.prototype.addListener = EventEmitter.prototype.on;
	
	  EventEmitter.prototype.off = function(type, listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('removeListener only takes instances of Function');
	    }
	
	    var handlers,leafs=[];
	
	    if(this.wildcard) {
	      var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
	      leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
	    }
	    else {
	      // does not use listeners(), so no side effect of creating _events[type]
	      if (!this._events[type]) return this;
	      handlers = this._events[type];
	      leafs.push({_listeners:handlers});
	    }
	
	    for (var iLeaf=0; iLeaf<leafs.length; iLeaf++) {
	      var leaf = leafs[iLeaf];
	      handlers = leaf._listeners;
	      if (isArray(handlers)) {
	
	        var position = -1;
	
	        for (var i = 0, length = handlers.length; i < length; i++) {
	          if (handlers[i] === listener ||
	            (handlers[i].listener && handlers[i].listener === listener) ||
	            (handlers[i]._origin && handlers[i]._origin === listener)) {
	            position = i;
	            break;
	          }
	        }
	
	        if (position < 0) {
	          continue;
	        }
	
	        if(this.wildcard) {
	          leaf._listeners.splice(position, 1);
	        }
	        else {
	          this._events[type].splice(position, 1);
	        }
	
	        if (handlers.length === 0) {
	          if(this.wildcard) {
	            delete leaf._listeners;
	          }
	          else {
	            delete this._events[type];
	          }
	        }
	
	        this.emit("removeListener", type, listener);
	
	        return this;
	      }
	      else if (handlers === listener ||
	        (handlers.listener && handlers.listener === listener) ||
	        (handlers._origin && handlers._origin === listener)) {
	        if(this.wildcard) {
	          delete leaf._listeners;
	        }
	        else {
	          delete this._events[type];
	        }
	
	        this.emit("removeListener", type, listener);
	      }
	    }
	
	    function recursivelyGarbageCollect(root) {
	      if (root === undefined) {
	        return;
	      }
	      var keys = Object.keys(root);
	      for (var i in keys) {
	        var key = keys[i];
	        var obj = root[key];
	        if ((obj instanceof Function) || (typeof obj !== "object") || (obj === null))
	          continue;
	        if (Object.keys(obj).length > 0) {
	          recursivelyGarbageCollect(root[key]);
	        }
	        if (Object.keys(obj).length === 0) {
	          delete root[key];
	        }
	      }
	    }
	    recursivelyGarbageCollect(this.listenerTree);
	
	    return this;
	  };
	
	  EventEmitter.prototype.offAny = function(fn) {
	    var i = 0, l = 0, fns;
	    if (fn && this._all && this._all.length > 0) {
	      fns = this._all;
	      for(i = 0, l = fns.length; i < l; i++) {
	        if(fn === fns[i]) {
	          fns.splice(i, 1);
	          this.emit("removeListenerAny", fn);
	          return this;
	        }
	      }
	    } else {
	      fns = this._all;
	      for(i = 0, l = fns.length; i < l; i++)
	        this.emit("removeListenerAny", fns[i]);
	      this._all = [];
	    }
	    return this;
	  };
	
	  EventEmitter.prototype.removeListener = EventEmitter.prototype.off;
	
	  EventEmitter.prototype.removeAllListeners = function(type) {
	    if (arguments.length === 0) {
	      !this._events || init.call(this);
	      return this;
	    }
	
	    if (this.wildcard) {
	      var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
	      var leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
	
	      for (var iLeaf=0; iLeaf<leafs.length; iLeaf++) {
	        var leaf = leafs[iLeaf];
	        leaf._listeners = null;
	      }
	    }
	    else if (this._events) {
	      this._events[type] = null;
	    }
	    return this;
	  };
	
	  EventEmitter.prototype.listeners = function(type) {
	    if (this.wildcard) {
	      var handlers = [];
	      var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
	      searchListenerTree.call(this, handlers, ns, this.listenerTree, 0);
	      return handlers;
	    }
	
	    this._events || init.call(this);
	
	    if (!this._events[type]) this._events[type] = [];
	    if (!isArray(this._events[type])) {
	      this._events[type] = [this._events[type]];
	    }
	    return this._events[type];
	  };
	
	  EventEmitter.prototype.listenerCount = function(type) {
	    return this.listeners(type).length;
	  };
	
	  EventEmitter.prototype.listenersAny = function() {
	
	    if(this._all) {
	      return this._all;
	    }
	    else {
	      return [];
	    }
	
	  };
	
	  if (true) {
	     // AMD. Register as an anonymous module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return EventEmitter;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    // CommonJS
	    module.exports = EventEmitter;
	  }
	  else {
	    // Browser global.
	    window.EventEmitter2 = EventEmitter;
	  }
	}();


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * EventHandlers - tracks and creates bound event handlers for a set of functions.
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _HlsUtils = __webpack_require__(6);
	
	var _HlsUtils2 = _interopRequireDefault(_HlsUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	* @access internal
	*/
	var EventHandlers = function () {
		function EventHandlers() {
			var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
			_classCallCheck(this, EventHandlers);
	
			this._handlers = {};
	
			this._hlsEventsWired = false;
			this._hlsEvents = null;
			this._hlsObjToBindTo = null;
			this._hlsEmitter = null;
	
			this._mediaEvents = null;
			this._hlsJsEvents = null;
	
			_HlsUtils2.default.applyConfig(this, config);
		}
	
		_createClass(EventHandlers, [{
			key: 'dispose',
			value: function dispose() {
				if (this._hlsEventsWired) {
					this.unwireHlsEvents();
				}
				this._hlsEvents = null;
				this._hlsObjToBindTo = null;
				this._hlsEmitter = null;
	
				this._mediaEvents = null;
				this._hlsJsEvents = null;
	
				this._handlers = null;
			}
		}, {
			key: 'setHlsEventsList',
			value: function setHlsEventsList(objToBindTo, emitter, eventsList) {
				EventHandlers.verifyEventsList(eventsList);
	
				if (this._hlsEvents) {
					throw new Error('HlsEvents already set');
				}
	
				if (!_HlsUtils2.default.isObject(objToBindTo)) {
					throw new Error('objToBindTo must be type: object, ' + objToBindTo);
				}
	
				if (!_HlsUtils2.default.isObject(emitter)) {
					throw new Error('emitter must be type: object, ' + emitter);
				}
	
				if (!_HlsUtils2.default.isFunction(emitter.on) || !_HlsUtils2.default.isFunction(emitter.off)) {
					throw new Error('emitter :' + emitter + ' does not appear to be an emitter');
				}
	
				this._hlsObjToBindTo = objToBindTo;
				this._hlsEmitter = emitter;
				this._hlsEvents = eventsList;
	
				return this; // enable chaining
			}
		}, {
			key: 'wireHlsEvent',
			value: function wireHlsEvent(_ref) {
				var event = _ref.event,
				    func = _ref.func;
	
				var handler = this.createEventHandler(this._hlsObjToBindTo, func);
	
				if (!handler) {
					throw new Error('no handler for event: ' + event + ', func: ' + func);
				}
	
				this._hlsEmitter.on(event, handler);
			}
		}, {
			key: 'unwireHlsEvent',
			value: function unwireHlsEvent(_ref2) {
				var event = _ref2.event,
				    func = _ref2.func;
	
				var handler = this.getHandlerForFunction(func);
	
				if (handler) {
					this._hlsEmitter.off(event, handler);
				}
			}
		}, {
			key: 'wireHlsEvents',
			value: function wireHlsEvents() {
				var _this = this;
	
				if (this._hlsEventsWired) {
					throw new Error('hlsEvents are already wired');
				}
	
				if (!_HlsUtils2.default.isObject(this._hlsObjToBindTo)) {
					throw new Error('No hlsObjToBindTo: ' + this._hlsObjToBindTo);
				}
	
				if (!_HlsUtils2.default.isObject(this._hlsEmitter)) {
					throw new Error('No hlsEmitter: ' + this._hlsEmitter);
				}
	
				this._hlsEvents.forEach(function (event) {
					return _this.wireHlsEvent(event);
				});
				this._hlsEventsWired = true;
			}
		}, {
			key: 'unwireHlsEvents',
			value: function unwireHlsEvents() {
				var _this2 = this;
	
				if (!this._hlsEventsWired) {
					throw new Error('hlsEvents aren\'t wired');
				}
	
				this._hlsEvents.forEach(function (event) {
					return _this2.unwireHlsEvent(event);
				});
				this._hlsEventsWired = false;
			}
		}, {
			key: 'getHandlerKeyForFunction',
			value: function getHandlerKeyForFunction(func) {
				if (!_HlsUtils2.default.isFunction(func)) {
					throw new Error('getHandlerForFunction requires a function as argument');
				}
	
				return 'Handler: ' + func;
			}
		}, {
			key: 'getHandlerForFunction',
			value: function getHandlerForFunction(func) {
				//return this._handlers[this.getHandlerNameForFunction(func)];
				return this._handlers[this.getHandlerKeyForFunction(func)];
			}
		}, {
			key: 'createEventHandler',
			value: function createEventHandler(obj, func) {
				//	let handlerName = this.getHandlerNameForFunction(func);
				var handlerName = this.getHandlerKeyForFunction(func);
	
				// only do this once when we need to.
				if (!this._handlers[handlerName]) {
					this._handlers[handlerName] = func.bind(obj);
				}
	
				return this._handlers[handlerName];
			}
		}], [{
			key: 'verifyEventsList',
			value: function verifyEventsList(eventsList) {
	
				// check the eventsList
				if (!eventsList || !eventsList.forEach || !_HlsUtils2.default.isFunction(eventsList.forEach)) {
					throw new Error('verifyEventsList: invalid eventslist');
				}
	
				eventsList.forEach(function (event) {
	
					// TODO: should also verify the event exists in HlsEvents
	
					// check the event
					if (!event.event) {
						throw new Error('verifyEventsList: invalid event: \'' + event.event + '\', func: \'' + event.func + '\'');
					}
	
					// check the function
					if (!_HlsUtils2.default.isFunction(event.func)) {
						throw new Error('verifyEventsList: event: \'' + event.event + '\' invalid func: \'' + event.func + '\'');
					}
				});
			}
		}]);
	
		return EventHandlers;
	}();
	
	exports.default = EventHandlers;
	module.exports = exports['default'];

/***/ }),
/* 35 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	/**
	* @public
	*/
	var KeySystems = {
		FAIRPLAY: 'FAIRPLAY',
		PLAYREADY: 'PLAYREADY',
		WIDEVINE: 'WIDEVINE',
		CLEARKEY: 'CLEARKEY'
	};
	
	exports.default = KeySystems;
	module.exports = exports['default'];

/***/ }),
/* 36 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	//Mactrix file added
	/**
	 * @public
	 */
	var DataTypes = {
		MANIFEST: 'MANIFEST', //.m3u8 files
		CHUNK: 'CHUNK', //.ts files
		KEY: 'KEY' //AES key files
	};
	
	exports.default = DataTypes;
	module.exports = exports['default'];

/***/ }),
/* 37 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(23);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(31);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ArrayHelper = __webpack_require__(21);
	
	var _ArrayHelper2 = _interopRequireDefault(_ArrayHelper);
	
	var _errors = __webpack_require__(4);
	
	var _events = __webpack_require__(3);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _KeySystems = __webpack_require__(35);
	
	var _KeySystems2 = _interopRequireDefault(_KeySystems);
	
	var _logger = __webpack_require__(1);
	
	var _HlsUtils = __webpack_require__(6);
	
	var _HlsUtils2 = _interopRequireDefault(_HlsUtils);
	
	var _DrmUtils = __webpack_require__(114);
	
	var _DrmUtils2 = _interopRequireDefault(_DrmUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EME = function () {
		function EME(hls, keySystemName, obtainKeySystemConfigCallback, totalSessions) {
			_classCallCheck(this, EME);
	
			this._obtainKeySystemConfigCallback = obtainKeySystemConfigCallback;
			this._keySystemName = keySystemName;
			this._keySystemConfig = null;
			this._keySystem = null;
			this._caps = null;
			this._hls = hls;
			this._totalSessions = totalSessions;
	
			if (this._keySystemName === _KeySystems2.default.WIDEVINE) {
				this._keySystem = 'com.widevine.alpha';
			} else if (this._keySystemName === _KeySystems2.default.PLAYREADY) {
				this._keySystem = 'com.microsoft.playready';
			} else if (this._keySystemName === _KeySystems2.default.FAIRPLAY) {
				this._keySystem = 'com.apple.fps.2_0';
			} else if (this._keySystemName === _KeySystems2.default.CLEARKEY) {
				this._keySystem = 'org.w3.clearkey';
			}
		}
	
		_createClass(EME, [{
			key: 'obtainData',
			value: function obtainData(dataPromise, event) {
				var _this = this;
	
				if (dataPromise) {
					dataPromise.then(function (data) {
						try {
							var promise = event.target.update(new Uint8Array(data));
	
							if (promise) {
								promise.catch(function (err) {
									_this.onError(err);
								});
							}
						} catch (err) {
							_this.onError(err);
						}
					}).catch(function (err) {
						_this.onError({ message: err });
					});
				} else {
					this.onError({ message: ' The promise is not defined in the keySystemConfig' });
				}
			}
		}, {
			key: 'obtainCertificate',
			value: function obtainCertificate(event) {
				if (this._keySystemConfig) {
					this.obtainData(this._keySystemConfig.certificate, event);
				} else {
					this.onError({ message: ' The keySystemConfig has not been set' });
				}
			}
		}, {
			key: 'obtainLicense',
			value: function obtainLicense(event) {
				if (this._keySystemConfig && this._keySystemConfig.obtainLicenseCallback) {
					//Normalise cdm data
					var data = _ArrayHelper2.default.makeUint8Array(event.message);
	
					// if we are Tizen, and PlayReady, then reformat the challenge as if it were the IE/Edge reformat
					// so the same client code can be used for both platforms.
					if (_HlsUtils2.default.isTizen() && this._keySystemName === _KeySystems2.default.PLAYREADY) {
						data = _DrmUtils2.default.wrapPlayReadyChallengeAsPlayReadyObjectUcs16(data);
					}
	
					this.obtainData(this._keySystemConfig.obtainLicenseCallback(this._keySystemName, data), event);
				} else {
					this.onError({ message: ' The keySystemConfig has not been set' });
				}
			}
		}, {
			key: 'onError',
			value: function onError(err) {
				_logger.logger.error('EME error : ' + err.message);
				if (this._hls) {
					this._hls.trigger(_events2.default.ERROR, {
						type: _errors.ErrorTypes.MEDIA_ERROR,
						details: _errors.ErrorDetails.DRM_ERROR,
						fatal: true,
						reason: err.message
					});
				}
			}
		}, {
			key: 'setKeySystemConfig',
			value: function setKeySystemConfig(keySystemData) {
				if (this._obtainKeySystemConfigCallback) {
					this._keySystemConfig = this._obtainKeySystemConfigCallback(this._keySystemName, keySystemData);
				}
			}
		}, {
			key: 'keySystem',
			get: function get() {
				return this._keySystem;
			}
		}, {
			key: 'keySystemName',
			get: function get() {
				return this._keySystemName;
			}
		}], [{
			key: 'capabilities',
			get: function get() {
				if (!this._caps) {
					this._caps = new Promise(function (resolve) {
						var keySystems = ['com.apple.fps.2_0', 'com.microsoft.playready', 'com.widevine.alpha', 'org.w3.clearkey'];
						var supportedKeySystems = [];
						var i = 0;
	
						if (window.navigator.requestMediaKeySystemAccess) {
							(function () {
								var count = 0;
	
								var options = [{
									initDataTypes: ['cenc']
								}];
	
								options[0].audioCapabilities = [{
									contentType: 'audio/mp4; codecs="mp4a.40.2"'
								}];
	
								options[0].videoCapabilities = [{
									contentType: 'video/mp4; codecs="avc1.4d401f"'
								}];
	
								for (i = 0; i < keySystems.length; i++) {
									navigator.requestMediaKeySystemAccess(keySystems[i], options).then(function (keySystemAccess) {
										// eslint-disable-line no-loop-func
										supportedKeySystems.push(keySystemAccess.keySystem);
										count++;
	
										if (count === keySystems.length) {
											resolve(supportedKeySystems);
										}
									}).catch(function () {
										// eslint-disable-line no-loop-func
										count++;
	
										if (count === keySystems.length) {
											resolve(supportedKeySystems);
										}
									});
								}
							})();
						} else {
							var legacyMediaKeys = window.WebKitMediaKeys || window.MSMediaKeys || window.WEBKITMediaKeys;
	
							if (legacyMediaKeys) {
								for (i = 0; i < keySystems.length; i++) {
									if (legacyMediaKeys.isTypeSupported(keySystems[i], 'video/mp4')) {
										supportedKeySystems.push(keySystems[i]);
									}
								}
							}
	
							resolve(supportedKeySystems);
						}
					});
				}
	
				return this._caps;
			}
		}]);
	
		return EME;
	}();
	
	exports.default = EME;
	module.exports = exports['default'];

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Stream = __webpack_require__(11);
	
	var _AdtsStream;
	
	var ADTS_SAMPLING_FREQUENCIES = [96000, 88200, 64000, 48000, 44100, 32000, 24000, 22050, 16000, 12000, 11025, 8000, 7350];
	
	/*
	 * Accepts a ElementaryStream and emits data events with parsed
	 * AAC Audio Frames of the individual packets. Input audio in ADTS
	 * format is unpacked and re-emitted as AAC frames.
	 *
	 * @see http://wiki.multimedia.cx/index.php?title=ADTS
	 * @see http://wiki.multimedia.cx/?title=Understanding_AAC
	 */
	_AdtsStream = function AdtsStream() {
	  var buffer;
	
	  _AdtsStream.prototype.init.call(this);
	
	  this.push = function (packet) {
	    var i = 0,
	        frameNum = 0,
	        frameLength,
	        protectionSkipBytes,
	        frameEnd,
	        oldBuffer,
	        sampleCount,
	        adtsFrameDuration;
	
	    if (packet.type !== 'audio') {
	      // ignore non-audio data
	      return;
	    }
	
	    // Prepend any data in the buffer to the input data so that we can parse
	    // aac frames the cross a PES packet boundary
	    if (buffer) {
	      oldBuffer = buffer;
	      buffer = new Uint8Array(oldBuffer.byteLength + packet.data.byteLength);
	      buffer.set(oldBuffer);
	      buffer.set(packet.data, oldBuffer.byteLength);
	    } else {
	      buffer = packet.data;
	    }
	
	    // unpack any ADTS frames which have been fully received
	    // for details on the ADTS header, see http://wiki.multimedia.cx/index.php?title=ADTS
	    while (i + 5 < buffer.length) {
	
	      // Loook for the start of an ADTS header..
	      if (buffer[i] !== 0xFF || (buffer[i + 1] & 0xF6) !== 0xF0) {
	        // If a valid header was not found,  jump one forward and attempt to
	        // find a valid ADTS header starting at the next byte
	        i++;
	        continue;
	      }
	
	      // The protection skip bit tells us if we have 2 bytes of CRC data at the
	      // end of the ADTS header
	      protectionSkipBytes = (~buffer[i + 1] & 0x01) * 2;
	
	      // Frame length is a 13 bit integer starting 16 bits from the
	      // end of the sync sequence
	      frameLength = (buffer[i + 3] & 0x03) << 11 | buffer[i + 4] << 3 | (buffer[i + 5] & 0xe0) >> 5;
	
	      sampleCount = ((buffer[i + 6] & 0x03) + 1) * 1024;
	      adtsFrameDuration = sampleCount * 90000 / ADTS_SAMPLING_FREQUENCIES[(buffer[i + 2] & 0x3c) >>> 2];
	
	      frameEnd = i + frameLength;
	
	      // If we don't have enough data to actually finish this ADTS frame, return
	      // and wait for more data
	      if (buffer.byteLength < frameEnd) {
	        return;
	      }
	
	      // Otherwise, deliver the complete AAC frame
	      this.trigger('data', {
	        pts: packet.pts + frameNum * adtsFrameDuration,
	        dts: packet.dts + frameNum * adtsFrameDuration,
	        sampleCount: sampleCount,
	        audioobjecttype: (buffer[i + 2] >>> 6 & 0x03) + 1,
	        channelcount: (buffer[i + 2] & 1) << 2 | (buffer[i + 3] & 0xc0) >>> 6,
	        samplerate: ADTS_SAMPLING_FREQUENCIES[(buffer[i + 2] & 0x3c) >>> 2],
	        samplingfrequencyindex: (buffer[i + 2] & 0x3c) >>> 2,
	        // assume ISO/IEC 14496-12 AudioSampleEntry default of 16
	        samplesize: 16,
	        data: buffer.subarray(i + 7 + protectionSkipBytes, frameEnd)
	      });
	
	      // If the buffer is empty, clear it and return
	      if (buffer.byteLength === frameEnd) {
	        buffer = undefined;
	        return;
	      }
	
	      frameNum++;
	
	      // Remove the finished frame from the buffer and start the process again
	      buffer = buffer.subarray(frameEnd);
	    }
	  };
	  this.flush = function () {
	    this.trigger('done');
	  };
	};
	
	_AdtsStream.prototype = new Stream();
	
	module.exports = _AdtsStream;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Stream = __webpack_require__(11);
	var ExpGolomb = __webpack_require__(162);
	
	var _H264Stream, _NalByteStream;
	var PROFILES_WITH_OPTIONAL_SPS_DATA;
	
	/**
	 * Accepts a NAL unit byte stream and unpacks the embedded NAL units.
	 */
	_NalByteStream = function NalByteStream() {
	  var syncPoint = 0,
	      i,
	      buffer;
	  _NalByteStream.prototype.init.call(this);
	
	  this.push = function (data) {
	    var swapBuffer;
	
	    if (!buffer) {
	      buffer = data.data;
	    } else {
	      swapBuffer = new Uint8Array(buffer.byteLength + data.data.byteLength);
	      swapBuffer.set(buffer);
	      swapBuffer.set(data.data, buffer.byteLength);
	      buffer = swapBuffer;
	    }
	
	    // Rec. ITU-T H.264, Annex B
	    // scan for NAL unit boundaries
	
	    // a match looks like this:
	    // 0 0 1 .. NAL .. 0 0 1
	    // ^ sync point        ^ i
	    // or this:
	    // 0 0 1 .. NAL .. 0 0 0
	    // ^ sync point        ^ i
	
	    // advance the sync point to a NAL start, if necessary
	    for (; syncPoint < buffer.byteLength - 3; syncPoint++) {
	      if (buffer[syncPoint + 2] === 1) {
	        // the sync point is properly aligned
	        i = syncPoint + 5;
	        break;
	      }
	    }
	
	    while (i < buffer.byteLength) {
	      // look at the current byte to determine if we've hit the end of
	      // a NAL unit boundary
	      switch (buffer[i]) {
	        case 0:
	          // skip past non-sync sequences
	          if (buffer[i - 1] !== 0) {
	            i += 2;
	            break;
	          } else if (buffer[i - 2] !== 0) {
	            i++;
	            break;
	          }
	
	          // deliver the NAL unit if it isn't empty
	          if (syncPoint + 3 !== i - 2) {
	            this.trigger('data', buffer.subarray(syncPoint + 3, i - 2));
	          }
	
	          // drop trailing zeroes
	          do {
	            i++;
	          } while (buffer[i] !== 1 && i < buffer.length);
	          syncPoint = i - 2;
	          i += 3;
	          break;
	        case 1:
	          // skip past non-sync sequences
	          if (buffer[i - 1] !== 0 || buffer[i - 2] !== 0) {
	            i += 3;
	            break;
	          }
	
	          // deliver the NAL unit
	          this.trigger('data', buffer.subarray(syncPoint + 3, i - 2));
	          syncPoint = i - 2;
	          i += 3;
	          break;
	        default:
	          // the current byte isn't a one or zero, so it cannot be part
	          // of a sync sequence
	          i += 3;
	          break;
	      }
	    }
	    // filter out the NAL units that were delivered
	    buffer = buffer.subarray(syncPoint);
	    i -= syncPoint;
	    syncPoint = 0;
	  };
	
	  this.flush = function () {
	    // deliver the last buffered NAL unit
	    if (buffer && buffer.byteLength > 3) {
	      this.trigger('data', buffer.subarray(syncPoint + 3));
	    }
	    // reset the stream state
	    buffer = null;
	    syncPoint = 0;
	    this.trigger('done');
	  };
	};
	_NalByteStream.prototype = new Stream();
	
	// values of profile_idc that indicate additional fields are included in the SPS
	// see Recommendation ITU-T H.264 (4/2013),
	// 7.3.2.1.1 Sequence parameter set data syntax
	PROFILES_WITH_OPTIONAL_SPS_DATA = {
	  100: true,
	  110: true,
	  122: true,
	  244: true,
	  44: true,
	  83: true,
	  86: true,
	  118: true,
	  128: true,
	  138: true,
	  139: true,
	  134: true
	};
	
	/**
	 * Accepts input from a ElementaryStream and produces H.264 NAL unit data
	 * events.
	 */
	_H264Stream = function H264Stream() {
	  var nalByteStream = new _NalByteStream(),
	      self,
	      trackId,
	      currentPts,
	      currentDts,
	      discardEmulationPreventionBytes,
	      readSequenceParameterSet,
	      skipScalingList;
	
	  _H264Stream.prototype.init.call(this);
	  self = this;
	
	  this.push = function (packet) {
	    if (packet.type !== 'video') {
	      return;
	    }
	    trackId = packet.trackId;
	    currentPts = packet.pts;
	    currentDts = packet.dts;
	
	    nalByteStream.push(packet);
	  };
	
	  nalByteStream.on('data', function (data) {
	    var event = {
	      trackId: trackId,
	      pts: currentPts,
	      dts: currentDts,
	      data: data
	    };
	
	    switch (data[0] & 0x1f) {
	      case 0x05:
	        event.nalUnitType = 'slice_layer_without_partitioning_rbsp_idr';
	        break;
	      case 0x06:
	        event.nalUnitType = 'sei_rbsp';
	        event.escapedRBSP = discardEmulationPreventionBytes(data.subarray(1));
	        break;
	      case 0x07:
	        event.nalUnitType = 'seq_parameter_set_rbsp';
	        event.escapedRBSP = discardEmulationPreventionBytes(data.subarray(1));
	        event.config = readSequenceParameterSet(event.escapedRBSP);
	        break;
	      case 0x08:
	        event.nalUnitType = 'pic_parameter_set_rbsp';
	        break;
	      case 0x09:
	        event.nalUnitType = 'access_unit_delimiter_rbsp';
	        break;
	
	      default:
	        break;
	    }
	    self.trigger('data', event);
	  });
	  nalByteStream.on('done', function () {
	    self.trigger('done');
	  });
	
	  this.flush = function () {
	    nalByteStream.flush();
	  };
	
	  /**
	   * Advance the ExpGolomb decoder past a scaling list. The scaling
	   * list is optionally transmitted as part of a sequence parameter
	   * set and is not relevant to transmuxing.
	   * @param count {number} the number of entries in this scaling list
	   * @param expGolombDecoder {object} an ExpGolomb pointed to the
	   * start of a scaling list
	   * @see Recommendation ITU-T H.264, Section 7.3.2.1.1.1
	   */
	  skipScalingList = function skipScalingList(count, expGolombDecoder) {
	    var lastScale = 8,
	        nextScale = 8,
	        j,
	        deltaScale;
	
	    for (j = 0; j < count; j++) {
	      if (nextScale !== 0) {
	        deltaScale = expGolombDecoder.readExpGolomb();
	        nextScale = (lastScale + deltaScale + 256) % 256;
	      }
	
	      lastScale = nextScale === 0 ? lastScale : nextScale;
	    }
	  };
	
	  /**
	   * Expunge any "Emulation Prevention" bytes from a "Raw Byte
	   * Sequence Payload"
	   * @param data {Uint8Array} the bytes of a RBSP from a NAL
	   * unit
	   * @return {Uint8Array} the RBSP without any Emulation
	   * Prevention Bytes
	   */
	  discardEmulationPreventionBytes = function discardEmulationPreventionBytes(data) {
	    var length = data.byteLength,
	        emulationPreventionBytesPositions = [],
	        i = 1,
	        newLength,
	        newData;
	
	    // Find all `Emulation Prevention Bytes`
	    while (i < length - 2) {
	      if (data[i] === 0 && data[i + 1] === 0 && data[i + 2] === 0x03) {
	        emulationPreventionBytesPositions.push(i + 2);
	        i += 2;
	      } else {
	        i++;
	      }
	    }
	
	    // If no Emulation Prevention Bytes were found just return the original
	    // array
	    if (emulationPreventionBytesPositions.length === 0) {
	      return data;
	    }
	
	    // Create a new array to hold the NAL unit data
	    newLength = length - emulationPreventionBytesPositions.length;
	    newData = new Uint8Array(newLength);
	    var sourceIndex = 0;
	
	    for (i = 0; i < newLength; sourceIndex++, i++) {
	      if (sourceIndex === emulationPreventionBytesPositions[0]) {
	        // Skip this byte
	        sourceIndex++;
	        // Remove this position index
	        emulationPreventionBytesPositions.shift();
	      }
	      newData[i] = data[sourceIndex];
	    }
	
	    return newData;
	  };
	
	  /**
	   * Read a sequence parameter set and return some interesting video
	   * properties. A sequence parameter set is the H264 metadata that
	   * describes the properties of upcoming video frames.
	   * @param data {Uint8Array} the bytes of a sequence parameter set
	   * @return {object} an object with configuration parsed from the
	   * sequence parameter set, including the dimensions of the
	   * associated video frames.
	   */
	  readSequenceParameterSet = function readSequenceParameterSet(data) {
	    var frameCropLeftOffset = 0,
	        frameCropRightOffset = 0,
	        frameCropTopOffset = 0,
	        frameCropBottomOffset = 0,
	        sarScale = 1,
	        expGolombDecoder,
	        profileIdc,
	        levelIdc,
	        profileCompatibility,
	        chromaFormatIdc,
	        picOrderCntType,
	        numRefFramesInPicOrderCntCycle,
	        picWidthInMbsMinus1,
	        picHeightInMapUnitsMinus1,
	        frameMbsOnlyFlag,
	        scalingListCount,
	        sarRatio,
	        aspectRatioIdc,
	        i;
	
	    expGolombDecoder = new ExpGolomb(data);
	    profileIdc = expGolombDecoder.readUnsignedByte(); // profile_idc
	    profileCompatibility = expGolombDecoder.readUnsignedByte(); // constraint_set[0-5]_flag
	    levelIdc = expGolombDecoder.readUnsignedByte(); // level_idc u(8)
	    expGolombDecoder.skipUnsignedExpGolomb(); // seq_parameter_set_id
	
	    // some profiles have more optional data we don't need
	    if (PROFILES_WITH_OPTIONAL_SPS_DATA[profileIdc]) {
	      chromaFormatIdc = expGolombDecoder.readUnsignedExpGolomb();
	      if (chromaFormatIdc === 3) {
	        expGolombDecoder.skipBits(1); // separate_colour_plane_flag
	      }
	      expGolombDecoder.skipUnsignedExpGolomb(); // bit_depth_luma_minus8
	      expGolombDecoder.skipUnsignedExpGolomb(); // bit_depth_chroma_minus8
	      expGolombDecoder.skipBits(1); // qpprime_y_zero_transform_bypass_flag
	      if (expGolombDecoder.readBoolean()) {
	        // seq_scaling_matrix_present_flag
	        scalingListCount = chromaFormatIdc !== 3 ? 8 : 12;
	        for (i = 0; i < scalingListCount; i++) {
	          if (expGolombDecoder.readBoolean()) {
	            // seq_scaling_list_present_flag[ i ]
	            if (i < 6) {
	              skipScalingList(16, expGolombDecoder);
	            } else {
	              skipScalingList(64, expGolombDecoder);
	            }
	          }
	        }
	      }
	    }
	
	    expGolombDecoder.skipUnsignedExpGolomb(); // log2_max_frame_num_minus4
	    picOrderCntType = expGolombDecoder.readUnsignedExpGolomb();
	
	    if (picOrderCntType === 0) {
	      expGolombDecoder.readUnsignedExpGolomb(); // log2_max_pic_order_cnt_lsb_minus4
	    } else if (picOrderCntType === 1) {
	      expGolombDecoder.skipBits(1); // delta_pic_order_always_zero_flag
	      expGolombDecoder.skipExpGolomb(); // offset_for_non_ref_pic
	      expGolombDecoder.skipExpGolomb(); // offset_for_top_to_bottom_field
	      numRefFramesInPicOrderCntCycle = expGolombDecoder.readUnsignedExpGolomb();
	      for (i = 0; i < numRefFramesInPicOrderCntCycle; i++) {
	        expGolombDecoder.skipExpGolomb(); // offset_for_ref_frame[ i ]
	      }
	    }
	
	    expGolombDecoder.skipUnsignedExpGolomb(); // max_num_ref_frames
	    expGolombDecoder.skipBits(1); // gaps_in_frame_num_value_allowed_flag
	
	    picWidthInMbsMinus1 = expGolombDecoder.readUnsignedExpGolomb();
	    picHeightInMapUnitsMinus1 = expGolombDecoder.readUnsignedExpGolomb();
	
	    frameMbsOnlyFlag = expGolombDecoder.readBits(1);
	    if (frameMbsOnlyFlag === 0) {
	      expGolombDecoder.skipBits(1); // mb_adaptive_frame_field_flag
	    }
	
	    expGolombDecoder.skipBits(1); // direct_8x8_inference_flag
	    if (expGolombDecoder.readBoolean()) {
	      // frame_cropping_flag
	      frameCropLeftOffset = expGolombDecoder.readUnsignedExpGolomb();
	      frameCropRightOffset = expGolombDecoder.readUnsignedExpGolomb();
	      frameCropTopOffset = expGolombDecoder.readUnsignedExpGolomb();
	      frameCropBottomOffset = expGolombDecoder.readUnsignedExpGolomb();
	    }
	    if (expGolombDecoder.readBoolean()) {
	      // vui_parameters_present_flag
	      if (expGolombDecoder.readBoolean()) {
	        // aspect_ratio_info_present_flag
	        aspectRatioIdc = expGolombDecoder.readUnsignedByte();
	        switch (aspectRatioIdc) {
	          case 1:
	            sarRatio = [1, 1];break;
	          case 2:
	            sarRatio = [12, 11];break;
	          case 3:
	            sarRatio = [10, 11];break;
	          case 4:
	            sarRatio = [16, 11];break;
	          case 5:
	            sarRatio = [40, 33];break;
	          case 6:
	            sarRatio = [24, 11];break;
	          case 7:
	            sarRatio = [20, 11];break;
	          case 8:
	            sarRatio = [32, 11];break;
	          case 9:
	            sarRatio = [80, 33];break;
	          case 10:
	            sarRatio = [18, 11];break;
	          case 11:
	            sarRatio = [15, 11];break;
	          case 12:
	            sarRatio = [64, 33];break;
	          case 13:
	            sarRatio = [160, 99];break;
	          case 14:
	            sarRatio = [4, 3];break;
	          case 15:
	            sarRatio = [3, 2];break;
	          case 16:
	            sarRatio = [2, 1];break;
	          case 255:
	            {
	              sarRatio = [expGolombDecoder.readUnsignedByte() << 8 | expGolombDecoder.readUnsignedByte(), expGolombDecoder.readUnsignedByte() << 8 | expGolombDecoder.readUnsignedByte()];
	              break;
	            }
	        }
	        if (sarRatio) {
	          sarScale = sarRatio[0] / sarRatio[1];
	        }
	      }
	    }
	    return {
	      profileIdc: profileIdc,
	      levelIdc: levelIdc,
	      profileCompatibility: profileCompatibility,
	      width: Math.ceil(((picWidthInMbsMinus1 + 1) * 16 - frameCropLeftOffset * 2 - frameCropRightOffset * 2) * sarScale),
	      height: (2 - frameMbsOnlyFlag) * (picHeightInMapUnitsMinus1 + 1) * 16 - frameCropTopOffset * 2 - frameCropBottomOffset * 2
	    };
	  };
	};
	_H264Stream.prototype = new Stream();
	
	module.exports = {
	  H264Stream: _H264Stream,
	  NalByteStream: _NalByteStream
	};

/***/ }),
/* 43 */
/***/ (function(module, exports) {

	/**
	 * An object that stores the bytes of an FLV tag and methods for
	 * querying and manipulating that data.
	 * @see http://download.macromedia.com/f4v/video_file_format_spec_v10_1.pdf
	 */
	'use strict';
	
	var _FlvTag;
	
	// (type:uint, extraData:Boolean = false) extends ByteArray
	_FlvTag = function FlvTag(type, extraData) {
	  var
	  // Counter if this is a metadata tag, nal start marker if this is a video
	  // tag. unused if this is an audio tag
	  adHoc = 0,
	      // :uint
	
	  // The default size is 16kb but this is not enough to hold iframe
	  // data and the resizing algorithm costs a bit so we create a larger
	  // starting buffer for video tags
	  bufferStartSize = 16384,
	
	
	  // checks whether the FLV tag has enough capacity to accept the proposed
	  // write and re-allocates the internal buffers if necessary
	  prepareWrite = function prepareWrite(flv, count) {
	    var bytes,
	        minLength = flv.position + count;
	    if (minLength < flv.bytes.byteLength) {
	      // there's enough capacity so do nothing
	      return;
	    }
	
	    // allocate a new buffer and copy over the data that will not be modified
	    bytes = new Uint8Array(minLength * 2);
	    bytes.set(flv.bytes.subarray(0, flv.position), 0);
	    flv.bytes = bytes;
	    flv.view = new DataView(flv.bytes.buffer);
	  },
	
	
	  // commonly used metadata properties
	  widthBytes = _FlvTag.widthBytes || new Uint8Array('width'.length),
	      heightBytes = _FlvTag.heightBytes || new Uint8Array('height'.length),
	      videocodecidBytes = _FlvTag.videocodecidBytes || new Uint8Array('videocodecid'.length),
	      i;
	
	  if (!_FlvTag.widthBytes) {
	    // calculating the bytes of common metadata names ahead of time makes the
	    // corresponding writes faster because we don't have to loop over the
	    // characters
	    // re-test with test/perf.html if you're planning on changing this
	    for (i = 0; i < 'width'.length; i++) {
	      widthBytes[i] = 'width'.charCodeAt(i);
	    }
	    for (i = 0; i < 'height'.length; i++) {
	      heightBytes[i] = 'height'.charCodeAt(i);
	    }
	    for (i = 0; i < 'videocodecid'.length; i++) {
	      videocodecidBytes[i] = 'videocodecid'.charCodeAt(i);
	    }
	
	    _FlvTag.widthBytes = widthBytes;
	    _FlvTag.heightBytes = heightBytes;
	    _FlvTag.videocodecidBytes = videocodecidBytes;
	  }
	
	  this.keyFrame = false; // :Boolean
	
	  switch (type) {
	    case _FlvTag.VIDEO_TAG:
	      this.length = 16;
	      // Start the buffer at 256k
	      bufferStartSize *= 6;
	      break;
	    case _FlvTag.AUDIO_TAG:
	      this.length = 13;
	      this.keyFrame = true;
	      break;
	    case _FlvTag.METADATA_TAG:
	      this.length = 29;
	      this.keyFrame = true;
	      break;
	    default:
	      throw new Error('Unknown FLV tag type');
	  }
	
	  this.bytes = new Uint8Array(bufferStartSize);
	  this.view = new DataView(this.bytes.buffer);
	  this.bytes[0] = type;
	  this.position = this.length;
	  this.keyFrame = extraData; // Defaults to false
	
	  // presentation timestamp
	  this.pts = 0;
	  // decoder timestamp
	  this.dts = 0;
	
	  // ByteArray#writeBytes(bytes:ByteArray, offset:uint = 0, length:uint = 0)
	  this.writeBytes = function (bytes, offset, length) {
	    var start = offset || 0,
	        end;
	    length = length || bytes.byteLength;
	    end = start + length;
	
	    prepareWrite(this, length);
	    this.bytes.set(bytes.subarray(start, end), this.position);
	
	    this.position += length;
	    this.length = Math.max(this.length, this.position);
	  };
	
	  // ByteArray#writeByte(value:int):void
	  this.writeByte = function (byte) {
	    prepareWrite(this, 1);
	    this.bytes[this.position] = byte;
	    this.position++;
	    this.length = Math.max(this.length, this.position);
	  };
	
	  // ByteArray#writeShort(value:int):void
	  this.writeShort = function (short) {
	    prepareWrite(this, 2);
	    this.view.setUint16(this.position, short);
	    this.position += 2;
	    this.length = Math.max(this.length, this.position);
	  };
	
	  // Negative index into array
	  // (pos:uint):int
	  this.negIndex = function (pos) {
	    return this.bytes[this.length - pos];
	  };
	
	  // The functions below ONLY work when this[0] == VIDEO_TAG.
	  // We are not going to check for that because we dont want the overhead
	  // (nal:ByteArray = null):int
	  this.nalUnitSize = function () {
	    if (adHoc === 0) {
	      return 0;
	    }
	
	    return this.length - (adHoc + 4);
	  };
	
	  this.startNalUnit = function () {
	    // remember position and add 4 bytes
	    if (adHoc > 0) {
	      throw new Error('Attempted to create new NAL wihout closing the old one');
	    }
	
	    // reserve 4 bytes for nal unit size
	    adHoc = this.length;
	    this.length += 4;
	    this.position = this.length;
	  };
	
	  // (nal:ByteArray = null):void
	  this.endNalUnit = function (nalContainer) {
	    var nalStart, // :uint
	    nalLength; // :uint
	
	    // Rewind to the marker and write the size
	    if (this.length === adHoc + 4) {
	      // we started a nal unit, but didnt write one, so roll back the 4 byte size value
	      this.length -= 4;
	    } else if (adHoc > 0) {
	      nalStart = adHoc + 4;
	      nalLength = this.length - nalStart;
	
	      this.position = adHoc;
	      this.view.setUint32(this.position, nalLength);
	      this.position = this.length;
	
	      if (nalContainer) {
	        // Add the tag to the NAL unit
	        nalContainer.push(this.bytes.subarray(nalStart, nalStart + nalLength));
	      }
	    }
	
	    adHoc = 0;
	  };
	
	  /**
	   * Write out a 64-bit floating point valued metadata property. This method is
	   * called frequently during a typical parse and needs to be fast.
	   */
	  // (key:String, val:Number):void
	  this.writeMetaDataDouble = function (key, val) {
	    var i;
	    prepareWrite(this, 2 + key.length + 9);
	
	    // write size of property name
	    this.view.setUint16(this.position, key.length);
	    this.position += 2;
	
	    // this next part looks terrible but it improves parser throughput by
	    // 10kB/s in my testing
	
	    // write property name
	    if (key === 'width') {
	      this.bytes.set(widthBytes, this.position);
	      this.position += 5;
	    } else if (key === 'height') {
	      this.bytes.set(heightBytes, this.position);
	      this.position += 6;
	    } else if (key === 'videocodecid') {
	      this.bytes.set(videocodecidBytes, this.position);
	      this.position += 12;
	    } else {
	      for (i = 0; i < key.length; i++) {
	        this.bytes[this.position] = key.charCodeAt(i);
	        this.position++;
	      }
	    }
	
	    // skip null byte
	    this.position++;
	
	    // write property value
	    this.view.setFloat64(this.position, val);
	    this.position += 8;
	
	    // update flv tag length
	    this.length = Math.max(this.length, this.position);
	    ++adHoc;
	  };
	
	  // (key:String, val:Boolean):void
	  this.writeMetaDataBoolean = function (key, val) {
	    var i;
	    prepareWrite(this, 2);
	    this.view.setUint16(this.position, key.length);
	    this.position += 2;
	    for (i = 0; i < key.length; i++) {
	      // if key.charCodeAt(i) >= 255, handle error
	      prepareWrite(this, 1);
	      this.bytes[this.position] = key.charCodeAt(i);
	      this.position++;
	    }
	    prepareWrite(this, 2);
	    this.view.setUint8(this.position, 0x01);
	    this.position++;
	    this.view.setUint8(this.position, val ? 0x01 : 0x00);
	    this.position++;
	    this.length = Math.max(this.length, this.position);
	    ++adHoc;
	  };
	
	  // ():ByteArray
	  this.finalize = function () {
	    var dtsDelta, // :int
	    len; // :int
	
	    switch (this.bytes[0]) {
	      // Video Data
	      case _FlvTag.VIDEO_TAG:
	        // We only support AVC, 1 = key frame (for AVC, a seekable
	        // frame), 2 = inter frame (for AVC, a non-seekable frame)
	        this.bytes[11] = (this.keyFrame || extraData ? 0x10 : 0x20) | 0x07;
	        this.bytes[12] = extraData ? 0x00 : 0x01;
	
	        dtsDelta = this.pts - this.dts;
	        this.bytes[13] = (dtsDelta & 0x00FF0000) >>> 16;
	        this.bytes[14] = (dtsDelta & 0x0000FF00) >>> 8;
	        this.bytes[15] = (dtsDelta & 0x000000FF) >>> 0;
	        break;
	
	      case _FlvTag.AUDIO_TAG:
	        this.bytes[11] = 0xAF; // 44 kHz, 16-bit stereo
	        this.bytes[12] = extraData ? 0x00 : 0x01;
	        break;
	
	      case _FlvTag.METADATA_TAG:
	        this.position = 11;
	        this.view.setUint8(this.position, 0x02); // String type
	        this.position++;
	        this.view.setUint16(this.position, 0x0A); // 10 Bytes
	        this.position += 2;
	        // set "onMetaData"
	        this.bytes.set([0x6f, 0x6e, 0x4d, 0x65, 0x74, 0x61, 0x44, 0x61, 0x74, 0x61], this.position);
	        this.position += 10;
	        this.bytes[this.position] = 0x08; // Array type
	        this.position++;
	        this.view.setUint32(this.position, adHoc);
	        this.position = this.length;
	        this.bytes.set([0, 0, 9], this.position);
	        this.position += 3; // End Data Tag
	        this.length = this.position;
	        break;
	    }
	
	    len = this.length - 11;
	
	    // write the DataSize field
	    this.bytes[1] = (len & 0x00FF0000) >>> 16;
	    this.bytes[2] = (len & 0x0000FF00) >>> 8;
	    this.bytes[3] = (len & 0x000000FF) >>> 0;
	    // write the Timestamp
	    this.bytes[4] = (this.dts & 0x00FF0000) >>> 16;
	    this.bytes[5] = (this.dts & 0x0000FF00) >>> 8;
	    this.bytes[6] = (this.dts & 0x000000FF) >>> 0;
	    this.bytes[7] = (this.dts & 0xFF000000) >>> 24;
	    // write the StreamID
	    this.bytes[8] = 0;
	    this.bytes[9] = 0;
	    this.bytes[10] = 0;
	
	    // Sometimes we're at the end of the view and have one slot to write a
	    // uint32, so, prepareWrite of count 4, since, view is uint8
	    prepareWrite(this, 4);
	    this.view.setUint32(this.length, this.length);
	    this.length += 4;
	    this.position += 4;
	
	    // trim down the byte buffer to what is actually being used
	    this.bytes = this.bytes.subarray(0, this.length);
	    this.frameTime = _FlvTag.frameTime(this.bytes);
	    // if bytes.bytelength isn't equal to this.length, handle error
	    return this;
	  };
	};
	
	_FlvTag.AUDIO_TAG = 0x08; // == 8, :uint
	_FlvTag.VIDEO_TAG = 0x09; // == 9, :uint
	_FlvTag.METADATA_TAG = 0x12; // == 18, :uint
	
	// (tag:ByteArray):Boolean {
	_FlvTag.isAudioFrame = function (tag) {
	  return _FlvTag.AUDIO_TAG === tag[0];
	};
	
	// (tag:ByteArray):Boolean {
	_FlvTag.isVideoFrame = function (tag) {
	  return _FlvTag.VIDEO_TAG === tag[0];
	};
	
	// (tag:ByteArray):Boolean {
	_FlvTag.isMetaData = function (tag) {
	  return _FlvTag.METADATA_TAG === tag[0];
	};
	
	// (tag:ByteArray):Boolean {
	_FlvTag.isKeyFrame = function (tag) {
	  if (_FlvTag.isVideoFrame(tag)) {
	    return tag[11] === 0x17;
	  }
	
	  if (_FlvTag.isAudioFrame(tag)) {
	    return true;
	  }
	
	  if (_FlvTag.isMetaData(tag)) {
	    return true;
	  }
	
	  return false;
	};
	
	// (tag:ByteArray):uint {
	_FlvTag.frameTime = function (tag) {
	  var pts = tag[4] << 16; // :uint
	  pts |= tag[5] << 8;
	  pts |= tag[6] << 0;
	  pts |= tag[7] << 24;
	  return pts;
	};
	
	module.exports = _FlvTag;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var muxjs = {
	  codecs: __webpack_require__(145),
	  mp4: __webpack_require__(156),
	  flv: __webpack_require__(149),
	  mp2t: __webpack_require__(153)
	};
	
	// include all the tools when the full library is required
	muxjs.mp4.tools = __webpack_require__(159);
	muxjs.flv.tools = __webpack_require__(158);
	muxjs.mp2t.tools = __webpack_require__(160);
	
	module.exports = muxjs;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * mux.js
	 *
	 * Copyright (c) 2015 Brightcove
	 * All rights reserved.
	 *
	 * A stream-based mp2t to mp4 converter. This utility can be used to
	 * deliver mp4s to a SourceBuffer on platforms that support native
	 * Media Source Extensions.
	 */
	'use strict';
	
	var Stream = __webpack_require__(11),
	    CaptionStream = __webpack_require__(152),
	    StreamTypes = __webpack_require__(26),
	    TimestampRolloverStream = __webpack_require__(76).TimestampRolloverStream;
	
	var m2tsStreamTypes = __webpack_require__(26);
	
	// object types
	var _TransportPacketStream, _TransportParseStream, _ElementaryStream;
	
	// constants
	var MP2T_PACKET_LENGTH = 188,
	    // bytes
	SYNC_BYTE = 0x47;
	
	/**
	 * Splits an incoming stream of binary data into MPEG-2 Transport
	 * Stream packets.
	 */
	/*Mactrix replace
	TransportPacketStream = function() {
	*/
	//Mactrix changes begin: pass in the logger
	_TransportPacketStream = function TransportPacketStream(tube) {
	  //Mactrix changes end
	  var buffer = new Uint8Array(MP2T_PACKET_LENGTH),
	
	  //Mactrix changes begin
	  logTube = tube,
	
	  //Mactrix changes end
	  bytesInBuffer = 0;
	
	  _TransportPacketStream.prototype.init.call(this);
	
	  // Deliver new bytes to the stream.
	
	  this.push = function (bytes) {
	    var startIndex = 0,
	        endIndex = MP2T_PACKET_LENGTH,
	
	    //Mactrix changes begin
	    corrupt = false,
	
	    //Mactrix changes end
	    everything;
	
	    // If there are bytes remaining from the last segment, prepend them to the
	    // bytes that were pushed in
	    if (bytesInBuffer) {
	      everything = new Uint8Array(bytes.byteLength + bytesInBuffer);
	      everything.set(buffer.subarray(0, bytesInBuffer));
	      everything.set(bytes, bytesInBuffer);
	      bytesInBuffer = 0;
	    } else {
	      everything = bytes;
	    }
	
	    // While we have enough data for a packet
	    while (endIndex < everything.byteLength) {
	      // Look for a pair of start and end sync bytes in the data..
	      if (everything[startIndex] === SYNC_BYTE && everything[endIndex] === SYNC_BYTE) {
	        // We found a packet so emit it and jump one whole packet forward in
	        // the stream
	        this.trigger('data', everything.subarray(startIndex, endIndex));
	        startIndex += MP2T_PACKET_LENGTH;
	        endIndex += MP2T_PACKET_LENGTH;
	        continue;
	      }
	      // If we get here, we have somehow become de-synchronized and we need to step
	      // forward one byte at a time until we find a pair of sync bytes that denote
	      // a packet
	      //Mactrix changes begin: this chunk is corrupt
	      corrupt = true;
	      //Mactrix changes end
	      startIndex++;
	      endIndex++;
	    }
	
	    //Mactrix changes begin: emit a warning if we failed to sync at least once
	    if (corrupt === true) {
	      if (logTube) {
	        logTube.log('m2ts.js: Lost pkt alignment at least once while processing the transport stream chunk');
	      }
	    }
	    //Mactrix changes end
	
	    // If there was some data left over at the end of the segment that couldn't
	    // possibly be a whole packet, keep it because it might be the start of a packet
	    // that continues in the next segment
	    if (startIndex < everything.byteLength) {
	      buffer.set(everything.subarray(startIndex), 0);
	      bytesInBuffer = everything.byteLength - startIndex;
	    }
	  };
	
	  this.flush = function () {
	    // If the buffer contains a whole packet when we are being flushed, emit it
	    // and empty the buffer. Otherwise hold onto the data because it may be
	    // important for decoding the next segment
	    if (bytesInBuffer === MP2T_PACKET_LENGTH && buffer[0] === SYNC_BYTE) {
	      this.trigger('data', buffer);
	      bytesInBuffer = 0;
	    }
	    this.trigger('done');
	  };
	};
	_TransportPacketStream.prototype = new Stream();
	
	/**
	 * Accepts an MP2T TransportPacketStream and emits data events with parsed
	 * forms of the individual transport stream packets.
	 */
	/*Mactrix replace
	TransportParseStream = function() {
	*/
	//Mactrix changes begin: pass in the logger
	_TransportParseStream = function TransportParseStream(tube) {
	  var logTube = tube;
	  //Mactrix changes end
	  var parsePsi, parsePat, parsePmt, self;
	  _TransportParseStream.prototype.init.call(this);
	  self = this;
	
	  this.packetsWaitingForPmt = [];
	  this.programMapTable = undefined;
	
	  parsePsi = function parsePsi(payload, psi) {
	    var offset = 0;
	
	    // PSI packets may be split into multiple sections and those
	    // sections may be split into multiple packets. If a PSI
	    // section starts in this packet, the payload_unit_start_indicator
	    // will be true and the first byte of the payload will indicate
	    // the offset from the current position to the start of the
	    // section.
	    if (psi.payloadUnitStartIndicator) {
	      offset += payload[offset] + 1;
	    }
	
	    if (psi.type === 'pat') {
	      parsePat(payload.subarray(offset), psi);
	    } else {
	      parsePmt(payload.subarray(offset), psi);
	    }
	  };
	
	  parsePat = function parsePat(payload, pat) {
	    pat.section_number = payload[7]; // eslint-disable-line camelcase
	    pat.last_section_number = payload[8]; // eslint-disable-line camelcase
	
	    // skip the PSI header and parse the first PMT entry
	    self.pmtPid = (payload[10] & 0x1F) << 8 | payload[11];
	    pat.pmtPid = self.pmtPid;
	  };
	
	  /**
	   * Parse out the relevant fields of a Program Map Table (PMT).
	   * @param payload {Uint8Array} the PMT-specific portion of an MP2T
	   * packet. The first byte in this array should be the table_id
	   * field.
	   * @param pmt {object} the object that should be decorated with
	   * fields parsed from the PMT.
	   */
	  parsePmt = function parsePmt(payload, pmt) {
	    var sectionLength, tableEnd, programInfoLength, offset;
	
	    // PMTs can be sent ahead of the time when they should actually
	    // take effect. We don't believe this should ever be the case
	    // for HLS but we'll ignore "forward" PMT declarations if we see
	    // them. Future PMT declarations have the current_next_indicator
	    // set to zero.
	    if (!(payload[5] & 0x01)) {
	      return;
	    }
	
	    // overwrite any existing program map table
	    self.programMapTable = {};
	
	    //Mactrix changes begin: the current audio track will be the one with the lowest audio pid
	    //0x1FFF(13 bits) is the maximum pid value (a null pkt), so we can use this as a start value
	    self.audioPid = 8191;
	    //Mactrix changes end
	
	    // the mapping table ends at the end of the current section
	    sectionLength = (payload[1] & 0x0f) << 8 | payload[2];
	    tableEnd = 3 + sectionLength - 4;
	
	    // to determine where the table is, we have to figure out how
	    // long the program info descriptors are
	    programInfoLength = (payload[10] & 0x0f) << 8 | payload[11];
	
	    // advance the offset to the first entry in the mapping table
	    offset = 12 + programInfoLength;
	    while (offset < tableEnd) {
	      /*Mactrix replace
	            // add an entry that maps the elementary_pid to the stream_type
	            self.programMapTable[(payload[offset + 1] & 0x1F) << 8 | payload[offset + 2]] = payload[offset];
	      */
	      //Mactrix changes begin: we need to store the lowest audio pid so we can compare each audio pkts pid against this so we don't emit multiple audio streams as one audio fragment
	      var pid = (payload[offset + 1] & 0x1F) << 8 | payload[offset + 2];
	      var streamType = payload[offset];
	      self.programMapTable[pid] = streamType;
	
	      if (streamType === 15 /*aac*/) {
	          //will need this when we add a/ec3 support
	          //|| streamType === 129 /*ac3*/ || streamType === 135 /*ec3*/) {
	          if (pid < self.audioPid) {
	            self.audioPid = pid;
	          }
	        }
	      //Mactrix changes end
	
	      // move to the next table entry
	      // skip past the elementary stream descriptors, if present
	      offset += ((payload[offset + 3] & 0x0F) << 8 | payload[offset + 4]) + 5;
	    }
	
	    // record the map on the packet as well
	    pmt.programMapTable = self.programMapTable;
	
	    // if there are any packets waiting for a PMT to be found, process them now
	    while (self.packetsWaitingForPmt.length) {
	      self.processPes_.apply(self, self.packetsWaitingForPmt.shift());
	    }
	  };
	
	  /**
	   * Deliver a new MP2T packet to the stream.
	   */
	  this.push = function (packet) {
	    var result = {},
	        offset = 4;
	
	    result.payloadUnitStartIndicator = !!(packet[1] & 0x40);
	
	    // pid is a 13-bit field starting at the last bit of packet[1]
	    result.pid = packet[1] & 0x1f;
	    result.pid <<= 8;
	    result.pid |= packet[2];
	
	    // if an adaption field is present, its length is specified by the
	    // fifth byte of the TS packet header. The adaptation field is
	    // used to add stuffing to PES packets that don't fill a complete
	    // TS packet, and to specify some forms of timing and control data
	    // that we do not currently use.
	    if ((packet[3] & 0x30) >>> 4 > 0x01) {
	      offset += packet[offset] + 1;
	    }
	
	    // parse the rest of the packet based on the type
	    if (result.pid === 0) {
	      result.type = 'pat';
	      parsePsi(packet.subarray(offset), result);
	      this.trigger('data', result);
	    } else if (result.pid === this.pmtPid) {
	      result.type = 'pmt';
	      parsePsi(packet.subarray(offset), result);
	      this.trigger('data', result);
	    } else if (this.programMapTable === undefined) {
	      // When we have not seen a PMT yet, defer further processing of
	      // PES packets until one has been parsed
	      this.packetsWaitingForPmt.push([packet, offset, result]);
	    } else {
	      this.processPes_(packet, offset, result);
	    }
	  };
	
	  this.processPes_ = function (packet, offset, result) {
	    result.streamType = this.programMapTable[result.pid];
	
	    /*Mactrix replace
	        result.type = 'pes';
	        result.data = packet.subarray(offset);
	        this.trigger('data', result);
	    */
	    //Mactrix changes begin: need to only add audio pkts from the lowest audio pid
	    if (result.streamType === 15) {
	      //or a/ec3
	      if (result.pid === this.audioPid) {
	        result.type = 'pes';
	        result.data = packet.subarray(offset);
	        this.trigger('data', result);
	      }
	    } else {
	      result.type = 'pes';
	      result.data = packet.subarray(offset);
	      this.trigger('data', result);
	    }
	    //Mactrix changes end
	  };
	};
	_TransportParseStream.prototype = new Stream();
	_TransportParseStream.STREAM_TYPES = {
	  h264: 0x1b,
	  adts: 0x0f
	};
	
	/**
	 * Reconsistutes program elementary stream (PES) packets from parsed
	 * transport stream packets. That is, if you pipe an
	 * mp2t.TransportParseStream into a mp2t.ElementaryStream, the output
	 * events will be events which capture the bytes for individual PES
	 * packets plus relevant metadata that has been extracted from the
	 * container.
	 */
	/*Mactrix replace
	ElementaryStream = function() {
	*/
	_ElementaryStream = function ElementaryStream(tube) {
	  var self = this,
	
	  // PES packet fragments
	  video = {
	    data: [],
	    size: 0
	  },
	      audio = {
	    data: [],
	    size: 0
	  },
	      timedMetadata = {
	    data: [],
	    size: 0
	  },
	
	  //Mactrix changes begin
	  logTube = tube,
	
	  //Mactrix changes end
	  parsePes = function parsePes(payload, pes) {
	    var ptsDtsFlags;
	
	    // find out if this packets starts a new keyframe
	    pes.dataAlignmentIndicator = (payload[6] & 0x04) !== 0;
	    // PES packets may be annotated with a PTS value, or a PTS value
	    // and a DTS value. Determine what combination of values is
	    // available to work with.
	    ptsDtsFlags = payload[7];
	
	    // PTS and DTS are normally stored as a 33-bit number.  Javascript
	    // performs all bitwise operations on 32-bit integers but javascript
	    // supports a much greater range (52-bits) of integer using standard
	    // mathematical operations.
	    // We construct a 31-bit value using bitwise operators over the 31
	    // most significant bits and then multiply by 4 (equal to a left-shift
	    // of 2) before we add the final 2 least significant bits of the
	    // timestamp (equal to an OR.)
	    if (ptsDtsFlags & 0xC0) {
	      // the PTS and DTS are not written out directly. For information
	      // on how they are encoded, see
	      // http://dvd.sourceforge.net/dvdinfo/pes-hdr.html
	      pes.pts = (payload[9] & 0x0E) << 27 | (payload[10] & 0xFF) << 20 | (payload[11] & 0xFE) << 12 | (payload[12] & 0xFF) << 5 | (payload[13] & 0xFE) >>> 3;
	      pes.pts *= 4; // Left shift by 2
	      pes.pts += (payload[13] & 0x06) >>> 1; // OR by the two LSBs
	      pes.dts = pes.pts;
	      if (ptsDtsFlags & 0x40) {
	        pes.dts = (payload[14] & 0x0E) << 27 | (payload[15] & 0xFF) << 20 | (payload[16] & 0xFE) << 12 | (payload[17] & 0xFF) << 5 | (payload[18] & 0xFE) >>> 3;
	        pes.dts *= 4; // Left shift by 2
	        pes.dts += (payload[18] & 0x06) >>> 1; // OR by the two LSBs
	      }
	    }
	    // the data section starts immediately after the PES header.
	    // pes_header_data_length specifies the number of header bytes
	    // that follow the last byte of the field.
	    pes.data = payload.subarray(9 + payload[8]);
	  },
	      flushStream = function flushStream(stream, type) {
	    var packetData = new Uint8Array(stream.size),
	        event = {
	      type: type
	    },
	        i = 0,
	        fragment;
	
	    // do nothing if there is no buffered data
	    if (!stream.data.length) {
	      return;
	    }
	    event.trackId = stream.data[0].pid;
	
	    //Mactrix changes begin: it's possible for the remaining part of a frame to reside in the next chunk
	    //						 esp with audio. This will still be a problem when changing streams as we will
	    //						 be joining two different audio streams, which will result in unalignment, dropped
	    //						 frames and buffer holes!
	    //						 The real solution is to pass in the contiguous parameter from mux-inline.js.
	    //						 If it is true, then just appened like we are doing else we would have to parse
	    //						 the adts already buffered and then inject silence for the remainder of the
	    //						 chunk duration, then discard stream.data (stream.data[0].payloadUnitStartIndicator === false)
	    var payloadUnitStartIndicator = stream.data[0].payloadUnitStartIndicator;
	    //Mactrix changes end
	
	    // reassemble the packet
	    while (stream.data.length) {
	      fragment = stream.data.shift();
	
	      packetData.set(fragment.data, i);
	      i += fragment.data.byteLength;
	    }
	
	    /*Mactrix replace
	          // parse assembled packet's PES header
	          parsePes(packetData, event);
	    */
	    //Mactrix changes begin: only parse the pes if it is complete
	    if (payloadUnitStartIndicator === true) {
	      // parse assembled packet's PES header
	      parsePes(packetData, event);
	    } else {
	      if (logTube) {
	        logTube.log('m2ts.js: trailing frame found');
	      }
	
	      //the remaining buffer to be appended
	      event.data = fragment.data;
	    }
	    //Mactrix changes end
	
	    stream.size = 0;
	
	    self.trigger('data', event);
	  };
	
	  _ElementaryStream.prototype.init.call(this);
	
	  this.push = function (data) {
	    ({
	      pat: function pat() {
	        // we have to wait for the PMT to arrive as well before we
	        // have any meaningful metadata
	      },
	      pes: function pes() {
	        var stream, streamType;
	
	        switch (data.streamType) {
	          case StreamTypes.H264_STREAM_TYPE:
	          case m2tsStreamTypes.H264_STREAM_TYPE:
	            stream = video;
	            streamType = 'video';
	            break;
	          case StreamTypes.ADTS_STREAM_TYPE:
	            stream = audio;
	            streamType = 'audio';
	            break;
	          case StreamTypes.METADATA_STREAM_TYPE:
	            stream = timedMetadata;
	            streamType = 'timed-metadata';
	            break;
	          default:
	            // ignore unknown stream types
	            return;
	        }
	
	        // if a new packet is starting, we can flush the completed
	        // packet
	        if (data.payloadUnitStartIndicator) {
	          flushStream(stream, streamType);
	        }
	
	        // buffer this fragment until we are sure we've received the
	        // complete payload
	        stream.data.push(data);
	        stream.size += data.data.byteLength;
	      },
	      pmt: function pmt() {
	        var event = {
	          type: 'metadata',
	          tracks: []
	        },
	            programMapTable = data.programMapTable,
	            k,
	            track;
	
	        // translate streams to tracks
	        for (k in programMapTable) {
	          if (programMapTable.hasOwnProperty(k)) {
	            track = {
	              timelineStartInfo: {
	                baseMediaDecodeTime: 0
	              },
	              //Mactrix changes begin: store the last timeline so we don't perform superflous calls
	              lastTimelineStartInfo: {}
	              //baseMediaDecodeTime: 0
	
	              //Mactrix changes
	            };
	            track.id = +k;
	            if (programMapTable[k] === m2tsStreamTypes.H264_STREAM_TYPE) {
	              track.codec = 'avc';
	              track.type = 'video';
	            } else if (programMapTable[k] === m2tsStreamTypes.ADTS_STREAM_TYPE) {
	              track.codec = 'adts';
	              track.type = 'audio';
	            }
	            event.tracks.push(track);
	          }
	        }
	        self.trigger('data', event);
	      }
	    })[data.type]();
	  };
	
	  /**
	   * Flush any remaining input. Video PES packets may be of variable
	   * length. Normally, the start of a new video packet can trigger the
	   * finalization of the previous packet. That is not possible if no
	   * more video is forthcoming, however. In that case, some other
	   * mechanism (like the end of the file) has to be employed. When it is
	   * clear that no additional data is forthcoming, calling this method
	   * will flush the buffered packets.
	   */
	  this.flush = function () {
	    // !!THIS ORDER IS IMPORTANT!!
	    // video first then audio
	    flushStream(video, 'video');
	    flushStream(audio, 'audio');
	    flushStream(timedMetadata, 'timed-metadata');
	    this.trigger('done');
	  };
	};
	_ElementaryStream.prototype = new Stream();
	
	var m2ts = {
	  PAT_PID: 0x0000,
	  MP2T_PACKET_LENGTH: MP2T_PACKET_LENGTH,
	  TransportPacketStream: _TransportPacketStream,
	  TransportParseStream: _TransportParseStream,
	  ElementaryStream: _ElementaryStream,
	  TimestampRolloverStream: TimestampRolloverStream,
	  CaptionStream: CaptionStream.CaptionStream,
	  Cea608Stream: CaptionStream.Cea608Stream,
	  MetadataStream: __webpack_require__(154)
	};
	
	for (var type in StreamTypes) {
	  if (StreamTypes.hasOwnProperty(type)) {
	    m2ts[type] = StreamTypes[type];
	  }
	}
	
	module.exports = m2ts;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * mux.js
	 *
	 * Copyright (c) 2015 Brightcove
	 * All rights reserved.
	 *
	 * A stream-based mp2t to mp4 converter. This utility can be used to
	 * deliver mp4s to a SourceBuffer on platforms that support native
	 * Media Source Extensions.
	 */
	'use strict';
	
	var Stream = __webpack_require__(11);
	var mp4 = __webpack_require__(77);
	var m2ts = __webpack_require__(45);
	var AdtsStream = __webpack_require__(41);
	var H264Stream = __webpack_require__(42).H264Stream;
	var AacStream = __webpack_require__(143);
	var coneOfSilence = __webpack_require__(146);
	var clock = __webpack_require__(161);
	
	// constants
	var AUDIO_PROPERTIES = ['audioobjecttype', 'channelcount', 'samplerate', 'samplingfrequencyindex', 'samplesize',
	//Mactrix changes start: the start time of each fragment
	'startTime', 'fragmentDuration', 'totalSamples'
	//Mactrix changes end
	];
	
	var VIDEO_PROPERTIES = ['width', 'height', 'profileIdc', 'levelIdc', 'profileCompatibility',
	//Mactrix changes start: the start time of each fragment
	'startTime', 'fragmentDuration', 'totalSamples'
	//Mactrix changes end
	];
	
	var ONE_SECOND_IN_TS = 90000; // 90kHz clock
	
	// object types
	var _VideoSegmentStream, _AudioSegmentStream, _Transmuxer, _CoalesceStream;
	
	// Helper functions
	var createDefaultSample, isLikelyAacData, collectDtsInfo, clearDtsInfo, calculateTrackBaseMediaDecodeTime, arrayEquals,
	//Mactrix changes begin: helper function to adjust the base media decode time
	applyCompositionTimeOffsetToBaseMediaDecodeTime,
	//Mactrix change end
	sumFrameByteLengths;
	
	/**
	 * Default sample object
	 * see ISO/IEC 14496-12:2012, section 8.6.4.3
	 */
	createDefaultSample = function createDefaultSample() {
	  return {
	    size: 0,
	    flags: {
	      isLeading: 0,
	      dependsOn: 1,
	      isDependedOn: 0,
	      hasRedundancy: 0,
	      degradationPriority: 0
	    }
	  };
	};
	
	isLikelyAacData = function isLikelyAacData(data) {
	  if (data[0] === 'I'.charCodeAt(0) && data[1] === 'D'.charCodeAt(0) && data[2] === '3'.charCodeAt(0)) {
	    return true;
	  }
	  return false;
	};
	
	/**
	 * Compare two arrays (even typed) for same-ness
	 */
	arrayEquals = function arrayEquals(a, b) {
	  var i;
	
	  if (a.length !== b.length) {
	    return false;
	  }
	
	  // compare the value of each element in the array
	  for (i = 0; i < a.length; i++) {
	    if (a[i] !== b[i]) {
	      return false;
	    }
	  }
	
	  return true;
	};
	
	/**
	 * Sum the `byteLength` properties of the data in each AAC frame
	 */
	sumFrameByteLengths = function sumFrameByteLengths(array) {
	  var i,
	      currentObj,
	      sum = 0;
	
	  // sum the byteLength's all each nal unit in the frame
	  for (i = 0; i < array.length; i++) {
	    currentObj = array[i];
	    sum += currentObj.data.byteLength;
	  }
	
	  return sum;
	};
	
	/**
	 * Constructs a single-track, ISO BMFF media segment from AAC data
	 * events. The output of this stream can be fed to a SourceBuffer
	 * configured with a suitable initialization segment.
	 */
	_AudioSegmentStream = function AudioSegmentStream(track) {
	  var adtsFrames = [],
	      sequenceNumber = 0,
	      earliestAllowedDts = 0,
	      audioAppendStartTs = 0,
	
	  //Mactrix changes begin
	  gapDuration = 0,
	      lastFragAborted = false,
	
	  //Mactrix changes end
	  videoBaseMediaDecodeTime = Infinity;
	
	  _AudioSegmentStream.prototype.init.call(this);
	
	  this.push = function (data) {
	    collectDtsInfo(track, data);
	
	    if (track) {
	      AUDIO_PROPERTIES.forEach(function (prop) {
	        track[prop] = data[prop];
	      });
	    }
	
	    // buffer audio data until end() is called
	    adtsFrames.push(data);
	  };
	
	  track.timescale = track.samplerate;
	
	  this.setEarliestDts = function (earliestDts) {
	    earliestAllowedDts = earliestDts - track.timelineStartInfo.baseMediaDecodeTime;
	  };
	
	  this.setVideoBaseMediaDecodeTime = function (baseMediaDecodeTime) {
	    videoBaseMediaDecodeTime = baseMediaDecodeTime;
	  };
	
	  this.setAudioAppendStart = function (timestamp) {
	    audioAppendStartTs = timestamp;
	  };
	
	  //Mactrix changes begin
	  this.setGapDuration = function (gap) {
	    gapDuration = gap;
	  };
	
	  this.setlastFragAborted = function (abort) {
	    lastFragAborted = abort;
	  };
	  //Mactrix changes end
	
	  this.flush = function () {
	    var frames,
	        moof,
	        mdat,
	
	    //Mactrix changes begin
	    frameDuration = 1024 / track.samplerate * ONE_SECOND_IN_TS,
	
	    //Mactrix changes end
	    boxes;
	
	    // return early if no audio data has been observed
	    if (adtsFrames.length === 0) {
	      this.trigger('done', 'AudioSegmentStream');
	      return;
	    }
	
	    /*Mactrix replace
	        frames = this.trimAdtsFramesByEarliestDts_(adtsFrames);
	    */
	    //Mactrix changes begin
	    frames = adtsFrames;
	    //Mactrix changes end
	
	    //console.log('# audio - seg diff: ' + (track.minSegmentDts - track.lastMinSegmentDts) + ' nextBMDT: ' + (track.nextBMDT / ONE_SECOND_IN_TS));
	
	    /*Mactrix replace
	    	track.baseMediaDecodeTime = calculateTrackBaseMediaDecodeTime(track);
	    */
	    //Mactrix changes begin: keep track of whether this frag is the same as the previous frag
	    //						 allow for 3 frame variance ... need to fix the duplicate issue in hlsjs
	    //if(!track.lastFragAborted && track.lastMinSegmentDts !== undefined && (track.lastMinSegmentDts >= track.minSegmentDts - (frameDuration * 3) && track.lastMinSegmentDts <= track.minSegmentDts + (frameDuration * 3))) {
	    //	track.duplicateFrag = false;
	    //} else {
	    track.duplicateFrag = false;
	    //}
	
	    /*if(track.lastMinSegmentDts === undefined) {
	    	track.padDuration = (track.minSegmentDts - track.timelineStartInfo.dts) * (track.samplerate / ONE_SECOND_IN_TS);
	    		//pad duration should now always be 0
	    	console.log('@@ audio flush pad duration of ' + track.padDuration + ' should be 0');
	    }*/
	
	    track.lastMinSegmentDts = track.minSegmentDts;
	    //Mactrix changes end
	
	    /*Mactrix replace
	    	this.prefixWithSilence_(track, frames);
	    */
	    //Mactrix changes begin
	    if (track.lastTimelineStartInfo && (track.lastTimelineStartInfo.baseMediaDecodeTime === undefined || track.lastTimelineStartInfo.baseMediaDecodeTime != track.timelineStartInfo.baseMediaDecodeTime)) {
	      track.lastTimelineStartInfo.baseMediaDecodeTime = track.timelineStartInfo.baseMediaDecodeTime;
	
	      if (track.frameInsertCount) {
	        var silentFrame = coneOfSilence[track.samplerate];
	        var i = void 0;
	
	        if (!silentFrame) {
	          // we don't have a silent frame pregenerated for the sample rate, so use a frame
	          // from the content instead
	          silentFrame = frames[0].data;
	        }
	
	        for (i = 0; i < track.frameInsertCount; i++) {
	          frames.splice(i, 0, {
	            data: silentFrame
	          });
	        }
	
	        track.frameInsertCount = 0;
	      } else if (track.frameDropCount) {
	        frames.splice(0, track.frameDropCount);
	        track.frameDropCount = 0;
	      }
	    }
	    //Mactrix changes end
	
	    // we have to build the index from byte locations to
	    // samples (that is, adts frames) in the audio data
	    track.samples = this.generateSampleTable_(frames);
	
	    //Mactrix changes begin: cache the fragment duration (in seconds) and the total samples
	    if (lastFragAborted) {
	      track.nextBMDT -= track.lastDuration;
	      lastFragAborted = false;
	    }
	
	    track.baseMediaDecodeTime = track.nextBMDT * (track.samplerate / ONE_SECOND_IN_TS); // + track.padDuration;
	    track.totalSamples = track.samples.length;
	    track.fragmentDuration = 1024 /*sampleCount - this will need to change when we add ac3*/ / track.samplerate * track.totalSamples;
	    track.timescale = track.samplerate;
	    track.startTime = track.nextBMDT; //track.baseMediaDecodeTime / track.samplerate;
	
	    if (track.duplicateFrag === false) {
	      track.nextBMDT += frameDuration * track.totalSamples;
	    }
	
	    track.lastDuration = frameDuration * track.totalSamples;
	    //Mactrix changes end
	
	    // concatenate the audio data to constuct the mdat
	    mdat = mp4.mdat(this.concatenateFrameData_(frames));
	
	    adtsFrames = [];
	
	    moof = mp4.moof(sequenceNumber, [track]);
	    boxes = new Uint8Array(moof.byteLength + mdat.byteLength);
	
	    // bump the sequence number for next time
	    sequenceNumber++;
	
	    boxes.set(moof);
	    boxes.set(mdat, moof.byteLength);
	
	    this.trigger('data', { track: track, boxes: boxes });
	    this.trigger('done', 'AudioSegmentStream');
	
	    clearDtsInfo(track);
	  };
	
	  // Possibly pad (prefix) the audio track with silence if appending this track
	  // would lead to the introduction of a gap in the audio buffer
	  this.prefixWithSilence_ = function (track, frames) {
	    var baseMediaDecodeTimeTs,
	        frameDuration = 0,
	        audioGapDuration = 0,
	        audioFillFrameCount = 0,
	        audioFillDuration = 0,
	        silentFrame,
	        i;
	
	    if (!frames.length) {
	      return;
	    }
	
	    baseMediaDecodeTimeTs = clock.audioTsToVideoTs(track.baseMediaDecodeTime, track.samplerate);
	    // determine frame clock duration based on sample rate, round up to avoid overfills
	    frameDuration = Math.ceil(ONE_SECOND_IN_TS / (track.samplerate / 1024));
	
	    if (audioAppendStartTs && videoBaseMediaDecodeTime) {
	      // insert the shortest possible amount (audio gap or audio to video gap)
	      audioGapDuration = baseMediaDecodeTimeTs - Math.max(audioAppendStartTs, videoBaseMediaDecodeTime);
	      // number of full frames in the audio gap
	      audioFillFrameCount = Math.floor(audioGapDuration / frameDuration);
	      audioFillDuration = audioFillFrameCount * frameDuration;
	    }
	
	    // don't attempt to fill gaps smaller than a single frame or larger
	    // than a half second
	    if (audioFillFrameCount < 1 || audioFillDuration > ONE_SECOND_IN_TS / 2) {
	      return;
	    }
	
	    silentFrame = coneOfSilence[track.samplerate];
	
	    if (!silentFrame) {
	      // we don't have a silent frame pregenerated for the sample rate, so use a frame
	      // from the content instead
	      silentFrame = frames[0].data;
	    }
	
	    for (i = 0; i < audioFillFrameCount; i++) {
	      frames.splice(i, 0, {
	        data: silentFrame
	      });
	    }
	
	    track.baseMediaDecodeTime -= Math.floor(clock.videoTsToAudioTs(audioFillDuration, track.samplerate));
	  };
	
	  // If the audio segment extends before the earliest allowed dts
	  // value, remove AAC frames until starts at or after the earliest
	  // allowed DTS so that we don't end up with a negative baseMedia-
	  // DecodeTime for the audio track
	  this.trimAdtsFramesByEarliestDts_ = function (adtsFrames) {
	    if (track.minSegmentDts >= earliestAllowedDts) {
	      return adtsFrames;
	    }
	
	    // We will need to recalculate the earliest segment Dts
	    track.minSegmentDts = Infinity;
	
	    return adtsFrames.filter(function (currentFrame) {
	      // If this is an allowed frame, keep it and record it's Dts
	      if (currentFrame.dts >= earliestAllowedDts) {
	        track.minSegmentDts = Math.min(track.minSegmentDts, currentFrame.dts);
	        track.minSegmentPts = track.minSegmentDts;
	        return true;
	      }
	      // Otherwise, discard it
	      return false;
	    });
	  };
	
	  // generate the track's raw mdat data from an array of frames
	  this.generateSampleTable_ = function (frames) {
	    var i,
	        currentFrame,
	        samples = [];
	
	    for (i = 0; i < frames.length; i++) {
	      currentFrame = frames[i];
	      samples.push({
	        size: currentFrame.data.byteLength,
	        duration: 1024 // For AAC audio, all samples contain 1024 samples
	      });
	    }
	    return samples;
	  };
	
	  // generate the track's sample table from an array of frames
	  this.concatenateFrameData_ = function (frames) {
	    var i,
	        currentFrame,
	        dataOffset = 0,
	        data = new Uint8Array(sumFrameByteLengths(frames));
	
	    for (i = 0; i < frames.length; i++) {
	      currentFrame = frames[i];
	
	      data.set(currentFrame.data, dataOffset);
	      dataOffset += currentFrame.data.byteLength;
	    }
	    return data;
	  };
	};
	
	_AudioSegmentStream.prototype = new Stream();
	
	/**
	 * Constructs a single-track, ISO BMFF media segment from H264 data
	 * events. The output of this stream can be fed to a SourceBuffer
	 * configured with a suitable initialization segment.
	 * @param track {object} track metadata configuration
	 */
	_VideoSegmentStream = function VideoSegmentStream(track) {
	  var sequenceNumber = 0,
	      nalUnits = [],
	      config,
	
	  //Mactrix changes begin
	  gapDuration = 0,
	      lastFragAborted = false,
	
	  //Mactrix changes end
	  pps;
	
	  _VideoSegmentStream.prototype.init.call(this);
	
	  delete track.minPTS;
	
	  //Mactrix changes begin: assume constant frag duration with a tolerance of max composition time
	  this.lastGopsDuration = undefined, this.constantGopsDuration = true,
	  //Mactrix changes end
	  this.gopCache_ = [];
	
	  this.push = function (nalUnit) {
	    collectDtsInfo(track, nalUnit);
	
	    // record the track config
	    if (nalUnit.nalUnitType === 'seq_parameter_set_rbsp' && !config) {
	      config = nalUnit.config;
	      track.sps = [nalUnit.data];
	
	      VIDEO_PROPERTIES.forEach(function (prop) {
	        track[prop] = config[prop];
	      }, this);
	    }
	
	    if (nalUnit.nalUnitType === 'pic_parameter_set_rbsp' && !pps) {
	      pps = nalUnit.data;
	      track.pps = [nalUnit.data];
	    }
	
	    // buffer video until flush() is called
	    nalUnits.push(nalUnit);
	  };
	
	  //Mactrix changes begin
	  this.setGapDuration = function (gap) {
	    gapDuration = gap;
	  };
	
	  this.setlastFragAborted = function (abort) {
	    lastFragAborted = abort;
	  };
	  //Mactrix changes end
	
	  this.flush = function () {
	    var frames, gopForFusion, gops, moof, mdat, boxes;
	
	    // Throw away nalUnits at the start of the byte stream until
	    // we find the first AUD
	    while (nalUnits.length) {
	      if (nalUnits[0].nalUnitType === 'access_unit_delimiter_rbsp') {
	        break;
	      }
	      nalUnits.shift();
	    }
	
	    // Return early if no video data has been observed
	    if (nalUnits.length === 0) {
	      this.resetStream_();
	      this.trigger('done', 'VideoSegmentStream');
	      return;
	    }
	
	    // Organize the raw nal-units into arrays that represent
	    // higher-level constructs such as frames and gops
	    // (group-of-pictures)
	    frames = this.groupNalsIntoFrames_(nalUnits);
	    gops = this.groupFramesIntoGops_(frames);
	
	    //Mactrix changes begin: store the total duration of the gop to be played in seconds (not including preroll), hence we MUST assign this before gop fusion
	    track.fragmentDuration = gops.duration / ONE_SECOND_IN_TS;
	    //this is the unfused baseTime
	    track.startTime = track.nextBMDT; // / ONE_SECOND_IN_TS;//calculateTrackBaseMediaDecodeTime(track/*, (gops[0][0].pts - gops[0][0].dts)*/) / ONE_SECOND_IN_TS;
	    track.timescale = ONE_SECOND_IN_TS;
	    //Mactrix changes end
	
	
	    // If the first frame of this fragment is not a keyframe we have
	    // a problem since MSE (on Chrome) requires a leading keyframe.
	    //
	    // We have two approaches to repairing this situation:
	    // 1) GOP-FUSION:
	    //    This is where we keep track of the GOPS (group-of-pictures)
	    //    from previous fragments and attempt to find one that we can
	    //    prepend to the current fragment in order to create a valid
	    //    fragment.
	    // 2) KEYFRAME-PULLING:
	    //    Here we search for the first keyframe in the fragment and
	    //    throw away all the frames between the start of the fragment
	    //    and that keyframe. We then extend the duration and pull the
	    //    PTS of the keyframe forward so that it covers the time range
	    //    of the frames that were disposed of.
	    //
	    // #1 is far prefereable over #2 which can cause "stuttering" but
	    // requires more things to be just right.
	    if (!gops[0][0].keyFrame) {
	      // Search for a gop for fusion from our gopCache
	      gopForFusion = this.getGopForFusion_(nalUnits[0], track);
	
	      if (gopForFusion) {
	        gops.unshift(gopForFusion);
	        // Adjust Gops' metadata to account for the inclusion of the
	        // new gop at the beginning
	        gops.byteLength += gopForFusion.byteLength;
	        gops.nalCount += gopForFusion.nalCount;
	        gops.pts = gopForFusion.pts;
	        gops.dts = gopForFusion.dts;
	        gops.duration += gopForFusion.duration;
	
	        //Mactrix changes begin
	        track.fusionDuration += gopForFusion.duration;
	        //Mactrix changes end
	      } else {
	        // If we didn't find a candidate gop fall back to keyrame-pulling
	        gops = this.extendFirstKeyFrame_(gops);
	      }
	
	      //Mactrix changes begin: only re-collect the info if we need fusion/keyframe-pulling
	      collectDtsInfo(track, gops);
	      //Mactrix changes end
	    }
	
	    /*Mactrix remove: This only needs to be done again if we require gop fusion/keyframe-pulling
	    	collectDtsInfo(track, gops);
	    */
	    // First, we have to build the index from byte locations to
	    // samples (that is, frames) in the video data
	    track.samples = this.generateSampleTable_(gops);
	
	    //Mactrix changes begin: cache the fragment sampleCount
	    track.totalSamples = track.samples.length;
	    //Mactrix changes end
	
	    // Concatenate the video data and construct the mdat
	    mdat = mp4.mdat(this.concatenateNalData_(gops));
	
	    // save all the nals in the last GOP into the gop cache
	    this.gopCache_.unshift({
	      gop: gops.pop(),
	      pps: track.pps,
	      sps: track.sps
	    });
	
	    // Keep a maximum of 6 GOPs in the cache
	    this.gopCache_.length = Math.min(6, this.gopCache_.length);
	
	    // Clear nalUnits
	    nalUnits = [];
	
	    if (lastFragAborted) {
	      track.nextBMDT -= track.lastGopsDuration;
	    }
	
	    track.baseMediaDecodeTime = track.nextBMDT - track.fusionDuration; //calculateTrackBaseMediaDecodeTime(track/*, track.samples[0].compositionTimeOffset*/);
	
	    //Mactrix changes begin: track any variations in fragment duration
	    /*
	    	if (track.samples[0].compositionTimeOffset != 0 || (track.timelineStartInfo.pts - track.timelineStartInfo.dts) != 0) {
	    		if (this.constantGopsDuration === true) {
	    			if (this.lastGopsDuration !== undefined) {
	    				//adjust the bmdt to account for any b frame variance
	    				let remainder = track.baseMediaDecodeTime % this.lastGopsDuration;
	    
	    				if(remainder > 0) {
	    					//we didn't get what we expected
	    					if (remainder > track.maxCompositionTimeOffset) {
	    						//if we are > the maxCompositionTimeOffset then we are behind where we expect to be
	    						remainder = this.lastGopsDuration - remainder;
	    						track.baseMediaDecodeTime += remainder;
	    					} else if (remainder <= track.maxCompositionTimeOffset) {
	    						//if we are <= the maxCompositionTimeOffset then we are ahead of where we expect to be
	    						track.baseMediaDecodeTime -= remainder;
	    					}
	    				}
	    
	    				if (this.lastGopsDuration !== gops.duration) {
	    					this.constantGopsDuration = false;
	    				}
	    			}
	    		} else {
	    			//fall back to the old method ... not without flaws
	    			track.baseMediaDecodeTime = applyCompositionTimeOffsetToBaseMediaDecodeTime(track, track.baseMediaDecodeTime, track.samples[0].compositionTimeOffset);
	    		}
	    	}
	    */
	    //Mactrix changes end
	
	    this.trigger('baseMediaDecodeTime', track.baseMediaDecodeTime);
	
	    /*Mactrix replace
	    	this.trigger('timelineStartInfo', track.timelineStartInfo);
	    */
	    //Mactrix changes begin
	    if (gapDuration) {
	      //refine the gapDuration as it could be slightly inaccurate
	      var extensionTime = 0;
	
	      if (track.lastMinSegmentDts && this.lastGopsDuration) {
	        //refine the gapDuration as it could be slightly inaccurate
	        //use the last dts
	        extensionTime = track.minSegmentDts - (track.lastMinSegmentDts + this.lastGopsDuration);
	        //console.log('# VideoSegmentStream flush - gap requested, using lastMinSegmentDts to set the gap extension time to: ' + extensionTime);
	      }
	      /*
	      		else {
	      			//if none are available (requesting a gap on the first frag?? This is untested) use the gapDuration supplied to us (this could be inaccurate)
	      			//gapDuration is in millis
	      			extensionTime = 0;//gapDuration * 90;
	      			console.log('# VideoSegmentStream flush - gap requested, setting gap extension time to the manifest gapDuration: ' + extensionTime);
	      		}
	      */
	
	      //extend the first frame of the current frag
	      track.samples[0].duration += extensionTime;
	      gops.duration += extensionTime;
	
	      //if we decide to extend the last frame of the current frag, this relies on us trusting gapDuration to be frame accurate
	      /*
	      track.samples[track.totalSamples - 1].duration += (gapDuration * 90);
	      gops.duration += (gapDuration * 90);
	      */
	    }
	
	    if (track.lastTimelineStartInfo && (track.lastTimelineStartInfo.baseMediaDecodeTime === undefined || track.lastTimelineStartInfo.baseMediaDecodeTime != track.timelineStartInfo.baseMediaDecodeTime)) {
	      this.trigger('timelineStartInfo', track.timelineStartInfo);
	      track.lastTimelineStartInfo.baseMediaDecodeTime = track.timelineStartInfo.baseMediaDecodeTime;
	
	      if (track.truncateDuration) {
	        track.samples[0].duration += track.truncateDuration;
	        gops.duration += track.truncateDuration;
	        track.truncateDuration = 0;
	      }
	
	      if (track.allowNegativeTFDT) {
	        var initialCTO = track.samples[0].compositionTimeOffset;
	        track.baseMediaDecodeTime -= initialCTO;
	        track.nextBMDT -= initialCTO;
	      }
	    }
	
	    //console.log('# video - seg diff: ' + (track.minSegmentDts - track.lastMinSegmentDts) + ' nextBMDT: ' + (track.nextBMDT / ONE_SECOND_IN_TS));
	
	    //if(track.lastMinSegmentDts !== undefined && track.lastMinSegmentDts === track.minSegmentDts) {
	
	    //if(!track.lastFragAborted && track.lastMinSegmentDts !== undefined && track.lastMinSegmentDts >= track.minSegmentDts - track.maxCompositionTimeOffset && track.lastMinSegmentDts <= track.minSegmentDts + track.maxCompositionTimeOffset) {
	    //	track.duplicateFrag = false;
	    //} else {
	    track.nextBMDT += gops.duration;
	    track.duplicateFrag = false;
	    //}
	
	    lastFragAborted = false;
	
	    //minSegmentDts can be changed by this.trigger('timelineStartInfo', track.timelineStartInfo);
	    track.lastMinSegmentDts = track.minSegmentDts;
	    this.lastGopsDuration = gops.duration;
	    //Mactrix changes end
	    moof = mp4.moof(sequenceNumber, [track]);
	
	    // it would be great to allocate this array up front instead of
	    // throwing away hundreds of media segment fragments
	    boxes = new Uint8Array(moof.byteLength + mdat.byteLength);
	
	    // Bump the sequence number for next time
	    sequenceNumber++;
	
	    boxes.set(moof);
	    boxes.set(mdat, moof.byteLength);
	
	    this.trigger('data', { track: track, boxes: boxes });
	
	    // Continue with the flush process now
	    this.trigger('done', 'VideoSegmentStream');
	
	    this.resetStream_();
	  };
	
	  this.resetGOPS = function () {
	    this.gopCache_ = [];
	    this.lastGopsDuration = undefined;
	    this.constantGopsDuration = true;
	  };
	
	  this.resetStream_ = function () {
	    clearDtsInfo(track);
	
	    // reset config and pps because they may differ across segments
	    // for instance, when we are rendition switching
	    config = undefined;
	    pps = undefined;
	  };
	
	  // Search for a candidate Gop for gop-fusion from the gop cache and
	  // return it or return null if no good candidate was found
	  this.getGopForFusion_ = function (nalUnit) {
	    var halfSecond = 45000,
	        // Half-a-second in a 90khz clock
	    allowableOverlap = 10000,
	        // About 3 frames @ 30fps
	    nearestDistance = Infinity,
	        dtsDistance,
	        nearestGopObj,
	        currentGop,
	        currentGopObj,
	        i;
	
	    // Search for the GOP nearest to the beginning of this nal unit
	    for (i = 0; i < this.gopCache_.length; i++) {
	      currentGopObj = this.gopCache_[i];
	      currentGop = currentGopObj.gop;
	
	      // Reject Gops with different SPS or PPS
	      if (!(track.pps && arrayEquals(track.pps[0], currentGopObj.pps[0])) || !(track.sps && arrayEquals(track.sps[0], currentGopObj.sps[0]))) {
	        continue;
	      }
	
	      // Reject Gops that would require a negative baseMediaDecodeTime
	      if (currentGop.dts < track.timelineStartInfo.dts) {
	        continue;
	      }
	
	      // The distance between the end of the gop and the start of the nalUnit
	      dtsDistance = nalUnit.dts - currentGop.dts - currentGop.duration;
	
	      // Only consider GOPS that start before the nal unit and end within
	      // a half-second of the nal unit
	      if (dtsDistance >= -allowableOverlap && dtsDistance <= halfSecond) {
	
	        // Always use the closest GOP we found if there is more than
	        // one candidate
	        if (!nearestGopObj || nearestDistance > dtsDistance) {
	          nearestGopObj = currentGopObj;
	          nearestDistance = dtsDistance;
	        }
	      }
	    }
	
	    if (nearestGopObj) {
	      return nearestGopObj.gop;
	    }
	    return null;
	  };
	
	  this.extendFirstKeyFrame_ = function (gops) {
	    var currentGop;
	
	    if (!gops[0][0].keyFrame && gops.length > 1) {
	      // Remove the first GOP
	      currentGop = gops.shift();
	
	      gops.byteLength -= currentGop.byteLength;
	      gops.nalCount -= currentGop.nalCount;
	
	      // Extend the first frame of what is now the
	      // first gop to cover the time period of the
	      // frames we just removed
	      gops[0][0].dts = currentGop.dts;
	      gops[0][0].pts = currentGop.pts;
	      gops[0][0].duration += currentGop.duration;
	    }
	
	    return gops;
	  };
	
	  // Convert an array of nal units into an array of frames with each frame being
	  // composed of the nal units that make up that frame
	  // Also keep track of cummulative data about the frame from the nal units such
	  // as the frame duration, starting pts, etc.
	  this.groupNalsIntoFrames_ = function (nalUnits) {
	    var i,
	        currentNal,
	        currentFrame = [],
	        frames = [];
	
	    currentFrame.byteLength = 0;
	
	    for (i = 0; i < nalUnits.length; i++) {
	      currentNal = nalUnits[i];
	
	      // Split on 'aud'-type nal units
	      if (currentNal.nalUnitType === 'access_unit_delimiter_rbsp') {
	        // Since the very first nal unit is expected to be an AUD
	        // only push to the frames array when currentFrame is not empty
	        if (currentFrame.length) {
	          currentFrame.duration = currentNal.dts - currentFrame.dts;
	          frames.push(currentFrame);
	        }
	        currentFrame = [currentNal];
	        currentFrame.byteLength = currentNal.data.byteLength;
	
	        /*Mactrix replace
	        		currentFrame.pts = currentNal.pts;
	        		currentFrame.dts = currentNal.dts;
	        */
	        //Mactrix changes begin: since duration is being passed back in the properties, some tests will fail where minimal is passed due to these values being undefined
	        if (currentNal.pts !== undefined) {
	          currentFrame.pts = currentNal.pts;
	        } else {
	          currentFrame.pts = 0;
	        }
	
	        if (currentNal.dts !== undefined) {
	          currentFrame.dts = currentNal.dts;
	        } else {
	          currentFrame.dts = 0;
	        }
	        //Mactrix changes end
	      } else {
	        // Specifically flag key frames for ease of use later
	        if (currentNal.nalUnitType === 'slice_layer_without_partitioning_rbsp_idr') {
	          currentFrame.keyFrame = true;
	        }
	
	        //Mactrix changes begin: set to 0 if undefined, not doind this trips up some tests since we now pass back the duration in the props
	        if (currentNal.dts === undefined) {
	          currentNal.dts = 0;
	        }
	        //Mactrix changes end
	
	        currentFrame.duration = currentNal.dts - currentFrame.dts;
	        currentFrame.byteLength += currentNal.data.byteLength;
	        currentFrame.push(currentNal);
	      }
	    }
	
	    // For the last frame, use the duration of the previous frame if we
	    // have nothing better to go on
	    if (frames.length && (!currentFrame.duration || currentFrame.duration <= 0)) {
	      currentFrame.duration = frames[frames.length - 1].duration;
	    }
	
	    // Push the final frame
	    frames.push(currentFrame);
	    return frames;
	  };
	
	  // Convert an array of frames into an array of Gop with each Gop being composed
	  // of the frames that make up that Gop
	  // Also keep track of cummulative data about the Gop from the frames such as the
	  // Gop duration, starting pts, etc.
	  this.groupFramesIntoGops_ = function (frames) {
	    var i,
	        currentFrame,
	        currentGop = [],
	        gops = [];
	
	    // We must pre-set some of the values on the Gop since we
	    // keep running totals of these values
	    currentGop.byteLength = 0;
	    currentGop.nalCount = 0;
	    currentGop.duration = 0;
	    currentGop.pts = frames[0].pts;
	    currentGop.dts = frames[0].dts;
	
	    // store some metadata about all the Gops
	    gops.byteLength = 0;
	    gops.nalCount = 0;
	    gops.duration = 0;
	    gops.pts = frames[0].pts;
	    gops.dts = frames[0].dts;
	
	    for (i = 0; i < frames.length; i++) {
	      currentFrame = frames[i];
	
	      if (currentFrame.keyFrame) {
	        // Since the very first frame is expected to be an keyframe
	        // only push to the gops array when currentGop is not empty
	        if (currentGop.length) {
	          gops.push(currentGop);
	          gops.byteLength += currentGop.byteLength;
	          gops.nalCount += currentGop.nalCount;
	          gops.duration += currentGop.duration;
	        }
	
	        currentGop = [currentFrame];
	        currentGop.nalCount = currentFrame.length;
	        currentGop.byteLength = currentFrame.byteLength;
	        currentGop.pts = currentFrame.pts;
	        currentGop.dts = currentFrame.dts;
	        currentGop.duration = currentFrame.duration;
	      } else {
	        currentGop.duration += currentFrame.duration;
	        currentGop.nalCount += currentFrame.length;
	        currentGop.byteLength += currentFrame.byteLength;
	        currentGop.push(currentFrame);
	      }
	    }
	
	    if (gops.length && currentGop.duration <= 0) {
	      currentGop.duration = gops[gops.length - 1].duration;
	    }
	    gops.byteLength += currentGop.byteLength;
	    gops.nalCount += currentGop.nalCount;
	    gops.duration += currentGop.duration;
	
	    // push the final Gop
	    gops.push(currentGop);
	    return gops;
	  };
	
	  // generate the track's sample table from an array of gops
	  this.generateSampleTable_ = function (gops, baseDataOffset) {
	    var h,
	        i,
	        sample,
	        currentGop,
	        currentFrame,
	        dataOffset = baseDataOffset || 0,
	        samples = [];
	
	    for (h = 0; h < gops.length; h++) {
	      currentGop = gops[h];
	
	      for (i = 0; i < currentGop.length; i++) {
	        currentFrame = currentGop[i];
	
	        sample = createDefaultSample();
	
	        sample.dataOffset = dataOffset;
	        sample.compositionTimeOffset = currentFrame.pts - currentFrame.dts;
	        sample.duration = currentFrame.duration;
	        sample.size = 4 * currentFrame.length; // Space for nal unit size
	        sample.size += currentFrame.byteLength;
	
	        if (currentFrame.keyFrame) {
	          sample.flags.dependsOn = 2;
	          sample.flags.isNonSyncSample = 0;
	        } else {
	          sample.flags.isNonSyncSample = 1;
	        }
	
	        dataOffset += sample.size;
	
	        samples.push(sample);
	      }
	    }
	    return samples;
	  };
	
	  // generate the track's raw mdat data from an array of gops
	  this.concatenateNalData_ = function (gops) {
	    var h,
	        i,
	        j,
	        currentGop,
	        currentFrame,
	        currentNal,
	        dataOffset = 0,
	        nalsByteLength = gops.byteLength,
	        numberOfNals = gops.nalCount,
	        totalByteLength = nalsByteLength + 4 * numberOfNals,
	        data = new Uint8Array(totalByteLength),
	        view = new DataView(data.buffer);
	
	    // For each Gop..
	    for (h = 0; h < gops.length; h++) {
	      currentGop = gops[h];
	
	      // For each Frame..
	      for (i = 0; i < currentGop.length; i++) {
	        currentFrame = currentGop[i];
	
	        // For each NAL..
	        for (j = 0; j < currentFrame.length; j++) {
	          currentNal = currentFrame[j];
	
	          view.setUint32(dataOffset, currentNal.data.byteLength);
	          dataOffset += 4;
	          data.set(currentNal.data, dataOffset);
	          dataOffset += currentNal.data.byteLength;
	        }
	      }
	    }
	    return data;
	  };
	};
	
	_VideoSegmentStream.prototype = new Stream();
	
	/**
	 * Store information about the start and end of the track and the
	 * duration for each frame/sample we process in order to calculate
	 * the baseMediaDecodeTime
	 */
	collectDtsInfo = function collectDtsInfo(track, data) {
	  if (typeof data.pts === 'number') {
	    if (track.timelineStartInfo.pts === undefined) {
	      track.timelineStartInfo.pts = data.pts;
	    }
	
	    if (track.minSegmentPts === undefined) {
	      track.minSegmentPts = data.pts;
	    } else {
	      track.minSegmentPts = Math.min(track.minSegmentPts, data.pts);
	    }
	
	    if (track.maxSegmentPts === undefined) {
	      track.maxSegmentPts = data.pts;
	    } else {
	      track.maxSegmentPts = Math.max(track.maxSegmentPts, data.pts);
	    }
	  }
	
	  if (typeof data.dts === 'number') {
	    if (track.timelineStartInfo.dts === undefined) {
	      track.timelineStartInfo.dts = data.dts;
	    }
	
	    if (track.minSegmentDts === undefined) {
	      track.minSegmentDts = data.dts;
	    } else {
	      track.minSegmentDts = Math.min(track.minSegmentDts, data.dts);
	    }
	
	    if (track.maxSegmentDts === undefined) {
	      track.maxSegmentDts = data.dts;
	    } else {
	      track.maxSegmentDts = Math.max(track.maxSegmentDts, data.dts);
	    }
	  }
	
	  //Mactrix changes begin: retain the maximum composition time
	  if (typeof data.pts === 'number' && typeof data.dts === 'number') {
	    track.maxCompositionTimeOffset = Math.max(track.maxCompositionTimeOffset, data.pts - data.dts);
	  }
	  //Mactrix changes end
	};
	
	/**
	 * Clear values used to calculate the baseMediaDecodeTime between
	 * tracks
	 */
	clearDtsInfo = function clearDtsInfo(track) {
	  delete track.minSegmentDts;
	  delete track.maxSegmentDts;
	  delete track.minSegmentPts;
	  delete track.maxSegmentPts;
	};
	
	//Mactrix changes begin: if we start with a fragment with bframes then we need to offset all fragments with no bframes by the composition time offset
	//						 we also need to do the opposite in the reverse case
	applyCompositionTimeOffsetToBaseMediaDecodeTime = function applyCompositionTimeOffsetToBaseMediaDecodeTime(track, baseMediaDecodeTime, firstSampleCompositionTimeOffset) {
	  //we don't want to apply changes to the first fragment
	  if (track.minSegmentPts > track.timelineStartInfo.pts) {
	    var compositionTimeOffset = track.timelineStartInfo.pts - track.timelineStartInfo.dts;
	    if (compositionTimeOffset === 0) {
	      //we started on a fragment with no indication of bframes, if track.samples[0].compositionTimeOffset > 0 then the current fragment has bframes
	      //and we need to add the offset to the base media decode time
	      //track.samples[0].compositionTimeOffset should be >= 0 otherwise it indicates a sample which should be presented before its decoded!
	      if (firstSampleCompositionTimeOffset > 0 /*track.samples[0].compositionTimeOffset > 0*/) {
	          baseMediaDecodeTime += firstSampleCompositionTimeOffset; //track.samples[0].compositionTimeOffset;
	        }
	    } else {
	      //we started on a fragment WITH bframes and there is NO indication of bframes in the current fragment
	      if (firstSampleCompositionTimeOffset === 0 /*track.samples[0].compositionTimeOffset === 0*/) {
	          baseMediaDecodeTime -= compositionTimeOffset;
	        }
	    }
	  }
	
	  return baseMediaDecodeTime;
	};
	//Mactrix changes end
	
	/**
	 * Calculate the track's baseMediaDecodeTime based on the earliest
	 * DTS the transmuxer has ever seen and the minimum DTS for the
	 * current track
	 */
	
	calculateTrackBaseMediaDecodeTime = function calculateTrackBaseMediaDecodeTime(track) {
	  var baseMediaDecodeTime,
	      scale,
	
	  // Calculate the distance, in time, that this segment starts from the start
	  // of the timeline (earliest time seen since the transmuxer initialized)
	  /*Mactrix replace
	    timeSinceStartOfTimeline = track.minSegmentDts - track.timelineStartInfo.dts;
	  */
	  //Mactrix changes begin: need to init to 0 if dts info in undefined
	  timeSinceStartOfTimeline = 0;
	
	  if (track.minSegmentDts !== undefined && track.timelineStartInfo.dts !== undefined) {
	    timeSinceStartOfTimeline = track.minSegmentDts - track.timelineStartInfo.dts;
	  }
	  //Mactrix changes end
	  // track.timelineStartInfo.baseMediaDecodeTime is the location, in time, where
	  // we want the start of the first segment to be placed
	  baseMediaDecodeTime = track.timelineStartInfo.baseMediaDecodeTime;
	
	  // Add to that the distance this segment is from the very first
	  baseMediaDecodeTime += timeSinceStartOfTimeline;
	
	  // baseMediaDecodeTime must not become negative
	  baseMediaDecodeTime = Math.max(0, baseMediaDecodeTime);
	
	  if (track.type === 'audio') {
	    // Audio has a different clock equal to the sampling_rate so we need to
	    // scale the PTS values into the clock rate of the track
	    scale = track.samplerate / ONE_SECOND_IN_TS;
	    baseMediaDecodeTime *= scale;
	    baseMediaDecodeTime = Math.floor(baseMediaDecodeTime);
	  }
	
	  return baseMediaDecodeTime;
	};
	
	/**
	 * A Stream that can combine multiple streams (ie. audio & video)
	 * into a single output segment for MSE. Also supports audio-only
	 * and video-only streams.
	 */
	_CoalesceStream = function CoalesceStream(options, metadataStream) {
	  // Number of Tracks per output segment
	  // If greater than 1, we combine multiple
	  // tracks into a single segment
	  this.numberOfTracks = 0;
	  this.metadataStream = metadataStream;
	
	  if (typeof options.remux !== 'undefined') {
	    this.remuxTracks = !!options.remux;
	  } else {
	    this.remuxTracks = true;
	  }
	
	  //Mactrix changes begin: duration set via transmux options
	  this.baseMediaDecodeTime = options.baseMediaDecodeTime || 0;
	
	  if (typeof options.duration !== 'undefined') {
	    this.duration = options.duration;
	  }
	  this.logTube = options.logTube;
	  //Mactrix changes end
	
	  this.pendingTracks = [];
	  this.videoTrack = null;
	  this.pendingBoxes = [];
	  this.pendingCaptions = [];
	  this.pendingMetadata = [];
	  this.pendingBytes = 0;
	  this.emittedTracks = 0;
	
	  _CoalesceStream.prototype.init.call(this);
	
	  // Take output from multiple
	  this.push = function (output) {
	    // buffer incoming captions until the associated video segment
	    // finishes
	    if (output.text) {
	      /*Mactrix replace
	            return this.pendingCaptions.push(output);
	      */
	      //Mactrix changes begin: assign the raw sei units to the pendingCaptions array
	      return this.pendingCaptions = output.userData.slice(0);
	      //Mactrix changes end
	    }
	    // buffer incoming id3 tags until the final flush
	    if (output.frames) {
	      return this.pendingMetadata.push(output);
	    }
	
	    // Add this track to the list of pending tracks and store
	    // important information required for the construction of
	    // the final segment
	    this.pendingTracks.push(output.track);
	    this.pendingBoxes.push(output.boxes);
	    this.pendingBytes += output.boxes.byteLength;
	
	    if (output.track.type === 'video') {
	      this.videoTrack = output.track;
	    }
	    if (output.track.type === 'audio') {
	      this.audioTrack = output.track;
	    }
	  };
	};
	
	_CoalesceStream.prototype = new Stream();
	_CoalesceStream.prototype.flush = function (flushSource) {
	  var offset = 0,
	      event = {
	    captions: [],
	    metadata: [],
	    info: {},
	    //Mactrix changes start: holds the audio info on combined streams
	    audioInfo: {}
	    //Mactrix changes end
	  },
	
	  /*Mactrix replace: not used
	  	caption,
	  */
	  id3,
	      initSegment,
	      timelineStartPts = 0,
	
	  //Mactric changes start: send back the dts for metadata, should be the same as pts
	  timelineStartDts = 0,
	      segmentTime,
	      //fall back to the bmdt when no metadata pts set
	  //Mactrix changes end
	  i;
	
	  if (this.pendingTracks.length < this.numberOfTracks) {
	    if (flushSource !== 'VideoSegmentStream' && flushSource !== 'AudioSegmentStream') {
	      // Return because we haven't received a flush from a data-generating
	      // portion of the segment (meaning that we have only recieved meta-data
	      // or captions.)
	      return;
	    } else if (this.remuxTracks) {
	      // Return until we have enough tracks from the pipeline to remux (if we
	      // are remuxing audio and video into a single MP4)
	      return;
	    } else if (this.pendingTracks.length === 0) {
	      // In the case where we receive a flush without any data having been
	      // received we consider it an emitted track for the purposes of coalescing
	      // `done` events.
	      // We do this for the case where there is an audio and video track in the
	      // segment but no audio data. (seen in several playlists with alternate
	      // audio tracks and no audio present in the main TS segments.)
	      this.emittedTracks++;
	
	      if (this.emittedTracks >= this.numberOfTracks) {
	        this.trigger('done');
	        this.emittedTracks = 0;
	      }
	      return;
	    }
	  }
	
	  /* Mactrix replace
	    if (this.videoTrack) {
	      timelineStartPts = this.videoTrack.timelineStartInfo.pts;
	      VIDEO_PROPERTIES.forEach(function(prop) {
	        event.info[prop] = this.videoTrack[prop];
	      }, this);
	    } else if (this.audioTrack) {
	      timelineStartPts = this.audioTrack.timelineStartInfo.pts;
	      AUDIO_PROPERTIES.forEach(function(prop) {
	        event.info[prop] = this.audioTrack[prop];
	      }, this);
	    }
	  
	    if (this.pendingTracks.length === 1) {
	      event.type = this.pendingTracks[0].type;
	    } else {
	      event.type = 'combined';
	    }
	  */
	  //Mactrix changes start: need to send back audio info on combined streams, need to send back the sample count and the fragment duration
	  if (this.pendingTracks.length === 1) {
	    event.type = this.pendingTracks[0].type;
	    event.duplicate = this.pendingTracks[0].duplicateFrag;
	    event.timeStamp = this.pendingTracks[0].minSegmentDts;
	
	    if (this.videoTrack) {
	      timelineStartPts = this.videoTrack.timelineStartInfo.pts;
	      timelineStartDts = this.videoTrack.timelineStartInfo.dts;
	      segmentTime = this.videoTrack.baseMediaDecodeTime;
	      VIDEO_PROPERTIES.forEach(function (prop) {
	        event.info[prop] = this.videoTrack[prop];
	      }, this);
	    } else if (this.audioTrack) {
	      timelineStartPts = this.audioTrack.timelineStartInfo.pts;
	      timelineStartDts = this.audioTrack.timelineStartInfo.dts;
	      segmentTime = this.audioTrack.baseMediaDecodeTime;
	      AUDIO_PROPERTIES.forEach(function (prop) {
	        event.info[prop] = this.audioTrack[prop];
	      }, this);
	    }
	  } else if (this.pendingTracks.length > 1) {
	    event.type = 'combined';
	    event.duplicate = this.pendingTracks[0].duplicateFrag;
	
	    if (this.videoTrack) {
	      timelineStartPts = this.videoTrack.timelineStartInfo.pts;
	      timelineStartDts = this.videoTrack.timelineStartInfo.dts;
	      segmentTime = this.videoTrack.baseMediaDecodeTime;
	      VIDEO_PROPERTIES.forEach(function (prop) {
	        event.info[prop] = this.videoTrack[prop];
	      }, this);
	    }
	
	    if (this.audioTrack) {
	      timelineStartPts = this.audioTrack.timelineStartInfo.pts;
	      timelineStartDts = this.audioTrack.timelineStartInfo.dts;
	      segmentTime = this.audioTrack.baseMediaDecodeTime;
	      AUDIO_PROPERTIES.forEach(function (prop) {
	        event.audioInfo[prop] = this.audioTrack[prop];
	      }, this);
	    }
	  }
	  //Mactrix changes end
	
	  this.emittedTracks += this.pendingTracks.length;
	
	  //Mactrix changes start: need to write write out the duration in mvhd
	  for (i = 0; i < this.pendingTracks.length; i++) {
	    this.pendingTracks[i].duration = this.duration * this.pendingTracks[i].timescale;
	    //Edge uses this for the first duration. Need to investigate deeper - SIEG
	
	    //		if (this.logTube) {
	    //			this.logTube.log('pendingTrack.duration: ' + this.pendingTracks[i].duration + ' dr:' + this.duration + ' sr: ' + this.pendingTracks[i].samplerate  + ' t: ' + this.pendingTracks[i].timescale + ' type: ' + this.pendingTracks[i].type);
	    //		}
	  }
	  //Mactrix changes end
	
	  // Create a new typed array to hold the init segment
	  initSegment = mp4.initSegment(this.pendingTracks);
	
	  event.initSegment = new Uint8Array(initSegment.byteLength);
	
	  // Create an init segment containing a moov
	  // and track definitions
	  event.initSegment.set(initSegment);
	
	  // Create a new typed array to hold the moof+mdats
	  event.data = new Uint8Array(this.pendingBytes);
	
	  // Append each moof+mdat (one per track) together
	  for (i = 0; i < this.pendingBoxes.length; i++) {
	    event.data.set(this.pendingBoxes[i], offset);
	    offset += this.pendingBoxes[i].byteLength;
	  }
	
	  // Translate caption PTS times into second offsets into the
	  // video timeline for the segment
	  /*Mactrix replace
	    for (i = 0; i < this.pendingCaptions.length; i++) {
	      caption = this.pendingCaptions[i];
	      caption.startTime = (caption.startPts - timelineStartPts);
	      caption.startTime /= 90e3;
	      caption.endTime = (caption.endPts - timelineStartPts);
	      caption.endTime /= 90e3;
	      event.captions.push(caption);
	    }
	  */
	  //Mactrix changes begin:  convert the 90k caption time into seconds starting from the base media decode time of the track that these
	  //						  captions are associated with
	  if (this.pendingCaptions.length > 0) {
	    var lastPts = this.pendingCaptions[0].pts;
	    this.pendingCaptions[0].pts = this.pendingTracks[0].baseMediaDecodeTime / ONE_SECOND_IN_TS;
	
	    for (i = 1; i < this.pendingCaptions.length; i++) {
	      var nextPts = this.pendingCaptions[i].pts;
	      this.pendingCaptions[i].pts = this.pendingCaptions[i - 1].pts + (nextPts - lastPts) / ONE_SECOND_IN_TS;
	      lastPts = nextPts;
	    }
	
	    event.captions = this.pendingCaptions.slice(0);
	  }
	  //Mactrix changes end
	
	  // Translate ID3 frame PTS times into second offsets into the
	  // video timeline for the segment
	  /*Mactrix replace
	    for (i = 0; i < this.pendingMetadata.length; i++) {
	      id3 = this.pendingMetadata[i];
	      id3.cueTime = (id3.pts - timelineStartPts);
	      id3.cueTime /= 90e3;
	      event.metadata.push(id3);
	    }
	  */
	
	  //Mactrix changes begin:  convert the 90k metadata time into seconds starting from the base media decode time of the track that these
	  //						  metadatas are associated with
	  if (this.pendingMetadata.length > 0) {
	    for (i = 0; i < this.pendingMetadata.length; i++) {
	      if (this.videoTrack) {
	        if (this.pendingMetadata[i].pts) {
	          this.pendingMetadata[i].pts = this.baseMediaDecodeTime + (this.pendingMetadata[i].pts - timelineStartPts);
	        } else {
	          this.pendingMetadata[i].pts = this.baseMediaDecodeTime + segmentTime;
	        }
	
	        if (this.pendingMetadata[i].dts) {
	          this.pendingMetadata[i].dts = this.baseMediaDecodeTime + (this.pendingMetadata[i].dts - timelineStartDts);
	        } else {
	          this.pendingMetadata[i].pts = this.baseMediaDecodeTime + segmentTime;
	        }
	        this.pendingMetadata[i].pts /= ONE_SECOND_IN_TS;
	        this.pendingMetadata[i].dts /= ONE_SECOND_IN_TS;
	      } else {
	        this.pendingMetadata[i].pts = this.baseMediaDecodeTime + segmentTime / this.audioTrack.samplerate;
	        this.pendingMetadata[i].dts = this.baseMediaDecodeTime + segmentTime / this.audioTrack.samplerate;
	      }
	    }
	
	    event.metadata = this.pendingMetadata.slice(0);
	  }
	  //Mactrix changes end
	
	  // We add this to every single emitted segment even though we only need
	  // it for the first
	  event.metadata.dispatchType = this.metadataStream.dispatchType;
	
	  // Reset stream state
	  this.pendingTracks.length = 0;
	  this.videoTrack = null;
	  this.pendingBoxes.length = 0;
	  this.pendingCaptions.length = 0;
	  this.pendingBytes = 0;
	  this.pendingMetadata.length = 0;
	
	  // Emit the built segment
	  this.trigger('data', event);
	
	  // Only emit `done` if all tracks have been flushed and emitted
	  if (this.emittedTracks >= this.numberOfTracks) {
	    this.trigger('done');
	    this.emittedTracks = 0;
	  }
	};
	/**
	 * A Stream that expects MP2T binary data as input and produces
	 * corresponding media segments, suitable for use with Media Source
	 * Extension (MSE) implementations that support the ISO BMFF byte
	 * stream format, like Chrome.
	 */
	_Transmuxer = function Transmuxer(options) {
	  var self = this,
	      hasFlushed = true,
	      videoTrack,
	      audioTrack;
	
	  _Transmuxer.prototype.init.call(this);
	
	  options = options || {};
	  this.baseMediaDecodeTime = options.baseMediaDecodeTime || 0;
	  //Mactrix changes begin
	  this.allowNegativeTFDT = options.allowNegativeTFDT || false;
	  this.logTube = options.logTube || null;
	  //Mactrix changes end
	  this.transmuxPipeline_ = {};
	
	  this.setupAacPipeline = function () {
	    var pipeline = {};
	    this.transmuxPipeline_ = pipeline;
	
	    pipeline.type = 'aac';
	    pipeline.metadataStream = new m2ts.MetadataStream();
	
	    // set up the parsing pipeline
	    pipeline.aacStream = new AacStream();
	    pipeline.audioTimestampRolloverStream = new m2ts.TimestampRolloverStream('audio');
	    pipeline.timedMetadataTimestampRolloverStream = new m2ts.TimestampRolloverStream('timed-metadata');
	    pipeline.adtsStream = new AdtsStream();
	    pipeline.coalesceStream = new _CoalesceStream(options, pipeline.metadataStream);
	    pipeline.headOfPipeline = pipeline.aacStream;
	
	    pipeline.aacStream.pipe(pipeline.audioTimestampRolloverStream).pipe(pipeline.adtsStream);
	    pipeline.aacStream.pipe(pipeline.timedMetadataTimestampRolloverStream).pipe(pipeline.metadataStream).pipe(pipeline.coalesceStream);
	
	    pipeline.metadataStream.on('timestamp', function (frame) {
	      pipeline.aacStream.setTimestamp(frame.timeStamp);
	    });
	
	    pipeline.aacStream.on('data', function (data) {
	      if (data.type === 'timed-metadata' && !pipeline.audioSegmentStream) {
	        audioTrack = audioTrack || {
	          //Mactrix changes begin
	          nextBMDT: self.baseMediaDecodeTime,
	          maxCompositionTimeOffset: 0,
	          //Mactrix changes end
	          timelineStartInfo: {
	            baseMediaDecodeTime: self.baseMediaDecodeTime
	          },
	          codec: 'adts',
	          type: 'audio',
	          //assign a constant id for the audio track instead of 0 (0 is illegal)
	          //under safari the id must remain constant throughout the presentation
	          id: 2
	        };
	
	        // hook up the audio segment stream to the first track with aac data
	        pipeline.coalesceStream.numberOfTracks++;
	        pipeline.audioSegmentStream = new _AudioSegmentStream(audioTrack);
	        // Set up the final part of the audio pipeline
	        pipeline.adtsStream.pipe(pipeline.audioSegmentStream).pipe(pipeline.coalesceStream);
	      }
	    });
	
	    // Re-emit any data coming from the coalesce stream to the outside world
	    pipeline.coalesceStream.on('data', this.trigger.bind(this, 'data'));
	    // Let the consumer know we have finished flushing the entire pipeline
	    pipeline.coalesceStream.on('done', this.trigger.bind(this, 'done'));
	  };
	
	  this.setupTsPipeline = function () {
	    var pipeline = {};
	    this.transmuxPipeline_ = pipeline;
	
	    pipeline.type = 'ts';
	    pipeline.metadataStream = new m2ts.MetadataStream();
	
	    // set up the parsing pipeline
	    /* Mactrix replace
	    	pipeline.packetStream = new m2ts.TransportPacketStream();
	        pipeline.parseStream = new m2ts.TransportParseStream();
	        pipeline.elementaryStream = new m2ts.ElementaryStream();
	    */
	    //Mactrix changes begin: pass in the logger - add these to the other components below when required
	    pipeline.packetStream = new m2ts.TransportPacketStream(self.logTube);
	    pipeline.parseStream = new m2ts.TransportParseStream(self.logTube);
	    pipeline.elementaryStream = new m2ts.ElementaryStream(self.logTube);
	    //Mactrix changes end
	    pipeline.videoTimestampRolloverStream = new m2ts.TimestampRolloverStream('video');
	    pipeline.audioTimestampRolloverStream = new m2ts.TimestampRolloverStream('audio');
	    pipeline.timedMetadataTimestampRolloverStream = new m2ts.TimestampRolloverStream('timed-metadata');
	    pipeline.adtsStream = new AdtsStream();
	    pipeline.h264Stream = new H264Stream();
	    pipeline.captionStream = new m2ts.CaptionStream();
	    pipeline.coalesceStream = new _CoalesceStream(options, pipeline.metadataStream);
	    pipeline.headOfPipeline = pipeline.packetStream;
	
	    // disassemble MPEG2-TS packets into elementary streams
	    pipeline.packetStream.pipe(pipeline.parseStream).pipe(pipeline.elementaryStream);
	
	    // !!THIS ORDER IS IMPORTANT!!
	    // demux the streams
	    pipeline.elementaryStream.pipe(pipeline.videoTimestampRolloverStream).pipe(pipeline.h264Stream);
	    pipeline.elementaryStream.pipe(pipeline.audioTimestampRolloverStream).pipe(pipeline.adtsStream);
	
	    pipeline.elementaryStream.pipe(pipeline.timedMetadataTimestampRolloverStream).pipe(pipeline.metadataStream).pipe(pipeline.coalesceStream);
	
	    // Hook up CEA-608/708 caption stream
	    pipeline.h264Stream.pipe(pipeline.captionStream).pipe(pipeline.coalesceStream);
	
	    pipeline.elementaryStream.on('data', function (data) {
	      var i;
	
	      if (data.type === 'metadata') {
	        i = data.tracks.length;
	
	        //Mactrix changes begin: need this for metadata
	        pipeline.coalesceStream.baseMediaDecodeTime = self.baseMediaDecodeTime;
	        //Mactrix changes end
	
	        // scan the tracks listed in the metadata
	        while (i--) {
	          if (!videoTrack && data.tracks[i].type === 'video') {
	            videoTrack = data.tracks[i];
	            videoTrack.timelineStartInfo.baseMediaDecodeTime = self.baseMediaDecodeTime;
	            //Mactrix changes begin: how much to extend/truncate the first video frame of a segment
	            videoTrack.allowNegativeTFDT = self.allowNegativeTFDT;
	            videoTrack.nextBMDT = self.baseMediaDecodeTime;
	            videoTrack.maxCompositionTimeOffset = 0;
	            videoTrack.fusionDuration = 0;
	            //assign a constant id for the video track instead of the transport stream video pid
	            //under safari the id must remain constant throughout the presentation
	            videoTrack.id = 1;
	            //Mactrix changes end
	          } else if (!audioTrack && data.tracks[i].type === 'audio') {
	            audioTrack = data.tracks[i];
	            audioTrack.timelineStartInfo.baseMediaDecodeTime = self.baseMediaDecodeTime;
	            //Mactrix changes begin
	            audioTrack.nextBMDT = self.baseMediaDecodeTime;
	            audioTrack.maxCompositionTimeOffset = 0;
	            //not required for audio
	            audioTrack.fusionDuration = 0;
	            //assign a constant id for the audio track instead of the transport stream audio pid
	            //under safari the id must remain constant throughout the presentation
	            audioTrack.id = 2;
	            //Mactrix changes end
	          }
	        }
	
	        // hook up the video segment stream to the first track with h264 data
	        if (videoTrack && !pipeline.videoSegmentStream) {
	          pipeline.coalesceStream.numberOfTracks++;
	          pipeline.videoSegmentStream = new _VideoSegmentStream(videoTrack);
	
	          //only set timelineStartInfo when timelineStartInfo has been reset ... at the beggining or after a seek
	          pipeline.videoSegmentStream.on('timelineStartInfo', function (timelineStartInfo) {
	            // When video emits timelineStartInfo data after a flush, we forward that
	            // info to the AudioSegmentStream, if it exists, because video timeline
	            // data takes precedence.
	            if (audioTrack) {
	              var audioFrameDuration = 1024 / audioTrack.samplerate * ONE_SECOND_IN_TS;
	              var avGap = timelineStartInfo.dts - audioTrack.timelineStartInfo.dts;
	
	              if (avGap < 0) {
	                //audio is ahead of video, need to insert audio frames
	                videoTrack.truncateDuration = -avGap % audioFrameDuration;
	                audioTrack.frameInsertCount = (-avGap - videoTrack.truncateDuration) / audioFrameDuration;
	              } else if (avGap > 0) {
	                //video is ahead of audio, need to drop audio frames
	                videoTrack.truncateDuration = -avGap % audioFrameDuration;
	                audioTrack.frameDropCount = (avGap - -videoTrack.truncateDuration) / audioFrameDuration;
	              }
	
	              if (avGap !== 0) {
	                timelineStartInfo.pts += videoTrack.truncateDuration;
	                timelineStartInfo.dts += videoTrack.truncateDuration;
	                videoTrack.minSegmentPts += videoTrack.truncateDuration;
	                videoTrack.minSegmentDts += videoTrack.truncateDuration;
	                audioTrack.minSegmentPts = videoTrack.minSegmentPts;
	                audioTrack.minSegmentDts = videoTrack.minSegmentDts;
	              }
	
	              audioTrack.timelineStartInfo = timelineStartInfo;
	              // On the first segment we trim AAC frames that exist before the
	              // very earliest DTS we have seen in video because Chrome will
	              // interpret any video track with a baseMediaDecodeTime that is
	              // non-zero as a gap.
	              pipeline.audioSegmentStream.setEarliestDts(timelineStartInfo.dts);
	            }
	          });
	
	          pipeline.videoSegmentStream.on('baseMediaDecodeTime', function (baseMediaDecodeTime) {
	            if (audioTrack) {
	              pipeline.audioSegmentStream.setVideoBaseMediaDecodeTime(baseMediaDecodeTime);
	            }
	          });
	
	          // Set up the final part of the video pipeline
	          pipeline.h264Stream.pipe(pipeline.videoSegmentStream).pipe(pipeline.coalesceStream);
	        }
	
	        if (audioTrack && !pipeline.audioSegmentStream) {
	          // hook up the audio segment stream to the first track with aac data
	          pipeline.coalesceStream.numberOfTracks++;
	          pipeline.audioSegmentStream = new _AudioSegmentStream(audioTrack);
	
	          // Set up the final part of the audio pipeline
	          pipeline.adtsStream.pipe(pipeline.audioSegmentStream).pipe(pipeline.coalesceStream);
	        }
	      }
	    });
	
	    // Re-emit any data coming from the coalesce stream to the outside world
	    pipeline.coalesceStream.on('data', this.trigger.bind(this, 'data'));
	    // Let the consumer know we have finished flushing the entire pipeline
	    pipeline.coalesceStream.on('done', this.trigger.bind(this, 'done'));
	  };
	
	  // hook up the segment streams once track metadata is delivered
	  this.setBaseMediaDecodeTime = function (baseMediaDecodeTime) {
	    var pipeline = this.transmuxPipeline_;
	
	    this.baseMediaDecodeTime = baseMediaDecodeTime;
	    if (audioTrack) {
	
	      if (pipeline.audioSegmentStream) {
	        pipeline.audioSegmentStream.setlastFragAborted(false);
	      }
	
	      audioTrack.timelineStartInfo.dts = undefined;
	      audioTrack.timelineStartInfo.pts = undefined;
	      clearDtsInfo(audioTrack);
	      audioTrack.timelineStartInfo.baseMediaDecodeTime = baseMediaDecodeTime;
	      //Mactrix changes begin
	      audioTrack.lastMinSegmentDts = undefined;
	      audioTrack.nextBMDT = baseMediaDecodeTime;
	      audioTrack.fusionDuration = 0;
	      //Mactrix changes end
	    }
	    if (videoTrack) {
	      if (pipeline.videoSegmentStream) {
	        /*Mactrix replace
	                pipeline.videoSegmentStream.gopCache_ = [];
	        */
	        //Mactrix changes begin
	        pipeline.videoSegmentStream.resetGOPS();
	        pipeline.videoSegmentStream.setlastFragAborted(false);
	        //Mactrix changes end
	      }
	
	      videoTrack.timelineStartInfo.dts = undefined;
	      videoTrack.timelineStartInfo.pts = undefined;
	      clearDtsInfo(videoTrack);
	      videoTrack.timelineStartInfo.baseMediaDecodeTime = baseMediaDecodeTime;
	      //Mactrix changes begin
	      videoTrack.maxCompositionTimeOffset = 0;
	      videoTrack.lastMinSegmentDts = undefined;
	      videoTrack.nextBMDT = baseMediaDecodeTime;
	      videoTrack.fusionDuration = 0;
	      //Mactrix changes end
	    }
	  };
	
	  //Mactrix changes begin
	  this.setGapDuration = function (gapDuration) {
	    if (audioTrack) {
	      this.transmuxPipeline_.audioSegmentStream.setGapDuration(gapDuration);
	    }
	
	    if (videoTrack) {
	      this.transmuxPipeline_.videoSegmentStream.setGapDuration(gapDuration);
	    }
	  };
	
	  this.setLastFragAborted = function (lastFragAborted) {
	    if (audioTrack) {
	      this.transmuxPipeline_.audioSegmentStream.setlastFragAborted(lastFragAborted);
	    }
	
	    if (videoTrack) {
	      this.transmuxPipeline_.videoSegmentStream.setlastFragAborted(lastFragAborted);
	    }
	  };
	  //Mactrix changes end
	
	  this.setAudioAppendStart = function (timestamp) {
	    if (audioTrack) {
	      this.transmuxPipeline_.audioSegmentStream.setAudioAppendStart(timestamp);
	    }
	  };
	
	  // feed incoming data to the front of the parsing pipeline
	  this.push = function (data) {
	    if (hasFlushed) {
	      var isAac = isLikelyAacData(data);
	
	      if (isAac && this.transmuxPipeline_.type !== 'aac') {
	        this.setupAacPipeline();
	      } else if (!isAac && this.transmuxPipeline_.type !== 'ts') {
	        this.setupTsPipeline();
	      }
	      hasFlushed = false;
	    }
	    this.transmuxPipeline_.headOfPipeline.push(data);
	  };
	
	  // flush any buffered data
	  this.flush = function () {
	    hasFlushed = true;
	    // Start at the top of the pipeline and flush all pending work
	    this.transmuxPipeline_.headOfPipeline.flush();
	  };
	};
	_Transmuxer.prototype = new Stream();
	
	module.exports = {
	  Transmuxer: _Transmuxer,
	  VideoSegmentStream: _VideoSegmentStream,
	  AudioSegmentStream: _AudioSegmentStream,
	  AUDIO_PROPERTIES: AUDIO_PROPERTIES,
	  VIDEO_PROPERTIES: VIDEO_PROPERTIES
	};

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.detectBrowser = exports.detectedBrowser = undefined;
	
	var _logger = __webpack_require__(1);
	
	function detectBrowserM(userAgentString) {
		var browsers = [['edge', /Edge\/([0-9._]+)/], ['yandexbrowser', /YaBrowser\/([0-9._]+)/], ['tizen', /Tizen\s([0-9._]+)/], ['webos3', /Web0S.*Chrome\/([0-9.]+)/], ['webos2', /Web0S.*Safari\/([0-9.]+)/], ['chrome', /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9.]+)(:?\s|$)/], ['crios', /CriOS\/([0-9.]+)(:?\s|$)/], ['firefox', /Firefox\/([0-9.]+)(?:\s|$)/], ['opera', /Opera\/([0-9.]+)(?:\s|$)/], ['opera', /OPR\/([0-9.]+)(:?\s|$)$/], ['ie', /Trident\/7\.0.*rv:([0-9.]+)\).*Gecko$/], ['ie', /MSIE\s([0-9.]+);.*Trident\/[4-7].0/], ['ie', /MSIE\s(7\.0)/], ['bb10', /BB10;\sTouch.*Version\/([0-9.]+)/], ['android', /Android\s([0-9.]+)/], ['phantom', /PhantomJS\/([0-9._]+)/], ['ios', /Version\/([0-9._]+).*Mobile.*Safari.*/], ['safari', /Version\/([0-9._]+).*Safari/], ['electron', /Electron\s([0-9._]+)/]];
	
		return browsers.map(function (rule) {
			if (rule[1].test(userAgentString)) {
				var match = rule[1].exec(userAgentString);
				var version = match && match[1].split(/[._]/).slice(0, 3);
	
				if (version && version.length < 3) {
					Array.prototype.push.apply(version, version.length === 1 ? [0, 0] : [0]);
				}
				return {
					name: rule[0],
					version: version.join('.')
				};
			} else {
				return undefined; //This function relies on the undefined to cause a map shift
			}
		}).filter(Boolean).shift();
	} /*
	  
	  Based off detect-browser 1.6.2 which has a MIT License
	  
	  MIT License
	  
	  Copyright (c) 2016 Damon Oehlman
	  
	  Permission is hereby granted, free of charge, to any person obtaining a copy
	  of this software and associated documentation files (the "Software"), to deal
	  in the Software without restriction, including without limitation the rights
	  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	  copies of the Software, and to permit persons to whom the Software is
	  furnished to do so, subject to the following conditions:
	  
	  The above copyright notice and this permission notice shall be included in all
	  copies or substantial portions of the Software.
	  
	  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	  SOFTWARE.
	  */
	
	function detectPlatformM(userAgentString) {
		var platforms = [['windows', /Windows\sNT\s([0-9.]+)/]];
	
		return platforms.map(function (rule) {
			if (rule[1].test(userAgentString)) {
				var match = rule[1].exec(userAgentString);
				var version = match && match[1].split(/[._]/).slice(0, 3);
	
				if (version && version.length < 3) {
					Array.prototype.push.apply(version, version.length === 1 ? [0, 0] : [0]);
				}
				return {
					name: rule[0],
					version: version.join('.')
				};
			} else {
				return undefined; //This function relies on the undefined to cause a map shift
			}
		}).filter(Boolean).shift();
	}
	
	function isNode() {
		try {
			return process.release.name === 'node';
		} catch (e) {
			return false;
		}
	}
	
	function detectPlatform(userAgentString) {
		var platform = 'unknown';
	
		if (userAgentString.indexOf('Macintosh') !== -1) {
			platform = 'macintosh';
		} else if (userAgentString.indexOf('Windows NT') !== -1) {
			platform = 'windows';
		} else if (userAgentString.indexOf('Android') !== -1) {
			platform = 'android'; //Needs to be before Linux
		} else if (userAgentString.indexOf('Tizen') !== -1) {
			platform = 'tizen'; //Needs to be before Linux
		} else if (userAgentString.indexOf('Web0S') !== -1) {
			platform = 'webos'; //Needs to be before Linux
		} else if (userAgentString.indexOf('Linux') !== -1) {
			platform = 'linux';
		} else if (userAgentString.indexOf('iPhone') !== -1) {
			platform = 'ios';
		} else if (userAgentString.indexOf('iPad') !== -1) {
			platform = 'ios';
		}
	
		return platform;
	}
	
	function detectPlatformVersion(platform, userAgentString) {
	
		var platformVersion = 'unknown';
	
		if (platform === 'windows') {
			var spot = userAgentString.indexOf('Windows NT');
	
			if (spot !== -1) {
				var platformV2 = detectPlatformM(userAgentString);
	
				if (platformV2 !== undefined) {
					platformVersion = platformV2.version;
				} else {
					platformVersion = 'winxx';
				}
			} else {
				platformVersion = 'winxx';
			}
		}
	
		return platformVersion;
	}
	
	function detectNodePlatform(platformString) {
		var platform = 'unknown';
	
		if (platformString.indexOf('darwin') !== -1) {
			platform = 'macintosh';
		} else if (platformString.indexOf('win32') !== -1) {
			platform = 'windows';
		} else {
			_logger.logger.log('DetectBrowser: Unknown Node platform: {' + platformString + '}');
			platform = platformString;
		}
	
		return platform;
	}
	
	function detectBrowser(userAgentString) {
		var usrAgent = userAgentString;
		var detection = {};
	
		if (!usrAgent && typeof navigator !== 'undefined') {
			usrAgent = navigator.userAgent;
		}
	
		if (usrAgent) {
			detection = detectBrowserM(usrAgent);
			if (detection !== undefined) {
				if (detection.name === 'webos2') {
					detection.name = 'webos';
					//Need some real world examples here, but it doesn't matter too much...
					if (detection.version === '537.41.0') {
						detection.version = '1.0';
					} else if (detection.version === '538.2.0') {
						detection.version = '2.0';
					} else {
						//assume 2.0 otherwise
						detection.version = '2.0';
					}
				} else if (detection.name === 'webos3') {
					detection.name = 'webos';
					//Need some real world examples here, but it doesn't matter too much...
					if (detection.version === '38.0.2125') {
						detection.version = '3.0';
					} else if (detection.version === '53.0.2785') {
						detection.version = '4.0';
					} else {
						//assume 3.0 otherwise
						detection.version = '3.0';
					}
				}
				detection.platform = detectPlatform(usrAgent);
				detection.platformVersion = detectPlatformVersion(detection.platform, usrAgent);
			} else {
				_logger.logger.log('DetectBrowser: Unknown userAgent: {' + usrAgent + '}');
			}
		} else if (isNode()) {
			detection.name = 'node';
			detection.version = process.version.slice(1);
			detection.platform = detectNodePlatform(process.platform);
			detection.platformVersion = 'unknown';
		}
	
		if (detection === undefined || detection.version === undefined) {
			detection = {};
			detection.name = 'unknown';
			detection.version = '1.0';
			detection.platform = 'unknown';
			detection.platformVersion = 'unknown';
		}
	
		return detection;
	}
	
	var detectedBrowser = detectBrowser();
	
	exports.default = detectedBrowser;
	exports.detectedBrowser = detectedBrowser;
	exports.detectBrowser = detectBrowser;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(62)))

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(32);
	var toLength = __webpack_require__(9);
	var toAbsoluteIndex = __webpack_require__(39);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(173);
	
	module.exports = function (original, length) {
	  return new (speciesConstructor(original))(length);
	};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(23);
	var TAG = __webpack_require__(7)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 51 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(20);
	var document = __webpack_require__(8).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(8).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(23);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(15);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ }),
/* 56 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(29).f;
	var has = __webpack_require__(37);
	var TAG = __webpack_require__(7)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(93)('keys');
	var uid = __webpack_require__(59);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 59 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 60 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright JS Foundation and other contributors <https://js.foundation/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.17.5';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;
	
	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;
	
	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading and trailing whitespace. */
	  var reTrim = /^\s+|\s+$/g,
	      reTrimStart = /^\s+/,
	      reTrimEnd = /\s+$/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
	      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Gets the value at `key`, unless `key` is "__proto__".
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function safeGet(object, key) {
	    return key == '__proto__'
	      ? undefined
	      : object[key];
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
	        symIterator = Symbol ? Symbol.iterator : undefined,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;
	
	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);
	
	      this.size = data.size;
	      return result;
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }
	
	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;
	
	      while (++index < length) {
	        result[index] = skip ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      if (isSet(value)) {
	        value.forEach(function(subValue) {
	          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	        });
	
	        return result;
	      }
	
	      if (isMap(value)) {
	        value.forEach(function(subValue, key) {
	          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	        });
	
	        return result;
	      }
	
	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);
	
	      var props = isArr ? undefined : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);
	
	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;
	
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        if (isObject(srcValue)) {
	          stack || (stack = new Stack);
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = safeGet(object, key),
	          srcValue = safeGet(source, key),
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      var index = -1;
	      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};
	
	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);
	
	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }
	
	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };
	
	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array == null ? 0 : array.length,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      return object == null || delete object[toKey(last(path))];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);
	
	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;
	
	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }
	
	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined : value;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(array);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];
	
	      try {
	        value[symToStringTag] = undefined;
	        var unmasked = true;
	      } catch (e) {}
	
	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : '';
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          result = false;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return new Ctor;
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return new Ctor;
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      var type = typeof value;
	      length = length == null ? MAX_SAFE_INTEGER : length;
	
	      return !!length &&
	        (type == 'number' ||
	          (type != 'symbol' && reIsUint.test(value))) &&
	            (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });
	
	      var cache = result.cache;
	      return result;
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }
	
	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }
	
	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;
	
	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }
	
	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;
	
	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];
	
	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (string.charCodeAt(0) === 46 /* . */) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, subString) {
	        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            timeWaiting = wait - timeSinceLastCall;
	
	        return maxing
	          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	          : timeWaiting;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Expose `MapCache`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = value.replace(reTrim, '');
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(object, sources) {
	      object = Object(object);
	
	      var index = -1;
	      var length = sources.length;
	      var guard = length > 2 ? sources[2] : undefined;
	
	      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	        length = 1;
	      }
	
	      while (++index < length) {
	        var source = sources[index];
	        var props = keysIn(source);
	        var propsIndex = -1;
	        var propsLength = props.length;
	
	        while (++propsIndex < propsLength) {
	          var key = props[propsIndex];
	          var value = object[key];
	
	          if (value === undefined ||
	              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	            object[key] = source[key];
	          }
	        }
	      }
	
	      return object;
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, customDefaultsMerge);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);
	
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, customDefaultsAssignIn);
	
	      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      var sourceURL = '//# sourceURL=' +
	        ('sourceURL' in options
	          ? options.sourceURL
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrim, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimEnd, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();
	
	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = (lodashFunc.name + ''),
	            names = realNames[key] || (realNames[key] = []);
	
	        names.push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(218)(module)))

/***/ }),
/* 62 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 63 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	/**
	* @public
	*/
	var CencModes = {
		CBC: 'CBC',
		CTR: 'CTR'
	};
	
	exports.default = CencModes;
	module.exports = exports['default'];

/***/ }),
/* 64 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	/**
	* @public
	*/
	var HlsErrorStrings = {
		WARNING: 'BamHLS issued a non-fatal warning',
		LOAD_FAILED: 'BamHLS was not able to load the stream',
		FETCH_FAILED: 'BamHLS was not able to fetch the variants',
		PLAYBACK_FAILED: 'BamHLS was not able to playback the media',
		MEDIA_CONTROLLER_FAILED: 'BamHLS was not able to wire or attach the media',
		MEDIA_ELEMENT_FAILED: 'BamHLS experienced an error in the media element',
		STREAM_TIMEOUT: 'BamHLS experienced unexpected stream ending',
		UNEXPECTED_ERROR: 'BamHLS experienced an unexpected error',
		INTERNAL_EXCEPTION: 'BamHLS experienced an internal exception'
	};
	
	exports.default = HlsErrorStrings;
	module.exports = exports['default'];

/***/ }),
/* 65 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	/**
	* @public
	*/
	var HlsErrors = {
		// normal failures
	
		// provides informative errors which are not necessarily fatal, ie retries.
		WARNING: 'WARNING',
	
		// error preventing LOAD state from being entered.
		LOAD_FAILED: 'LOAD_FAILED',
	
		// error occurred while FETCHING, will prevent PLAYBACK
		FETCH_FAILED: 'FETCH_FAILED', // for example, if there were no variants to fetch.
	
		// error occurred during playback which will prevent playback.
		PLAYBACK_FAILED: 'PLAYBACK_FAILED',
	
		// an error occurred either during WIRING or ATTACHING the media
		MEDIA_CONTROLLER_FAILED: 'MEDIA_CONTROLLER_FAILED',
	
		// the media element threw an error.
		MEDIA_ELEMENT_FAILED: 'MEDIA_ELEMENT_FAILED',
	
		/*
	 	This error generally occurs during PLAYBACK, when no new content can be output
	 	and thus the stream will end earlier than expected. You should still wait for the
	 	STREAM_ENDED event in order to display all the content which is available.
	 */
		STREAM_TIMEOUT: 'STREAM_TIMEOUT',
	
		UNEXPECTED_ERROR: 'UNEXPECTED_ERROR',
	
		INTERNAL_EXCEPTION: 'INTERNAL_EXCEPTION'
	};
	
	exports.default = HlsErrors;
	module.exports = exports['default'];

/***/ }),
/* 66 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	/**
	* @public
	*/
	var HlsStates = {
		UNLOADED: 'UNLOADED',
		LOADING: 'LOADING',
		LOADED: 'LOADED',
		FETCHING: 'FETCHING',
		PLAYBACK: 'PLAYBACK'
	};
	
	exports.default = HlsStates;
	module.exports = exports['default'];

/***/ }),
/* 67 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	/**
	* @public
	*/
	var MediaStates = {
		WIRING: 'WIRING',
		WIRED: 'WIRED',
		ATTACHING: 'ATTACHING',
		ATTACHED: 'ATTACHED',
		DETACHING: 'DETACHING',
		DETACHED: 'DETACHED' // initial state
	};
	
	exports.default = MediaStates;
	module.exports = exports['default'];

/***/ }),
/* 68 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	/**
	* @public
	*/
	var PlaybackStates = {
		NOTREADY: 'NOTREADY',
		PAUSED: 'PAUSED',
		BUFFERING: 'BUFFERING',
		PLAYING: 'PLAYING',
		SEEKING: 'SEEKING',
		ENDED: 'ENDED'
	};
	
	exports.default = PlaybackStates;
	module.exports = exports['default'];

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); //Mactrix line added
	
	var _events = __webpack_require__(3);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _CryptoAesCbc = __webpack_require__(107);
	
	var _CryptoAesCbc2 = _interopRequireDefault(_CryptoAesCbc);
	
	var _errors = __webpack_require__(4);
	
	var _logger = __webpack_require__(1);
	
	var _ArrayHelper = __webpack_require__(21);
	
	var _ArrayHelper2 = _interopRequireDefault(_ArrayHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	__webpack_require__(79);
	
	var MactrixDecrypter = function () {
		function MactrixDecrypter(observer, config) {
			_classCallCheck(this, MactrixDecrypter);
	
			this.observer = observer;
			this.config = config;
			this.logEnabled = true;
			this.crypto = new _CryptoAesCbc2.default(); // super-duper-mactrix-crypto
		}
	
		_createClass(MactrixDecrypter, [{
			key: 'isSync',
			value: function isSync() {
				return false; // we're async/Promise based.
			}
		}, {
			key: 'decrypt',
			value: function decrypt(data, key, iv, callback) {
				var _this = this;
	
				// TODO: this.config.enableSoftwareAES
				var keyArray = _ArrayHelper2.default.makeUint8Array(key);
				var ivArray = _ArrayHelper2.default.makeUint8Array(iv);
	
				try {
					if (this.key !== key) {
						this.key = key;
						this.cryptoKey = this.crypto.createKey(keyArray);
					}
	
					this.cryptoKey.then(function (aesKey) {
						return _this.crypto.decrypt(aesKey, ivArray, data);
					}).then(function (result) {
						callback(result);
					}).catch(function (err) {
						_this.onCryptoError(err);
					});
				} catch (err) {
					this.onCryptoError(err);
				}
			}
		}, {
			key: 'onCryptoError',
			value: function onCryptoError(err) {
				_logger.logger.error('decrypting error : ' + err.message);
				if (this.observer) {
					this.observer.trigger(_events2.default.ERROR, {
						type: _errors.ErrorTypes.MEDIA_ERROR,
						details: _errors.ErrorDetails.FRAG_DECRYPT_ERROR,
						fatal: true,
						reason: err.message
					});
				}
			}
		}, {
			key: 'destroy',
			value: function destroy() {
				this.observer = null;
				this.config = null;
				this.crypto = null;
				this.cryptoKey = null;
				this.key = null;
			}
		}]);
	
		return MactrixDecrypter;
	}();
	
	exports.default = MactrixDecrypter;
	module.exports = exports['default'];

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	//Mactrix additions begin
	//mux js wrapper
	//mux js web worker
	// browersify only
	// webpack only
	
	//Mactrix additions end
	
	
	var _events = __webpack_require__(3);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _muxjsInline = __webpack_require__(74);
	
	var _muxjsInline2 = _interopRequireDefault(_muxjsInline);
	
	var _muxjsWorker = __webpack_require__(75);
	
	var _muxjsWorker2 = _interopRequireDefault(_muxjsWorker);
	
	var _webworkify = __webpack_require__(220);
	
	var _webworkify2 = _interopRequireDefault(_webworkify);
	
	var _webworkifyWebpack = __webpack_require__(219);
	
	var _webworkifyWebpack2 = _interopRequireDefault(_webworkifyWebpack);
	
	var _MactrixDecrypter = __webpack_require__(69);
	
	var _MactrixDecrypter2 = _interopRequireDefault(_MactrixDecrypter);
	
	var _logger = __webpack_require__(1);
	
	var _errors = __webpack_require__(4);
	
	var _events3 = __webpack_require__(60);
	
	var _events4 = _interopRequireDefault(_events3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Demuxer = function () {
	  function Demuxer(hls, id) {
	    _classCallCheck(this, Demuxer);
	
	    this.hls = hls;
	    this.id = id;
	    //Mactrix changes begin
	    this.enableMuxJs = !!hls.config.enableMuxJs; //switch between the use of hls js transmuxer and mux js transmuxer
	    this.decryptOutsideWebworker = !!hls.config.decryptOutsideWebworker; //for platforms that don't support decyption in Webworkers
	    this.decrypter = null;
	    //Mactrix changes end
	    // observer setup
	    var observer = this.observer = new _events4.default();
	    /*Mactrix replace
	    	const config = hls.config;
	    Mactrix replace*/
	    var config = this.config = hls.config; //Mactrix addition; need to retain
	    observer.trigger = function trigger(event) {
	      for (var _len = arguments.length, data = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        data[_key - 1] = arguments[_key];
	      }
	
	      observer.emit.apply(observer, [event, event].concat(data));
	    };
	
	    observer.off = function off(event) {
	      for (var _len2 = arguments.length, data = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	        data[_key2 - 1] = arguments[_key2];
	      }
	
	      observer.removeListener.apply(observer, [event].concat(data));
	    };
	
	    var forwardMessage = function (ev, data) {
	      data = data || {};
	      data.frag = this.frag;
	      data.id = this.id;
	      hls.trigger(ev, data);
	    }.bind(this);
	
	    // forward events to main thread
	    observer.on(_events2.default.FRAG_DECRYPTED, forwardMessage);
	    observer.on(_events2.default.FRAG_PARSING_INIT_SEGMENT, forwardMessage);
	    observer.on(_events2.default.FRAG_PARSING_DATA, forwardMessage);
	    observer.on(_events2.default.FRAG_PARSED, forwardMessage);
	    observer.on(_events2.default.ERROR, forwardMessage);
	    observer.on(_events2.default.FRAG_PARSING_METADATA, forwardMessage);
	    observer.on(_events2.default.FRAG_PARSING_USERDATA, forwardMessage);
	    observer.on(_events2.default.INIT_PTS_FOUND, forwardMessage);
	
	    var typeSupported = {
	      mp4: MediaSource.isTypeSupported('video/mp4'),
	      mpeg: MediaSource.isTypeSupported('audio/mpeg'),
	      /* Mactrix changed line
	            mp3: MediaSource.isTypeSupported('audio/mp4; codecs="mp3"'),
	      */
	      // Mactrix changes begin
	      mp3: MediaSource.isTypeSupported('audio/mp4; codecs="mp3"'),
	      browChrome: hls.browChrome,
	      browSafari: hls.browSafari,
	      browFirefox: hls.browFirefox,
	      browAndroid: hls.browAndroid,
	      browEdge: hls.browEdge,
	      browIE: hls.browIE
	      // Mactrix changes end
	    };
	    // navigator.vendor is not always available in Web Worker
	    // refer to https://developer.mozilla.org/en-US/docs/Web/API/WorkerGlobalScope/navigator
	    var vendor = navigator.vendor;
	    //if(false) {
	    if (config.enableWorker && typeof Worker !== 'undefined') {
	      _logger.logger.log('demuxing in webworker');
	      var w = void 0;
	      try {
	        /* mactrix replace
	        			let work = require('webworkify');
	        			w = this.w = work(DemuxerWorker);
	        */
	        //Mactrix changes begin
	        // if we're using WebPack we need to use webworkify-webpack rather than webworkify
	        if (false) {
	          w = this.w = (0, _webworkify2.default)(_muxjsWorker2.default);
	        } else {
	          w = this.w = (0, _webworkifyWebpack2.default)(/*require.resolve*/(75));
	        }
	        //Mactrix changes end
	        this.onwmsg = this.onWorkerMessage.bind(this);
	        w.addEventListener('message', this.onwmsg);
	        w.onerror = function (event) {
	          hls.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.OTHER_ERROR, details: _errors.ErrorDetails.INTERNAL_EXCEPTION, fatal: true, event: 'demuxerWorker', err: { message: event.message + ' (' + event.filename + ':' + event.lineno + ')' } });
	        };
	        w.postMessage({ cmd: 'init', typeSupported: typeSupported, vendor: vendor, id: id, config: JSON.stringify(config) });
	      } catch (err) {
	        _logger.logger.error('error while initializing DemuxerWorker, fallback on DemuxerInline');
	        hls.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.MUX_ERROR, details: _errors.ErrorDetails.DEMUX_WORKER_ALLOC_ERROR, fatal: false }); //Mactrix line added, emit errors
	        if (w) {
	          // revoke the Object URL that was used to create demuxer worker, so as not to leak it
	          URL.revokeObjectURL(w.objectURL);
	        }
	        //Mactrix changes begin
	        this.demuxer = new _muxjsInline2.default(observer, typeSupported, config, vendor);
	        //Mactrix changes end
	        this.w = undefined;
	      }
	    } else {
	      //Mactrix changes begin
	      this.demuxer = new _muxjsInline2.default(observer, typeSupported, config, vendor);
	      //Mactrix changes end
	    }
	  }
	
	  _createClass(Demuxer, [{
	    key: 'destroy',
	    value: function destroy() {
	      var w = this.w;
	      if (w) {
	        w.removeEventListener('message', this.onwmsg);
	        w.terminate();
	        this.w = null;
	      } else {
	        var demuxer = this.demuxer;
	        if (demuxer) {
	          demuxer.destroy();
	          this.demuxer = null;
	        }
	      }
	      var observer = this.observer;
	      if (observer) {
	        observer.removeAllListeners();
	        this.observer = null;
	      }
	    }
	  }, {
	    key: 'push',
	    value: function push(data, initSegment, audioCodec, videoCodec, frag, duration, accurateTimeOffset, lastFragAborted, deliberateGap) {
	      var w = this.w;
	      var timeOffset = !isNaN(frag.startDTS) ? frag.startDTS : frag.start;
	      var decryptdata = frag.decryptdata;
	      var lastFrag = this.frag;
	      var discontinuity = !(lastFrag && frag.cc === lastFrag.cc);
	      var trackSwitch = !(lastFrag && frag.level === lastFrag.level);
	      var pdt = frag.pdt;
	      /*Mactrix replace
	          const nextSN = lastFrag && (frag.sn === (lastFrag.sn+1));
	          const contiguous = !discontinuity && !trackSwitch && nextSN;
	      */
	      //Mactrix changes begin: in the case muxjs (to make the code simpler) contiguous will mean if we seeked or not, ie; nextSN is true or false
	      //this needs to be based on pdt if available, we still have an issue with duplicate
	      //frags, most likely occurs when we hit the edge of a live playlist and we end up selecting
	      //the last frag again instead of waiting for a refresh ... needs to be fixed.
	      var nextSN = void 0;
	      var contiguous = void 0;
	      var hasBeenProcessed = false;
	
	      if (this.enableMuxJs === true) {
	        if (lastFrag) {
	          if (lastFrag.pdt && frag.pdt) {
	            var expectedTime = lastFrag.pdt + lastFrag.manifestDuration * 1000;
	            var variance = lastFrag.manifestDuration * 500; //variance is 1/2 a manifest duration
	
	            //for the next frag to be in sequence it needs to begin at the end of the previous frag (or be the same as the current frag)
	            //we will allow up to but not including 1/2 a manifest duration of variance
	
	            if (frag.pdt > lastFrag.pdt - variance && frag.pdt < lastFrag.pdt + variance) {
	              //this is the same frag ... we need to reset
	              contiguous = true;
	            } else {
	              if (frag.pdt > expectedTime - variance && frag.pdt < expectedTime + variance) {
	                //for the sake of simplicity, contiguous indicates whether or not we have seeked .... its backwards ... I know ... change me!
	                contiguous = false;
	              } else {
	                contiguous = !deliberateGap;
	              }
	            }
	          } else {
	            nextSN = frag.sn === lastFrag.sn + 1;
	            contiguous = !(nextSN === true || deliberateGap);
	          }
	        } else {
	          contiguous = true;
	        }
	
	        //to avoid additional changes I'm using the accurateTimeOffset parameter as the disco gap since the parameter is not used in muxjs
	        accurateTimeOffset = frag.gap;
	      }
	      //Mactrix changes end
	
	      //This block is for decryptOutsideWebworker. There's supporting code for this, but the major changes should be mostly self contained; if you delete this block nothing should break.
	      if (this.decryptOutsideWebworker === true && w && decryptdata != null && data.byteLength > 0 && decryptdata.key != null && decryptdata.method === 'AES-128') {
	
	        var decrypter = this.decrypter;
	        if (decrypter === null) {
	          decrypter = this.decrypter = new _MactrixDecrypter2.default(this.observer, this.config);
	        }
	        var localthis = this;
	        var startTime = void 0;
	        hasBeenProcessed = true;
	
	        try {
	          startTime = performance.now();
	        } catch (error) {
	          startTime = Date.now();
	        }
	
	        decrypter.decrypt(data, decryptdata.key.buffer, decryptdata.iv.buffer, function (decryptedData) {
	          var endTime = void 0;
	          try {
	            endTime = performance.now();
	          } catch (error) {
	            endTime = Date.now();
	          }
	          localthis.observer.trigger(_events2.default.FRAG_DECRYPTED, { stats: { tstart: startTime, tdecrypt: endTime } });
	          w.postMessage({ cmd: 'demux', data: decryptedData, decryptdata: null, initSegment: initSegment, audioCodec: audioCodec, videoCodec: videoCodec, timeOffset: timeOffset, discontinuity: discontinuity, trackSwitch: trackSwitch, contiguous: contiguous, duration: duration, accurateTimeOffset: accurateTimeOffset, lastFragAborted: lastFragAborted, pdt: pdt }, [data]);
	        });
	      }
	
	      //Mactrix changes end
	      if (discontinuity) {
	        _logger.logger.log(this.id + ':discontinuity detected');
	      }
	      if (trackSwitch) {
	        _logger.logger.log(this.id + ':switch detected');
	      }
	      this.frag = frag;
	      //Mactrix changes start
	      if (!hasBeenProcessed) {
	        //Mactrix changes end
	        if (w) {
	          // post fragment payload as transferable objects (no copy)
	          w.postMessage({ cmd: 'demux', data: data, decryptdata: decryptdata, initSegment: initSegment, audioCodec: audioCodec, videoCodec: videoCodec, timeOffset: timeOffset, discontinuity: discontinuity, trackSwitch: trackSwitch, contiguous: contiguous, duration: duration, accurateTimeOffset: accurateTimeOffset, lastFragAborted: lastFragAborted, pdt: pdt }, [data]);
	        } else {
	          var demuxer = this.demuxer;
	          if (demuxer) {
	            demuxer.push(data, decryptdata, initSegment, audioCodec, videoCodec, timeOffset, discontinuity, trackSwitch, contiguous, duration, accurateTimeOffset, lastFragAborted, pdt);
	          }
	        }
	        //Mactrix changes start
	      }
	      //Mactrix changes end
	    }
	  }, {
	    key: 'onWorkerMessage',
	    value: function onWorkerMessage(ev) {
	      var data = ev.data,
	          hls = this.hls;
	      //console.log('onWorkerMessage:' + data.event);
	      switch (data.event) {
	        case 'init':
	          // revoke the Object URL that was used to create demuxer worker, so as not to leak it
	          URL.revokeObjectURL(this.w.objectURL);
	          break;
	        // special case for FRAG_PARSING_DATA: data1 and data2 are transferable objects
	        case _events2.default.FRAG_PARSING_DATA:
	          data.data.data1 = new Uint8Array(data.data1);
	          if (data.data2) {
	            data.data.data2 = new Uint8Array(data.data2);
	          }
	        /* falls through */
	        default:
	          data.data = data.data || {};
	          data.data.frag = this.frag;
	          data.data.id = this.id;
	          hls.trigger(data.event, data.data);
	          break;
	      }
	    }
	  }]);
	
	  return Demuxer;
	}();
	
	exports.default = Demuxer;
	module.exports = exports['default'];

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _events = __webpack_require__(3);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _eventHandler = __webpack_require__(5);
	
	var _eventHandler2 = _interopRequireDefault(_eventHandler);
	
	var _errors = __webpack_require__(4);
	
	var _dataTypes = __webpack_require__(36);
	
	var _dataTypes2 = _interopRequireDefault(_dataTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Decrypt key Loader
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */
	
	//import { logger } from '../utils/logger';
	
	
	//Mactrix line added - datatypes are used to signal the type of object in XHR request
	
	var KeyLoader = function (_EventHandler) {
		_inherits(KeyLoader, _EventHandler);
	
		function KeyLoader(hls) {
			_classCallCheck(this, KeyLoader);
	
			var _this = _possibleConstructorReturn(this, (KeyLoader.__proto__ || Object.getPrototypeOf(KeyLoader)).call(this, hls, _events2.default.KEY_LOADING, _events2.default.ERROR));
	
			_this.loaders = {};
			_this.decryptkey = null;
			_this.decrypturl = null;
			return _this;
		}
	
		_createClass(KeyLoader, [{
			key: 'destroy',
			value: function destroy() {
				for (var loaderName in this.loaders) {
					//eslint-disable-line guard-for-in
					var loader = this.loaders[loaderName];
					if (loader) {
						loader.destroy();
					}
				}
				this.loaders = {};
				_eventHandler2.default.prototype.destroy.call(this);
			}
	
			//Mactrix additions start
			//on fatal error, abort all loaders
	
		}, {
			key: 'onError',
			value: function onError(data) {
				if (data.fatal) {
					for (var loaderName in this.loaders) {
						if (this.loaders[loaderName]) {
							this.loaders[loaderName].abort();
						}
					}
				}
			}
			//Mactrix additions end
	
		}, {
			key: 'onKeyLoading',
			value: function onKeyLoading(data) {
				var frag = data.frag;
				var type = frag.type;
				var loader = this.loaders[type];
				var decryptdata = frag.decryptdata;
				var uri = decryptdata.uri;
	
				// if uri is different from previous one or if decrypt key not retrieved yet
				if (uri !== this.decrypturl || this.decryptkey === null) {
					var config = this.hls.config;
	
					if (loader) {
						//logger.warn(`abort previous key loader for type:${type}`);
						loader.abort();
						frag.loader = loader;
					} else {
						frag.loader = this.loaders[type] = new config.loader(config);
					}
	
					this.decrypturl = uri;
					this.decryptkey = null;
	
					var loaderContext = void 0;
					var loaderConfig = void 0;
					var loaderCallbacks = void 0;
					/* mactrix replace
	    		loaderContext = { url : uri, frag : frag, responseType : 'arraybuffer'};
	    */
					loaderContext = { url: uri, frag: frag, responseType: 'arraybuffer', dataType: _dataTypes2.default.KEY }; //Mactrix above line changed, dataType added
					loaderConfig = {
						timeout: config.fragLoadingTimeOut,
						maxRetry: config.fragLoadingMaxRetry,
						retryDelay: config.fragLoadingRetryDelay,
						maxRetryDelay: config.fragLoadingMaxRetryTimeout
					};
	
					loaderCallbacks = { onSuccess: this.loadsuccess.bind(this), onError: this.loaderror.bind(this), onTimeout: this.loadtimeout.bind(this) };
					frag.loader.load(loaderContext, loaderConfig, loaderCallbacks);
				} else if (this.decryptkey) {
					// we already loaded this key, return it
					decryptdata.key = this.decryptkey;
					this.hls.trigger(_events2.default.KEY_LOADED, { frag: frag });
				}
			}
		}, {
			key: 'loadsuccess',
			value: function loadsuccess(response, stats, context) {
				var frag = context.frag;
				this.decryptkey = frag.decryptdata.key = new Uint8Array(response.data);
				// detach fragment loader on load success
				frag.loader = undefined;
				//this.loaders[frag.type] = undefined;
				this.hls.trigger(_events2.default.KEY_LOADED, { frag: frag });
			}
		}, {
			key: 'loaderror',
			value: function loaderror(response, context) {
				var frag = context.frag;
				var loader = frag.loader;
	
				if (loader) {
					loader.abort();
				}
				//this.loaders[context.type] = undefined;
				this.hls.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.NETWORK_ERROR, details: _errors.ErrorDetails.KEY_LOAD_ERROR, fatal: false, frag: frag, response: response });
			}
		}, {
			key: 'loadtimeout',
			value: function loadtimeout(stats, context) {
				var frag = context.frag;
				var loader = frag.loader;
	
				if (loader) {
					loader.abort();
				}
				//this.loaders[context.type] = undefined;
				this.hls.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.NETWORK_ERROR, details: _errors.ErrorDetails.KEY_LOAD_TIMEOUT, fatal: false, frag: frag });
			}
		}]);
	
		return KeyLoader;
	}(_eventHandler2.default);
	
	exports.default = KeyLoader;
	module.exports = exports['default'];

/***/ }),
/* 72 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 *  TimeRanges to string helper
	 */
	
	var TimeRanges = {
		toString: function toString(r) {
			var log = '';
			var len = r.length;
	
			for (var i = 0; i < len; i++) {
				log += '[' + r.start(i).toFixed(3) + ',' + r.end(i).toFixed(3) + ']';
			}
			return log;
		}
	};
	
	module.exports = TimeRanges;

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.fixLineBreaks = undefined;
	
	var _logger = __webpack_require__(1);
	
	var _vttcue = __webpack_require__(140);
	
	var _vttcue2 = _interopRequireDefault(_vttcue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StringDecoder = function StringDecoder() {
		return {
			decode: function decode(data) {
				if (!data) {
					return '';
				}
				if (typeof data !== 'string') {
					throw new Error('Error - expected string data.');
				}
				return decodeURIComponent(encodeURIComponent(data));
			}
		};
	}; //Mactrix line added
	/*
	 * Source: https://github.com/mozilla/vtt.js/blob/master/dist/vtt.js#L1716
	 */
	
	function VTTParser() {
		this.window = window;
		this.state = 'INITIAL';
		this.buffer = '';
		this.decoder = new StringDecoder();
		this.regionList = [];
	}
	
	// Try to parse input as a time stamp.
	function parseTimeStamp(input) {
	
		function computeSeconds(h, m, s, f) {
			return (h | 0) * 3600 + (m | 0) * 60 + (s | 0) + (f | 0) / 1000;
		}
	
		var m = input.match(/^(\d+):(\d{2})(:\d{2})?\.(\d{3})/);
		if (!m) {
			return null;
		}
	
		if (m[3]) {
			// Timestamp takes the form of [hours]:[minutes]:[seconds].[milliseconds]
			return computeSeconds(m[1], m[2], m[3].replace(':', ''), m[4]);
		} else if (m[1] > 59) {
			// Timestamp takes the form of [hours]:[minutes].[milliseconds]
			// First position is hours as it's over 59.
			return computeSeconds(m[1], m[2], 0, m[4]);
		} else {
			// Timestamp takes the form of [minutes]:[seconds].[milliseconds]
			return computeSeconds(0, m[1], m[2], m[4]);
		}
	}
	
	// A settings object holds key/value pairs and will ignore anything but the first
	// assignment to a specific key.
	function Settings() {
		this.values = Object.create(null);
	}
	
	Settings.prototype = {
		// Only accept the first assignment to any key.
		set: function set(k, v) {
			if (!this.get(k) && v !== '') {
				this.values[k] = v;
			}
		},
		// Return the value for a key, or a default value.
		// If 'defaultKey' is passed then 'dflt' is assumed to be an object with
		// a number of possible default values as properties where 'defaultKey' is
		// the key of the property that will be chosen; otherwise it's assumed to be
		// a single value.
		get: function get(k, dflt, defaultKey) {
			if (defaultKey) {
				return this.has(k) ? this.values[k] : dflt[defaultKey];
			}
			return this.has(k) ? this.values[k] : dflt;
		},
		// Check whether we have a value for a key.
		has: function has(k) {
			return k in this.values;
		},
		// Accept a setting if its one of the given alternatives.
		alt: function alt(k, v, a) {
			for (var n = 0; n < a.length; ++n) {
				if (v === a[n]) {
					this.set(k, v);
					break;
				}
			}
		},
		// Accept a setting if its a valid (signed) integer.
		integer: function integer(k, v) {
			if (/^-?\d+$/.test(v)) {
				// integer
				this.set(k, parseInt(v, 10));
			}
		},
		// Accept a setting if its a valid percentage.
		percent: function percent(k, v) {
			var m = v.match(/^([\d]{1,3})(\.[\d]*)?%$/);
	
			if (m) {
				var myV = parseFloat(v);
				if (myV >= 0 && myV <= 100) {
					this.set(k, myV);
					return true;
				}
			}
			return false;
		}
	};
	
	// Helper function to parse input into groups separated by 'groupDelim', and
	// interprete each group as a key/value pair separated by 'keyValueDelim'.
	function parseOptions(input, callback, keyValueDelim, groupDelim) {
		var groups = groupDelim ? input.split(groupDelim) : [input];
		for (var i in groups) {
			if (typeof groups[i] !== 'string') {
				continue;
			}
			var kv = groups[i].split(keyValueDelim);
			if (kv.length !== 2) {
				continue;
			}
			var k = kv[0];
			var v = kv[1];
			callback(k, v);
		}
	}
	
	var defaults = new _vttcue2.default(0, 0, 0);
	// 'middle' was changed to 'center' in the spec: https://github.com/w3c/webvtt/pull/244
	// Chrome and Safari don't yet support this change, but FF does
	var center = defaults.align === 'middle' ? 'middle' : 'center';
	
	function parseCue(input, cue, regionList) {
		// Remember the original input if we need to throw an error.
		var oInput = input;
		// 4.1 WebVTT timestamp
		function consumeTimeStamp() {
			var ts = parseTimeStamp(input);
			if (ts === null) {
				throw new Error('Malformed timestamp: ' + oInput);
			}
			// Remove time stamp from input.
			// se: poor form
			input = input.replace(/^[^\sa-zA-Z-]+/, ''); // eslint-disable-line no-param-reassign
			return ts;
		}
	
		// 4.4.2 WebVTT cue settings
		function consumeCueSettings(input, cue) {
			// eslint-disable-line no-shadow
			var settings = new Settings();
	
			parseOptions(input, function (k, v) {
				switch (k) {
					case 'region':
						// Find the last region we parsed with the same region id.
						for (var i = regionList.length - 1; i >= 0; i--) {
							if (regionList[i].id === v) {
								settings.set(k, regionList[i].region);
								break;
							}
						}
						break;
					case 'vertical':
						settings.alt(k, v, ['rl', 'lr']);
						break;
					case 'line':
						var vals = v.split(',');
						var vals0 = vals[0];
	
						settings.integer(k, vals0);
						if (settings.percent(k, vals0)) {
							settings.set('snapToLines', false);
						}
						settings.alt(k, vals0, ['auto']);
						if (vals.length === 2) {
							settings.alt('lineAlign', vals[1], ['start', center, 'end']);
						}
						break;
					case 'position':
						vals = v.split(',');
						settings.percent(k, vals[0]);
						if (vals.length === 2) {
							settings.alt('positionAlign', vals[1], ['start', center, 'end', 'line-left', 'line-right', 'auto']);
						}
						break;
					case 'size':
						settings.percent(k, v);
						break;
					case 'align':
						settings.alt(k, v, ['start', center, 'end', 'left', 'right']);
						break;
				}
			}, /:/, /\s/);
	
			// Apply default values for any missing fields.
			cue.region = settings.get('region', null);
			cue.vertical = settings.get('vertical', '');
			var line = settings.get('line', 'auto');
			if (line === 'auto' && defaults.line === -1) {
				// set numeric line number for Safari
				line = -1;
			}
			cue.line = line;
			cue.lineAlign = settings.get('lineAlign', 'start');
			cue.snapToLines = settings.get('snapToLines', true);
			cue.size = settings.get('size', 100);
			cue.align = settings.get('align', center);
			var position = settings.get('position', 'auto');
			if (position === 'auto' && defaults.position === 50) {
				// set numeric position for Safari
				// se: poor form.
				position = cue.align === 'start' || cue.align === 'left' ? 0 : cue.align === 'end' || cue.align === 'right' ? 100 : 50; // eslint-disable-line no-nested-ternary
			}
			cue.position = position;
		}
	
		function skipWhitespace() {
			// se: poor form.
			input = input.replace(/^\s+/, ''); // eslint-disable-line no-param-reassign
		}
	
		// 4.1 WebVTT cue timings.
		skipWhitespace();
		cue.startTime = consumeTimeStamp(); // (1) collect cue start time
		skipWhitespace();
		if (input.substr(0, 3) !== '-->') {
			// (3) next characters must match '-->'
			throw new Error('Malformed time stamp (time stamps must be separated by \'-->\'): ' + oInput);
		}
		//se: poor form.
		input = input.substr(3); // eslint-disable-line no-param-reassign
		skipWhitespace();
		cue.endTime = consumeTimeStamp(); // (5) collect cue end time
	
		// 4.1 WebVTT cue settings list.
		skipWhitespace();
		consumeCueSettings(input, cue);
	}
	
	function fixLineBreaks(input) {
		return input.replace(/<br(?: \/)?>/gi, '\n');
	}
	
	VTTParser.prototype = {
		parse: function parse(data) {
			var self = this;
	
			// If there is no data then we won't decode it, but will just try to parse
			// whatever is in buffer already. This may occur in circumstances, for
			// example when flush() is called.
			if (data) {
				// Try to decode the data that we received.
				self.buffer += self.decoder.decode(data, { stream: true });
			}
	
			function collectNextLine() {
				var buffer = self.buffer;
				var pos = 0;
	
				buffer = fixLineBreaks(buffer);
	
				while (pos < buffer.length && buffer[pos] !== '\r' && buffer[pos] !== '\n') {
					++pos;
				}
				var line = buffer.substr(0, pos);
				// Advance the buffer early in case we fail below.
				if (buffer[pos] === '\r') {
					++pos;
				}
				if (buffer[pos] === '\n') {
					++pos;
				}
				self.buffer = buffer.substr(pos);
				return line;
			}
	
			// 3.2 WebVTT metadata header syntax
			function parseHeader(input) {
				parseOptions(input, function (k, v) {
					switch (k) {
						case 'Region':
							// 3.3 WebVTT region metadata header syntax
							/*
	      console.log('parse region', v);
	      */
							_logger.logger.log('parse region', v); //Mactrix line changed
							//parseRegion(v);
							break;
					}
				}, /:/);
			}
	
			// 5.1 WebVTT file parsing.
			try {
				var line;
				if (self.state === 'INITIAL') {
					// We can't start parsing until we have the first line.
					if (!/\r\n|\n/.test(self.buffer)) {
						return this;
					}
	
					line = collectNextLine();
	
					var m = line.match(/^WEBVTT([ \t].*)?$/);
					if (!m || !m[0]) {
						throw new Error('Malformed WebVTT signature.');
					}
	
					self.state = 'HEADER';
				}
	
				var alreadyCollectedLine = false;
				while (self.buffer) {
					// We can't parse a line until we have the full line.
					if (!/\r\n|\n/.test(self.buffer)) {
						return this;
					}
	
					if (!alreadyCollectedLine) {
						line = collectNextLine();
					} else {
						alreadyCollectedLine = false;
					}
	
					switch (self.state) {
						case 'HEADER':
							// 13-18 - Allow a header (metadata) under the WEBVTT line.
							if (/:/.test(line)) {
								parseHeader(line);
							} else if (!line) {
								// An empty line terminates the header and starts the body (cues).
								self.state = 'ID';
							}
							continue;
						case 'NOTE':
							// Ignore NOTE blocks.
							if (!line) {
								self.state = 'ID';
							}
							continue;
						case 'ID':
							// Check for the start of NOTE blocks.
							if (/^NOTE($|[ \t])/.test(line)) {
								self.state = 'NOTE';
								break;
							}
							// 19-29 - Allow any number of line terminators, then initialize new cue values.
							if (!line) {
								continue;
							}
							self.cue = new _vttcue2.default(0, 0, '');
							self.state = 'CUE';
							// 30-39 - Check if self line contains an optional identifier or timing data.
							if (line.indexOf('-->') === -1) {
								self.cue.id = line;
								continue;
							}
						// Process line as start of a cue.
						/* falls through */
						case 'CUE':
							// 40 - Collect cue timings and settings.
							try {
								parseCue(line, self.cue, self.regionList);
							} catch (e) {
								// In case of an error ignore rest of the cue.
								self.cue = null;
								self.state = 'BADCUE';
								continue;
							}
							self.state = 'CUETEXT';
							continue;
						case 'CUETEXT':
							var hasSubstring = line.indexOf('-->') !== -1;
							// 34 - If we have an empty line then report the cue.
							// 35 - If we have the special substring '-->' then report the cue,
							// but do not collect the line as we need to process the current
							// one as a new cue.
							// se: poor form.
							if (!line || hasSubstring && (alreadyCollectedLine = true)) {
								// eslint-disable-line no-cond-assign
								// We are done parsing self cue.
								if (self.oncue) {
									self.oncue(self.cue);
								}
								self.cue = null;
								self.state = 'ID';
								continue;
							}
							if (self.cue.text) {
								self.cue.text += '\n';
							}
							self.cue.text += line;
							continue;
						case 'BADCUE':
							// BADCUE
							// 54-62 - Collect and discard the remaining cue.
							if (!line) {
								self.state = 'ID';
							}
							continue;
					}
				}
			} catch (e) {
	
				// If we are currently parsing a cue, report what we have.
				if (self.state === 'CUETEXT' && self.cue && self.oncue) {
					self.oncue(self.cue);
				}
				self.cue = null;
				// Enter BADWEBVTT state if header was not parsed correctly otherwise
				// another exception occurred so enter BADCUE state.
				self.state = self.state === 'INITIAL' ? 'BADWEBVTT' : 'BADCUE';
			}
			return this;
		},
		flush: function flush() {
			var self = this;
			try {
				// Finish decoding the stream.
				self.buffer += self.decoder.decode();
				// Synthesize the end of the current cue or region.
				if (self.cue || self.state === 'HEADER') {
					self.buffer += '\n\n';
					self.parse();
				}
				// If we've flushed, parsed, and we're still on the INITIAL state then
				// that means we don't have enough of the stream to parse the first
				// line.
				if (self.state === 'INITIAL') {
					throw new Error('Malformed WebVTT signature.');
				}
			} catch (e) {
				throw e;
			}
			if (self.onflush) {
				self.onflush();
			}
			return this;
		}
	};
	
	exports.fixLineBreaks = fixLineBreaks;
	exports.default = VTTParser;

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _events = __webpack_require__(3);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _MactrixDecrypter = __webpack_require__(69);
	
	var _MactrixDecrypter2 = _interopRequireDefault(_MactrixDecrypter);
	
	var _ArrayHelper = __webpack_require__(21);
	
	var _ArrayHelper2 = _interopRequireDefault(_ArrayHelper);
	
	var _muxjs = __webpack_require__(44);
	
	var _muxjs2 = _interopRequireDefault(_muxjs);
	
	var _HlsUtils = __webpack_require__(6);
	
	var _HlsUtils2 = _interopRequireDefault(_HlsUtils);
	
	var _lodash = __webpack_require__(61);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /*  inline demuxer.
	                                                                                                                                                           *   probe fragments and instantiate appropriate demuxer depending on content type (TSDemuxer, AACDemuxer, ...)
	                                                                                                                                                           */
	
	//import {ErrorTypes, ErrorDetails} from '../errors';
	
	
	var Fragment = function Fragment() {
		_classCallCheck(this, Fragment);
	
		this.segments = [];
		this.length = 0;
	};
	
	var MuxJsInline = function () {
		function MuxJsInline(observer, typeSupported, config, vendor, logTube) {
			_classCallCheck(this, MuxJsInline);
	
			this.observer = observer;
			this.vendor = vendor;
			this.typeSupported = typeSupported;
			this.config = config;
			this.videoFragment = new Fragment();
			this.audioFragment = new Fragment();
			this.combinedFragment = new Fragment();
			this.initPts = -1;
			this.remux = false;
			this.resetInitSegment = true;
			this.transmuxer = null;
			this.enableAudio = true;
			this.enableVideo = true;
			this.logTube = logTube;
			this.timeInfoList = [];
			this.pdt = 0;
		}
	
		_createClass(MuxJsInline, [{
			key: 'destroy',
			value: function destroy() {
				this.transmuxer = null;
				this.videoFragment = null;
				this.audioFragment = null;
				this.combinedFragment = null;
			}
		}, {
			key: 'push',
			value: function push(data, decryptdata, initSegment, audioCodec, videoCodec, timeOffset, discontinuity, trackSwitch, seek, duration, accurateTimeOffset, lastFragAborted, pdt) {
	
				if (data.byteLength > 0 && decryptdata != null && decryptdata.key != null && decryptdata.method === 'AES-128') {
					var decrypter = this.decrypter;
					if (decrypter == null) {
						decrypter = this.decrypter = new _MactrixDecrypter2.default(this.observer, this.config);
					}
					var localthis = this;
					// performance.now() not available on WebWorker, at least on Safari Desktop
					var startTime;
					try {
						startTime = performance.now();
					} catch (error) {
						startTime = Date.now();
					}
					decrypter.decrypt(data, decryptdata.key.buffer, decryptdata.iv.buffer, function (decryptedData) {
						var endTime;
						try {
							endTime = performance.now();
						} catch (error) {
							endTime = Date.now();
						}
						localthis.observer.trigger(_events2.default.FRAG_DECRYPTED, { stats: { tstart: startTime, tdecrypt: endTime } });
						localthis.pushDecrypted(_ArrayHelper2.default.makeUint8Array(decryptedData), decryptdata, new Uint8Array(initSegment), audioCodec, videoCodec, timeOffset, discontinuity, trackSwitch, seek, duration, accurateTimeOffset, lastFragAborted, pdt);
					});
				} else {
					this.pushDecrypted(_ArrayHelper2.default.makeUint8Array(data), decryptdata, new Uint8Array([]), audioCodec, videoCodec, timeOffset, discontinuity, trackSwitch, seek, duration, accurateTimeOffset, lastFragAborted, pdt);
				}
			}
		}, {
			key: 'pushDecrypted',
			value: function pushDecrypted(data, decryptdata, initSegment, audioCodec, videoCodec, timeOffset, discontinuity, trackSwitch, seek, duration, gap, lastFragAborted, pdt) {
				var transmuxer = this.transmuxer;
	
				// in case of continuity change, we might switch from content type (AAC container to TS container for example)
				// so let's check that current demuxer is still valid
				if (!transmuxer) {
					var localthis = this;
	
					transmuxer = new _muxjs2.default.mp4.Transmuxer({ remux: this.remux, duration: duration, baseMediaDecodeTime: timeOffset * 90000,
						allowNegativeTFDT: !this.typeSupported.browChrome && !_HlsUtils2.default.isTizen3(), logTube: this.logTube });
	
					transmuxer.on('data', function (event) {
						localthis.onData(event);
					});
	
					transmuxer.on('done', function () {
						localthis.onDone(this.baseMediaDecodeTime);
					});
	
					this.transmuxer = transmuxer;
				}
	
				//ignore gaps on seeks
				if (!seek) {
					//if we have have a gap in the stream, in the case of audio we will fill it with silence (not implemented) or extend the first video frame
					transmuxer.setGapDuration(gap);
				}
	
				/*
	   		if(lastFragAborted === true) {
	   			console.log('# pushDecrypted lastFragAborted: ' + lastFragAborted);
	   			transmuxer.setLastFragAborted(lastFragAborted);
	   		}
	   */
	
				/*
	   		if (seek && gap) {
	   			console.log('# ignore gap on seek: ' + seek + ' : ' + gap);
	   		}
	   */
	
				if (trackSwitch || discontinuity || seek) {
					this.resetInitSegment = true;
	
					//don't reset the time on disco ... this will most likely break metadata and closed captioning across the disco
					//solution is most likely to split setBaseMediaDecodeTime into two functions, one for seek the other for disco
					if ( /*discontinuity ||*/seek) {
						var bmdt = timeOffset * 90000;
	
						var searchPdt = function searchPdt(candidate) {
							var found = void 0;
	
							if (pdt >= candidate.pdt - candidate.variance && pdt <= candidate.pdt + candidate.variance) {
								found = true;
							} else {
								found = false;
							}
	
							return found;
						};
	
						var timeInfo = _lodash2.default.find(this.timeInfoList, searchPdt);
	
						if (timeInfo) {
							bmdt = timeInfo.bmdt;
						}
						//else {
						// the pdt is not in the current list, this means we have seeked or flushed.
						//}
	
						transmuxer.setBaseMediaDecodeTime(bmdt);
	
						this.timeInfoList = [];
					}
				}
	
				this.pdt = pdt;
	
				transmuxer.push(data);
				transmuxer.flush();
			}
		}, {
			key: 'onData',
			value: function onData(event) {
				if (event.type === 'video' && this.enableVideo === true) {
					this.videoFragment.segments.push(event);
					this.videoFragment.length += event.data.length;
				} else if (event.type === 'audio' && this.enableAudio === true) {
					this.audioFragment.segments.push(event);
					this.audioFragment.length += event.data.length;
				} else if (event.type === 'combined') {
					this.combinedFragment.segments.push(event);
					this.combinedFragment.length += event.data.length;
				}
			}
		}, {
			key: 'doInitSegment',
			value: function doInitSegment() {
				var tracks = {};
				var data = { tracks: tracks };
	
				if (this.combinedFragment.length > 0 && !this.combinedFragment.segments[0].duplicate) {
					//if(this.combinedFragment.segments[0].length > 1) {
					//	console.warn('combined fragment contains more than one segment');
					//}
	
					tracks.video = {
						container: 'video/mp4', //videoCodec?
						codec: 'avc1.42e00b', //need to form the codec from the event info
						initSegment: this.combinedFragment.segments[0].initSegment,
						metadata: {
							width: this.combinedFragment.segments[0].info.width,
							height: this.combinedFragment.segments[0].info.height
						}
					};
	
					tracks.audio = {
						container: 'audio/mp4', //audioCodec?
						codec: 'mp4a.40.2', //need to form the codec from the event info
						initSegment: null,
						//remuxedSegments[i].initSegment,//!audioTrack.isAAC && typeSupported.mpeg ? new Uint8Array() : MP4.initSegment([audioTrack]),
						metadata: {
							channelCount: this.combinedFragment.segments[0].audioInfo.channelcount
						}
					};
	
					this.resetInitSegment = false;
				} else {
					if (this.videoFragment.length > 0 && !this.videoFragment.segments[0].duplicate) {
						//if(this.videoFragment.segments[0].length > 1) {
						//	console.warn('video fragment contains more than one segment');
						//}
	
						tracks.video = {
							container: 'video/mp4', //videoCodec?
							codec: 'avc1.42e00b', //need to form the codec from the event info
							initSegment: this.videoFragment.segments[0].initSegment,
							metadata: {
								width: this.videoFragment.segments[0].info.width,
								height: this.videoFragment.segments[0].info.height
							}
						};
	
						this.resetInitSegment = false;
					}
	
					if (this.audioFragment.length > 0 && !this.audioFragment.segments[0].duplicate) {
						//if(this.audioFragment.segments[0].length > 1) {
						//	console.warn('audio fragment contains more than one segment');
						//}
	
						tracks.audio = {
							container: 'audio/mp4', //audioCodec?
							codec: 'mp4a.40.2', //need to form the codec from the event info
							initSegment: this.audioFragment.segments[0].initSegment,
							//!audioTrack.isAAC && typeSupported.mpeg ? new Uint8Array() : MP4.initSegment([audioTrack]),
							metadata: {
								channelCount: this.audioFragment.segments[0].info.channelcount
							}
						};
	
						this.resetInitSegment = false;
					}
				}
	
				if (tracks.audio || tracks.video) {
					this.observer.trigger(_events2.default.FRAG_PARSING_INIT_SEGMENT, data);
				}
			}
		}, {
			key: 'doFrag',
			value: function doFrag(fragment) {
				//stash the correct base media decode time for this fragment, allow a pdt variance of 1/2 a fragment duration.
				this.timeInfoList.push({ pdt: this.pdt, variance: fragment.info.fragmentDuration * 500, bmdt: fragment.info.startTime });
	
				var startTime = fragment.info.startTime / 90e3;
				var endTime = startTime + fragment.info.fragmentDuration;
				var data = {
					data1: fragment.data,
					data2: null, //is ignored
					startPTS: startTime,
					endPTS: endTime,
					startDTS: startTime,
					endDTS: endTime,
					type: fragment.type,
					nb: fragment.info.totalSamples,
					dropped: 0, //dropped
					duplicate: fragment.duplicate,
					dts: fragment.timeStamp
				};
	
				this.observer.trigger(_events2.default.FRAG_PARSING_DATA, data);
			}
		}, {
			key: 'doMetadata',
			value: function doMetadata(metadata) {
				if (metadata.length > 0) {
					//match exactly what hlsjs is throwing out
					var samples = [];
	
					for (var index = 0; index < metadata.length; index++) {
						var sample = { data: null, pts: 0, dts: 0, len: 0 };
						sample.data = metadata[index].data;
						sample.pts = metadata[index].pts;
						sample.dts = metadata[index].dts;
						sample.len = metadata[index].data.length;
						samples.push(sample);
					}
	
					this.observer.trigger(_events2.default.FRAG_PARSING_METADATA, {
						samples: samples
					});
				}
			}
		}, {
			key: 'doCaptions',
			value: function doCaptions(captions) {
				if (captions.length > 0) {
					this.observer.trigger(_events2.default.FRAG_PARSING_USERDATA, {
						samples: captions
					});
				}
			}
		}, {
			key: 'deliverFragment',
			value: function deliverFragment(fragment) {
				this.doFrag(fragment.segments[0]);
				this.doMetadata(fragment.segments[0].metadata);
				this.doCaptions(fragment.segments[0].captions);
	
				fragment.segments = [];
				fragment.length = 0;
			}
		}, {
			key: 'onDone',
			value: function onDone(baseMediaDecodeTime) {
				if (this.initPts !== baseMediaDecodeTime) {
					this.observer.trigger(_events2.default.INIT_PTS_FOUND, { initPTS: baseMediaDecodeTime });
					this.initPts = baseMediaDecodeTime;
				}
	
				//send out the init segment
				if (this.resetInitSegment === true) {
					this.doInitSegment();
				}
	
				//send out the rest of the frag
				if (this.combinedFragment.length > 0) {
					this.deliverFragment(this.combinedFragment);
				} else {
					if (this.videoFragment.length > 0) {
						this.deliverFragment(this.videoFragment);
					}
	
					if (this.audioFragment.length > 0) {
						this.deliverFragment(this.audioFragment);
					}
				}
	
				this.observer.trigger(_events2.default.FRAG_PARSED);
			}
		}]);
	
		return MuxJsInline;
	}();
	
	exports.default = MuxJsInline;
	module.exports = exports['default'];

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _muxjsInline = __webpack_require__(74);
	
	var _muxjsInline2 = _interopRequireDefault(_muxjsInline);
	
	var _events = __webpack_require__(3);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _logger = __webpack_require__(1);
	
	var _events3 = __webpack_require__(60);
	
	var _events4 = _interopRequireDefault(_events3);
	
	var _logTube = __webpack_require__(168);
	
	var _logTube2 = _interopRequireDefault(_logTube);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MuxJsWorker = function MuxJsWorker(self) {
		// observer setup
		var observer = new _events4.default();
		observer.trigger = function trigger(event) {
			for (var _len = arguments.length, data = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
				data[_key - 1] = arguments[_key];
			}
	
			observer.emit.apply(observer, [event, event].concat(data));
		};
	
		observer.off = function off(event) {
			for (var _len2 = arguments.length, data = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
				data[_key2 - 1] = arguments[_key2];
			}
	
			observer.removeListener.apply(observer, [event].concat(data));
		};
	
		var forwardMessage = function forwardMessage(ev, data) {
			self.postMessage({ event: ev, data: data });
		};
	
		self.addEventListener('message', function (ev) {
			var data = ev.data;
			switch (data.cmd) {
				case 'init':
					{
						var config = JSON.parse(data.config);
	
						self.tube.debug = config.debug;
						self.demuxer = new _muxjsInline2.default(observer, data.typeSupported, config, data.vendor, self.tube);
						try {
							(0, _logger.enableLogs)(config.debug === true);
						} catch (err) {}
	
						self.tube.log('MuxJsWorker created (Logs enabled)');
	
						// signal end of worker init
						forwardMessage('init', null);
					}
					break;
				case 'demux':
					self.demuxer.push(data.data, data.decryptdata, data.initSegment, data.audioCodec, data.videoCodec, data.timeOffset, data.discontinuity, data.trackSwitch, data.contiguous, data.duration, data.accurateTimeOffset, data.defaultInitPTS, data.pdt);
					break;
				default:
					break;
			}
		});
	
		// forward events to main thread
		observer.on(_events2.default.FRAG_DECRYPTED, forwardMessage);
		observer.on(_events2.default.FRAG_PARSING_INIT_SEGMENT, forwardMessage);
		observer.on(_events2.default.FRAG_PARSED, forwardMessage);
		observer.on(_events2.default.ERROR, forwardMessage);
		observer.on(_events2.default.FRAG_PARSING_METADATA, forwardMessage);
		observer.on(_events2.default.FRAG_PARSING_USERDATA, forwardMessage);
		observer.on(_events2.default.INIT_PTS_FOUND, forwardMessage);
		observer.on(_events2.default.LOGTUBE_LOG, forwardMessage);
	
		// special case for FRAG_PARSING_DATA: pass data1/data2 as transferable object (no copy)
		observer.on(_events2.default.FRAG_PARSING_DATA, function (ev, data) {
			var transferable = [];
			var message = { event: ev, data: data };
			if (data.data1) {
				message.data1 = data.data1.buffer;
				transferable.push(data.data1.buffer);
				delete data.data1;
			}
			if (data.data2) {
				message.data2 = data.data2.buffer;
				transferable.push(data.data2.buffer);
				delete data.data2;
			}
			self.postMessage(message, transferable);
		});
	
		self.tube = new _logTube2.default({ debug: true, event: _events2.default.LOGTUBE_LOG }, { eventEmitter: observer });
	}; /* demuxer web worker.
	    *  - listen to worker message, and trigger MuxJsInline upon reception of Fragments.
	    *  - provides MP4 Boxes back to main thread using [transferable objects](https://developers.google.com/web/updates/2011/12/Transferable-Objects-Lightning-Fast) in order to minimize message passing overhead.
	    */
	
	exports.default = MuxJsWorker;
	module.exports = exports['default'];

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * mux.js
	 *
	 * Copyright (c) 2016 Brightcove
	 * All rights reserved.
	 *
	 * Accepts program elementary stream (PES) data events and corrects
	 * decode and presentation time stamps to account for a rollover
	 * of the 33 bit value.
	 */
	
	'use strict';
	
	var Stream = __webpack_require__(11);
	
	var MAX_TS = 8589934592;
	
	var RO_THRESH = 4294967296;
	
	var handleRollover = function handleRollover(value, reference) {
	  var direction = 1;
	
	  if (value > reference) {
	    // If the current timestamp value is greater than our reference timestamp and we detect a
	    // timestamp rollover, this means the roll over is happening in the opposite direction.
	    // Example scenario: Enter a long stream/video just after a rollover occurred. The reference
	    // point will be set to a small number, e.g. 1. The user then seeks backwards over the
	    // rollover point. In loading this segment, the timestamp values will be very large,
	    // e.g. 2^33 - 1. Since this comes before the data we loaded previously, we want to adjust
	    // the time stamp to be `value - 2^33`.
	    direction = -1;
	  }
	
	  // Note: A seek forwards or back that is greater than the RO_THRESH (2^32, ~13 hours) will
	  // cause an incorrect adjustment.
	  while (Math.abs(reference - value) > RO_THRESH) {
	    value += direction * MAX_TS;
	  }
	
	  return value;
	};
	
	var TimestampRolloverStream = function TimestampRolloverStream(type) {
	  var lastDTS, referenceDTS;
	
	  TimestampRolloverStream.prototype.init.call(this);
	
	  this.type_ = type;
	
	  this.push = function (data) {
	    if (data.type !== this.type_) {
	      return;
	    }
	
	    //Mactrix changes begin: if we are dealing with remaining data, pts/dts will be undefined
	    if (data.dts !== undefined && data.pts !== undefined) {
	      //Mactrix changes end
	      if (referenceDTS === undefined) {
	        referenceDTS = data.dts;
	      }
	
	      data.dts = handleRollover(data.dts, referenceDTS);
	      data.pts = handleRollover(data.pts, referenceDTS);
	
	      lastDTS = data.dts;
	      //Mactrix changes begin
	    }
	    //Mactrix changes end
	    this.trigger('data', data);
	  };
	
	  this.flush = function () {
	    referenceDTS = lastDTS;
	    this.trigger('done');
	  };
	};
	
	TimestampRolloverStream.prototype = new Stream();
	
	module.exports = {
	  TimestampRolloverStream: TimestampRolloverStream,
	  handleRollover: handleRollover
	};

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _HlsUtils = __webpack_require__(6);
	
	var _HlsUtils2 = _interopRequireDefault(_HlsUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//Mactrix line added, need browser detection for a Tizen-specific fix
	'use strict'; /**
	               * mux.js
	               *
	               * Copyright (c) 2015 Brightcove
	               * All rights reserved.
	               *
	               * Functions that generate fragmented MP4s suitable for use with Media
	               * Source Extensions.
	               */
	
	
	var UINT32_MAX = Math.pow(2, 32) - 1;
	
	var ONE_SECOND_IN_TS = 90000; //Mactrix line added 90kHz clock for compatibility with transmuxer.js
	
	var box, dinf, esds, ftyp, mdat, mfhd, minf, moof, moov, mvex, mvhd, trak, tkhd, mdia, mdhd, hdlr, sdtp, stbl, stsd, traf, trex, trun, types, MAJOR_BRAND, MINOR_VERSION, AVC1_BRAND, VIDEO_HDLR, AUDIO_HDLR, HDLR_TYPES, VMHD, SMHD, DREF, STCO, STSC, STSZ, STTS;
	
	// pre-calculate constants
	(function () {
	  var i;
	  types = {
	    avc1: [], // codingname
	    avcC: [],
	    btrt: [],
	    dinf: [],
	    dref: [],
	    esds: [],
	    ftyp: [],
	    hdlr: [],
	    mdat: [],
	    mdhd: [],
	    mdia: [],
	    mfhd: [],
	    minf: [],
	    moof: [],
	    moov: [],
	    mp4a: [], // codingname
	    mvex: [],
	    mvhd: [],
	    sdtp: [],
	    smhd: [],
	    stbl: [],
	    stco: [],
	    stsc: [],
	    stsd: [],
	    stsz: [],
	    stts: [],
	    styp: [],
	    tfdt: [],
	    tfhd: [],
	    traf: [],
	    trak: [],
	    trun: [],
	    trex: [],
	    tkhd: [],
	    vmhd: []
	  };
	
	  // In environments where Uint8Array is undefined (e.g., IE8), skip set up so that we
	  // don't throw an error
	  if (typeof Uint8Array === 'undefined') {
	    return;
	  }
	
	  for (i in types) {
	    if (types.hasOwnProperty(i)) {
	      types[i] = [i.charCodeAt(0), i.charCodeAt(1), i.charCodeAt(2), i.charCodeAt(3)];
	    }
	  }
	
	  MAJOR_BRAND = new Uint8Array(['i'.charCodeAt(0), 's'.charCodeAt(0), 'o'.charCodeAt(0), 'm'.charCodeAt(0)]);
	  AVC1_BRAND = new Uint8Array(['a'.charCodeAt(0), 'v'.charCodeAt(0), 'c'.charCodeAt(0), '1'.charCodeAt(0)]);
	  MINOR_VERSION = new Uint8Array([0, 0, 0, 1]);
	  VIDEO_HDLR = new Uint8Array([0x00, // version 0
	  0x00, 0x00, 0x00, // flags
	  0x00, 0x00, 0x00, 0x00, // pre_defined
	  0x76, 0x69, 0x64, 0x65, // handler_type: 'vide'
	  0x00, 0x00, 0x00, 0x00, // reserved
	  0x00, 0x00, 0x00, 0x00, // reserved
	  0x00, 0x00, 0x00, 0x00, // reserved
	  0x56, 0x69, 0x64, 0x65, 0x6f, 0x48, 0x61, 0x6e, 0x64, 0x6c, 0x65, 0x72, 0x00 // name: 'VideoHandler'
	  ]);
	  AUDIO_HDLR = new Uint8Array([0x00, // version 0
	  0x00, 0x00, 0x00, // flags
	  0x00, 0x00, 0x00, 0x00, // pre_defined
	  0x73, 0x6f, 0x75, 0x6e, // handler_type: 'soun'
	  0x00, 0x00, 0x00, 0x00, // reserved
	  0x00, 0x00, 0x00, 0x00, // reserved
	  0x00, 0x00, 0x00, 0x00, // reserved
	  0x53, 0x6f, 0x75, 0x6e, 0x64, 0x48, 0x61, 0x6e, 0x64, 0x6c, 0x65, 0x72, 0x00 // name: 'SoundHandler'
	  ]);
	  HDLR_TYPES = {
	    video: VIDEO_HDLR,
	    audio: AUDIO_HDLR
	  };
	  DREF = new Uint8Array([0x00, // version 0
	  0x00, 0x00, 0x00, // flags
	  0x00, 0x00, 0x00, 0x01, // entry_count
	  0x00, 0x00, 0x00, 0x0c, // entry_size
	  0x75, 0x72, 0x6c, 0x20, // 'url' type
	  0x00, // version 0
	  0x00, 0x00, 0x01 // entry_flags
	  ]);
	  SMHD = new Uint8Array([0x00, // version
	  0x00, 0x00, 0x00, // flags
	  0x00, 0x00, // balance, 0 means centered
	  0x00, 0x00 // reserved
	  ]);
	  STCO = new Uint8Array([0x00, // version
	  0x00, 0x00, 0x00, // flags
	  0x00, 0x00, 0x00, 0x00 // entry_count
	  ]);
	  STSC = STCO;
	  STSZ = new Uint8Array([0x00, // version
	  0x00, 0x00, 0x00, // flags
	  0x00, 0x00, 0x00, 0x00, // sample_size
	  0x00, 0x00, 0x00, 0x00 // sample_count
	  ]);
	  STTS = STCO;
	  VMHD = new Uint8Array([0x00, // version
	  0x00, 0x00, 0x01, // flags
	  0x00, 0x00, // graphicsmode
	  0x00, 0x00, 0x00, 0x00, 0x00, 0x00 // opcolor
	  ]);
	})();
	
	box = function box(type) {
	  var payload = [],
	      size = 0,
	      i,
	      result,
	      view;
	
	  for (i = 1; i < arguments.length; i++) {
	    payload.push(arguments[i]);
	  }
	
	  i = payload.length;
	
	  // calculate the total size we need to allocate
	  while (i--) {
	    size += payload[i].byteLength;
	  }
	  result = new Uint8Array(size + 8);
	  view = new DataView(result.buffer, result.byteOffset, result.byteLength);
	  view.setUint32(0, result.byteLength);
	  result.set(type, 4);
	
	  // copy the payload into the result
	  for (i = 0, size = 8; i < payload.length; i++) {
	    result.set(payload[i], size);
	    size += payload[i].byteLength;
	  }
	  return result;
	};
	
	dinf = function dinf() {
	  return box(types.dinf, box(types.dref, DREF));
	};
	
	esds = function esds(track) {
	  return box(types.esds, new Uint8Array([0x00, // version
	  0x00, 0x00, 0x00, // flags
	
	  // ES_Descriptor
	  0x03, // tag, ES_DescrTag
	  0x19, // length
	  0x00, 0x00, // ES_ID
	  0x00, // streamDependenceFlag, URL_flag, reserved, streamPriority
	
	  // DecoderConfigDescriptor
	  0x04, // tag, DecoderConfigDescrTag
	  0x11, // length
	  0x40, // object type
	  0x15, // streamType
	  0x00, 0x06, 0x00, // bufferSizeDB
	  0x00, 0x00, 0xda, 0xc0, // maxBitrate
	  0x00, 0x00, 0xda, 0xc0, // avgBitrate
	
	  // DecoderSpecificInfo
	  0x05, // tag, DecoderSpecificInfoTag
	  0x02, // length
	  // ISO/IEC 14496-3, AudioSpecificConfig
	  // for samplingFrequencyIndex see ISO/IEC 13818-7:2006, 8.1.3.2.2, Table 35
	  track.audioobjecttype << 3 | track.samplingfrequencyindex >>> 1, track.samplingfrequencyindex << 7 | track.channelcount << 3, 0x06, 0x01, 0x02 // GASpecificConfig
	  ]));
	};
	
	ftyp = function ftyp() {
	  return box(types.ftyp, MAJOR_BRAND, MINOR_VERSION, MAJOR_BRAND, AVC1_BRAND);
	};
	
	hdlr = function hdlr(type) {
	  return box(types.hdlr, HDLR_TYPES[type]);
	};
	mdat = function mdat(data) {
	  return box(types.mdat, data);
	};
	mdhd = function mdhd(track) {
	  var result = new Uint8Array([0x00, // version 0
	  0x00, 0x00, 0x00, // flags
	  0x00, 0x00, 0x00, 0x02, // creation_time
	  0x00, 0x00, 0x00, 0x03, // modification_time
	  0x00, 0x01, 0x5f, 0x90, // timescale, 90,000 "ticks" per second
	
	  track.duration >>> 24 & 0xFF, track.duration >>> 16 & 0xFF, track.duration >>> 8 & 0xFF, track.duration & 0xFF, // duration
	  0x55, 0xc4, // 'und' language (undetermined)
	  0x00, 0x00]);
	
	  // Use the sample rate from the track metadata, when it is
	  // defined. The sample rate can be parsed out of an ADTS header, for
	  // instance.
	  if (track.samplerate) {
	    result[12] = track.samplerate >>> 24 & 0xFF;
	    result[13] = track.samplerate >>> 16 & 0xFF;
	    result[14] = track.samplerate >>> 8 & 0xFF;
	    result[15] = track.samplerate & 0xFF;
	  }
	
	  return box(types.mdhd, result);
	};
	mdia = function mdia(track) {
	  return box(types.mdia, mdhd(track), hdlr(track.type), minf(track));
	};
	mfhd = function mfhd(sequenceNumber) {
	  return box(types.mfhd, new Uint8Array([0x00, 0x00, 0x00, 0x00, // flags
	  (sequenceNumber & 0xFF000000) >> 24, (sequenceNumber & 0xFF0000) >> 16, (sequenceNumber & 0xFF00) >> 8, sequenceNumber & 0xFF // sequence_number
	  ]));
	};
	minf = function minf(track) {
	  return box(types.minf, track.type === 'video' ? box(types.vmhd, VMHD) : box(types.smhd, SMHD), dinf(), stbl(track));
	};
	moof = function moof(sequenceNumber, tracks) {
	  var trackFragments = [],
	      i = tracks.length;
	  // build traf boxes for each track fragment
	  while (i--) {
	    trackFragments[i] = traf(tracks[i]);
	  }
	  return box.apply(null, [types.moof, mfhd(sequenceNumber)].concat(trackFragments));
	};
	/**
	 * Returns a movie box.
	 * @param tracks {array} the tracks associated with this movie
	 * @see ISO/IEC 14496-12:2012(E), section 8.2.1
	 */
	moov = function moov(tracks) {
	  var i = tracks.length,
	
	  //Mactrix changes begin: use the shortest duration of all tracks added
	  //						 since this is coming from the hls manifest it should be constant
	  duration = 0xffffffff,
	      timescale = ONE_SECOND_IN_TS,
	
	  //Mactrix changes end
	  boxes = [];
	
	  while (i--) {
	    //Mactrix changes begin - use the shortest duration regardless of samplerate
	    if (tracks[i].duration / tracks[i].timescale < duration) {
	      duration = tracks[i].duration;
	      timescale = tracks[i].timescale;
	    }
	    //Mactrix changes end
	    boxes[i] = trak(tracks[i]);
	  }
	  /* Mactrix replace:
	    return box.apply(null, [types.moov, mvhd(0xffffffff)].concat(boxes).concat(mvex(tracks)));
	  */
	  //Mactrix changes start: need to have a valid duration in the mvhd for safari
	  return box.apply(null, [types.moov, mvhd(duration, timescale)].concat(boxes).concat(mvex(tracks)));
	  //Mactrix changes end
	};
	mvex = function mvex(tracks) {
	  var i = tracks.length,
	      boxes = [];
	
	  while (i--) {
	    boxes[i] = trex(tracks[i]);
	  }
	  return box.apply(null, [types.mvex].concat(boxes));
	};
	/* Mactrix replace:
	mvhd = function(duration) {
	*/
	//Mactrix changes start: need to have a configurable timescale
	mvhd = function mvhd(duration, timescale) {
	  //Mactrix changes end
	  var bytes = new Uint8Array([0x00, // version 0
	  0x00, 0x00, 0x00, // flags
	  0x00, 0x00, 0x00, 0x01, // creation_time
	  0x00, 0x00, 0x00, 0x02, // modification_time
	  /* Mactrix replace:
	        0x00, 0x01, 0x5f, 0x90, // timescale, 90,000 "ticks" per second
	  */
	  //Mactrix changes start: need to have a configurable timescale
	  (timescale & 0xFF000000) >> 24, (timescale & 0xFF0000) >> 16, (timescale & 0xFF00) >> 8, timescale & 0xFF, // timescale
	  //Mactrix changes end
	  (duration & 0xFF000000) >> 24, (duration & 0xFF0000) >> 16, (duration & 0xFF00) >> 8, duration & 0xFF, // duration
	  0x00, 0x01, 0x00, 0x00, // 1.0 rate
	  0x01, 0x00, // 1.0 volume
	  0x00, 0x00, // reserved
	  0x00, 0x00, 0x00, 0x00, // reserved
	  0x00, 0x00, 0x00, 0x00, // reserved
	  0x00, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x40, 0x00, 0x00, 0x00, // transformation: unity matrix
	  0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, // pre_defined
	  0xff, 0xff, 0xff, 0xff // next_track_ID
	  ]);
	  return box(types.mvhd, bytes);
	};
	
	sdtp = function sdtp(track) {
	  var samples = track.samples || [],
	      bytes = new Uint8Array(4 + samples.length),
	      flags,
	      i;
	
	  // leave the full box header (4 bytes) all zero
	
	  // write the sample table
	  for (i = 0; i < samples.length; i++) {
	    flags = samples[i].flags;
	
	    bytes[i + 4] = flags.dependsOn << 4 | flags.isDependedOn << 2 | flags.hasRedundancy;
	  }
	
	  return box(types.sdtp, bytes);
	};
	
	stbl = function stbl(track) {
	  return box(types.stbl, stsd(track), box(types.stts, STTS), box(types.stsc, STSC), box(types.stsz, STSZ), box(types.stco, STCO));
	};
	
	(function () {
	  var videoSample, audioSample;
	
	  stsd = function stsd(track) {
	
	    return box(types.stsd, new Uint8Array([0x00, // version 0
	    0x00, 0x00, 0x00, // flags
	    0x00, 0x00, 0x00, 0x01]), track.type === 'video' ? videoSample(track) : audioSample(track));
	  };
	
	  videoSample = function videoSample(track) {
	    var sps = track.sps || [],
	        pps = track.pps || [],
	        sequenceParameterSets = [],
	        pictureParameterSets = [],
	        i;
	
	    // assemble the SPSs
	    for (i = 0; i < sps.length; i++) {
	      sequenceParameterSets.push((sps[i].byteLength & 0xFF00) >>> 8);
	      sequenceParameterSets.push(sps[i].byteLength & 0xFF); // sequenceParameterSetLength
	      sequenceParameterSets = sequenceParameterSets.concat(Array.prototype.slice.call(sps[i])); // SPS
	    }
	
	    // assemble the PPSs
	    for (i = 0; i < pps.length; i++) {
	      pictureParameterSets.push((pps[i].byteLength & 0xFF00) >>> 8);
	      pictureParameterSets.push(pps[i].byteLength & 0xFF);
	      pictureParameterSets = pictureParameterSets.concat(Array.prototype.slice.call(pps[i]));
	    }
	
	    return box(types.avc1, new Uint8Array([0x00, 0x00, 0x00, 0x00, 0x00, 0x00, // reserved
	    0x00, 0x01, // data_reference_index
	    0x00, 0x00, // pre_defined
	    0x00, 0x00, // reserved
	    0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, // pre_defined
	    (track.width & 0xff00) >> 8, track.width & 0xff, // width
	    (track.height & 0xff00) >> 8, track.height & 0xff, // height
	    0x00, 0x48, 0x00, 0x00, // horizresolution
	    0x00, 0x48, 0x00, 0x00, // vertresolution
	    0x00, 0x00, 0x00, 0x00, // reserved
	    0x00, 0x01, // frame_count
	    0x13, 0x76, 0x69, 0x64, 0x65, 0x6f, 0x6a, 0x73, 0x2d, 0x63, 0x6f, 0x6e, 0x74, 0x72, 0x69, 0x62, 0x2d, 0x68, 0x6c, 0x73, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, // compressorname
	    0x00, 0x18, // depth = 24
	    0x11, 0x11 // pre_defined = -1
	    ]), box(types.avcC, new Uint8Array([0x01, // configurationVersion
	    track.profileIdc, // AVCProfileIndication
	    track.profileCompatibility, // profile_compatibility
	    track.levelIdc, // AVCLevelIndication
	    0xff // lengthSizeMinusOne, hard-coded to 4 bytes
	    ].concat([sps.length // numOfSequenceParameterSets
	    ]).concat(sequenceParameterSets).concat([pps.length // numOfPictureParameterSets
	    ]).concat(pictureParameterSets))), // "PPS"
	    box(types.btrt, new Uint8Array([0x00, 0x1c, 0x9c, 0x80, // bufferSizeDB
	    0x00, 0x2d, 0xc6, 0xc0, // maxBitrate
	    0x00, 0x2d, 0xc6, 0xc0])) // avgBitrate
	    );
	  };
	
	  audioSample = function audioSample(track) {
	    return box(types.mp4a, new Uint8Array([
	
	    // SampleEntry, ISO/IEC 14496-12
	    0x00, 0x00, 0x00, 0x00, 0x00, 0x00, // reserved
	    0x00, 0x01, // data_reference_index
	
	    // AudioSampleEntry, ISO/IEC 14496-12
	    0x00, 0x00, 0x00, 0x00, // reserved
	    0x00, 0x00, 0x00, 0x00, // reserved
	    (track.channelcount & 0xff00) >> 8, track.channelcount & 0xff, // channelcount
	
	    (track.samplesize & 0xff00) >> 8, track.samplesize & 0xff, // samplesize
	    0x00, 0x00, // pre_defined
	    0x00, 0x00, // reserved
	
	    (track.samplerate & 0xff00) >> 8, track.samplerate & 0xff, 0x00, 0x00 // samplerate, 16.16
	
	    // MP4AudioSampleEntry, ISO/IEC 14496-14
	    ]), esds(track));
	  };
	})();
	
	tkhd = function tkhd(track) {
	  var result = new Uint8Array([0x00, // version 0
	  0x00, 0x00, 0x07, // flags
	  0x00, 0x00, 0x00, 0x00, // creation_time
	  0x00, 0x00, 0x00, 0x00, // modification_time
	  (track.id & 0xFF000000) >> 24, (track.id & 0xFF0000) >> 16, (track.id & 0xFF00) >> 8, track.id & 0xFF, // track_ID
	  0x00, 0x00, 0x00, 0x00, // reserved
	  (track.duration & 0xFF000000) >> 24, (track.duration & 0xFF0000) >> 16, (track.duration & 0xFF00) >> 8, track.duration & 0xFF, // duration
	  0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, // reserved
	  0x00, 0x00, // layer
	  0x00, 0x00, // alternate_group
	  0x01, 0x00, // non-audio track volume
	  0x00, 0x00, // reserved
	  0x00, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x40, 0x00, 0x00, 0x00, // transformation: unity matrix
	  (track.width & 0xFF00) >> 8, track.width & 0xFF, 0x00, 0x00, // width
	  (track.height & 0xFF00) >> 8, track.height & 0xFF, 0x00, 0x00 // height
	  ]);
	
	  return box(types.tkhd, result);
	};
	
	/**
	 * Generate a track fragment (traf) box. A traf box collects metadata
	 * about tracks in a movie fragment (moof) box.
	 */
	traf = function traf(track) {
	  var trackFragmentHeader, trackFragmentDecodeTime, trackFragmentRun, sampleDependencyTable, dataOffset, upperWordBaseMediaDecodeTime, lowerWordBaseMediaDecodeTime;
	
	  trackFragmentHeader = box(types.tfhd, new Uint8Array([0x00, // version 0
	  0x00, 0x00, 0x3a, // flags
	  (track.id & 0xFF000000) >> 24, (track.id & 0xFF0000) >> 16, (track.id & 0xFF00) >> 8, track.id & 0xFF, // track_ID
	  0x00, 0x00, 0x00, 0x01, // sample_description_index
	  0x00, 0x00, 0x00, 0x00, // default_sample_duration
	  0x00, 0x00, 0x00, 0x00, // default_sample_size
	  0x00, 0x00, 0x00, 0x00 // default_sample_flags
	  ]));
	
	  upperWordBaseMediaDecodeTime = Math.floor(track.baseMediaDecodeTime / (UINT32_MAX + 1));
	  lowerWordBaseMediaDecodeTime = Math.floor(track.baseMediaDecodeTime % (UINT32_MAX + 1));
	
	  trackFragmentDecodeTime = box(types.tfdt, new Uint8Array([0x01, // version 1
	  0x00, 0x00, 0x00, // flags
	  // baseMediaDecodeTime
	  upperWordBaseMediaDecodeTime >>> 24 & 0xFF, upperWordBaseMediaDecodeTime >>> 16 & 0xFF, upperWordBaseMediaDecodeTime >>> 8 & 0xFF, upperWordBaseMediaDecodeTime & 0xFF, lowerWordBaseMediaDecodeTime >>> 24 & 0xFF, lowerWordBaseMediaDecodeTime >>> 16 & 0xFF, lowerWordBaseMediaDecodeTime >>> 8 & 0xFF, lowerWordBaseMediaDecodeTime & 0xFF]));
	
	  // the data offset specifies the number of bytes from the start of
	  // the containing moof to the first payload byte of the associated
	  // mdat
	  dataOffset = 32 + // tfhd
	  20 + // tfdt
	  8 + // traf header
	  16 + // mfhd
	  8 + // moof header
	  8; // mdat header
	
	  // audio tracks require less metadata
	  if (track.type === 'audio') {
	    trackFragmentRun = trun(track, dataOffset);
	    return box(types.traf, trackFragmentHeader, trackFragmentDecodeTime, trackFragmentRun);
	  }
	
	  // video tracks should contain an independent and disposable samples
	  // box (sdtp)
	  // generate one and adjust offsets to match
	  sampleDependencyTable = sdtp(track);
	  trackFragmentRun = trun(track, sampleDependencyTable.length + dataOffset);
	  return box(types.traf, trackFragmentHeader, trackFragmentDecodeTime, trackFragmentRun, sampleDependencyTable);
	};
	
	/**
	 * Generate a track box.
	 * @param track {object} a track definition
	 * @return {Uint8Array} the track box
	 */
	trak = function trak(track) {
	  /*
	   track.duration = track.duration || 0xffffffff;
	   */
	  //Mactrix changes start
	  //fix duration bug in Tizen
	  if (_HlsUtils2.default.isTizen2()) {
	    track.duration = track.duration / 1000 || 0xffffffff;
	  } else {
	    track.duration = track.duration || 0xffffffff; //Not used for starting duration for Edge/Chrome/Firefox
	  }
	  //Mactrix changes end
	  return box(types.trak, tkhd(track), mdia(track));
	};
	
	trex = function trex(track) {
	  var result = new Uint8Array([0x00, // version 0
	  0x00, 0x00, 0x00, // flags
	  (track.id & 0xFF000000) >> 24, (track.id & 0xFF0000) >> 16, (track.id & 0xFF00) >> 8, track.id & 0xFF, // track_ID
	  0x00, 0x00, 0x00, 0x01, // default_sample_description_index
	  0x00, 0x00, 0x00, 0x00, // default_sample_duration
	  0x00, 0x00, 0x00, 0x00, // default_sample_size
	  0x00, 0x01, 0x00, 0x01 // default_sample_flags
	  ]);
	  // the last two bytes of default_sample_flags is the sample
	  // degradation priority, a hint about the importance of this sample
	  // relative to others. Lower the degradation priority for all sample
	  // types other than video.
	  if (track.type !== 'video') {
	    result[result.length - 1] = 0x00;
	  }
	
	  return box(types.trex, result);
	};
	
	(function () {
	  var audioTrun, videoTrun, trunHeader;
	
	  // This method assumes all samples are uniform. That is, if a
	  // duration is present for the first sample, it will be present for
	  // all subsequent samples.
	  // see ISO/IEC 14496-12:2012, Section 8.8.8.1
	  trunHeader = function trunHeader(samples, offset) {
	    var durationPresent = 0,
	        sizePresent = 0,
	        flagsPresent = 0,
	        compositionTimeOffset = 0;
	
	    // trun flag constants
	    if (samples.length) {
	      if (samples[0].duration !== undefined) {
	        durationPresent = 0x1;
	      }
	      if (samples[0].size !== undefined) {
	        sizePresent = 0x2;
	      }
	      if (samples[0].flags !== undefined) {
	        flagsPresent = 0x4;
	      }
	      if (samples[0].compositionTimeOffset !== undefined) {
	        compositionTimeOffset = 0x8;
	      }
	    }
	
	    return [0x00, // version 0
	    0x00, durationPresent | sizePresent | flagsPresent | compositionTimeOffset, 0x01, // flags
	    (samples.length & 0xFF000000) >>> 24, (samples.length & 0xFF0000) >>> 16, (samples.length & 0xFF00) >>> 8, samples.length & 0xFF, // sample_count
	    (offset & 0xFF000000) >>> 24, (offset & 0xFF0000) >>> 16, (offset & 0xFF00) >>> 8, offset & 0xFF // data_offset
	    ];
	  };
	
	  videoTrun = function videoTrun(track, offset) {
	    var bytes, samples, sample, i;
	
	    samples = track.samples || [];
	    offset += 8 + 12 + 16 * samples.length;
	
	    bytes = trunHeader(samples, offset);
	
	    for (i = 0; i < samples.length; i++) {
	      sample = samples[i];
	      bytes = bytes.concat([(sample.duration & 0xFF000000) >>> 24, (sample.duration & 0xFF0000) >>> 16, (sample.duration & 0xFF00) >>> 8, sample.duration & 0xFF, // sample_duration
	      (sample.size & 0xFF000000) >>> 24, (sample.size & 0xFF0000) >>> 16, (sample.size & 0xFF00) >>> 8, sample.size & 0xFF, // sample_size
	      sample.flags.isLeading << 2 | sample.flags.dependsOn, sample.flags.isDependedOn << 6 | sample.flags.hasRedundancy << 4 | sample.flags.paddingValue << 1 | sample.flags.isNonSyncSample, sample.flags.degradationPriority & 0xF0 << 8, sample.flags.degradationPriority & 0x0F, // sample_flags
	      (sample.compositionTimeOffset & 0xFF000000) >>> 24, (sample.compositionTimeOffset & 0xFF0000) >>> 16, (sample.compositionTimeOffset & 0xFF00) >>> 8, sample.compositionTimeOffset & 0xFF // sample_composition_time_offset
	      ]);
	    }
	    return box(types.trun, new Uint8Array(bytes));
	  };
	
	  audioTrun = function audioTrun(track, offset) {
	    var bytes, samples, sample, i;
	
	    samples = track.samples || [];
	    offset += 8 + 12 + 8 * samples.length;
	
	    bytes = trunHeader(samples, offset);
	
	    for (i = 0; i < samples.length; i++) {
	      sample = samples[i];
	      bytes = bytes.concat([(sample.duration & 0xFF000000) >>> 24, (sample.duration & 0xFF0000) >>> 16, (sample.duration & 0xFF00) >>> 8, sample.duration & 0xFF, // sample_duration
	      (sample.size & 0xFF000000) >>> 24, (sample.size & 0xFF0000) >>> 16, (sample.size & 0xFF00) >>> 8, sample.size & 0xFF]); // sample_size
	    }
	
	    return box(types.trun, new Uint8Array(bytes));
	  };
	
	  trun = function trun(track, offset) {
	    if (track.type === 'audio') {
	      return audioTrun(track, offset);
	    }
	
	    return videoTrun(track, offset);
	  };
	})();
	
	module.exports = {
	  ftyp: ftyp,
	  mdat: mdat,
	  moof: moof,
	  moov: moov,
	  initSegment: function initSegment(tracks) {
	    var fileType = ftyp(),
	        movie = moov(tracks),
	        result;
	
	    result = new Uint8Array(fileType.byteLength + movie.byteLength);
	    result.set(fileType);
	    result.set(movie, fileType.byteLength);
	    return result;
	  }
	};

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(98);
	__webpack_require__(196);
	__webpack_require__(194);
	__webpack_require__(200);
	__webpack_require__(197);
	__webpack_require__(203);
	__webpack_require__(205);
	__webpack_require__(193);
	__webpack_require__(199);
	__webpack_require__(190);
	__webpack_require__(204);
	__webpack_require__(188);
	__webpack_require__(202);
	__webpack_require__(201);
	__webpack_require__(195);
	__webpack_require__(198);
	__webpack_require__(187);
	__webpack_require__(189);
	__webpack_require__(192);
	__webpack_require__(191);
	__webpack_require__(206);
	__webpack_require__(97);
	__webpack_require__(211);
	__webpack_require__(209);
	__webpack_require__(210);
	module.exports = __webpack_require__(18).Array;


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(207);
	__webpack_require__(98);
	__webpack_require__(214);
	__webpack_require__(208);
	__webpack_require__(212);
	__webpack_require__(213);
	module.exports = __webpack_require__(18).Promise;


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	var aFunction = __webpack_require__(15);
	var toObject = __webpack_require__(12);
	var IObject = __webpack_require__(38);
	var toLength = __webpack_require__(9);
	
	module.exports = function (that, callbackfn, aLen, memo, isRight) {
	  aFunction(callbackfn);
	  var O = toObject(that);
	  var self = IObject(O);
	  var length = toLength(O.length);
	  var index = isRight ? length - 1 : 0;
	  var i = isRight ? -1 : 1;
	  if (aLen < 2) for (;;) {
	    if (index in self) {
	      memo = self[index];
	      index += i;
	      break;
	    }
	    index += i;
	    if (isRight ? index < 0 : length <= index) {
	      throw TypeError('Reduce of empty array with no initial value');
	    }
	  }
	  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
	    memo = callbackfn(memo, self[index], index, O);
	  }
	  return memo;
	};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(29);
	var createDesc = __webpack_require__(56);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ }),
/* 82 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
	var isArray = __webpack_require__(54);
	var isObject = __webpack_require__(20);
	var toLength = __webpack_require__(9);
	var ctx = __webpack_require__(19);
	var IS_CONCAT_SPREADABLE = __webpack_require__(7)('isConcatSpreadable');
	
	function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
	  var targetIndex = start;
	  var sourceIndex = 0;
	  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
	  var element, spreadable;
	
	  while (sourceIndex < sourceLen) {
	    if (sourceIndex in source) {
	      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
	
	      spreadable = false;
	      if (isObject(element)) {
	        spreadable = element[IS_CONCAT_SPREADABLE];
	        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
	      }
	
	      if (spreadable && depth > 0) {
	        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
	      } else {
	        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
	        target[targetIndex] = element;
	      }
	
	      targetIndex++;
	    }
	    sourceIndex++;
	  }
	  return targetIndex;
	}
	
	module.exports = flattenIntoArray;


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(28);
	var ITERATOR = __webpack_require__(7)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(16);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(88);
	var $export = __webpack_require__(2);
	var redefine = __webpack_require__(30);
	var hide = __webpack_require__(25);
	var Iterators = __webpack_require__(28);
	var $iterCreate = __webpack_require__(177);
	var setToStringTag = __webpack_require__(57);
	var getPrototypeOf = __webpack_require__(182);
	var ITERATOR = __webpack_require__(7)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(7)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 88 */
/***/ (function(module, exports) {

	module.exports = false;


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(183);
	var enumBugKeys = __webpack_require__(82);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 90 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(16);
	var isObject = __webpack_require__(20);
	var newPromiseCapability = __webpack_require__(55);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(8);
	var dP = __webpack_require__(29);
	var DESCRIPTORS = __webpack_require__(27);
	var SPECIES = __webpack_require__(7)('species');
	
	module.exports = function (KEY) {
	  var C = global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(8);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	module.exports = function (key) {
	  return store[key] || (store[key] = {});
	};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(16);
	var aFunction = __webpack_require__(15);
	var SPECIES = __webpack_require__(7)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(19);
	var invoke = __webpack_require__(176);
	var html = __webpack_require__(53);
	var cel = __webpack_require__(52);
	var global = __webpack_require__(8);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(23)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(50);
	var ITERATOR = __webpack_require__(7)('iterator');
	var Iterators = __webpack_require__(28);
	module.exports = __webpack_require__(18).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(13);
	var step = __webpack_require__(178);
	var Iterators = __webpack_require__(28);
	var toIObject = __webpack_require__(32);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(86)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(185)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(86)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {exports = module.exports = SemVer;
	
	// The debug function is excluded entirely from the minified version.
	/* nomin */ var debug;
	/* nomin */ if (typeof process === 'object' &&
	    /* nomin */ process.env &&
	    /* nomin */ process.env.NODE_DEBUG &&
	    /* nomin */ /\bsemver\b/i.test(process.env.NODE_DEBUG))
	  /* nomin */ debug = function() {
	    /* nomin */ var args = Array.prototype.slice.call(arguments, 0);
	    /* nomin */ args.unshift('SEMVER');
	    /* nomin */ console.log.apply(console, args);
	    /* nomin */ };
	/* nomin */ else
	  /* nomin */ debug = function() {};
	
	// Note: this is the semver.org version of the spec that it implements
	// Not necessarily the package version of this code.
	exports.SEMVER_SPEC_VERSION = '2.0.0';
	
	var MAX_LENGTH = 256;
	var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;
	
	// Max safe segment length for coercion.
	var MAX_SAFE_COMPONENT_LENGTH = 16;
	
	// The actual regexps go on exports.re
	var re = exports.re = [];
	var src = exports.src = [];
	var R = 0;
	
	// The following Regular Expressions can be used for tokenizing,
	// validating, and parsing SemVer version strings.
	
	// ## Numeric Identifier
	// A single `0`, or a non-zero digit followed by zero or more digits.
	
	var NUMERICIDENTIFIER = R++;
	src[NUMERICIDENTIFIER] = '0|[1-9]\\d*';
	var NUMERICIDENTIFIERLOOSE = R++;
	src[NUMERICIDENTIFIERLOOSE] = '[0-9]+';
	
	
	// ## Non-numeric Identifier
	// Zero or more digits, followed by a letter or hyphen, and then zero or
	// more letters, digits, or hyphens.
	
	var NONNUMERICIDENTIFIER = R++;
	src[NONNUMERICIDENTIFIER] = '\\d*[a-zA-Z-][a-zA-Z0-9-]*';
	
	
	// ## Main Version
	// Three dot-separated numeric identifiers.
	
	var MAINVERSION = R++;
	src[MAINVERSION] = '(' + src[NUMERICIDENTIFIER] + ')\\.' +
	                   '(' + src[NUMERICIDENTIFIER] + ')\\.' +
	                   '(' + src[NUMERICIDENTIFIER] + ')';
	
	var MAINVERSIONLOOSE = R++;
	src[MAINVERSIONLOOSE] = '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
	                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
	                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')';
	
	// ## Pre-release Version Identifier
	// A numeric identifier, or a non-numeric identifier.
	
	var PRERELEASEIDENTIFIER = R++;
	src[PRERELEASEIDENTIFIER] = '(?:' + src[NUMERICIDENTIFIER] +
	                            '|' + src[NONNUMERICIDENTIFIER] + ')';
	
	var PRERELEASEIDENTIFIERLOOSE = R++;
	src[PRERELEASEIDENTIFIERLOOSE] = '(?:' + src[NUMERICIDENTIFIERLOOSE] +
	                                 '|' + src[NONNUMERICIDENTIFIER] + ')';
	
	
	// ## Pre-release Version
	// Hyphen, followed by one or more dot-separated pre-release version
	// identifiers.
	
	var PRERELEASE = R++;
	src[PRERELEASE] = '(?:-(' + src[PRERELEASEIDENTIFIER] +
	                  '(?:\\.' + src[PRERELEASEIDENTIFIER] + ')*))';
	
	var PRERELEASELOOSE = R++;
	src[PRERELEASELOOSE] = '(?:-?(' + src[PRERELEASEIDENTIFIERLOOSE] +
	                       '(?:\\.' + src[PRERELEASEIDENTIFIERLOOSE] + ')*))';
	
	// ## Build Metadata Identifier
	// Any combination of digits, letters, or hyphens.
	
	var BUILDIDENTIFIER = R++;
	src[BUILDIDENTIFIER] = '[0-9A-Za-z-]+';
	
	// ## Build Metadata
	// Plus sign, followed by one or more period-separated build metadata
	// identifiers.
	
	var BUILD = R++;
	src[BUILD] = '(?:\\+(' + src[BUILDIDENTIFIER] +
	             '(?:\\.' + src[BUILDIDENTIFIER] + ')*))';
	
	
	// ## Full Version String
	// A main version, followed optionally by a pre-release version and
	// build metadata.
	
	// Note that the only major, minor, patch, and pre-release sections of
	// the version string are capturing groups.  The build metadata is not a
	// capturing group, because it should not ever be used in version
	// comparison.
	
	var FULL = R++;
	var FULLPLAIN = 'v?' + src[MAINVERSION] +
	                src[PRERELEASE] + '?' +
	                src[BUILD] + '?';
	
	src[FULL] = '^' + FULLPLAIN + '$';
	
	// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
	// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
	// common in the npm registry.
	var LOOSEPLAIN = '[v=\\s]*' + src[MAINVERSIONLOOSE] +
	                 src[PRERELEASELOOSE] + '?' +
	                 src[BUILD] + '?';
	
	var LOOSE = R++;
	src[LOOSE] = '^' + LOOSEPLAIN + '$';
	
	var GTLT = R++;
	src[GTLT] = '((?:<|>)?=?)';
	
	// Something like "2.*" or "1.2.x".
	// Note that "x.x" is a valid xRange identifer, meaning "any version"
	// Only the first item is strictly required.
	var XRANGEIDENTIFIERLOOSE = R++;
	src[XRANGEIDENTIFIERLOOSE] = src[NUMERICIDENTIFIERLOOSE] + '|x|X|\\*';
	var XRANGEIDENTIFIER = R++;
	src[XRANGEIDENTIFIER] = src[NUMERICIDENTIFIER] + '|x|X|\\*';
	
	var XRANGEPLAIN = R++;
	src[XRANGEPLAIN] = '[v=\\s]*(' + src[XRANGEIDENTIFIER] + ')' +
	                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
	                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
	                   '(?:' + src[PRERELEASE] + ')?' +
	                   src[BUILD] + '?' +
	                   ')?)?';
	
	var XRANGEPLAINLOOSE = R++;
	src[XRANGEPLAINLOOSE] = '[v=\\s]*(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
	                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
	                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
	                        '(?:' + src[PRERELEASELOOSE] + ')?' +
	                        src[BUILD] + '?' +
	                        ')?)?';
	
	var XRANGE = R++;
	src[XRANGE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAIN] + '$';
	var XRANGELOOSE = R++;
	src[XRANGELOOSE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAINLOOSE] + '$';
	
	// Coercion.
	// Extract anything that could conceivably be a part of a valid semver
	var COERCE = R++;
	src[COERCE] = '(?:^|[^\\d])' +
	              '(\\d{1,' + MAX_SAFE_COMPONENT_LENGTH + '})' +
	              '(?:\\.(\\d{1,' + MAX_SAFE_COMPONENT_LENGTH + '}))?' +
	              '(?:\\.(\\d{1,' + MAX_SAFE_COMPONENT_LENGTH + '}))?' +
	              '(?:$|[^\\d])';
	
	// Tilde ranges.
	// Meaning is "reasonably at or greater than"
	var LONETILDE = R++;
	src[LONETILDE] = '(?:~>?)';
	
	var TILDETRIM = R++;
	src[TILDETRIM] = '(\\s*)' + src[LONETILDE] + '\\s+';
	re[TILDETRIM] = new RegExp(src[TILDETRIM], 'g');
	var tildeTrimReplace = '$1~';
	
	var TILDE = R++;
	src[TILDE] = '^' + src[LONETILDE] + src[XRANGEPLAIN] + '$';
	var TILDELOOSE = R++;
	src[TILDELOOSE] = '^' + src[LONETILDE] + src[XRANGEPLAINLOOSE] + '$';
	
	// Caret ranges.
	// Meaning is "at least and backwards compatible with"
	var LONECARET = R++;
	src[LONECARET] = '(?:\\^)';
	
	var CARETTRIM = R++;
	src[CARETTRIM] = '(\\s*)' + src[LONECARET] + '\\s+';
	re[CARETTRIM] = new RegExp(src[CARETTRIM], 'g');
	var caretTrimReplace = '$1^';
	
	var CARET = R++;
	src[CARET] = '^' + src[LONECARET] + src[XRANGEPLAIN] + '$';
	var CARETLOOSE = R++;
	src[CARETLOOSE] = '^' + src[LONECARET] + src[XRANGEPLAINLOOSE] + '$';
	
	// A simple gt/lt/eq thing, or just "" to indicate "any version"
	var COMPARATORLOOSE = R++;
	src[COMPARATORLOOSE] = '^' + src[GTLT] + '\\s*(' + LOOSEPLAIN + ')$|^$';
	var COMPARATOR = R++;
	src[COMPARATOR] = '^' + src[GTLT] + '\\s*(' + FULLPLAIN + ')$|^$';
	
	
	// An expression to strip any whitespace between the gtlt and the thing
	// it modifies, so that `> 1.2.3` ==> `>1.2.3`
	var COMPARATORTRIM = R++;
	src[COMPARATORTRIM] = '(\\s*)' + src[GTLT] +
	                      '\\s*(' + LOOSEPLAIN + '|' + src[XRANGEPLAIN] + ')';
	
	// this one has to use the /g flag
	re[COMPARATORTRIM] = new RegExp(src[COMPARATORTRIM], 'g');
	var comparatorTrimReplace = '$1$2$3';
	
	
	// Something like `1.2.3 - 1.2.4`
	// Note that these all use the loose form, because they'll be
	// checked against either the strict or loose comparator form
	// later.
	var HYPHENRANGE = R++;
	src[HYPHENRANGE] = '^\\s*(' + src[XRANGEPLAIN] + ')' +
	                   '\\s+-\\s+' +
	                   '(' + src[XRANGEPLAIN] + ')' +
	                   '\\s*$';
	
	var HYPHENRANGELOOSE = R++;
	src[HYPHENRANGELOOSE] = '^\\s*(' + src[XRANGEPLAINLOOSE] + ')' +
	                        '\\s+-\\s+' +
	                        '(' + src[XRANGEPLAINLOOSE] + ')' +
	                        '\\s*$';
	
	// Star ranges basically just allow anything at all.
	var STAR = R++;
	src[STAR] = '(<|>)?=?\\s*\\*';
	
	// Compile to actual regexp objects.
	// All are flag-free, unless they were created above with a flag.
	for (var i = 0; i < R; i++) {
	  debug(i, src[i]);
	  if (!re[i])
	    re[i] = new RegExp(src[i]);
	}
	
	exports.parse = parse;
	function parse(version, loose) {
	  if (version instanceof SemVer)
	    return version;
	
	  if (typeof version !== 'string')
	    return null;
	
	  if (version.length > MAX_LENGTH)
	    return null;
	
	  var r = loose ? re[LOOSE] : re[FULL];
	  if (!r.test(version))
	    return null;
	
	  try {
	    return new SemVer(version, loose);
	  } catch (er) {
	    return null;
	  }
	}
	
	exports.valid = valid;
	function valid(version, loose) {
	  var v = parse(version, loose);
	  return v ? v.version : null;
	}
	
	
	exports.clean = clean;
	function clean(version, loose) {
	  var s = parse(version.trim().replace(/^[=v]+/, ''), loose);
	  return s ? s.version : null;
	}
	
	exports.SemVer = SemVer;
	
	function SemVer(version, loose) {
	  if (version instanceof SemVer) {
	    if (version.loose === loose)
	      return version;
	    else
	      version = version.version;
	  } else if (typeof version !== 'string') {
	    throw new TypeError('Invalid Version: ' + version);
	  }
	
	  if (version.length > MAX_LENGTH)
	    throw new TypeError('version is longer than ' + MAX_LENGTH + ' characters')
	
	  if (!(this instanceof SemVer))
	    return new SemVer(version, loose);
	
	  debug('SemVer', version, loose);
	  this.loose = loose;
	  var m = version.trim().match(loose ? re[LOOSE] : re[FULL]);
	
	  if (!m)
	    throw new TypeError('Invalid Version: ' + version);
	
	  this.raw = version;
	
	  // these are actually numbers
	  this.major = +m[1];
	  this.minor = +m[2];
	  this.patch = +m[3];
	
	  if (this.major > MAX_SAFE_INTEGER || this.major < 0)
	    throw new TypeError('Invalid major version')
	
	  if (this.minor > MAX_SAFE_INTEGER || this.minor < 0)
	    throw new TypeError('Invalid minor version')
	
	  if (this.patch > MAX_SAFE_INTEGER || this.patch < 0)
	    throw new TypeError('Invalid patch version')
	
	  // numberify any prerelease numeric ids
	  if (!m[4])
	    this.prerelease = [];
	  else
	    this.prerelease = m[4].split('.').map(function(id) {
	      if (/^[0-9]+$/.test(id)) {
	        var num = +id;
	        if (num >= 0 && num < MAX_SAFE_INTEGER)
	          return num;
	      }
	      return id;
	    });
	
	  this.build = m[5] ? m[5].split('.') : [];
	  this.format();
	}
	
	SemVer.prototype.format = function() {
	  this.version = this.major + '.' + this.minor + '.' + this.patch;
	  if (this.prerelease.length)
	    this.version += '-' + this.prerelease.join('.');
	  return this.version;
	};
	
	SemVer.prototype.toString = function() {
	  return this.version;
	};
	
	SemVer.prototype.compare = function(other) {
	  debug('SemVer.compare', this.version, this.loose, other);
	  if (!(other instanceof SemVer))
	    other = new SemVer(other, this.loose);
	
	  return this.compareMain(other) || this.comparePre(other);
	};
	
	SemVer.prototype.compareMain = function(other) {
	  if (!(other instanceof SemVer))
	    other = new SemVer(other, this.loose);
	
	  return compareIdentifiers(this.major, other.major) ||
	         compareIdentifiers(this.minor, other.minor) ||
	         compareIdentifiers(this.patch, other.patch);
	};
	
	SemVer.prototype.comparePre = function(other) {
	  if (!(other instanceof SemVer))
	    other = new SemVer(other, this.loose);
	
	  // NOT having a prerelease is > having one
	  if (this.prerelease.length && !other.prerelease.length)
	    return -1;
	  else if (!this.prerelease.length && other.prerelease.length)
	    return 1;
	  else if (!this.prerelease.length && !other.prerelease.length)
	    return 0;
	
	  var i = 0;
	  do {
	    var a = this.prerelease[i];
	    var b = other.prerelease[i];
	    debug('prerelease compare', i, a, b);
	    if (a === undefined && b === undefined)
	      return 0;
	    else if (b === undefined)
	      return 1;
	    else if (a === undefined)
	      return -1;
	    else if (a === b)
	      continue;
	    else
	      return compareIdentifiers(a, b);
	  } while (++i);
	};
	
	// preminor will bump the version up to the next minor release, and immediately
	// down to pre-release. premajor and prepatch work the same way.
	SemVer.prototype.inc = function(release, identifier) {
	  switch (release) {
	    case 'premajor':
	      this.prerelease.length = 0;
	      this.patch = 0;
	      this.minor = 0;
	      this.major++;
	      this.inc('pre', identifier);
	      break;
	    case 'preminor':
	      this.prerelease.length = 0;
	      this.patch = 0;
	      this.minor++;
	      this.inc('pre', identifier);
	      break;
	    case 'prepatch':
	      // If this is already a prerelease, it will bump to the next version
	      // drop any prereleases that might already exist, since they are not
	      // relevant at this point.
	      this.prerelease.length = 0;
	      this.inc('patch', identifier);
	      this.inc('pre', identifier);
	      break;
	    // If the input is a non-prerelease version, this acts the same as
	    // prepatch.
	    case 'prerelease':
	      if (this.prerelease.length === 0)
	        this.inc('patch', identifier);
	      this.inc('pre', identifier);
	      break;
	
	    case 'major':
	      // If this is a pre-major version, bump up to the same major version.
	      // Otherwise increment major.
	      // 1.0.0-5 bumps to 1.0.0
	      // 1.1.0 bumps to 2.0.0
	      if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0)
	        this.major++;
	      this.minor = 0;
	      this.patch = 0;
	      this.prerelease = [];
	      break;
	    case 'minor':
	      // If this is a pre-minor version, bump up to the same minor version.
	      // Otherwise increment minor.
	      // 1.2.0-5 bumps to 1.2.0
	      // 1.2.1 bumps to 1.3.0
	      if (this.patch !== 0 || this.prerelease.length === 0)
	        this.minor++;
	      this.patch = 0;
	      this.prerelease = [];
	      break;
	    case 'patch':
	      // If this is not a pre-release version, it will increment the patch.
	      // If it is a pre-release it will bump up to the same patch version.
	      // 1.2.0-5 patches to 1.2.0
	      // 1.2.0 patches to 1.2.1
	      if (this.prerelease.length === 0)
	        this.patch++;
	      this.prerelease = [];
	      break;
	    // This probably shouldn't be used publicly.
	    // 1.0.0 "pre" would become 1.0.0-0 which is the wrong direction.
	    case 'pre':
	      if (this.prerelease.length === 0)
	        this.prerelease = [0];
	      else {
	        var i = this.prerelease.length;
	        while (--i >= 0) {
	          if (typeof this.prerelease[i] === 'number') {
	            this.prerelease[i]++;
	            i = -2;
	          }
	        }
	        if (i === -1) // didn't increment anything
	          this.prerelease.push(0);
	      }
	      if (identifier) {
	        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
	        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
	        if (this.prerelease[0] === identifier) {
	          if (isNaN(this.prerelease[1]))
	            this.prerelease = [identifier, 0];
	        } else
	          this.prerelease = [identifier, 0];
	      }
	      break;
	
	    default:
	      throw new Error('invalid increment argument: ' + release);
	  }
	  this.format();
	  this.raw = this.version;
	  return this;
	};
	
	exports.inc = inc;
	function inc(version, release, loose, identifier) {
	  if (typeof(loose) === 'string') {
	    identifier = loose;
	    loose = undefined;
	  }
	
	  try {
	    return new SemVer(version, loose).inc(release, identifier).version;
	  } catch (er) {
	    return null;
	  }
	}
	
	exports.diff = diff;
	function diff(version1, version2) {
	  if (eq(version1, version2)) {
	    return null;
	  } else {
	    var v1 = parse(version1);
	    var v2 = parse(version2);
	    if (v1.prerelease.length || v2.prerelease.length) {
	      for (var key in v1) {
	        if (key === 'major' || key === 'minor' || key === 'patch') {
	          if (v1[key] !== v2[key]) {
	            return 'pre'+key;
	          }
	        }
	      }
	      return 'prerelease';
	    }
	    for (var key in v1) {
	      if (key === 'major' || key === 'minor' || key === 'patch') {
	        if (v1[key] !== v2[key]) {
	          return key;
	        }
	      }
	    }
	  }
	}
	
	exports.compareIdentifiers = compareIdentifiers;
	
	var numeric = /^[0-9]+$/;
	function compareIdentifiers(a, b) {
	  var anum = numeric.test(a);
	  var bnum = numeric.test(b);
	
	  if (anum && bnum) {
	    a = +a;
	    b = +b;
	  }
	
	  return (anum && !bnum) ? -1 :
	         (bnum && !anum) ? 1 :
	         a < b ? -1 :
	         a > b ? 1 :
	         0;
	}
	
	exports.rcompareIdentifiers = rcompareIdentifiers;
	function rcompareIdentifiers(a, b) {
	  return compareIdentifiers(b, a);
	}
	
	exports.major = major;
	function major(a, loose) {
	  return new SemVer(a, loose).major;
	}
	
	exports.minor = minor;
	function minor(a, loose) {
	  return new SemVer(a, loose).minor;
	}
	
	exports.patch = patch;
	function patch(a, loose) {
	  return new SemVer(a, loose).patch;
	}
	
	exports.compare = compare;
	function compare(a, b, loose) {
	  return new SemVer(a, loose).compare(new SemVer(b, loose));
	}
	
	exports.compareLoose = compareLoose;
	function compareLoose(a, b) {
	  return compare(a, b, true);
	}
	
	exports.rcompare = rcompare;
	function rcompare(a, b, loose) {
	  return compare(b, a, loose);
	}
	
	exports.sort = sort;
	function sort(list, loose) {
	  return list.sort(function(a, b) {
	    return exports.compare(a, b, loose);
	  });
	}
	
	exports.rsort = rsort;
	function rsort(list, loose) {
	  return list.sort(function(a, b) {
	    return exports.rcompare(a, b, loose);
	  });
	}
	
	exports.gt = gt;
	function gt(a, b, loose) {
	  return compare(a, b, loose) > 0;
	}
	
	exports.lt = lt;
	function lt(a, b, loose) {
	  return compare(a, b, loose) < 0;
	}
	
	exports.eq = eq;
	function eq(a, b, loose) {
	  return compare(a, b, loose) === 0;
	}
	
	exports.neq = neq;
	function neq(a, b, loose) {
	  return compare(a, b, loose) !== 0;
	}
	
	exports.gte = gte;
	function gte(a, b, loose) {
	  return compare(a, b, loose) >= 0;
	}
	
	exports.lte = lte;
	function lte(a, b, loose) {
	  return compare(a, b, loose) <= 0;
	}
	
	exports.cmp = cmp;
	function cmp(a, op, b, loose) {
	  var ret;
	  switch (op) {
	    case '===':
	      if (typeof a === 'object') a = a.version;
	      if (typeof b === 'object') b = b.version;
	      ret = a === b;
	      break;
	    case '!==':
	      if (typeof a === 'object') a = a.version;
	      if (typeof b === 'object') b = b.version;
	      ret = a !== b;
	      break;
	    case '': case '=': case '==': ret = eq(a, b, loose); break;
	    case '!=': ret = neq(a, b, loose); break;
	    case '>': ret = gt(a, b, loose); break;
	    case '>=': ret = gte(a, b, loose); break;
	    case '<': ret = lt(a, b, loose); break;
	    case '<=': ret = lte(a, b, loose); break;
	    default: throw new TypeError('Invalid operator: ' + op);
	  }
	  return ret;
	}
	
	exports.Comparator = Comparator;
	function Comparator(comp, loose) {
	  if (comp instanceof Comparator) {
	    if (comp.loose === loose)
	      return comp;
	    else
	      comp = comp.value;
	  }
	
	  if (!(this instanceof Comparator))
	    return new Comparator(comp, loose);
	
	  debug('comparator', comp, loose);
	  this.loose = loose;
	  this.parse(comp);
	
	  if (this.semver === ANY)
	    this.value = '';
	  else
	    this.value = this.operator + this.semver.version;
	
	  debug('comp', this);
	}
	
	var ANY = {};
	Comparator.prototype.parse = function(comp) {
	  var r = this.loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
	  var m = comp.match(r);
	
	  if (!m)
	    throw new TypeError('Invalid comparator: ' + comp);
	
	  this.operator = m[1];
	  if (this.operator === '=')
	    this.operator = '';
	
	  // if it literally is just '>' or '' then allow anything.
	  if (!m[2])
	    this.semver = ANY;
	  else
	    this.semver = new SemVer(m[2], this.loose);
	};
	
	Comparator.prototype.toString = function() {
	  return this.value;
	};
	
	Comparator.prototype.test = function(version) {
	  debug('Comparator.test', version, this.loose);
	
	  if (this.semver === ANY)
	    return true;
	
	  if (typeof version === 'string')
	    version = new SemVer(version, this.loose);
	
	  return cmp(version, this.operator, this.semver, this.loose);
	};
	
	Comparator.prototype.intersects = function(comp, loose) {
	  if (!(comp instanceof Comparator)) {
	    throw new TypeError('a Comparator is required');
	  }
	
	  var rangeTmp;
	
	  if (this.operator === '') {
	    rangeTmp = new Range(comp.value, loose);
	    return satisfies(this.value, rangeTmp, loose);
	  } else if (comp.operator === '') {
	    rangeTmp = new Range(this.value, loose);
	    return satisfies(comp.semver, rangeTmp, loose);
	  }
	
	  var sameDirectionIncreasing =
	    (this.operator === '>=' || this.operator === '>') &&
	    (comp.operator === '>=' || comp.operator === '>');
	  var sameDirectionDecreasing =
	    (this.operator === '<=' || this.operator === '<') &&
	    (comp.operator === '<=' || comp.operator === '<');
	  var sameSemVer = this.semver.version === comp.semver.version;
	  var differentDirectionsInclusive =
	    (this.operator === '>=' || this.operator === '<=') &&
	    (comp.operator === '>=' || comp.operator === '<=');
	  var oppositeDirectionsLessThan =
	    cmp(this.semver, '<', comp.semver, loose) &&
	    ((this.operator === '>=' || this.operator === '>') &&
	    (comp.operator === '<=' || comp.operator === '<'));
	  var oppositeDirectionsGreaterThan =
	    cmp(this.semver, '>', comp.semver, loose) &&
	    ((this.operator === '<=' || this.operator === '<') &&
	    (comp.operator === '>=' || comp.operator === '>'));
	
	  return sameDirectionIncreasing || sameDirectionDecreasing ||
	    (sameSemVer && differentDirectionsInclusive) ||
	    oppositeDirectionsLessThan || oppositeDirectionsGreaterThan;
	};
	
	
	exports.Range = Range;
	function Range(range, loose) {
	  if (range instanceof Range) {
	    if (range.loose === loose) {
	      return range;
	    } else {
	      return new Range(range.raw, loose);
	    }
	  }
	
	  if (range instanceof Comparator) {
	    return new Range(range.value, loose);
	  }
	
	  if (!(this instanceof Range))
	    return new Range(range, loose);
	
	  this.loose = loose;
	
	  // First, split based on boolean or ||
	  this.raw = range;
	  this.set = range.split(/\s*\|\|\s*/).map(function(range) {
	    return this.parseRange(range.trim());
	  }, this).filter(function(c) {
	    // throw out any that are not relevant for whatever reason
	    return c.length;
	  });
	
	  if (!this.set.length) {
	    throw new TypeError('Invalid SemVer Range: ' + range);
	  }
	
	  this.format();
	}
	
	Range.prototype.format = function() {
	  this.range = this.set.map(function(comps) {
	    return comps.join(' ').trim();
	  }).join('||').trim();
	  return this.range;
	};
	
	Range.prototype.toString = function() {
	  return this.range;
	};
	
	Range.prototype.parseRange = function(range) {
	  var loose = this.loose;
	  range = range.trim();
	  debug('range', range, loose);
	  // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
	  var hr = loose ? re[HYPHENRANGELOOSE] : re[HYPHENRANGE];
	  range = range.replace(hr, hyphenReplace);
	  debug('hyphen replace', range);
	  // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
	  range = range.replace(re[COMPARATORTRIM], comparatorTrimReplace);
	  debug('comparator trim', range, re[COMPARATORTRIM]);
	
	  // `~ 1.2.3` => `~1.2.3`
	  range = range.replace(re[TILDETRIM], tildeTrimReplace);
	
	  // `^ 1.2.3` => `^1.2.3`
	  range = range.replace(re[CARETTRIM], caretTrimReplace);
	
	  // normalize spaces
	  range = range.split(/\s+/).join(' ');
	
	  // At this point, the range is completely trimmed and
	  // ready to be split into comparators.
	
	  var compRe = loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
	  var set = range.split(' ').map(function(comp) {
	    return parseComparator(comp, loose);
	  }).join(' ').split(/\s+/);
	  if (this.loose) {
	    // in loose mode, throw out any that are not valid comparators
	    set = set.filter(function(comp) {
	      return !!comp.match(compRe);
	    });
	  }
	  set = set.map(function(comp) {
	    return new Comparator(comp, loose);
	  });
	
	  return set;
	};
	
	Range.prototype.intersects = function(range, loose) {
	  if (!(range instanceof Range)) {
	    throw new TypeError('a Range is required');
	  }
	
	  return this.set.some(function(thisComparators) {
	    return thisComparators.every(function(thisComparator) {
	      return range.set.some(function(rangeComparators) {
	        return rangeComparators.every(function(rangeComparator) {
	          return thisComparator.intersects(rangeComparator, loose);
	        });
	      });
	    });
	  });
	};
	
	// Mostly just for testing and legacy API reasons
	exports.toComparators = toComparators;
	function toComparators(range, loose) {
	  return new Range(range, loose).set.map(function(comp) {
	    return comp.map(function(c) {
	      return c.value;
	    }).join(' ').trim().split(' ');
	  });
	}
	
	// comprised of xranges, tildes, stars, and gtlt's at this point.
	// already replaced the hyphen ranges
	// turn into a set of JUST comparators.
	function parseComparator(comp, loose) {
	  debug('comp', comp);
	  comp = replaceCarets(comp, loose);
	  debug('caret', comp);
	  comp = replaceTildes(comp, loose);
	  debug('tildes', comp);
	  comp = replaceXRanges(comp, loose);
	  debug('xrange', comp);
	  comp = replaceStars(comp, loose);
	  debug('stars', comp);
	  return comp;
	}
	
	function isX(id) {
	  return !id || id.toLowerCase() === 'x' || id === '*';
	}
	
	// ~, ~> --> * (any, kinda silly)
	// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0
	// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0
	// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0
	// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0
	// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0
	function replaceTildes(comp, loose) {
	  return comp.trim().split(/\s+/).map(function(comp) {
	    return replaceTilde(comp, loose);
	  }).join(' ');
	}
	
	function replaceTilde(comp, loose) {
	  var r = loose ? re[TILDELOOSE] : re[TILDE];
	  return comp.replace(r, function(_, M, m, p, pr) {
	    debug('tilde', comp, _, M, m, p, pr);
	    var ret;
	
	    if (isX(M))
	      ret = '';
	    else if (isX(m))
	      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
	    else if (isX(p))
	      // ~1.2 == >=1.2.0 <1.3.0
	      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
	    else if (pr) {
	      debug('replaceTilde pr', pr);
	      if (pr.charAt(0) !== '-')
	        pr = '-' + pr;
	      ret = '>=' + M + '.' + m + '.' + p + pr +
	            ' <' + M + '.' + (+m + 1) + '.0';
	    } else
	      // ~1.2.3 == >=1.2.3 <1.3.0
	      ret = '>=' + M + '.' + m + '.' + p +
	            ' <' + M + '.' + (+m + 1) + '.0';
	
	    debug('tilde return', ret);
	    return ret;
	  });
	}
	
	// ^ --> * (any, kinda silly)
	// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0
	// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0
	// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0
	// ^1.2.3 --> >=1.2.3 <2.0.0
	// ^1.2.0 --> >=1.2.0 <2.0.0
	function replaceCarets(comp, loose) {
	  return comp.trim().split(/\s+/).map(function(comp) {
	    return replaceCaret(comp, loose);
	  }).join(' ');
	}
	
	function replaceCaret(comp, loose) {
	  debug('caret', comp, loose);
	  var r = loose ? re[CARETLOOSE] : re[CARET];
	  return comp.replace(r, function(_, M, m, p, pr) {
	    debug('caret', comp, _, M, m, p, pr);
	    var ret;
	
	    if (isX(M))
	      ret = '';
	    else if (isX(m))
	      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
	    else if (isX(p)) {
	      if (M === '0')
	        ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
	      else
	        ret = '>=' + M + '.' + m + '.0 <' + (+M + 1) + '.0.0';
	    } else if (pr) {
	      debug('replaceCaret pr', pr);
	      if (pr.charAt(0) !== '-')
	        pr = '-' + pr;
	      if (M === '0') {
	        if (m === '0')
	          ret = '>=' + M + '.' + m + '.' + p + pr +
	                ' <' + M + '.' + m + '.' + (+p + 1);
	        else
	          ret = '>=' + M + '.' + m + '.' + p + pr +
	                ' <' + M + '.' + (+m + 1) + '.0';
	      } else
	        ret = '>=' + M + '.' + m + '.' + p + pr +
	              ' <' + (+M + 1) + '.0.0';
	    } else {
	      debug('no pr');
	      if (M === '0') {
	        if (m === '0')
	          ret = '>=' + M + '.' + m + '.' + p +
	                ' <' + M + '.' + m + '.' + (+p + 1);
	        else
	          ret = '>=' + M + '.' + m + '.' + p +
	                ' <' + M + '.' + (+m + 1) + '.0';
	      } else
	        ret = '>=' + M + '.' + m + '.' + p +
	              ' <' + (+M + 1) + '.0.0';
	    }
	
	    debug('caret return', ret);
	    return ret;
	  });
	}
	
	function replaceXRanges(comp, loose) {
	  debug('replaceXRanges', comp, loose);
	  return comp.split(/\s+/).map(function(comp) {
	    return replaceXRange(comp, loose);
	  }).join(' ');
	}
	
	function replaceXRange(comp, loose) {
	  comp = comp.trim();
	  var r = loose ? re[XRANGELOOSE] : re[XRANGE];
	  return comp.replace(r, function(ret, gtlt, M, m, p, pr) {
	    debug('xRange', comp, ret, gtlt, M, m, p, pr);
	    var xM = isX(M);
	    var xm = xM || isX(m);
	    var xp = xm || isX(p);
	    var anyX = xp;
	
	    if (gtlt === '=' && anyX)
	      gtlt = '';
	
	    if (xM) {
	      if (gtlt === '>' || gtlt === '<') {
	        // nothing is allowed
	        ret = '<0.0.0';
	      } else {
	        // nothing is forbidden
	        ret = '*';
	      }
	    } else if (gtlt && anyX) {
	      // replace X with 0
	      if (xm)
	        m = 0;
	      if (xp)
	        p = 0;
	
	      if (gtlt === '>') {
	        // >1 => >=2.0.0
	        // >1.2 => >=1.3.0
	        // >1.2.3 => >= 1.2.4
	        gtlt = '>=';
	        if (xm) {
	          M = +M + 1;
	          m = 0;
	          p = 0;
	        } else if (xp) {
	          m = +m + 1;
	          p = 0;
	        }
	      } else if (gtlt === '<=') {
	        // <=0.7.x is actually <0.8.0, since any 0.7.x should
	        // pass.  Similarly, <=7.x is actually <8.0.0, etc.
	        gtlt = '<';
	        if (xm)
	          M = +M + 1;
	        else
	          m = +m + 1;
	      }
	
	      ret = gtlt + M + '.' + m + '.' + p;
	    } else if (xm) {
	      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
	    } else if (xp) {
	      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
	    }
	
	    debug('xRange return', ret);
	
	    return ret;
	  });
	}
	
	// Because * is AND-ed with everything else in the comparator,
	// and '' means "any version", just remove the *s entirely.
	function replaceStars(comp, loose) {
	  debug('replaceStars', comp, loose);
	  // Looseness is ignored here.  star is always as loose as it gets!
	  return comp.trim().replace(re[STAR], '');
	}
	
	// This function is passed to string.replace(re[HYPHENRANGE])
	// M, m, patch, prerelease, build
	// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
	// 1.2.3 - 3.4 => >=1.2.0 <3.5.0 Any 3.4.x will do
	// 1.2 - 3.4 => >=1.2.0 <3.5.0
	function hyphenReplace($0,
	                       from, fM, fm, fp, fpr, fb,
	                       to, tM, tm, tp, tpr, tb) {
	
	  if (isX(fM))
	    from = '';
	  else if (isX(fm))
	    from = '>=' + fM + '.0.0';
	  else if (isX(fp))
	    from = '>=' + fM + '.' + fm + '.0';
	  else
	    from = '>=' + from;
	
	  if (isX(tM))
	    to = '';
	  else if (isX(tm))
	    to = '<' + (+tM + 1) + '.0.0';
	  else if (isX(tp))
	    to = '<' + tM + '.' + (+tm + 1) + '.0';
	  else if (tpr)
	    to = '<=' + tM + '.' + tm + '.' + tp + '-' + tpr;
	  else
	    to = '<=' + to;
	
	  return (from + ' ' + to).trim();
	}
	
	
	// if ANY of the sets match ALL of its comparators, then pass
	Range.prototype.test = function(version) {
	  if (!version)
	    return false;
	
	  if (typeof version === 'string')
	    version = new SemVer(version, this.loose);
	
	  for (var i = 0; i < this.set.length; i++) {
	    if (testSet(this.set[i], version))
	      return true;
	  }
	  return false;
	};
	
	function testSet(set, version) {
	  for (var i = 0; i < set.length; i++) {
	    if (!set[i].test(version))
	      return false;
	  }
	
	  if (version.prerelease.length) {
	    // Find the set of versions that are allowed to have prereleases
	    // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
	    // That should allow `1.2.3-pr.2` to pass.
	    // However, `1.2.4-alpha.notready` should NOT be allowed,
	    // even though it's within the range set by the comparators.
	    for (var i = 0; i < set.length; i++) {
	      debug(set[i].semver);
	      if (set[i].semver === ANY)
	        continue;
	
	      if (set[i].semver.prerelease.length > 0) {
	        var allowed = set[i].semver;
	        if (allowed.major === version.major &&
	            allowed.minor === version.minor &&
	            allowed.patch === version.patch)
	          return true;
	      }
	    }
	
	    // Version has a -pre, but it's not one of the ones we like.
	    return false;
	  }
	
	  return true;
	}
	
	exports.satisfies = satisfies;
	function satisfies(version, range, loose) {
	  try {
	    range = new Range(range, loose);
	  } catch (er) {
	    return false;
	  }
	  return range.test(version);
	}
	
	exports.maxSatisfying = maxSatisfying;
	function maxSatisfying(versions, range, loose) {
	  var max = null;
	  var maxSV = null;
	  try {
	    var rangeObj = new Range(range, loose);
	  } catch (er) {
	    return null;
	  }
	  versions.forEach(function (v) {
	    if (rangeObj.test(v)) { // satisfies(v, range, loose)
	      if (!max || maxSV.compare(v) === -1) { // compare(max, v, true)
	        max = v;
	        maxSV = new SemVer(max, loose);
	      }
	    }
	  })
	  return max;
	}
	
	exports.minSatisfying = minSatisfying;
	function minSatisfying(versions, range, loose) {
	  var min = null;
	  var minSV = null;
	  try {
	    var rangeObj = new Range(range, loose);
	  } catch (er) {
	    return null;
	  }
	  versions.forEach(function (v) {
	    if (rangeObj.test(v)) { // satisfies(v, range, loose)
	      if (!min || minSV.compare(v) === 1) { // compare(min, v, true)
	        min = v;
	        minSV = new SemVer(min, loose);
	      }
	    }
	  })
	  return min;
	}
	
	exports.validRange = validRange;
	function validRange(range, loose) {
	  try {
	    // Return '*' instead of '' so that truthiness works.
	    // This will throw if it's invalid anyway
	    return new Range(range, loose).range || '*';
	  } catch (er) {
	    return null;
	  }
	}
	
	// Determine if version is less than all the versions possible in the range
	exports.ltr = ltr;
	function ltr(version, range, loose) {
	  return outside(version, range, '<', loose);
	}
	
	// Determine if version is greater than all the versions possible in the range.
	exports.gtr = gtr;
	function gtr(version, range, loose) {
	  return outside(version, range, '>', loose);
	}
	
	exports.outside = outside;
	function outside(version, range, hilo, loose) {
	  version = new SemVer(version, loose);
	  range = new Range(range, loose);
	
	  var gtfn, ltefn, ltfn, comp, ecomp;
	  switch (hilo) {
	    case '>':
	      gtfn = gt;
	      ltefn = lte;
	      ltfn = lt;
	      comp = '>';
	      ecomp = '>=';
	      break;
	    case '<':
	      gtfn = lt;
	      ltefn = gte;
	      ltfn = gt;
	      comp = '<';
	      ecomp = '<=';
	      break;
	    default:
	      throw new TypeError('Must provide a hilo val of "<" or ">"');
	  }
	
	  // If it satisifes the range it is not outside
	  if (satisfies(version, range, loose)) {
	    return false;
	  }
	
	  // From now on, variable terms are as if we're in "gtr" mode.
	  // but note that everything is flipped for the "ltr" function.
	
	  for (var i = 0; i < range.set.length; ++i) {
	    var comparators = range.set[i];
	
	    var high = null;
	    var low = null;
	
	    comparators.forEach(function(comparator) {
	      if (comparator.semver === ANY) {
	        comparator = new Comparator('>=0.0.0')
	      }
	      high = high || comparator;
	      low = low || comparator;
	      if (gtfn(comparator.semver, high.semver, loose)) {
	        high = comparator;
	      } else if (ltfn(comparator.semver, low.semver, loose)) {
	        low = comparator;
	      }
	    });
	
	    // If the edge version comparator has a operator then our version
	    // isn't outside it
	    if (high.operator === comp || high.operator === ecomp) {
	      return false;
	    }
	
	    // If the lowest version comparator has an operator and our version
	    // is less than it then it isn't higher than the range
	    if ((!low.operator || low.operator === comp) &&
	        ltefn(version, low.semver)) {
	      return false;
	    } else if (low.operator === ecomp && ltfn(version, low.semver)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	exports.prerelease = prerelease;
	function prerelease(version, loose) {
	  var parsed = parse(version, loose);
	  return (parsed && parsed.prerelease.length) ? parsed.prerelease : null;
	}
	
	exports.intersects = intersects;
	function intersects(r1, r2, loose) {
	  r1 = new Range(r1, loose)
	  r2 = new Range(r2, loose)
	  return r1.intersects(r2)
	}
	
	exports.coerce = coerce;
	function coerce(version) {
	  if (version instanceof SemVer)
	    return version;
	
	  if (typeof version !== 'string')
	    return null;
	
	  var match = version.match(re[COERCE]);
	
	  if (match == null)
	    return null;
	
	  return parse((match[1] || '0') + '.' + (match[2] || '0') + '.' + (match[3] || '0')); 
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(62)))

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _events = __webpack_require__(3);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _eventHandler = __webpack_require__(5);
	
	var _eventHandler2 = _interopRequireDefault(_eventHandler);
	
	var _errors = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Decrypt key Loader
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	//import { logger } from './hlsjs/utils/logger';
	
	/**
	* @access internal
	*/
	var CustomKeyLoader = function (_EventHandler) {
		_inherits(CustomKeyLoader, _EventHandler);
	
		/**
	  * constructor
	  *
	  * @param {Hls} hlsJs - the hlsJs instance
	  * @param {KeyLoadCallback} keyLoaderCallback - the keyload callback to call { context, callbacks }
	  */
		function CustomKeyLoader(hlsJs, keyLoaderCallback) {
			_classCallCheck(this, CustomKeyLoader);
	
			var _this = _possibleConstructorReturn(this, (CustomKeyLoader.__proto__ || Object.getPrototypeOf(CustomKeyLoader)).call(this, hlsJs, _events2.default.KEY_LOADING));
	
			_this._disposed = false;
			_this._keyLoaderCallback = keyLoaderCallback;
	
			// this overrides the keyLoader with one that returns the bourne key.
			//this._keyLoaderCallback = this._bourneKeyLoadCallback;
	
			_this._decryptkey = null;
			_this._decrypturl = null;
			return _this;
		}
	
		_createClass(CustomKeyLoader, [{
			key: 'destroy',
			value: function destroy() {
				this._disposed = true;
				this._keyLoadCallback = null;
				this._decryptkey = null;
				this._decrypturl = null;
	
				_eventHandler2.default.prototype.destroy.call(this);
			}
	
			/**
	   * a simple callback tester function.
	   *
	   * @param {Object} context
	   * @param {Object} callbacks
	   */
	
		}, {
			key: '_bourneKeyLoadCallback',
			value: function _bourneKeyLoadCallback(context, callbacks) {
				var bourneKey = [0x5D, 0x8C, 0x1E, 0xE7, 0x0E, 0x6F, 0x4E, 0xEB, 0x4D, 0x6E, 0xB0, 0x50, 0x3B, 0xAD, 0x4D, 0x6F];
	
				var key = new Uint8Array(bourneKey);
				//callbacks.onTimeout();
				//callbacks.onError(null, new Error('Oh Dear!'));
				callbacks.onSuccess(key);
			}
		}, {
			key: 'onKeyLoading',
			value: function onKeyLoading(data) {
				if (!this._disposed) {
					var frag = data.frag;
					var decryptdata = frag.decryptdata;
					var uri = decryptdata.uri;
	
					// if uri is different from previous one or if decrypt key not retrieved yet
					if (uri !== this._decrypturl || this._decryptkey === null) {
						this._decrypturl = uri;
						this._decryptkey = null;
	
						var context = {
							url: uri,
							frag: frag
						};
	
						var callbacks = {
							onSuccess: this._doSuccess.bind(this, context),
							onError: this._doError.bind(this, context),
							onTimeout: this._doTimeout.bind(this, context)
						};
	
						// call the client's keyLoader callacbl
						this._keyLoaderCallback(context, callbacks);
					} else if (this._decryptkey) {
						// we already loaded this key, return it
						decryptdata.key = this._decryptkey;
						this.hls.trigger(_events2.default.KEY_LOADED, { frag: frag });
					}
				}
			}
	
			/**
	   * called with key data upon success
	   *
	   * @param {Object} context - the loader context, which is bound at creation.
	   * @param {Uint8Array} key - the 16 bytes of key data. must be valid.
	   */
	
		}, {
			key: '_doSuccess',
			value: function _doSuccess(context, key) {
				if (!this._disposed) {
					var frag = context.frag;
	
					// verify key
					this._decryptkey = frag.decryptdata.key = key;
	
					this.hls.trigger(_events2.default.KEY_LOADED, {
						frag: frag
					});
				}
			}
	
			/**
	   * called with a response object on failure.
	   *
	   * @param {Object} context - the loader context, which is bound at creation.
	   * @param {[response]} key - xhr like response... or not.
	   * @param {[Error]} error - error object, if applicable.
	   */
	
		}, {
			key: '_doError',
			value: function _doError(context, response, error) {
				if (!this._disposed) {
					var data = {
						type: _errors.ErrorTypes.NETWORK_ERROR,
						details: _errors.ErrorDetails.KEY_LOAD_ERROR,
						fatal: false,
						frag: context.frag,
						response: response,
						err: error
					};
	
					this.hls.trigger(_events2.default.ERROR, data);
				}
			}
	
			/**
	   * called with a response object on failure.
	   *
	   * @param {Object} context - the loader context, which is bound at creation.
	   * @param {[response]} key - xhr like response... or not.
	   */
	
		}, {
			key: '_doTimeout',
			value: function _doTimeout(context) {
				if (!this._disposed) {
					this.hls.trigger(_events2.default.ERROR, {
						type: _errors.ErrorTypes.NETWORK_ERROR,
						details: _errors.ErrorDetails.KEY_LOAD_TIMEOUT,
						fatal: false,
						frag: context.frag
					});
				}
			}
		}]);
	
		return CustomKeyLoader;
	}(_eventHandler2.default);
	
	exports.default = CustomKeyLoader;
	module.exports = exports['default'];

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * HLS Controller - controls hls.js and the media element.
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // Enhanced Node style event emitter
	
	
	//import type from 'type-detect';
	
	var _eventemitter = __webpack_require__(33);
	
	var _eventemitter2 = _interopRequireDefault(_eventemitter);
	
	var _HlsEvents = __webpack_require__(14);
	
	var _HlsEvents2 = _interopRequireDefault(_HlsEvents);
	
	var _HlsStates = __webpack_require__(66);
	
	var _HlsStates2 = _interopRequireDefault(_HlsStates);
	
	var _HlsErrors = __webpack_require__(65);
	
	var _HlsErrors2 = _interopRequireDefault(_HlsErrors);
	
	var _errors = __webpack_require__(4);
	
	var _HlsErrorStrings = __webpack_require__(64);
	
	var _HlsErrorStrings2 = _interopRequireDefault(_HlsErrorStrings);
	
	var _PlaybackStates = __webpack_require__(68);
	
	var _PlaybackStates2 = _interopRequireDefault(_PlaybackStates);
	
	var _MediaStates = __webpack_require__(67);
	
	var _MediaStates2 = _interopRequireDefault(_MediaStates);
	
	var _EventHandlers = __webpack_require__(34);
	
	var _EventHandlers2 = _interopRequireDefault(_EventHandlers);
	
	var _HlsJsController = __webpack_require__(103);
	
	var _HlsJsController2 = _interopRequireDefault(_HlsJsController);
	
	var _MediaController = __webpack_require__(106);
	
	var _MediaController2 = _interopRequireDefault(_MediaController);
	
	var _HlsUtils = __webpack_require__(6);
	
	var _HlsUtils2 = _interopRequireDefault(_HlsUtils);
	
	var _HlsMarkers = __webpack_require__(104);
	
	var _HlsMarkers2 = _interopRequireDefault(_HlsMarkers);
	
	var _instanceCounter = __webpack_require__(167);
	
	var _instanceCounter2 = _interopRequireDefault(_instanceCounter);
	
	var _hlsKey = __webpack_require__(166);
	
	var _hlsKey2 = _interopRequireDefault(_hlsKey);
	
	var _logger = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _counter = new _instanceCounter2.default();
	var _hlsKeyLoader = new _hlsKey2.default();
	
	/**
	* @access internal
	*/
	
	var HlsController = function () {
	
		//Creation
		function HlsController() {
			var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
			var di = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
			_classCallCheck(this, HlsController);
	
			var disableWorkarounds = !!config.disableWorkarounds;
			this._disablePromiseOverloadCheck = !!config.disablePromiseOverloadCheck;
			var decryptOutsideWebworker = !!config.decryptOutsideWebworker;
			var instanceId = 0;
	
			//This needs to be incremented every time, but we do allow the value to be passed in as a config value.
			//Thus we check if it has been set and change the internal only if it has not been. Note that regardless
			//the _counter internal value is still incremented and the next creation will be valid unless
			//overridden again.
			instanceId = _counter.increment();
			if (this._instanceId === 0) {
				this._instanceId = instanceId;
			}
	
			this._emitter = di.eventEmitter || new _eventemitter2.default();
	
			this._hlsJsController = di.hlsJsController || new _HlsJsController2.default({
				disableWorkarounds: disableWorkarounds,
				instanceId: instanceId,
				decryptOutsideWebworker: decryptOutsideWebworker
			}, {
				eventEmitter: this._emitter
			});
	
			this._mediaController = di.mediaController || new _MediaController2.default({
				disableWorkarounds: disableWorkarounds,
				instanceId: instanceId
			}, {
				eventEmitter: this._emitter
			});
	
			this._markers = new _HlsMarkers2.default({
				instanceId: instanceId
			}, {
				eventEmitter: this._emitter
			});
	
			this._state = _HlsStates2.default.UNLOADED;
			this._playbackState = _PlaybackStates2.default.NOTREADY;
			this._mediaState = _MediaStates2.default.DETACHED;
	
			this._source = null;
	
			this._pendingMedia = null;
			this._media = null;
	
			this._paused = true;
			this._canplay = false;
			this._canplaythrough = false;
			this._ended = false;
			this._seeking = false;
			this._buffering = false;
			this._startPositionSet = false;
			this._startPosition = 0;
			this._canplayWaiting = false;
			this._instanceId = instanceId;
	
			//for now, STREAM_PLAYBACKRATE_CHANGED only fires in response to MEDIA_RATECHANGE, at which point this.playbackRate has already changed
			//so we need to keep track of the previous rate so we can emit it with the event
			this._lastPlaybackRate = 1;
	
			/*
	  seek over hole workaround - IE generates extra seeking events on a bufferSeekOverHole error, which interferes
	  with some seeking related processes. This workaround detects bufferSeekOverHole errors, and ignores the next
	  seeking event that occurs.
	  */
			this._seekOverHoleWorkaround = _HlsUtils2.default.isIE() && !disableWorkarounds;
			this._swallowNextSeek = false;
	
			/*
	  canplay workaround - Firefox tends to fire media canplay and canplaythrough events later than other browsers,
	  and in some cases may not fire the event at all. This workaround forces canplay to fire on the third fragment
	  loaded (any earlier may interfere with startTime/startTimeByPdt), improving the time it takes to start.
	  */
			this._canplayWorkaround = _HlsUtils2.default.isFirefox() && !disableWorkarounds;
			this._canplayWorkaroundCount = 0;
	
			/*
	  Tizen 3 won't begin playback on audio only streams if startTime is used. This appears to be due to the timing of the seek, when hlsJs requests a seek
	  to the start position, audio only streams on Tizen 3 just aren't ready to start yet. This works around the issue by delaying the initial seek and
	  handling it in the media controller, which is set up to handle seeks when the media object isn't ready yet.
	  */
			this._lateStartWorkaround = _HlsUtils2.default.isTizen3() && !disableWorkarounds;
	
			/*
	  Tizen 2.3 crashes if we attempt to seek outside of the buffered range of an audio only stream. In this case, we need to finish loading the frag we're
	  going to seek to first, then seek.
	  */
			this._audioOnlySeekWorkaround = _HlsUtils2.default.isTizen2() && !disableWorkarounds;
			this._seekWaitingForBuffer = false; //also used for _dataReadySeekWorkaround
	
			/*
	  IE11 on 8.1 crashes if we attempt to seek outside of the buffered range of some streams. In this case, we need to finish loading the frag we're
	  going to seek to first, then seek. Will Investigate this further but for now it's always on.
	  */
			this._dataReadySeekWorkaround = _HlsUtils2.default.isIEWin8Point1() && !disableWorkarounds;
	
			/*
	  Tizen 2.3 has issues handling playback rate changes, it will always say it did the change, but will not always reflect this change in playback. To get
	  the rate change to work consistently, a seek needs to be performed after the media element reports that it has done the change. This forces Tizen's
	  media element to switch the playback rate to what it says it should be.
	  */
			this._forcePlaybackRateWorkaround = _HlsUtils2.default.isTizen2() && !disableWorkarounds;
	
			/*
	  Firefox (tested on 58.0.2) and Chrome (tested on 64.0.3282.167, issue replicates on Mac only) may desync on a playback rate change. This is the same workaround as the Tizen 2 playback rate workaround above,
	  but only triggers when playback rate changes to 1.
	  */
			this._resyncPlaybackRateWorkaround = (_HlsUtils2.default.isFirefox() || _HlsUtils2.default.isChromiumMacOS()) && !disableWorkarounds;
	
			/*
	  Added as it seemed that this was doing more harm than good on IEWin8Point1, but this does not seem to be the case. Removable. - SIEG
	  */
			this._disableFakeSeek = false; // Utils.isIEWin8Point1();
	
			this._seekBackOnPlay = false;
	
			this._initialTime = -1;
			this._pendingSeek = undefined;
			this._seekableRange = { start: undefined, end: undefined, duration: undefined };
			this._prevDuration = 0;
			this._playbackRange = { start: undefined, end: undefined, duration: undefined };
	
			this._playbackMetrics = {};
	
			this._debug = false;
			this._disposed = false;
			this._disposedPromise = undefined;
	
			this._loaded = false;
			this._fetching = false;
			this._autoPrefetch = true;
			this._autoPlay = false;
			this._autoRecover = true;
			this._prefetch = false;
			this._sourceLoaded = false;
			this._sourceMetadataLoaded = false;
	
			this._pendingUrl = null;
			this._pendingDispose = false;
			this._mediaErrorRecovery = false;
			this._playOnMediaErrorRecovery = false;
			this._recoveryOptions = { playbackRate: undefined, volume: undefined, startPdt: undefined };
	
			this._runtimeCheckFinished = false;
	
			this._handlers = new _EventHandlers2.default();
	
			this._handlers.setHlsEventsList(this, // obj to bind to
			this._emitter, // emitter to use
			[
			/* HlsController events */
			{ event: _HlsEvents2.default.MEDIA_WIRING, func: this._onMediaWiring }, { event: _HlsEvents2.default.MEDIA_WIRED, func: this._onMediaWired }, { event: _HlsEvents2.default.MEDIA_ATTACHING, func: this._onMediaAttaching }, { event: _HlsEvents2.default.MEDIA_ATTACHED, func: this._onMediaAttached }, { event: _HlsEvents2.default.MEDIA_DETACHING, func: this._onMediaDetaching }, { event: _HlsEvents2.default.MEDIA_DETACHED, func: this._onMediaDetached },
	
			/* HlsJsController events */
			{ event: _HlsEvents2.default.HLSJS_ERROR, func: this._onHlsJsError }, { event: _HlsEvents2.default.MANIFEST_PARSED, func: this._onManifestParsed }, { event: _HlsEvents2.default.CHUNK_BUFFERED, func: this._onChunkBuffered }, { event: _HlsEvents2.default.STREAM_SUBTITLERENDITIONS_CHANGED, func: this._onHlsJsSubtitleUpdate }, { event: _HlsEvents2.default.VARIANT_DURATION_UPDATED, func: this._onVariantDurationUpdate }, { event: _HlsEvents2.default.STREAM_STARTPOSITION_SET, func: this._onStartPositionSet }, { event: _HlsEvents2.default.HLSJS_MEDIA_ATTACHED, func: this._onHlsJsMediaAttached }, { event: _HlsEvents2.default.HLSJS_MEDIA_DETACHED, func: this._onHlsJsMediaDetached }, { event: _HlsEvents2.default.STREAM_NETWORKMETRICS_CHANGED, func: this._onNetworkMetricsChanged }, { event: _HlsEvents2.default.HLSJS_SEEK_READY, func: this._onHlsJsSeekReady },
	
			/* MediaController events */
			{ event: _HlsEvents2.default.MEDIA_CONTROLLER_WIRED, func: this._onMediaControllerWired }, { event: _HlsEvents2.default.MEDIA_CONTROLLER_UNWIRED, func: this._onMediaControllerUnwired }, { event: _HlsEvents2.default.MEDIA_CANPLAY, func: this._onMediaCanPlay }, { event: _HlsEvents2.default.MEDIA_CANPLAYTHROUGH, func: this._onMediaCanPlayThrough }, { event: _HlsEvents2.default.MEDIA_DURATIONCHANGE, func: this._onMediaDurationChange }, { event: _HlsEvents2.default.MEDIA_TIMEUPDATE, func: this._onMediaTimeUpdate }, { event: _HlsEvents2.default.MEDIA_SEEKING, func: this._onMediaSeeking }, { event: _HlsEvents2.default.MEDIA_SEEKED, func: this._onMediaSeeked }, { event: _HlsEvents2.default.MEDIA_ENDED, func: this._onMediaEnded }, { event: _HlsEvents2.default.MEDIA_RATECHANGE, func: this._onMediaRateChange }, { event: _HlsEvents2.default.MEDIA_CONTROLLER_ERROR, func: this._onMediaControllerError }, { event: _HlsEvents2.default.MEDIA_ELEMENT_ERROR, func: this._onMediaElementError },
	
			/* internal test event */
			{ event: _HlsEvents2.default.TEST_EVENT, func: this._onTestEvent }]).wireHlsEvents();
	
			_HlsUtils2.default.applyConfig(this, config);
	
			this._hlsJsController.keyCache(_hlsKeyLoader);
		}
	
		_createClass(HlsController, [{
			key: '_promiseOverloadCheck',
			value: function _promiseOverloadCheck() {
				if (!this._disablePromiseOverloadCheck) {
					if (_HlsUtils2.default.isPromiseOverloaded()) {
						//if Promise doesn't match native prototype, emit warning
						_logger.logger.warn('The native Promise object has been overloaded. This may cause issues, as various native APIs will return native Promises.');
						this._emitWarning(_errors.ErrorDetails.PROMISE_IS_OVERLOADED);
					}
				} else {
					_logger.logger.log('Promise overload check has been disabled.');
				}
			}
		}, {
			key: '_runtimeCheck',
			value: function _runtimeCheck() {
				if (!this._runtimeCheckFinished) {
					//check if promise is overloaded
	
					this._promiseOverloadCheck();
	
					this._runtimeCheckFinished = true;
				}
			}
		}, {
			key: '_doDispose',
			value: function _doDispose() {
				_logger.logger.log('HlsController::_doDispose() instanceId ' + this._instanceId + ', instanceCount ' + _counter.active());
	
				if (!this._disposed) {
					this._disposed = true;
	
					// do not clear pendingDispose. Although we might schedule extra disposes, none of the extras will have effect,
					// because we'll have already disposed by the time they execute
					//	this._pendingDispose = false;
	
					_logger.logger.log('STREAM_DISPOSING');
					this._emit(_HlsEvents2.default.STREAM_DISPOSING);
	
					// no more video events please
					this._mediaController.dispose();
					//this._mediaController = null; //I wanted to null these out but there are too many assumptions. Should be fixed - SIEG
					this._hlsJsController.dispose();
					//this._hlsJsController = null; //I wanted to null these out but there are too many assumptions. Should be fixed - SIEG
	
					// start hlsjs destroy
					//FIXME: need to kill HlsJsController
					/*if ( this._hlsjs ) {
	    	this._unwireHlsJsEvents();
	    	this._hlsjs.destroy();
	    	this._hlsjs = null;
	    }*/
	
					this._source = null;
					this._media = null;
					this._pendingMedia = null;
	
					this._STREAM_VARIANTS_CHANGED = [];
					this._sourceLoaded = false;
					this._sourceMetadataLoaded = false;
	
					this._swallowNextSeek = false;
					this._seekOverHoleWorkaround = false;
	
					this._seekableRange = null;
					this._playbackRange = null;
					this._playbackMetrics = null;
	
					this._markers.dispose();
					this._markers = null;
	
					// this should free up _emitter
					this._handlers.unwireHlsEvents();
					this._handlers.dispose();
					this._handlers = null;
	
					_counter.decrement(); //Can't do it after the event
	
					// this is the final EVENT that will ever be emitted
					_logger.logger.log('STREAM_DISPOSED');
					this._emit(_HlsEvents2.default.STREAM_DISPOSED);
	
					this._emitter.removeAllListeners();
					this._emitter = null;
	
					// this will destroy our event handlers too...
					this._mediaEvents = null;
					this._hlsJsEvents = null;
	
					// ITS NOW ILLEGAL TO USE HlsController.
				}
			}
		}, {
			key: 'dispose',
			value: function dispose() {
				_logger.logger.log('HlsController::dispose()');
				// we might have active stuff on the nextTick already.
				// the problem with doing this is that the outside app won't be sure
				// that we've disposed when we return... that was always going to be a
				// problem eventually though.
				//process.nextTick( () => this._doDispose() );
	
				if (!this._disposed) {
					// if we're detached and unloaded, then just dispose immediately
					// if we're loading HlsJs will blow up...
					if (this._mediaState === _MediaStates2.default.DETACHED && this._state === _HlsStates2.default.UNLOADED) {
						this._doDispose();
					} else if (!this._pendingDispose) {
						_logger.logger.log('HlsController::dispose - pending dispose after detach');
						// otherwise, if we're not already pendingDispose, then we need to pend this dispose
						// and detach. MEDIA_DETACHED will then trigger the pendingDispose to be resolved.
						this._pendingDispose = true;
						// unload
						this._doDetach();
					}
				} else {
					_logger.logger.log('HlsController::dispose - already disposed');
				}
			}
		}, {
			key: 'loadPendingSource',
			value: function loadPendingSource() {
				_logger.logger.log('HlsController::loadPendingSource');
				/* TODO: do we reset in the event handler... or before running the event? */
				//this._source = url;
				if (this._state !== _HlsStates2.default.UNLOADED) {
					this._unloadSource();
				}
	
				//Should we do this? I've tested with and without. Need more testing - SIEG
				//this._resetState();
				//No. We should not as it breaks the way play works... but maybe pause should
				//be removed from it.
	
				this._loaded = false;
				var pendingUrl = this._pendingUrl;
				this._pendingUrl = null;
	
				this._beginStreamLoading(pendingUrl);
			}
		}, {
			key: 'loadSource',
			value: function loadSource(url) {
				var _this = this;
	
				_logger.logger.log('HlsController::loadSource()');
	
				if (url !== null && !_HlsUtils2.default.isString(url)) {
					throw new Error('loadSource: url ' + url + ' must be either null, or a string');
				}
	
				this._runtimeCheck();
	
				this._pendingUrl = null;
	
				//logger.log(this.isMediaAttached + ' ' + this._state);
	
				if (this._disposed) {
					_logger.logger.log('loadSource() Disposed; cannot load');
				} else {
					this._pendingUrl = url;
					this._safeDoNextTick(function () {
						return _this.doLoadSource();
					});
				}
			}
		}, {
			key: 'doLoadSource',
			value: function doLoadSource() {
				if (this._pendingUrl) {
					if ((this._mediaState === _MediaStates2.default.ATTACHED || this._mediaState === _MediaStates2.default.DETACHING) && this._state !== _HlsStates2.default.UNLOADED) {
						_logger.logger.log('doLoadSource() Need to detach first');
						if (this._media != null && this._mediaState !== _MediaStates2.default.DETACHING) {
							this._pendingMedia = this._media;
							_logger.logger.log('HlsController::doLoadSource() old media stashed');
						}
						this._doDetach(); //This can take time. It is best to wait for the event.
					} else {
						_logger.logger.log('doLoadSource() loadPendingSource');
						this.loadPendingSource();
					}
				}
			}
		}, {
			key: 'flushBuffer',
			value: function flushBuffer(levelFlush) {
				return this._hlsJsController.flushBuffer(!!levelFlush);
			}
		}, {
			key: 'attachMedia',
			value: function attachMedia(video) {
				_logger.logger.log('HlsController::attachMedia() { video: ' + video + ', mediaState: ' + this._mediaState + ' }');
	
				/*
	   if( video !== null && !(video instanceof HTMLMediaElement) ) {
	   	throw new TypeError( `HlsController::attachMedia(): { video: ${video} } must be an instanceof HTMLMediaElement, or null`);
	   }
	   */
	
				// start by nullifying source.
	
				// it is a requirement that we nullify the src when the media is
				// attached, or if the source is set to null. Best to nullify it
				// before we loadSource.
	
				// It will be set to something once loadSource is called with a non-null
				// parameter.
	
				if (!this._disposed) {
	
					//Moved to MediaController....
	
					//if( video && video.src && this._mediaState !== MediaState.DETACHING) {
					//	// its not as simple as setting the src to null.
					//	// https://github.com/w3c/media-source/issues/53
					//	video.removeAttribute('src');
					//	video.load();
					//}
	
					this._pendingMedia = video;
	
					if (this._mediaState !== _MediaStates2.default.DETACHED && this._mediaState !== _MediaStates2.default.DETACHING) {
						_logger.logger.log('HlsController::attachMedia, still attached, forcing detach, { mediaState: ' + this._mediaState + ', media: ' + this._media + ' }');
						this._doDetach();
					} else {
						// if we're ready to attach, don't wait for unwiring et al, just attach
						// the pendingMedia now.
						this._attachPendingMediaOrUrl();
					}
				} else {
					_logger.logger.log('attachMedia() Disposed; cannot attach');
				}
			}
		}, {
			key: 'detachMedia',
			value: function detachMedia() {
				_logger.logger.log('HlsController::detachMedia()');
	
				this._pendingMedia = null;
	
				this._doDetach();
			}
		}, {
			key: '_doDetach',
			value: function _doDetach() {
				var _this2 = this;
	
				// this should trigger DETACHING and then DETACHED.
				// unless we're already DETACHED.
				_logger.logger.log('HlsController::_doDetach() { mediaState: ' + this._mediaState + ' }');
	
				if (this._mediaState === _MediaStates2.default.DETACHED) {
					// if we're WIRED we never ATTACHED, if we're wiring, we never WIRED.
					// Either way, we can go straight to DETACHED and if necessary onMediaDetached
					// will take care of nulling the media.
	
					_logger.logger.log('HlsController::_doDetach(), already DETACHED emitting MEDIA_DETACHED anyway');
					// if we never attached, then we need to fake a MEDIA_DETACHED
					this._emit(_HlsEvents2.default.MEDIA_DETACHED, { media: null });
				} else if (this._mediaState !== _MediaStates2.default.DETACHING) {
					// a state transition (ie from WIRING -> WIRED), may already be in flight, and if we don't
					// do this on the next tick, then we would be pre-empting it...
	
					//It's possible to nextTick several DETACHINGS. Not sure if this is a problem - SIEG
					this._safeDoNextTick(function () {
						return _this2._emit(_HlsEvents2.default.MEDIA_DETACHING, { media: null });
					});
				} else {
					_logger.logger.log('HlsController::_doDetach() not requesting detach');
					_logger.logger.log(this._mediaState);
				}
			}
		}, {
			key: 'prefetch',
			value: function prefetch() {
				this._doStreamPrefetch();
			}
		}, {
			key: 'stopFetching',
			value: function stopFetching() {
				if (this.loaded && this._fetching) {
					this._fetching = false;
					this._hlsJsController.stopFetching();
				}
			}
		}, {
			key: 'resumeFetching',
			value: function resumeFetching() {
				if (this._loaded && !this._fetching) {
					this._fetching = true;
					this._hlsJsController.resumeFetching(this.currentTime);
				}
			}
		}, {
			key: 'pause',
			value: function pause() {
				this._doStreamPause();
			}
		}, {
			key: 'play',
			value: function play() {
				this._doStreamPlay();
			}
		}, {
			key: 'playPause',
			value: function playPause() {
				if (this._paused) {
					this.play();
				} else {
					this.pause();
				}
			}
		}, {
			key: 'seek',
			value: function seek(seconds) {
				_HlsUtils2.default.checkNotFiniteAndThrow(seconds, 'seek time');
				_HlsUtils2.default.checkLessThanZeroPointZeroAndWarn(seconds, 'seek time'); //we fix this in _determineSeekTime
				_logger.logger.log('seek: seconds: ' + seconds + ', currentTime: ' + this.currentTime + ', _seekableRange: [' + this._seekableRange.start + ',' + this._seekableRange.end + ']');
	
				if (this._playbackState === _PlaybackStates2.default.NOTREADY || this._playbackState === _PlaybackStates2.default.SEEKING || this._seekWaitingForBuffer) {
					_logger.logger.log('seek: pendingSeek playbackState: ' + this._playbackState + ' seekWaitingForBuffer: ' + this._seekWaitingForBuffer);
					this._pendingSeek = seconds;
				} else {
					var targetTime = this._determineSeekTime(seconds);
	
					if (this._audioOnlySeekWorkaround && this.audioOnly || this._dataReadySeekWorkaround) {
						var seekReady = false;
	
						for (var i = 0; i < this.bufferedRange.length; i++) {
							if (targetTime > this.bufferedRange[i].start && targetTime < this.bufferedRange[i].end) {
								seekReady = true;
							}
						}
	
						if (seekReady) {
							this._mediaController.seek(targetTime);
						} else {
							_logger.logger.log('seek: _seekWaitingForBuffer');
							this._hlsJsController.bufferBeforeSeeking = targetTime;
							this._seekWaitingForBuffer = true;
						}
					} else {
						this._mediaController.seek(targetTime);
					}
				}
			}
		}, {
			key: 'seekByPdt',
			value: function seekByPdt(time) {
				if (!_HlsUtils2.default.isValidDate(time)) {
					this._startTimeByPdt = time;
					throw new Error('seekByPdt: ' + time + ' is not a valid date');
				}
	
				var pdtBaseDate = this._hlsJsController.basePdt;
				if (_HlsUtils2.default.isValidDate(pdtBaseDate) && _HlsUtils2.default.isValidDate(time)) {
					var seekTime = 0;
	
					//seekTime = (time.getTime() - pdtBaseDate.getTime()) / 1000;
					seekTime = this.getTimeForPdt(time);
					_logger.logger.log('seekByPdt: seekTime: ' + seekTime + ' time: ' + time.getTime() / 1000 + ' pdtBaseDate: ' + pdtBaseDate.getTime() / 1000);
					this.seek(seekTime);
				}
			}
		}, {
			key: 'seekToLive',
			value: function seekToLive() {
				//TODO: need to apply some smarts if we haven't started yet, or are getting there
				if (this.live && this.currentTime < this.liveTime) {
					_logger.logger.log('seekToLive: liveTime: ' + this.liveTime + ', duration: ' + this.duration);
	
					this.seek(this.liveTime);
				}
			}
	
			/**
	   * Calculate the correct seek time
	   *
	   * we don't want to seek before the start of the seekable range, and if live we don't want to seek after live time
	   *
	   * seeking after the end of the seekable range is fine, the media element already handles that
	   *
	   * @param {Number} requestTime - the requested seekTime in seconds.
	   */
	
		}, {
			key: '_determineSeekTime',
			value: function _determineSeekTime(requestTime) {
				var seekTime = requestTime;
	
				seekTime = Math.min(seekTime, this._seekableRange.end);
	
				if (this.live) {
					seekTime = Math.min(seekTime, this.liveTime);
				}
	
				seekTime = Math.max(seekTime, this._seekableRange.start);
	
				_logger.logger.log('determineSeekTime: seeking to ' + seekTime);
	
				return Number(seekTime.toFixed(6));
			}
		}, {
			key: '_resolvePendingSeek',
			value: function _resolvePendingSeek() {
				_logger.logger.log('_resolvePendingSeek: _pendingSeek: ' + this._pendingSeek + ' _seekableRange: [' + this._seekableRange.start + ', ' + this._seekableRange.end + '] currentTime: ' + this.currentTime);
	
				if (this._pendingSeek !== this.currentTime) {
					//don't bother doing the pending seek if we're already at the target seek time
					this.seek(this._pendingSeek);
				}
	
				this._pendingSeek = undefined;
			}
		}, {
			key: '_onHlsJsSeekReady',
			value: function _onHlsJsSeekReady(data) {
				_logger.logger.log('_onHlsJsSeekReady: time: ' + data.time + ' _seekableRange: [' + this._seekableRange.start + ', ' + this._seekableRange.end + '] currentTime: ' + this.currentTime);
	
				this._seekWaitingForBuffer = false;
	
				this._mediaController.seek(this._determineSeekTime(data.time));
			}
		}, {
			key: '_wireEvents',
			value: function _wireEvents() {
				this._handlers._wireHlsEvents(this, this.emitter);
			}
		}, {
			key: '_unwireEvents',
			value: function _unwireEvents() {
				this._handlers._unwireHlsEvents(this.emitter);
			}
		}, {
			key: '_decidePlaybackState',
			value: function _decidePlaybackState() {
				var newState = void 0;
	
				if (this._state !== _HlsStates2.default.PLAYBACK) {
					newState = _PlaybackStates2.default.NOTREADY;
				} else if (this._ended) {
					newState = _PlaybackStates2.default.ENDED;
				} else if (this._seeking) {
					newState = _PlaybackStates2.default.SEEKING;
				} else if (this._paused) {
					newState = _PlaybackStates2.default.PAUSED;
				} else if (this._buffering) {
					newState = _PlaybackStates2.default.BUFFERING;
				} else {
					newState = _PlaybackStates2.default.PLAYING;
				}
	
				if (newState === _PlaybackStates2.default.NOTREADY && this._state === _HlsStates2.default.PLAYBACK) {
					throw new Error('PlaybackState should not be NOTREADY');
				}
	
				if (newState === undefined) {
					throw new Error('PlaybackState should not be undefined');
				}
	
				this._setPlaybackState(newState);
			}
		}, {
			key: '_setMediaState',
			value: function _setMediaState(newMediaState) {
				if (!newMediaState) {
					throw new Error('invalid mediaState: ' + newMediaState);
				}
	
				if (this._mediaState !== newMediaState) {
					var oldMediaState = this._mediaState;
					this._mediaState = newMediaState;
	
					this._doMediaStateChanged({ mediaState: newMediaState, lastMediaState: oldMediaState });
				}
			}
		}, {
			key: '_setPlaybackState',
			value: function _setPlaybackState(newPlaybackState) {
				if (!newPlaybackState) {
					throw new Error('invalid playbackState: ' + newPlaybackState);
				}
	
				if (this._playbackState !== newPlaybackState) {
					var oldPlaybackState = this._playbackState;
					this._playbackState = newPlaybackState;
	
					this._doStreamPlaybackStateChanged({
						playbackState: newPlaybackState,
						lastPlaybackState: oldPlaybackState
					});
				}
			}
		}, {
			key: '_setState',
			value: function _setState(newState) {
				if (!newState) {
					throw new Error('invalid state: ' + newState);
				}
	
				if (this._state !== newState) {
					var oldState = this._state;
					this._state = newState;
	
					this._doStreamStateChanged({ state: newState, lastState: oldState });
				}
			}
		}, {
			key: '_resetState',
			value: function _resetState() {
				if (!this._disposed) {
					_logger.logger.log('HlsController::_resetState');
					this._paused = true;
					this._canplay = false;
					this._canplaythrough = false;
					this._ended = false;
					this._seeking = false;
					this._buffering = false;
					this._loaded = false;
					this._fetching = false;
					this._prefetch = false;
					this._startPositionSet = false;
					this._canplayWaiting = false;
					this._markers.clearAllMarkers();
					this._seekableRange.start = undefined;
					this._seekableRange.end = undefined;
					this._seekableRange.duration = undefined;
					this._playbackRange.start = undefined;
					this._playbackRange.end = undefined;
					this._playbackRange.duration = undefined;
					this._prevDuration = 0;
					this._canplayWorkaroundCount = 0;
				}
			}
	
			/**
	   * this is purely used to set the internal media, and thus post when the result of
	   * get media has changed.
	   */
	
		}, {
			key: '_setMedia',
			value: function _setMedia(newMedia) {
				_logger.logger.log('HlsController::_setMedia');
	
				if (newMedia === undefined) {
					throw new Error('invalid media: ' + newMedia);
				}
	
				if (this._media !== newMedia) {
					var oldMedia = this._media;
					this._media = newMedia;
	
					var data = { media: newMedia, lastMedia: oldMedia };
					_logger.logger.log('STREAM_MEDIA_CHANGED: { media: ' + data.media + ' lastMedia: ' + data.lastMedia + ' }');
	
					this._emit(_HlsEvents2.default.STREAM_MEDIA_CHANGED, data);
				}
			}
		}, {
			key: '_startFetching',
			value: function _startFetching() {
				// se: ran into an issue where during disposal, this blew up... hacked in the penddispose check
				// but now its blowing up again during "prefetch then play works"
				// need to work out why State is not LOADED.
				if (!this._fetching) {
					if (this._state !== _HlsStates2.default.LOADED) {
						throw new Error('can\'t start fetching if not loaded! state: ' + this._state);
					}
	
					this._beginStreamFetching();
				}
			}
		}, {
			key: '_doStreamStateChanged',
			value: function _doStreamStateChanged(data) {
				_logger.logger.log('STREAM_STATE_CHANGED: { state: ' + data.state + ' lastState: ' + data.lastState + ' }');
	
				if (data.state === _HlsStates2.default.PLAYBACK || data.lastState === _HlsStates2.default.PLAYBACK) {
					this._decidePlaybackState();
				}
				this._emit(_HlsEvents2.default.STREAM_STATE_CHANGED, data);
			}
	
			/**
	   * log, emit and process the STREAM_PLAYBACKSTATE_CHANGED event.
	   *
	   * determines when buffering/seeking have finished
	   *
	   * dispatches to the next playback state handler based on the new state.
	   *
	   * @emits STREAM_PLAYBACKSTATE_CHANGED
	   * @emits STREAM_BUFFERING_FINISHED
	   * @emits STREAM_SEEKING_FINISHED
	   *
	   * @param {Object} data - event data
	   * @param {PlaybackState} data.playbackState - the new playbackState
	   * @param {PlaybackState} data.lastPlaybackState - the last playbackState
	   */
	
		}, {
			key: '_doStreamPlaybackStateChanged',
			value: function _doStreamPlaybackStateChanged(data) {
				_logger.logger.log('STREAM_PLAYBACKSTATE_CHANGED: { playbackState: ' + data.playbackState + ' lastPlaybackState: ' + data.lastPlaybackState + ' }');
	
				if (data.playbackState !== _PlaybackStates2.default.NOTREADY && data.playbackState !== _PlaybackStates2.default.SEEKING && this._pendingSeek !== undefined) {
					//seek was requested while we were unable to do anything with it, now that we can, resolve it
					this._resolvePendingSeek();
				}
	
				if (data.playbackState !== this._playbackState) {
					throw new Error('playbackState: ' + this._playbackState + ' out of sync with new playbackState ' + data.playbackState);
				}
	
				switch (data.playbackState) {
					case _PlaybackStates2.default.PAUSED:
						this._doPlaybackPaused();
						break;
					case _PlaybackStates2.default.BUFFERING:
						this._doPlaybackBuffering();
						break;
					case _PlaybackStates2.default.PLAYING:
						this._doPlaybackPlaying();
						break;
					case _PlaybackStates2.default.SEEKING:
						this._doPlaybackSeeking();
						break;
					case _PlaybackStates2.default.ENDED:
						this._doPlaybackEnded();
						break;
					case _PlaybackStates2.default.NOTREADY:
						//this._onPlaybackNotReady();
						this._emit(_HlsEvents2.default.PLAYBACK_NOTREADY);
						break;
	
					default:
						throw new Error('invalid playback state transition');
				}
	
				this._emit(_HlsEvents2.default.STREAM_PLAYBACKSTATE_CHANGED, data);
	
				switch (data.lastPlaybackState) {
					case _PlaybackStates2.default.BUFFERING:
						_logger.logger.log('STREAM_BUFFERING_FINISHED');
						this._emit(_HlsEvents2.default.STREAM_BUFFERING_FINISHED);
						break;
					case _PlaybackStates2.default.SEEKING:
						_logger.logger.log('STREAM_SEEKING_FINISHED');
						this._emit(_HlsEvents2.default.STREAM_SEEKING_FINISHED);
						break;
				}
			}
	
			/**
	   * log and emit the STREAM_MEDIASTATE_CHANGED event
	   */
	
		}, {
			key: '_doMediaStateChanged',
			value: function _doMediaStateChanged(data) {
				_logger.logger.log('STREAM_MEDIASTATE_CHANGED: { mediaState: ' + data.mediaState + ' lastMediaState: ' + data.lastMediaState + ' }');
	
				this._emit(_HlsEvents2.default.STREAM_MEDIASTATE_CHANGED, data);
			}
	
			/**
	   *  fired by HlsJsController
	   */
	
		}, {
			key: '_onManifestParsed',
			value: function _onManifestParsed(data) {
				if (this._recoveryOptions.startPdt !== undefined) {
					this._hlsJsController.recoveryStartTimeByPdt = this._recoveryOptions.startPdt;
					this._recoveryOptions.startPdt = undefined;
				}
				this._doStreamLoaded(data);
	
				// this kicks us along the prefetch/autoprefetch/
				this._afterStreamLoaded();
			}
	
			/**
	   *  used when we have an error, or when the user changes source.
	   */
	
		}, {
			key: '_unloadSource',
			value: function _unloadSource() {
				this._onStreamUnloaded();
				this._emit(_HlsEvents2.default.STREAM_UNLOADED);
			}
	
			/**
	   * in response to MEDIA_CONTROLLER_ERROR fired by MediaController.
	   */
	
		}, {
			key: '_handleMediaControllerError',
			value: function _handleMediaControllerError(data) {
				var _this3 = this;
	
				var theError = {};
	
				theError._data = data;
				theError.fatal = true;
				theError.cause = data.details;
				theError.streamId = this._instanceId;
				theError.source = this._source;
				theError.lastState = this._state;
				theError.lastPlaybackState = this._playbackState;
				theError.lastMediaState = this._mediaState;
	
				if (data.errorObj !== undefined) {
					theError.errorObj = data.errorObj;
				}
	
				theError.error = _HlsErrors2.default.MEDIA_CONTROLLER_FAILED;
				theError.message = _HlsErrorStrings2.default[theError.error];
				theError.messageDetailed = '[' + theError.error + '] ' + theError.message + ' (' + theError.cause + ')';
				theError.willDetachMedia = true;
				theError.willUnload = false;
	
				if (theError.willDetachMedia) {
					_logger.logger.log('MediaController Error; Detaching due to error');
					this._safeDoNextTick(function () {
						return _this3._emit(_HlsEvents2.default.MEDIA_DETACHING, { media: null });
					});
				}
	
				this._emit(_HlsEvents2.default.STREAM_ERROR, theError);
			}
		}, {
			key: '_emitError',
			value: function _emitError(errorFatal, errorCause, errorObj) {
	
				var errorData = {};
	
				errorData.details = errorCause;
				errorData.err = errorObj;
				errorData.fatal = errorFatal;
	
				this._handleError(errorData);
			}
		}, {
			key: '_emitWarning',
			value: function _emitWarning(errorCause, errorObj) {
				this._emitError(false, errorCause, errorObj);
			}
			/**
	   * in response to MEDIA_ELEMENT_ERROR fired by MediaController.
	   */
	
		}, {
			key: '_handleMediaElementError',
			value: function _handleMediaElementError(data) {
				_logger.logger.warn('media element errored out');
	
				var theError = {};
	
				theError._data = data;
				theError.cause = data.details;
				theError.streamId = this._instanceId;
				theError.source = this._source;
				theError.lastState = this._state;
				theError.lastPlaybackState = this._playbackState;
				theError.lastMediaState = this._mediaState;
	
				if (data.errorObj !== undefined) {
					theError.errorObj = data.errorObj;
				}
	
				if (data.mediaErrorObj !== undefined) {
					theError.mediaErrorObj = data.mediaErrorObj;
				}
	
				theError.error = _HlsErrors2.default.MEDIA_ELEMENT_FAILED;
				theError.message = _HlsErrorStrings2.default[theError.error];
				theError.messageDetailed = '[' + theError.error + '] ' + theError.message + ' (' + theError.cause + ')';
	
				if (this._autoRecover) {
					_logger.logger.log('media error recovery: autoRecover === true');
					theError.willDetachMedia = false;
					theError.willUnload = false;
					theError.fatal = false;
	
					this._emit(_HlsEvents2.default.STREAM_ERROR, theError);
	
					if (this._media) {
						_logger.logger.log('Attempting to recover media element');
						//HlsJs's auto recover doesn't work for us as we need to reset a lot of things outside of HlsJs
						this._doMediaErrorRecovery(true, true);
					}
				} else {
					_logger.logger.log('media error recovery: autoRecover === false, treating as fatal');
					theError.willDetachMedia = true;
					theError.willUnload = false;
					theError.fatal = true;
	
					this._emit(_HlsEvents2.default.STREAM_ERROR, theError);
	
					_logger.logger.log('MediaElement Error; Detaching due to error');
					this._doDetach();
				}
			}
		}, {
			key: '_handleError',
			value: function _handleError(data) {
				var theError = {};
				var shouldUnload = false;
	
				theError._data = data;
				theError.fatal = data.fatal;
				theError.cause = data.details;
				theError.streamId = this._instanceId;
				theError.source = this._source;
				theError.lastState = this._state;
				theError.lastPlaybackState = this._playbackState;
				theError.lastMediaState = this._mediaState;
	
				if (data.response !== undefined) {
					theError.response = data.response;
				}
	
				if (data.err !== undefined) {
					theError.errorObj = data.err;
				}
	
				// TODO: we should consider returning the currentTime (lastTime?) to
				// allow retrying with startTime = lastTime
	
				if (theError.cause === _errors.ErrorDetails.INTERNAL_EXCEPTION) {
					// we shouldn't get internalExceptions...
					theError.fatal = true;
				}
	
				// when click-to-play browsers are used, media.play can fail.
				// we then pause. Sometimes if you set isMuted=true, and try again
				// it might play.
				if (theError.cause === _errors.ErrorDetails.MEDIA_PLAY_FAILED) {
					this.pause();
				}
	
				if (theError.cause === _errors.ErrorDetails.BUFFER_STALLED_ERROR) {
					this._buffering = true;
					this._decidePlaybackState();
	
					this._emit(_HlsEvents2.default.STREAM_BUFFERING_STARTED);
	
					// swallow the error
					return;
				}
				if (theError.cause === _errors.ErrorDetails.BUFFER_SEEK_OVER_HOLE && this._seekOverHoleWorkaround) {
					// swallow unnecessary PLAYBACK_SEEKING events in IE
					this._swallowNextSeek = true;
				}
	
				// calculate error code
				if (!theError.fatal) {
					// a warning may eventually trigger a fatal error, but not this time.
					theError.error = _HlsErrors2.default.WARNING;
				} else {
					switch (this._state) {
						case _HlsStates2.default.UNLOADED:
							theError.error = _HlsErrors2.default.UNEXPECTED_ERROR;
							throw new Error('Should be impossible to have an error in state: ' + this._state + ', data:' + data);
						//break;
	
						case _HlsStates2.default.LOADING:
							theError.error = _HlsErrors2.default.LOAD_FAILED;
							shouldUnload = true;
							break;
	
						case _HlsStates2.default.FETCHING:
							theError.error = _HlsErrors2.default.FETCH_FAILED;
							shouldUnload = true;
							break;
	
						case _HlsStates2.default.PLAYBACK:
							theError.error = _HlsErrors2.default.PLAYBACK_FAILED;
							shouldUnload = true;
							break;
	
						default:
							theError.error = _HlsErrors2.default.UNEXPECTED_ERROR;
							shouldUnload = true;
							throw new Error('Should be impossible to be in this state : ' + this._state);
						//break;
					}
				}
	
				// add the error message
				theError.message = _HlsErrorStrings2.default[theError.error];
				theError.messageDetailed = '[' + theError.error + '] ' + theError.message + ' (' + theError.cause + ')';
	
				theError.willUnload = shouldUnload;
				theError.willDetachMedia = false; // FIXME: this needs to be derived.
	
				this._emit(_HlsEvents2.default.STREAM_ERROR, theError);
	
				if (shouldUnload) {
					_logger.logger.log('Unloading due to error');
					this._mediaController.pause();
					this.stopFetching();
					this._unloadSource();
				}
			}
	
			// also fired by HlsJsController
	
		}, {
			key: '_onHlsJsError',
			value: function _onHlsJsError(data) {
				/* TODO: this needs a lot more work! We may even want an ErrorController */
				_logger.logger.log('STREAM_ERROR');
				_logger.logger.log(data);
	
				this._handleError(data);
			}
		}, {
			key: '_doMediaErrorRecovery',
			value: function _doMediaErrorRecovery(force, recoverTime) {
				if (this._mediaErrorRecovery || force) {
	
					_logger.logger.log('_doMediaErrorRecovery: force: ' + force + ' _mediaErrorRecovery: ' + this._mediaErrorRecovery);
	
					this._mediaErrorRecovery = true;
	
					_logger.logger.log('_doMediaErrorRecovery: starting recovery');
	
					if (this._hlsJsController.basePdt) {
						this._hlsJsController._resumeBasePdt = this._hlsJsController.basePdt;
					}
					_logger.logger.log('_doMediaErrorRecovery: _resumeBasePdt ' + this._hlsJsController._resumeBasePdt);
	
					if (!this._paused) {
						this._playOnMediaErrorRecovery = true;
						_logger.logger.log('media error recovery: playback state not paused, will autoplay after recovery');
					} else {
						_logger.logger.log('media error recovery: playback state paused, will not autoplay');
					}
	
					if (recoverTime) {
						this._recoveryOptions.startPdt = this.getPdtForTime(this.currentTime);
						_logger.logger.log('media error recovery: recovered currentTime: ' + this._recoveryOptions.startPdt);
					} else if (this.live && this.liveTime !== 0) {
						this._recoveryOptions.startPdt = this.getPdtForTime(this.liveTime);
						_logger.logger.log('media error recovery: recovered liveTime: ' + this._recoveryOptions.startPdt);
					} else {
						this._recoveryOptions.startPdt = this.getPdtForTime(0);
						_logger.logger.log('media error recovery: zeroed currentTime: ' + this._recoveryOptions.startPdt);
					}
	
					this._recoveryOptions.playbackRate = this.playbackRate;
					_logger.logger.log('media error recovery: recovered playbackRate: ' + this._recoveryOptions.playbackRate);
					this._recoveryOptions.volume = this.volume;
					_logger.logger.log('media error recovery: recovered volume: ' + this._recoveryOptions.volume);
	
					if (this.currentAudioRendition) {
						this._hlsJsController.recoveryAudioIndex = this.currentAudioRendition;
						_logger.logger.log('media error recovery: recovered and applied audio rendition: ' + this.currentAudioRendition);
					}
	
					this._pendingUrl = this._source;
					this._pendingMedia = this._media;
					this._doDetach();
				} else {
					_logger.logger.log('_doMediaErrorRecovery: already in recovery');
				}
			}
		}, {
			key: '_onHlsJsMediaAttached',
			value: function _onHlsJsMediaAttached(data) {
				_logger.logger.log('HLSJS_MEDIA_ATTACHED: { media: ' + data.media + ' mediaState: ' + this._mediaState + ' }');
	
				if (this._mediaState === _MediaStates2.default.ATTACHING) {
					this._emit(_HlsEvents2.default.MEDIA_ATTACHED, data);
				} else if (this._mediaState === _MediaStates2.default.DETACHING) {
					this._hlsJsController.detachMedia();
				} else {
					throw new Error('HlsController::_onHlsJsMediaAttached invalid mediaState { ' + this._mediaState + ' }');
				}
			}
		}, {
			key: '_onHlsJsMediaDetached',
			value: function _onHlsJsMediaDetached(data) {
				_logger.logger.log('HLSJS_MEDIA_DETACHED: { media: ' + data.media + ' mediaState: ' + this._mediaState + ' }');
	
				if (this._mediaState === _MediaStates2.default.DETACHING) {
					// will trigger MEDIA_CONTROLLER_UNWIRED
					this._mediaController.media = null;
				} else {
					throw new Error('HlsController::_onHlsJsMediaDetached invalid mediaState { ' + this._mediaState + ' }');
				}
			}
		}, {
			key: '_onChunkBuffered',
			value: function _onChunkBuffered() {
				this._updatePlaybackRange();
	
				if (this._canplayWorkaround && !this._canplay) {
					//Firefox is very cautious about declaring canplay/canplaythrough compared to other browsers that do it as
					//soon as possible. In some cases Firefox doesn't send canplay at all.
					//This workaround causes canplay to be triggered at around the same time as other browsers, greatly
					//increasing performance.
					this._canplayWorkaroundCount++;
	
					if (this._canplayWorkaroundCount > 2) {
						//forcing canplay on the first two frag loads interferes with startTimeByPdt
						this._doStreamCanPlay();
					}
				}
	
				if (this._checkIfInBufferedRange()) {
					this._buffering = false;
					if (this._state === _HlsStates2.default.PLAYBACK && this._seeking && !this._disableFakeSeek) {
						//If we're in this situation, a seek has happened, and resolved, but MEDIA_SEEKED has not fired
						//run mediaController._onMediaSeeked here to properly reset the state of the controllers
						_logger.logger.log('faking a MEDIA_SEEKED');
						this._mediaController._onMediaSeeked();
						//this._emit(Event.MEDIA_SEEKED, { currentTime : this.currentTime });
					}
				}
				this._decidePlaybackState();
	
				this._markers.trimMeta(this.bufferedRange[0].start);
			}
		}, {
			key: '_onHlsJsSubtitleUpdate',
			value: function _onHlsJsSubtitleUpdate() {
				this._mediaController.captionsControl();
			}
		}, {
			key: '_onVariantDurationUpdate',
			value: function _onVariantDurationUpdate(data) {
				if (this._seekableRange.start === undefined || this._seekableRange.start < data.totalDuration - data.playlistDuration || this._seekableRange.end < data.totalDuration) {
					this._seekableRange.end = data.totalDuration;
					this._seekableRange.duration = data.playlistDuration;
					this._seekableRange.start = Math.max(this._seekableRange.end - this._seekableRange.duration, 0);
				}
	
				this._checkIfInSeekableRange();
				this._updatePlaybackRange();
			}
		}, {
			key: '_onStartPositionSet',
			value: function _onStartPositionSet(data) {
				this._startPositionSet = true;
				this._startPosition = data.startPosition;
	
				if (this._canplayWaiting) {
					this._doStreamCanPlay();
				}
			}
	
			// Player States
	
		}, {
			key: '_onStreamUnloaded',
			value: function _onStreamUnloaded() {
				_logger.logger.log('STREAM_UNLOADED');
				this._setState(_HlsStates2.default.UNLOADED);
	
				// need to reset stuff.
				this._prefetch = false;
			}
		}, {
			key: '_beginStreamLoading',
			value: function _beginStreamLoading(url) {
				_logger.logger.log('STREAM_LOADING: { url: ' + url + ' }');
	
				this._source = url;
	
				this._setState(_HlsStates2.default.LOADING);
				this._hlsJsController.loadSource(url);
	
				// if we have a source, and media, we should attach.
				// this is because we have a requirement to NOT attach when
				// source is null
				// If the source wasn't attached when WIRED came through, we'll
				// be stuck in WIRED waiting for a source.
				if (this._source !== null && this._mediaState === _MediaStates2.default.WIRED) {
					_logger.logger.log('_beginStreamLoading: mediaState: ' + this._mediaState);
	
					this._attemptMediaAttaching();
				}
	
				this._emit(_HlsEvents2.default.STREAM_LOADING, { url: url });
			}
	
			// after we've done _doStreamLoaded AND emitted the event
	
		}, {
			key: '_afterStreamLoaded',
			value: function _afterStreamLoaded() {
				if (!this._prefetch && (this._autoPrefetch || this._paused === false)) {
					this.prefetch();
				}
				if (this._mediaErrorRecovery) {
					_logger.logger.log('media error recovery: reapplying state before error');
					if (this._playOnMediaErrorRecovery) {
						this.play();
						this._playOnMediaErrorRecovery = false;
						_logger.logger.log('media error recovery: playing video');
					}
	
					if (this._recoveryOptions.playbackRate) {
						this.playbackRate = this._recoveryOptions.playbackRate;
						this._recoveryOptions.playbackRate = undefined;
						_logger.logger.log('media error recovery: reapplying playbackRate: ' + this.playbackRate);
					}
	
					if (this._recoveryOptions.volume) {
						this.volume = this._recoveryOptions.volume;
						this._recoveryOptions.volume = undefined;
						_logger.logger.log('media error recovery: reapplying volume: ' + this.volume);
					}
	
					this._mediaErrorRecovery = false;
				} else if (this.paused && this._autoPlay) {
					this.play(); // will take care of prefetch for the autoplay case.
				}
	
				// we'll issues the play to the media after CANPLAYTHROUGH.
			}
		}, {
			key: '_doStreamLoaded',
			value: function _doStreamLoaded(data) {
				_logger.logger.log('STREAM_LOADED');
	
				this._loaded = true;
	
				this._setState(_HlsStates2.default.LOADED);
	
				this._emit(_HlsEvents2.default.STREAM_LOADED, data);
			}
		}, {
			key: '_beginStreamFetching',
			value: function _beginStreamFetching() {
				_logger.logger.log('STREAM_FETCHING');
	
				this._fetching = true;
				this._setState(_HlsStates2.default.FETCHING);
	
				this._hlsJsController.startFetching();
	
				this._emit(_HlsEvents2.default.STREAM_FETCHING);
			}
		}, {
			key: '_beginStreamPlayback',
			value: function _beginStreamPlayback() {
				_logger.logger.log('STREAM_PLAYBACK');
				this._setState(_HlsStates2.default.PLAYBACK); // will decide playbackState
	
				this._emit(_HlsEvents2.default.STREAM_PLAYBACK);
			}
	
			// PLAYBACK STATES
	
		}, {
			key: '_doPlaybackSeeking',
			value: function _doPlaybackSeeking() {
				if (this._swallowNextSeek) {
					this._swallowNextSeek = false;
				} else {
					_logger.logger.log('PLAYBACK_SEEKING');
					this._emit(_HlsEvents2.default.PLAYBACK_SEEKING);
				}
			}
		}, {
			key: '_doPlaybackPaused',
			value: function _doPlaybackPaused() {
				_logger.logger.log('PLAYBACK_PAUSED');
				this._mediaController.pause();
				this._emit(_HlsEvents2.default.PLAYBACK_PAUSED);
			}
		}, {
			key: '_doPlaybackBuffering',
			value: function _doPlaybackBuffering() {
				_logger.logger.log('PLAYBACK_BUFFERING');
				this._emit(_HlsEvents2.default.PLAYBACK_BUFFERING);
			}
		}, {
			key: '_doPlaybackPlaying',
			value: function _doPlaybackPlaying() {
				var _this4 = this;
	
				_logger.logger.log('PLAYBACK_PLAYING');
				var playPromise = this._mediaController.play();
				this._emit(_HlsEvents2.default.PLAYBACK_PLAYING);
	
				playPromise.then(function () {
					if (_this4._seekBackOnPlay) {
						_this4.currentTime -= 0.000001;
						_this4._seekBackOnPlay = false;
					}
				}).catch(function (err) {
					if (!_this4._disposed && !_this4._paused) {
						_this4._emitWarning(_errors.ErrorDetails.MEDIA_PLAY_FAILED, err);
					}
				});
			}
		}, {
			key: '_doPlaybackEnded',
			value: function _doPlaybackEnded() {
				_logger.logger.log('PLAYBACK_ENDED');
				// no need to pause mediaController. If we seek etc, it'll use the last state.
				this.playbackRate = 1;
				this._emit(_HlsEvents2.default.PLAYBACK_ENDED);
			}
	
			/*
	  	we seem to get Media CANPLAY just after buffer depletions...
	  */
	
		}, {
			key: '_doStreamCanPlay',
			value: function _doStreamCanPlay() {
				_logger.logger.log('STREAM_CANPLAY');
	
				if (this._lateStartWorkaround && this.audioOnly) {
					this.seek(this._startPosition);
				}
	
				this._canplay = true;
				this._initialTime = this._startPosition;
	
				this._buffering = true;
	
				if (this._state !== _HlsStates2.default.FETCHING) {
					throw new Error('impossible not to be in fetching when canplay comes through');
				}
	
				this._emit(_HlsEvents2.default.STREAM_CANPLAY);
	
				// decide playback happens onStreamPlayback
				this._beginStreamPlayback();
			}
	
			// and media CANPLAYTHROUGH seems to signal end of media buffering
	
		}, {
			key: '_doStreamCanPlayThrough',
			value: function _doStreamCanPlayThrough() {
				_logger.logger.log('STREAM_CANPLAYTHROUGH');
	
				this._canplaythrough = true;
	
				this._buffering = false;
				this._ended = false;
	
				// running a captions control here fixes a couple of issues that are detailed in the media controller
				this._mediaController.captionsControl();
	
				this._emit(_HlsEvents2.default.STREAM_CANPLAYTHROUGH);
	
				this._decidePlaybackState();
			}
	
			// commands
	
		}, {
			key: '_doStreamPrefetch',
			value: function _doStreamPrefetch() {
				if (this._state === _HlsStates2.default.LOADED) {
					this._prefetch = true;
					this._emit(_HlsEvents2.default.STREAM_PREFETCH);
					this._startFetching();
				}
			}
	
			// perhaps need a pause/play/buffer/fetching decider function.
	
		}, {
			key: '_doStreamPause',
			value: function _doStreamPause() {
				_logger.logger.log('HlsController::_doStreamPause');
				this._paused = true;
				this._emit(_HlsEvents2.default.STREAM_PAUSE);
	
				this._decidePlaybackState();
			}
		}, {
			key: '_doStreamPlay',
			value: function _doStreamPlay() {
				_logger.logger.log('HlsController::_doStreamPlay');
				this._paused = false;
				this._ended = false;
				if (this._checkIfInBufferedRange()) {
					this._buffering = false;
				}
	
				this._emit(_HlsEvents2.default.STREAM_PLAY);
	
				// if we aren't already, we need prefetch()
				if (!this._prefetch) {
					this.prefetch();
				}
				this._decidePlaybackState();
			}
		}, {
			key: '_attemptMediaAttaching',
			value: function _attemptMediaAttaching() {
				_logger.logger.log('HlsController::_attemptMediaAttaching');
	
				if (this._mediaState === _MediaStates2.default.WIRED && this._source !== null) {
					this._emit(_HlsEvents2.default.MEDIA_ATTACHING, { media: this._media });
				}
			}
		}, {
			key: '_attachPendingMediaOrUrl',
			value: function _attachPendingMediaOrUrl() {
				_logger.logger.log('HlsController::_attachPendingMediaOrUrl { mediaState: ' + this._mediaState + ' }');
	
				if (this._mediaState !== _MediaStates2.default.DETACHING) {
					_logger.logger.log('HlsController::_attachPendingMediaOrUrl checking for pending Url or Media');
					if (this._pendingMedia) {
						if (this._media) {
							throw new Error('_attachPendingMediaOrUrl with valid media already set!');
						}
	
						_logger.logger.log('HlsController::_attachPendingMediaOrUrl: wiring media ' + this._pendingMedia);
	
						this._setMedia(this._pendingMedia);
						this._pendingMedia = null;
	
						this._emit(_HlsEvents2.default.MEDIA_WIRING, { media: this._media });
	
						//console.log(`preBUMP _prefetch: ${this._prefetch} _paused: ${this._paused}
						// _autoPrefetch: ${this._canplay} _canplay: ${this._canplay} _state: ${this._state}`);
						//This is causing regressions in tests that load source before attaching media. Need a better solution.
						/*if (!this._canplay && this._source !== null && this._state === State.FETCHING) {
	     	logger.log('Likely load stall. Reload.'); //Not the best solution. Investigate. - SIEG
	     	this._pendingUrl = this._source;
	     }*/
					}
					if (this._pendingUrl) {
	
						_logger.logger.log('HlsController::_attachPendingMediaOrUrl: setting url ' + this._pendingUrl);
						this.loadPendingSource();
					}
				}
			}
		}, {
			key: '_onMediaWiring',
			value: function _onMediaWiring(data) {
				// no nulll, no undefined.
				if (!data.media) {
					throw new Error('HlsController::_onMediaWiring, invalid media { media: ' + data.media + ' }');
				}
	
				_logger.logger.log('MEDIA_WIRING: { media: ' + data.media + ' mediaState: ' + this._mediaState + ' }');
	
				this._setMediaState(_MediaStates2.default.WIRING);
	
				this._mediaController.media = data.media;
			}
		}, {
			key: '_onMediaWired',
			value: function _onMediaWired(data) {
				var _this5 = this;
	
				_logger.logger.log('MEDIA_WIRED: { media: ' + data.media + ' mediaState: ' + this._mediaState + ' }');
	
				this._media = data.media;
	
				this._setMediaState(_MediaStates2.default.WIRED);
	
				// if we have a pending detach, might as well skip attaching and fake a MEDIA_DETACHED
	
				if (this._source !== null) {
					_logger.logger.log('_onMediaWired, queuing _attemptMediaAttaching');
	
					// to keep things ordered, we'll delay attaching until nextTick.
					this._safeDoNextTick(function () {
						return _this5._attemptMediaAttaching();
					});
				}
			}
		}, {
			key: '_onMediaAttaching',
			value: function _onMediaAttaching(data) {
				var _this6 = this;
	
				_logger.logger.log('MEDIA_ATTACHING: { media: ' + data.media + ' mediaState: ' + this._mediaState + ' }');
	
				if (!(data.media instanceof HTMLMediaElement)) {
					throw new Error('HlsController::_onMediaAttaching, invalid media { media: ' + data.media + ' }');
				}
	
				if (this._mediaState !== _MediaStates2.default.WIRED) {
					throw new Error('HlsController::_onMediaAttaching, invalid state { mediaState: ' + this._mediaState + ' }');
				}
	
				this._setMediaState(_MediaStates2.default.ATTACHING);
	
				_logger.logger.log('_onMediaAttaching, queuing _hlsJsController.attachMedia');
	
				// attachMedia will emit HLSJS_MEDIA_ATTACHED eventually
				this._safeDoNextTick(function () {
					return _this6._hlsJsController.attachMedia(data.media);
				});
			}
		}, {
			key: '_onMediaAttached',
			value: function _onMediaAttached(data) {
				_logger.logger.log('MEDIA_ATTACHED: { media: ' + data.media + ', mediaState: ' + this._mediaState + ' }');
	
				if (this._mediaState !== _MediaStates2.default.ATTACHING) {
					throw new Error('HlsController::_onMediaAttached invalid state { mediaState: ' + this._mediaState + ' }');
				}
				// otherwise we're good to go to attached
				this._setMediaState(_MediaStates2.default.ATTACHED);
			}
		}, {
			key: '_onMediaDetaching',
			value: function _onMediaDetaching(data) {
				var _this7 = this;
	
				_logger.logger.log('MEDIA_DETACHING: { media: ' + data.media + ' mediaState: ' + this._mediaState + ' }');
	
				if (this._mediaState === _MediaStates2.default.DETACHED) {
					throw new Error('HlsController::_onMediaDetaching invalid mediaState { ' + this._mediaState + '}');
				}
	
				var lastMediaState = this._mediaState;
	
				this._setMediaState(_MediaStates2.default.DETACHING);
	
				// if media is ATTACHING or WIRING, it will resolve DETACHING when it completes
	
				// if we're wiring or wired, then set media to null.
				if (lastMediaState === _MediaStates2.default.WIRING || lastMediaState === _MediaStates2.default.WIRED) {
					_logger.logger.log('HlsController::_onMediaDetaching unwiring mediaController');
	
					this._safeDoNextTick(function () {
						if (_this7._mediaController.media) {
							_this7._mediaController.media = null;
						} else {
							/* if mediaController is already nulled, then it won't emit UNWIRED */
							_this7._emit(_HlsEvents2.default.MEDIA_CONTROLLER_UNWIRED, { media: null });
						}
					});
				} else if (lastMediaState === _MediaStates2.default.ATTACHED) {
					_logger.logger.log('HlsController::_onMediaDetaching detaching hlsJsController');
					this._hlsJsController.detachMedia();
				}
	
				// all other cases nothing to do.
			}
		}, {
			key: '_onMediaDetached',
			value: function _onMediaDetached(data) {
				var _this8 = this;
	
				_logger.logger.log('MEDIA_DETACHED: { media: ' + data.media + ' }');
	
				this._setMedia(null);
	
				this._setMediaState(_MediaStates2.default.DETACHED);
				this._resetState();
	
				if (this._pendingDispose) {
					_logger.logger.log('HlsController::_onMediaDetached processing _pendingDispose');
					//this._doDispose();
	
					// we need to do the dispose after the next tick to ensure all listeners can handle
					// the MEDIA_DETACHED event before the final STREAM_DISPOSED event is emitted.
					process.nextTick(function () {
						return _this8._doDispose();
					});
				} else if (!this._disposed) {
					// if we have a pending media or url... its time to handle it.
					this._attachPendingMediaOrUrl();
				}
			}
		}, {
			key: '_safeDoNextTick',
			value: function _safeDoNextTick(lambda) {
				var _this9 = this;
	
				process.nextTick(function () {
					if (!_this9._disposed) {
						lambda();
					}
				});
			}
		}, {
			key: '_onMediaControllerWired',
			value: function _onMediaControllerWired(data) {
				var _this10 = this;
	
				_logger.logger.log('MEDIA_CONTROLLER_WIRED: { media: ' + data.media + ' mediaState: ' + this._mediaState + ' }');
	
				if (this._mediaState === _MediaStates2.default.WIRING) {
					this._safeDoNextTick(function () {
						return _this10._emit(_HlsEvents2.default.MEDIA_WIRED, data);
					});
				} else if (this._mediaState === _MediaStates2.default.DETACHING) {
					this._mediaController = null;
				} else {
					throw new Error('HlsController::_onMediaControllerWired invalid state { mediaState: ' + this._mediaState + ' }');
				}
			}
		}, {
			key: '_onMediaControllerUnwired',
			value: function _onMediaControllerUnwired(data) {
				var _this11 = this;
	
				_logger.logger.log('MEDIA_CONTROLLER_UNWIRED: { media: ' + data.media + ' mediaState: ' + this._mediaState + ' }');
	
				if (this._mediaState === _MediaStates2.default.DETACHING) {
					this._safeDoNextTick(function () {
						return _this11._emit(_HlsEvents2.default.MEDIA_DETACHED, data);
					});
				} else {
					throw new Error('HlsController:_onMediaControllerUnwired invalid state { mediaState: ' + this._mediaState + ' }');
				}
			}
		}, {
			key: '_onMediaControllerError',
			value: function _onMediaControllerError(data) {
				_logger.logger.log('MEDIA_CONTROLLER_ERROR: { data: ' + data + ' }');
	
				this._handleMediaControllerError(data);
			}
		}, {
			key: '_onMediaElementError',
			value: function _onMediaElementError(data) {
				_logger.logger.log('MEDIA_ELEMENT_ERROR: { data: ' + data + ' }');
	
				this._handleMediaElementError(data);
			}
		}, {
			key: '_onMediaCanPlayThrough',
			value: function _onMediaCanPlayThrough() {
				_logger.logger.log('MEDIA_CANPLAYTHROUGH');
	
				if (!this._canplaythrough) {
					this._doStreamCanPlayThrough();
				} else {
					_logger.logger.log('redundant CANPLAYTHROUGH call, ignoring');
				}
			}
		}, {
			key: '_onMediaDurationChange',
			value: function _onMediaDurationChange() {
				_logger.logger.log('MEDIA_DURATIONCHANGE');
	
				var data = { duration: this._mediaController.duration, lastDuration: this._prevDuration };
	
				this._prevDuration = this._mediaController.duration;
	
				this._emit(_HlsEvents2.default.STREAM_DURATION_CHANGED, data);
			}
		}, {
			key: '_onMediaTimeUpdate',
			value: function _onMediaTimeUpdate(data) {
				this._updatePlaybackRange();
	
				if (this.live) {
					if (this.playbackRate > 1 && this.currentTime > this.liveTime) {
						_logger.logger.log('live time reached, setting playback rate to 1');
						this.playbackRate = 1;
					} else if (this.currentTime <= this.seekableRange.start && this.playbackRate < 1) {
						_logger.logger.log('start of stream reached, setting playback rate to 1');
						this.playbackRate = 1;
					}
				}
				this._emit(_HlsEvents2.default.STREAM_TIMEUPDATE, data);
			}
		}, {
			key: '_onMediaCanPlay',
			value: function _onMediaCanPlay() {
				_logger.logger.log('MEDIA_CANPLAY');
	
				if (!this._canplay) {
					if (this._startPositionSet) {
						this._doStreamCanPlay();
					} else {
						this._canplayWaiting = true;
					}
				} else {
					_logger.logger.log('redundant CANPLAY call, ignoring');
				}
			}
		}, {
			key: '_onMediaSeeking',
			value: function _onMediaSeeking() {
				if (this._mediaState !== _MediaStates2.default.DETACHING) {
					//probably a safe-shutdown seek.
					_logger.logger.log('MEDIA_SEEKING');
					if (!this._fetching && this._state === _HlsStates2.default.PLAYBACK) {
						//stopFetching() was called at some point and we need to resume fetching or the seek will never finish
						this.resumeFetching();
					}
	
					this._seeking = true;
					this._ended = false;
					_logger.logger.log('playbackRange: [' + this._playbackRange.start + ',' + this._playbackRange.end + ',' + this._playbackRange.duration + '], isLive: ' + this.live);
				}
				this._decidePlaybackState();
			}
		}, {
			key: '_onMediaSeeked',
			value: function _onMediaSeeked() {
				if (this._seeking) {
					_logger.logger.log('MEDIA_SEEKED');
					this._seeking = false;
				}
				if (this._checkIfInBufferedRange()) {
					this._buffering = false;
				}
	
				this._decidePlaybackState();
			}
		}, {
			key: '_onMediaEnded',
			value: function _onMediaEnded() {
				//console.log('MEDIA_ENDED');
				this._ended = true;
				this._seeking = false;
				this._buffering = false;
				//this._canplay = false;
				//this._canplaythrough = false;
	
				this._decidePlaybackState();
			}
		}, {
			key: '_onMediaRateChange',
			value: function _onMediaRateChange() {
				_logger.logger.log('MEDIA_RATECHANGE');
	
				var lastPlaybackRate = this._lastPlaybackRate;
				this._lastPlaybackRate = this.playbackRate; //need to update this before the event is sent in case the rate is changed as a response to the event
	
				this._emit(_HlsEvents2.default.STREAM_PLAYBACKRATE_CHANGED, { playbackRate: this.playbackRate, lastPlaybackRate: lastPlaybackRate });
	
				if (this._forcePlaybackRateWorkaround || this._resyncPlaybackRateWorkaround && this.playbackRate === 1 && lastPlaybackRate !== 1) {
					if (this._paused) {
						this._seekBackOnPlay = true;
					} else {
						this.currentTime -= 0.000001;
					}
				}
			}
		}, {
			key: '_updatePlaybackRange',
			value: function _updatePlaybackRange() {
				this._playbackRange.start = this.currentTime;
				this._playbackRange.end = Math.min(this.seekableRange.end, this.bufferedRangeCurrent.end);
				this._playbackRange.duration = this._playbackRange.end - this._playbackRange.start;
			}
		}, {
			key: '_checkIfInSeekableRange',
			value: function _checkIfInSeekableRange() {
				_logger.logger.log('_checkIfInSeekableRange: currentTime: ' + this.currentTime + ' _seekableRange.start: ' + this._seekableRange.start);
	
				if (this._seekableRange.start > this.currentTime) {
					var data = { currentTime: this.currentTime, windowStart: this._seekableRange.start,
						timeBehindWindow: this._seekableRange.start - this.currentTime };
					_logger.logger.warn('playhead has fallen behind sliding window start @' + this.currentTime);
					//if we're not buffered, or we're not live, readjust to the start of the range
					//we need to bypass seek here as we may be in NOTREADY or SEEKING when this happens and don't want to buffer a pending seek
					if (!this._checkIfInBufferedRange() || !this.live) {
						//we're going a millisecond in as in some cases, skipping to the very start of the range just doesn't work
						_logger.logger.warn('attempting to correct playhead');
						this._mediaController.currentTime = this.seekableRange.start + 0.001;
					}
	
					this._emit(_HlsEvents2.default.STREAM_PLAYHEAD_BEHIND_SLIDING_WINDOW, data);
				}
			}
		}, {
			key: '_checkIfInBufferedRange',
			value: function _checkIfInBufferedRange() {
				for (var i = 0; i < this.bufferedRange.length; i++) {
					if (this.bufferedRange[i].start !== this.bufferedRange[i].end && this.currentTime >= this.bufferedRange[i].start && this.currentTime <= this.bufferedRange[i].end) {
						return true;
					}
				}
	
				return false;
			}
		}, {
			key: 'on',
			value: function on(event, func) {
				_HlsUtils2.default.throwIfNotEvent(event);
	
				this._emitter.on(event, func);
			}
		}, {
			key: 'off',
			value: function off(event, func) {
				_HlsUtils2.default.throwIfNotEvent(event);
	
				this._emitter.off(event, func);
			}
		}, {
			key: 'once',
			value: function once(event, func) {
				_HlsUtils2.default.throwIfNotEvent(event);
	
				this._emitter.once(event, func);
			}
		}, {
			key: '_emit',
			value: function _emit(event) {
				var _emitter;
	
				for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
					args[_key - 1] = arguments[_key];
				}
	
				(_emitter = this._emitter).emit.apply(_emitter, [event].concat(args));
			}
		}, {
			key: 'getConstraints',
			value: function getConstraints() {
				return this._hlsJsController.getConstraints();
			}
		}, {
			key: 'setConstraints',
			value: function setConstraints(constraints) {
				var causeNoSideEffects = false;
	
				if (this._mediaState === _MediaStates2.default.DETACHED || this._state === _HlsStates2.default.UNLOADED) {
					causeNoSideEffects = true;
				}
	
				this._hlsJsController.setConstraints(constraints, causeNoSideEffects);
			}
		}, {
			key: 'getTimeouts',
			value: function getTimeouts() {
				return this._hlsJsController.getTimeouts();
			}
		}, {
			key: 'setTimeouts',
			value: function setTimeouts(timeouts) {
				this._hlsJsController.setTimeouts(timeouts);
			}
		}, {
			key: 'getPlaybackMetrics',
	
	
			/**
	  * return a HlsPlaybackMetrics structure
	  *
	  * https://jira.mlbam.com/browse/BAMHLS-309
	  *
	  * From Primetime TVSDK API PlaybackMetrics:
	  * - bitrate:Number;
	  * - bufferLength:Number;
	  * - bufferTime:Number;
	  * - droppedFramesCount:Number;
	  * - frameRate:Number;
	  * - readHead:Number;
	  * - time:Number;
	  *
	  * - bufferedRange:VideoTimeRange;
	  * - playbackRange:VideoTimeRange;
	  * - seekableRange:VideoTimeRange;
	  *
	  * @returns {HlsPlaybackMetrics}
	    */
			//TODO: change this so that it's a persistent object, like network metrics
			//the base of it is already there, for bitrate, it just needs to be expanded
			value: function getPlaybackMetrics() {
				var metrics = {};
	
				metrics.bitrate = this._playbackMetrics.bitrate;
				metrics.droppedFramesCount = this._mediaController.droppedFramesCount;
				metrics.frameRate = this._mediaController.frameRate;
				metrics.time = this.currentTime;
				//
				metrics.bufferedRange = this.bufferedRangeCurrent;
				metrics.playbackRange = this.playbackRange;
				metrics.seekableRange = this.seekableRange;
	
				return metrics;
			}
		}, {
			key: 'getNetworkMetrics',
			value: function getNetworkMetrics() {
				return this._hlsJsController.getNetworkMetrics();
			}
		}, {
			key: 'getDrmCapabilities',
			value: function getDrmCapabilities() {
				return this._hlsJsController.getDrmCapabilities();
			}
		}, {
			key: '_onNetworkMetricsChanged',
			value: function _onNetworkMetricsChanged(data) {
				var lastMetrics = data.lastNetworkMetrics;
				var currentMetrics = data.networkMetrics;
	
				if (currentMetrics.chosenVariant !== lastMetrics.chosenVariant) {
					var eventData = { chosenVariant: currentMetrics.chosenVariant, lastChosenVariant: lastMetrics.chosenVariant };
	
					this._emit(_HlsEvents2.default.STREAM_CHOSENVARIANT_CHANGED, eventData);
				}
	
				if (currentMetrics.chosenBitrate !== lastMetrics.chosenBitrate) {
					this._playbackMetrics.bitrate = currentMetrics.chosenBitrate;
	
					var _eventData = { chosenBitrate: currentMetrics.chosenBitrate, lastChosenBitrate: lastMetrics.chosenBitrate };
	
					this._emit(_HlsEvents2.default.STREAM_CHOSENBITRATE_CHANGED, _eventData);
				}
			}
		}, {
			key: '_onTestEvent',
			value: function _onTestEvent(data) {
				_logger.logger.log('TEST_EVENT received');
				this.testEventData = data;
			}
		}, {
			key: 'fireTestEvent',
			value: function fireTestEvent(data) {
				_logger.logger.log('firing TEST_EVENT');
				this._emit(_HlsEvents2.default.TEST_EVENT, data);
			}
		}, {
			key: 'addUserMarker',
			value: function addUserMarker(time, callback, data) {
				return this._markers.addTypedMarker(time, callback, 'user', data);
			}
		}, {
			key: 'removeMarker',
			value: function removeMarker(markerId) {
				this._markers.removeMarker(markerId);
			}
		}, {
			key: 'getTimeForPdt',
			value: function getTimeForPdt(pdt) {
				if (this.basePdt) {
					return this._hlsJsController.getTimeForPdt(pdt);
				} else {
					return undefined;
				}
			}
		}, {
			key: 'getPdtForTime',
			value: function getPdtForTime(time) {
				if (this.basePdt) {
					return this._hlsJsController.getPdtForTime(time);
				} else {
					return undefined; //was null, but undefined is more consistent
				}
			}
		}, {
			key: 'emitter',
			get: function get() {
				return this._emitter;
			}
		}, {
			key: 'isMediaAttached',
			get: function get() {
				return this._mediaState === _MediaStates2.default.ATTACHED;
			}
		}, {
			key: 'state',
			get: function get() {
				return this._state;
			}
		}, {
			key: 'playbackState',
			get: function get() {
				return this._playbackState;
			}
		}, {
			key: 'mediaState',
			get: function get() {
				return this._mediaState;
			}
		}, {
			key: 'src',
			get: function get() {
				var retSource = null;
	
				if (this._pendingUrl) {
					retSource = this._pendingUrl;
				} else {
					retSource = this._source;
				}
				return retSource;
			},
			set: function set(url) {
				this.loadSource(url);
			}
		}, {
			key: 'media',
			get: function get() {
				return this._media;
			},
			set: function set(video) {
				this.attachMedia(video);
			}
		}, {
			key: 'autoPrefetch',
			get: function get() {
				return this._autoPrefetch;
			},
			set: function set(value) {
				this._autoPrefetch = !!value;
			}
		}, {
			key: 'autoPlay',
			get: function get() {
				return this._autoPlay;
			},
			set: function set(value) {
				this._autoPlay = !!value;
			}
		}, {
			key: 'autoRecover',
			get: function get() {
				return this._autoRecover;
			},
			set: function set(value) {
				this._autoRecover = !!value;
			}
		}, {
			key: 'nudgeOnStall',
			get: function get() {
				return this._hlsJsController.nudgeOnStall;
			},
			set: function set(value) {
				this._hlsJsController.nudgeOnStall = value;
			}
	
			/**
	   * if true, and the stream is live, the stream will start at the liveTime
	   *
	   * @type {boolean}
	   */
	
		}, {
			key: 'liveStreamsStartAtLiveTime',
			get: function get() {
				return this._hlsJsController.liveStreamsStartAtLiveTime;
			},
			set: function set(value) {
				this._hlsJsController.liveStreamsStartAtLiveTime = value;
			}
		}, {
			key: 'xhrSetup',
			get: function get() {
				return this._hlsJsController.xhrSetup;
			},
			set: function set(func) {
				this._hlsJsController.xhrSetup = func;
			}
		}, {
			key: 'keyLoadCallback',
			get: function get() {
				return this._hlsJsController.keyLoadCallback;
			},
			set: function set(func) {
				this._hlsJsController.keyLoadCallback = func;
			}
		}, {
			key: 'obtainKeySystemConfigCallback',
			get: function get() {
				return this._hlsJsController.obtainKeySystemConfigCallback;
			},
			set: function set(func) {
				this._hlsJsController.obtainKeySystemConfigCallback = func;
			}
	
			// stage booleans.
	
		}, {
			key: 'loaded',
			get: function get() {
				return this._loaded;
			}
		}, {
			key: 'fetching',
			get: function get() {
				return this._fetching;
			}
		}, {
			key: 'paused',
			get: function get() {
				return this._paused;
			}
		}, {
			key: 'ended',
			get: function get() {
				return this._ended;
			}
		}, {
			key: 'basePdt',
			get: function get() {
				return this._hlsJsController.basePdt;
			}
		}, {
			key: 'buffering',
			get: function get() {
				return this._buffering;
			}
		}, {
			key: 'seeking',
			get: function get() {
				return this._seeking;
			}
		}, {
			key: 'live',
			get: function get() {
				return this._hlsJsController.live;
			}
		}, {
			key: 'slidingWindow',
			get: function get() {
				return this._hlsJsController.slidingWindow;
			}
		}, {
			key: 'audioOnly',
			get: function get() {
				return this._hlsJsController.audioOnly;
			}
		}, {
			key: 'multithreaded',
			get: function get() {
				return this._hlsJsController.multithreaded;
			}
		}, {
			key: 'duration',
			get: function get() {
				return this._mediaController.duration;
			}
		}, {
			key: 'variants',
			get: function get() {
				return this._hlsJsController.levels;
			}
		}, {
			key: 'audioRenditions',
			get: function get() {
				return this._hlsJsController.audioRenditions;
			}
		}, {
			key: 'currentAudioRendition',
			get: function get() {
				return this._hlsJsController.currentAudioRendition;
			},
			set: function set(index) {
				this._hlsJsController.currentAudioRendition = index;
			}
		}, {
			key: 'initialAudioLanguage',
			get: function get() {
				return this._hlsJsController.initialAudioLanguage;
			},
			set: function set(language) {
				this._hlsJsController.initialAudioLanguage = language;
			}
		}, {
			key: 'initialAudioName',
			get: function get() {
				return this._hlsJsController.initialAudioName;
			},
			set: function set(name) {
				this._hlsJsController.initialAudioName = name;
			}
		}, {
			key: 'initialAudioIndex',
			get: function get() {
				return this._hlsJsController.initialAudioIndex;
			},
			set: function set(index) {
				this._hlsJsController.initialAudioIndex = index;
			}
		}, {
			key: 'subtitleRenditions',
			get: function get() {
				return this._hlsJsController.subtitleRenditions;
			}
		}, {
			key: 'subtitlesEnabled',
			get: function get() {
				return this._mediaController.subtitlesEnabled;
			},
			set: function set(value) {
				this._mediaController.subtitlesEnabled = value;
			}
		}, {
			key: 'changeSubtitlesByIndex',
			set: function set(value) {
				this._hlsJsController.changeSubtitlesByIndex = value;
			}
		}, {
			key: 'muted',
			get: function get() {
				return this._mediaController.muted;
			},
			set: function set(value) {
				this._mediaController.muted = value;
			}
		}, {
			key: 'volume',
			get: function get() {
				return this._mediaController.volume;
			},
			set: function set(value) {
				this._mediaController.volume = value;
			}
		}, {
			key: 'debug',
			get: function get() {
				return this._debug;
			},
			set: function set(value) {
				this._debug = !!value;
				(0, _logger.enableLogs)(this._debug);
			}
		}, {
			key: 'disposed',
			get: function get() {
				return this._disposed;
			}
		}, {
			key: 'useAutomaticComplexityReduction',
			get: function get() {
				return this._hlsJsController.useAutomaticComplexityReduction;
			},
			set: function set(value) {
				this._hlsJsController.useAutomaticComplexityReduction = value;
			}
		}, {
			key: 'bitrateCycle',
			get: function get() {
				return this._hlsJsController.bitrateCycle;
			},
			set: function set(value) {
				this._hlsJsController.bitrateCycle = value;
			}
		}, {
			key: 'maximumBufferSize',
			get: function get() {
				return this._hlsJsController.maximumBufferSize;
			},
			set: function set(value) {
				this._hlsJsController.maximumBufferSize = value;
			}
		}, {
			key: 'minimumBufferLength',
			get: function get() {
				return this._hlsJsController.minimumBufferLength;
			},
			set: function set(value) {
				this._hlsJsController.minimumBufferLength = value;
			}
		}, {
			key: 'maximumBufferLength',
			get: function get() {
				return this._hlsJsController.maximumBufferLength;
			},
			set: function set(value) {
				this._hlsJsController.maximumBufferLength = value;
			}
		}, {
			key: 'startTime',
			get: function get() {
				return this._hlsJsController.startTime;
			},
			set: function set(seconds) {
				this._hlsJsController.startTime = seconds;
			}
		}, {
			key: 'startTimeByPdt',
			get: function get() {
				return this._hlsJsController.startTimeByPdt;
			},
			set: function set(time) {
				this._hlsJsController.startTimeByPdt = time;
			}
		}, {
			key: 'startVariant',
			get: function get() {
				return this._hlsJsController.startLevel;
			},
			set: function set(variant) {
				this._hlsJsController.startLevel = variant;
			}
		}, {
			key: 'startBitrate',
			get: function get() {
				return this._hlsJsController.startBitrate;
			},
			set: function set(bitrate) {
				this._hlsJsController.startBitrate = bitrate;
			}
		}, {
			key: 'currentTime',
			get: function get() {
				return this._mediaController.currentTime;
			},
			set: function set(seconds) {
				_logger.logger.log('set currentTime: seconds: ' + seconds + ', _seekableRange.start: ' + this._seekableRange.start + ' liveTime: ' + this.liveTime);
				_HlsUtils2.default.checkNotFiniteAndThrow(seconds, 'currentTime');
				//we don't need both set currentTime and seek() to give warnings
				//Utils.checkLessThanZeroPointZeroAndWarn(seconds, 'currentTime');
	
				this.seek(seconds);
			}
		}, {
			key: 'currentTimeAsPdt',
			get: function get() {
				return this.getPdtForTime(this.currentTime);
			},
			set: function set(pdt) {
				this.seekByPdt(pdt);
				//this.currentTime = this.getTimeForPdt(pdt);
			}
		}, {
			key: 'playbackRate',
			get: function get() {
				return this._mediaController.playbackRate;
			},
			set: function set(value) {
				if (this.live) {
					if (this.currentTime > this.liveTime && value > 1) {
						_logger.logger.warn('set playbackRate: can\'t fast forward after the live point');
					} else if (this.currentTime < this.seekableRange.start && value < 1) {
						_logger.logger.warn('set playbackRate: can\'t slow forward before the start of the sliding window');
					} else {
						this._mediaController.playbackRate = value;
					}
				} else {
					this._mediaController.playbackRate = value;
				}
			}
		}, {
			key: 'initialTime',
			get: function get() {
				return this._initialTime !== -1 ? this._initialTime : 0;
			}
		}, {
			key: 'liveTime',
			get: function get() {
				return this._hlsJsController.liveTime;
			}
		}, {
			key: 'seekableRange',
			get: function get() {
				var seekableRange = {
					start: this._seekableRange.start !== undefined ? this._seekableRange.start : 0,
					end: this._seekableRange.end !== undefined ? this._seekableRange.end : 0,
					duration: this._seekableRange.duration !== undefined ? this._seekableRange.duration : 0
				};
	
				return seekableRange;
			}
		}, {
			key: 'bufferedRange',
			get: function get() {
				return this._hlsJsController.bufferedRange;
			}
		}, {
			key: 'playbackRange',
			get: function get() {
				var playbackRange = {
					start: this._playbackRange.start !== undefined ? this._playbackRange.start : 0,
					end: this._playbackRange.end !== undefined ? this._playbackRange.end : 0,
					duration: this._playbackRange.duration !== undefined ? this._playbackRange.duration : 0
				};
	
				return playbackRange;
			}
	
			//while bufferedRange is calculated in HlsJsController, we want to calculate bufferedRangeCurrent here, due to
			//easier acces to currentTime
	
		}, {
			key: 'bufferedRangeCurrent',
			get: function get() {
				for (var i = 0; i < this.bufferedRange.length; i++) {
					if (this.currentTime >= this.bufferedRange[i].start && this.currentTime <= this.bufferedRange[i].end) {
						return this.bufferedRange[i];
					}
				}
	
				return { start: this.currentTime, end: this.currentTime, duration: 0 };
			}
		}, {
			key: 'instanceId',
			get: function get() {
				return this._instanceId;
			}
		}], [{
			key: 'isSupported',
			value: function isSupported() {
				return _HlsUtils2.default.isBrowser() && _HlsJsController2.default.isSupported();
			}
		}, {
			key: 'totalActive',
			value: function totalActive() {
				return _counter.active();
			}
		}, {
			key: 'totalCreated',
			value: function totalCreated() {
				return _counter.total();
			}
		}, {
			key: 'isRedirectSupported',
			value: function isRedirectSupported() {
				//Current assumption is that IE and Tizen 2 are the only non-compliant platforms
				var redirectSupported = true;
	
				if (_HlsUtils2.default.isIE() === true) {
					redirectSupported = false;
				} else if (_HlsUtils2.default.isTizen2() === true) {
					redirectSupported = false;
				}
	
				return redirectSupported;
			}
		}]);
	
		return HlsController;
	}();
	
	exports.default = HlsController;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(62)))

/***/ }),
/* 102 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	/**
	 * @public
	 */
	var HlsDataTypes = {
		MANIFEST: 'MANIFEST', //.m3u8 files
		CHUNK: 'CHUNK', //.ts files
		KEY: 'KEY' //AES key files
	};
	
	exports.default = HlsDataTypes;
	module.exports = exports['default'];

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * HlsJs Controller - controls the hls.js instance.
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _hls = __webpack_require__(131);
	
	var _hls2 = _interopRequireDefault(_hls);
	
	var _HlsEvents = __webpack_require__(14);
	
	var _HlsEvents2 = _interopRequireDefault(_HlsEvents);
	
	var _events = __webpack_require__(3);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _errors = __webpack_require__(4);
	
	var _EventHandlers = __webpack_require__(34);
	
	var _EventHandlers2 = _interopRequireDefault(_EventHandlers);
	
	var _eventemitter = __webpack_require__(33);
	
	var _eventemitter2 = _interopRequireDefault(_eventemitter);
	
	var _KeySystems = __webpack_require__(35);
	
	var _KeySystems2 = _interopRequireDefault(_KeySystems);
	
	var _CencModes = __webpack_require__(63);
	
	var _CencModes2 = _interopRequireDefault(_CencModes);
	
	var _CustomKeyLoader = __webpack_require__(100);
	
	var _CustomKeyLoader2 = _interopRequireDefault(_CustomKeyLoader);
	
	var _keyLoader = __webpack_require__(71);
	
	var _keyLoader2 = _interopRequireDefault(_keyLoader);
	
	var _HlsUtils = __webpack_require__(6);
	
	var _HlsUtils2 = _interopRequireDefault(_HlsUtils);
	
	var _logger = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	__webpack_require__(78);
	
	/**
	* @access internal
	*/
	
	var HlsJsController = function () {
		_createClass(HlsJsController, null, [{
			key: 'isHlsSupported',
	
	
			//Creation
	
			value: function isHlsSupported() {
				return _hls2.default.isSupported();
			}
		}]);
	
		function HlsJsController() {
			var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
			var di = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
			_classCallCheck(this, HlsJsController);
	
			var disableWorkarounds = !!config.disableWorkarounds || false;
			var enableMuxJs = true;
			var decryptOutsideWebworker = false;
	
			if (config.decryptOutsideWebworker === true) {
				decryptOutsideWebworker = true;
			}
	
			this._instanceId = config.instanceId;
	
			this._emitter = di.eventEmitter || new _eventemitter2.default();
	
			this._hlsJs = di.hlsJs || new _hls2.default({
				// we want to control loading
				autoStartLoad: false,
	
				// we want to control buffer size
				maxBufferSize: 60000000,
				maxBufferLength: 30,
				maxMaxBufferLength: 60,
	
				enableWorker: !_HlsUtils2.default.isFirefoxBadWorker() || disableWorkarounds,
				enableMuxJs: enableMuxJs,
				decryptOutsideWebworker: decryptOutsideWebworker,
	
				xhrSetup: this._hlsJsXhrSetup.bind(this),
				obtainKeySystemConfigCallback: this._hlsJsObtainKeySystemConfigCallback.bind(this),
				fetchSetup: function fetchSetup(context, initParams) {
					// Always send cookies, even for cross-origin calls.
					initParams.credentials = 'include';
					return new Request(context.url, initParams);
				}
			});
	
			this._disposed = false;
			this._inDetach = false;
			this._pendingDispose = false;
	
			this._handlers = new _EventHandlers2.default();
	
			this._source = ''; // the HLS manifest URL
			this._levels = []; // from hlsjs manifest parsed data
	
			// source config properties
			this._startTime = 0;
			this._startTimeByPdt = undefined;
			this._startLevel = -1;
			this._startBitrate = -1;
			this._liveStreamsStartAtLiveTime = true;
	
			this._fetching = false; // are we buffering chunks
			this._loaded = false; // is the manifest parsed
	
			this._live = undefined; // default is undefined. ie true.
	
			this._basePdt = undefined;
	
			this._slidingWindow = false;
			this._slidingWindowSize = 0;
			this._liveTime = undefined;
	
			this._bufferedRange = undefined;
			this._networkMetrics = {
				chosenBitrate: null,
				chosenVariant: null,
				perceivedBitrate: null,
				displayTime: null
			};
			this._nextNetworkMetrics = {
				chosenBitrate: null,
				chosenVariant: null,
				perceivedBitrate: null,
				displayTime: null
			};
	
			this._multithreaded = (!_HlsUtils2.default.isFirefoxBadWorker() || disableWorkarounds) && typeof Worker !== 'undefined';
	
			this._audioOnly = false;
	
			this._mediaAttached = false; // is the media attached
			this._media = null;
	
			this._constraints = {
				minVariant: -1,
				maxVariant: -1,
				minBitrate: -1,
				maxBitrate: -1,
				minWidth: -1,
				minHeight: -1,
				maxWidth: -1,
				maxHeight: -1
			};
	
			this._timeouts = {
				manifestTimeout: 10000,
				manifestTimeoutMax: 5000, //exponential delay max
				variantTimeout: 10000,
				variantTimeoutMax: 5000,
				chunkTimeout: 20000,
				chunkTimeoutMax: 5000,
				streamTimeout: 30000
			};
	
			/* hlsjs defaults
	  this._timeouts = {
	  	manifestTimeout : 10000,
	  	manifestTimeoutMax : 64000,
	  	variantTimeout : 10000,
	  	variantTimeoutMax : 64000,
	  	chunkTimeout : 20000,
	  	chunkTimeoutMax : 64000
	  }; */
	
			this._hlsJs.timeouts = this._timeouts;
	
			this._minimumConstraint = -1;
			this._maximumConstraint = -1;
	
			this._subtitleRenditions = [];
			this._explicitDimensions = false; // does manifest explicitly define dimensions
	
			this._bitrateCycle = false;
			this._bitrateStepDown = false;
			this._bitrateCycleMax = -1;
			this._bitrateCycleMin = -1;
	
			this._xhrSetup = null;
			this._customKeyLoadCallback = null;
			this._originalKeyLoader = null;
			this._keyCache = null;
			this._obtainKeySystemConfigCallback = null;
	
			this._fatalErrors = 0;
	
			this._initialAudioLanguage = null;
			this._initialAudioName = null;
			this._initialAudioIndex = -1;
			this._initialAudioTrackSelected = false;
	
			//Recovery parameters.
			this._recoveryAudioIndex = -1;
			this._recoveryStartTime = -1;
			this._recoveryStartTimeByPdt = undefined;
	
			this._hlsJsEvents = [{ event: _events2.default.ERROR, func: this._onHlsJsError }, { event: _events2.default.MEDIA_ATTACHING, func: this._onHlsJsMediaAttaching }, { event: _events2.default.MEDIA_ATTACHED, func: this._onHlsJsMediaAttached }, { event: _events2.default.MEDIA_DETACHING, func: this._onHlsJsMediaDetaching }, { event: _events2.default.MEDIA_DETACHED, func: this._onHlsJsMediaDetached }, { event: _events2.default.MANIFEST_LOADED, func: this._onHlsJsManifestLoaded }, { event: _events2.default.MANIFEST_PARSED, func: this._onHlsJsManifestParsed }, { event: _events2.default.LEVEL_LOADED, func: this._onHlsJsLevelLoaded }, { event: _events2.default.LEVEL_UPDATED, func: this._onHlsJsLevelUpdated }, { event: _events2.default.LEVEL_DURATION_UPDATED, func: this._onHlsJsLevelDurationUpdated }, { event: _events2.default.BUFFER_CREATED, func: this._onHlsJsBufferCreated }, { event: _events2.default.BUFFER_APPENDED, func: this._onHlsJsBufferAppended }, { event: _events2.default.BUFFER_FLUSHED, func: this._onHlsJsBufferFlushed }, { event: _events2.default.LEVEL_SWITCHING, func: this._onHlsJsLevelSwitching }, { event: _events2.default.FRAG_LOADED, func: this._onHlsJsFragLoaded }, { event: _events2.default.FRAG_PARSING_METADATA, func: this._onHlsJsMetadataParsed }, { event: _events2.default.FRAG_BUFFERED, func: this._onHlsJsFragBuffered }, { event: _events2.default.TEXT_TRACK_ADDED, func: this._onHlsJsTextTrackAdded }, { event: _events2.default.AUDIO_TRACKS_UPDATED, func: this._onHlsJsAudioTracksUpdated }, { event: _events2.default.START_POSITION_SET, func: this._onHlsJsStartPositionSet }, { event: _events2.default.FPS_DROP_LEVEL_CAPPING, func: this._onHlsJsFpsDropLevelCapping }, { event: _events2.default.LOGTUBE_LOG, func: this._onHlsJsLogTube }, { event: _events2.default.FRAG_DATERANGE_UPDATE, func: this._onHlsJsDateRange }, { event: _events2.default.STREAM_LIVETIME_CHANGED, func: this._onHlsJsLiveTimeChange }, { event: _events2.default.STREAM_BASEPDT_FOUND, func: this._onHlsJsBasePdtFound }, { event: _events2.default.BITRATE_ESTIMATE_UPDATED, func: this._onHlsJsBitrateEstimateUpdated }, { event: _events2.default.LEVEL_SELECTION_FINISHED, func: this._onHlsJsLevelSelectionFinished }, { event: _events2.default.FRAG_START_FOUND, func: this._onHlsJsFragStartFound }, { event: _events2.default.SEEK_READY, func: this._onHlsJsSeekReady }];
			_EventHandlers2.default.verifyEventsList(this._hlsJsEvents);
	
			this._wireHlsJsEvents();
	
			_HlsUtils2.default.applyConfig(this, config);
		}
	
		_createClass(HlsJsController, [{
			key: 'dispose',
			value: function dispose() {
				if (this._disposed || this._pendingDispose) {
					throw new Error('HlsJsController can not be disposed more than once');
				}
	
				if (!this._hlsJs) {
					throw new Error('HlsJsController.dispose no hlsjs instance');
				}
	
				// start hlsjs destroy
				if (this._mediaAttached) {
					this._pendingDispose = true;
	
					// MEDIA_DETACHED will resolve the pendingDispose
					this._doDetachMedia();
				} else {
					this._doDispose();
				}
			}
		}, {
			key: '_doDispose',
			value: function _doDispose() {
				this._disposed = true;
	
				this._unwireHlsJsEvents();
				this._hlsJs.destroy();
				this._hlsJs = null;
	
				if (this._originalKeyLoader) {
					this._originalKeyLoader.destroy();
				}
				this._originalKeyLoader = null;
	
				this._constraints = null;
				this._timeouts = null;
	
				this._source = null;
				this._levels = null;
				this._subtitleRenditions = null;
	
				this._customKeyLoadCallback = null;
	
				this._bufferedRange = null;
	
				this._basePdt = null;
				this._startTimeByPdt = null;
	
				// this would be our last chance to emit any events... say a DESTROY
	
				// this will destroy our event handlers too...
				this._handlers.dispose();
				this._handlers = null;
	
				this._hlsJsEvents = null;
	
				this._emitter = null;
	
				this._pendingDispose = false;
	
				// need to destroy the EventEmitter _ee too.
	
				// ITS NOW ILLEGAL TO USE HlsJsController.
			}
		}, {
			key: 'flushBuffer',
			value: function flushBuffer(levelFlush) {
				return this._hlsJs.flushBuffers(levelFlush);
			}
		}, {
			key: '_wireHlsJsEvent',
			value: function _wireHlsJsEvent(_ref) {
				var event = _ref.event,
				    func = _ref.func;
	
				var handler = this._handlers.createEventHandler(this, func);
	
				this._hlsJs.on(event, handler);
			}
		}, {
			key: '_unwireHlsJsEvent',
			value: function _unwireHlsJsEvent(_ref2) {
				var event = _ref2.event,
				    func = _ref2.func;
	
				var handler = this._handlers.getHandlerForFunction(func);
	
				if (handler) {
					this._hlsJs.off(event, handler);
				}
			}
		}, {
			key: '_wireHlsJsEvents',
			value: function _wireHlsJsEvents() {
				var _this = this;
	
				this._hlsJsEvents.forEach(function (event) {
					return _this._wireHlsJsEvent(event);
				});
			}
		}, {
			key: '_unwireHlsJsEvents',
			value: function _unwireHlsJsEvents() {
				var _this2 = this;
	
				this._hlsJsEvents.forEach(function (event) {
					return _this2._unwireHlsJsEvent(event);
				});
			}
	
			/**
	   * Calls the clients xhrSetup function if it exists
	   *
	   * Is passed as a configuration parameter to HlsJs, and allows the client
	   * to modify outgoing XHRs.
	   *
	   * @link https://github.com/dailymotion/hls.js/issues/246
	   *
	   * @param {XMLHttpRequest} xhr - the http requested
	   * @param {string} url the url
	   * @param {DataTypes} type type of object being loaded
	   */
	
		}, {
			key: '_hlsJsXhrSetup',
			value: function _hlsJsXhrSetup(xhr, url, type) {
				if (this._xhrSetup) {
					this._xhrSetup(xhr, url, type);
				}
			}
		}, {
			key: '_hlsJsObtainKeySystemConfigCallback',
			value: function _hlsJsObtainKeySystemConfigCallback(keySystem, keySystemData) {
				if (this._obtainKeySystemConfigCallback) {
					return this._obtainKeySystemConfigCallback(keySystem, keySystemData);
				} else {
					return null;
				}
			}
		}, {
			key: '_emit',
			value: function _emit(event) {
				var _emitter;
	
				for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
					args[_key - 1] = arguments[_key];
				}
	
				(_emitter = this._emitter).emit.apply(_emitter, [event].concat(args));
			}
		}, {
			key: '_setLevels',
			value: function _setLevels(levels) {
				this._levels = levels;
				this._emit(_HlsEvents2.default.STREAM_VARIANTS_CHANGED, { variants: levels });
			}
	
			// note, the parent object contains the currentLevel if we ever want that.
			/*
	  PTSKnown
	  averagetargetduration
	  endSN
	  fragments[]
	  live
	  startSN
	  targetduration
	  totalduration
	  type
	  url
	  version
	  */
	
		}, {
			key: '_processLevelUpdate',
			value: function _processLevelUpdate(levelUpdate) {
				//		logger.log('_processLevelUpdate');
				//		logger.log(levelDetails);
	
				/*
	   	now lets calculate the liveTime
	   	The problem is that HlsJs doesn't calculate this until it gets an update to
	   	its current level. It should be able to calculate it on every load/update, so
	   	instead we'll reach inside and perform the calculation... which is basically
	   	duration - liveBuffer + timeSlid.
	   */
	
				// the assumption is that as the level slides, the start point is updated...
				//let sliding = levelDetails.details.fragments[0].start;
				var sliding = levelUpdate.sliding;
	
				/*
	   	computeLivePosition(sliding, levelDetails) {
	   		let targetLatency = this.config.liveSyncDuration !== undefined
	   			? this.config.liveSyncDuration
	   			: this.config.liveSyncDurationCount * levelDetails.targetduration;
	   		return sliding + Math.max(0, levelDetails.totalduration - targetLatency);
	   	}
	   */
				var liveSyncPosition = this._hlsJs.streamController.computeLivePosition(sliding, levelUpdate.details);
				//let liveSyncPosition = 0;
				_logger.logger.log('_processLevelUpdate: sliding: ' + sliding + ', liveSyncPosition: ' + liveSyncPosition);
	
				// we want to increase the liveTime before we declare live.
				//this._setLiveTime(liveSyncPosition);
				this._setLive(levelUpdate.details.live);
	
				/*
	   	TODO: calculate sliding window based on original MEDIA-SEQUENCE
	   	HlsJs doesn't bother keeping the original media sequence around. If it did
	   	it would be a simple matter to compare the new MEDIA-SEQUENCE against the old, and
	   	then we are sliding. Also, we would then keep the amount slid based on the durations
	   	that slid off. Instead it always goes back to PTS.
	   	This means that it picks up differences between levels PTS as sliding.
	   	The problem is that it produces strange fractional second sliding values either direction
	   	even for event streams. Just detecting sliding, the below heuristic should be enough to
	   	filter it, but eventually we will want to add more smarts to HlsJs's playlist management.
	   */
	
				// sliding > 0 produces false positives, so we assume as long as its at least half a duration, its valid.
				if (sliding >= levelUpdate.details.targetduration / 2) {
					this._setSlidingWindowSize(sliding);
				}
	
				// TODO: _slidingWindow = sliding > 0; and perhaps stash sliding as well.
				//this._setSlidingWindow(sliding);	// best to send slidingWindow AFTER Live update.
			}
		}, {
			key: '_setLiveTime',
			value: function _setLiveTime(newLiveTime) {
	
				if (newLiveTime === undefined || newLiveTime < 0) {
					throw new Error('_setLiveTime: newLiveTime ' + newLiveTime + ' must be valid');
				}
	
				// live time should only ever increase.
	
				if (this._liveTime === undefined || newLiveTime > this._liveTime) {
	
					// if its undefined, we actually return 0
					var oldLiveTime = this.liveTime;
					this._liveTime = newLiveTime;
	
					var data = { liveTime: newLiveTime, lastLiveTime: oldLiveTime };
					_logger.logger.log('STREAM_LIVETIME_CHANGED: { liveTime: ' + data.liveTime + ' lastLiveTime: ' + data.lastLiveTime + ' }');
	
					this._emit(_HlsEvents2.default.STREAM_LIVETIME_CHANGED, data);
				}
			}
		}, {
			key: '_setLive',
			value: function _setLive(newLive) {
	
				if (newLive === undefined) {
					throw new Error('_setLive: newLive must be valid');
				}
	
				// we should only be able to go either :
				// undefined -> true -> false
				// undefined -> false
	
				if (this._live === undefined || this._live === true && newLive === false) {
	
					// if its undefined, we actually return true, as when it is undefined we assume live
					var oldLive = this.live;
					this._live = newLive;
	
					var data = { live: newLive, lastLive: oldLive };
					_logger.logger.log('STREAM_ISLIVE_CHANGED: { live: ' + data.live + ' lastLive: ' + data.lastLive + ' }');
	
					this._emit(_HlsEvents2.default.STREAM_ISLIVE_CHANGED, data);
				}
				/*else if( this._live === false && newLive === true ) {
	   	throw new Error( '_setLive: should be impossible to transition for not-live to live');
	   }*/
			}
	
			/**
	   * @param {boolean} slidingWindow - sliding window true or false.
	   */
	
		}, {
			key: '_setSlidingWindow',
			value: function _setSlidingWindow(slidingWindow) {
				if (slidingWindow !== true) {
					throw new Error('_setSlidingWindow: slidingWindow can only ever become true. slidingWindow: ' + slidingWindow);
				}
	
				if (this._slidingWindow !== slidingWindow) {
					var oldSlidingWindow = this._slidingWindow;
					this._slidingWindow = slidingWindow;
	
					var data = { slidingWindow: slidingWindow, lastSlidingWindow: oldSlidingWindow };
					_logger.logger.log('STREAM_ISSLIDINGWINDOW_CHANGED: { slidingWindow: ' + data.slidingWindow + ' lastSlidingWindow: ' + data.lastSlidingWindow + ' }');
	
					this._emit(_HlsEvents2.default.STREAM_ISSLIDINGWINDOW_CHANGED, data);
				}
			}
		}, {
			key: '_setSlidingWindowSize',
			value: function _setSlidingWindowSize(slidingWindowSize) {
	
				if (slidingWindowSize === undefined) {
					throw new Error('_setSlidingWindowSize: slidingWindowSize must be valid');
				}
	
				//sliding window should only increase.
	
				if (slidingWindowSize > this._slidingWindowSize) {
					this._slidingWindowSize = slidingWindowSize;
					if (!this._slidingWindow) {
						// emits STREAM_ISSLIDINGWINDOW_CHANGED
						this._setSlidingWindow(true);
					}
				}
			}
		}, {
			key: '_setAudioOnly',
			value: function _setAudioOnly(audioOnly) {
				if (audioOnly !== this._audioOnly) {
					var data = { audioOnly: audioOnly, lastAudioOnly: this._audioOnly };
					_logger.logger.log('STREAM_ISAUDIOONLY_CHANGED: { audioOnly: ' + data.audioOnly + ' lastAudioOnly: ' + data.lastAudioOnly + ' }');
	
					this._audioOnly = audioOnly;
	
					this._emit(_HlsEvents2.default.STREAM_ISAUDIOONLY_CHANGED, data);
				}
			}
		}, {
			key: '_setMultithreaded',
			value: function _setMultithreaded(multithreaded) {
				if (multithreaded !== false) {
					throw new Error('_setMultithreaded: multithreaded should only ever become false. multithreaded: ' + multithreaded);
				}
	
				if (this._multithreaded !== multithreaded) {
					var oldMultithreaded = this._multithreaded;
					this._multithreaded = multithreaded;
	
					var data = { multithreaded: this._multithreaded, lastMultithreaded: oldMultithreaded };
					_logger.logger.log('STREAM_ISMULTITHREADED_CHANGED: { multithreaded: ' + data.multithreaded + ' lastMultithreaded: ' + data.lastMultithreaded + ' }');
	
					this._emit(_HlsEvents2.default.STREAM_ISMULTITHREADED_CHANGED, data);
				}
			}
		}, {
			key: '_setHlsJsMinMaxBitrate',
			value: function _setHlsJsMinMaxBitrate() {
				// these functions are highly dependant on internal behaviour in hlsjs.
				// this capability would be good for unit testing.
				this._setHlsJsMaximumBitrate(this._constraints.maxBitrate);
				this._setHlsJsMinimumBitrate(this._constraints.minBitrate);
			}
		}, {
			key: '_setHlsJsMaximumBitrate',
			value: function _setHlsJsMaximumBitrate(maxBitrate) {
	
				// we can only do this after we have levels... and if there is a level.
				if (this._levels && this._levels.length > 0) {
					var maxLevel = this._levels.length - 1;
	
					// -1 means use maximum bitrate, which is already set.
					if (maxBitrate >= 0) {
	
						// calculate level which is under or equal to maxBitrate, stopping at the lowest bitrate.
						while (maxLevel > 0 && this._levels[maxLevel].bitrate > maxBitrate) {
							maxLevel--;
						}
					}
	
					// In HlsJs, autoLevelCapping will clamp the level to this level. It next gets bumped up by minAutoBitrate.
					this._hlsJs.autoLevelCapping = maxLevel;
	
					// TODO: I think its actually more efficient for us to set the autoLevelCapping to
					// the maximum level for the -1 case rather than to let hlsjs continually re-calculate
					// the maximum level. hls.js will short-circuit to the set value.
				}
			}
		}, {
			key: '_setHlsJsMinimumBitrate',
			value: function _setHlsJsMinimumBitrate(minBitrate) {
	
				// In HlsJs, After a level is selected, and then clamped to autoLevelCapping level, it is then bumped up
				// in a loop to satisfy minAutoBitrate.
				//
				// BUT if there is no level that satisfies minAutoBitrate an "internal processing error is triggered
				// in abr-controller.js at line 210
				//
				//		if(minAutoBitrate !== undefined) {
				//			while (levels[nextABRAutoLevel].bitrate < minAutoBitrate) {		// <-- reads past end of array
				//				nextABRAutoLevel++;
				//			}
				//		}
				//
				// The best solution is to ensure that minAutoBitrate is clamped to the maximum levels bitrate.
				// Otherwise who knows what else will blow up in hlsjs.
	
				// NOTE: this also means that minBitrate OVERRIDES maxBitrate. I'm not sure if we like that
				// behaviour... but we could fix it.
	
				if (this._levels && this._levels.length > 0) {
					if (minBitrate === -1 || this._levels.length === 1) {
						// this is the no-limit case. By setting undefined, we skip the repetive calculation
						// every bitrate decision. we might as well also do this for a single variant playlist.
						// don't know how smart hlsjs is.
						this._hlsJs.config.minAutoBitrate = undefined;
					} else {
						// critical that we clamp to actual max bitrate, or hlsjs will explode.
						this._hlsJs.config.minAutoBitrate = Math.min(minBitrate, this._levels[this._levels.length - 1].bitrate);
					}
				}
			}
		}, {
			key: '_setBasePdt',
			value: function _setBasePdt(pdt) {
				var oldBasePdt = this.basePdt;
				this._basePdt = pdt;
	
				var data = { basePdt: new Date(this._basePdt), oldBasePdt: oldBasePdt };
				_logger.logger.log('STREAM_BASEPDT_CHANGED: { basePdt: ' + data.basePdt + ' oldBasePdt: ' + data.oldBasePdt + ' }');
	
				this._emit(_HlsEvents2.default.STREAM_BASEPDT_CHANGED, data);
			}
		}, {
			key: '_setChosenVariant',
			value: function _setChosenVariant(newVariant) {
				_logger.logger.log('HlsJsController::_setChosenVariant');
	
				if (newVariant === undefined || newVariant < 0) {
					throw new Error('invalid variant: ' + newVariant);
				}
	
				if (this._nextNetworkMetrics.chosenVariant !== newVariant) {
					this._nextNetworkMetrics.chosenVariant = newVariant;
	
					if (this._levels[newVariant].bitrate) {
						this._setChosenBitrate(this._levels[newVariant].bitrate);
					}
				}
			}
		}, {
			key: '_setChosenBitrate',
			value: function _setChosenBitrate(newBitrate) {
				_logger.logger.log('HlsJsController::_setChosenBitrate');
	
				if (newBitrate === undefined || newBitrate < 0) {
					throw new Error('invalid bitrate: ' + newBitrate);
				}
	
				if (this._nextNetworkMetrics.chosenBitrate !== newBitrate) {
					this._nextNetworkMetrics.chosenBitrate = newBitrate;
				}
			}
		}, {
			key: '_setPerceivedBitrate',
			value: function _setPerceivedBitrate(newBitrate) {
				_logger.logger.log('HlsJsController::_setPerceivedBitrate');
	
				if (newBitrate === undefined || newBitrate < 0) {
					throw new Error('invalid bitrate: ' + newBitrate);
				}
	
				var roundedBitrate = Math.round(newBitrate);
	
				if (this._nextNetworkMetrics.perceivedBitrate !== roundedBitrate) {
					this._nextNetworkMetrics.perceivedBitrate = roundedBitrate;
				}
			}
		}, {
			key: '_updateNetworkMetrics',
			value: function _updateNetworkMetrics() {
				var nm = this._networkMetrics;
				var nnm = this._nextNetworkMetrics;
	
				if (nm.displayTime !== nnm.displayTime || nm.perceivedBitrate !== nnm.perceivedBitrate || nm.chosenBitrate !== nnm.chosenBitrate || nm.chosenVariant !== nnm.chosenVariant) {
					this._networkMetrics = {
						chosenVariant: this._nextNetworkMetrics.chosenVariant,
						chosenBitrate: this._nextNetworkMetrics.chosenBitrate,
						perceivedBitrate: this._nextNetworkMetrics.perceivedBitrate,
						displayTime: this._nextNetworkMetrics.displayTime
					};
	
					_logger.logger.log('STREAM_NETWORKMETRICS_CHANGED');
					this._emit(_HlsEvents2.default.STREAM_NETWORKMETRICS_CHANGED, { networkMetrics: nnm, lastNetworkMetrics: nm });
				}
			}
		}, {
			key: '_setKeyLoadCallback',
			value: function _setKeyLoadCallback() {
				if (this._originalKeyLoader === null) {
					this._originalKeyLoader = this._hlsJs.keyLoader;
				}
	
				if (this._customKeyLoadCallback === null && this._originalKeyLoader === null) {
					this._originalKeyLoader = new _keyLoader2.default(this._hlsJs); //Invalid keyloaders. Make new one.
				}
	
				if (this._keyCache != null) {
					//			if (this._customKeyLoadCallback !== null) {
					//				this._keyCache.downloader = this._customKeyLoadCallback;
					//			}
					//			else {
	
					//logger.log(this._hlsJs.config.loader + ' original key loader set *************************************************************');
	
					this._keyCache.downloader = new this._hlsJs.config.loader();
					//			}
					this._hlsJs.keyLoader = new _CustomKeyLoader2.default(this._hlsJs, this._keyCache.hlsKeyLoadCallback);
				} else if (this._customKeyLoadCallback !== null) {
					this._hlsJs.keyLoader = new _CustomKeyLoader2.default(this._hlsJs, this._customKeyLoadCallback);
				} else if (this._hlsJs.keyLoader === null) {
					this._hlsJs.keyLoader = this._originalKeyLoader;
					this._originalKeyLoader = null; //if we keep this we'll double destroy...
				}
			}
		}, {
			key: '_updateBufferedRange',
			value: function _updateBufferedRange() {
				var bufferedRange = [];
				var bufferTimes = [];
	
				try {
					/*if (this._hlsJs.bufferController.sourceBuffer.audio !== undefined) {
	    	bufferTimes = this._hlsJs.bufferController.sourceBuffer.audio.buffered;
	    }
	    else if (this._hlsJs.bufferController.sourceBuffer.video !== undefined) {
	    	bufferTimes = this._hlsJs.bufferController.sourceBuffer.video.buffered;
	    }*/
					bufferTimes = this._hlsJs.media.buffered;
	
					if (bufferTimes === undefined || bufferTimes.length === 0) {
						bufferedRange[0] = { start: 0, end: 0, duration: 0 };
					} else {
						for (var i = 0; i < bufferTimes.length; i++) {
							bufferedRange[i] = { start: bufferTimes.start(i), end: bufferTimes.end(i),
								duration: bufferTimes.end(i) - bufferTimes.start(i) };
						}
					}
	
					_logger.logger.log('_updateBufferedRange completed');
				} catch (err) {
					bufferedRange = [];
					bufferedRange[0] = { start: 0, end: 0, duration: 0 };
				}
	
				this._bufferedRange = bufferedRange;
			}
		}, {
			key: 'loadSource',
			value: function loadSource(url) {
				this._source = url;
				this._loaded = false;
				this._fetching = false;
	
				//Used to preserve BasePdt in live recovery cases
				this._hlsJs.resumeBasePdt = this._resumeBasePdt;
				this._resumeBasePdt = undefined;
	
				this._hlsJs.loadSource(this._source);
			}
		}, {
			key: 'attachMedia',
			value: function attachMedia(video) {
				_logger.logger.log('HlsjsController::attachMedia');
				if (this._mediaAttached) {
					throw new Error('HlsjsController::attachMedia media already attached');
				}
	
				if (video) {
					this._media = video;
					this._hlsJs.attachMedia(video);
				}
			}
		}, {
			key: '_doDetachMedia',
			value: function _doDetachMedia() {
				if (!this._mediaAttached) {
					throw new Error('HlsjsController::_doDetachMedia no media attached');
				}
	
				if (!this._inDetach) {
					this._inDetach = true;
					this._hlsJs.detachMedia();
				} else {
					_logger.logger.log('HlsJsController::_doDetachMedia not requesting detach');
				}
			}
		}, {
			key: 'detachMedia',
			value: function detachMedia() {
				_logger.logger.log('HlsJsController::detachMedia()');
	
				this._doDetachMedia();
			}
		}, {
			key: 'startFetching',
			value: function startFetching() {
				if (!this._loaded) {
					throw new Error('stream not loaded');
				}
	
				if (this._fetching) {
					throw new Error('stream already loading');
				}
	
				var timeToStartAt = this._startTime;
	
				if (this._recoveryStartTime !== -1) {
					timeToStartAt = this._recoveryStartTime;
					this._recoveryStartTime = -1;
				}
	
				this._fetching = true;
	
				_logger.logger.log('startFetching: { isLive: ' + this.live + ', LSSALT: ' + this._liveStreamsStartAtLiveTime + ', startTime: ' + timeToStartAt + ' }');
	
				this._hlsJs.startLoad(timeToStartAt, this._liveStreamsStartAtLiveTime);
			}
		}, {
			key: 'stopFetching',
			value: function stopFetching() {
				if (!this._loaded) {
					throw new Error('stream not loaded');
				}
	
				if (!this._fetching) {
					throw new Error('stream already not fetching');
				}
	
				this._fetching = false;
	
				this._hlsJs.stopFetch();
			}
		}, {
			key: 'resumeFetching',
			value: function resumeFetching() {
				var resumePosition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
	
				if (!this._loaded) {
					throw new Error('stream not loaded');
				}
	
				if (this._fetching) {
					throw new Error('stream already fetching');
				}
	
				this._fetching = true;
	
				this._hlsJs.resumeFetch(resumePosition);
			}
		}, {
			key: '_resetState',
			value: function _resetState() {
				this._live = undefined;
				this._liveTime = undefined;
				this._audioOnly = false;
				this._slidingWindow = false;
				this._bufferedRange = undefined;
				this._fatalErrors = 0;
				this._basePdt = undefined;
				this._initialAudioTrackSelected = false;
			}
		}, {
			key: '_onHlsJsError',
			value: function _onHlsJsError(event, data) {
				if (data.fatal === true) {
					_logger.logger.log('HLSJS FATAL ERROR');
					this._hlsJs.stopLoad();
					/* we shouldn't be getting fatal errors unless the stream needs to be shut down
	    this._fatalErrors++;
	    logger.log('HLSJS FATAL ERROR ' + this._fatalErrors);
	    if (this._fatalErrors > 5) {
	    	logger.log('hlsjs stalled in error loop; calling stopLoad');
	    	//This does seem needed sometimes, but other times it might make things worse.
	    	//Could be better to fix issues in hlsjs instead.... - SIEG
	    	this._hlsJs.stopLoad();
	    }
	    */
				} else {
					_logger.logger.log('HLSJS ERROR');
				}
	
				if (data.details === _errors.ErrorDetails.DEMUX_WORKER_ALLOC_ERROR) {
					this._setMultithreaded(false);
				}
	
				this._emit(_HlsEvents2.default.HLSJS_ERROR, data);
			}
		}, {
			key: '_onHlsJsLogTube',
			value: function _onHlsJsLogTube(event, data) {
				_logger.logger.log(data.message);
			}
		}, {
			key: '_onHlsJsDateRange',
			value: function _onHlsJsDateRange(event, data) {
				_logger.logger.log('HLSJS STREAM_DATERANGE_UPDATE');
				if (data) {
					this._emit(_HlsEvents2.default.STREAM_DATERANGE_UPDATE, {
						dateRange: data.dateRange,
						startTime: data.startTime
					});
				}
			}
		}, {
			key: '_onHlsJsMediaAttached',
			value: function _onHlsJsMediaAttached(event, data) {
				_logger.logger.log('HLSJS MEDIA_ATTACHED');
				this._mediaAttached = true;
	
				this._updateBufferedRange(); //in some error cases this isn't cleared.
	
				this._emit(_HlsEvents2.default.HLSJS_MEDIA_ATTACHED, data);
			}
		}, {
			key: '_onHlsJsMediaDetaching',
			value: function _onHlsJsMediaDetaching() {
				_logger.logger.log('HLSJS MEDIA_DETACHING { mediaAttached: ' + this._mediaAttached + ' }');
			}
		}, {
			key: '_onHlsJsMediaAttaching',
			value: function _onHlsJsMediaAttaching() {
				_logger.logger.log('HLSJS MEDIA_ATTACHING { mediaAttached: ' + this._mediaAttached + ' }');
			}
		}, {
			key: '_onHlsJsMediaDetached',
			value: function _onHlsJsMediaDetached() /* event, data */{
				if (this._disposed) {
					_logger.logger.log('HLSJS MEDIA_DETACHED - already disposed, dropping event');
				} else {
					_logger.logger.log('HLSJS MEDIA_DETACHED { mediaAttached: ' + this._mediaAttached + ', _inDetach: ' + this._inDetach + ', pendingDispose: ' + this._pendingDispose + ' }');
					this._mediaAttached = false;
					this._resetState();
	
					this._media = null;
	
					if (this._inDetach) {
						this._inDetach = false;
						this._emit(_HlsEvents2.default.HLSJS_MEDIA_DETACHED, { media: null });
					}
	
					if (this._pendingDispose) {
						this._doDispose();
					}
				}
			}
		}, {
			key: '_onHlsJsManifestLoaded',
			value: function _onHlsJsManifestLoaded(event, data) {
				_logger.logger.log('HLSJS MANIFEST_LOADED');
	
				this._emit(_HlsEvents2.default.MANIFEST_LOADED, data);
			}
		}, {
			key: '_onHlsJsManifestParsed',
			value: function _onHlsJsManifestParsed(event, data) {
				_logger.logger.log('HLSJS MANIFEST_PARSED');
	
				if (this._loaded) {
					throw new Error('manifest is already parsed!');
				}
	
				// emits event
				this._setLevels(data.levels);
	
				var newExplicitDimensions = false;
	
				if (this._levels) {
					this._levels.forEach(function (item) {
						if (item.width !== undefined && item.height !== undefined) {
							newExplicitDimensions = true;
						}
					});
				}
	
				this._explicitDimensions = newExplicitDimensions;
	
				this._loaded = true;
	
				// can only set this after we recieve the levels.
				var newMinMax = this._updateConstraints();
				var startLevel = this._getDefaultLevel();
				this._maximumConstraint = newMinMax.max;
				this._minimumConstraint = newMinMax.min;
	
				// selects a level based on the selected starting bitrate or level
				if (this._startBitrate !== -1) {
					var startBitrate = this._startBitrate;
	
					if (this._constraints.minBitrate !== -1) {
						startBitrate = Math.max(startBitrate, this._constraints.minBitrate);
					}
	
					if (this._constraints.maxBitrate !== -1) {
						startBitrate = Math.min(startBitrate, this._constraints.maxBitrate);
					}
	
					startLevel = this._setStartLevelUsingBitrate(startBitrate);
				} else {
					if (this._startLevel !== -1) {
						startLevel = this._startLevel;
					}
	
					if (this._minimumConstraint !== -1) {
						startLevel = Math.max(startLevel, this._minimumConstraint);
					}
	
					if (this._maximumConstraint !== -1) {
						startLevel = Math.min(startLevel, this._maximumConstraint);
					}
				}
	
				this._hlsJs.startLevel = startLevel;
	
				this._emit(_HlsEvents2.default.MANIFEST_PARSED, data);
			}
		}, {
			key: '_onHlsJsFragBuffered',
			value: function _onHlsJsFragBuffered(event, data) {
				_logger.logger.log('HLSJS FRAG_BUFFERED');
				this._emit(_HlsEvents2.default.CHUNK_BUFFERED);
	
				if (this._bitrateCycle && data.id === 'main') {
					this._cycleBitrates();
				}
			}
		}, {
			key: '_onHlsJsLiveTimeChange',
			value: function _onHlsJsLiveTimeChange(event, data) {
				this._setLiveTime(data.liveTime);
			}
		}, {
			key: '_onHlsJsBasePdtFound',
			value: function _onHlsJsBasePdtFound(event, data) {
				if (_HlsUtils2.default.isValidDate(data.basePdt)) {
					this._setBasePdt(data.basePdt);
	
					if (_HlsUtils2.default.isValidDate(this._recoveryStartTimeByPdt)) {
						if (this._recoveryStartTimeByPdt.getTime() > data.basePdt.getTime()) {
							_logger.logger.log('_onHlsJsBasePdtFound: applied this._recoveryStartTimeByPdt: ' + this._recoveryStartTimeByPdt);
							this._hlsJs.startPositionPdt(this._recoveryStartTimeByPdt);
						} else {
							_logger.logger.log('_onHlsJsBasePdtFound: ignoring recovery time as it is too early this._recoveryStartTimeByPdt: ' + this._recoveryStartTimeByPdt);
						}
						this._recoveryStartTimeByPdt = undefined;
					} else if (_HlsUtils2.default.isValidDate(this._startTimeByPdt)) {
						//replace the stream coordinator start time with the PDT we have
						this._hlsJs.startPositionPdt(this._startTimeByPdt);
					}
				}
			}
		}, {
			key: '_cycleBitrates',
			value: function _cycleBitrates() {
				if (this._bitrateStepDown) {
					if (this.getConstraints().maxVariant === this._bitrateCycleMin) {
						this._bitrateStepDown = false;
						this.setConstraints({ minVariant: this.getConstraints().maxVariant + 1,
							maxVariant: this.getConstraints().maxVariant + 1, noFlush: true });
					} else {
						this.setConstraints({ minVariant: this.getConstraints().maxVariant - 1,
							maxVariant: this.getConstraints().maxVariant - 1, noFlush: true });
					}
				} else {
					if (this.getConstraints().maxVariant === this._bitrateCycleMax) {
						this._bitrateStepDown = true;
						this.setConstraints({ minVariant: this.getConstraints().maxVariant - 1,
							maxVariant: this.getConstraints().maxVariant - 1, noFlush: true });
					} else {
						this.setConstraints({ minVariant: this.getConstraints().maxVariant + 1,
							maxVariant: this.getConstraints().maxVariant + 1, noFlush: true });
					}
				}
	
				_logger.logger.log('HlsJsController::_cycleBitrates: level changed to ' + this.getConstraints().maxVariant);
			}
		}, {
			key: '_selectInitialAudioTrack',
			value: function _selectInitialAudioTrack(renditions) {
				_logger.logger.log('Selecting Initial Audio Track ' + this._initialAudioLanguage + ' ' + this._initialAudioName);
	
				var renditionCount = renditions.audioTracks.length;
				var i = 0;
				var initialAudioIndex = this._initialAudioIndex;
				var primarySelect = -1;
				var secondarySelect = -1;
	
				if (this._recoveryAudioIndex !== -1) {
					initialAudioIndex = this._recoveryAudioIndex;
					this._recoveryAudioIndex = -1;
				}
	
				if (initialAudioIndex > 0 && this._initialAudioIndex < renditionCount) {
					primarySelect = initialAudioIndex;
				} else {
					while (i < renditionCount && primarySelect === -1) {
						if (this._initialAudioLanguage !== null && this._initialAudioName !== null) {
							if (this._initialAudioLanguage === renditions.audioTracks[i].lang && this._initialAudioName === renditions.audioTracks[i].name) {
								primarySelect = i;
							} else if (secondarySelect === -1 && this._initialAudioName === renditions.audioTracks[i].name) {
								secondarySelect = i;
							} else if (secondarySelect === -1 && this._initialAudioLanguage === renditions.audioTracks[i].lang) {
								secondarySelect = i;
							}
						} else if (this._initialAudioLanguage !== null) {
							if (this._initialAudioLanguage === renditions.audioTracks[i].lang) {
								primarySelect = i;
							}
						} else if (this._initialAudioName !== null) {
							if (this._initialAudioName === renditions.audioTracks[i].name) {
								primarySelect = i;
							}
						}
						i++;
					}
				}
	
				if (primarySelect !== -1) {
					this.currentAudioRendition = primarySelect;
				} else if (secondarySelect !== -1) {
					this.currentAudioRendition = secondarySelect;
				}
			}
		}, {
			key: '_setStartLevelUsingBitrate',
			value: function _setStartLevelUsingBitrate(bitrate) {
				var closest = -1;
				var diff = -1;
				var count = 0;
	
				// find variant with the closest bitrate to what has been requested
				this._levels.forEach(function (item) {
					var newDiff = Math.abs(bitrate - item.bitrate);
					if (diff === -1 || newDiff < diff) {
						diff = newDiff;
						closest = count;
					}
					count++;
				});
	
				return closest;
			}
		}, {
			key: '_onHlsJsLevelLoaded',
			value: function _onHlsJsLevelLoaded(event, data) {
				_logger.logger.log('HLSJS LEVEL_LOADED');
	
				/*if (data.details.fragments[0].rawProgramDateTime) {
	   	if (this._basePdt === undefined) {
	   		let basePdt = new Date(Date.parse(data.details.fragments[0].rawProgramDateTime));
	   			if(Utils.isValidDate(basePdt)) {
	   			this._setBasePdt(basePdt);
	   				if (Utils.isValidDate(this._startTimeByPdt)) {
	   				let startPosition = 0;
	   					startPosition = (this._startTimeByPdt.getTime() - this._basePdt.getTime()) / 1000;
	   					this._hlsJs.startPositionPdt(startPosition);
	   			}
	   		}
	   	}
	   }*/
	
				this._emit(_HlsEvents2.default.VARIANT_LOADED, data);
			}
		}, {
			key: '_onHlsJsLevelUpdated',
			value: function _onHlsJsLevelUpdated(event, data) {
				_logger.logger.log('HLSJS LEVEL_UPDATED');
	
				this._emit(_HlsEvents2.default.VARIANT_UPDATED, data);
	
				// update duration, liveTime, live, slidingWindow etc (emit events)
				_logger.logger.log(data);
				this._processLevelUpdate(data);
			}
		}, {
			key: '_onHlsJsLevelDurationUpdated',
			value: function _onHlsJsLevelDurationUpdated(event, data) {
				_logger.logger.log('HLSJS LEVEL_DURATION_UPDATED');
	
				this._emit(_HlsEvents2.default.VARIANT_DURATION_UPDATED, data);
			}
		}, {
			key: '_onHlsJsBufferCreated',
			value: function _onHlsJsBufferCreated() {
				var audioOnly = true;
	
				for (var i = 0; i < this._levels.length; i++) {
					if (this._levels[i].videoCodec !== undefined) {
						audioOnly = false;
					}
				}
	
				this._setAudioOnly(audioOnly);
			}
		}, {
			key: '_onHlsJsBufferAppended',
			value: function _onHlsJsBufferAppended() {
				this._updateBufferedRange();
			}
		}, {
			key: '_onHlsJsBufferFlushed',
			value: function _onHlsJsBufferFlushed() {
				this._updateBufferedRange();
	
				this._emit(_HlsEvents2.default.BUFFER_FLUSHED);
			}
		}, {
			key: '_onHlsJsLevelSwitching',
			value: function _onHlsJsLevelSwitching(event, data) {
				_logger.logger.log('HLSJS LEVEL_SWITCHING');
	
				this._setChosenVariant(data.level);
			}
		}, {
			key: '_onHlsJsBitrateEstimateUpdated',
			value: function _onHlsJsBitrateEstimateUpdated(event, data) {
				this._setPerceivedBitrate(data.bitrate);
			}
	
			//While this is no longer the main point where metrics update, the initial firing is tied to this event
	
		}, {
			key: '_onHlsJsLevelSelectionFinished',
			value: function _onHlsJsLevelSelectionFinished() {
				this._updateNetworkMetrics();
			}
		}, {
			key: '_onHlsJsFragStartFound',
			value: function _onHlsJsFragStartFound(event, data) {
				this._nextNetworkMetrics.displayTime = this.getTimeForPdt(new Date(data.startPdt));
				this._updateNetworkMetrics();
			}
		}, {
			key: '_onHlsJsFragLoaded',
			value: function _onHlsJsFragLoaded(event, data) {
				_logger.logger.log('HLSJS FRAG_LOADED');
	
				this._emit(_HlsEvents2.default.CHUNK_LOADED, data);
			}
		}, {
			key: '_onHlsJsTextTrackAdded',
			value: function _onHlsJsTextTrackAdded(event, data) {
				_logger.logger.log('HLSJS TEXT_TRACK_ADDED');
	
				this._subtitleRenditions.push(data.track);
	
				this._emit(_HlsEvents2.default.STREAM_SUBTITLERENDITIONS_CHANGED, data);
			}
		}, {
			key: '_onHlsJsAudioTracksUpdated',
			value: function _onHlsJsAudioTracksUpdated(event, data) {
				_logger.logger.log('HLSJS AUDIO_TRACKS_UPDATED');
	
				if (this._initialAudioTrackSelected === false && data.audioTracks.length > 0 && (this._initialAudioLanguage !== null || this._initialAudioName !== null || this._initialAudioIndex !== null)) {
					this._initialAudioTrackSelected = true;
					this._selectInitialAudioTrack(data);
				}
	
				this._emit(_HlsEvents2.default.STREAM_AUDIORENDITIONS_CHANGED, data);
			}
		}, {
			key: '_onHlsJsMetadataParsed',
			value: function _onHlsJsMetadataParsed(event, data) {
				_logger.logger.log('HLSJS FRAG_PARSING_METADATA');
				if (data.frag) {
					this._emit(_HlsEvents2.default.TIMED_METADATA_UPDATE, {
						id: data.id,
						variant: data.frag.level,
						chunkIdx: data.frag.sn,
						chunkStartTime: data.frag.start,
						chunkEndTime: data.frag.start + data.frag.duration,
						samples: data.samples
					});
				}
			}
		}, {
			key: '_onHlsJsStartPositionSet',
			value: function _onHlsJsStartPositionSet(event, data) {
				_logger.logger.log('HLSJS START_POSITION_SET');
	
				this._emit(_HlsEvents2.default.STREAM_STARTPOSITION_SET, data);
			}
		}, {
			key: '_onHlsJsFpsDropLevelCapping',
			value: function _onHlsJsFpsDropLevelCapping(event, data) {
				_logger.logger.log('HLSJS FPS_DROP_LEVEL_CAPPING');
	
				this._constraints.maxVariant = data.level; //we don't want to trigger a constraint recalculation but we do want the change reflected
			}
		}, {
			key: '_onHlsJsSeekReady',
			value: function _onHlsJsSeekReady(event, data) {
				this._emit(_HlsEvents2.default.HLSJS_SEEK_READY, data);
			}
		}, {
			key: 'getConstraints',
			value: function getConstraints() {
				var constraints = {};
	
				constraints.minVariant = this._constraints.minVariant;
				constraints.maxVariant = this._constraints.maxVariant;
				constraints.minBitrate = this._constraints.minBitrate;
				constraints.maxBitrate = this._constraints.maxBitrate;
				constraints.minWidth = this._constraints.minWidth;
				constraints.minHeight = this._constraints.minHeight;
				constraints.maxWidth = this._constraints.maxWidth;
				constraints.maxHeight = this._constraints.maxHeight;
	
				return constraints;
			}
		}, {
			key: 'setConstraints',
			value: function setConstraints(constraints, causeNoSideEffects) {
				if (!_HlsUtils2.default.isObject(constraints)) {
					throw new Error('setConstraints: must use a valid constraints object');
				}
				var newConstraints = this._constraints;
				var flush = false;
	
				//find and check valid properties, put valid properties into set of changes to make
				//invalid properties can be ignored, valid properties that are < -1 should throw
				if (constraints.minVariant !== undefined) {
					_HlsUtils2.default.checkNotIntegerAndThrow(constraints.minVariant, 'minVariant');
					_HlsUtils2.default.checkLessThanMinusOneAndThrow(constraints.minVariant, 'minVariant');
	
					newConstraints.minVariant = constraints.minVariant;
				}
				if (constraints.maxVariant !== undefined) {
					_HlsUtils2.default.checkNotIntegerAndThrow(constraints.maxVariant, 'maxVariant');
					_HlsUtils2.default.checkLessThanMinusOneAndThrow(constraints.maxVariant, 'maxVariant');
	
					newConstraints.maxVariant = constraints.maxVariant;
				}
				if (constraints.minBitrate !== undefined) {
					_HlsUtils2.default.checkNotIntegerAndThrow(constraints.minBitrate, 'minBitrate');
					_HlsUtils2.default.checkLessThanMinusOneAndThrow(constraints.minBitrate, 'minBitrate');
	
					newConstraints.minBitrate = constraints.minBitrate;
				}
				if (constraints.maxBitrate !== undefined) {
					_HlsUtils2.default.checkNotIntegerAndThrow(constraints.maxBitrate, 'maxBitrate');
					_HlsUtils2.default.checkLessThanMinusOneAndThrow(constraints.maxBitrate, 'maxBitrate');
	
					newConstraints.maxBitrate = constraints.maxBitrate;
				}
				if (constraints.minWidth !== undefined) {
					_HlsUtils2.default.checkNotIntegerAndThrow(constraints.minWidth, 'minWidth');
					_HlsUtils2.default.checkLessThanMinusOneAndThrow(constraints.minWidth, 'minWidth');
	
					newConstraints.minWidth = constraints.minWidth;
				}
				if (constraints.minHeight !== undefined) {
					_HlsUtils2.default.checkNotIntegerAndThrow(constraints.minHeight, 'minHeight');
					_HlsUtils2.default.checkLessThanMinusOneAndThrow(constraints.minHeight, 'minHeight');
	
					newConstraints.minHeight = constraints.minHeight;
				}
				if (constraints.maxWidth !== undefined) {
					_HlsUtils2.default.checkNotIntegerAndThrow(constraints.maxWidth, 'maxWidth');
					_HlsUtils2.default.checkLessThanMinusOneAndThrow(constraints.maxWidth, 'maxWidth');
	
					newConstraints.maxWidth = constraints.maxWidth;
				}
				if (constraints.maxHeight !== undefined) {
					_HlsUtils2.default.checkNotIntegerAndThrow(constraints.maxHeight, 'maxHeight');
					_HlsUtils2.default.checkLessThanMinusOneAndThrow(constraints.maxHeight, 'maxHeight');
	
					newConstraints.maxHeight = constraints.maxHeight;
				}
	
				//apply new properties after checks so that in case of throw, we don't partially apply new constraints
				this._constraints = newConstraints;
				var newMinMax = this._updateConstraints();
	
				//if the maximum constraint is relaxed prepare a buffer flush
				if ((newMinMax.max > this._maximumConstraint || newMinMax.max === -1) && this._maximumConstraint !== -1) {
					flush = true;
				}
	
				if (constraints.noFlush === true || causeNoSideEffects) {
					flush = false;
				}
	
				this._maximumConstraint = newMinMax.max;
				this._minimumConstraint = newMinMax.min;
	
				if (flush) {
					this._hlsJs.stopFetch();
					this.flushBuffer(true);
					this._hlsJs.resumeFetch();
				}
			}
		}, {
			key: 'getTimeouts',
			value: function getTimeouts() {
				var timeouts = {};
	
				timeouts.manifestTimeout = this._timeouts.manifestTimeout;
				timeouts.manifestTimeoutMax = this._timeouts.manifestTimeoutMax;
				timeouts.variantTimeout = this._timeouts.variantTimeout;
				timeouts.variantTimeoutMax = this._timeouts.variantTimeoutMax;
				timeouts.chunkTimeout = this._timeouts.chunkTimeout;
				timeouts.chunkTimeoutMax = this._timeouts.chunkTimeoutMax;
				timeouts.streamTimeout = this._timeouts.streamTimeout;
	
				return timeouts;
			}
		}, {
			key: 'setTimeouts',
			value: function setTimeouts(timeouts) {
				if (!_HlsUtils2.default.isObject(timeouts)) {
					throw new Error('setTimeouts: must use a valid timeouts object');
				}
	
				var newTimeouts = this._timeouts;
	
				if (timeouts.manifestTimeout !== undefined) {
					_HlsUtils2.default.checkNotIntegerAndThrow(timeouts.manifestTimeout, 'manifestTimeout');
					_HlsUtils2.default.checkLessThanZeroPointZeroAndThrow(timeouts.manifestTimeout, 'manifestTimeout');
	
					newTimeouts.manifestTimeout = timeouts.manifestTimeout;
				}
				if (timeouts.manifestTimeoutMax !== undefined) {
					_HlsUtils2.default.checkNotIntegerAndThrow(timeouts.manifestTimeoutMax, 'manifestTimeoutMax');
					_HlsUtils2.default.checkLessThanZeroPointZeroAndThrow(timeouts.manifestTimeoutMax, 'manifestTimeoutMax');
	
					newTimeouts.manifestTimeoutMax = timeouts.manifestTimeoutMax;
				}
				if (timeouts.variantTimeout !== undefined) {
					_HlsUtils2.default.checkNotIntegerAndThrow(timeouts.variantTimeout, 'variantTimeout');
					_HlsUtils2.default.checkLessThanZeroPointZeroAndThrow(timeouts.variantTimeout, 'variantTimeout');
	
					newTimeouts.variantTimeout = timeouts.variantTimeout;
				}
				if (timeouts.variantTimeoutMax !== undefined) {
					_HlsUtils2.default.checkNotIntegerAndThrow(timeouts.variantTimeoutMax, 'variantTimeoutMax');
					_HlsUtils2.default.checkLessThanZeroPointZeroAndThrow(timeouts.variantTimeoutMax, 'variantTimeoutMax');
	
					newTimeouts.variantTimeoutMax = timeouts.variantTimeoutMax;
				}
				if (timeouts.chunkTimeout !== undefined) {
					_HlsUtils2.default.checkNotIntegerAndThrow(timeouts.chunkTimeout, 'chunkTimeout');
					_HlsUtils2.default.checkLessThanZeroPointZeroAndThrow(timeouts.chunkTimeout, 'chunkTimeout');
	
					newTimeouts.chunkTimeout = timeouts.chunkTimeout;
				}
				if (timeouts.chunkTimeoutMax !== undefined) {
					_HlsUtils2.default.checkNotIntegerAndThrow(timeouts.chunkTimeoutMax, 'chunkTimeoutMax');
					_HlsUtils2.default.checkLessThanZeroPointZeroAndThrow(timeouts.chunkTimeoutMax, 'chunkTimeoutMax');
	
					newTimeouts.chunkTimeoutMax = timeouts.chunkTimeoutMax;
				}
				if (timeouts.streamTimeout !== undefined) {
					_HlsUtils2.default.checkNotIntegerAndThrow(timeouts.streamTimeout, 'streamTimeout');
					_HlsUtils2.default.checkLessThanZeroPointZeroAndThrow(timeouts.streamTimeout, 'streamTimeout');
	
					newTimeouts.streamTimeout = timeouts.streamTimeout;
				}
	
				this._timeouts = newTimeouts;
	
				this._hlsJs.timeouts = this._timeouts;
			}
		}, {
			key: 'getNetworkMetrics',
			value: function getNetworkMetrics() {
				return this._networkMetrics;
			}
		}, {
			key: 'getDrmCapabilities',
			value: function getDrmCapabilities() {
				var _this3 = this;
	
				// this needs to call into *something* to get the capabilities. And if we need to pend it, then I guess we need to stash the promise while we pend, etc.
	
				if (!this._drmCapabilitiesPromise) {
					this._drmCapabilitiesPromise = new Promise(function (resolve, reject) {
						_this3._hlsJs.getCdmListAsync().then(function (cdmList) {
							//process list
							var processedList = _this3.generateCapabilities(cdmList);
							resolve(processedList);
						}).catch(function (err) {
							reject(err);
						});
					});
				}
	
				return this._drmCapabilitiesPromise;
			}
		}, {
			key: 'keyCache',
			value: function keyCache(cache) {
				if (cache !== null && !_HlsUtils2.default.isFunction(cache.hlsKeyLoadCallback)) {
					throw new Error('keyCache: func ' + cache.hlsKeyLoadCallback + ' must be either null, or a function');
				}
	
				if (this._keyCache !== null) {
					//			this._keyCache.destroy();
					this._keyCache = null;
				}
				this._keyCache = cache;
	
				//Best place to disable hlsKey. Disable nulling to use hlsKey
				this._keyCache = null;
				//Best place to disable hlsKey. Disable nulling to use hlsKey
				//Note that there are some keyCache tests that should be enabled once this is final
	
				//		//If there's a existing custom callback we do not want to set this
				//		if (this._keyLoadCallback === null && this._cache != null) {
				//			this._setKeyLoadCallback( this._cache.hlsKeyLoadCallback );
				//		}
	
				if (this._keyCache != null) {
					this._setKeyLoadCallback();
				}
			}
	
			//max is to be treated as a constraint, min is a preferred quality. Max has
			//priority, but we should always try to play something.
	
		}, {
			key: '_updateConstraints',
			value: function _updateConstraints() {
				if (this._levels && this._levels.length > 0) {
					var lastLevel = this._levels.length - 1;
					var maxBitrateAsLevel = lastLevel;
					var minBitrateAsLevel = -1;
					var minBitrateAsBitrate = -1;
	
					// -1 means use maximum bitrate, which is already set.
					if (this._constraints.maxBitrate >= 0) {
	
						// calculate level which is under or equal to maxBitrate, stopping at the lowest bitrate.
						while (maxBitrateAsLevel > 0 && this._levels[maxBitrateAsLevel].bitrate > this._constraints.maxBitrate) {
							maxBitrateAsLevel--;
						}
					}
	
					// only apply maxWidth/Height if at least one level has an explicit width and height
					if (this._explicitDimensions) {
						if (this._constraints.maxWidth >= 0) {
							while (maxBitrateAsLevel > 0 && this._levels[maxBitrateAsLevel].width > this._constraints.maxWidth) {
								maxBitrateAsLevel--;
							}
						}
						if (this._constraints.maxHeight >= 0) {
							while (maxBitrateAsLevel > 0 && this._levels[maxBitrateAsLevel].height > this._constraints.maxHeight) {
								maxBitrateAsLevel--;
							}
						}
					}
	
					//if the set maxVariant is less than the calculated maxBitrateAsLevel then use the maxVariant
					if (this._constraints.maxVariant >= 0 && this._constraints.maxVariant <= lastLevel && maxBitrateAsLevel > this._constraints.maxVariant) {
						maxBitrateAsLevel = this._constraints.maxVariant;
					}
					// In HlsJs, autoLevelCapping will clamp the level to this level. It next gets bumped up by minAutoBitrate.
					this._hlsJs.autoLevelCapping = maxBitrateAsLevel;
					_logger.logger.log('_updateConstraints autoLevelCapping to ' + maxBitrateAsLevel);
	
					if (this._constraints.minBitrate >= 0 || this._constraints.minVariant >= 0 || this._constraints.minWidth >= 0 || this._constraints.minHeight >= 0) {
						minBitrateAsLevel = 0;
					}
	
					if (this._constraints.minBitrate >= 0) {
						while (minBitrateAsLevel < lastLevel && this._levels[minBitrateAsLevel].bitrate < this._constraints.minBitrate) {
							minBitrateAsLevel++;
						}
					}
	
					// only apply minWidth/Height if at least one level has an explicit width and height
					if (this._explicitDimensions) {
						if (this._constraints.minWidth >= 0) {
							while (minBitrateAsLevel < lastLevel && this._levels[minBitrateAsLevel].width < this._constraints.minWidth) {
								minBitrateAsLevel++;
							}
						}
						if (this._constraints.minHeight >= 0) {
							while (minBitrateAsLevel < lastLevel && this._levels[minBitrateAsLevel].height < this._constraints.minHeight) {
								minBitrateAsLevel++;
							}
						}
					}
					if (this._constraints.minVariant >= 0 && minBitrateAsLevel <= this._constraints.minVariant) {
						minBitrateAsLevel = this._constraints.minVariant;
					}
	
					if (maxBitrateAsLevel !== -1 && minBitrateAsLevel > maxBitrateAsLevel) {
						minBitrateAsLevel = maxBitrateAsLevel;
					}
	
					if (minBitrateAsLevel >= 0) {
						if (minBitrateAsLevel > lastLevel) {
							minBitrateAsLevel = lastLevel;
						}
						minBitrateAsBitrate = this._levels[minBitrateAsLevel].bitrate;
					}
					if (minBitrateAsBitrate < this._constraints.minBitrate) {
						minBitrateAsBitrate = this._constraints.minBitrate;
					}
	
					if (maxBitrateAsLevel !== -1 && minBitrateAsBitrate > this._levels[maxBitrateAsLevel].bitrate) {
						minBitrateAsBitrate = this._levels[maxBitrateAsLevel].bitrate;
					}
	
					if (minBitrateAsBitrate === -1 || this._levels.length === 1) {
	
						// this is the no-limit case. By setting undefined, we skip the
						// repetive calculation every bitrate decision.  we might as well
						// also do this for a single variant playlist. don't know how smart
						// hlsjs is.
						this._hlsJs.minAutoBitrate = undefined;
					} else {
						// critical that we clamp to actual max bitrate, or hlsjs will explode.
						this._hlsJs.minAutoBitrate = Math.min(this._levels[lastLevel].bitrate, minBitrateAsBitrate - 1);
						_logger.logger.log('_updateConstraints minAutoBitrate to ' + minBitrateAsLevel);
					}
	
					//if we try to flush the buffer before hlsjs is actually putting chunks in there hlsjs blows up
					//if(this._fetching) {
					//this._hlsJs.flushBuffers();
					//}
					return { min: minBitrateAsLevel, max: maxBitrateAsLevel };
				}
	
				return { min: -1, max: -1 };
			}
		}, {
			key: '_getDefaultLevel',
			value: function _getDefaultLevel() {
				if (this.levels && this.levels.length > 0) {
					for (var i = 0; i < this.levels.length; i++) {
						if (this.levels[i].default) {
							return i;
						}
					}
				}
	
				return 0;
			}
		}, {
			key: 'getTimeForPdt',
			value: function getTimeForPdt(pdt) {
				return this._hlsJs.getTimeForPdt(pdt);
			}
		}, {
			key: 'getPdtForTime',
			value: function getPdtForTime(time) {
				return this._hlsJs.getPdtForTime(time);
			}
		}, {
			key: 'generateCapabilities',
			value: function generateCapabilities(cdmList) {
				var drmCaps = { keySystems: {} };
	
				for (var key in _KeySystems2.default) {
					if (_KeySystems2.default.hasOwnProperty(key)) {
						drmCaps.keySystems[key] = { supported: false, modes: {} };
	
						for (var mode in _CencModes2.default) {
							if (_CencModes2.default.hasOwnProperty(mode)) {
								drmCaps.keySystems[key].modes[mode] = false;
							}
						}
					}
				}
	
				if (cdmList.includes('com.apple.fps.2_0')) {
					drmCaps.keySystems[_KeySystems2.default.FAIRPLAY].supported = true;
					drmCaps.keySystems[_KeySystems2.default.FAIRPLAY].modes[_CencModes2.default.CBC] = true;
				}
				if (cdmList.includes('com.microsoft.playready')) {
					drmCaps.keySystems[_KeySystems2.default.PLAYREADY].supported = true;
					drmCaps.keySystems[_KeySystems2.default.PLAYREADY].modes[_CencModes2.default.CTR] = true;
				}
				if (cdmList.includes('com.widevine.alpha')) {
					drmCaps.keySystems[_KeySystems2.default.WIDEVINE].supported = true;
					drmCaps.keySystems[_KeySystems2.default.WIDEVINE].modes[_CencModes2.default.CTR] = true;
				}
				if (cdmList.includes('org.w3.clearkey')) {
					drmCaps.keySystems[_KeySystems2.default.CLEARKEY].supported = true;
					drmCaps.keySystems[_KeySystems2.default.CLEARKEY].modes[_CencModes2.default.CTR] = true;
				}
	
				return drmCaps;
			}
		}, {
			key: 'hlsJs',
			get: function get() {
				return this._hlsJs;
			}
		}, {
			key: 'emitter',
			get: function get() {
				return this._emitter;
			}
		}, {
			key: 'live',
			get: function get() {
				return this._live === undefined || this._live;
			}
		}, {
			key: 'liveTime',
			get: function get() {
				//return this._hlsJs.liveSyncPosition;
				return this._liveTime !== undefined ? this._liveTime : 0;
			}
		}, {
			key: 'bufferedRange',
			get: function get() {
				if (this._bufferedRange !== undefined) {
					return this._bufferedRange;
				} else {
					var bufferedRange = [];
					bufferedRange[0] = { start: 0, end: 0, duration: 0 };
					return bufferedRange;
				}
			}
		}, {
			key: 'isMediaAttached',
			get: function get() {
				return this._mediaAttached;
			}
		}, {
			key: 'levels',
			get: function get() {
				return this._levels;
			}
		}, {
			key: 'audioRenditions',
			get: function get() {
				return this._hlsJs.audioTracks || [];
			}
		}, {
			key: 'currentAudioRendition',
			get: function get() {
				return this._hlsJs.audioTrack >= 0 ? this._hlsJs.audioTrack : 0;
			},
			set: function set(index) {
				_HlsUtils2.default.checkNotIntegerAndThrow(index, 'audioRendition');
				_HlsUtils2.default.checkLessThanZeroPointZeroAndThrow(index, 'audioRendition');
	
				if (index >= this.audioRenditions.length) {
					throw new Error('audioRendition can not be greater than ' + (this.audioRenditions.length - 1) + ' for this stream, ( ' + index + ' )');
				}
	
				var lastAudioRendition = this.currentAudioRendition;
	
				if (lastAudioRendition !== index) {
					this._hlsJs.audioTrack = index;
					this._emit(_HlsEvents2.default.STREAM_AUDIORENDITION_CHANGED, { lastAudioRendition: lastAudioRendition, audioRendition: index });
				}
			}
		}, {
			key: 'subtitleRenditions',
			get: function get() {
				return this._subtitleRenditions;
			}
		}, {
			key: 'changeSubtitlesByIndex',
			set: function set(value) {
				_HlsUtils2.default.checkNotIntegerAndThrow(value, 'subtitleIndex');
				_HlsUtils2.default.checkLessThanOnePointZeroAndThrow(value, 'subtitleIndex');
	
				var lastSubtitleRendition = this._hlsJs.subtitleIndex;
	
				if (lastSubtitleRendition !== value) {
					this._hlsJs.subtitleIndex = value;
					this._emit(_HlsEvents2.default.STREAM_SUBTITLERENDITION_CHANGED, { lastSubtitleRendition: lastSubtitleRendition, subtitleRendition: value });
				}
			}
		}, {
			key: 'slidingWindow',
			get: function get() {
				return this._slidingWindow;
			}
		}, {
			key: 'audioOnly',
			get: function get() {
				return this._audioOnly;
			}
		}, {
			key: 'multithreaded',
			get: function get() {
				return this._multithreaded;
			}
		}, {
			key: 'useAutomaticComplexityReduction',
			get: function get() {
				return this._hlsJs.config.capLevelOnFPSDrop;
			},
			set: function set(value) {
				if (!!value === true && _HlsUtils2.default.isTizen()) {
					_logger.logger.warn('enabling useAutomaticComplexityReduction will have no effect on Tizen applications');
				}
	
				this._hlsJs.config.capLevelOnFPSDrop = !!value;
			}
		}, {
			key: 'bitrateCycle',
			get: function get() {
				return this._bitrateCycle;
			},
			set: function set(value) {
				this._bitrateCycle = !!value;
	
				if (this._bitrateCycle) {
					this._bitrateStepDown = false;
					this._bitrateCycleMax = this.getConstraints().maxVariant === -1 ? this._levels.length - 1 : this.getConstraints().maxVariant;
					this._bitrateCycleMin = this.getConstraints().minVariant === -1 ? 0 : this.getConstraints().minVariant;
					this.setConstraints({ minVariant: 1, maxVariant: 1 });
				}
			}
	
			// HlsJs appears to be able to handle changing the buffer size by itself, although we should still sanity check to
			// make sure no negative values get in and risk breaking things.
	
		}, {
			key: 'maximumBufferSize',
			get: function get() {
				return this._hlsJs.config.maxBufferSize;
			},
			set: function set(value) {
				_HlsUtils2.default.checkNotIntegerAndThrow(value, 'maximumBufferSize');
				_HlsUtils2.default.checkLessThanZeroPointZeroAndThrow(value, 'maximumBufferSize');
	
				this._hlsJs.config.maxBufferSize = value;
			}
		}, {
			key: 'minimumBufferLength',
			get: function get() {
				return this._hlsJs.config.maxBufferLength;
			},
			set: function set(value) {
				_HlsUtils2.default.checkNotIntegerAndThrow(value, 'minimumBufferLength');
				_HlsUtils2.default.checkLessThanOnePointZeroAndThrow(value, 'minimumBufferLength');
	
				this._hlsJs.config.maxBufferLength = value;
			}
		}, {
			key: 'maximumBufferLength',
			get: function get() {
				return this._hlsJs.config.maxMaxBufferLength;
			},
			set: function set(value) {
				_HlsUtils2.default.checkNotIntegerAndThrow(value, 'maximumBufferLength');
				_HlsUtils2.default.checkLessThanOnePointZeroAndThrow(value, 'maximumBufferLength');
	
				this._hlsJs.config.maxMaxBufferLength = value;
			}
		}, {
			key: 'startTime',
			get: function get() {
				return this._startTime;
			},
			set: function set(seconds) {
				_HlsUtils2.default.checkNotFiniteAndThrow(seconds, 'startTime');
				_HlsUtils2.default.checkLessThanZeroPointZeroAndThrow(seconds, 'startTime');
	
				this._startTime = Number(seconds);
			}
		}, {
			key: 'recoveryStartTime',
			set: function set(seconds) {
				_HlsUtils2.default.checkNotFiniteAndThrow(seconds, 'recoveryStartTime');
				_HlsUtils2.default.checkLessThanZeroPointZeroAndThrow(seconds, 'recoveryStartTime');
	
				this._recoveryStartTime = Number(seconds);
			}
		}, {
			key: 'startTimeByPdt',
			get: function get() {
				if (_HlsUtils2.default.isValidDate(this._startTimeByPdt)) {
					return this._startTimeByPdt;
				} else {
					return null;
				}
			},
			set: function set(time) {
				if (_HlsUtils2.default.isValidDate(time)) {
					this._startTimeByPdt = time;
				} else {
					throw new Error('set startTimeByPdt: ' + time + ' is not a valid date');
				}
			}
		}, {
			key: 'startLevel',
			get: function get() {
				return this._startLevel;
			},
			set: function set(level) {
				_HlsUtils2.default.checkNotIntegerAndThrow(level, 'startVariant');
				_HlsUtils2.default.checkLessThanMinusOneAndThrow(level, 'startVariant');
	
				this._startLevel = level;
			}
		}, {
			key: 'startBitrate',
			get: function get() {
				return this._startBitrate;
			},
			set: function set(bitrate) {
				_HlsUtils2.default.checkNotIntegerAndThrow(bitrate, 'startBitrate');
				_HlsUtils2.default.checkLessThanMinusOneAndThrow(bitrate, 'startBitrate');
	
				this._startBitrate = bitrate;
			}
		}, {
			key: 'nudgeOnStall',
			get: function get() {
				return this._hlsJs.config.nudgeOnStall;
			},
			set: function set(value) {
				if (!!value === false && !this._hlsJs.config.enableMuxJs) {
					throw new Error('Disabling nudgeOnStall while using the legacy demuxer is not allowed');
				}
	
				this._hlsJs.config.nudgeOnStall = !!value;
			}
		}, {
			key: 'initialAudioLanguage',
			get: function get() {
				return this._initialAudioLanguage;
			},
			set: function set(language) {
				this._initialAudioLanguage = language;
			}
		}, {
			key: 'initialAudioName',
			get: function get() {
				return this._initialAudioName;
			},
			set: function set(name) {
				this._initialAudioName = name;
			}
		}, {
			key: 'initialAudioIndex',
			get: function get() {
				return this._initialAudioIndex;
			},
			set: function set(index) {
				this._initialAudioIndex = index;
			}
		}, {
			key: 'recoveryAudioIndex',
			set: function set(index) {
				this._recoveryAudioIndex = index;
			}
		}, {
			key: 'recoveryStartTimeByPdt',
			set: function set(time) {
				if (_HlsUtils2.default.isValidDate(time)) {
					this._recoveryStartTimeByPdt = time;
				} else {
					throw new Error('set recoveryStartTimeByPdt: ' + time + ' is not a valid date');
				}
			}
	
			/**
	   * if true, and the stream is live, the stream will start at the liveTime
	   *
	   * @type {boolean}
	   */
	
		}, {
			key: 'liveStreamsStartAtLiveTime',
			get: function get() {
				return this._liveStreamsStartAtLiveTime;
			},
			set: function set(value) {
				this._liveStreamsStartAtLiveTime = !!value;
			}
	
			/**
	  * a callback which is called after creating an XHR request to allow modification of
	  * the request. Ie to enable cookie support, or add RequestHeaders.
	  *
	  * @example
	  * hlsJsController.xhrSetup = function (xhr, url) {
	  *     xhr.withCredentials = true; // do send cookies
	  * }),
	  *
	  * null means no function is defined. Use null to clear.
	  *
	  * @type {function(xhr: XMLHttpRequest, url: string)} Xhr Setup Function
	  */
	
		}, {
			key: 'xhrSetup',
			get: function get() {
				return this._xhrSetup;
			},
			set: function set(func) {
				if (func !== null && !_HlsUtils2.default.isFunction(func)) {
					throw new Error('xhrSetup: func ' + func + ' must be either null, or a function');
				}
	
				this._xhrSetup = func;
			}
	
			/**
	   * a callback which when called will return a KeySystemConfig
	   *
	   * Not yet implemented
	   */
	
		}, {
			key: 'obtainKeySystemConfigCallback',
			get: function get() {
				return this._obtainKeySystemConfigCallback;
			},
			set: function set(func) {
				if (func !== null && !_HlsUtils2.default.isFunction(func)) {
					throw new Error('obtainKeySystemConfigCallback: func ' + func + ' must be either null, or a function');
				}
	
				this._obtainKeySystemConfigCallback = func;
			}
	
			/**
	  * a callback which is called to acquire a key
	  *
	  * @example
	  * hlsJsController.keyLoadCallback = function (context, callbacks) {
	  *     let result = myGetKeyFunction(context.url);
	  *     switch(result.code) {
	  *     case 'SUCCESS':
	  *         callbacks.onSuccess(result.key);
	  *         break;
	  *     case 'ERROR':
	  *         callbacks.onError(result.response, result.error);
	  *         break;
	  *     case 'TIMEOUT':
	  *         callbacks.onTimeout();
	  *     }
	  * }),
	  *
	  * null means no function is defined. Use null to clear.
	  *
	  * @type { function( context, callbacks ) } keyLoadCallback
	  */
	
		}, {
			key: 'keyLoadCallback',
			get: function get() {
				return this._customKeyLoadCallback;
			},
			set: function set(callback) {
				if (callback !== null && !_HlsUtils2.default.isFunction(callback)) {
					throw new Error('keyLoadCallback: func ' + callback + ' must be either null, or a function');
				}
				this._customKeyLoadCallback = callback;
				this._setKeyLoadCallback();
			}
		}, {
			key: 'basePdt',
			get: function get() {
				if (_HlsUtils2.default.isValidDate(this._basePdt)) {
					return this._basePdt;
				} else {
					return null;
				}
			}
		}, {
			key: 'bufferBeforeSeeking',
			set: function set(seconds) {
				this._hlsJs.bufferBeforeSeeking = seconds;
			}
		}], [{
			key: 'isSupported',
			value: function isSupported() {
				return !!_hls2.default.isSupported(); //booleanify
			}
		}]);
	
		return HlsJsController;
	}();
	
	exports.default = HlsJsController;
	module.exports = exports['default'];

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * HlsMarkers
	 *
	 *  HlsJs internal marker managment
	 *
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _HlsEvents = __webpack_require__(14);
	
	var _HlsEvents2 = _interopRequireDefault(_HlsEvents);
	
	var _markerM = __webpack_require__(169);
	
	var _markerM2 = _interopRequireDefault(_markerM);
	
	var _eventemitter = __webpack_require__(33);
	
	var _eventemitter2 = _interopRequireDefault(_eventemitter);
	
	var _EventHandlers = __webpack_require__(34);
	
	var _EventHandlers2 = _interopRequireDefault(_EventHandlers);
	
	var _HlsUtils = __webpack_require__(6);
	
	var _HlsUtils2 = _interopRequireDefault(_HlsUtils);
	
	var _logger = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	* @access internal
	*/
	var HlsMarkers = function () {
		function HlsMarkers() {
			var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
			var di = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
			_classCallCheck(this, HlsMarkers);
	
			this._emitter = di.eventEmitter || new _eventemitter2.default();
			this._markers = new _markerM2.default();
			this._chunkIndex = [];
			this._markerTriggeredCallback = this._markerTriggered.bind(this);
			this._handlers = new _EventHandlers2.default();
			this._lastTime = 0;
			this._instanceId = config.instanceId;
	
			this._handlers.setHlsEventsList(this, // obj to bind to
			this._emitter, // emitter to use
			[{ event: _HlsEvents2.default.TIMED_METADATA_UPDATE, func: this._onTimedMetadataUpdate }, { event: _HlsEvents2.default.STREAM_TIMEUPDATE, func: this._onStreamTimeUpdate }, { event: _HlsEvents2.default.MEDIA_SEEKED, func: this._onMediaSeeked }]).wireHlsEvents();
		}
	
		_createClass(HlsMarkers, [{
			key: 'dispose',
			value: function dispose() {
				this._handlers.unwireHlsEvents();
				this._handlers.dispose();
				this._handlers = null;
				this._chunkIndex = null;
				this._markers.dispose();
				this._markers = null;
				this._markerTriggeredCallback = null;
				this._emitter = null;
			}
		}, {
			key: '_emit',
			value: function _emit(event) {
				var _emitter;
	
				for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
					args[_key - 1] = arguments[_key];
				}
	
				(_emitter = this._emitter).emit.apply(_emitter, [event].concat(args));
			}
		}, {
			key: '_onTimedMetadataUpdate',
			value: function _onTimedMetadataUpdate(data) {
				this._addHlsMetaMarkers(data);
			}
		}, {
			key: '_onStreamTimeUpdate',
			value: function _onStreamTimeUpdate(data) {
				//The time update comes first sometimes... checking for large jumps is a workaround for now
				//		console.log(`_onStreamTimeUpdate time: ${data.currentTime} count: ${this._markers.count}`);
				if (Math.abs(data.currentTime - this._lastTime) < 15) {
					this.timeUpdateMeta(data.currentTime);
				} else {
					this.seekMarkers(data.currentTime);
				}
			}
		}, {
			key: '_onMediaSeeked',
			value: function _onMediaSeeked(data) {
				this.seekMarkers(data.currentTime);
			}
		}, {
			key: '_markerTriggered',
			value: function _markerTriggered(time, data, id) {
				//		console.log(`markerTriggered time: ${time} id: ${id} type: ${data.type} count: ${this._markers.count}`);
				switch (data.type) {
					case 'meta':
						this._emit(_HlsEvents2.default.TIMED_METADATA_PTS_REACHED, {
							time: time,
							id: data.id,
							sample: data.sample
						});
						break;
	
					case 'user':
						data.usercallback(time, data.userdata, id);
						break;
	
					default:
						throw new Error('HlsMarkers._markerTriggered: unknown type ' + data.type);
				}
			}
	
			//Passes though with no changes
	
		}, {
			key: 'addMarker',
			value: function addMarker(marker) {
				var markerId = this._markers.addMarker(marker.time, marker.data, marker.callback);
	
				return markerId;
			}
		}, {
			key: 'addTypedMarker',
			value: function addTypedMarker(time, callback, type, data) {
				if (!_HlsUtils2.default.isFunction(callback)) {
					throw new Error('HlsMarkers.addTypedMarker: callback must be valid');
				}
	
				var markerId = this._markers.addMarker(time, {
					userdata: data,
					usercallback: callback,
					type: type
				}, this._markerTriggeredCallback);
	
				return markerId;
			}
	
			//Adds a custom de-blocker and an optional callback override
	
		}, {
			key: '_addHlsMetaMarkers',
			value: function _addHlsMetaMarkers(data) {
				var _this = this;
	
				var markerId = 0;
	
				if (data.samples !== undefined && data.chunkIdx !== undefined) {
					var replacing = false;
	
					if (this._chunkIndex[data.chunkIdx] !== undefined) {
						replacing = true;
					}
	
					this._chunkIndex[data.chunkIdx] = {
						variant: data.variant,
						startTime: data.chunkStartTime,
						endTime: data.chunkEndTime
					};
					//			console.log(`addHlsMetaMarkers index: ${data.chunkIdx} MetaChunk index total: ${this._chunkIndex.length}`);
	
					if (replacing) {
						//				console.log(`MetaChunk removing/replacing ${data.chunkStartTime} to ${data.chunkEndTime} before: ${this._markers.count}`);
						this.removeMetaMarkerRange(data.chunkStartTime, data.chunkEndTime);
						//				console.log('MetaChunk removing/replacing after: ' + this._markers.count);
					}
	
					data.samples.forEach(function (sample) {
						var sampleTime = Number(sample.pts);
						if (isNaN(sampleTime)) {
							_logger.logger.log('addHlsMetaMarkers; no pts!'); //This should be fixed...
							sampleTime = data.chunkStartTime;
						}
	
						//				console.log(`addHlsMetaMarkers adding time: ${sampleTime}`);
	
						markerId = _this._markers.addMarker(sampleTime, // time
						{
							sample: sample, // data
							type: 'meta',
							id: data.id
						}, _this._markerTriggeredCallback);
					});
				}
	
				return markerId;
			}
		}, {
			key: 'removeMarker',
			value: function removeMarker(markerId) {
				//		console.log(`removeMarker markerId: ${markerId}`);
				this._markers.removeMarker(markerId);
			}
		}, {
			key: 'removeMarkerRange',
			value: function removeMarkerRange(start, end, filter) {
				//		console.log(`removeMarkerRange start: ${start}`);
				this._markers.removeMarkerRange({ time: start }, { time: end }, filter);
			}
		}, {
			key: 'removeMetaMarkerRange',
			value: function removeMetaMarkerRange(start, end) {
	
				//		let trimmed = this._markers.count;
	
				//		console.log(`removeMetaMarkerRange start: ${start} BEFORE count: ${this._markers.count}`);
				this._markers.removeMarkerRange({ time: start }, { time: end }, function (v) {
					return v.data.type === 'meta';
				});
				//		console.log(`removeMetaMarkerRange AFTER count: ${this._markers.count}`);
	
				//		trimmed -= this._markers.count;
				//		if (trimmed !== 0) {
				//			console.log(`removeMetaMarkerRange trimmed: ${trimmed}`);
				//		}
				//		if (this._markers.count !== 0) {
				//			console.log(`removeMetaMarkerRange  ${this._markers._markers._values[0].time}`);
				//		}
			}
		}, {
			key: 'clearAllMarkers',
			value: function clearAllMarkers() {
				//		console.log(`clearAllMarkers count: ${this._markers.count}`);
				this._markers.clearAllMarkers();
			}
		}, {
			key: 'seekMarkers',
			value: function seekMarkers(time) {
				//		console.log(`seekMarkers: time ${time} count ${this._markers.count}` );
				this._markers.seekMarkers(time);
				this._lastTime = time;
			}
		}, {
			key: 'timeUpdate',
			value: function timeUpdate(timeNow) {
				this._markers.timeUpdate(timeNow);
			}
		}, {
			key: 'timeUpdateMeta',
			value: function timeUpdateMeta(timeNow) {
				//		console.log(`timeUpdateMeta: time ${timeNow} count ${this._markers.count}` );
	
				//		This is how you do a one-shot metadata... but we do not want it right now
				//		this._markers.timeUpdateWithExtract(timeNow, (v) => v.data.type === 'meta');
	
				this._markers.timeUpdate(timeNow);
				this._markers.seekMarkers(timeNow);
				this._lastTime = timeNow;
			}
	
			//Used to prevent Metadata building up. Intended to be called when the buffered range changes.
	
		}, {
			key: 'trimMeta',
			value: function trimMeta(upTo) {
				//		console.log(`trimMeta upTo: ${upTo}`);
				if (upTo > 1) {
					//remove is inclusive. It's safer to remove a bit less
					this.removeMetaMarkerRange(0, upTo - 0.5);
				}
			}
		}, {
			key: 'emitter',
			get: function get() {
				return this._emitter;
			}
		}, {
			key: 'count',
			get: function get() {
				return this._markers.count;
			}
		}]);
	
		return HlsMarkers;
	}();
	
	exports.default = HlsMarkers;
	module.exports = exports['default'];

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * HlsStream - The Public API to Bam-Hls
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _HlsEvents = __webpack_require__(14);
	
	var _HlsEvents2 = _interopRequireDefault(_HlsEvents);
	
	var _HlsStates = __webpack_require__(66);
	
	var _HlsStates2 = _interopRequireDefault(_HlsStates);
	
	var _HlsErrors = __webpack_require__(65);
	
	var _HlsErrors2 = _interopRequireDefault(_HlsErrors);
	
	var _HlsErrorStrings = __webpack_require__(64);
	
	var _HlsErrorStrings2 = _interopRequireDefault(_HlsErrorStrings);
	
	var _PlaybackStates = __webpack_require__(68);
	
	var _PlaybackStates2 = _interopRequireDefault(_PlaybackStates);
	
	var _MediaStates = __webpack_require__(67);
	
	var _MediaStates2 = _interopRequireDefault(_MediaStates);
	
	var _HlsController = __webpack_require__(101);
	
	var _HlsController2 = _interopRequireDefault(_HlsController);
	
	var _HlsUtils = __webpack_require__(6);
	
	var _HlsUtils2 = _interopRequireDefault(_HlsUtils);
	
	var _HlsDataTypes = __webpack_require__(102);
	
	var _HlsDataTypes2 = _interopRequireDefault(_HlsDataTypes);
	
	var _KeySystems = __webpack_require__(35);
	
	var _KeySystems2 = _interopRequireDefault(_KeySystems);
	
	var _CencModes = __webpack_require__(63);
	
	var _CencModes2 = _interopRequireDefault(_CencModes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Supports control, playback and monitoring of a single HLS stream to a single video element
	 *
	 * It provides access to all properties, events and methods which are used to monitor,
	 * control and affect playback of a single HLS stream.
	 *
	 * The intent is that all control of the video element and HLS stream will be handled via the
	 * HlsStream interface.
	 *
	 * @example
	 * if( HlsStream.isSupported() ) {
	 *     hls = new HlsStream();
	 *     hls.loadSource('http://www.streambox.fr/playlists/x36xhzz/x36xhzz.m3u8');
	 *     hls.attachMedia(document.getElementById('video'));
	 *     hls.play();
	 * }
	 *
	 * @public
	 */
	var HlsStream = function () {
		_createClass(HlsStream, null, [{
			key: 'isSupported',
	
	
			/**
	  * Is it possible to load and play Hls using the current browser environment with this
	  * HlsStream implementation?
	  *
	  * In order for HLS playback and loading to be possible a number of pre-requisites
	  * must be met, including the availability of basic H.264/AAC codec support as well as the
	  * MSE capabality on the media element
	  *
	  * If playback is not supported, you will not be able to call loadSource() or attachMedia(),
	  * thus leaving not much point.
	  *
	  * @example
	  * if( HlsStream.isSupported() ) {
	  *     // instantiate HlsStream
	     * }
	  *
	  * @since 0.0.1
	  * @returns {boolean} is playback supports in this environment?
	  */
			value: function isSupported() {
				return _HlsController2.default.isSupported();
			}
	
			/**
	  * Events enumeration, used with on/off/once methods
	  *
	  * All the events which are emitted during operation. Some events
	  * are intended for intenral use only.
	  *
	  * @example
	  * hls.on( HlsStream.Events.STREAM_PLAYBACK, () => {
	  *     //the stream is now in the playback state
	  * });
	  *
	  * @since 0.0.1
	  * @type {enumeration}
	  */
	
		}, {
			key: 'version',
	
			/**
	  * The current version of the player at build time, assuming versionify was run.
	  *
	  * This should be a semantic version, ie semver
	  *
	  * If versionify was not run the value will be \__VERSION__
	  *
	  * @since 0.0.1
	  * @type {string} -
	  */
			get: function get() {
				return '__VERSION__';
			}
	
			/**
	  * The current number of active HlsStresm instances
	  *
	  * @since 2.9
	  * @type {integer} -
	  */
	
		}, {
			key: 'activeStreamCount',
			get: function get() {
				return _HlsController2.default.totalActive();
			}
	
			/**
	  * If the current browser supports redirects
	  *
	  * @since 2.9
	  * @type {boolean} -
	  */
	
		}, {
			key: 'isRedirectSupported',
			get: function get() {
				return _HlsController2.default.isRedirectSupported();
			}
		}, {
			key: 'Events',
			get: function get() {
				return _HlsEvents2.default;
			}
	
			/**
	  * Errors enumeration, see STREAM_ERROR event
	  *
	  * @example
	  * if(theError.error === HlsStream.Errors.LOAD_FAILED) {
	  *     // loading failed
	  * }
	  *
	  * @type {enumeration} -
	  *
	  * @since 0.2
	  */
	
		}, {
			key: 'Errors',
			get: function get() {
				return _HlsErrors2.default;
			}
	
			/**
	   * Error message strings enumeration, see STREAM_ERROR event
	   *
	   * @type {enumeration}
	   *
	   * @since 1.4
	   */
	
		}, {
			key: 'ErrorStrings',
			get: function get() {
				return _HlsErrorStrings2.default;
			}
	
			/**
	  * States enumeration, used with the state property
	  *
	  * All the possible player states
	  *
	  * @example
	  * if(hls.state === HlsStream.States.LOADING) {
	  *     //the player is currently loading
	  * }
	  *
	  * @type {enumeration}
	  *
	  * @since 0.2
	  */
	
		}, {
			key: 'States',
			get: function get() {
				return _HlsStates2.default;
			}
	
			/**
	  * Playback States enumeration, used with the playbackState property
	  *
	  * All the possible playback states
	  *
	  * @example
	  * if(hls.playbackState === HlsStream.PlaybackStates.PLAYING) {
	  *     //the video is currently playing
	  * }
	  *
	  * @since 0.2
	  */
	
		}, {
			key: 'PlaybackStates',
			get: function get() {
				return _PlaybackStates2.default;
			}
	
			/**
	  * Media States enumeration, used with the mediaState property
	  *
	  * All the possible media states
	  *
	  * @example
	  * if(hls.mediaState === HlsStream.MediaStates.DETACHED) {
	  *     //the media is currently detached
	  * }
	  *
	  * @type {enumeration}
	  *
	  * @since 0.3
	  */
	
		}, {
			key: 'MediaStates',
			get: function get() {
				return _MediaStates2.default;
			}
	
			/**
	   * Data types enumeration, used with the xhrSetupCallback property
	   *
	   * All the possible data types of objects that can be loaded
	   *
	   * @example
	   * hls.xhrSetupCallback = function (xhr, url, type) {
	   * 	if (url){
	   * 		if (type === HlsStream.DataTypes.KEY) {
	   * 			// the requested URL is a key call
	   * 		}
	   * 	}
	   * 	return xhr;
	   * }
	   *
	   * @type {enumeration}
	   * @since 0.10
	   */
	
		}, {
			key: 'DataTypes',
			get: function get() {
				return _HlsDataTypes2.default;
			}
	
			/**
	   * Key systems enumeration
	   *
	   * All of the possible key systems
	   *
	   * @type {enumeration}
	   * @since 3.2
	   */
	
		}, {
			key: 'KeySystems',
			get: function get() {
				return _KeySystems2.default;
			}
	
			/**
	   * @type {enumeration}
	   * @since 3.2
	   */
	
		}, {
			key: 'CencModes',
			get: function get() {
				return _CencModes2.default;
			}
	
			/**
	   * Constructs an instance of an HlsStream
	   *
	   * @param {object} [config={}] - configuration object. Properties matching setters will be applied.
	   *
	   * @example
	   * hls = new HlsStream({
	   *     autoPlay: true,
	   *     debug: true,
	   * });
	   *
	   * @since 0.0.1
	   */
	
		}]);
	
		function HlsStream() {
			var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
			_classCallCheck(this, HlsStream);
	
			this._controller = new _HlsController2.default({
				disableWorkarounds: !!config.disableWorkarounds,
				disablePromiseOverloadCheck: !!config.disablePromiseOverloadCheck,
				decryptOutsideWebworker: !!config.decryptOutsideWebworker
			});
			this._disposed = false;
	
			// config properties will ONLY be applied to setters.
			this.applyConfig(config);
		}
	
		/**
	  * release all resources used by HlsStream instance.
	  *
	  * The event list will be released, the media will be detached.
	  *
	  * It is an error to use the HlsStream instance once STREAM_DISPOSED has
	  * been emitted
	  *
	  * @since 0.0.4
	  */
	
	
		_createClass(HlsStream, [{
			key: 'dispose',
			value: function dispose() {
				var _this = this;
	
				// this issue is that events may fire after calling dispose(), and those
				// events may have handlers which themselves call HlsStream methods.
				// the final event is always STREAM_DISPOSED, and that is when we close
				// the gate.
				if (!this._disposed) {
					this._disposed = true;
	
					this.once(_HlsEvents2.default.STREAM_DISPOSED, function () {
						_this._controller = null;
					});
	
					this._controller.dispose();
				}
			}
	
			/**
	  * registers a listener for an event.
	  *
	  * When the event is triggered, the callback function will be called
	  *
	  * Use `off` to unregister. Use `once` for a once-off registration
	  *
	  * @example
	  * hls.on( HlsStream.Events.STREAM_LOADED, function () {
	  *     //STREAM_LOADED was emitted
	  * });
	  *
	  * @param {HlsStream.Events.EVENT} event - the event to register
	  * @param {function} func - the function to call when event is emitted
	  *
	  * @since 0.0.4
	  */
	
		}, {
			key: 'on',
			value: function on(event, func) {
				this._controller.on(event, func);
			}
	
			/**
	  * deregisters a listener for an event. func must === the func used to register
	  * the event in the first place
	  *
	  * If there is no matching event handler, then nothing happens.
	  *
	  * @example
	  * hls.off( HlsStream.Events.STREAM_LOADED, myStreamLoadedHandler );
	  *
	  * @param {HlsStream.Events.EVENT} event - the event to deregister
	  * @param {function} func - the function that was registered previously
	  *
	  * @since 0.0.6
	  */
	
		}, {
			key: 'off',
			value: function off(event, func) {
				this._controller.off(event, func);
			}
	
			/**
	  * registers a one-shot listener for an event. The listener is automatically Removed
	  * once the event fires.
	  *
	  * @example
	  * hls.once( HlsStream.Events.STREAM_SEEKING_FINISHED, () => {
	  *     //the stream seeked!
	  * });
	  *
	  * @param {HlsStream.Events.EVENT} event - the event to register
	  * @param {function} func - the function to invoke on the event
	  *
	  * @since 0.0.6
	  */
	
		}, {
			key: 'once',
			value: function once(event, func) {
				this._controller.once(event, func);
			}
	
			/**
	  * begin prefetching if the stream is in the LOADED state, or if the stream is not LOADED yet,
	  * then queue the prefetch.
	  *
	  * This essentially means that the player will move into the FETCHING state after
	  * entering the LOADED state, or if it is already in the LOADED state will immeidately
	  * move into the FETCHING state. If a media is ATTACHED, then it will proceed to the
	  * PLAYBACK state after STREAM_CAN_PLAY is emitted.
	  *
	  * The FETCHING state is where the player begins downloading media content.
	  *
	  * This only has an effect if autoPrefetch is false, otherwise the player will automatically
	  * prefetch.
	  *
	  * This capability might be useful if you wanted to pre-emptively load an HLS stream,
	  * but did not want to buffer it, or begin downloading.
	  *
	  * @example
	  * if( hasCurrentHlsStreamFinished()) {
	  *     nextHlsStream.prefetch();
	  * }
	  *
	  * @since 0.0.1
	  */
	
		}, {
			key: 'prefetch',
			value: function prefetch() {
				this._controller.prefetch();
			}
	
			/**
	   * halt fetching fragments if the stream is has loaded and is currently fetching.
	   *
	   * This does not halt the loading of variants, and as such live streams will continue to update the chosen
	   * variant, updating the fragment list and moving the sliding window as needed.
	   *
	   * This may be useful if you want to limit the amount of data the user downloads if they have the stream
	   * paused for a long time.
	   *
	   * @since 1.12
	   */
	
		}, {
			key: 'stopFetching',
			value: function stopFetching() {
				this._controller.stopFetching();
			}
	
			/**
	   * resumes fetching fragments if the stream has loaded and has previously stopped fetching.
	   *
	   * This does not trigger the loading of variants. If you're starting the stream, prefetch() should be used instead.
	   *
	   * @since 1.12
	   */
	
		}, {
			key: 'resumeFetching',
			value: function resumeFetching() {
				this._controller.resumeFetching();
			}
	
			/**
	  * pauses the player. If the player is not in the PLAYBACK state, the player will
	  * enter the PAUSED playbackState when it enters the PLAYBACK state.
	  *
	  * `paused` will return true.
	  *
	  * The player is always either paused or not paused. If it is capable of PLAYBACK,
	  * ie, the mediaState is ATTACHED and the source is sufficiently downloaded, then
	  * the player will enter the PLAYBACK state, and the PAUSED playbackState.
	  *
	  * If the player is the PLAYING or BUFFERING playbackStates and you call `pause()` the player
	  * will immediately pause and return to the PAUSED state. The player will continue fetching,
	  * ie, if the player was BUFFERING, BUFFERING will continue in the background, Although
	  * the playbackState will no longer be BUFFERING and the STREAM_BUFFERING_FINISHED event
	  * will fire.
	  *
	  * Should have no effect in the ENDED playbackState
	  *
	  * @example
	  * if( userPressedPauseButton()) {
	  *     hls.pause();
	  * }
	  *
	  * @since 0.0.1
	  */
	
		}, {
			key: 'pause',
			value: function pause() {
				this._controller.pause();
			}
	
			/**
	  * unpauses the player. If the player is not in the PLAYBACK state, the player will enter the
	  * PLAYING playbackState when sufficient content is buffered and the media is ATTACHED
	  *
	  * `paused` will return false.
	  *
	  * The player is always either paused or not paused. If it is capable of PLAYBACK,
	  * ie, the mediaState is ATTACHED and the source is sufficiently downloaded, then
	  * the player will enter the PLAYBACK state. If enough content is buffered to play, then
	  * the player will enter the PLAYING playbackState. If enough content is not available to play,
	  * then the player will enter the BUFFERING playbackState, and transition to the PLAYING playbackState
	  * when BUFFERING has finished and it can begin PLAYING, ie STREAM_BUFFERING_FINISHED event has fired.
	  *
	  * If the player is not paused, and a seek occurs, the player will continue PLAYING after the seek
	  * has completed.
	  *
	  * Should have no effect in the ENDED playbackState
	  *
	  * @example
	  * if( userPressedPlayButton()) {
	  *     hls.play();
	  * }
	  *
	  * @since 0.0.1
	  */
	
		}, {
			key: 'play',
			value: function play() {
				this._controller.play();
			}
	
			/**
	  * toggles the paused/playing state of the player.
	  *
	  * If the player is paused, it will play(), if its not paused, it will pause()
	  *
	  * @example
	  * if( userPressedPlayPauseButton()) {
	  *     hls.playPause();
	  * }
	  *
	  * @since 0.0.4
	  */
	
		}, {
			key: 'playPause',
			value: function playPause() {
				this._controller.playPause();
			}
	
			/**
	  * seeks the player to the time specified in seconds.
	  *
	  * The player needs to be in the PLAYBACK state for this to have an
	  * effect.
	  *
	  * It is equivalent to setting the currentTime property to seconds.
	  *
	  * If the player is paused, the player will return to the PAUSED
	  * playbackState after the seek is completed (ie when STREAM_SEEKING_FINISHED is
	  * emitted). If the player is !paused, it will return to either PLAYING or BUFFERING
	  * and then PLAYING playbackState after the seek has completed
	  *
	  * In the ENDED playbackState seek() can be used to restart video playback.
	  *
	  * @example
	  * hls.seek(5*60); // seek 5 minutes into the video
	  *
	  * @since 0.0.5
	  * @param {number} seconds - how many seconds to seek into the video from the start
	  */
	
		}, {
			key: 'seek',
			value: function seek(seconds) {
				this._controller.seek(seconds);
			}
	
			/**
	  * seeks the player to the specified time
	  *
	  * The manifest needs to have a PDT and the player needs to have loaded at least one variant
	  * for this to have an effect.
	  *
	  * This is a helper function; seeking is handled the same way as the normal seek
	  * once the offset is calculated.
	  *
	  * In the ENDED playbackState seek() can be used to restart video playback.
	  *
	  * @example
	  * hls.seekByPdt('Thu May 19 2016 07:22:55 GMT+1000');
	  *
	  * @since 0.7
	  * @param {Date} time - desired date/time to seek to
	  */
	
		}, {
			key: 'seekByPdt',
			value: function seekByPdt(time) {
				this._controller.seekByPdt(time);
			}
	
			/**
	  * seeks the player to the live point.
	  *
	  * It's better to use liveStreamsStartAtLiveTime for an intial seek to live, to
	  * avoid an initial seek.
	  *
	  * Does not function if isLive is false.
	  *
	  * @since 0.4
	  */
	
		}, {
			key: 'seekToLive',
			value: function seekToLive() {
				this._controller.seekToLive();
			}
	
			/**
	  * attaches a video element to the player and sets up the MSE media chain.
	  *
	  * The player takes control of the video element provided and establishes a
	  * transmuxing, remuxing pipeline which culminates in a Media Stream source
	  * feeding into the video element.
	  *
	  * This takes a relatively long time, thus the media is only attached, once
	  * the MEDIA_ATTACHED event has fired.
	  *
	  * @emit {MEDIA_ATTACHED} when the media is attached
	  *
	  * Currently, if you detach a media element, the HlsStream is no longer
	  * usable.
	  *
	  * Calling with null is the same as calling detachMedia()
	  *
	  * @example
	  * hls.attachMedia(document.getElementById('video'));
	  *
	  * @since 0.0.1
	  * @param {video} video - the video element to attach to the HLS player.
	  */
	
		}, {
			key: 'attachMedia',
			value: function attachMedia(video) {
				this._controller.attachMedia(video);
			}
	
			/**
	  * detaches the current video element from the player and destroys the MSE chain.
	  *
	  * @emits {MEDIA_DETACHED} when the media is detached
	  *
	  * Currently, if you detach a media element, the HlsStream is no longer
	  * usable. You should either destroy the hlsStream instance or detach the media
	  * before attaching the same video element to another HlsStream isntance.
	  *
	  * @example
	  * hls.detachMedia();
	  *
	  * @since 0.0.1
	  */
	
		}, {
			key: 'detachMedia',
			value: function detachMedia() {
				this._controller.detachMedia();
			}
	
			/**
	  * returns true if the media is attached.
	  *
	  * @emits {MEDIA_ATTACHED} when the media is detached
	  * @emits {MEDIA_DETACHED} when the media is detached
	  *
	  * @since 0.2
	  * @type {boolean}
	  */
	
		}, {
			key: 'loadSource',
	
	
			/**
	  * begins loading the specified HLS stream.
	  *
	  * The player will begin loading the HLS url supplied. It will transition to the
	  * LOADING state. If the url is valid, and downloads and parses successfully, it
	  * will transition to the LOADED state.
	  *
	  * If autoPrefetch, or autoPlay are enabled, or play() has been called, or prefetch()
	  * it will then transition into the FETCHING state.
	  *
	  * Once the media has been attached with attachMedia, it will transition into the
	  * PLAYBACK state.
	  *
	  * @emits {STREAM_LOADING} when the stream begins loading
	  * @emits {STREAM_LOADED} once the stream is succesfully LOADED
	  * @emits {STREAM_FETCHING} once the stream begins FETCHING
	  * @emits {STREAM_PLAYBACK} once the stream enters the PLAYBACK state after a media has
	  * been attached
	  * @emits {STREAM_ERROR} if an error occurs during LOADING.
	  * @example
	  * hls.loadSource('http://www.streambox.fr/playlists/x36xhzz/x36xhzz.m3u8');
	  *
	  * @since 0.0.1
	  * @param {string} url - the hls url to load, ie an .m3u8
	  */
			value: function loadSource(url) {
				this._controller.loadSource(url);
			}
	
			/**
	   * Flushes the stream buffer.
	   *
	   * The flush behaves differently based on the value of levelFlush, if false it will flush all fragments ahead of
	   * the current time, if true it will flush all fragments of lower bitrate variants than current. Regardless of
	   * setting the currently playing fragment and the next will not be flushed, to prevent buffer stalls.
	   *
	   * Returns true if the buffer was successfully flushed. Returns false if failed. A failed buffer flush typically
	   * means that no variants have had their fragment data loaded yet.
	   *
	   * Note that backfill is not currently implemented so seeking backwards after a level based flush may cause stalls.
	   *
	   * @since 1.0
	   * @param {boolean} levelFlush - if true, only flushes fragments that were loaded from a variant lower than
	   * chosenVariant
	   */
	
		}, {
			key: 'flushBuffer',
			value: function flushBuffer(levelFlush) {
				return this._controller.flushBuffer(levelFlush);
			}
	
			/**
	  * returns the player's state
	  *
	  * - UNLOADED
	  * - LOADING
	  * - LOADED
	  * - FETCHING
	  * - PLAYBACK
	  *
	  * @emits {STREAM_STATE_CHANGED} when the state changes.
	  *
	  * @since 0.2
	  * @type {HlsStream.States.STATE}
	  */
	
		}, {
			key: 'getConstraints',
	
	
			/**
	   * current constraints used for variant selection
	   *
	   * This object contains minimum and maximum values for variant number, bitrate (in bps), width and height (both in
	   * pixels). A value of -1 indicates that that constraint is not being used.
	   *
	   * The variant selector will try to follow as many of these constraints as possible, but will ignore constraints
	   * if it determines that following them is impossible, such as if a minimum constraint exceeds a maximum, there is
	   * no variant between the minimum or maximum, or if no level satisfies a constraint. Minimum constraints will be
	   * ignored before maximum constraints.
	   *
	   * If it has been determined that the overall maximum variant constraint has been relaxed, the buffer will flush
	   * fragments that have a lower bitrate than the one currently being loaded. Note that backfill is not currently
	   * implemented so seeking backwards after the flush may cause stalls. This flush can be cancelled by setting noFlush
	   * to true.
	   *
	   * width and height constraints will currently only be considered if the stream has explicitly defined dimensions.
	   *
	   * @since 1.9
	   * @type {object} { minVariant:integer, maxVariant:integer, minBitrate:integer, maxBitrate:integer,
	   * minWidth:integer, minHeight:integer, maxWidth:integer, maxHeight:integer, noFlush:boolean }
	   */
			value: function getConstraints() {
				return this._controller.getConstraints();
			}
		}, {
			key: 'setConstraints',
			value: function setConstraints() {
				var constraints = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
				this._controller.setConstraints(constraints);
			}
	
			/**
	   * current timeouts
	   *
	   * @since 1.15
	   * @type {object} { manifestTimeout:integer, manifestTimeoutMax:integer, variantTimeout:integer,
	   * variantTimeoutMax:integer, chunkTimeout:integer, chunkTimeoutMax:integer, streamTimeout:integer }
	   */
	
		}, {
			key: 'getTimeouts',
			value: function getTimeouts() {
				return this._controller.getTimeouts();
			}
		}, {
			key: 'setTimeouts',
			value: function setTimeouts() {
				var timeouts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
				this._controller.setTimeouts(timeouts);
			}
	
			/**
	   * If true, this will attempt to simplify the stream when performance issues are detected. For example,
	   * it will lower the maximum bitrate variant to below the one that is currently playing if more than 20% of frames have been dropped.
	   *
	   * Defaults to false. Changes will apply upon switching video or media element. This property has no effect when running on a platform that does not track
	   * number of frames decoded/dropped (known supported platforms with this issue: all Tizen versions).
	   *
	   * @since 2.10
	   * @type {boolean}
	   */
	
		}, {
			key: 'getPlaybackMetrics',
	
	
			/**
	   * returns an object containing various playback metrics
	   *
	   * HlsPlaybackMetrics{
	   *     time,				// currentTime
	   *     droppedFramesCount,	// media.getVideoPlaybackQuality().droppedVideoFrames or media.webkitDroppedFrameCount
	   *     bitrate,				// chosenBitrate
	   *     bufferedRange,		// bufferedRangeCurrent {start,end,duration}
	   *     playbackRange,		// {start,end,duration}
	   *     seekableRange, 		// manifest window {start,end,duration}
	   * }
	   *
	   * @since 1.3
	   * @returns {HlsPlaybackMetrics}
	   */
			value: function getPlaybackMetrics() {
				return this._controller.getPlaybackMetrics();
			}
	
			/**
	   * returns an object containing various network metrics
	   *
	   * HlsNetworkMetrics{
	   *     chosenVariant,		// index of currently loading stream variant
	   *     chosenBitrate,		// bitrate of currently loading stream variant
	   *     perceivedBitrate,	// estimate of the current available network bandwith
	   * }
	   *
	   * @since 3.2
	   * @returns {HlsNetworkkMetrics}
	   */
	
		}, {
			key: 'getNetworkMetrics',
			value: function getNetworkMetrics() {
				return this._controller.getNetworkMetrics();
			}
	
			/**
	   * returns a promise to a copy of the DrmCapabilities
	   * DrmCapabilities is a list of the supported status and capabilities for all KeySystems specified in the KeySystems enum
	   */
	
		}, {
			key: 'getDrmCapabilities',
			value: function getDrmCapabilities() {
				return this._controller.getDrmCapabilities();
			}
	
			/**
	   * Sets a callback to be called at the specified timeline time with an ID being the return value.
	   * The callback will in the format of (time, data, id) to enable you to match IDs
	   * or remove as needed.
	   *
	   * @since 2.8
	   * @returns {integer}
	   */
	
		}, {
			key: 'addMarker',
			value: function addMarker(time, callback, data) {
				return this._controller.addUserMarker(time, callback, data);
			}
	
			/**
	   * Removes specified ID from marker list. IDs can be obtained from the addMarker
	   * method as well as addMarker callbacks.
	   *
	   * @since 2.8
	   */
	
		}, {
			key: 'removeMarker',
			value: function removeMarker(id) {
				this._controller.removeMarker(id);
			}
	
			/**
	   * applies the supplied config object to the HlsStream instance.
	   *
	   * All properties in the config which match an available setters on the instance
	   * will be applied.
	   *
	   * @example
	   * hls.applyConfig({
	   *     autoPlay: true,
	   *     debug: true,
	  	 * });
	  	 *
	   * @since 0.1
	   * @param {Object} [config={}] - configuration obect
	   */
	
		}, {
			key: 'applyConfig',
			value: function applyConfig() {
				var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
				_HlsUtils2.default.applyConfig(this, config);
			}
	
			/**
	   * Converts a given date into a timestamp for the currently loaded stream.
	   *
	   * This function is able to return timestamps that are outside of the seekable range.
	   *
	   * Returns null if the stream does not have a base PDT
	   *
	   * @since 2.12
	   * @param {Date} pdt
	   * @returns {number}
	   */
	
		}, {
			key: 'getTimeForPdt',
			value: function getTimeForPdt(pdt) {
				return this._controller.getTimeForPdt(pdt);
			}
	
			/**
	   * Converts a given timestamp into a PDT for the currently loaded stream.
	   *
	   * This function is able to use timestamps that are outside of the seekable range.
	   *
	   * Returns null if the stream does not have a base PDT
	   *
	   * @since 2.12
	   * @param {number} time
	   * @returns {Date}
	   */
	
		}, {
			key: 'getPdtForTime',
			value: function getPdtForTime(time) {
				return this._controller.getPdtForTime(time);
			}
	
			/**************************
	  	SOFT DEPRECATIONS
	   **************************/
	
			/**
	   * synonym for getNetworkMetrics().chosenVariant, for compatibility with pre-3.2
	   *
	   * @deprecated use getNetworkMetrics()
	   * @since 0.9
	   * @type {integer}
	   */
	
		}, {
			key: 'isMediaAttached',
			get: function get() {
				return this._controller.isMediaAttached;
			}
		}, {
			key: 'state',
			get: function get() {
				return this._controller.state;
			}
	
			/**
	  * returns the player's playback state
	  *
	  * If the player is not in state PLAYBACK, then will returns
	  * NOTREADY
	  *
	  * - NOTREADY
	  * - PAUSED
	  * - BUFFERING
	  * - PLAYING
	  * - SEEKING
	  * - ENDED
	  *
	  * @emits {STREAM_PLAYBACKSTATE_CHANGED} when the playbackState changes.
	  *
	  * @since 0.2
	  * @type {HlsStream.PlaybackStates.PLAYBACKSTATE}
	  */
	
		}, {
			key: 'playbackState',
			get: function get() {
				return this._controller.playbackState;
			}
	
			/**
	  * returns the player's media state
	  *
	  * - DETACHED
	  * - ATTACHING
	  * - ATTACHED
	  *
	  * @emits {STREAM_MEDIASTATE_CHANGED} when the mediaState changes.
	  *
	  * @since 0.3
	  * @type {HlsStream.MediaStates.MEDIASTATE}
	  */
	
		}, {
			key: 'mediaState',
			get: function get() {
				return this._controller.mediaState;
			}
	
			/**
	  * the media position, in seconds, that the player will start playback at after loading
	  *
	  * If you want to start the stream at anywhere other than the beginning, It is more efficient
	  * to provide a startTime, than it is to wait for the media to load at the beginning and then
	  * seek() to a different position
	  *
	  * The startTime needs to be set before the stream enters the FETCHING state. It has no
	  * effect once the FETCHING state has been entered.
	  *
	  * @since 0.0.1
	  * @type {number}
	  */
	
		}, {
			key: 'startTime',
			get: function get() {
				return this._controller.startTime;
			},
			set: function set(seconds) {
				this._controller.startTime = seconds;
			}
	
			/**
	   * the media position that the player will start playback at after loading
	   *
	   * The manifest must have a PDT for this to have an effect. The start time will be set as soon as the PDT is known.
	   *
	   * startTimeByPdt will override startTime.
	   *
	   * @since 1.10
	   * @type {Date}
	   */
	
		}, {
			key: 'startTimeByPdt',
			get: function get() {
				return this._controller.startTimeByPdt;
			},
			set: function set(time) {
				this._controller.startTimeByPdt = time;
			}
	
			/**
	  * the variant to select for intitial playback, an index into the variants
	  * array, -1 for the default variant
	  *
	  * A variant is a version of the stream encoded at a given bitrate. There are
	  * multiple variants in the stream in order to allow bitrate adaption.
	  *
	  * The default variant is the first variant in the manifest, as specified by the
	  * server.
	  *
	  * You can effect which variant is selected for stream startup by specifying the
	  * startVariant
	  *
	  * The bitrate controller may choose a variant that does not match the variant
	  * you requested in order to meet the various other constraints/requests that
	  * may be placed on it.
	  *
	  * Use 0 if you want the minimum variant, as the variant list is sorted by
	  * bitrate.
	  *
	  * If startVariant is higher than the highest number variant, the highest numbered
	  * variant will be selected.
	  *
	  * startVariant is overriden by startBitrate. It overrides minimumBitrate and maximumBitrate,
	  * but only for the first fragment.
	  *
	  * @since 0.9
	  * @type {integer}
	  */
	
		}, {
			key: 'startVariant',
			get: function get() {
				return this._controller.startVariant;
			},
			set: function set(value) {
				this._controller.startVariant = value;
			}
	
			/**
	  * the bitrate to select for intitial playback, in bits per second, -1 to use
	  * the default bitrate
	  *
	  * The default bitrate is the first bitrate in the manifest, as specified by the
	  * server.
	  *
	  * You can effect which bitrate is selected by specifying the startBitrate, and
	  * the bitrate controller will select the bitrate which is closest to the bitrate you
	  * specify.
	  *
	  * Use 0 if you want the minimum bitrate.
	  *
	  * startBitrate overrides startVariant. It also overrides minimumBitrate and maximumBitrate,
	  * but only for the first fragment.
	  *
	  * @since 0.9
	  * @type {integer}
	  */
	
		}, {
			key: 'startBitrate',
			get: function get() {
				return this._controller.startBitrate;
			},
			set: function set(value) {
				this._controller.startBitrate = value;
			}
	
			/**
	  * if true, the player will automatically move into the FETCHING state once the stream is
	  * LOADED (ie STREAM_LOADED has fired).
	  *
	  * Defaults to true.
	  *
	  * Has no effect after STREAM_LOADED has fired.
	  *
	  * @since 0.0.4
	  * @type {boolean}
	  */
	
		}, {
			key: 'autoPrefetch',
			get: function get() {
				return this._controller.autoPrefetch;
			},
			set: function set(value) {
				this._controller.autoPrefetch = value;
			}
	
			/**
	  * if true, the player will automatically move into the FETCHING state once the stream is
	  * LOADED (ie STREAM_LOADED has fired), and then into the PLAYBACK state once the media
	  * is attached.
	  *
	  * Defaults to false.
	  *
	  * Has no effect after STREAM_PLAYBACK has fired.
	  *
	  * @since 0.0.4
	  * @type {boolean}
	  */
	
		}, {
			key: 'autoPlay',
			get: function get() {
				return this._controller.autoPlay;
			},
			set: function set(value) {
				this._controller.autoPlay = value;
			}
	
			/**
	   * If true, the player will automatically reload the stream if the media element throws an error.
	   *
	   * Defaults to true.
	   *
	   * @since 1.13
	   * @type {boolean}
	   */
	
		}, {
			key: 'autoRecover',
			get: function get() {
				return this._controller.autoRecover;
			},
			set: function set(value) {
				this._controller.autoRecover = value;
			}
	
			/**
	   * If true, the player will attempt to force the stream to continue playing if playback stalls.
	   *
	   * In older versions of bam-hls, it was possible for playback to become stuck, and require the player to nudge the
	   * playhead forward a small amount of time to unstick playback. This is no longer needed, due to our MuxJS demuxer.
	   *
	   * Defaults to false.
	   *
	   * @since 2.3
	   * @type {boolean}
	   */
	
		}, {
			key: 'nudgeOnStall',
			get: function get() {
				return this._controller.nudgeOnStall;
			},
			set: function set(value) {
				this._controller.nudgeOnStall = value;
			}
	
			/**
	   * if true, and the stream is live, the stream will start at the liveTime
	   *
	   * @since 0.8
	   * @type {boolean}
	   */
	
		}, {
			key: 'liveStreamsStartAtLiveTime',
			get: function get() {
				return this._controller.liveStreamsStartAtLiveTime;
			},
			set: function set(value) {
				this._controller.liveStreamsStartAtLiveTime = value;
			}
	
			/**
	  * the currently loaded hls url.
	  *
	  * setting is equivalent to calling loadSource(url)
	  *
	  * @since 0.3
	  * @type {?url}
	  */
	
		}, {
			key: 'source',
			get: function get() {
				return this._controller.src;
			},
			set: function set(url) {
				this._controller.src = url;
			}
	
			/**
	  * the currently attached media.
	  *
	  * setting is equivalent to calling attachMedia(video)
	  *
	  * @since 0.1
	  * @type {?video}
	  */
	
		}, {
			key: 'media',
			get: function get() {
				return this._controller.media;
			},
			set: function set(video) {
				this._controller.media = video;
			}
	
			/**
	  * the current media position, in seconds, from the start
	  *
	  * setting is equivalent to calling seek(seconds)
	  *
	  * It can be useful to use for implemnting jump-forward capability
	  *
	  * @example
	  * hls.currentTime += 30; // skip 30 seconds forward
	  *
	  * @since 0.0.5
	  * @type {number}
	  */
	
		}, {
			key: 'currentTime',
			get: function get() {
				return this._controller.currentTime;
			},
			set: function set(seconds) {
				this._controller.currentTime = seconds;
			}
	
			/**
	  * the current media position, as a date
	  *
	  * setting is equivalent to calling seekByPdt(time)
	  *
	  * The manifest needs to have a PDT and the player needs to have loaded at least one variant
	  * for this to have an effect.
	  *
	  * Returns null if the stream does not have a base PDT
	  *
	  * @since 2.12
	  * @type {Date}
	  */
	
		}, {
			key: 'currentTimeAsPdt',
			get: function get() {
				return this._controller.currentTimeAsPdt;
			},
			set: function set(time) {
				this._controller.currentTimeAsPdt = time;
			}
	
			/**
	   * Playback rate of the stream.
	   *
	   * Default is 1.0. The higher the value, the faster the stream will play.
	   *
	   * Only values greater than 0.0 are supported. Reverse playback is not yet implemented. pause() should be used
	   * instead of trying to set the playback rate to 0.0.
	   *
	   * @since 0.10
	   * @type {number}
	   */
	
		}, {
			key: 'playbackRate',
			get: function get() {
				return this._controller.playbackRate;
			},
			set: function set(value) {
				this._controller.playbackRate = value;
			}
	
			/**
	  * is the stream loaded? Has STREAM_LOADED fired.
	  *
	  * A stream being loaded means that it has successfully download and parsed
	  * the manifest, and has not had a following error to cause it to become
	  * UNLOADED.
	  *
	  * @emits {STREAM_LOADED} when the stream loads successfully
	  * @emits {STREAM_UNLOADED} when the stream is unloaded, possibly due to error
	  *
	  * @since 0.2
	  * @type {boolean}
	  */
	
		}, {
			key: 'isLoaded',
			get: function get() {
				return this._controller.loaded;
			}
	
			/**
	  * is the stream fetching?
	  *
	  * The stream will be fetching once it has entered the FETCHING phase, until
	  * the source is unloaded or the HlsStream is destroyed. The stream continues
	  * to be fetching while the state is in the FETCHING or PLAYBACK states, even if
	  * the playbackState is ENDED.
	  *
	  * @emits {STREAM_FETCHING} when the stream begins fetching
	  *
	  * @since 0.2
	  * @type {boolean}
	  */
	
		}, {
			key: 'isFetching',
			get: function get() {
				return this._controller.fetching;
			}
	
			/**
	  * is the player paused?
	  *
	  * This is the players' target playback state. This does not mean it is currently
	  * displaying video, and if it is false, it does not mean that it is currently playing
	  * video.
	  *
	  * @emits {PLAYBACK_PAUSED} when the player actually pauses
	  * @emits {PLAYBACK_PLAYING} when the player actually begins playing
	  *
	  * @since 0.0.3
	  * @type {boolean}
	  */
	
		}, {
			key: 'isPaused',
			get: function get() {
				return this._controller.paused;
			}
	
			/**
	  * is the player buffering?
	  *
	  * Note, the player can still be buffering, but will return false if it is paused.
	  *
	  * @emits {PLAYBACK_BUFFERING} when buffering starts
	  * @emits {STREAM_BUFFERING_FINISHED} when the buffering finishes
	  *
	  * @since 0.2
	  * @type {boolean}
	  */
	
		}, {
			key: 'isBuffering',
			get: function get() {
				return this._controller.buffering;
			}
	
			/**
	  * is the player seeking?
	  *
	  * @emits {PLAYBACK_SEEKING} when seeking starts
	  * @emits {STREAM_SEEKING_FINISHED} when seeking finishes
	  *
	  * @since 0.2
	  * @type {boolean}
	  */
	
		}, {
			key: 'isSeeking',
			get: function get() {
				return this._controller.seeking;
			}
	
			/**
	  * has playback reached the end of the content?
	  *
	  * Will remain true after reaching the end until the source is reloaded/changed
	  * or a seek is performed.
	  *
	  * @emits {PLAYBACK_ENDED} when the end is reached
	  *
	  * @since 0.0.3
	  * @type {boolean}
	  */
	
		}, {
			key: 'isEnded',
			get: function get() {
				return this._controller.ended;
			}
	
			/**
	  * is the stream live?
	  *
	  * A live stream is a stream which is being actively appended with new content.
	  * As the stream is appended to the duration will change. Eventually the stream
	  * may become not-live.
	  *
	  * A live stream may or may not be sliding window. Use isSlidingWindow to tell
	  *
	  * All streams are assumed to be live when they are first loaded. This is
	  * because a non-live stream can never transition to being live. This means that
	  * when the stream is first loaded, isLive will return true, when it later
	  * becomes known to be either live or not live, STREAM_ISLIVE_CHANGED will fire.
	  * In the case of a stream loading in a live state this means that the live and
	  * lastLive properties of the update event will both be true. Internally
	  * lastLive was undefined until the time the event was fired.
	  *
	  * In effect, this means you do not need to poll isLive, but rather can rely on
	  * the event being fired when the isLive property becomes known, or is updated.
	  *
	  * @emits {STREAM_ISLIVE_CHANGED} when the isLive property becomes
	  * known or is updated. data: {live: , lastLive };
	  *
	  * @since 0.4
	  * @type {boolean}
	  */
	
		}, {
			key: 'isLive',
			get: function get() {
				return this._controller.live;
			}
	
			/**
	  * does the stream have a sliding window?
	  *
	  * A sliding window stream is a live stream where content is being removed as
	  * more content is added. Thus the window of available content slides. Generally
	  * this is the concept that most people think of when they think of live
	  * streaming video. If the stream isLive but is not isSlidingWindow then it is
	  * an event stream, ie a live stream that you can seek to any point in.
	  *
	  * NOTE: live streams may start out as non sliding window streams until content
	  * is removed from the stream, then they become sliding window streams.
	  *
	  * @emits {STREAM_ISSLIDINGWINDOW_CHANGED} when the isSlidingWindow property becomes
	  * known or is updated. data: {slidingWindow: , lastSlidingWindow };
	  *
	  * @since 0.4
	  * @type {boolean}
	  */
	
		}, {
			key: 'isSlidingWindow',
			get: function get() {
				return this._controller.slidingWindow;
			}
	
			/**
	   * Is the stream audio only?
	   *
	   * Note that this checks if all variants of the stream are audio only. If one variant is audio only but other
	   * variants contain video, this will return false.
	   *
	   * @since 1.2
	   * @type {boolean}
	   */
	
		}, {
			key: 'isAudioOnly',
			get: function get() {
				return this._controller.audioOnly;
			}
	
			/**
	   * Is BAMHLS operating in multiple threads?
	   *
	   * When possible, a separate worker thread will be created for demuxing/remuxing. At start, this will return wether
	   * or not it is possible to have a worker thread. Once demuxing has begun, this will return wether or not the
	   * worker thread exists.
	   *
	   * @emits {STREAM_ISMULTITHREADED_CHANGED} if isMultithreaded changes. data: {multithreaded, lastMultithreaded};
	   *
	   * @since 1.8
	   * @type {boolean}
	   */
	
		}, {
			key: 'isMultithreaded',
			get: function get() {
				return this._controller.multithreaded;
			}
	
			/**
	   * The seekable range of the stream
	   *
	   * A stream's seekable range is a range of times in which a fragment is currently loadable. In VOD and live event
	   * streams, the range is the entire stream, however in sliding window streams, the range is limited by the duration
	   * of the sliding window, and the user will not be able to seek outside this range.
	   *
	   * Returns an object containing the start, the end, and the total duration of the seekable range, all three
	   * measured in seconds.
	   *
	   * @since 1.1
	   * @type {object} { start: number, end: number, duration: number }
	   */
	
		}, {
			key: 'seekableRange',
			get: function get() {
				return this._controller.seekableRange;
			}
	
			/**
	   * All buffered ranges of the stream
	   *
	   * A stream's buffered range is a range of times in which fragments have been added to the buffer. If a specified
	   * time is within a buffered range and the playback range, seeking to that time should play as soon as the seek
	   * finishes.
	   *
	   * The buffered range is based on the audio buffer when possible, the video buffer may have slight differences.
	   *
	   * Returns an array of objects that contain the start, the end, and the total duration of each buffered range,
	   * all three measured in seconds.
	   *
	   * @since 1.9
	   * @type {object[]} { start: number, end: number, duration: number }
	   */
	
		}, {
			key: 'bufferedRange',
			get: function get() {
				return this._controller.bufferedRange;
			}
	
			/**
	   * The buffered range the current time is located in.
	   *
	   * A stream may have multiple buffered ranges. This property returns the buffered range that the player is
	   * currently in.
	   *
	   * The buffered range is based on the audio buffer when possible, the video buffer may have slight differences.
	   *
	   * Returns an object that contains the start, the end, and the total duration of the current buffered range, all
	   * three measured in seconds.
	   *
	   * @since 1.9
	   * @type {object} { start: number, end: number, duration: number }
	   */
	
		}, {
			key: 'bufferedRangeCurrent',
			get: function get() {
				return this._controller.bufferedRangeCurrent;
			}
	
			/**
	   * The playback range of the stream
	   *
	   * A stream's playback range is a range of times that the stream will play through without interruption. The start
	   * point of the range is the current time, and it extends to the end of the seekable or current buffered range,
	   * whichever comes first.
	   *
	   * Returns an object that contains the start, the end, and the total duration of the playback range, all three
	   * measured in seconds.
	   *
	   * @since 1.9
	   * @type {object} { start: number, end: number, duration: number }
	   */
	
		}, {
			key: 'playbackRange',
			get: function get() {
				return this._controller.playbackRange;
			}
	
			/**
	  * first PDT specified by the current manifest. Will be null if none is in manifest.
	  *
	  * @since 0.7
	  * @type {Date}
	  */
	
		}, {
			key: 'basePdt',
			get: function get() {
				return this._controller.basePdt;
			}
	
			/**
	  * the current duration of the content, in seconds
	  *
	  * Note: this may continue to increase sporadically for live content
	  *
	  * @emits {STREAM_DURATION_CHANGED} when the duration changes
	  *
	  * @since 0.0.6
	  * @type {number}
	  */
	
		}, {
			key: 'duration',
			get: function get() {
				return this._controller.duration;
			}
	
			/**
	  * the initial time that playback started at in seconds. This is related to startTime
	  *
	  * Note: this may not exactly equal startTime.
	  *
	  * @since 0.0.6
	  * @type {number}
	  */
	
		}, {
			key: 'initialTime',
			get: function get() {
				return this._controller.initialTime;
			}
	
			/**
	  * the current live time in seconds. ie the maximum seekable time in the stream that is regarded as the
	  * live point.
	  *
	  * Note: this will be less than the duration, as the liveTime takes account of the liveBuffer
	  *
	  * Note: this value defaults to zero, and will only be initialised once it is know. This will occur
	  * when the variants are loaded. It is sufficient to listen to the event for changes.
	  *
	  * It will only ever increase.
	  *
	  * @emits {STREAM_LIVETIME_CHANGED} when the live time changes. data: {liveTime, lastLiveTime };
	  *
	  * @since 0.4
	  * @type {number}
	  */
	
		}, {
			key: 'liveTime',
			get: function get() {
				return this._controller.liveTime;
			}
	
			/**
	  * the variants array, ie bitrate profiles or levels
	  *
	  * The variants array contains each variant in the manifest sorted by
	  * ascending bitrate with various interesting properties.
	  *
	  * A variant is a version of the stream which is encoded at a specific bitrate
	  *
	  * @emits {STREAM_VARIANTS_CHANGED} when changed/updated/available.
	  *
	  * @since 0.3
	  * @type {array} -
	  */
	
		}, {
			key: 'variants',
			get: function get() {
				return this._controller.variants;
			}
	
			/**
	   * the audio renditions array
	   *
	   * The audio rendition array contains each audio language in the mainfest. Tracks with the same name are grouped together into a single rendition.
	   *
	   * Renditions are assigned a numerical ID when added to the rendition list. This number is what is used with the currentAudioRendition property.
	   *
	   * @since 2.8
	   * @type {array}
	   */
	
		}, {
			key: 'audioRenditions',
			get: function get() {
				return this._controller.audioRenditions;
			}
	
			/**
	   * currently selected audio rendition
	   *
	   * If there are multiple tracks with the selected rendition, the track with the same audio rendition group as the currently selected variant
	   * will play.
	   *
	   * @since 2.8
	   * @type {integer}
	   */
	
		}, {
			key: 'currentAudioRendition',
			get: function get() {
				return this._controller.currentAudioRendition;
			},
			set: function set(index) {
				this._controller.currentAudioRendition = index;
			}
	
			/**
	   * default audio rendition language
	   *
	   * When renditions are valid for the first time this will be set if possible.
	   * Compares this with the lang value of the audioRenditions array
	   *
	   * @since 2.9
	   * @type {string}
	   */
	
		}, {
			key: 'initialAudioLanguage',
			get: function get() {
				return this._controller.initialAudioLanguage;
			},
			set: function set(language) {
				this._controller.initialAudioLanguage = language;
			}
	
			/**
	   * default audio rendition name
	   *
	   * When renditions are valid for the first time this will be set if possible.
	   * Compares this with the name value of the audioRenditions array
	   *
	   * @since 2.9
	   * @type {string}
	   */
	
		}, {
			key: 'initialAudioName',
			get: function get() {
				return this._controller.initialAudioName;
			},
			set: function set(name) {
				this._controller.initialAudioName = name;
			}
	
			/**
	   * default audio rendition name
	   *
	   * When renditions are valid for the first time this will be set if possible.
	   * Compares this with the name value of the audioRenditions array
	   *
	   * @since 2.9
	   * @type {string}
	   */
	
		}, {
			key: 'initialAudioIndex',
			get: function get() {
				return this._controller.initialAudioIndex;
			},
			set: function set(index) {
				this._controller.initialAudioIndex = index;
			}
	
			/**
	  * the subtitle renditions array, ie the available subtitle/caption languages
	  *
	  * The Subtitle Renditions is a list of all the available subtitle renditions
	  * found in the media
	  *
	  * @emits {STREAM_SUBTITLERENDITIONS_CHANGED} when changed/updated/available
	  *
	  * @since 0.3
	  * @type {array}
	  */
	
		}, {
			key: 'subtitleRenditions',
			get: function get() {
				return this._controller.subtitleRenditions;
			}
	
			/**
	   * current muted state of the media
	   *
	   * isMuted returns true if playback is currently muted, ie, isMuted has been set true
	   * or volume is set to 0.0. If isMuted is set, then volume will return 0.0 until
	   * isMuted is set to false, then volume will return its previous value.
	   *
	   * @since 0.0.3
	   * @type {boolean}
	   */
	
		}, {
			key: 'isMuted',
			get: function get() {
				return this._controller.muted;
			},
			set: function set(value) {
				this._controller.muted = value;
			}
	
			/**
	   * current volume of the media (0.0 - 1.0)
	   *
	   * The volume applied to the media. Valid ranges are 0.0 to 1.0 (ie 100%)
	   *
	   * Setting volume to 0.0 will cause muted to return true, until the volume is
	   * not 0.0.
	   *
	   * Setting muted to true will cause volume to evaluate as 0.0 until muted is
	   * is set false, and the volume is not 0.0
	   *
	   * @since 0.0.3
	   * @type {float}
	   */
	
		}, {
			key: 'volume',
			get: function get() {
				return this._controller.volume;
			},
			set: function set(value) {
				this._controller.volume = value;
			}
		}, {
			key: 'useAutomaticComplexityReduction',
			get: function get() {
				return this._controller.useAutomaticComplexityReduction;
			},
			set: function set(value) {
				this._controller.useAutomaticComplexityReduction = !!value;
			}
	
			/**
	   * If true, cycles the bitrate up and down between the minimum and maximum variant constraints.
	   *
	   * Variant changes done this way will not flush the buffer.
	   *
	   * @since 1.10
	   * @type {boolean}
	   */
	
		}, {
			key: 'bitrateCycle',
			get: function get() {
				return this._controller.bitrateCycle;
			},
			set: function set(value) {
				this._controller.bitrateCycle = value;
			}
	
			/**
	   * Size of the stream buffer, in bytes. Default is 60000000, or 60 megabytes.
	   *
	   * This is used with the current bitrate to determine the length of the buffer in seconds.
	   *
	   * @since 0.10
	   * @type {number}
	   */
	
		}, {
			key: 'maximumBufferSize',
			get: function get() {
				return this._controller.maximumBufferSize;
			},
			set: function set(value) {
				this._controller.maximumBufferSize = value;
			}
	
			/**
	   * Minimum stream buffer length, in seconds. Default is 30 seconds.
	   *
	   * maximumBufferSeconds will override this constraint, if necessary.
	   *
	   * 1 is the minimum allowed value, as lower buffer lengths may prevent the stream from buffering at all.
	   *
	   * @since 0.10
	   * @type {number}
	   */
	
		}, {
			key: 'minimumBufferSeconds',
			get: function get() {
				return this._controller.minimumBufferLength;
			},
			set: function set(value) {
				this._controller.minimumBufferLength = value;
			}
	
			/**
	   * Maximum stream buffer length, in seconds. Default is 60 seconds.
	   *
	   * This constraint will override minimumBufferSeconds, if necessary.
	   *
	   * 1 is the minimum allowed value, as lower buffer lengths may prevent the stream from buffering at all.
	   *
	   * @since 0.10
	   * @type {number}
	   */
	
		}, {
			key: 'maximumBufferSeconds',
			get: function get() {
				return this._controller.maximumBufferLength;
			},
			set: function set(value) {
				this._controller.maximumBufferLength = value;
			}
	
			/**
	  * are subtitles being rendered on the video element. If there are no subtitles to
	  * display, then there will be no subtitles to display.
	  *
	  * setting to true will cause subtitles to display if they are available
	  *
	  * @since 0.3
	  * @type {bool}
	  */
	
		}, {
			key: 'areSubtitlesEnabled',
			get: function get() {
				return this._controller.subtitlesEnabled;
			},
			set: function set(value) {
				this._controller.subtitlesEnabled = value;
			}
	
			/**
	  * Changes the output of the video element to the requested
	  * language if possible. If not possible the caption selection will be unchanged.
	  *
	  * @since 0.6
	  * @type {integer}
	  */
	
		}, {
			key: 'changeSubtitlesByIndex',
			set: function set(value) {
				this._controller.changeSubtitlesByIndex = value;
			}
	
			/**
	  * a callback which is called after creating an XHR request to allow modification of
	  * the request. Ie to enable cookie support, or add RequestHeaders.
	  *
	  * @example
	  * stream.xhrSetupCallback = function (xhr, url, type) {
	  *     xhr.withCredentials = true; // do send cookies
	  * }),
	  *
	  * null means no function is defined. Use null to clear.
	  *
	  * @since 0.7
	  * @type {function} function(xhr: XMLHttpRequest, url: string, type: DataTypes)} Xhr Setup Function
	  */
	
		}, {
			key: 'xhrSetupCallback',
			get: function get() {
				return this._controller.xhrSetup;
			},
			set: function set(func) {
				this._controller.xhrSetup = func;
			}
	
			/**
	  * a callback which, if not null, will be called to acquire a key
	  *
	  * The callback will be supplied with context and callbacks parameters. It *must*
	  * call either onSuccess, onError or onTimeout methods in the callbacks parameter.
	  *
	  * The context.url property is the url for the key. The context.frag property is
	  * the fragment that is requesting the key.
	  *
	  * @example
	  * stream.keyLoadCallback = function (context, callbacks) {
	  *     let result = myGetKeyFunction(context.url);
	  *     switch(result.code) {
	  *     case 'SUCCESS':
	  *         callbacks.onSuccess(result.key);
	  *         break;
	  *     case 'ERROR':
	  *         callbacks.onError(result.response, result.error);
	  *         break;
	  *     case 'TIMEOUT':
	  *         callbacks.onTimeout();
	  *     }
	  * }),
	  *
	  * null means no function is defined. Use null to clear.
	  *
	  * @since 0.9
	  * @type {function} keyLoadCallback(context,callbacks)
	  */
	
		}, {
			key: 'keyLoadCallback',
			get: function get() {
				return this._controller.keyLoadCallback;
			},
			set: function set(func) {
				this._controller.keyLoadCallback = func;
			}
	
			/**
	   * A callback which when called will return a KeySystemConfig
	   *
	   * @since 3.2
	   * @type {function} obtainKeySystemConfigCallback( keySystem, keySystemData )
	   */
	
		}, {
			key: 'obtainKeySystemConfigCallback',
			get: function get() {
				return this._controller.obtainKeySystemConfigCallback;
			},
			set: function set(func) {
				this._controller.obtainKeySystemConfigCallback = func;
			}
	
			/**
	  * If true then dispose has been called already, and the HlsStream has either
	  * already been disposed, or is in the process of disposing.
	  *
	  * @since 0.8
	  * @type {boolean}
	  */
	
		}, {
			key: 'isDisposed',
			get: function get() {
				return !!this._disposed;
			}
	
			/**
	  * If true then dispose has been called, and the implementation has been destroyed.
	  * Further attempts to access any methods on HlsStream will fail.
	  *
	  * @since 3.2
	  * @type {boolean}
	  */
	
		}, {
			key: 'isDestroyed',
			get: function get() {
				return !this._controller;
			}
	
			/**
	   * Reference Id for this stream
	   * Increases each new stream
	   *
	   * @since 2.9
	   *  @type {integer}
	   */
	
		}, {
			key: 'streamId',
			get: function get() {
				return this._controller.instanceId;
			}
	
			/**
	  * If true then console.log will be used to output debug trace information
	  *
	  * @since 0.1
	  * @type {boolean}
	  */
	
		}, {
			key: 'debug',
			get: function get() {
				return this._controller.debug;
			},
			set: function set(value) {
				this._controller.debug = value;
			}
		}, {
			key: 'chosenVariant',
			get: function get() {
				return this.getNetworkMetrics().chosenVariant;
			}
	
			/**
	   * synonym for getNetworkMetrics().chosenBitrate, for compatibility with pre-3.2
	   *
	   * @deprecated use getNetworkMetrics()
	   * @since 0.9
	   * @type {integer}
	   */
	
		}, {
			key: 'chosenBitrate',
			get: function get() {
				return this.getNetworkMetrics().chosenBitrate;
			}
	
			/**************************
	  	HARD DEPRECATIONS
	   **************************/
	
			/**
	  * @ignore use getConstraints and setConstraints
	  */
	
		}, {
			key: 'maximumBitrate',
			get: function get() {
				throw new Error('maximumBitrate is no longer supported');
			},
			set: function set(value) {
				throw new Error('maximumBitrate is no longer supported');
			}
	
			/**
	  * @ignore use getConstraints and setConstraints
	  */
	
		}, {
			key: 'minimumBitrate',
			get: function get() {
				throw new Error('minimumBitrate is no longer supported');
			},
			set: function set(value) {
				throw new Error('minimumBitrate is no longer supported');
			}
	
			/**
	  * @ignore use getConstraints and setConstraints
	  */
	
		}, {
			key: 'maximumVariant',
			get: function get() {
				throw new Error('maximumVariant is no longer supported');
			},
			set: function set(value) {
				throw new Error('maximumVariant is no longer supported');
			}
	
			/**
	  * @ignore use getConstraints and setConstraints
	  */
	
		}, {
			key: 'minimumVariant',
			get: function get() {
				throw new Error('minimumVariant is no longer supported');
			},
			set: function set(value) {
				throw new Error('minimumVariant is no longer supported');
			}
	
			/**
	  * @ignore use getConstraints and setConstraints
	  */
	
		}, {
			key: 'maximumWidth',
			get: function get() {
				throw new Error('maximumWidth is no longer supported');
			},
			set: function set(value) {
				throw new Error('maximumWidth is no longer supported');
			}
	
			/**
	  * @ignore use getConstraints and setConstraints
	  */
	
		}, {
			key: 'maximumHeight',
			get: function get() {
				throw new Error('maximumHeight is no longer supported');
			},
			set: function set(value) {
				throw new Error('maximumHeight is no longer supported');
			}
		}]);
	
		return HlsStream;
	}();
	
	exports.default = HlsStream;
	module.exports = exports['default'];

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Media Controller - controls the video element.
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	//import Event from './HlsEvents';
	
	
	var _eventemitter = __webpack_require__(33);
	
	var _eventemitter2 = _interopRequireDefault(_eventemitter);
	
	var _EventHandlers = __webpack_require__(34);
	
	var _EventHandlers2 = _interopRequireDefault(_EventHandlers);
	
	var _HlsEvents = __webpack_require__(14);
	
	var _HlsEvents2 = _interopRequireDefault(_HlsEvents);
	
	var _HlsUtils = __webpack_require__(6);
	
	var _HlsUtils2 = _interopRequireDefault(_HlsUtils);
	
	var _logger = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	//const HAVE_NOTHING = 0;
	var HAVE_METADATA = 1;
	//const HAVE_CURRENT_DATA = 2;
	//const HAVE_FUTURE_DATA = 3;
	//const HAVE_ENOUGH_DATA = 4;
	
	/*
		IE will error unless the currentTime is set after HAVE_METADATA, Safari seems to silently fail, all other browsers don't care
		Probably smarter to just apply the rule to all
	 */
	var minReadyStateForCurrentTime = HAVE_METADATA;
	
	/**
	* @access internal
	*/
	
	var MediaController = function () {
		//Creation
		function MediaController() {
			var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
			var di = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
			_classCallCheck(this, MediaController);
	
			var disableWorkarounds = !!config.disableWorkarounds || false;
	
			this._emitter = di.eventEmitter || new _eventemitter2.default();
	
			// source config properties
			this._media = null;
			this._subtitlesEnabled = false;
			this._seeking = false;
			// default properties used if no media attached, and no overrides.
			this._mediaDefaults = {
				muted: false,
				volume: 1.0,
				ended: false,
				duration: 0,
				readyState: 0,
				currentTime: 0,
				playbackRate: 1.0
			};
	
			this._frameRate = 0;
			this._lastDecoded = 0;
			this._lastFrameRateTime = new Date();
	
			//ignore frame rate dropping to 0 at regular intervals
			this._safariFrameRateWorkaround = _HlsUtils2.default.isSafari() && !disableWorkarounds;
			this._lastFrameRate = 0;
	
			//We need 2 Tizen seek workarounds here, as one is used for both Tizen 2 + 3 and the other is just Tizen 2
			//The first workaround is for both 2 + 3, and stops attempts to set current time to 0 when it hasn't been prompted to
			//The second workaround is 2 only, and re-seeks if the previous seek failed to get the right time
			this._tizenSeekWorkaround = _HlsUtils2.default.isTizen() && !disableWorkarounds;
			this._tizen2ReseekWorkaround = _HlsUtils2.default.isTizen2() && !disableWorkarounds;
			this._targetSeekTime = 0;
	
			//properly apply playbackRate at the start of a video
			this._usePendingPlaybackRate = true; //Utils.isTizen() && !disableWorkarounds; //needed to make the config setting work as designed
			this._pendingPlaybackRate = undefined;
			this._pendingCurrentTime = undefined; //For seeking before a media is attached
	
			//reduce amount of media element errors on seek
			//turned this off for now, as we're going to try and just let error recovery handle it
			//this._windows8Point1IESeekWorkaround = Utils.isIEWin8Point1() && !disableWorkarounds;
			this._windows8Point1IESeekWorkaround = false;
			this._pauseAfterSeek = false;
	
			//stop attempts to set playbackRate to 1 at the end of a seek
			this._IEPlaybackRateWorkaround = _HlsUtils2.default.isIE() && !disableWorkarounds;
			this._rateChangeExpected = false;
			this._expectedPlaybackRate = 1;
	
			this._mediaOverrides = {
				// ie a bunch of undefined.
			};
	
			this._seekTimer = undefined;
	
			// media property values, that persist while media is not connected.
			this._handlers = new _EventHandlers2.default();
	
			// all the media events we will subscribe to
			this._mediaEvents = [{ event: 'seeking', func: this._onMediaSeeking }, { event: 'seeked', func: this._onMediaSeeked }, { event: 'ended', func: this._onMediaEnded }, { event: 'timeupdate', func: this._onMediaTimeUpdate }, { event: 'pause', func: this._onMediaPause }, { event: 'play', func: this._onMediaPlay }, { event: 'durationchange', func: this._onMediaDurationChange }, { event: 'playing', func: this._onMediaPlaying }, { event: 'loadedmetadata', func: this._onMediaLoadedMetaData }, //readyState 1 HAVE_METADATA
			{ event: 'loadeddata', func: this._onMediaLoadedData }, //readyState 2 HAVE_CURRENT_DATA
			{ event: 'canplay', func: this._onMediaCanPlay }, //readyState 3 HAVE_FUTURE_DATA
			{ event: 'canplaythrough', func: this._onMediaCanPlayThrough }, //readyState 4 HAVE_ENOUGH_DATA
			{ event: 'ratechange', func: this._onMediaRateChange }, { event: 'volumechange', func: this._onMediaVolumeChange }, { event: 'error', func: this._onMediaError }];
			_EventHandlers2.default.verifyEventsList(this._mediaEvents);
	
			_HlsUtils2.default.applyConfig(this, config);
		}
	
		_createClass(MediaController, [{
			key: 'dispose',
			value: function dispose() {
				if (this._seekTimer) {
					clearTimeout(this._seekTimer);
					this._seekTimer = undefined;
				}
				// triggers unwiring
	
				this._subtitlesEnabled = false;
				this.captionsControl();
	
				this.media = null;
	
				// this will destroy our event handlers too...
				this._handlers.dispose();
				this._handlers = null;
	
				this._mediaEvents = null;
				this._mediaDefaults = null;
				this._mediaOverrides = null;
	
				this._emitter = null;
	
				clearInterval(this._fpsMonitor);
				this._frameRate = 0;
				this._lastDecoded = 0;
	
				// need to destroy the EventEmitter _ee too.
	
				// ITS NOW ILLEGAL TO USE MediaController.
			}
	
			/**
	   * Wires a single media event
	   *
	   * @param {string} event - media element event type
	   * @param {function} func - event handler, must === the one in unwired.
	   */
	
		}, {
			key: '_wireMediaEvent',
			value: function _wireMediaEvent(_ref) {
				var event = _ref.event,
				    func = _ref.func;
	
				var handler = this._handlers.createEventHandler(this, func);
	
				this._media.addEventListener(event, handler);
			}
	
			/**
	   * Unwires a single media event
	   *
	   * @param {string} event - media element event type
	   * @param {function} func - event handler, must === the one in wired.
	   */
	
		}, {
			key: '_unwireMediaEvent',
			value: function _unwireMediaEvent(_ref2) {
				var event = _ref2.event,
				    func = _ref2.func;
	
				var handler = this._handlers.getHandlerForFunction(func);
	
				if (handler) {
					this._media.removeEventListener(event, handler);
				}
			}
	
			/**
	   * Wires all media events that we listen for.
	   *
	   * @emits MEDIA_CONTROLLER_WIRED {media}
	   */
	
		}, {
			key: '_wireMediaEvents',
			value: function _wireMediaEvents() {
				var _this = this;
	
				var data = { media: this._media };
				_logger.logger.log('MediaController::_wireMediaEvents: { media: ' + data.media + ' }');
	
				try {
					this._mediaEvents.forEach(function (event) {
						return _this._wireMediaEvent(event);
					});
					this._emit(_HlsEvents2.default.MEDIA_CONTROLLER_WIRED, data);
				} catch (e) {
					this._media = null; // otherwise we'll blow up when we unwire.
					this._emitMediaError(e);
				}
			}
	
			/**
	   * Unwires all registered media events.
	   *
	   * @emits MEDIA_CONTROLLER_UNWIRED {media}
	   */
	
		}, {
			key: '_unwireMediaEvents',
			value: function _unwireMediaEvents() {
				var _this2 = this;
	
				var data = { media: this._media };
				_logger.logger.log('MediaController::_unwireMediaEvents: { media: ' + data.media + ' }');
	
				this._mediaEvents.forEach(function (event) {
					return _this2._unwireMediaEvent(event);
				});
	
				this._emit(_HlsEvents2.default.MEDIA_CONTROLLER_UNWIRED, data);
			}
	
			/**
	   * Constructs and emits a MEDIA_CONTROLLER_ERROR
	   *
	   * @emits MEDIA_CONTROLLER_ERROR {details, [errorObj]}
	   *
	   * @todo add more error types etc... ie wiringError.
	   *
	   * @param {Error} errObj - the error obj, if there is one
	   */
	
		}, {
			key: '_emitMediaError',
			value: function _emitMediaError(errObj) {
				var theError = {};
				theError.details = 'mediaControllerError';
				theError.errorObj = errObj || new Error('MediaController::_emitMediaError \'' + theError.details + '\'');
	
				this._emit(_HlsEvents2.default.MEDIA_CONTROLLER_ERROR, theError);
			}
	
			// MEDIA EVENTS
	
		}, {
			key: '_onMediaLoadedMetaData',
			value: function _onMediaLoadedMetaData() {
				_logger.logger.log('MEDIA_LOADEDMETADATA'); //readyState 1 HAVE_METADATA
	
				this._mediaReadyStateChange();
			}
		}, {
			key: '_onMediaLoadedData',
			value: function _onMediaLoadedData() {
				_logger.logger.log('MEDIA_LOADEDDATA :' + this.currentTime); //readyState 2 HAVE_CURRENT_DATA
	
				this._emit(_HlsEvents2.default.MEDIA_LOADEDDATA);
			}
		}, {
			key: '_onMediaCanPlay',
			value: function _onMediaCanPlay() {
				_logger.logger.log('Media: CANPLAY : duration: ' + this.duration); //readyState 3 HAVE_FUTURE_DATA
	
				this._emit(_HlsEvents2.default.MEDIA_CANPLAY);
			}
		}, {
			key: '_onMediaCanPlayThrough',
			value: function _onMediaCanPlayThrough() {
				_logger.logger.log('Media: CANPLAYTHROUGH : duration: ' + this.duration); //readyState 4 HAVE_ENOUGH_DATA
	
				this._emit(_HlsEvents2.default.MEDIA_CANPLAYTHROUGH);
	
				//	this.play();
			}
		}, {
			key: '_mediaReadyStateChange',
			value: function _mediaReadyStateChange() {
				if (this._pendingCurrentTime && this._readyForCurrentTime()) {
					//note that media is checked in _readyForCurrentTime
					this._media.currentTime = this._pendingCurrentTime;
					this._pendingCurrentTime = undefined;
				}
			}
		}, {
			key: '_onMediaSeeked',
			value: function _onMediaSeeked() {
				_logger.logger.log('seeked: currentTime: ' + this.currentTime + ', _seeking: ' + this._seeking);
				if (this._seeking) {
	
					//if( !this._seeking ) {
					// need to force the seeking event, since it was skipped by the media
					//this._onMediaSeeking();
					//}
	
					if (this._tizen2ReseekWorkaround && this.currentTime < this._targetSeekTime && this._targetSeekTime !== 0) {
						this.currentTime = this._targetSeekTime;
					} else {
						this._seeking = false;
						this._emit(_HlsEvents2.default.MEDIA_SEEKED, { currentTime: this.currentTime });
	
						if (this._pauseAfterSeek) {
							this.pause();
							this._pauseAfterSeek = false;
						}
					}
				}
			}
	
			// this is NOT always fired! Is mediaSeeked always fired?
	
		}, {
			key: '_onMediaSeeking',
			value: function _onMediaSeeking() {
				_logger.logger.log('seeking: currentTime: ' + this.currentTime + ', _seeking: ' + this._seeking);
				if (!this._seeking) {
	
					/*if( this._seeking ) {
	    	//throw new Error( 'should not be seeking already');
	    }*/
	
					this._seeking = true;
	
					if (this._tizenSeekWorkaround) {
						this._targetSeekTime = this.currentTime;
					}
	
					this._emit(_HlsEvents2.default.MEDIA_SEEKING);
				}
			}
		}, {
			key: '_onMediaEnded',
			value: function _onMediaEnded() {
				_logger.logger.log('ended :' + this.currentTime);
	
				this._targetSeekTime = 0;
	
				this._emit(_HlsEvents2.default.MEDIA_ENDED);
			}
		}, {
			key: '_onMediaTimeUpdate',
			value: function _onMediaTimeUpdate() {
				//logger.log('timeupdate :' + this.currentTime);
				if (this._tizenSeekWorkaround && this.currentTime === 0 && this._targetSeekTime !== 0) {
					this.currentTime = this._targetSeekTime;
				} else {
					this._emit(_HlsEvents2.default.MEDIA_TIMEUPDATE, { currentTime: this.currentTime });
				}
	
				//Would the pendingPlaybackRate be better in one of the readyState checks? - SIEG
				if (this._pendingPlaybackRate !== undefined && this.currentTime !== 0) {
					var pendingPlaybackRate = this._pendingPlaybackRate;
					this._pendingPlaybackRate = undefined;
					this.playbackRate = pendingPlaybackRate;
	
					_logger.logger.log('_onMediaTimeUpdate: applying pending playback rate:' + pendingPlaybackRate);
				}
			}
		}, {
			key: '_onMediaPause',
			value: function _onMediaPause() {
				_logger.logger.log('pause :' + this.currentTime);
	
				this._emit(_HlsEvents2.default.MEDIA_PAUSE);
			}
		}, {
			key: '_onMediaPlay',
			value: function _onMediaPlay() {
				_logger.logger.log('play :' + this.currentTime);
	
				this._emit(_HlsEvents2.default.MEDIA_PLAY);
			}
		}, {
			key: '_onMediaDurationChange',
			value: function _onMediaDurationChange() {
				_logger.logger.log('durationchange :' + this.duration);
	
				this._emit(_HlsEvents2.default.MEDIA_DURATIONCHANGE);
			}
		}, {
			key: '_onMediaPlaying',
			value: function _onMediaPlaying() {
				_logger.logger.log('MEDIA_PLAYING playing :' + this.currentTime);
	
				//this._emit( Event.STREAM_PLAYING);
			}
		}, {
			key: '_onMediaRateChange',
			value: function _onMediaRateChange() {
				//the timing of the playback rate reset in IE is late enough that we can't rely on being in the seeking state when it happens
				//as such we need to track whether or not we were expecting the playback rate to change
				if (this._IEPlaybackRateWorkaround && !this._rateChangeExpected && this.playbackRate === 1) {
					_logger.logger.log('_onMediaRateChange: rate change correction');
					this.playbackRate = this._expectedPlaybackRate;
				} else {
					this._rateChangeExpected = false;
					_logger.logger.log('_onMediaRateChange: ratechange: ' + this.playbackRate);
	
					this._emit(_HlsEvents2.default.MEDIA_RATECHANGE);
				}
			}
		}, {
			key: '_onMediaVolumeChange',
			value: function _onMediaVolumeChange() {
				_logger.logger.log('volumechange :' + this.currentTime);
	
				this._emit(_HlsEvents2.default.MEDIA_VOLUMECHANGE);
			}
		}, {
			key: '_onMediaError',
			value: function _onMediaError() {
				// TODO: MediaError object is HTML5, and thus we can map more detail into the sub-error.
				var theError = {};
				theError.details = 'mediaElementError';
				theError.mediaErrorObj = this._media.error;
	
				if (theError.mediaErrorObj && theError.mediaErrorObj.msExtendedCode !== undefined) {
					theError.mediaErrorObj.msExtendedHex = _HlsUtils2.default.msErrToHex(theError.mediaErrorObj.msExtendedCode);
				}
				theError.errorObj = new Error('MediaController::_onMediaError \'' + theError.details + '\'');
				_logger.logger.log('media error');
	
				this._emit(_HlsEvents2.default.MEDIA_ELEMENT_ERROR, theError);
			}
		}, {
			key: '_emit',
			value: function _emit(event) {
				var _emitter;
	
				for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
					args[_key - 1] = arguments[_key];
				}
	
				(_emitter = this._emitter).emit.apply(_emitter, [event].concat(args));
			}
		}, {
			key: 'pause',
			value: function pause() {
				if (this._media) {
					this._media.pause();
				}
			}
	
			// returns a promise
	
		}, {
			key: 'play',
			value: function play() {
				var playPromise = this._media.play();
	
				if (playPromise === undefined) {
					playPromise = Promise.resolve();
				}
	
				if (this._pauseAfterSeek) {
					//If we get a play command while pauseAfterSeek is on, assume that the user or player wants to play after seek and turn off pauseAfterSeek
					this._pauseAfterSeek = false;
				}
	
				return playPromise;
			}
		}, {
			key: 'seek',
			value: function seek(seconds) {
				if (this._windows8Point1IESeekWorkaround && this.paused) {
					//IE11 on Win8.1 can crash on seek if paused. Work around by switching to playing state during the seek.
					this.play();
					this._pauseAfterSeek = true;
				}
				// should maybe clamp to sane values...
				this.currentTime = seconds;
			}
		}, {
			key: '_getMediaProperty',
			value: function _getMediaProperty(prop) {
				//logger.log(`getMediaProperty prop: ${prop}, media: ${this._media}, ` +
				//	`mediaOverride:${this._mediaOverrides[prop]}, mediaDefault; ${this._mediaDefaults[prop]}`);
	
				if (this._media) {
					//console.log(`returning media property: ${prop}: ${this._media[prop]}`);
					return this._media[prop];
				} else if (this._mediaOverrides[prop] !== undefined) {
					return this._mediaOverrides[prop];
				} else {
					if (this._mediaDefaults[prop] === undefined) {
						throw new Error('no default for media.' + prop + ' defined');
					}
					return this._mediaDefaults[prop];
				}
			}
		}, {
			key: '_setMediaProperty',
			value: function _setMediaProperty(prop, value) {
				if (this._mediaDefaults[prop] === undefined) {
					throw new Error('media.' + prop + ' has no default. Not safe to override with ' + value);
				}
	
				// TODO: we might want to consider deleting properties which are getitng set to 'undefined'
				if (value === undefined) {
					throw new Error('setting media.' + prop + ' to undefined is not currently supported.');
				}
	
				this._mediaOverrides[prop] = value;
				//console.log(`setting media override property: ${prop}: ${this._mediaOverrides[prop]}`);
				//console.log(Object.keys(this._mediaOverrides));
	
				if (this._media) {
					//console.log(`setting media property: ${prop}: ${this._media[prop]}`);
					this._media[prop] = value;
				}
			}
		}, {
			key: '_checkFrameRate',
			value: function _checkFrameRate() {
				var frames = 0;
				var time = new Date();
				var timeSinceLast = time.getTime() - this._lastFrameRateTime.getTime();
	
				if (this._media) {
					if (typeof this._media.getVideoPlaybackQuality === 'function') {
						frames = this._media.getVideoPlaybackQuality().totalVideoFrames;
					} else {
						frames = this._media.webkitDecodedFrameCount;
					}
	
					this._frameRate = Math.max(frames - this._lastDecoded, 0) * (1000 / timeSinceLast);
					this._lastDecoded = frames;
	
					if (this._safariFrameRateWorkaround) {
						var lastFrameRate = this._lastFrameRate;
						this._lastFrameRate = this._frameRate;
	
						if (this._frameRate === 0 && lastFrameRate !== 0) {
							this._frameRate = lastFrameRate;
						}
					}
				} else {
					this._lastDecoded = 0;
				}
	
				this._lastFrameRateTime = time;
			}
		}, {
			key: 'captionsControl',
			value: function captionsControl() {
				//force the text track to hidden, then switch it to showing if we want it to be visible
				//running the caption control on canplaythrough fixes two issues:
				// - Firefox does not re-render captions after deleting cues. hiding then showing again forces a re-render.
				// - Tizen 2.3 switches text tracks to disabled on canplaythrough. we don't want the track in that mode, especially as we have to create the text track
				//   on startup or it won't work at all.
				if (this._media && this._media.textTracks && this._media.textTracks.length !== 0) {
					this._media.textTracks[0].mode = 'hidden';
	
					if (this._subtitlesEnabled) {
						this._media.textTracks[0].mode = 'showing';
					}
					/*
	    			for (let i = 0; i < this._media.textTracks.length; i++) {
	    				this._media.textTracks[i].mode = newMode;
	    			}
	    */
				}
			}
		}, {
			key: '_applyProperties',
			value: function _applyProperties(propertyList) {
				if (this._media && propertyList) {
	
					var setProps = Object.keys(propertyList);
	
					//console.log(`_applyProperties: ${setProps} ${setProps.length}`);
					for (var i = 0; i < setProps.length; i++) {
						//console.log(`_applyProperties: before ${this._media[setProps[i]]}`);
						//console.log(`_applyProperties: ${setProps[i]}: ${propertyList[setProps[i]]}`);
						this._media[setProps[i]] = propertyList[setProps[i]];
						//console.log(`_applyProperties: after ${this._media[setProps[i]]}`);
					}
				}
			}
		}, {
			key: '_readMediaProperties',
			value: function _readMediaProperties() {
				var propertyList = {};
	
				if (this._media) {
					//walking the list would seem nicer but really all we want is..
					propertyList.muted = this._media.muted;
					propertyList.volume = this._media.volume;
					propertyList.playbackRate = this._media.playbackRate;
				}
	
				return propertyList;
			}
		}, {
			key: '_readyForCurrentTime',
			value: function _readyForCurrentTime() {
				return this._media && this._media.readyState >= minReadyStateForCurrentTime;
			}
		}, {
			key: 'emitter',
			get: function get() {
				return this._emitter;
			}
		}, {
			key: 'media',
			get: function get() {
				return this._media;
			},
			set: function set(video) {
				if (this._media) {
					this._mediaOverrides = this._readMediaProperties();
					this._unwireMediaEvents();
					clearInterval(this._fpsMonitor);
				}
	
				this._media = video;
	
				if (this._media) {
					if (this._media.src) {
						// its not as simple as setting the src to null.
						// https://github.com/w3c/media-source/issues/53
	
						this._media.removeAttribute('src');
						this._media.load();
					}
	
					this._wireMediaEvents();
					this._lastFrameRateTime = new Date();
					this._fpsMonitor = setInterval(this._checkFrameRate.bind(this), 1000, this._media);
					this._applyProperties(this._mediaOverrides);
				}
			}
		}, {
			key: 'paused',
			get: function get() {
				return this._media.paused;
			}
		}, {
			key: 'ended',
			get: function get() {
				return this._getMediaProperty('ended');
			}
		}, {
			key: 'duration',
			get: function get() {
				var duration = 0;
	
				if (this._media) {
					duration = this._media.duration;
	
					if (isNaN(duration)) {
						duration = 0;
					}
				}
	
				return duration;
			}
		}, {
			key: 'readyState',
			get: function get() {
				return this._getMediaProperty('readyState');
			}
		}, {
			key: 'muted',
			get: function get() {
				if (this._getMediaProperty('volume') === 0.0) {
					return true;
				} else {
					return this._getMediaProperty('muted');
				}
			},
			set: function set(value) {
				//TODO: sanity check (true, false and undefined?)
				this._setMediaProperty('muted', !!value);
			}
		}, {
			key: 'volume',
			get: function get() {
				// FIXME: this should return 0.0 if _muted
				return this._getMediaProperty('muted') ? 0.0 : this._getMediaProperty('volume');
			},
			set: function set(value) {
				_HlsUtils2.default.checkNotFiniteAndThrow(value, 'volume');
				_HlsUtils2.default.checkLessThanZeroPointZeroAndThrow(value, 'volume');
				_HlsUtils2.default.checkMoreThanOnePointZeroAndThrow(value, 'volume');
	
				this._setMediaProperty('volume', value);
			}
		}, {
			key: 'currentTime',
			get: function get() {
				var time = this._pendingCurrentTime;
	
				if (time === undefined) {
					time = this._getMediaProperty('currentTime');
				}
	
				return time;
			},
			set: function set(seconds) {
				// TODO: sanity check?
				if (seconds === this.currentTime) {
					//seeking to the current time causes Safari to stall, and there's no reason to do it in other browsers
					//emit a MEDIA_SEEKED, in case something is waiting on confirmation that it's done
					_logger.logger.log('already at the seek time, faking a seek');
					//this._emit(Event.MEDIA_SEEKING);
					this._emit(_HlsEvents2.default.MEDIA_SEEKED, { currentTime: this.currentTime });
				} else {
					if (this._readyForCurrentTime()) {
						this._media.currentTime = seconds;
					} else {
						_logger.logger.log('Media not ready. Pending seek');
						this._pendingCurrentTime = seconds;
					}
				}
			}
		}, {
			key: 'playbackRate',
			get: function get() {
				if (this._pendingPlaybackRate !== undefined) {
					return this._pendingPlaybackRate;
				} else {
					return this._getMediaProperty('playbackRate');
				}
			},
			set: function set(value) {
				_HlsUtils2.default.checkNotFiniteAndThrow(value, 'playbackRate');
				_HlsUtils2.default.checkEqualToZeroPointZeroAndThrow(value, 'playbackRate');
				_HlsUtils2.default.checkLessThanZeroPointZeroAndThrow(value, 'playbackRate');
	
				var newPlaybackRate = value;
	
				if (newPlaybackRate > 8) {
					_logger.logger.warn('set playbackRate: fast forward is currently limited to 8x');
					newPlaybackRate = 8;
				}
	
				if (this._usePendingPlaybackRate && this.currentTime === 0 || this._pendingPlaybackRate !== undefined) {
					_logger.logger.log('set playbackRate: Pending change to ' + newPlaybackRate);
					this._pendingPlaybackRate = newPlaybackRate;
				} else if (this.playbackRate !== newPlaybackRate) {
					_logger.logger.log('set playbackRate: Requesting change to ' + newPlaybackRate);
					this._expectedPlaybackRate = newPlaybackRate;
					this._rateChangeExpected = true;
					this._setMediaProperty('playbackRate', newPlaybackRate);
				} else if (this.playbackRate === newPlaybackRate && this._pendingPlaybackRate === undefined) {
					_logger.logger.log('set playbackRate: Rate is already ' + newPlaybackRate);
	
					this._emit(_HlsEvents2.default.MEDIA_RATECHANGE);
				}
			}
		}, {
			key: 'droppedFramesCount',
			get: function get() {
				if (this._media) {
					if (typeof this._media.getVideoPlaybackQuality === 'function') {
						return this._media.getVideoPlaybackQuality().droppedVideoFrames;
					} else {
						return this._media.webkitDroppedFrameCount;
					}
				} else {
					return 0;
				}
			}
		}, {
			key: 'frameRate',
			get: function get() {
				return this._frameRate;
			}
		}, {
			key: 'isPlaying',
			get: function get() {
				var playing = false;
	
				if (this._media) {
					//current time is too slow to work at start.
					if ( /*this._media.currentTime > 0 && */!this._media.paused && !this._media.ended && this._media.readyState > 2) {
						playing = true;
					}
				}
	
				return playing;
			}
		}, {
			key: 'subtitlesEnabled',
			get: function get() {
				return this._subtitlesEnabled;
			},
			set: function set(value) {
				this._subtitlesEnabled = !!value;
				this.captionsControl();
			}
		}]);
	
		return MediaController;
	}();
	
	exports.default = MediaController;
	module.exports = exports['default'];

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _WebCryptoAesCbc = __webpack_require__(111);
	
	var _WebCryptoAesCbc2 = _interopRequireDefault(_WebCryptoAesCbc);
	
	var _JsCryptoAesCbc = __webpack_require__(108);
	
	var _JsCryptoAesCbc2 = _interopRequireDefault(_JsCryptoAesCbc);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	__webpack_require__(79);
	
	var CryptoAesCbc = function () {
		function CryptoAesCbc() {
			_classCallCheck(this, CryptoAesCbc);
	
			// acquire a promise to the correct crypto implementation.
			this.crypto = _WebCryptoAesCbc2.default.isSupportedAsync().then(function (webCryptoSupported) {
				if (webCryptoSupported) {
					return new _WebCryptoAesCbc2.default();
				} else {
					return new _JsCryptoAesCbc2.default();
				}
			}).catch(function () {
				// fallback
				return new _JsCryptoAesCbc2.default();
			});
		}
	
		_createClass(CryptoAesCbc, [{
			key: 'createKey',
			value: function createKey(key) {
				return this.crypto.then(function (crypto) {
					return crypto.createKey(key);
				});
			}
		}, {
			key: 'decrypt',
			value: function decrypt(cryptoKey, iv, cypherText) {
				return this.crypto.then(function (crypto) {
					return crypto.decrypt(cryptoKey, iv, cypherText);
				});
			}
		}]);
	
		return CryptoAesCbc;
	}();
	
	exports.default = CryptoAesCbc;
	module.exports = exports['default'];

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _JsCryptoWrapper = __webpack_require__(109);
	
	var _JsCryptoWrapper2 = _interopRequireDefault(_JsCryptoWrapper);
	
	var _ArrayHelper = __webpack_require__(21);
	
	var _ArrayHelper2 = _interopRequireDefault(_ArrayHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	//import type from 'type-detect';
	
	var JsCryptoAesCbc = function () {
		_createClass(JsCryptoAesCbc, null, [{
			key: 'isSupported',
			value: function isSupported() {
				return true;
			}
	
			/**
	   * Initialises the WebCrypto sub-system. Only one instance is needed.
	   */
	
		}]);
	
		function JsCryptoAesCbc() {
			_classCallCheck(this, JsCryptoAesCbc);
	
			this.wrapper = new _JsCryptoWrapper2.default();
		}
	
		/**
	  * returns an AES-CBC cryptoKey from Uint8Array(16) for use with decrypt
	  */
	
	
		_createClass(JsCryptoAesCbc, [{
			key: 'createKey',
			value: function createKey(key) {
				try {
					if (key.length !== 16) {
						throw new Error('JsCryptoAesCbc.createKey length must be 16');
					}
	
					return this.wrapper.importKey('raw', key, { name: 'AES-CBC' }, false, ['encrypt', 'decrypt']);
				} catch (err) {
					return Promise.reject(err);
				}
			}
		}, {
			key: '_decryptInternal',
			value: function _decryptInternal(cryptoKey, iv, cypherText) {
				return this.wrapper.decrypt({
					name: 'AES-CBC',
					iv: iv
				}, cryptoKey, cypherText);
			}
		}, {
			key: '_stripPadding',
			value: function _stripPadding(clearText) {
				var myClearText = clearText;
				var len = myClearText.length;
	
				// now we need to check for padding, and if its there, strip it.
				var p = myClearText[len - 1];
	
				if (p > 0 && p <= 16) {
					var good = true;
					for (var i = len - p; i < len; i++) {
						if (myClearText[i] !== p) {
							good = false;
							break;
						}
					}
	
					if (good) {
						myClearText = myClearText.subarray(0, len - p);
					}
				}
	
				return myClearText;
			}
		}, {
			key: 'decrypt',
			value: function decrypt(cryptoKey, iv, cypherText) {
				var _this = this;
	
				try {
					// we need to use a Uint8Array for some of our processing
					var myCypherText = _ArrayHelper2.default.makeUint8Array(cypherText);
	
					// if we're non-modulo 16 truncate if necessary
					var truncated = void 0;
	
					var _ArrayHelper$makeModu = _ArrayHelper2.default.makeModulo16(myCypherText);
	
					myCypherText = _ArrayHelper$makeModu.data;
					truncated = _ArrayHelper$makeModu.truncated;
	
	
					return this._decryptInternal(cryptoKey, iv, myCypherText).then(function (decrypted) {
						var result = new Uint8Array(decrypted);
	
						if (!truncated) {
							result = _this._stripPadding(result);
						}
	
						return result;
					});
				} catch (err) {
					return Promise.reject(err);
				}
			}
		}]);
	
		return JsCryptoAesCbc;
	}();
	
	exports.default = JsCryptoAesCbc;
	module.exports = exports['default'];

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _HlsUtils = __webpack_require__(6);
	
	var _HlsUtils2 = _interopRequireDefault(_HlsUtils);
	
	var _jsAesDecryptor = __webpack_require__(113);
	
	var _jsAesDecryptor2 = _interopRequireDefault(_jsAesDecryptor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	//import type from 'type-detect';
	
	var JsCryptoWrapper = function () {
		function JsCryptoWrapper() {
			_classCallCheck(this, JsCryptoWrapper);
	
			this.crypto = new _jsAesDecryptor2.default();
		}
	
		_createClass(JsCryptoWrapper, [{
			key: '_importKeyCheck',
			value: function _importKeyCheck(format, keyData, algo, extractable, usages) {
				// eslint-disable-line no-unused-vars
				if (format !== 'raw') {
					throw new Error('JsCryptoWrapper.importKey only supports raw keys : ' + format);
				}
	
				if (algo.name !== 'AES-CBC') {
					throw new Error('JsCryptoWrapper.importKey only supports AES-CBC algorithm : ' + algo);
				}
	
				if (keyData.length !== 16) {
					throw new Error('JsCryptoWrapper.importKey key is not a valid length : ' + keyData.length);
				}
			}
		}, {
			key: 'importKey',
			value: function importKey(format, keyData, algo, extractable, usages) {
				var _this = this;
	
				return new Promise(function (resolve, reject) {
					try {
						_this._importKeyCheck(format, keyData, algo, extractable, usages); // throws
	
						// Each key has its own AESDecryptor, because each AESDecryptor has its own key.
						var aesKey = _this.crypto.expandKey(keyData);
	
						var cryptoKey = { aesKey: aesKey, algo: algo };
						if (extractable) {
							cryptoKey.key = keyData;
						}
	
						// the key contains a field for the crypto instance, with the key loaded.
						resolve(cryptoKey);
					} catch (err) {
						reject(err);
					}
				});
			}
		}, {
			key: '_decryptCheck',
			value: function _decryptCheck(algo, key, data) {
				if (!_HlsUtils2.default.isObject(key.aesKey) || !_HlsUtils2.default.isObject(key.algo)) {
					throw new Error('JsCryptoWrapper.decrypt, key is not valid : ' + key);
				}
	
				if (key.algo.name !== algo.name) {
					throw new Error('JsCryptoWrapper.decrypt, algorithm doesn\'t match key : ' + algo);
				}
	
				if (!_HlsUtils2.default.isObject(algo.iv)) {
					throw new Error('JsCryptoWrapper.decrypt, IV invalid : ' + algo.iv);
				}
	
				if (algo.iv.length !== 16) {
					throw new Error('JsCryptoWrapper.decrypt, IV length invalid : ' + algo.iv.length);
				}
	
				if (data.length % 16 !== 0) {
					throw new Error('JsCryptoWrapper.decrypt, data is not a multiple of 16 : ' + data.length);
				}
			}
		}, {
			key: 'decrypt',
			value: function decrypt(algo, key, data) {
				var _this2 = this;
	
				var result = new Promise(function (resolve, reject) {
	
					try {
						_this2._decryptCheck(algo, key, data); // throws
	
						var decrypted = _this2.crypto.decrypt(key.aesKey, data, algo.iv);
						resolve(decrypted);
					} catch (err) {
						reject(err);
					}
				});
	
				return result;
			}
		}]);
	
		return JsCryptoWrapper;
	}();
	
	exports.default = JsCryptoWrapper;
	module.exports = exports['default'];

/***/ }),
/* 110 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MsCryptoWrapper = function () {
		_createClass(MsCryptoWrapper, null, [{
			key: 'getMsCrypto',
			value: function getMsCrypto() {
				var msCrypto = void 0;
	
				try {
					msCrypto = msCrypto || self.msCrypto;
				} catch (e) {}
	
				return msCrypto;
			}
		}, {
			key: 'isSupported',
			value: function isSupported() {
				return !!MsCryptoWrapper.getMsCrypto();
			}
		}]);
	
		function MsCryptoWrapper() {
			_classCallCheck(this, MsCryptoWrapper);
	
			var crypto = MsCryptoWrapper.getMsCrypto();
			if (!crypto) {
				throw new Error('MsCryptoWrapper: msCrypto not supported');
			}
	
			this.crypto = crypto;
		}
	
		_createClass(MsCryptoWrapper, [{
			key: 'importKey',
			value: function importKey(format, keyData, algo, extractable, usages) {
				var _this = this;
	
				return new Promise(function (resolve, reject) {
					try {
						var keyOp = _this.crypto.subtle.importKey(format, keyData, algo, extractable, usages);
						keyOp.onerror = function (e) {
							// eslint-disable-line no-unused-vars
							reject(new Error('MsCryptoWrapper.importKey failed'));
						};
						keyOp.oncomplete = function (e) {
							resolve(e.target.result);
						};
					} catch (err) {
						reject(err);
					}
				});
			}
		}, {
			key: 'decrypt',
			value: function decrypt(algorithm, key, data) {
				var _this2 = this;
	
				return new Promise(function (resolve, reject) {
					try {
						var decryptOp = _this2.crypto.subtle.decrypt(algorithm, key, data);
						decryptOp.onerror = function (e) {
							// eslint-disable-line no-unused-vars
							reject(new Error('MsCryptoWrapper.decrypt failed'));
						};
						decryptOp.oncomplete = function (e) {
							resolve(e.target.result);
						};
					} catch (err) {
						reject(err);
					}
				});
			}
		}, {
			key: 'encrypt',
			value: function encrypt(algorithm, key, data) {
				var _this3 = this;
	
				return new Promise(function (resolve, reject) {
					try {
						var encryptOp = _this3.crypto.subtle.encrypt(algorithm, key, data);
						encryptOp.onerror = function (e) {
							// eslint-disable-line no-unused-vars
							reject(new Error('MsCryptoWrapper.encrypt failed'));
						};
						encryptOp.oncomplete = function (e) {
							resolve(e.target.result);
						};
					} catch (err) {
						reject(err);
					}
				});
			}
		}]);
	
		return MsCryptoWrapper;
	}();
	
	exports.default = MsCryptoWrapper;
	module.exports = exports['default'];

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _WebCryptoWrapper = __webpack_require__(112);
	
	var _WebCryptoWrapper2 = _interopRequireDefault(_WebCryptoWrapper);
	
	var _ArrayHelper = __webpack_require__(21);
	
	var _ArrayHelper2 = _interopRequireDefault(_ArrayHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var WebCryptoAesCbc = function () {
		_createClass(WebCryptoAesCbc, null, [{
			key: 'isSupportedAsync',
			value: function isSupportedAsync() {
				return _WebCryptoWrapper2.default.isSupportedAsync();
			}
	
			/**
	   * Initialises the WebCrypto sub-system. Only one instance is needed.
	   */
	
		}]);
	
		function WebCryptoAesCbc() {
			_classCallCheck(this, WebCryptoAesCbc);
	
			this.crypto = new _WebCryptoWrapper2.default();
		}
	
		/**
	  * returns an AES-CBC cryptoKey from Uint8Array(16) for use with decrypt
	  */
	
	
		_createClass(WebCryptoAesCbc, [{
			key: 'createKey',
			value: function createKey(key) {
				try {
					if (key.length !== 16) {
						throw new Error('WebCryptoAesCbc.createKey length must be 16');
					}
	
					return this.crypto.importKey('raw', key, { name: 'AES-CBC' }, false, ['encrypt', 'decrypt']);
				} catch (err) {
					return Promise.reject(err);
				}
			}
		}, {
			key: '_padCypherTextAsync',
			value: function _padCypherTextAsync(cryptoKey, cypherText) {
	
				// the padding needs to be encoded with an IV which is the last
				// 16 bytes of the current cypherText
				var paddingIv = cypherText.subarray(cypherText.length - 16);
	
				// the padding consists of 16 bytes of 16. In pkcs7, 16 indicates to remove 16 bytes,
				// ie strip all the padding.
				var padding = new Uint8Array(16).fill(16);
	
				// now we need to encrypt the padding
				return this.crypto.encrypt({
					name: 'AES-CBC',
					iv: paddingIv
				}, cryptoKey, padding).then(function (encrypted) {
					// encrypted is an ArrayBuffer, we need just the first 16 bytes
					var encryptedPadding = new Uint8Array(encrypted, 0, 16);
	
					// we need to allocate a new array which includes space for the extra 16 bytes
					// of encrypted padding
					var paddedCypherText = new Uint8Array(cypherText.length + 16);
	
					// now we concat the two data items together
					paddedCypherText.set(cypherText);
					paddedCypherText.set(encryptedPadding, cypherText.length);
	
					return paddedCypherText;
				});
			}
		}, {
			key: '_decryptInternal',
			value: function _decryptInternal(cryptoKey, iv, cypherText) {
				return this.crypto.decrypt({
					name: 'AES-CBC',
					iv: iv
				}, cryptoKey, cypherText);
			}
		}, {
			key: 'decrypt',
			value: function decrypt(cryptoKey, iv, cypherText) {
				var _this = this;
	
				try {
					// we need to use a Uint8Array for some of our processing
					var myCypherText = _ArrayHelper2.default.makeUint8Array(cypherText);
	
					// if we're non-modulo 16 truncate if necessary
					var truncated = void 0;
	
					// we need to add padding if we truncated
					var _ArrayHelper$makeModu = _ArrayHelper2.default.makeModulo16(myCypherText);
	
					myCypherText = _ArrayHelper$makeModu.data;
					truncated = _ArrayHelper$makeModu.truncated;
					if (truncated) {
						// adding padding involves encrypting, and is an Async op
						// thus myCypherText is now a promise.
						myCypherText = this._padCypherTextAsync(cryptoKey, myCypherText);
					}
	
					// because myCypherText might be a promise, we need to resolve it
					return Promise.resolve(myCypherText).then(function (resolvedCypherText) {
						return _this._decryptInternal(cryptoKey, iv, resolvedCypherText).catch(function (err) {
	
							// if we get here, the decrypt failed... if we have't already truncated
							// and added padding, then we assume it failed because it was truncated
							// to modulo-16, thus we try again, but with added padding.
							if (!truncated) {
								return _this._padCypherTextAsync(cryptoKey, resolvedCypherText).then(function (paddedCypherText) {
									return _this._decryptInternal(cryptoKey, iv, paddedCypherText);
								});
	
								// if this fails, we can't resolve it, and the client will need to
								// deal with the failed promise.
							} else {
								// this means that we failed after truncating, which shouldn't happen.
								throw err;
							}
						});
					});
				} catch (err) {
					return Promise.reject(err);
				}
			}
		}]);
	
		return WebCryptoAesCbc;
	}();
	
	exports.default = WebCryptoAesCbc;
	module.exports = exports['default'];

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); //import Utils from '../HlsUtils';
	
	
	var _MsCryptoWrapper = __webpack_require__(110);
	
	var _MsCryptoWrapper2 = _interopRequireDefault(_MsCryptoWrapper);
	
	var _logger = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var WebCryptoWrapper = function () {
		_createClass(WebCryptoWrapper, null, [{
			key: 'getSubtle',
			value: function getSubtle() {
				var subtle = void 0;
	
				try {
					var browserCrypto = crypto || self.crypto;
					subtle = browserCrypto.subtle || browserCrypto.webkitSubtle;
				} catch (e) {}
	
				if (!subtle) {
					if (_MsCryptoWrapper2.default.isSupported()) {
						subtle = new _MsCryptoWrapper2.default();
					}
				}
	
				return subtle;
			}
	
			/**
	   * NOTE: this returns Promise(Boolean)
	   */
	
		}, {
			key: 'isSupportedAsync',
			value: function isSupportedAsync() {
				var subtle = WebCryptoWrapper.getSubtle();
				var supported = Promise.resolve(false);
	
				// we actually need to test to see if it works. NOTE: this results in a Promise!
				if (subtle) {
					try {
						supported = subtle.importKey('raw', new Uint8Array(16), { name: 'AES-CBC' }, false, ['encrypt', 'decrypt']).then(function () {
							// we were able to importKey, assume WebCrypto is functioning
							return true;
						}).catch(function () /*err*/{
							// unable to importKey, assume WebCrypto is busted.
							//logger.warn( `WebCryptoWrapper.isSupported: error while testing
							// WebCrypto, WebCrypto will be disabled : ${err.message}`, err );
							return false;
						});
					} catch (err) {
						// in theory this shouldn't happen... but bad WebCrypto implementations sometimes throw.
						_logger.logger.warn('WebCryptoWrapper.isSupported: Unexpected error while testing WebCrypto : ' + err.message, err);
						supported = Promise.resolve(false);
					}
				}
	
				return supported;
			}
	
			/**
	   * NOTE: subtle may be defined, but non-functional when insecure-origin in this case, this will not
	   * throw. you need to resolve isSupportedAsync to know if WebCrypto is truly supported.
	   */
	
		}]);
	
		function WebCryptoWrapper() {
			_classCallCheck(this, WebCryptoWrapper);
	
			var subtle = WebCryptoWrapper.getSubtle();
	
			if (!subtle) {
				// please note: if subtle exists, but is not supported, say, because of insecure-origin
				// policy this will not throw.
				throw new Error('WebCryptoWrapper: no WebCrypto implementation available');
			}
	
			this.crypto = subtle;
		}
	
		_createClass(WebCryptoWrapper, [{
			key: 'importKey',
			value: function importKey(format, keyData, algo, extractable, usages) {
				try {
					if (keyData.length !== 16) {
						throw new Error('WebCryptoWrapper.importKey, invalid key length ' + keyData.length);
					}
	
					return this.crypto.importKey(format, keyData, algo, extractable, usages);
				} catch (err) {
					return Promise.reject(err);
				}
			}
		}, {
			key: 'decrypt',
			value: function decrypt(algorithm, key, data) {
				try {
					if (data.byteLength % 16 !== 0) {
						throw new Error('WebCryptoWrapper.decrypt, data.byteLength must be modulo-16 ' + data.byteLength);
					}
	
					return this.crypto.decrypt(algorithm, key, data);
				} catch (err) {
					return Promise.reject(err);
				}
			}
		}, {
			key: 'encrypt',
			value: function encrypt(algorithm, key, data) {
				try {
					return this.crypto.encrypt(algorithm, key, data);
				} catch (err) {
					return Promise.reject(err);
				}
			}
		}]);
	
		return WebCryptoWrapper;
	}();
	
	exports.default = WebCryptoWrapper;
	module.exports = exports['default'];

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint-disable */
	
	var _ArrayHelper = __webpack_require__(21);
	
	var _ArrayHelper2 = _interopRequireDefault(_ArrayHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AESDecryptor = function () {
	  function AESDecryptor() {
	    _classCallCheck(this, AESDecryptor);
	
	    // Static after running initTable
	    this.rcon = [0x0, 0x1, 0x2, 0x4, 0x8, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36];
	    this.subMix = [new Uint32Array(256), new Uint32Array(256), new Uint32Array(256), new Uint32Array(256)];
	    this.invSubMix = [new Uint32Array(256), new Uint32Array(256), new Uint32Array(256), new Uint32Array(256)];
	    this.sBox = new Uint32Array(256);
	    this.invSBox = new Uint32Array(256);
	
	    // Changes during runtime
	    this.key = new Uint32Array(0);
	
	    this.initTable();
	  }
	
	  // Using view.getUint32() also swaps the byte order.
	
	
	  _createClass(AESDecryptor, [{
	    key: 'uint8ArrayToUint32Array_',
	    value: function uint8ArrayToUint32Array_(blockArray) {
	      var view = new DataView(blockArray.buffer, blockArray.byteOffset, blockArray.byteLength);
	      var newArray = new Uint32Array(4);
	      for (var i = 0; i < 4; i++) {
	        newArray[i] = view.getUint32(i * 4);
	      }
	      return newArray;
	    }
	  }, {
	    key: 'initTable',
	    value: function initTable() {
	      var sBox = this.sBox;
	      var invSBox = this.invSBox;
	      var subMix = this.subMix;
	      var subMix0 = subMix[0];
	      var subMix1 = subMix[1];
	      var subMix2 = subMix[2];
	      var subMix3 = subMix[3];
	      var invSubMix = this.invSubMix;
	      var invSubMix0 = invSubMix[0];
	      var invSubMix1 = invSubMix[1];
	      var invSubMix2 = invSubMix[2];
	      var invSubMix3 = invSubMix[3];
	
	      var d = new Uint32Array(256);
	      var x = 0;
	      var xi = 0;
	      var i = 0;
	      for (i = 0; i < 256; i++) {
	        if (i < 128) {
	          d[i] = i << 1;
	        } else {
	          d[i] = i << 1 ^ 0x11b;
	        }
	      }
	
	      for (i = 0; i < 256; i++) {
	        var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
	        sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
	        sBox[x] = sx;
	        invSBox[sx] = x;
	
	        // Compute multiplication
	        var x2 = d[x];
	        var x4 = d[x2];
	        var x8 = d[x4];
	
	        // Compute sub/invSub bytes, mix columns tables
	        var t = d[sx] * 0x101 ^ sx * 0x1010100;
	        subMix0[x] = t << 24 | t >>> 8;
	        subMix1[x] = t << 16 | t >>> 16;
	        subMix2[x] = t << 8 | t >>> 24;
	        subMix3[x] = t;
	
	        // Compute inv sub bytes, inv mix columns tables
	        t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
	        invSubMix0[sx] = t << 24 | t >>> 8;
	        invSubMix1[sx] = t << 16 | t >>> 16;
	        invSubMix2[sx] = t << 8 | t >>> 24;
	        invSubMix3[sx] = t;
	
	        // Compute next counter
	        if (!x) {
	          x = xi = 1;
	        } else {
	          x = x2 ^ d[d[d[x8 ^ x2]]];
	          xi ^= d[d[xi]];
	        }
	      }
	    }
	
	    /**
	     * returns a cryptoKey which must be passed to decrypt
	     */
	
	  }, {
	    key: 'expandKey',
	    value: function expandKey(keyBuffer) {
	      var theKey = {};
	
	      // convert keyBuffer to Uint32Array
	      var key = this.uint8ArrayToUint32Array_(keyBuffer);
	
	      var keySize = theKey.keySize = key.length;
	
	      if (keySize !== 4 && keySize !== 6 && keySize !== 8) {
	        throw new Error('Invalid aes key size=' + keySize);
	      }
	
	      var ksRows = theKey.ksRows = (keySize + 6 + 1) * 4;
	      var ksRow = void 0;
	      var invKsRow = void 0;
	
	      var keySchedule = theKey.keySchedule = new Uint32Array(ksRows);
	      var invKeySchedule = theKey.invKeySchedule = new Uint32Array(ksRows);
	      var sbox = this.sBox;
	      var rcon = this.rcon;
	
	      var invSubMix = this.invSubMix;
	      var invSubMix0 = invSubMix[0];
	      var invSubMix1 = invSubMix[1];
	      var invSubMix2 = invSubMix[2];
	      var invSubMix3 = invSubMix[3];
	
	      var prev = void 0;
	      var t = void 0;
	
	      for (ksRow = 0; ksRow < ksRows; ksRow++) {
	        if (ksRow < keySize) {
	          prev = keySchedule[ksRow] = key[ksRow];
	          continue;
	        }
	        t = prev;
	
	        if (ksRow % keySize === 0) {
	          // Rot word
	          t = t << 8 | t >>> 24;
	
	          // Sub word
	          t = sbox[t >>> 24] << 24 | sbox[t >>> 16 & 0xff] << 16 | sbox[t >>> 8 & 0xff] << 8 | sbox[t & 0xff];
	
	          // Mix Rcon
	          t ^= rcon[ksRow / keySize | 0] << 24;
	        } else if (keySize > 6 && ksRow % keySize === 4) {
	          // Sub word
	          t = sbox[t >>> 24] << 24 | sbox[t >>> 16 & 0xff] << 16 | sbox[t >>> 8 & 0xff] << 8 | sbox[t & 0xff];
	        }
	
	        keySchedule[ksRow] = prev = (keySchedule[ksRow - keySize] ^ t) >>> 0;
	      }
	
	      for (invKsRow = 0; invKsRow < ksRows; invKsRow++) {
	        ksRow = ksRows - invKsRow;
	        if (invKsRow & 3) {
	          t = keySchedule[ksRow];
	        } else {
	          t = keySchedule[ksRow - 4];
	        }
	
	        if (invKsRow < 4 || ksRow <= 4) {
	          invKeySchedule[invKsRow] = t;
	        } else {
	          invKeySchedule[invKsRow] = invSubMix0[sbox[t >>> 24]] ^ invSubMix1[sbox[t >>> 16 & 0xff]] ^ invSubMix2[sbox[t >>> 8 & 0xff]] ^ invSubMix3[sbox[t & 0xff]];
	        }
	
	        invKeySchedule[invKsRow] = invKeySchedule[invKsRow] >>> 0;
	      }
	
	      return theKey;
	    }
	
	    // Adding this as a method greatly improves performance.
	
	  }, {
	    key: 'networkToHostOrderSwap',
	    value: function networkToHostOrderSwap(word) {
	      return word << 24 | (word & 0xff00) << 8 | (word & 0xff0000) >> 8 | word >>> 24;
	    }
	  }, {
	    key: 'decrypt',
	    value: function decrypt(key, inputArray, aesIV) {
	
	      var nRounds = key.keySize + 6;
	      var invKeySchedule = key.invKeySchedule;
	      var invSBOX = this.invSBox;
	
	      var invSubMix = this.invSubMix;
	      var invSubMix0 = invSubMix[0];
	      var invSubMix1 = invSubMix[1];
	      var invSubMix2 = invSubMix[2];
	      var invSubMix3 = invSubMix[3];
	
	      var initVector = this.uint8ArrayToUint32Array_(aesIV);
	      var initVector0 = initVector[0];
	      var initVector1 = initVector[1];
	      var initVector2 = initVector[2];
	      var initVector3 = initVector[3];
	
	      // casts ArrayBuffer -> Uint8Array
	      var inputUint8 = _ArrayHelper2.default.makeUint8Array(inputArray);
	
	      var inputInt32 = new Int32Array(inputUint8.buffer, inputUint8.byteOffset, inputUint8.byteLength >> 2);
	      var outputInt32 = new Int32Array(inputInt32.length);
	
	      var t0 = void 0,
	          t1 = void 0,
	          t2 = void 0,
	          t3 = void 0;
	      var s0 = void 0,
	          s1 = void 0,
	          s2 = void 0,
	          s3 = void 0;
	      var inputWords0 = void 0,
	          inputWords1 = void 0,
	          inputWords2 = void 0,
	          inputWords3 = void 0;
	
	      var ksRow, i;
	      var swapWord = this.networkToHostOrderSwap;
	
	      var offset = 0;
	      while (offset < inputInt32.length) {
	        inputWords0 = swapWord(inputInt32[offset]);
	        inputWords1 = swapWord(inputInt32[offset + 1]);
	        inputWords2 = swapWord(inputInt32[offset + 2]);
	        inputWords3 = swapWord(inputInt32[offset + 3]);
	
	        s0 = inputWords0 ^ invKeySchedule[0];
	        s1 = inputWords3 ^ invKeySchedule[1];
	        s2 = inputWords2 ^ invKeySchedule[2];
	        s3 = inputWords1 ^ invKeySchedule[3];
	
	        ksRow = 4;
	
	        // Iterate through the rounds of decryption
	        for (i = 1; i < nRounds; i++) {
	          t0 = invSubMix0[s0 >>> 24] ^ invSubMix1[s1 >> 16 & 0xff] ^ invSubMix2[s2 >> 8 & 0xff] ^ invSubMix3[s3 & 0xff] ^ invKeySchedule[ksRow];
	          t1 = invSubMix0[s1 >>> 24] ^ invSubMix1[s2 >> 16 & 0xff] ^ invSubMix2[s3 >> 8 & 0xff] ^ invSubMix3[s0 & 0xff] ^ invKeySchedule[ksRow + 1];
	          t2 = invSubMix0[s2 >>> 24] ^ invSubMix1[s3 >> 16 & 0xff] ^ invSubMix2[s0 >> 8 & 0xff] ^ invSubMix3[s1 & 0xff] ^ invKeySchedule[ksRow + 2];
	          t3 = invSubMix0[s3 >>> 24] ^ invSubMix1[s0 >> 16 & 0xff] ^ invSubMix2[s1 >> 8 & 0xff] ^ invSubMix3[s2 & 0xff] ^ invKeySchedule[ksRow + 3];
	          // Update state
	          s0 = t0;
	          s1 = t1;
	          s2 = t2;
	          s3 = t3;
	
	          ksRow = ksRow + 4;
	        }
	
	        // Shift rows, sub bytes, add round key
	        t0 = invSBOX[s0 >>> 24] << 24 ^ invSBOX[s1 >> 16 & 0xff] << 16 ^ invSBOX[s2 >> 8 & 0xff] << 8 ^ invSBOX[s3 & 0xff] ^ invKeySchedule[ksRow];
	        t1 = invSBOX[s1 >>> 24] << 24 ^ invSBOX[s2 >> 16 & 0xff] << 16 ^ invSBOX[s3 >> 8 & 0xff] << 8 ^ invSBOX[s0 & 0xff] ^ invKeySchedule[ksRow + 1];
	        t2 = invSBOX[s2 >>> 24] << 24 ^ invSBOX[s3 >> 16 & 0xff] << 16 ^ invSBOX[s0 >> 8 & 0xff] << 8 ^ invSBOX[s1 & 0xff] ^ invKeySchedule[ksRow + 2];
	        t3 = invSBOX[s3 >>> 24] << 24 ^ invSBOX[s0 >> 16 & 0xff] << 16 ^ invSBOX[s1 >> 8 & 0xff] << 8 ^ invSBOX[s2 & 0xff] ^ invKeySchedule[ksRow + 3];
	        ksRow = ksRow + 3;
	
	        // Write
	        outputInt32[offset] = swapWord(t0 ^ initVector0);
	        outputInt32[offset + 1] = swapWord(t3 ^ initVector1);
	        outputInt32[offset + 2] = swapWord(t2 ^ initVector2);
	        outputInt32[offset + 3] = swapWord(t1 ^ initVector3);
	
	        // reset initVector to last 4 unsigned int
	        initVector0 = inputWords0;
	        initVector1 = inputWords1;
	        initVector2 = inputWords2;
	        initVector3 = inputWords3;
	
	        offset = offset + 4;
	      }
	
	      return _ArrayHelper2.default.makeUint8Array(outputInt32);
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      this.key = undefined;
	      this.keySize = undefined;
	      this.ksRows = undefined;
	
	      this.sBox = undefined;
	      this.invSBox = undefined;
	      this.subMix = undefined;
	      this.invSubMix = undefined;
	      this.keySchedule = undefined;
	      this.invKeySchedule = undefined;
	
	      this.rcon = undefined;
	    }
	  }]);
	
	  return AESDecryptor;
	}();
	
	exports.default = AESDecryptor;
	module.exports = exports['default'];

/***/ }),
/* 114 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**  DrmUtils.
	 *   Utilities used by the Drm functionality
	 */
	
	/**
	 * @access internal
	 */
	var DrmUtils = function () {
		function DrmUtils() {
			_classCallCheck(this, DrmUtils);
		}
	
		_createClass(DrmUtils, null, [{
			key: 'stringToArray8',
	
	
			// converts string to Uint8Array (wide chars)
			// better not be used for complex characters sets!
			value: function stringToArray8(string) {
				var buffer = new ArrayBuffer(string.length);
				var array = new Uint8Array(buffer);
				for (var i = 0, strLen = string.length; i < strLen; i++) {
					array[i] = string.charCodeAt(i);
				}
	
				return array;
			}
	
			// converts string to Uint16Array (wide chars)
	
		}, {
			key: 'stringToArray16',
			value: function stringToArray16(string) {
				var buffer = new ArrayBuffer(string.length * 2); // 2 bytes for each char
				var array = new Uint16Array(buffer);
				for (var i = 0, strLen = string.length; i < strLen; i++) {
					array[i] = string.charCodeAt(i);
				}
				return array;
			}
	
			// converts a 16 or 8 bit array of wide characters to a string
	
		}, {
			key: 'wideArrayToString',
			value: function wideArrayToString(array) {
				var uint16array = new Uint16Array(array.buffer);
				return String.fromCharCode.apply(null, uint16array);
			}
	
			// converts a 16 or 8 bit array to a string, does not cast to wide.
	
		}, {
			key: 'arrayToString',
			value: function arrayToString(array) {
				var uint16array = new Uint16Array(array);
				return String.fromCharCode.apply(null, uint16array);
			}
	
			// wraps a naked playready license request as a PlayReadyObject with headers that the 3.2 era DRM expects (and MS platforms deliver)
			// used by Tizen etc
	
		}, {
			key: 'wrapPlayReadyChallengeAsPlayReadyObjectUcs16',
			value: function wrapPlayReadyChallengeAsPlayReadyObjectUcs16(data) {
				var playReadyObjectHeader = '<PlayReadyKeyMessage type="LicenseAcquisition"><LicenseAcquisition Version="1"><Challenge encoding="base64encoded">';
				var playReadyObjectFooter = '</Challenge><HttpHeaders><HttpHeader><name>Content-Type</name><value>text/xml; charset=utf-8</value></HttpHeader><HttpHeader><name>SOAPAction</name><value>"http://schemas.microsoft.com/DRM/2007/03/protocols/AcquireLicense"</value></HttpHeader></HttpHeaders></LicenseAcquisition></PlayReadyKeyMessage>';
	
				// data is Uint8Array of character bytes, as would be sent to the license server.
	
				// convert to string
				var dataString = String.fromCharCode.apply(null, data);
	
				// base64 encode
				var dataB64 = btoa(dataString);
	
				// wrap in PlayReadyObject header/footer
				var playReadyObjectString = playReadyObjectHeader + dataB64 + playReadyObjectFooter;
	
				// convert to UCS16
				var data16 = DrmUtils.stringToArray16(playReadyObjectString);
	
				// pack as Uint8Array
				var data8 = new Uint8Array(data16.buffer);
	
				return data8;
			}
		}]);
	
		return DrmUtils;
	}();
	
	exports.default = DrmUtils;
	module.exports = exports['default'];

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _logger = __webpack_require__(1);
	
	var _EME2 = __webpack_require__(40);
	
	var _EME3 = _interopRequireDefault(_EME2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LegacyEME = function (_EME) {
		_inherits(LegacyEME, _EME);
	
		function LegacyEME(hls, keySystem, obtainKeySystemConfigCallback, video, totalSessions) {
			_classCallCheck(this, LegacyEME);
	
			_logger.logger.log('LegacyEME: constructor');
	
			var _this = _possibleConstructorReturn(this, (LegacyEME.__proto__ || Object.getPrototypeOf(LegacyEME)).call(this, hls, keySystem, obtainKeySystemConfigCallback, totalSessions));
	
			_this._options = null;
			_this._ensurePromise = null;
			_this._video = video;
			_this._sessions = [];
	
			_this._mediaKeys = window.WebKitMediaKeys || window.MSMediaKeys || window.WEBKITMediaKeys;
	
			if (_this._mediaKeys === window.MSMediaKeys) {
				_this._prefix = 'ms';
				//this._mediaKeys = window.MSMediaKeys;
			} else if (_this._mediaKeys === window.WebKitMediaKeys || window.WEBKITMediaKeys) {
				_this._prefix = 'webkit';
				//this._mediaKeys = window.WebKitMediaKeys;
			} else {
				_this.onError({ message: 'no legacy mediaKeys object found' });
			}
	
			_this.needkey = _this.onNeedKey.bind(_this);
			_this.keymessage = _this.onKeyMessage.bind(_this);
			_this.keyerror = _this.onKeyError.bind(_this);
			_this.keyadded = _this.onKeyAdded.bind(_this);
	
			_this._video.addEventListener(_this._prefix + 'needkey', _this.needkey);
			return _this;
		}
	
		_createClass(LegacyEME, [{
			key: 'dispose',
			value: function dispose() {
				if (this._video) {
					this._video.removeEventListener(this._prefix + 'needkey', this.needkey);
					this._video = null;
				}
	
				while (this._sessions.length > 0) {
					var session = this._sessions.shift();
					session.removeEventListener(this._prefix + 'keymessage', this.keymessage);
					session.removeEventListener(this._prefix + 'keyerror', this.keyerror);
					session.removeEventListener(this._prefix + 'keyadded', this.keyadded);
				}
	
				this._options = null;
			}
		}, {
			key: 'setOptions',
			value: function setOptions(options) {
				this._options = options;
			}
		}, {
			key: 'onKeyMessage',
			value: function onKeyMessage(event) {
				var strMessage = String.fromCharCode.apply(null, event.message);
	
				_logger.logger.log('createSession: keyMessage');
	
				if (strMessage === 'certificate') {
					_logger.logger.log('createSession: obtainCertificate');
					this.obtainCertificate(event);
				} else {
					_logger.logger.log('createSession: obtainLicense');
					this.obtainLicense(event);
				}
			}
		}, {
			key: 'onKeyError',
			value: function onKeyError(event) {
				this.onError(event);
			}
		}, {
			key: 'onKeyAdded',
			value: function onKeyAdded() /*event*/{
				_logger.logger.log('onKeyAdded: key added');
			}
		}, {
			key: 'createSession',
			value: function createSession(data, keys) {
				_logger.logger.log('createSession');
				var session = null;
				var initData = data;
	
				if (this._initData) {
					//TODO: extract the kid from the tenc atom
					//and lookup the kid in the initData map
					//alternatively we could just generate the initData directly from the tenc atom??
					initData = this._initData;
				}
	
				try {
					session = keys.createSession('video/mp4', initData);
					session.addEventListener(this._prefix + 'keymessage', this.keymessage);
					session.addEventListener(this._prefix + 'keyerror', this.keyerror);
					session.addEventListener(this._prefix + 'keyadded', this.keyadded);
					_logger.logger.log('createSession: session created');
				} catch (err) {
					_logger.logger.log('createSession: failed to create the session');
					this.onError(err);
				}
			}
		}, {
			key: 'onNeedKey',
			value: function onNeedKey(event) {
				if (!this._video.msKeys && !this._video.webkitKeys) {
					_logger.logger.log('onNeedKey');
					try {
						var keys = new this._mediaKeys(this.keySystem);
	
						if (keys) {
							if (this._prefix === 'ms') {
								this._video.msSetMediaKeys(keys);
							} else if (this._prefix === 'webkit') {
								this._video.webkitSetMediaKeys(keys);
							} else {
								this.onError({ message: 'unsupported keySystem ' + this.keySystem });
							}
	
							this.createSession(event.initData, this._video.msKeys ? this._video.msKeys : this._video.webkitKeys);
						} else {
							this.onError({ message: 'failed to create media keys' });
						}
					} catch (e) {
						this.onError(e);
					}
				}
			}
		}, {
			key: 'initData',
			set: function set(initData) {
				this._initData = initData;
			}
		}]);
	
		return LegacyEME;
	}(_EME3.default);
	
	exports.default = LegacyEME;
	module.exports = exports['default'];

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _errors = __webpack_require__(4);
	
	var _events = __webpack_require__(3);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _eventHandler = __webpack_require__(5);
	
	var _eventHandler2 = _interopRequireDefault(_eventHandler);
	
	var _EME = __webpack_require__(40);
	
	var _EME2 = _interopRequireDefault(_EME);
	
	var _KeySystems = __webpack_require__(35);
	
	var _KeySystems2 = _interopRequireDefault(_KeySystems);
	
	var _logger = __webpack_require__(1);
	
	var _LegacyEME = __webpack_require__(115);
	
	var _LegacyEME2 = _interopRequireDefault(_LegacyEME);
	
	var _ModernEME = __webpack_require__(117);
	
	var _ModernEME2 = _interopRequireDefault(_ModernEME);
	
	var _muxjs = __webpack_require__(44);
	
	var _muxjs2 = _interopRequireDefault(_muxjs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  EME wrapper.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *   Set up Encrypted Media Extensions
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var LicenseManager = function (_EventHandler) {
		_inherits(LicenseManager, _EventHandler);
	
		function LicenseManager(hls, obtainKeySystemConfigCallback) {
			_classCallCheck(this, LicenseManager);
	
			var _this = _possibleConstructorReturn(this, (LicenseManager.__proto__ || Object.getPrototypeOf(LicenseManager)).call(this, hls, _events2.default.MEDIA_ATTACHING, _events2.default.MEDIA_DETACHING, _events2.default.DESTROYING, _events2.default.BUFFER_CREATED));
	
			_this._obtainKeySystemConfigCallback = obtainKeySystemConfigCallback;
			return _this;
		}
	
		_createClass(LicenseManager, [{
			key: 'onMediaAttaching',
			value: function onMediaAttaching(data) {
				this._video = data.media;
			}
		}, {
			key: 'onDestroying',
			value: function onDestroying() {
				this._obtainKeySystemConfigCallback = null;
			}
		}, {
			key: 'onMediaDetaching',
			value: function onMediaDetaching() {
				if (this._drm) {
					this._drm.dispose();
				}
	
				this._drm = null;
				this._video = null;
			}
		}, {
			key: 'onLicenseManagerError',
			value: function onLicenseManagerError(err) {
				_logger.logger.error('license manager error: ' + err.message);
				if (this.hls) {
					this.hls.trigger(_events2.default.ERROR, {
						type: _errors.ErrorTypes.MEDIA_ERROR,
						details: _errors.ErrorDetails.DRM_ERROR,
						fatal: true,
						reason: err.message
					});
				}
			}
		}, {
			key: 'extractSkd',
			value: function extractSkd(levelkeys) {
				var i = void 0;
				var initData = null;
	
				if (levelkeys) {
					for (i = 0; i < levelkeys.length && initData === null; i++) {
						if (levelkeys[i].format === 'com.apple.streamingkeydelivery') {
							var str = levelkeys[i].reluri;
	
							var base64IndexStart = 6; //skd://
							var base64IndexEnd = str.indexOf(';');
	
							if (base64IndexEnd < 0) {
								base64IndexEnd = str.length;
							}
	
							var j = void 0;
							var base64 = str.substring(base64IndexStart, base64IndexEnd);
							initData = new Uint8Array(base64.length);
	
							for (j = 0; j < base64.length; j++) {
								initData[j] = base64.charCodeAt(j);
							}
						}
					}
				}
	
				return initData;
			}
		}, {
			key: 'hasSampleAes',
			value: function hasSampleAes(initFrag) {
				var hasSampleAes = false;
				var i = void 0;
	
				var frag = _muxjs2.default.mp4.tools.inspect(new Uint8Array(initFrag));
	
				/*
	   		//Need to implement this. muxjs.mp4.tools.inspect does not have full support for all these atoms.
	   		//For now we will look for the pssh box to determine encryption. We won't find a pssh box under Safari
	   		//so for now we will look for a stream type of enca or encv.
	   
	   		Protection scheme signaling conforms with ISO Base media File Format [BMFF]. When protection has been applied, the stream type will be
	   		transformed to 'encv' for video or 'enca' for audio, with a Protection Scheme Information Box ('sinf') added to the sample entry in the
	   		Sample Description Box ('stsd'). The Protection Scheme Information Box ('sinf') will contain a Scheme Type Box ('schm') with a scheme_type
	   		field set to a value of 'cenc' (Common Encryption).
	   		The "encrypted block" is a sample. Determining whether a sample is encrypted depends on the corresponding Track Encryption Box ('tenc') and the sample
	   		group with grouping type 'seig' (CencSampleEncryption group), if any, associated with the sample. The default encryption state of a sample is defined by
	   		the IsEncrypted flag in the associated track encryption box ('tenc'). This default state may be modified by the IsEncrypted flag in the
	   		SampleGroupDescriptionBox ('sgpd'), pointed to by an index in the SampleToGroupBox ('sbgp').
	   		Samples can be partially encrypted, specified by subsample information referenced by SampleAuxiliaryInformationSizesBox ('saiz')
	   		and SampleAuxiliaryInformationOffsetsBox ('saio') boxes.
	   */
	
				for (i = 0; i < frag.length && hasSampleAes === false; i++) {
					if (frag[i].type === 'moov') {
						var j = void 0;
						for (j = 0; j < frag[i].boxes.length && hasSampleAes === false; j++) {
							if (frag[i].boxes[j].type === 'pssh') {
								_logger.logger.log('hasSampleAes - pssh found');
								hasSampleAes = true;
							}
							//don't bother with all this if we are not Safari
							else if (this.hls.browSafari && frag[i].boxes[j].type === 'trak') {
									var k = void 0;
									for (k = 0; k < frag[i].boxes[j].boxes.length && hasSampleAes === false; k++) {
										if (frag[i].boxes[j].boxes[k].type === 'mdia') {
											var l = void 0;
											for (l = 0; l < frag[i].boxes[j].boxes[k].boxes.length && hasSampleAes === false; l++) {
												if (frag[i].boxes[j].boxes[k].boxes[l].type === 'minf') {
													var m = void 0;
													for (m = 0; m < frag[i].boxes[j].boxes[k].boxes[l].boxes.length && hasSampleAes === false; m++) {
														if (frag[i].boxes[j].boxes[k].boxes[l].boxes[m].type === 'stbl') {
															var n = void 0;
															for (n = 0; n < frag[i].boxes[j].boxes[k].boxes[l].boxes[m].boxes.length && hasSampleAes === false; n++) {
																if (frag[i].boxes[j].boxes[k].boxes[l].boxes[m].boxes[n].type === 'stsd') {
																	var sampleDescriptions = frag[i].boxes[j].boxes[k].boxes[l].boxes[m].boxes[n].sampleDescriptions;
																	if (sampleDescriptions) {
																		var o = void 0;
																		for (o = 0; o < sampleDescriptions.length && hasSampleAes === false; o++) {
																			if (sampleDescriptions[o].type === 'enca' || sampleDescriptions[o].type === 'encv') {
																				_logger.logger.log('hasSampleAes - sample description type: ' + sampleDescriptions[o].type);
																				hasSampleAes = true;
																			}
																		}
																	}
																}
															}
														}
													}
												}
											}
										}
									}
								}
						}
					}
				}
	
				return hasSampleAes;
			}
		}, {
			key: 'onBufferCreated',
			value: function onBufferCreated(data) {
				_logger.logger.log('LicenseManager onBufferCreated');
				var tracks = data.tracks;
				var encryptedCount = 0;
				var skd = null;
	
				if (!this._drm) {
					var options = [{
						initDataTypes: ['cenc']
					}];
	
					if (tracks.audio) {
						if (this.hasSampleAes(tracks.audio.initSegment)) {
							//change name of setOptions, it's confusing ... should be buildOptions/createOptions
							options = this.setOptions(tracks.audio, options);
	
							//this is a temp solution ... should really be building this from the tenc atom??
							//this relies on the skd being the same ... this will be overwritten in the next if block
							skd = this.extractSkd(tracks.audio.levelkeys);
	
							encryptedCount++;
						}
					}
	
					if (tracks.video) {
						if (this.hasSampleAes(tracks.video.initSegment)) {
							options = this.setOptions(tracks.video, options);
	
							//this is a temp solution ... should really be building this from the tenc atom??
							//this overwrites the previously set skd which is incorrect which means if the skd are different it will break
							//this really needs to be built from the tenc atom which is passed to us in onNeedKey (LegacyEME.js)
							skd = this.extractSkd(tracks.video.levelkeys);
	
							encryptedCount++;
						}
					}
	
					if (encryptedCount > 0) {
						if (window.navigator.requestMediaKeySystemAccess) {
							//need to factor in clearkey here by checking for identity key in the level manifest key tag
	
							if (this.hls.browEdge || this.hls.browTizen3) {
								_logger.logger.log('PlayReady ModernEME');
								this._drm = new _ModernEME2.default(this.hls, _KeySystems2.default.PLAYREADY, this._obtainKeySystemConfigCallback, this._video, encryptedCount);
							} else if (this.hls.browChrome || this.hls.browFirefox || this.hls.browTizen3) {
								_logger.logger.log('Widevine ModernEME');
								this._drm = new _ModernEME2.default(this.hls, _KeySystems2.default.WIDEVINE, this._obtainKeySystemConfigCallback, this._video, encryptedCount);
							} else {
								this.onLicenseManagerError({ message: 'unsupported browser' });
							}
						} else {
							if (this.hls.browIE || this.hls.browTizen2) {
								_logger.logger.log('PlayReady LegacyEME');
								this._drm = new _LegacyEME2.default(this.hls, _KeySystems2.default.PLAYREADY, this._obtainKeySystemConfigCallback, this._video, encryptedCount);
							} else if (this.hls.browSafari) {
								_logger.logger.log('FairPlay LegacyEME');
								this._drm = new _LegacyEME2.default(this.hls, _KeySystems2.default.FAIRPLAY, this._obtainKeySystemConfigCallback, this._video, encryptedCount);
							} else {
								this.onLicenseManagerError({ message: 'unsupported browser' });
							}
						}
	
						if (this._drm) {
							this._drm.setOptions(options);
							var keySystem = this._drm.keySystemName;
	
							//this will not work when multiple keys are in play
							//we would need to have a map based on the kid, then we would need to parse the tenc atom from the initSegment passed to us in onNeedKey
							//then we would have to extract the kid from that and then pull out the correct asset id from the generated map
							if (keySystem === _KeySystems2.default.FAIRPLAY) {
								this._drm.initData = skd;
							}
	
							//data - pass in data here and extract the relrui internally, we can also add the initData injection with a legacyEME derived function
							this._drm.setKeySystemConfig(null);
						}
					}
				}
			}
		}, {
			key: 'setOptions',
			value: function setOptions(data, options) {
				var newOptions = options;
	
				if (data.container === 'audio/mp4') {
					var audioContentType = data.container;
	
					if (data.codec) {
						audioContentType += '; codecs="' + data.codec + '"';
					}
	
					newOptions[0].audioCapabilities = [{
						contentType: audioContentType
					}];
				} else if (data.container === 'video/mp4') {
					var videoContentType = data.container;
	
					if (data.codec) {
						videoContentType += '; codecs="' + data.codec + '"';
					}
	
					newOptions[0].videoCapabilities = [{
						contentType: videoContentType
					}];
				}
	
				return newOptions;
			}
		}, {
			key: 'drmCapabilities',
			get: function get() {
				return _EME2.default.capabilities;
			}
		}]);
	
		return LicenseManager;
	}(_eventHandler2.default);
	
	exports.default = LicenseManager;
	module.exports = exports['default'];

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _logger = __webpack_require__(1);
	
	var _EME2 = __webpack_require__(40);
	
	var _EME3 = _interopRequireDefault(_EME2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModernEME = function (_EME) {
		_inherits(ModernEME, _EME);
	
		function ModernEME(hls, keySystem, obtainKeySystemConfigCallback, video, totalSessions) {
			_classCallCheck(this, ModernEME);
	
			_logger.logger.log('ModernEME: constructor');
	
			var _this = _possibleConstructorReturn(this, (ModernEME.__proto__ || Object.getPrototypeOf(ModernEME)).call(this, hls, keySystem, obtainKeySystemConfigCallback, totalSessions));
	
			_this._options = null;
			_this._ensurePromise = null;
			_this._video = video;
			_this._sessions = [];
			_this.encrypted = _this.onEncrypted.bind(_this);
			_this.message = _this.obtainLicense.bind(_this);
			_this._video.addEventListener('encrypted', _this.encrypted);
			return _this;
		}
	
		_createClass(ModernEME, [{
			key: 'setOptions',
			value: function setOptions(options) {
				this._options = options;
			}
		}, {
			key: 'dispose',
			value: function dispose() {
				var _this2 = this;
	
				if (this._video) {
					this._video.removeEventListener('encrypted', this.encrypted);
					this._video = null;
				}
	
				var _loop = function _loop() {
					var session = _this2._sessions.shift();
					session.removeEventListener('message', _this2.message);
	
					session.close().then(function () {
						_logger.logger.log('dispose: media key session closed');
						session.remove().then(function () {
							_logger.logger.log('dispose: media key session removed');
						}).catch(function () {
							_logger.logger.log('dispose: failed to remove the media key session');
						});
					}).catch(function () {
						_logger.logger.log('dispose: failed to close the media key session');
					});
				};
	
				while (this._sessions.length > 0) {
					_loop();
				}
	
				this._options = null;
			}
		}, {
			key: 'ensureMediaKeysCreated',
			value: function ensureMediaKeysCreated() {
				var _this3 = this;
	
				// We may already have a MediaKeys object if we initialized EME for a
				// different MSE SourceBuffer's "encrypted" event, or the initialization
				// may still be in progress.
				if (this._ensurePromise) {
					_logger.logger.log('ensureMediaKeysCreated: media keys already created');
					return this._ensurePromise;
				}
	
				this._ensurePromise = navigator.requestMediaKeySystemAccess(this._keySystem, this._options).then(function (keySystemAccess) {
					_logger.logger.log('ensureMediaKeysCreated: createMediaKeys');
					return keySystemAccess.createMediaKeys();
				}).then(function (mediaKeys) {
					if (!_this3._video.mediaKeys) {
						_logger.logger.log('ensureMediaKeysCreated: setMediaKeys');
						return _this3._video.setMediaKeys(mediaKeys);
					} else {
						_logger.logger.log('ensureMediaKeysCreated: media keys already set');
						return _this3._video.mediaKeys;
					}
				}).catch(function (err) {
					_this3.onError(err);
				});
	
				return this._ensurePromise;
			}
		}, {
			key: 'onEncrypted',
			value: function onEncrypted(event) {
				var _this4 = this;
	
				if (this._sessions.length < this._totalSessions) {
					this.ensureMediaKeysCreated().then(function () {
						_logger.logger.log('onEncrypted: createSession');
						var session = _this4._video.mediaKeys.createSession();
						//session.addEventListener("keystatuseschange", KeysChange);
						session.addEventListener('message', _this4.message);
						_this4._sessions.push(session);
	
						return session.generateRequest(event.initDataType, event.initData);
					}).then(function () {
						_logger.logger.log('onEncrypted: generated request');
					}).catch(function (err) {
						_this4.onError(err);
					});
				}
			}
		}]);
	
		return ModernEME;
	}(_EME3.default);
	
	exports.default = ModernEME;
	module.exports = exports['default'];

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * HLS config
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	      value: true
	});
	exports.hlsDefaultConfig = undefined;
	
	var _abrController = __webpack_require__(119);
	
	var _abrController2 = _interopRequireDefault(_abrController);
	
	var _bufferController = __webpack_require__(122);
	
	var _bufferController2 = _interopRequireDefault(_bufferController);
	
	var _capLevelController = __webpack_require__(123);
	
	var _capLevelController2 = _interopRequireDefault(_capLevelController);
	
	var _fpsController = __webpack_require__(124);
	
	var _fpsController2 = _interopRequireDefault(_fpsController);
	
	var _xhrLoader = __webpack_require__(142);
	
	var _xhrLoader2 = _interopRequireDefault(_xhrLoader);
	
	var _audioTrackController = __webpack_require__(121);
	
	var _audioTrackController2 = _interopRequireDefault(_audioTrackController);
	
	var _audioStreamController = __webpack_require__(120);
	
	var _audioStreamController2 = _interopRequireDefault(_audioStreamController);
	
	var _cues = __webpack_require__(137);
	
	var _cues2 = _interopRequireDefault(_cues);
	
	var _timelineController = __webpack_require__(130);
	
	var _timelineController2 = _interopRequireDefault(_timelineController);
	
	var _subtitleTrackController = __webpack_require__(129);
	
	var _subtitleTrackController2 = _interopRequireDefault(_subtitleTrackController);
	
	var _subtitleStreamController = __webpack_require__(128);
	
	var _subtitleStreamController2 = _interopRequireDefault(_subtitleStreamController);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//#endif
	
	//#endif
	
	//#if subtitle
	
	//import FetchLoader from './utils/fetch-loader';
	//#if altaudio
	var hlsDefaultConfig = exports.hlsDefaultConfig = {
	      autoStartLoad: true, // used by stream-controller
	      startPosition: -1, // used by stream-controller
	      defaultAudioCodec: undefined, // used by stream-controller
	      debug: false, // used by logger
	      capLevelOnFPSDrop: false, // used by fps-controller
	      capLevelToPlayerSize: false, // used by cap-level-controller
	      initialLiveManifestSize: 1, // used by stream-controller
	      maxBufferLength: 30, // used by stream-controller
	      maxBufferSize: 60 * 1000 * 1000, // used by stream-controller
	      maxBufferHole: 0.5, // used by stream-controller
	      maxSeekHole: 2, // used by stream-controller
	      lowBufferWatchdogPeriod: 0.5, // used by stream-controller
	      highBufferWatchdogPeriod: 3, // used by stream-controller
	      nudgeOffset: 0.1, // used by stream-controller
	      nudgeMaxRetry: 3, // used by stream-controller
	      /*
	         maxFragLookUpTolerance: 0.2,            // used by stream-controller
	      */
	      maxFragLookUpTolerance: 0, //Mactrix line changed, disable frag tolerance test to stop HlsJs creating buffer holes/overriding frame accurate seeks
	      liveSyncDurationCount: 3, // used by stream-controller
	      liveMaxLatencyDurationCount: Infinity, // used by stream-controller
	      liveSyncDuration: undefined, // used by stream-controller
	      liveMaxLatencyDuration: undefined, // used by stream-controller
	      maxMaxBufferLength: 60, // used by stream-controller
	      enableWorker: true, // used by demuxer
	      enableSoftwareAES: true, // used by decrypter
	      manifestLoadingTimeOut: 10000, // used by playlist-loader
	      manifestLoadingMaxRetry: 1, // used by playlist-loader
	      manifestLoadingRetryDelay: 1000, // used by playlist-loader
	      manifestLoadingMaxRetryTimeout: 64000, // used by playlist-loader
	      startLevel: undefined, // used by level-controller
	      levelLoadingTimeOut: 10000, // used by playlist-loader
	      levelLoadingMaxRetry: 4, // used by playlist-loader
	      levelLoadingRetryDelay: 1000, // used by playlist-loader
	      levelLoadingMaxRetryTimeout: 64000, // used by playlist-loader
	      fragLoadingTimeOut: 20000, // used by fragment-loader
	      fragLoadingMaxRetry: 2, // used by fragment-loader
	      fragLoadingRetryDelay: 1000, // used by fragment-loader
	      fragLoadingMaxRetryTimeout: 10000, // used by fragment-loader
	      fragLoadingLoopThreshold: 3, // used by stream-controller
	      startFragPrefetch: false, // used by stream-controller
	      fpsDroppedMonitoringPeriod: 5000, // used by fps-controller
	      fpsDroppedMonitoringThreshold: 0.2, // used by fps-controller
	      appendErrorMaxRetry: 3, // used by buffer-controller
	      loader: _xhrLoader2.default,
	      //loader: FetchLoader,
	      fLoader: undefined,
	      pLoader: undefined,
	      xhrSetup: undefined,
	      fetchSetup: undefined,
	      abrController: _abrController2.default,
	      bufferController: _bufferController2.default,
	      capLevelController: _capLevelController2.default,
	      fpsController: _fpsController2.default,
	      //#if altaudio
	      audioStreamController: _audioStreamController2.default,
	      audioTrackController: _audioTrackController2.default,
	      //#endif
	      //#if subtitle
	      subtitleStreamController: _subtitleStreamController2.default,
	      subtitleTrackController: _subtitleTrackController2.default,
	      timelineController: _timelineController2.default,
	      cueHandler: _cues2.default,
	      enableCEA708Captions: true, // used by timeline-controller
	      enableWebVTT: true, // used by timeline-controller
	      captionsTextTrack1Label: 'English', // used by timeline-controller
	      captionsTextTrack1LanguageCode: 'en', // used by timeline-controller
	      captionsTextTrack2Label: 'Spanish', // used by timeline-controller
	      captionsTextTrack2LanguageCode: 'es', // used by timeline-controller
	      //#endif
	      stretchShortVideoTrack: false, // used by mp4-remuxer
	      forceKeyFrameOnDiscontinuity: true, // used by ts-demuxer
	      abrEwmaFastLive: 3, // used by abr-controller
	      abrEwmaSlowLive: 9, // used by abr-controller
	      abrEwmaFastVoD: 3, // used by abr-controller
	      abrEwmaSlowVoD: 9, // used by abr-controller
	      abrEwmaDefaultEstimate: 5e5, // 500 kbps  // used by abr-controller
	      abrBandWidthFactor: 0.95, // used by abr-controller
	      abrBandWidthUpFactor: 0.7, // used by abr-controller
	      abrMaxWithRealBitrate: false, // used by abr-controller
	      maxStarvationDelay: 4, // used by abr-controller
	      maxLoadingDelay: 4, // used by abr-controller
	
	      //Mactrix additions start
	      browChrome: undefined,
	      browEdge: undefined,
	      browIE: undefined,
	      browFirefox: undefined,
	      browSafari: undefined,
	      browOpera: undefined,
	      browAndroid: undefined,
	      browTizen2: undefined,
	      browTizen3: undefined,
	      browDetected: undefined,
	      enableMuxJs: true,
	      nudgeOnStall: false,
	      decryptOutsideWebworker: false,
	      streamTimeOut: 30000,
	      //Mactrix additions end
	
	      minAutoBitrate: 0 // used by hls
	};

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _events = __webpack_require__(3);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _eventHandler = __webpack_require__(5);
	
	var _eventHandler2 = _interopRequireDefault(_eventHandler);
	
	var _bufferHelper = __webpack_require__(22);
	
	var _bufferHelper2 = _interopRequireDefault(_bufferHelper);
	
	var _errors = __webpack_require__(4);
	
	var _logger = __webpack_require__(1);
	
	var _ewmaBandwidthEstimator = __webpack_require__(138);
	
	var _ewmaBandwidthEstimator2 = _interopRequireDefault(_ewmaBandwidthEstimator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * simple ABR Controller
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  - compute next level based on last fragment bw heuristics
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  - implement an abandon rules triggered if we have less than 2 frag buffered and if computed bw shows that we risk buffer stalling
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var AbrController = function (_EventHandler) {
		_inherits(AbrController, _EventHandler);
	
		function AbrController(hls) {
			_classCallCheck(this, AbrController);
	
			var _this = _possibleConstructorReturn(this, (AbrController.__proto__ || Object.getPrototypeOf(AbrController)).call(this, hls, _events2.default.FRAG_LOADING, _events2.default.FRAG_LOADED, _events2.default.FRAG_BUFFERED, _events2.default.ERROR));
	
			_this.lastLoadedFragLevel = 0;
			_this._nextAutoLevel = -1;
			_this.hls = hls;
			_this.onCheck = _this._abandonRulesCheck.bind(_this);
			_this.latency = 0;
			return _this;
		}
	
		_createClass(AbrController, [{
			key: 'destroy',
			value: function destroy() {
				this.clearTimer();
				_eventHandler2.default.prototype.destroy.call(this);
				//Mactrix additions start
				//memory cleanup
				this.onCheck = null;
				if (this._bwEstimator) {
					this._bwEstimator.destroy();
					this._bwEstimator = null;
				}
				this.fragCurrent = null;
				//this.hls = null;
				//Mactrix additions end
			}
		}, {
			key: 'onFragLoading',
			value: function onFragLoading(data) {
				var frag = data.frag;
				if (frag.type === 'main') {
					if (!this.timer) {
						this.timer = setInterval(this.onCheck, 100);
					}
	
					// lazy init of bw Estimator, rationale is that we use different params for Live/VoD
					// so we need to wait for stream manifest / playlist type to instantiate it.
					if (!this._bwEstimator) {
						var hls = this.hls;
						var level = data.frag.level;
						var isLive = hls.levels[level].details.live;
						var config = hls.config;
						var ewmaFast = void 0;
						var ewmaSlow = void 0;
	
						if (isLive) {
							ewmaFast = config.abrEwmaFastLive;
							ewmaSlow = config.abrEwmaSlowLive;
						} else {
							ewmaFast = config.abrEwmaFastVoD;
							ewmaSlow = config.abrEwmaSlowVoD;
						}
						this._bwEstimator = new _ewmaBandwidthEstimator2.default(hls, ewmaSlow, ewmaFast, config.abrEwmaDefaultEstimate);
					}
					this.fragCurrent = frag;
				}
			}
		}, {
			key: '_abandonRulesCheck',
			value: function _abandonRulesCheck() {
				/*
	   	monitor fragment retrieval time...
	   	we compute expected time of arrival of the complete fragment.
	   	we compare it to expected time of buffer starvation
	   */
				var hls = this.hls;
				var v = hls.media;
				var frag = this.fragCurrent;
				var loader = frag.loader;
				var minAutoLevel = hls.minAutoLevel;
	
				// if loader has been destroyed or loading has been aborted, stop timer and return
				if (!loader || loader.stats && loader.stats.aborted) {
					//logger.warn('frag loader destroy or aborted, disarm abandonRules');
					this.clearTimer();
					return;
				}
				var stats = loader.stats;
	
				/*
	   	only monitor frag retrieval time if (video not paused OR first fragment being
	   	loaded(ready state === HAVE_NOTHING = 0)) AND autoswitching enabled AND not lowest
	   	level (=> means that we have several levels)
	   */
				if (v && (!v.paused && v.playbackRate !== 0 || !v.readyState) && frag.autoLevel && frag.level > minAutoLevel && stats.tfirst) {
					var requestDelay = performance.now() - stats.tfirst;
					var playbackRate = Math.abs(v.playbackRate);
	
					// monitor fragment load progress after half of expected fragment duration,to stabilize bitrate
					if (requestDelay > 500 * frag.duration / playbackRate) {
						var levels = hls.levels;
						var loadRate = Math.max(1, stats.loaded / (requestDelay / 1000)); // byte/s; at least 1 byte/s to avoid division by zero
						// compute expected fragment length using frag duration and level bitrate. also ensure that expected len is gte than already loaded size
						var level = levels[frag.level];
						var levelBitrate = level.realBitrate ? Math.max(level.realBitrate, level.bitrate) : level.bitrate;
						var expectedLen = stats.total ? stats.total : Math.max(stats.loaded, Math.round(frag.duration * levelBitrate / 8));
						var pos = v.currentTime;
						var fragLoadedDelay = (expectedLen - stats.loaded) / loadRate;
						var bufferStarvationDelay = (_bufferHelper2.default.bufferInfo(v, pos, hls.config.maxBufferHole).end - pos) / playbackRate;
	
						// consider emergency switch down only if we have less than 2 frag buffered AND
						// time to finish loading current fragment is bigger than buffer starvation delay
						// ie if we risk buffer starvation if bw does not increase quickly
						if (bufferStarvationDelay < 2 * frag.duration / playbackRate && fragLoadedDelay > bufferStarvationDelay) {
							var fragLevelNextLoadedDelay = void 0;
							var nextLoadLevel = frag.level;
	
							// lets iterate through lower level and try to find the biggest one that could avoid rebuffering
							// we start from current level - 1 and we step down , until we find a matching level
							do {
								nextLoadLevel--;
								// compute time to load next fragment at lower level
								// 0.8 : consider only 80% of current bw to be conservative
								// 8 = bits per byte (bps/Bps)
								var levelNextBitrate = levels[nextLoadLevel].realBitrate ? Math.max(levels[nextLoadLevel].realBitrate, levels[nextLoadLevel].bitrate) : levels[nextLoadLevel].bitrate;
								fragLevelNextLoadedDelay = levelNextBitrate * frag.duration / (loadRate * 8 * 0.8) / playbackRate + this.latency / 1000;
								if (fragLevelNextLoadedDelay < bufferStarvationDelay) {
									// we found a lower level that be rebuffering free with current estimated bw !
									break;
								}
							} while (nextLoadLevel > minAutoLevel);
	
							// only emergency switch down if it takes less time to load new fragment at lowest level instead
							// of finishing loading current one ...
							if (fragLevelNextLoadedDelay < fragLoadedDelay) {
								_logger.logger.warn('loading too slow, abort fragment loading and switch to level ' + nextLoadLevel + ':fragLoadedDelay[' + nextLoadLevel + ']<fragLoadedDelay[' + (frag.level - 1) + '];bufferStarvationDelay:' + fragLevelNextLoadedDelay.toFixed(1) + '<' + fragLoadedDelay.toFixed(1) + ':' + bufferStarvationDelay.toFixed(1));
	
								// force next load level in auto mode
								hls.nextLoadLevel = nextLoadLevel;
								// update bw estimate for this fragment before cancelling load (this will help reducing the bw)
								this._bwEstimator.sample(requestDelay, stats.loaded);
								hls.trigger(_events2.default.BITRATE_ESTIMATE_UPDATED, { bitrate: this.getBitrateEstimate() });
								//abort fragment loading
								loader.abort();
								// stop abandon rules timer
								this.clearTimer();
								hls.trigger(_events2.default.FRAG_LOAD_EMERGENCY_ABORTED, { frag: frag, stats: stats });
							}
						}
					}
				}
			}
		}, {
			key: 'onFragLoaded',
			value: function onFragLoaded(data) {
				var frag = data.frag;
	
				if (frag.type === 'main' && !isNaN(frag.sn)) {
					// stop monitoring bw once frag loaded
					this.clearTimer();
					// store level id after successful fragment load
					this.lastLoadedFragLevel = frag.level;
					// reset forced auto level value so that next level will be selected
					this._nextAutoLevel = -1;
	
					// compute level average bitrate
					if (this.hls.config.abrMaxWithRealBitrate) {
						var level = this.hls.levels[frag.level];
						var loadedBytes = (level.loaded ? level.loaded.bytes : 0) + data.stats.loaded;
						var loadedDuration = (level.loaded ? level.loaded.duration : 0) + data.frag.duration;
						level.loaded = { bytes: loadedBytes, duration: loadedDuration };
						level.realBitrate = Math.round(8 * loadedBytes / loadedDuration);
					}
	
					// if fragment has been loaded to perform a bitrate test,
					if (data.frag.bitrateTest) {
						var stats = data.stats;
						stats.tparsed = stats.tbuffered = stats.tload;
						this.onFragBuffered(data);
					}
				}
			}
		}, {
			key: 'onFragBuffered',
			value: function onFragBuffered(data) {
				var stats = data.stats;
				var frag = data.frag;
	
				// only update stats on first frag buffering
				// if same frag is loaded multiple times, it might be in browser cache, and loaded quickly
				// and leading to wrong bw estimation
				// on bitrate test, also only update stats once (if tload = tbuffered == on FRAG_LOADED)
				if (stats.aborted !== true && frag.loadCounter === 1 && frag.type === 'main' && !isNaN(frag.sn) && (!frag.bitrateTest || stats.tload === stats.tbuffered)) {
					// use tparsed-trequest instead of tbuffered-trequest to compute fragLoadingProcessing;
					// rationale is that  buffer appending only happens once media is attached
					// in case we use config.startFragPrefetch while media is not attached yet, fragment might
					// be parsed while media not attached yet, but it will only be buffered on media attached
					// as a consequence it could happen really late in the process. meaning that appending
					// duration might appears huge ... leading to underestimated throughput estimation
					var fragLoadingProcessingMs = stats.tparsed - stats.tfirst;
					this.latency = stats.tfirst - stats.trequest;
					_logger.logger.log('latency/loading/parsing/append/kbps: ' + Math.round(stats.tfirst - stats.trequest) + '/' + Math.round(stats.tload - stats.tfirst) + '/' + Math.round(stats.tparsed - stats.tload) + '/' + Math.round(stats.tbuffered - stats.tparsed) + '/' + Math.round(8 * stats.loaded / (stats.tbuffered - stats.trequest)));
	
					this._bwEstimator.sample(fragLoadingProcessingMs, stats.loaded);
					this.hls.trigger(_events2.default.BITRATE_ESTIMATE_UPDATED, { bitrate: this.getBitrateEstimate() });
	
					// if fragment has been loaded to perform a bitrate test, (hls.startLevel = -1), store bitrate test delay duration
					if (frag.bitrateTest) {
						this.bitrateTestDelay = (fragLoadingProcessingMs + this.latency) / 1000;
					} else {
						this.bitrateTestDelay = 0;
					}
				}
			}
		}, {
			key: 'onError',
			value: function onError(data) {
				// stop timer in case of frag loading error
				switch (data.details) {
					case _errors.ErrorDetails.FRAG_LOAD_ERROR:
					case _errors.ErrorDetails.FRAG_LOAD_TIMEOUT:
						this.clearTimer();
						break;
					default:
						break;
				}
			}
		}, {
			key: 'clearTimer',
			value: function clearTimer() {
				if (this.timer) {
					clearInterval(this.timer);
					this.timer = null;
				}
			}
	
			// return next auto level
	
		}, {
			key: '_findBestLevel',
			value: function _findBestLevel(currentLevel, currentFragDuration, currentBw, minAutoLevel, maxAutoLevel, bufferLength, bwFactor, bwUpFactor, levels, playbackRate) {
				for (var i = maxAutoLevel; i >= minAutoLevel; i--) {
					var levelInfo = levels[i];
					var levelDetails = levelInfo.details;
					var avgDuration = levelDetails ? levelDetails.totalduration / levelDetails.fragments.length : currentFragDuration;
					var live = levelDetails ? levelDetails.live : false;
					var adjustedbw = void 0;
					var adjustedBwFactor = this._getBwFactor(bwFactor, 1.25, bufferLength, avgDuration * 2);
					var adjustedBwUpFactor = this._getBwFactor(bwUpFactor, 1.25, bufferLength, avgDuration * 2);
					var maxFetchDuration = bufferLength / playbackRate;
	
					// follow algorithm captured from stagefright :
					// https://android.googlesource.com/platform/frameworks/av/+/master/media/libstagefright/httplive/LiveSession.cpp
					// Pick the highest bandwidth stream below or equal to estimated bandwidth.
					// consider only 80% of the available bandwidth, but if we are switching up,
					// be even more conservative (70%) to avoid overestimating and immediately
					// switching back.
					if (i <= currentLevel) {
						adjustedbw = adjustedBwFactor * currentBw / playbackRate;
					} else {
						adjustedbw = adjustedBwUpFactor * currentBw / playbackRate;
					}
					var bitrate = levels[i].realBitrate ? Math.max(levels[i].realBitrate, levels[i].bitrate) : levels[i].bitrate;
					var fetchDuration = bitrate * avgDuration / currentBw / playbackRate + this.latency / 1000;
	
					// if adjusted bw is greater than level bitrate AND
					if (adjustedbw > bitrate && (
					// fragment fetchDuration unknown OR live stream OR fragment fetchDuration less than max allowed fetch duration, then this level matches
					// we don't account for max Fetch Duration for live streams, this is to avoid switching down when near the edge of live sliding window ...
					!fetchDuration || live || fetchDuration < maxFetchDuration)) {
						// as we are looping from highest to lowest, this will return the best achievable quality level
						/*
	     logger.log(`level/adjustedbw/bitrate/avgDuration/maxFetchDuration/fetchDuration/bwFactor/bwUpFactor:\
	     ${i}/${Math.round(adjustedbw)}/${bitrate}/${avgDuration}/${maxFetchDuration}/${fetchDuration}/${adjustedBwFactor}/${adjustedBwUpFactor}`);
	     */
						return i;
					}
				}
	
				// not enough time budget even with quality level 0 ... rebuffering might happen
				return -1;
			}
		}, {
			key: '_getBwFactor',
			value: function _getBwFactor(baseFactor, maxFactor, bufferLength, minBufferLength) {
				var adjustedFactor = baseFactor;
				var bufferSizeRemaining = (bufferLength - minBufferLength) / (this.hls.config.maxMaxBufferLength - minBufferLength);
	
				adjustedFactor += Math.max(0, (maxFactor - baseFactor) * bufferSizeRemaining);
	
				return Math.min(adjustedFactor, maxFactor).toFixed(2);
			}
		}, {
			key: 'getBitrateEstimate',
			value: function getBitrateEstimate() {
				if (this._bwEstimator && this._bwEstimator.canEstimate) {
					return this._bwEstimator.getEstimate();
				} else {
					return 0;
				}
			}
		}, {
			key: 'nextAutoLevel',
			get: function get() {
				var forcedAutoLevel = this._nextAutoLevel;
				//const bwEstimator = this._bwEstimator;
				// in case next auto level has been forced, and bw not available or not reliable, return forced value
				if (forcedAutoLevel !== -1 /*&& (!bwEstimator || !bwEstimator.canEstimate())*/) {
						return forcedAutoLevel;
					}
				// compute next level using ABR logic
				var nextABRAutoLevel = this._nextABRAutoLevel;
				// if forced auto level has been defined, use it to cap ABR computed quality level
				if (forcedAutoLevel !== -1) {
					nextABRAutoLevel = Math.min(forcedAutoLevel, nextABRAutoLevel);
				}
				return nextABRAutoLevel;
			},
			set: function set(nextLevel) {
				this._nextAutoLevel = nextLevel;
			}
		}, {
			key: '_nextABRAutoLevel',
			get: function get() {
				var hls = this.hls;
				var maxAutoLevel = hls.maxAutoLevel;
				var levels = hls.levels;
				var config = hls.config;
				var minAutoLevel = hls.minAutoLevel;
				var v = hls.media;
				var currentLevel = this.lastLoadedFragLevel;
				var currentFragDuration = this.fragCurrent ? this.fragCurrent.duration : 0;
				var pos = v ? v.currentTime : 0;
				// playbackRate is the absolute value of the playback rate; if v.playbackRate is 0, we use 1 to load as
				// if we're playing back at the normal rate.
				var playbackRate = v && v.playbackRate !== 0 ? Math.abs(v.playbackRate) : 1.0;
				var avgbw = this._bwEstimator ? this._bwEstimator.getEstimate() : config.abrEwmaDefaultEstimate;
				// bufferStarvationDelay is the wall-clock time left until the playback buffer is exhausted.
				var bufferLength = _bufferHelper2.default.bufferInfo(v, pos, config.maxBufferHole).end - pos;
	
				// First, look to see if we can find a level matching with our avg bandwidth AND that could also guarantee no rebuffering at all
				var bestLevel = this._findBestLevel(currentLevel, currentFragDuration, avgbw, minAutoLevel, maxAutoLevel, bufferLength, config.abrBandWidthFactor, config.abrBandWidthUpFactor, levels, playbackRate);
	
				if (bestLevel >= 0) {
					return bestLevel;
				} else {
					_logger.logger.trace('rebuffering expected to happen, lets try to find a quality level minimizing the rebuffering');
					// not possible to get rid of rebuffering ... let's try to find level that will guarantee less than maxStarvationDelay of rebuffering
					// if no matching level found, logic will return 0
					var maxStarvationDelay = currentFragDuration ? Math.min(currentFragDuration, config.maxStarvationDelay) : config.maxStarvationDelay;
					var bwFactor = config.abrBandWidthFactor;
					var bwUpFactor = config.abrBandWidthUpFactor;
	
					if (bufferLength === 0) {
						// in case buffer is empty, let's check if previous fragment was loaded to perform a bitrate test
						var bitrateTestDelay = this.bitrateTestDelay;
						if (bitrateTestDelay) {
							// if it is the case, then we need to adjust our max starvation delay using maxLoadingDelay config value
							// max video loading delay used in  automatic start level selection :
							// in that mode ABR controller will ensure that video loading time (ie the time to fetch the first fragment at lowest quality level +
							// the time to fetch the fragment at the appropriate quality level is less than ```maxLoadingDelay``` )
							// cap maxLoadingDelay and ensure it is not bigger 'than bitrate test' frag duration
							var maxLoadingDelay = currentFragDuration ? Math.min(currentFragDuration, config.maxLoadingDelay) : config.maxLoadingDelay;
							maxStarvationDelay = maxLoadingDelay - bitrateTestDelay;
							_logger.logger.trace('bitrate test took ' + Math.round(1000 * bitrateTestDelay) + 'ms, set first fragment max fetchDuration to ' + Math.round(1000 * maxStarvationDelay) + ' ms');
							// don't use conservative factor on bitrate test
							bwFactor = bwUpFactor = 1;
						}
					}
					bestLevel = this._findBestLevel(currentLevel, currentFragDuration, avgbw, minAutoLevel, maxAutoLevel, bufferLength + maxStarvationDelay, bwFactor, bwUpFactor, levels, playbackRate);
	
					return Math.max(bestLevel, 0);
				}
			}
		}]);
	
		return AbrController;
	}(_eventHandler2.default);
	
	exports.default = AbrController;
	module.exports = exports['default'];

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _bufferHelper = __webpack_require__(22);
	
	var _bufferHelper2 = _interopRequireDefault(_bufferHelper);
	
	var _demuxer = __webpack_require__(70);
	
	var _demuxer2 = _interopRequireDefault(_demuxer);
	
	var _events = __webpack_require__(3);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _eventHandler = __webpack_require__(5);
	
	var _eventHandler2 = _interopRequireDefault(_eventHandler);
	
	var _timeRanges = __webpack_require__(72);
	
	var _timeRanges2 = _interopRequireDefault(_timeRanges);
	
	var _errors = __webpack_require__(4);
	
	var _logger = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Audio Stream Controller
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */
	
	//import BinarySearch from '../utils/binary-search';
	
	
	var State = {
		STOPPED: 'STOPPED',
		STARTING: 'STARTING',
		IDLE: 'IDLE',
		PAUSED: 'PAUSED',
		KEY_LOADING: 'KEY_LOADING',
		FRAG_LOADING: 'FRAG_LOADING',
		FRAG_LOADING_WAITING_RETRY: 'FRAG_LOADING_WAITING_RETRY',
		WAITING_TRACK: 'WAITING_TRACK',
		PARSING: 'PARSING',
		PARSED: 'PARSED',
		BUFFER_FLUSHING: 'BUFFER_FLUSHING',
		ENDED: 'ENDED',
		ERROR: 'ERROR',
		WAITING_INIT_PTS: 'WAITING_INIT_PTS'
	};
	
	var AudioStreamController = function (_EventHandler) {
		_inherits(AudioStreamController, _EventHandler);
	
		function AudioStreamController(hls) {
			_classCallCheck(this, AudioStreamController);
	
			var _this = _possibleConstructorReturn(this, (AudioStreamController.__proto__ || Object.getPrototypeOf(AudioStreamController)).call(this, hls, _events2.default.MEDIA_ATTACHED, _events2.default.MEDIA_DETACHING, _events2.default.AUDIO_TRACKS_UPDATED, _events2.default.AUDIO_TRACK_SWITCHING, _events2.default.AUDIO_TRACK_LOADED,
			//Mactrix additions start
			_events2.default.STREAM_ALL_LEVELS_LOADED, _events2.default.STREAM_DESYNC, _events2.default.FRAG_BUFFERED, _events2.default.MANIFEST_LOADED,
			//Mactrix additions end
			_events2.default.KEY_LOADED, _events2.default.FRAG_LOADED, _events2.default.FRAG_PARSING_INIT_SEGMENT, _events2.default.FRAG_PARSING_DATA, _events2.default.FRAG_PARSED, _events2.default.ERROR, _events2.default.BUFFER_CREATED, _events2.default.BUFFER_APPENDED, _events2.default.BUFFER_FLUSHED, _events2.default.BUFFER_WAIT, _events2.default.INIT_PTS_FOUND, _events2.default.SEEK_READY));
	
			_this.config = hls.config;
			_this.audioCodecSwap = false;
			_this.ticks = 0;
			_this._state = State.STOPPED;
			_this.ontick = _this.tick.bind(_this);
			_this.initPTS = [];
			_this.waitingFragment = null;
			_this.forceStopFetching = false;
			_this.allLevelsLoaded = false;
			_this.videoFragBuffered = false;
			_this._fragBufferCount = 0;
			_this._pausedTimer = true;
			_this._flushOnStoppedBuffering = {};
			_this._skipAppendAfterFlush = false;
			_this._waitForFlush = false;
			_this._bufferBeforeSeekingTime = undefined;
			_this._bufferBeforeSeekingApplied = undefined;
			_this._videoSeekReady = undefined;
			_this._audioSwitchComplete = true;
			_this._parsingDataCount = 0;
			return _this;
		}
	
		_createClass(AudioStreamController, [{
			key: 'destroy',
			value: function destroy() {
				this.stopLoad();
				this.pauseController();
	
				_eventHandler2.default.prototype.destroy.call(this);
				/*
	   this.state = State.STOPPED;
	   */
				//Mactrix changes and additions start
				//memory clean up
				this.config = null;
				this.initPTS = null;
				this.ontick = null;
				this.tracks = null;
				//this.hls = null;
				//Mactrix additions end
			}
	
			//Signal that video PTS was found
	
		}, {
			key: 'onInitPtsFound',
			value: function onInitPtsFound(data) {
				var demuxerId = data.id;
				var cc = data.frag.cc;
				var initPTS = data.initPTS;
	
				if (demuxerId === 'main') {
					//Always update the new INIT PTS
					//Can change due level switch
					this.initPTS[cc] = initPTS;
					_logger.logger.log('InitPTS for cc:' + cc + ' found from video track:' + initPTS);
	
					//If we are waiting we need to demux/remux the waiting frag
					//With the new initPTS
					if (this.state === State.WAITING_INIT_PTS) {
						_logger.logger.log('sending pending audio frag to demuxer');
						this.state = State.FRAG_LOADING;
	
						//We have audio frag waiting or video pts
						//Let process it
						this.onFragLoaded(this.waitingFragment);
	
						//Lets clean the waiting frag
						this.waitingFragment = null;
					}
				}
			}
		}, {
			key: 'startLoad',
			value: function startLoad() /*startPosition*/{}
	
			/* Mactrix lines removed, splitting load and fetch
	  	setting audio tracks already loads it, so we don't need to do anything in startLoad
	  	we still have to leave the function here for now, as HlsJs.startLoad calls startLoad in all the controllers
	  if (this.tracks) {
	    var lastCurrentTime = this.lastCurrentTime;
	    this.stopLoad();
	    if (!this.timer) {
	  	this.timer = setInterval(this.ontick, 100);
	    }
	    this.fragLoadError = 0;
	    if (lastCurrentTime > 0 && startPosition === -1) {
	  	logger.log(`audio:override startPosition with lastCurrentTime @${lastCurrentTime.toFixed(3)}`);
	  	this.state = State.IDLE;
	    } else {
	  	this.lastCurrentTime = this.startPosition ? this.startPosition : startPosition;
	  	this.state = State.STARTING;
	    }
	    this.nextLoadPosition = this.startPosition = this.lastCurrentTime;
	    this.tick();
	  } else {
	    this.startPosition = startPosition;
	    this.state = State.STOPPED;
	  }
	  */
	
	
			//Mactrix additions start
			//don't start fetch until all controllers are ready
	
		}, {
			key: 'onStreamAllLevelsLoaded',
			value: function onStreamAllLevelsLoaded(data) {
				this.allLevelsLoaded = true;
				this.videoFragBuffered = false;
	
				if (this.tracks) {
					this.stopLoad();
	
					//Disabling this for now
					//resync level as we are now guaranteed to have the base PDT
					//this.hls.streamController.adjustStartByBasePdt(this.tracks[this.trackId].details, this.hls.streamCoordinator.basePdt);
	
					this.state = State.STARTING;
					this.lastCurrentTime = this.nextLoadPosition = this.startPosition = data.startTime; //derivedStartTime;
					this.fragLoadError = 0;
					this.unpauseController();
				} else {
					this.startPosition = data.startTime;
					this.state = State.STOPPED;
				}
	
				_logger.logger.log('onStreamAllLevelsLoaded AUDIO this.startPosition: ' + this.startPosition + ' this.lastCurrentTime: ' + this.lastCurrentTime);
			}
	
			//fix desync
	
		}, {
			key: 'onStreamDesync',
			value: function onStreamDesync(data) {
				var i = void 0;
				var fragments = this.tracks[this.trackId].details.fragments;
				var totalDropDuration = 0;
				var duration = fragments[0].manifestDuration;
	
				//sum the total duration that was removed, then sub that from all frags
				for (i = 0; fragments.length > 1 && fragments[0].pdt < data.pdtToAlignTo - data.variance; i++) {
					fragments.splice(0, 1);
					totalDropDuration += duration;
					duration = fragments[0].manifestDuration;
				}
	
				if (i > 0) {
					var j = void 0;
	
					_logger.logger.log('audio PDT earlier than main PDT, adjusting audio timestamps');
	
					for (j = 0; j < fragments.length; j++) {
						fragments[j].index = j;
						fragments[j].start -= totalDropDuration;
						fragments[j].pdt -= totalDropDuration * 1000;
						fragments[j].sn -= i;
					}
	
					this.tracks[this.trackId].details.endSN -= i;
				}
			}
		}, {
			key: 'pauseController',
			value: function pauseController() {
				//it is best to always use pause/unpause as otherwise weird bugs are likely...
				if (this.timer && !this._pausedTimer) {
					clearInterval(this.timer);
				}
				this.timer = null;
				this._pausedTimer = true;
			}
		}, {
			key: 'unpauseController',
			value: function unpauseController() {
				//it is best to always use pause/unpause as otherwise weird bugs are likely...
				if (!this.timer && this._pausedTimer && this.tracks) {
					this.timer = setInterval(this.ontick, 100);
					this._pausedTimer = false;
					this.tick();
				}
			}
		}, {
			key: 'stopLoad',
	
			//Mactrix additions end
	
			value: function stopLoad() {
				var frag = this.fragCurrent;
				if (frag) {
					_logger.logger.log('Audio resetting current frag load count as load was aborted');
					frag.loadCounter = 0;
					if (frag.loader) {
						frag.loader.abort();
					}
					this.fragCurrent = null;
				}
				this._fragPrevious = null;
				if (this.demuxer) {
					this.demuxer.destroy();
					this.demuxer = null;
				}
				this.state = State.STOPPED;
				this.timestampOffset = undefined;
			}
		}, {
			key: 'tick',
			value: function tick() {
				if (!this.pausedTimer) {
					this.ticks++;
					if (this.ticks === 1) {
						this.doTick();
						if (this.ticks > 1) {
							setTimeout(this.tick, 1);
						}
						this.ticks = 0;
					}
				} else {
					_logger.logger.log('Audio Ticking while paused');
				}
			}
	
			// called from doTick() when idle
	
		}, {
			key: '_doTickIdle',
			value: function _doTickIdle() {
				var tracks = this.tracks;
	
				// audio tracks not received => exit loop
				if (!tracks) {
					_logger.logger.log('audio: No tracks. Idle exit');
					return;
				}
	
				// if video not attached AND
				// start fragment already requested OR start frag prefetch disable
				// exit loop
				// => if media not attached but start frag prefetch is enabled and start frag not requested yet, we will not exit loop
				var hls = this.hls;
				var config = hls.config;
	
				if (!this.media && (this.startFragRequested || !config.startFragPrefetch)) {
					return;
				}
	
				// determine next candidate fragment to be loaded, based on current position and
				//  end of buffer position
				// if we have not yet loaded any fragment, start loading from start position
	
				//stop pos from moving back to 0 before first video frag has buffered
				var pos = void 0;
	
				if (this._bufferBeforeSeekingTime !== undefined && this._bufferBeforeSeekingApplied === false) {
					_logger.logger.log('audio: using bufferBeforeSeeking');
					pos = this._bufferBeforeSeekingTime;
					this._fragPrevious = null;
					this._bufferBeforeSeekingApplied = true;
				} else if (!this.videoFragBuffered) {
					pos = this.startPosition;
				} else if (this.loadedmetadata && this._videoSeekReady !== false) {
					pos = this.media.currentTime;
				} else {
					pos = this.nextLoadPosition;
				}
	
				var media = this.mediaBuffer ? this.mediaBuffer : this.media;
				var bufferInfo = _bufferHelper2.default.bufferInfo(media, pos, 0);
				var bufferLen = bufferInfo.len;
				var bufferEnd = bufferInfo.end;
				var maxBufLen = config.maxMaxBufferLength;
				var audioSwitch = this.audioSwitch;
				var trackId = this.trackId;
				var audioSwitchComplete = this._audioSwitchComplete;
				var desiredTime = bufferEnd;
	
				// if buffer length is less than maxBufLen try to load a new fragment
				if (trackId < tracks.length && (bufferLen < maxBufLen || this._bufferBeforeSeekingApplied === true)) {
					var trackDetails = void 0;
					trackDetails = tracks[trackId].details;
					// if track info not retrieved yet, switch state and wait for track retrieval
					if (typeof trackDetails === 'undefined') {
						this.state = State.WAITING_TRACK;
						return;
					}
	
					// we just got done loading the final fragment, check if we need to finalize media stream
					if (!audioSwitch && !trackDetails.live && this._fragPrevious && trackDetails.fragments[trackDetails.fragments.length - 1].loadCounter > 0) {
						// if everything (almost) til the end is buffered, let's signal eos
						// we don't compare exactly media.duration === bufferInfo.end as there could be some subtle media duration difference when switching
						// between different renditions. using half frag duration should help cope with these cases.
	
						if (this.media.duration - bufferEnd < this._fragPrevious.duration / 2) {
							// Finalize the media stream
							hls.trigger(_events2.default.BUFFER_EOS, { type: 'audio' });
							this.state = State.ENDED;
							return;
						}
					}
	
					// find fragment index, contiguous with end of buffer position
					var fragments = trackDetails.fragments;
					var fragLen = fragments.length;
					var start = fragments[0].start;
					var end = fragments[fragLen - 1].start + fragments[fragLen - 1].duration;
					var findFragResults = undefined;
					var frag = void 0;
	
					// When switching audio track, reload audio as close as possible to currentTime
					if (!audioSwitchComplete) {
						desiredTime = pos;
	
						// if currentTime (pos) is less than alt audio playlist start time, it means that alt audio is ahead of currentTime
						if (trackDetails.PTSKnown && pos < start) {
							// if everything is buffered from pos to start or if audio buffer upfront, let's seek to start
							if (bufferInfo.end > start || bufferInfo.nextStart) {
								_logger.logger.log('alt audio track ahead of main track, seek to start of alt audio track');
								this.media.currentTime = start + 0.05;
							}
						}
	
						_logger.logger.log('audio: Audio changing, next chunk will be selected at playhead pos: ' + pos + ' currentTime: ' + this.media.currentTime);
					}
					if (trackDetails.initSegment && !trackDetails.initSegment.data) {
						frag = trackDetails.initSegment;
					}
					// if bufferEnd before start of playlist, load first fragment
					else if (desiredTime <= start) {
							//Mactrix changes begin: disable for now, Don't think it's correct
							/*
	      if(this.pdtDiff === undefined && this.initialPdt && hls.streamController && hls.streamController.initialPdt) {
	      	this.pdtDiff = this.initialPdt - hls.streamController.initialPdt;
	      		if(this.pdtDiff < 0 && fragments.length > 1) {
	      		hls.streamController._pdtAlign(fragments, trackDetails);
	      	}
	      }
	      */
							//Mactrix changes end
	
							frag = fragments[0];
	
							/* Mactrix lines removed, this doesn't appear to be working correctly right now
	      // it's been activating when there is alt audio at the current time, but didn't get buffered on first audio frag load
	      if (trackDetails.live && frag.loadIdx && frag.loadIdx === this.fragLoadIdx) {
	        // we just loaded this first fragment, and we are still lagging behind the start of the live playlist
	        // let's force seek to start
	        const nextBuffered = bufferInfo.nextStart ? bufferInfo.nextStart : start;
	        logger.log(`no alt audio available @currentTime:${this.media.currentTime}, seeking @${nextBuffered + 0.05}`);
	        this.media.currentTime = nextBuffered + 0.05;
	        return;
	      }
	      */
						} else if (this.forceStopFetching === true) {
							_logger.logger.log('audio: forceStopFetching. Idle exit');
							return;
						} else {
							findFragResults = hls.streamController._findFragment(start, this._fragPrevious, fragLen, fragments, desiredTime, end, trackDetails, pos, false, this.mediaBuffer);
							frag = findFragResults.frag;
							this._fragPrevious = findFragResults.fragPrevious;
						}
					//Mactrix line below changed, stop new frag selector loading frag at current end of live stream repeatedly but only if fragPrevious was previously valid
					//if(frag && ((!this._fragPrevious || !this._fragPrevious.pdt || !frag.pdt || this._fragPrevious.pdt !== frag.pdt) || !findFragResults.previouslyNoPrevious) ) {
					if (frag && (!findFragResults || findFragResults.previouslyNoPrevious || !findFragResults.noNewFrag)) {
						//logger.log('      loading frag ' + i +',pos/bufEnd:' + pos.toFixed(3) + '/' + desiredTime.toFixed(3));
						if (frag.decryptdata && frag.decryptdata.uri != null && frag.decryptdata.key == null) {
							_logger.logger.log('Audio loading key for ' + frag.sn + ' of [' + trackDetails.startSN + ' ,' + trackDetails.endSN + '],track ' + trackId);
							this.state = State.KEY_LOADING;
							hls.trigger(_events2.default.KEY_LOADING, { frag: frag });
						} else {
							_logger.logger.log('Audio loading ' + frag.sn + ' of [' + trackDetails.startSN + ', ' + trackDetails.endSN + '], track ' + trackId + ', pos:' + pos + ', desiredTime:' + desiredTime.toFixed(3));
							// ensure that we are not reloading the same fragments in loop ...
							if (this.fragLoadIdx !== undefined) {
								this.fragLoadIdx++;
							} else {
								this.fragLoadIdx = 0;
							}
							if (frag.loadCounter && this._bufferBeforeSeekingApplied !== true && audioSwitchComplete) {
								frag.loadCounter++;
								var maxThreshold = config.fragLoadingLoopThreshold;
								// if this frag has already been loaded fragLoadingLoopThreshold times (currently 3 ), and if it has been reloaded recently
								if (frag.loadCounter > maxThreshold && Math.abs(this.fragLoadIdx - frag.loadIdx) < maxThreshold) {
									hls.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.MEDIA_ERROR, details: _errors.ErrorDetails.FRAG_LOOP_LOADING_ERROR, fatal: false, frag: frag });
									return;
								}
							} else {
								frag.loadCounter = 1;
							}
							frag.loadIdx = this.fragLoadIdx;
							this.fragCurrent = frag;
							this.startFragRequested = true;
							if (!isNaN(frag.sn)) {
								this.nextLoadPosition = frag.start + frag.duration;
							}
							hls.trigger(_events2.default.FRAG_LOADING, { frag: frag });
							this.state = State.FRAG_LOADING;
						}
					} else {
						if (frag && this._fragPrevious) {
							_logger.logger.log('audio: Frag loop prevention. frag ' + frag + ' _fragPrevious.level ' + this._fragPrevious.level + ' audioSwitch ' + this.audioSwitch + ' frag.level ' + frag.level + ' Idle exit');
						}
					}
				}
			}
		}, {
			key: 'doTick',
			value: function doTick() {
				var track = void 0;
	
				switch (this.state) {
					case State.ERROR: //don't do anything in error state to avoid breaking further ...
					case State.PAUSED: //don't do anything in paused state either ...
					case State.BUFFER_FLUSHING:
						// or buffering
						break;
	
					case State.STARTING:
						this.state = State.WAITING_TRACK;
						this.loadedmetadata = false;
						break;
	
					case State.IDLE:
						this._doTickIdle();
						break;
	
					case State.WAITING_TRACK:
						track = this.tracks[this.trackId];
						// check if playlist is already loaded
						if (track && track.details) {
							this.state = State.IDLE;
						}
						break;
	
					case State.FRAG_LOADING_WAITING_RETRY:
						{
							var now = performance.now();
							var retryDate = this.retryDate;
							var media = this.media;
							var isSeeking = media && media.seeking;
							// if current time is gt than retryDate, or if media seeking let's switch to IDLE state to retry loading
							if (!retryDate || now >= retryDate || isSeeking) {
								_logger.logger.log('audioStreamController: retryDate reached, switch back to IDLE state');
								this.state = State.IDLE;
							}
							break;
						}
	
					case State.WAITING_INIT_PTS:
					case State.STOPPED:
					case State.FRAG_LOADING:
					case State.PARSING:
					case State.PARSED:
					case State.ENDED:
						break;
	
					default:
						break;
				}
			}
		}, {
			key: 'onMediaAttached',
			value: function onMediaAttached(data) {
				var media = this.media = this.mediaBuffer = data.media;
				this.onvseeking = this.onMediaSeeking.bind(this);
				this.onvended = this.onMediaEnded.bind(this);
	
				this.onvseeked = this.onMediaSeeked.bind(this);
				media.addEventListener('seeked', this.onvseeked);
				media.addEventListener('seeking', this.onvseeking);
				media.addEventListener('ended', this.onvended);
	
				var config = this.config;
				if (this.tracks && config.autoStartLoad) {
					this.startLoad(config.startPosition);
				}
			}
		}, {
			key: 'onMediaDetaching',
			value: function onMediaDetaching() {
				var media = this.media;
				if (media && media.ended) {
					_logger.logger.log('AUDIO MSE detaching and video ended, reset startPosition');
					this.startPosition = this.lastCurrentTime = 0;
				}
	
				// reset fragment loading counter on MSE detaching to avoid reporting FRAG_LOOP_LOADING_ERROR after error recovery
				var tracks = this.tracks;
				if (tracks) {
					// reset fragment load counter
					tracks.forEach(function (track) {
						if (track.details) {
							track.details.fragments.forEach(function (fragment) {
								fragment.loadCounter = undefined;
							});
						}
					});
				}
				// remove video listeners
				if (media) {
					media.removeEventListener('seeking', this.onvseeking);
					media.removeEventListener('seeked', this.onvseeked);
					media.removeEventListener('ended', this.onvended);
	
					this.onvseeking = this.onvseeked = this.onvended = null;
				}
				this.media = this.mediaBuffer = null;
				this.loadedmetadata = false;
				this.stopLoad();
			}
		}, {
			key: 'onMediaSeeking',
			value: function onMediaSeeking() {
				if (this.media) {
					this.lastCurrentTime = this.media.currentTime;
	
					if (this.state !== State.PARSING) {
						this.state = State.IDLE;
					}
	
					if (this._fragPrevious) {
						this._fragPrevious = null;
					}
				}
				// avoid reporting fragment loop loading error in case user is seeking several times on same position
				if (this.fragLoadIdx !== undefined) {
					this.fragLoadIdx += 2 * this.config.fragLoadingLoopThreshold;
				}
	
				this.hls.trigger(_events2.default.BUFFER_SOURCE_SEEKING); //Mactrix addition
	
				// tick to speed up processing
				this.tick();
			}
		}, {
			key: 'onMediaSeeked',
			value: function onMediaSeeked() {
				//logger.log(`AUDIO media seeked to ${this.media.currentTime.toFixed(3)}`);
				if (this.hls && this.hls._inSlowDetach) {
					if (this.hls.streamCoordinator.checkReadyForDispose(undefined, true)) {
						_logger.logger.log('AUDIO slow detach seek finished');
						this.hls._doCompleteSlowDetach();
					}
				}
			}
		}, {
			key: 'onMediaEnded',
			value: function onMediaEnded() {
				// reset startPosition and lastCurrentTime to restart playback @ stream beginning
				this.startPosition = this.lastCurrentTime = 0;
			}
		}, {
			key: 'onSeekReady',
			value: function onSeekReady() {
				this._videoSeekReady = undefined;
			}
		}, {
			key: 'onAudioTracksUpdated',
			value: function onAudioTracksUpdated(data) {
				_logger.logger.log('audio tracks updated');
				this.tracks = data.audioTracks;
	
				this.tracks.forEach(function (track) {
					track.deadFragList = [];
					track.containsGaps = false;
					track.gapList = []; //THIS IS TEMPORARY, REMOVE WHEN WE HAVE PROPER GAP HANDLING
				});
			}
		}, {
			key: 'onManifestLoaded',
			value: function onManifestLoaded() {
				this._fragBufferCount = 0;
				this.cmaf = false;
			}
		}, {
			key: 'onAudioTrackSwitching',
			value: function onAudioTrackSwitching(data) {
				// if any URL found on new audio track, it is an alternate audio track
				var altAudio = !!data.url;
				this.trackId = data.id;
				this.state = State.IDLE;
	
				this.pendingData = [];
	
				//clear load counter on track switch to prevent false fragLoopLoadingErrors
				this._clearFragCounts(this);
	
				this.fragCurrent = null;
				this.state = State.PAUSED;
				this.waitingFragment = null;
	
				// destroy useless demuxer when switching audio to main
				if (!altAudio) {
					if (this.demuxer) {
						this.demuxer.destroy();
						this.demuxer = null;
					}
				} else {
	
					//If all else fails we could just destroy...
					//			if (this.demuxer) {
					//				this.demuxer.destroy();
					//				this.demuxer = null;
					//			}
	
	
					// switching to audio track, start timer if not already started
					if (this.allLevelsLoaded) {
						//Mactrix line changed, don't start the timer until we're ready to fetch
						this.unpauseController();
					}
				}
	
				//should we switch tracks ?
				if (altAudio) {
					this.audioSwitch = true;
					this._audioSwitchComplete = false;
					//main audio track are handled by stream-controller, just do something if switching to alt audio track
					this.state = State.IDLE;
					// increase fragment load Index to avoid frag loop loading error after buffer flush
					if (this.fragLoadIdx !== undefined) {
						this.fragLoadIdx += 2 * this.config.fragLoadingLoopThreshold;
					}
				}
	
				/* Mactrix line removed, stop track switch from automatically starting fetching
	   this.tick();
	   */
			}
		}, {
			key: 'onAudioTrackLoaded',
			value: function onAudioTrackLoaded(data) {
				var _this2 = this;
	
				var newDetails = data.details;
				var trackId = data.id;
				var track = this.tracks[trackId];
				var duration = newDetails.totalduration;
				var sliding = 0;
	
				_logger.logger.log('onAudioTrackLoaded: track ' + trackId + ' loaded [' + newDetails.startSN + ',' + newDetails.endSN + '],duration:' + duration);
	
				//store the base pdt ... this would cause problems if pdts were to appear mid stream .. shouldn't happen
				if (this.initialPdt === undefined && newDetails.fragments[0].pdt) {
					this.initialPdt = newDetails.fragments[0].pdt;
				}
	
				if (newDetails.live) {
					var curDetails = track.details;
					if (curDetails && newDetails.fragments.length > 0) {
	
						// we already have details for that level, merge them
						if (this.hls.streamCoordinator.basePdt) {
							this.hls.streamController.adjustStartByBasePdt(newDetails, this.hls.streamCoordinator.basePdt);
						} else {
							//This case shouldn't hit, but it will on startup. Often it's not an issue as it'll just do a no-offset
							//as needed, but in a sliding live recovery it's bad. Since we're creating PDTs always now this whole
							//case probably can be deleted and just make the no-PDT case do no adjustment, but more testing is required. - SIEG
							_logger.logger.log('onAudioTrackLoaded adjustStartBySlidingOffset NO BASEPDT YET');
							this.hls.streamController.adjustStartBySlidingOffset(curDetails, newDetails);
						}
	
						sliding = newDetails.fragments[0].start;
	
						if (newDetails.PTSKnown) {
							_logger.logger.log('live audio playlist sliding:' + sliding.toFixed(3));
						} else {
							_logger.logger.log('live audio playlist - outdated PTS, unknown sliding');
						}
					} else {
						//if we know the base PDT we can sync and determine sliding
						if (this.hls.streamCoordinator.basePdt) {
							_logger.logger.log('live audio playlist - first load, calculating slide by syncing to base PDT');
							this.hls.streamController.adjustStartByBasePdt(newDetails, this.hls.streamCoordinator.basePdt);
							sliding = newDetails.fragments[0].start;
							_logger.logger.log('live audio playlist sliding:' + sliding.toFixed(3));
						} else {
							newDetails.PTSKnown = false;
							_logger.logger.log('live audio playlist - first load, unknown sliding');
						}
					}
				} else {
					//resync VODs, if needed
					if (this.hls.streamCoordinator.basePdt) {
						this.hls.streamController.adjustStartByBasePdt(newDetails, this.hls.streamCoordinator.basePdt);
					}
					newDetails.PTSKnown = false;
				}
	
				track.gapList = [];
	
				newDetails.fragments.forEach(function (frag, index) {
					if (frag.tagList.includes('GAP')) {
						_this2.hls.streamController.removeDeadFrag(index, newDetails.fragments);
						track.containsGaps = true;
	
						//check the frag that we just moved into this index
						while (newDetails.fragments[index] && newDetails.fragments[index].tagList.includes('GAP')) {
							_this2.hls.streamController.removeDeadFrag(index, newDetails.fragments);
						}
	
						if (newDetails.fragments[index]) {
							track.gapList.push({ start: newDetails.fragments[index].start - newDetails.fragments[index].gap / 1000, end: newDetails.fragments[index].start });
						}
					} else if (frag.gap > 0) {
						//we haven't removed dead frags yet so a gap without an EXT-X-GAP marks a discontinuity
						//for now we need to mark this as we would a gap for the workaround seek
						track.containsGaps = true;
						track.gapList.push({ start: frag.start - frag.gap / 1000, end: frag.start });
					}
				});
	
				track.deadFragList.forEach(function (deadSn) {
					var index = newDetails.fragments.findIndex(function (element) {
						return element.sn === deadSn;
					});
	
					if (index !== -1) {
						_this2.hls.streamController.removeDeadFrag(index, newDetails.fragments);
					}
				});
	
				//reconfirm first and last SN, in case there are dead frags at start or end
				newDetails.startSN = newDetails.fragments[0].sn;
				newDetails.originalEndSN = newDetails.endSN;
				newDetails.endSN = newDetails.fragments[newDetails.fragments.length - 1].sn;
	
				track.details = newDetails;
	
				// compute start position
				if (!this.startFragRequested) {
					// compute start position if set to -1. use it straight away if value is defined
					if (this.startPosition === -1) {
						// first, check if start time offset has been set in playlist, if yes, use this value
						var startTimeOffset = newDetails.startTimeOffset;
	
						if (!isNaN(startTimeOffset)) {
							_logger.logger.log('start time offset found in playlist, adjust startPosition to ' + startTimeOffset);
							this.startPosition = startTimeOffset;
						} else {
							this.startPosition = 0;
						}
					}
					this.nextLoadPosition = this.startPosition;
				}
	
				// only switch batck to IDLE state if we were waiting for track to start downloading a new fragment
				if (this.state === State.WAITING_TRACK) {
					this.state = State.IDLE;
				}
	
				this.hls.trigger(_events2.default.AUDIO_TRACK_UPDATED, { details: newDetails, track: trackId, sliding: sliding }); //Mactrix line added, log end of track parse
			}
		}, {
			key: 'onKeyLoaded',
			value: function onKeyLoaded() {
				if (this.state === State.KEY_LOADING) {
					this.state = State.IDLE;
					this.tick();
				}
			}
		}, {
			key: 'onFragLoaded',
			value: function onFragLoaded(data) {
				var fragCurrent = this.fragCurrent;
				var fragLoaded = data.frag;
	
				if (this.state === State.FRAG_LOADING && fragCurrent && fragLoaded.type === 'audio' && fragLoaded.level === fragCurrent.level && fragLoaded.sn === fragCurrent.sn) {
					var track = this.tracks[this.trackId];
					var details = track.details;
					var duration = details.totalduration;
					var trackId = fragCurrent.level;
					var sn = fragCurrent.sn;
					var cc = fragCurrent.cc;
					var audioCodec = this.config.defaultAudioCodec || track.audioCodec || 'mp4a.40.2';
					var stats = this.stats = data.stats;
	
					this._flushOnStoppedBuffering = {};
	
					if (this._waitForFlush) {
						_logger.logger.log('audio aborting parse due to flush');
						this._clearFragCounts(this);
						this._checkIfBufferReady();
					} else if (sn === 'initSegment') {
						this.state = State.IDLE;
						stats.tparsed = stats.tbuffered = performance.now();
						//details.initSegment.data = data.payload;
						details.initSegment.data = this.hls.streamController.insertPssh(data.payload, details.initSegment);
						//details.isCMAF = this.hls.streamController.isCMAF(details.initSegment.data);
						this.cmaf = this.hls.streamController.isCMAF(details.initSegment.data);
						this.hls.trigger(_events2.default.FRAG_BUFFERED, { stats: stats, frag: fragCurrent, id: 'audio' });
						this.tick(); // probably not required but more tests are needed - SIEG
					} else {
						this.state = State.PARSING;
						// transmux the MPEG-TS data to ISO-BMFF segments
						this.appended = false;
	
						_logger.logger.log('onFragLoaded: Loaded audio ' + fragCurrent.sn + ' of [' + details.startSN + ' ,' + details.endSN + '], track ' + fragCurrent.level + ', size ' + stats.loaded + ' bytes, load time ' + (stats.tload - stats.tfirst) + 'ms, latency ' + (stats.tfirst - stats.trequest) + 'ms');
	
						//Check if we have video initPTS
						// If not we need to wait for it
						var initPTS = this.initPTS[cc];
						var initSegmentData = details.initSegment ? details.initSegment.data : [];
						if (initSegmentData || initPTS !== undefined) {
							this.pendingBuffering = true;
	
							if (this.cmaf /*details.isCMAF*/) {
									if (details.initSegment.data) {
										var tracks = {};
										var initData = { tracks: tracks };
										initData.frag = fragLoaded;
										initData.id = 'audio';
	
										tracks.audio = {
											container: 'audio/mp4',
											codec: 'mp4a.40.2', //currentLevel.audioCodec,
											initSegment: details.initSegment.data,
											metadata: {
												channelCount: 2 //get the correct value!
											},
											//temporary hack for fairplay - DO NOT rely on this as it will be removed!
											levelkeys: details.initSegment.levelkeys
										};
	
										if (!this.timestampOffset) {
											var timeScale = this.hls.streamController.getTimeScale(details.initSegment.data);
											this.timestampOffset = this.hls.streamController.getTimestampOffset(data.payload, timeScale);
										}
	
										this.onFragParsingInitSegment(initData);
	
										//only do this once per init segment
										//details.initSegment.data = null;
									}
	
									var payload = {
										data1: new Int8Array(data.payload),
										data2: null, //is ignored
										startPTS: fragCurrent.startDTS / 90e3,
										endPTS: fragCurrent.nextDTS / 90e3,
										startDTS: fragCurrent.startDTS / 90e3,
										endDTS: fragCurrent.nextDTS / 90e3,
										type: 'audio',
										nb: fragCurrent.frames,
										dropped: 0, //dropped
										duplicate: false, //would need to keep track of the last startDTS
										dts: fragCurrent.startDTS,
										frag: fragCurrent,
										id: 'audio'
									};
	
									this.onFragParsingData(payload);
									this.onFragParsed(payload);
								} else {
								if (!this.demuxer) {
									this.demuxer = new _demuxer2.default(this.hls, 'audio');
								}
	
								_logger.logger.log('Audio Demuxing ' + sn + ' of [' + details.startSN + ' ,' + details.endSN + '],track ' + trackId);
								// time Offset is accurate if level PTS is known, or if playlist is not sliding (not live)
								var accurateTimeOffset = false; //details.PTSKnown || !details.live;
								this.demuxer.push(data.payload, initSegmentData, audioCodec, null, fragCurrent, duration, accurateTimeOffset, this.fragAborted, false);
								this.fragAborted = false;
								this._parsingDataCount = 0;
							}
						} else {
							_logger.logger.log('unknown video PTS for continuity counter ' + cc + ', waiting for video PTS before demuxing audio frag ' + sn + ' of [' + details.startSN + ' ,' + details.endSN + '],track ' + trackId);
							this.waitingFragment = data;
							this.state = State.WAITING_INIT_PTS;
						}
					}
				}
				this.fragLoadError = 0;
			}
		}, {
			key: 'onFragParsingInitSegment',
			value: function onFragParsingInitSegment(data) {
				var fragCurrent = this.fragCurrent;
				var fragNew = data.frag;
				if (fragCurrent && data.id === 'audio' && fragNew.sn === fragCurrent.sn && fragNew.level === fragCurrent.level && this.state === State.PARSING) {
					var tracks = data.tracks;
	
					// delete any video track found on audio demuxer
					if (tracks.video) {
						delete tracks.video;
					}
	
					// include levelCodec in audio and video tracks
					var track = tracks.audio;
					if (track) {
						track.levelCodec = 'mp4a.40.2';
						track.id = data.id;
						this.hls.trigger(_events2.default.BUFFER_CODECS, tracks);
						_logger.logger.log('audio track:audio,container:' + track.container + ',codecs[level/parsed]=[' + track.levelCodec + '/' + track.codec + ']');
						var initSegment = track.initSegment;
						if (initSegment) {
							var appendObj = { type: 'audio', data: initSegment, parent: 'audio', content: 'initSegment', sn: fragCurrent.sn };
	
							if (this.audioSwitch) {
								this.pendingData = [appendObj];
							} else {
								this.appended = true;
								// arm pending Buffering flag before appending a segment
								this.pendingBuffering = true;
								this.hls.trigger(_events2.default.BUFFER_APPENDING, appendObj);
							}
						}
						//trigger handler right now
						this.tick(); // probably not required but more tests are needed - SIEG
					}
				}
			}
		}, {
			key: 'onFragParsingData',
			value: function onFragParsingData(data) {
				var _this3 = this;
	
				var fragCurrent = this.fragCurrent;
				var fragNew = data.frag;
	
				if (this._waitForFlush) {
					_logger.logger.log('audio aborting append due to flush');
					this._checkIfBufferReady();
	
					this._clearFragCounts(this);
	
					this.fragAborted = true;
				} else if (fragCurrent && data.id === 'audio' && data.type === 'audio' && fragNew.sn === fragCurrent.sn && fragNew.level === fragCurrent.level && this.state === State.PARSING) {
					var hls = this.hls;
	
					if (isNaN(data.endPTS)) {
						data.endPTS = data.startPTS + fragCurrent.duration;
						data.endDTS = data.startDTS + fragCurrent.duration;
					}
	
					this._flushOnStoppedBuffering = { start: data.startPTS, end: data.endPTS };
	
					_logger.logger.log('onFragParsingData Audio parsed ' + data.type + ',PTS:[' + data.startPTS.toFixed(3) + ',' + data.endPTS.toFixed(3) + '],DTS:[' + data.startDTS.toFixed(3) + '/' + data.endDTS.toFixed(3) + '],nb:' + data.nb);
	
					var audioSwitch = this.audioSwitch;
					var media = this.media;
					var appendOnBufferFlush = false;
	
					//Only flush audio from old audio tracks when PTS is known on new audio track
					if (audioSwitch && media) {
						var trackId = this.trackId;
	
						if (media.readyState) {
							var currentTime = media.currentTime;
							_logger.logger.log('switching audio track : currentTime:' + currentTime);
	
							if (currentTime >= data.startPTS) {
								_logger.logger.log('switching audio track : flushing all audio');
								this.state = State.BUFFER_FLUSHING;
								hls.trigger(_events2.default.BUFFER_FLUSHING, { startOffset: 0, endOffset: Number.POSITIVE_INFINITY, type: 'audio' });
								appendOnBufferFlush = true;
							}
							//Lets announce that the initial audio track switch flush occur
							this.audioSwitch = false;
							hls.trigger(_events2.default.AUDIO_TRACK_SWITCHED, { id: trackId });
						} else {
							//Lets announce that the initial audio track switch flush occur
							this.audioSwitch = false;
							hls.trigger(_events2.default.AUDIO_TRACK_SWITCHED, { id: trackId });
						}
					}
	
					var pendingData = this.pendingData;
					if (!this.audioSwitch) {
						[data.data1, data.data2].forEach(function (buffer) {
							if (buffer && buffer.length) {
								pendingData.push({
									type: data.type,
									data: buffer,
									parent: 'audio',
									content: 'data',
									sn: data.frag.sn,
									level: data.frag.level,
									start: data.startPTS,
									end: data.endPTS,
									dts: data.dts,
									targetDuration: data.frag.duration
								});
							}
						});
	
						if (!appendOnBufferFlush && pendingData.length) {
							pendingData.forEach(function (appendObj) {
								// only append in PARSING state (rationale is that an appending error could happen synchronously on first segment appending)
								// in that case it is useless to append following segments
								if (_this3.state === State.PARSING) {
									// arm pending Buffering flag before appending a segment
									_this3.pendingBuffering = true;
									hls.trigger(_events2.default.BUFFER_APPENDING, appendObj);
									_this3._parsingDataCount++;
								}
							});
							this.pendingData = [];
							this.appended = true;
						}
					}
	
					//trigger handler right now
					this.tick(); // probably not required but more tests are needed - SIEG
				}
			}
		}, {
			key: 'onFragParsed',
			value: function onFragParsed(data) {
				var fragCurrent = this.fragCurrent;
				var fragNew = data.frag;
	
				if (fragCurrent && data.id === 'audio' && fragNew.sn === fragCurrent.sn && fragNew.level === fragCurrent.level && this.state === State.PARSING && this._parsingDataCount > 0) {
					this.stats.tparsed = performance.now();
					this.state = State.PARSED;
					this._parsingDataCount = 0;
					this._checkAppendedParsed();
				} else if (fragCurrent && data.id === 'audio' && fragNew.sn === fragCurrent.sn && fragNew.level === fragCurrent.level && this.state === State.PARSING && this._parsingDataCount === 0) {
					this.state = State.IDLE;
					this.fragCurrent = null;
					this._fragPrevious = null;
				}
			}
	
			//stop pos from moving back to 0 before first video frag has buffered
	
		}, {
			key: 'onFragBuffered',
			value: function onFragBuffered(data) {
				if (data.id === 'audio') {
					this._fragBufferCount++;
				} else if (!this.videoFragBuffered && data.id === 'main') {
					this.videoFragBuffered = true;
				}
			}
		}, {
			key: 'onBufferCreated',
			value: function onBufferCreated(data) {
				var audioTrack = data.tracks.audio;
				if (audioTrack) {
					this.mediaBuffer = audioTrack.buffer;
	
					if (this.timestampOffset) {
						this.mediaBuffer.timestampOffset = this.timestampOffset;
					}
	
					this.loadedmetadata = true;
				}
			}
		}, {
			key: 'onBufferAppended',
			value: function onBufferAppended(data) {
				if (data.parent === 'audio') {
					var state = this.state;
					if (state === State.PARSING || state === State.PARSED) {
						// check if all buffers have been appended
						this.pendingBuffering = data.pending > 0;
						this._checkAppendedParsed();
					}
				}
			}
		}, {
			key: '_checkAppendedParsed',
			value: function _checkAppendedParsed() {
				if (this.state === State.PARSED && (!this.appended || !this.pendingBuffering)) {
					var frag = this.fragCurrent;
	
					if (frag) {
						this._fragPrevious = frag;
	
						var stats = this.stats;
						stats.tbuffered = performance.now();
	
						var hls = this.hls;
						hls.trigger(_events2.default.FRAG_BUFFERED, { stats: stats, frag: frag, id: 'audio' });
	
						var media = this.mediaBuffer ? this.mediaBuffer : this.media;
	
						this._audioSwitchComplete = true;
	
						try {
							_logger.logger.log('audio buffered : ' + _timeRanges2.default.toString(media.buffered) + ' sn : ' + frag.sn);
						} catch (err) {
							_logger.logger.log('audio buffered : {TimeRanges.toString(media.buffered)} failed. err ' + err.message);
						}
	
						if (this._bufferBeforeSeekingTime !== undefined) {
							if (_bufferHelper2.default.isBuffered(media, this._bufferBeforeSeekingTime)) {
								_logger.logger.log('bufferBeforeSeeking: Audio Ready.');
								this._bufferBeforeSeekingTime = undefined;
								this._bufferBeforeSeekingApplied = undefined;
							} else if (this._bufferBeforeSeekingApplied === true) {
								var targetTime = this._bufferBeforeSeekingTime + 1;
	
								_logger.logger.log('bufferBeforeSeeking: Buffered audio but desired time not found. Pushing forward target time to ' + targetTime + '.');
	
								hls.bufferBeforeSeeking = targetTime;
							}
						}
	
						if (this.audioSwitch && this.appended) {
							this.audioSwitch = false;
							hls.trigger(_events2.default.AUDIO_TRACK_SWITCHED, { id: this.trackId });
						}
	
						this.state = State.IDLE;
					}
	
					//trigger handler right now
					this.tick(); // probably not required but more tests are needed - SIEG
				}
			}
		}, {
			key: 'onError',
			value: function onError(data) {
				var frag = data.frag;
	
				// don't handle frag error not related to audio fragment
				if (frag && frag.type !== 'audio') {
					return;
				}
	
				switch (data.details) {
					case _errors.ErrorDetails.FRAG_LOAD_ERROR:
					case _errors.ErrorDetails.FRAG_LOAD_TIMEOUT:
						if (!data.fatal) {
							var loadError = this.fragLoadError;
							if (loadError) {
								loadError++;
							} else {
								loadError = 1;
							}
	
							var config = this.config;
							if (loadError < 2) {
								this.fragLoadError = loadError;
								// reset load counter to avoid frag loop loading error
								frag.loadCounter = 0;
								// exponential backoff capped to config.fragLoadingMaxRetryTimeout
								var delay = Math.min(Math.pow(2, loadError - 1) * config.fragLoadingRetryDelay, config.fragLoadingMaxRetryTimeout);
								_logger.logger.warn('audioStreamController: frag loading failed, retry in ' + delay + ' ms');
								this.retryDate = performance.now() + delay;
								// retry loading state
								this.state = State.FRAG_LOADING_WAITING_RETRY;
							} else if (this._fragBufferCount !== 0) {
								if (data.frag) {
									_logger.logger.warn('audio stream controller,' + data.details + ': marking dead frag');
	
									if (this.tracks[this.trackId]) {
										this.tracks[this.trackId].deadFragList.push(data.frag.sn);
										this.tracks[this.trackId].details = undefined; //wipe track details so we're forced to reload
										this.hls.audioTrackController.updateTrack(this.trackId);
									}
	
									this.retryDate = performance.now();
									this.state = State.WAITING_TRACK;
								}
							} else {
								_logger.logger.error('audioStreamController: ' + data.details + ' reaches max retry, redispatch as fatal ...');
								// switch error to fatal
								data.fatal = true;
								this.state = State.ERROR;
							}
						}
						break;
	
					case _errors.ErrorDetails.AUDIO_TRACK_LOAD_ERROR:
					case _errors.ErrorDetails.AUDIO_TRACK_LOAD_TIMEOUT:
						//If we can't get the audio track, mark as fatal
						//TODO: try alternate tracks in the rendition group if we have them
						if (this._fragBufferCount === 0) {
							data.fatal = true;
							this.state = State.ERROR;
						} else if (this.state !== State.ERROR) {
							this.state = State.IDLE;
						}
	
						_logger.logger.warn('audioStreamController: ' + data.details + ' while loading audio track,switch to ' + this.state + ' state ...');
						break;
	
					case _errors.ErrorDetails.FRAG_LOOP_LOADING_ERROR:
					case _errors.ErrorDetails.KEY_LOAD_ERROR:
					case _errors.ErrorDetails.KEY_LOAD_TIMEOUT:
						// when in ERROR state, don't switch back to IDLE state in case a non-fatal error is received
						if (this.state !== State.ERROR) {
							// if fatal error, stop processing, otherwise move to IDLE to retry loading
							this.state = data.fatal ? State.ERROR : State.IDLE;
							_logger.logger.warn('audioStreamController: ' + data.details + ' while loading frag,switch to ' + this.state + ' state ...');
						}
						break;
	
					case _errors.ErrorDetails.BUFFER_FULL_ERROR:
						// if in appending state
						if (data.parent === 'audio' && (this.state === State.PARSING || this.state === State.PARSED)) {
							var media = this.mediaBuffer;
	
							var desiredPlayPoint = this._bufferBeforeSeekingTime;
							if (desiredPlayPoint === undefined && this.media) {
								desiredPlayPoint = this.media.currentTime;
							}
	
							var currentTime = desiredPlayPoint;
							var mediaBuffered = media && _bufferHelper2.default.isBuffered(media, currentTime) && _bufferHelper2.default.isBuffered(media, currentTime + 0.5);
	
							//reset frag load counter
							this.fragCurrent.loadCounter = 0;
	
							// reduce max buf len if current position is buffered
							if (mediaBuffered) {
								var _config = this.config;
								if (_config.maxMaxBufferLength >= _config.maxBufferLength) {
									// reduce max buffer length as it might be too high. we do this to avoid loop flushing ...
									_config.maxMaxBufferLength /= 2;
									_logger.logger.warn('audio:reduce max buffer length to ' + _config.maxMaxBufferLength + 's');
									// increase fragment load Index to avoid frag loop loading error after buffer flush
									this.fragLoadIdx += 2 * _config.fragLoadingLoopThreshold;
								}
								//let flushRange = this._flushOnStoppedBuffering;
								this._skipAppendAfterFlush = true; //if we try to append data immediately after this flush, it will error again
								this._fragPrevious = null;
								this.fragCurrent = null;
								/* this.hls.trigger(Event.BUFFER_FLUSHING, { startOffset: flushRange.start, endOffset: flushRange.end, type: 'audio' });
	       this.state = State.IDLE; */
								this.state = State.BUFFER_FLUSHING;
								this.hls.trigger(_events2.default.BUFFER_FLUSHING, { startOffset: 0, endOffset: Number.POSITIVE_INFINITY, type: 'audio' });
							} else {
								// current position is not buffered, but browser is still complaining about buffer full error
								// this happens on IE/Edge, refer to https://github.com/video-dev/hls.js/pull/708
								// in that case flush the whole audio buffer to recover
								_logger.logger.warn('buffer full error also desired time is not buffered, flush audio buffer');
								this.fragCurrent = null;
								// flush everything
								this.state = State.BUFFER_FLUSHING;
								this.hls.trigger(_events2.default.BUFFER_FLUSHING, { startOffset: 0, endOffset: Number.POSITIVE_INFINITY, type: 'audio' });
							}
	
							if (this._bufferBeforeSeekingApplied === true) {
								this._bufferBeforeSeekingApplied = false;
								_logger.logger.log('Audio: onBufferFull Rescheduling bufferBeforeSeeking');
							}
						}
						break;
	
					default:
						break;
				}
			}
		}, {
			key: 'onBufferFlushed',
			value: function onBufferFlushed() {
				var _this4 = this;
	
				var pendingData = this.pendingData;
	
				if (this.state === State.BUFFER_FLUSHING && this.hls.bufferController.readyForData === true && this._waitForFlush) {
					this.endBufferWait();
					this.state = State.IDLE;
				} else if (pendingData && pendingData.length && !this._skipAppendAfterFlush) {
					_logger.logger.log('appending pending audio data on Buffer Flushed');
					pendingData.forEach(function (appendObj) {
						_this4.hls.trigger(_events2.default.BUFFER_APPENDING, appendObj);
					});
					this.appended = true;
					this.pendingData = [];
					this.state = State.PARSED;
				} else {
					this._skipAppendAfterFlush = false;
					// move to IDLE once flush complete. this should trigger new fragment loading
					this.state = State.IDLE;
					// reset reference to frag
					this._fragPrevious = null;
					this.tick(); // probably not required but more tests are needed - SIEG
				}
			}
		}, {
			key: 'onBufferWait',
			value: function onBufferWait() {
				var frag = this._fragCurrent;
	
				_logger.logger.log('Audio: BufferWait');
	
				if (frag) {
					if (frag.loader) {
						frag.loader.abort();
					}
					this._fragCurrent = null;
					if (this._bufferBeforeSeekingApplied === true) {
						this._bufferBeforeSeekingApplied = false;
						_logger.logger.log('Audio: onBufferWait Rescheduling bufferBeforeSeeking');
					}
				}
	
				//All other cases should switch to FLUSHING
				if (this.state === State.FRAG_LOADING || this.state === State.KEY_LOADING || this.state === State.FRAG_LOADING_WAITING_RETRY) {
					this.state = State.BUFFER_FLUSHING;
				}
	
				if (this._waitForFlush) {
					_logger.logger.warn('Audio: onBufferWait Already waiting');
				}
				this._waitForFlush = true; //Should only set it to true here
			}
		}, {
			key: 'endBufferWait',
			value: function endBufferWait() {
				if (this._waitForFlush) {
					_logger.logger.log('Audio: end BufferWait No longer waiting');
				}
				this._waitForFlush = false; //Should only set it to false here
			}
		}, {
			key: '_checkIfBufferReady',
			value: function _checkIfBufferReady() {
				if (this.hls.bufferController.readyForData === true) {
					this.endBufferWait();
					this.state = State.IDLE;
				} else {
					this.state = State.BUFFER_FLUSHING;
				}
			}
		}, {
			key: '_clearFragCounts',
			value: function _clearFragCounts(stream) {
				var tracks = stream.tracks;
				_logger.logger.log('Audio: Clearing frag load counts');
				if (tracks) {
					// reset fragment load counter
					tracks.forEach(function (track) {
						if (track.details) {
							track.details.fragments.forEach(function (fragment) {
								fragment.loadCounter = undefined;
							});
						}
					});
				}
			}
		}, {
			key: 'pausedTimer',
			get: function get() {
				return this._pausedTimer;
			}
		}, {
			key: 'state',
			set: function set(nextState) {
				if (this.state !== nextState) {
					var previousState = this.state;
					this._state = nextState;
					_logger.logger.log('audio stream state: ' + previousState + '->' + nextState + ' pausedTimer: ' + this.pausedTimer);
				}
			},
			get: function get() {
				return this._state;
			}
		}, {
			key: 'bufferBeforeSeeking',
			set: function set(time) {
				_logger.logger.log('audio bufferBeforeSeeking set to ' + time);
				this._bufferBeforeSeekingTime = time;
				this._bufferBeforeSeekingApplied = false;
				this._videoSeekReady = false;
	
				if (this._fragCurrent && this._fragCurrent.loader) {
					this._fragCurrent.loader.abort();
				}
				this._fragCurrent = null;
				this._fragPrevious = null;
				this.state = State.IDLE;
	
				this.unpauseController(); //the audio controller will unpause without an unpause, but it should make seeking slightly faster
			},
			get: function get() {
				return this._bufferBeforeSeekingTime;
			}
		}]);
	
		return AudioStreamController;
	}(_eventHandler2.default);
	
	exports.default = AudioStreamController;
	module.exports = exports['default'];

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _events = __webpack_require__(3);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _eventHandler = __webpack_require__(5);
	
	var _eventHandler2 = _interopRequireDefault(_eventHandler);
	
	var _logger = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * audio track controller
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */
	
	var AudioTrackController = function (_EventHandler) {
		_inherits(AudioTrackController, _EventHandler);
	
		function AudioTrackController(hls) {
			_classCallCheck(this, AudioTrackController);
	
			//Mactrix changes end
			var _this = _possibleConstructorReturn(this, (AudioTrackController.__proto__ || Object.getPrototypeOf(AudioTrackController)).call(this, hls, _events2.default.MANIFEST_LOADING, _events2.default.MANIFEST_LOADED,
			/*
	  Event.AUDIO_TRACK_LOADED);
	  */
			//Mactrix changes begin
			//add audio rendition and stream coordinator support
			_events2.default.AUDIO_TRACK_LOADED, _events2.default.LEVEL_SWITCHING, _events2.default.STREAM_ALL_LEVELS_LOADED));
	
			_this.ticks = 0;
			_this.ontick = _this.tick.bind(_this);
			//Mactrix additions start
			_this._allLevelsLoaded = false;
			_this._pendingInterval = undefined;
			_this._timersActive = 0;
			//Mactrix additions end
			return _this;
		}
	
		_createClass(AudioTrackController, [{
			key: 'destroy',
			value: function destroy() {
				_eventHandler2.default.prototype.destroy.call(this);
				//Mactrix additions start
				//memory clean up
				this.ontick = null;
				//this.tracks = null;
				//this.hls = null;
				//Mactrix additions end
			}
		}, {
			key: 'clearTimer',
			value: function clearTimer() {
				if (this.timer) {
					clearInterval(this.timer);
					this.timer = null;
					this._timersActive--;
				}
			}
		}, {
			key: 'incrementTimerCount',
			value: function incrementTimerCount() {
				this._timersActive++;
				if (this._timersActive > 1) {
					_logger.logger.warn('Timer leak in audio track controller, number of active timers: ' + this._timersActive);
				}
			}
	
			//Mactrix additions start
			//stop audio track reloads on stopLoad
	
		}, {
			key: 'stopLoad',
			value: function stopLoad() {
				this.clearTimer();
			}
			//Mactrix additions end
	
		}, {
			key: 'tick',
			value: function tick() {
				this.ticks++;
				if (this.ticks === 1) {
					this.doTick();
					if (this.ticks > 1) {
						setTimeout(this.tick, 1);
					}
					this.ticks = 0;
				}
			}
		}, {
			key: 'doTick',
			value: function doTick() {
				this.updateTrack(this.trackId);
			}
		}, {
			key: 'onManifestLoading',
			value: function onManifestLoading() {
				// reset audio tracks on manifest loading
				this.tracks = [];
				this.trackId = -1;
			}
		}, {
			key: 'onManifestLoaded',
			value: function onManifestLoaded(data) {
				var _this2 = this;
	
				var tracks = data.audioTracks || [];
				var defaultFound = false;
				this.tracks = tracks;
				//Mactrix changes start
				//Moving this to lower down
				//    this.hls.trigger(Event.AUDIO_TRACKS_UPDATED, {audioTracks : tracks});
				//Mactrix changes end
				// loop through available audio tracks and autoselect default if needed
				var id = 0;
				tracks.forEach(function (track) {
					if (track.default) {
						_this2.audioTrack = id;
						defaultFound = true;
						return;
					}
					id++;
				});
				if (defaultFound === false && tracks.length) {
					_logger.logger.log('no default audio track defined, use first audio track as default');
					this.audioTrack = 0;
				}
				//Mactrix changes start
				//Moving this from above; it doesn't make much sense to me to report an update and THEN change the tracks...
				this.hls.trigger(_events2.default.AUDIO_TRACKS_UPDATED, { audioTracks: tracks });
				//Mactrix changes end
			}
		}, {
			key: 'onAudioTrackLoaded',
			value: function onAudioTrackLoaded(data) {
				if (data.id < this.tracks.length) {
					_logger.logger.log('audioTrack ' + data.id + ' loaded');
					this.tracks[data.id].details = data.details;
					// check if current playlist is a live playlist
					if (data.details.live && !this.timer) {
						// if live playlist we will have to reload it periodically
						// set reload period to playlist target duration
						if (this._allLevelsLoaded) {
							//Mactrix line added
							this.clearTimer();
							this.timer = setInterval(this.ontick, 1000 * data.details.targetduration);
							this.incrementTimerCount();
							//Mactrix additions start
							//don't start reloading manifests until STREAM_ALL_LEVELS_LOADED
						} else {
							_logger.logger.log('delaying arming timer until STREAM_ALL_LEVELS_LOADED');
							this._pendingInterval = 1000 * data.details.targetduration;
						}
						//Mactrix additions end
					}
					if (!data.details.live && this.timer) {
						// playlist is not live and timer is armed : stopping it
						this.clearTimer();
					}
				}
			}
	
			//Mactrix additions start
			//don't start reloading manifests until STREAM_ALL_LEVELS_LOADED
	
		}, {
			key: 'onStreamAllLevelsLoaded',
			value: function onStreamAllLevelsLoaded() {
				this._allLevelsLoaded = true;
				if (this._pendingInterval) {
					this.clearTimer();
					this.timer = setInterval(this.ontick, this._pendingInterval);
					this.incrementTimerCount();
				}
			}
			//Mactrix additions end
	
			//Mactrix additions start
			//on level switch, we want to run updateTrack, so we can change the rendition group we're loading from if needed
	
		}, {
			key: 'onLevelSwitching',
			value: function onLevelSwitching() {
				if (this.trackId >= 0) {
					this.updateTrack(this.trackId);
				}
			}
			//Mactrix additions end
	
			/** get alternate audio tracks list from playlist **/
	
		}, {
			key: 'setAudioTrackInternal',
			value: function setAudioTrackInternal(newId) {
				// check if level idx is valid
				if (newId >= 0 && newId < this.tracks.length) {
					// stopping live reloading timer if any
					this.clearTimer();
					this.trackId = newId;
					_logger.logger.log('switching to audioTrack ' + newId);
	
					var audioTrack = this.tracks[newId];
					var hls = this.hls;
					var type = audioTrack.type;
					var url = audioTrack.renditions[this.getRenditionNumber(newId)].url;
					var eventObj = { id: newId, type: type, url: url };
	
					// keep AUDIO_TRACK_SWITCH for legacy reason
					hls.trigger(_events2.default.AUDIO_TRACK_SWITCH, eventObj);
					hls.trigger(_events2.default.AUDIO_TRACK_SWITCHING, eventObj);
	
					// check if we need to load playlist for this audio Track
					var details = audioTrack.details;
					if (url && (details === undefined || details.live === true)) {
						// track not retrieved yet, or live playlist we need to (re)load it
						_logger.logger.log('(re)loading playlist for audioTrack ' + newId);
						hls.trigger(_events2.default.AUDIO_TRACK_LOADING, { url: url, id: newId });
					}
				}
			}
		}, {
			key: 'updateTrack',
			value: function updateTrack(newId) {
				// check if level idx is valid
				if (newId >= 0 && newId < this.tracks.length) {
					// stopping live reloading timer if any
					this.clearTimer();
					this.trackId = newId;
					_logger.logger.log('updating audioTrack ' + newId);
	
					/*
	    let audioTrack = this.tracks[newId], url = audioTrack.url;
	    */
	
					var audioTrack = this.tracks[newId];
					var url = audioTrack.renditions[this.getRenditionNumber(newId)].url;
	
					// check if we need to load playlist for this audio Track
					var details = audioTrack.details;
					if (url && (details === undefined || details.live === true)) {
						// track not retrieved yet, or live playlist we need to (re)load it
						_logger.logger.log('(re)loading playlist for audioTrack ' + newId);
						this.hls.trigger(_events2.default.AUDIO_TRACK_LOADING, { url: url, id: newId });
					}
				}
			}
	
			//Mactrix additions start
			//used to determine what audio rendition group we need to be using
	
		}, {
			key: 'getRenditionNumber',
			value: function getRenditionNumber(trackId) {
				var audioTrack = this.tracks[trackId];
				var hls = this.hls;
				var rendition = 0;
	
				if (hls.levels && hls.nextLoadLevel >= 0) {
					var levelAudioGroup = hls.levels[hls.nextLoadLevel].audioGroup;
	
					if (levelAudioGroup) {
						for (var i = 0; i < audioTrack.renditions.length; i++) {
							if (audioTrack.renditions[i].groupId === levelAudioGroup) {
								rendition = i;
							}
						}
					}
				}
	
				return rendition;
			}
			//Mactrix additions end
	
		}, {
			key: 'audioTracks',
			get: function get() {
				return this.tracks;
			}
	
			/** get index of the selected audio track (index in audio track lists) **/
	
		}, {
			key: 'audioTrack',
			get: function get() {
				return this.trackId;
			}
	
			/** select an audio track, based on its index in audio track lists**/
			,
			set: function set(audioTrackId) {
				if (this.trackId !== audioTrackId || this.tracks[audioTrackId].details === undefined) {
					this.setAudioTrackInternal(audioTrackId);
				}
			}
		}]);
	
		return AudioTrackController;
	}(_eventHandler2.default);
	
	exports.default = AudioTrackController;
	module.exports = exports['default'];

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _events = __webpack_require__(3);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _eventHandler = __webpack_require__(5);
	
	var _eventHandler2 = _interopRequireDefault(_eventHandler);
	
	var _logger = __webpack_require__(1);
	
	var _errors = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Buffer Controller
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */
	
	var BufferController = function (_EventHandler) {
		_inherits(BufferController, _EventHandler);
	
		function BufferController(hls) {
			_classCallCheck(this, BufferController);
	
			// the value that we have set mediasource.duration to
			// (the actual duration may be tweaked slighly by the browser)
			var _this = _possibleConstructorReturn(this, (BufferController.__proto__ || Object.getPrototypeOf(BufferController)).call(this, hls, _events2.default.MEDIA_ATTACHING, _events2.default.MEDIA_DETACHING, _events2.default.MANIFEST_PARSED, _events2.default.BUFFER_RESET, _events2.default.BUFFER_APPENDING, _events2.default.BUFFER_CODECS, _events2.default.BUFFER_EOS, _events2.default.BUFFER_FLUSHING,
			//Mactrix additions start
			_events2.default.BUFFER_SOURCE_SEEKING, _events2.default.AUDIO_TRACK_UPDATED,
			//Mactrix additions end
			_events2.default.LEVEL_PTS_UPDATED, _events2.default.LEVEL_UPDATED));
	
			_this._msDuration = null;
			// the value that we want to set mediaSource.duration to
			_this._levelDuration = null;
			_this._playlistDuration = null;
			_this._audioTrackDuration = null;
			_this._audioPlaylistDuration = null;
			_this._needsDetach = false;
			_this._firstAudioReceived = false;
			_this._firstVideoReceived = false;
			_this._firstAudioDts = -1;
			_this._firstVideoDts = -1;
			_this._firstAudioStart = -1;
			_this._firstVideoStart = -1;
			_this._syncChecked = false;
			_this._sbEndedFound = false;
			_this._readyForData = false; //Used to limit operations while a flush is pending. Can be extended to cover more if required
	
			//Old flushing behaviour. Disabled by default.
			_this._clampFlush = false; //this.hls.browFirefox;
			_this._rangeByRangeFlush = _this._clampFlush;
	
			// Source Buffer listeners
			_this.onsbue = _this.onSBUpdateEnd.bind(_this);
			_this.onsbe = _this.onSBUpdateError.bind(_this);
			_this.onsba = _this.onSBAbort.bind(_this);
	
			_this.pendingTracks = {};
			_this.tracks = {};
			return _this;
		}
	
		_createClass(BufferController, [{
			key: 'destroy',
			value: function destroy() {
				_eventHandler2.default.prototype.destroy.call(this);
				//memory clean up
				this._levelDuration = null;
				this._playlistDuration = null;
				this._audioTrackDuration = null;
				this._audioPlaylistDuration = null;
				this._msDuration = null;
				this.flushRange = null;
				this.onsbe = null;
				this.onsbue = null;
				this.onsba = null;
				this.parent = null;
				this.pendingTracks = null;
				//this.segments = null;
				//this.sourceBuffer = null;
				this.tracks = null;
				//this.hls = null;
			}
		}, {
			key: 'onLevelPtsUpdated',
			value: function onLevelPtsUpdated(data) {
				var type = data.type;
				var audioTrack = this.tracks.audio;
	
				// Adjusting `SourceBuffer.timestampOffset` (desired point in the timeline where the next frames should be appended)
				// in Chrome browser when we detect MPEG audio container and time delta between level PTS and `SourceBuffer.timestampOffset`
				// is greater than 100ms (this is enough to handle seek for VOD or level change for LIVE videos). At the time of change we issue
				// `SourceBuffer.abort()` and adjusting `SourceBuffer.timestampOffset` if `SourceBuffer.updating` is false or awaiting `updateend`
				// event if SB is in updating state.
				// More info here: https://github.com/video-dev/hls.js/issues/332#issuecomment-257986486
	
				if (type === 'audio' && audioTrack && audioTrack.container === 'audio/mpeg') {
					// Chrome audio mp3 track
					var audioBuffer = this.sourceBuffer.audio;
					var delta = Math.abs(audioBuffer.timestampOffset - data.start);
	
					// adjust timestamp offset if time delta is greater than 100ms
					if (delta > 0.1) {
						var updating = audioBuffer.updating;
	
						try {
							_logger.logger.warn('audioBuffer.abort()');
							audioBuffer.abort();
						} catch (err) {
							updating = true;
							_logger.logger.warn('can not abort audio buffer: ' + err);
						}
	
						if (!updating) {
							_logger.logger.warn('change mpeg audio timestamp offset from ' + audioBuffer.timestampOffset + ' to ' + data.start);
							audioBuffer.timestampOffset = data.start;
						} else {
							this.audioTimestampOffset = data.start;
						}
					}
				}
			}
		}, {
			key: 'onManifestParsed',
			value: function onManifestParsed(data) {
				var audioExpected = data.audio;
				var videoExpected = data.video;
				var sourceBufferNb = 0;
	
				// in case of alt audio 2 BUFFER_CODECS events will be triggered, one per stream controller
				// sourcebuffers will be created all at once when the expected nb of tracks will be reached
				// in case alt audio is not used, only one BUFFER_CODEC event will be fired from main stream controller
				// it will contain the expected nb of source buffers, no need to compute it
				if (data.altAudio && (audioExpected || videoExpected)) {
					sourceBufferNb = (audioExpected ? 1 : 0) + (videoExpected ? 1 : 0);
					_logger.logger.log(sourceBufferNb + ' sourceBuffer(s) expected');
				}
				this.sourceBufferNb = sourceBufferNb;
			}
		}, {
			key: 'onMediaAttaching',
			value: function onMediaAttaching(data) {
				var media = this.media = data.media;
				if (media) {
					// setup the media source
					var ms = this.mediaSource = new MediaSource();
	
					//Media Source listeners
					this.onmso = this.onMediaSourceOpen.bind(this);
					this.onmse = this.onMediaSourceEnded.bind(this);
					this.onmsc = this.onMediaSourceClose.bind(this);
					ms.addEventListener('sourceopen', this.onmso);
					ms.addEventListener('sourceended', this.onmse);
					ms.addEventListener('sourceclose', this.onmsc);
	
					// link video and media Source
					media.src = URL.createObjectURL(ms);
	
					this.readyForData = true;
				}
			}
		}, {
			key: 'onMediaDetaching',
			value: function onMediaDetaching() {
				_logger.logger.log('media source detaching');
				var ms = this.mediaSource;
				if (ms) {
					var notReady = this.checkEos();
	
					if (notReady) {
						this._needsDetach = true;
						this._needsEos = true;
					} else {
						this.doDetach();
					}
				} else {
					this.hls.trigger(_events2.default.MEDIA_DETACHED);
				}
			}
		}, {
			key: 'onMediaSourceOpen',
			value: function onMediaSourceOpen() {
				_logger.logger.log('media source opened');
				this.hls.trigger(_events2.default.MEDIA_ATTACHED, { media: this.media });
				var mediaSource = this.mediaSource;
				if (mediaSource) {
	
					// once received, don't listen anymore to sourceopen event
					mediaSource.removeEventListener('sourceopen', this.onmso);
				}
				this.checkPendingTracks();
			}
		}, {
			key: 'checkPendingTracks',
			value: function checkPendingTracks() {
				// if any buffer codecs pending, check if we have enough to create sourceBuffers
				var pendingTracks = this.pendingTracks;
				var pendingTracksNb = Object.keys(pendingTracks).length;
	
				// if any pending tracks and (if nb of pending tracks gt or equal than expected nb or if unknown expected nb)
				if (pendingTracksNb && (this.sourceBufferNb <= pendingTracksNb || this.sourceBufferNb === 0)) {
					// ok, let's create them now !
					this.createSourceBuffers(pendingTracks);
					this.pendingTracks = {};
	
					// append any pending segments now !
					this.doAppending();
				}
			}
		}, {
			key: 'onMediaSourceClose',
			value: function onMediaSourceClose() {
				_logger.logger.log('media source closed');
			}
		}, {
			key: 'onMediaSourceEnded',
			value: function onMediaSourceEnded() {
				_logger.logger.log('media source ended');
			}
		}, {
			key: 'onSBUpdateEnd',
			value: function onSBUpdateEnd() {
				// update timestampOffset
				if (this.audioTimestampOffset) {
					var audioBuffer = this.sourceBuffer.audio;
					_logger.logger.warn('change mpeg audio timestamp offset from ' + audioBuffer.timestampOffset + ' to ' + this.audioTimestampOffset);
					audioBuffer.timestampOffset = this.audioTimestampOffset;
					delete this.audioTimestampOffset;
				}
	
				if (this._needsFlush) {
					this.doFlush();
				}
	
				if (this._needsEos) {
					this.checkEos();
				}
				// Mactrix addtions start
				if (this._needsDetach) {
					this.doDetach();
				}
				// Mactrix addtions end
	
				this.appending = false;
				var parent = this.parent;
	
				// count nb of pending segments waiting for appending on this sourcebuffer
				var pending = this.segments.reduce(function (counter, segment) {
					return segment.parent === parent ? counter + 1 : counter;
				}, 0);
				this.hls.trigger(_events2.default.BUFFER_APPENDED, { parent: parent, pending: pending });
	
				// don't append in flushing mode
				if (!this._needsFlush) {
					this.doAppending();
				}
	
				this.updateMediaElementDuration();
			}
		}, {
			key: 'onSBUpdateError',
			value: function onSBUpdateError(event) {
				_logger.logger.error('sourceBuffer error:', event);
				// according to http://www.w3.org/TR/media-source/#sourcebuffer-append-error
				// this error might not always be fatal (it is fatal if decode error is set, in that case
				// it will be followed by a mediaElement error ...)
				this.hls.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.MEDIA_ERROR, details: _errors.ErrorDetails.BUFFER_APPENDING_ERROR, fatal: false });
				// we don't need to do more than that, as according to the spec, updateend will be fired just after
			}
		}, {
			key: 'onSBAbort',
			value: function onSBAbort() {
				_logger.logger.log('sourceBuffer abort');
			}
		}, {
			key: 'onBufferReset',
			value: function onBufferReset() {
				this.doRemoveSourceBuffer();
				this.flushRange = [];
				this.segments = [];
				this._msDuration = null;
	
				this._levelDuration = null;
				this._playlistDuration = null;
				this._audioTrackDuration = null;
				this._audioPlaylistDuration = null;
	
				this._sbEndedFound = false;
				this._resetSyncCheck(true);
			}
	
			//Mactrix additions start
	
		}, {
			key: 'onBufferSourceSeeking',
			value: function onBufferSourceSeeking() {
				//	this._resetSyncCheck(false); //Disable STREAM_SYNC_FAILED failed on seek
			}
		}, {
			key: '_resetSyncCheck',
			value: function _resetSyncCheck(force) {
				if (this._firstAudioReceived && this._firstVideoReceived || force === true) {
					this._syncChecked = false;
					this._firstAudioReceived = false;
					this._firstVideoReceived = false;
					this._firstAudioDts = -1;
					this._firstVideoDts = -1;
					this._firstAudioStart = -1;
					this._firstVideoStart = -1;
				}
			}
	
			//Mactrix additions end
	
		}, {
			key: 'onBufferCodecs',
			value: function onBufferCodecs(tracks) {
				// if source buffer(s) not created yet, appended buffer tracks in this.pendingTracks
				// if sourcebuffers already created, do nothing ...
				if (Object.keys(this.sourceBuffer).length === 0) {
					for (var trackName in tracks) {
						//eslint-disable-line guard-for-in
						this.pendingTracks[trackName] = tracks[trackName];
					}
	
					var mediaSource = this.mediaSource;
					if (mediaSource && mediaSource.readyState === 'open') {
						// try to create sourcebuffers if mediasource opened
						this.checkPendingTracks();
					}
				}
			}
		}, {
			key: 'createSourceBuffers',
			value: function createSourceBuffers(tracks) {
				var sourceBuffer = this.sourceBuffer;
				var mediaSource = this.mediaSource;
	
				for (var trackName in tracks) {
					if (!sourceBuffer[trackName]) {
						var track = tracks[trackName];
						// use levelCodec as first priority
						var codec = track.levelCodec || track.codec;
						var mimeType = track.container + ';codecs=' + codec;
	
						//Mactrix addition start
						for (var i = 0; i < this.hls.levels.length; i++) {
							if (track.container.indexOf('video') > -1 && this.hls.levels[i].videoCodec === undefined) {
								this.hls.levels[i].videoCodec = codec;
							} else if (track.container.indexOf('audio') > -1 && this.hls.levels[i].audioCodec === undefined) {
								this.hls.levels[i].audioCodec = codec;
							}
						}
						//Mactrix addition end
	
						_logger.logger.log('creating sourceBuffer(' + mimeType + ')');
						try {
							var sb = sourceBuffer[trackName] = mediaSource.addSourceBuffer(mimeType);
	
							//					this.mediaSource.removeSourceBuffer(sb);
							//					sb = sourceBuffer[trackName] = mediaSource.addSourceBuffer(mimeType);
	
	
							sb.addEventListener('updateend', this.onsbue);
							sb.addEventListener('error', this.onsbe);
							sb.addEventListener('abort', this.onsba);
							this.tracks[trackName] = { codec: codec, container: track.container };
							sb.frags = []; //Mactrix addition
							track.buffer = sb;
						} catch (err) {
							_logger.logger.error('error while trying to add sourceBuffer:' + err.message);
							this.hls.trigger(_events2.default.ERROR, {
								type: _errors.ErrorTypes.MEDIA_ERROR,
								details: _errors.ErrorDetails.BUFFER_ADD_CODEC_ERROR,
								fatal: false,
								err: err,
								mimeType: mimeType
							});
						}
					}
				}
				this.hls.trigger(_events2.default.BUFFER_CREATED, { tracks: tracks });
			}
		}, {
			key: 'onBufferAppending',
			value: function onBufferAppending(data) {
				// Detect potential sync issues by detecting larger than expected differences between audio and video segments
				if (!this._syncChecked) {
					if (data.type === 'audio' && data.dts !== undefined && !this._firstAudioReceived) {
						this._firstAudioDts = data.dts;
						this._firstAudioStart = data.start;
						this._firstAudioReceived = true;
						//logger.log(`SEEKSYNC firstAudioDts :${this._firstAudioDts} firstAudioStartPTS :${this._firstAudioStart}`);
					} else if (data.type === 'video' && data.dts !== undefined && !this._firstVideoReceived) {
						this._firstVideoDts = data.dts;
						this._firstVideoStart = data.start;
						this._firstVideoReceived = true;
						//logger.log(`SEEKSYNC firstVideoDts :${this._firstVideoDts} firstVideoStartPTS :${this._firstVideoStart}`);
					}
					if (this._firstAudioReceived && this._firstVideoReceived) {
						var ptsDiff = (this._firstAudioStart - this._firstVideoStart) * 90000;
						var dtsDiff = Math.abs(this._firstVideoDts + ptsDiff - this._firstAudioDts);
						var maxDiff = data.targetDuration * 67500; // 75% of 90000
	
						//logger.log(`Detected Diff :${dtsDiff} : Max :${maxDiff}`);
	
						if (dtsDiff > maxDiff) {
							_logger.logger.warn('onBufferAppending STREAM_SYNC_FAILED');
							this.hls.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.MUX_ERROR, details: _errors.ErrorDetails.STREAM_SYNC_FAILED, fatal: false });
						}
						this._syncChecked = true;
					}
				}
	
				if (!this.segments) {
					this.segments = [data];
				} else {
					this.segments.push(data);
				}
				if (!this._needsFlush) {
					this.doAppending();
				} else {
					_logger.logger.log('onBufferAppending: flush needed. Flushing....');
					this.doFlush();
				}
			}
		}, {
			key: 'onBufferAppendFail',
			value: function onBufferAppendFail(data) {
				_logger.logger.error('sourceBuffer error:', data.event);
				// according to http://www.w3.org/TR/media-source/#sourcebuffer-append-error
				// this error might not always be fatal (it is fatal if decode error is set, in that case
				// it will be followed by a mediaElement error ...)
				this.hls.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.MEDIA_ERROR, details: _errors.ErrorDetails.BUFFER_APPENDING_ERROR, fatal: false });
			}
	
			// on BUFFER_EOS mark matching sourcebuffer(s) as ended and trigger checkEos()
	
		}, {
			key: 'onBufferEos',
			value: function onBufferEos(data) {
				var sb = this.sourceBuffer;
				var dataType = data.type;
				for (var type in sb) {
					if (!dataType || type === dataType) {
						if (!sb[type].ended) {
							sb[type].ended = true;
							_logger.logger.log(type + ' sourceBuffer now EOS');
						}
					}
				}
				this.checkEos();
			}
	
			// if all source buffers are marked as ended, signal endOfStream() to MediaSource.
	
		}, {
			key: 'checkEos',
			value: function checkEos() {
				var sb = this.sourceBuffer;
				var mediaSource = this.mediaSource;
				var sbNotEndedFound = false;
	
				if (!mediaSource || mediaSource.readyState !== 'open') {
					this._needsEos = false;
					return;
				}
	
				for (var type in sb) {
					if (type === 'audio' || type === 'video') {
						var sbobj = sb[type];
	
						/* Mactrix removed
	     	if (!sbobj.ended) {
	     		return;
	     	}
	     */
						if (sbobj.updating) {
							this._needsEos = true;
							return;
						}
	
						if (sbobj.ended) {
							this._sbEndedFound = true;
						} else if (this._sbEndedFound && this._needsEos) {
							sbobj.ended = true;
							_logger.logger.log(type + ' sourceBuffer now set to Ended');
						} else {
							sbNotEndedFound = true;
						}
					}
				}
				if (!this._sbEndedFound) {
					return;
				} else if (this._sbEndedFound && sbNotEndedFound) {
					this._needsEos = true;
					return;
				}
	
				_logger.logger.log('all media data available, signal endOfStream() to MediaSource and stop loading fragment');
				//Notify the media element that it now has all of the media data
				try {
					mediaSource.endOfStream();
				} catch (e) {
					_logger.logger.warn('exception while calling mediaSource.endOfStream()');
				}
				this._needsEos = false;
			}
		}, {
			key: 'onBufferFlushing',
			value: function onBufferFlushing(data) {
				this.readyForData = false;
				this.flushRange.push({ start: data.startOffset, end: data.endOffset, type: data.type });
				// attempt flush immediately
				this.doFlush();
			}
		}, {
			key: 'onLevelUpdated',
			value: function onLevelUpdated(event) {
				var details = event.details;
				if (details.fragments.length === 0) {
					return;
				}
	
				_logger.logger.log('onLevelUpdated details.totalduration:' + details.totalduration + ' details.fragments[0].start:' + details.fragments[0].start + ' event.sliding:' + event.sliding);
	
				//forbid seeking to start of sliding window by shifting start of window in by one target duration
				if (event.sliding) {
					this._playlistDuration = details.totalduration - details.targetduration;
				} else {
					this._playlistDuration = details.totalduration;
				}
	
				this._levelDuration = details.totalduration + details.fragments[0].start;
				this.updateMediaElementDuration();
	
				//this.hls.trigger(Event.LEVEL_DURATION_UPDATED, { playlistDuration: playlistDuration, totalDuration: this._levelDuration }); //Mactrix addition
				this.updateLevelDuration(); //Mactrix line added
			}
	
			//Mactrix additions start
			//factor audio in sliding window calculation
			//TODO: Move this, as well as onLevelUpdated/updateMediaElementDuration, to the stream coordinator
	
		}, {
			key: 'onAudioTrackUpdated',
			value: function onAudioTrackUpdated(event) {
				var details = event.details;
				if (details.fragments.length === 0) {
					return;
				}
	
				//logger.log(`onAudioTrackUpdated details.totalduration:${details.totalduration} details.fragments[0].start:${details.fragments[0].start} event.sliding:${event.sliding}`);
	
				if (event.sliding) {
					this._audioPlaylistDuration = details.totalduration - details.targetduration;
				} else {
					this._audioPlaylistDuration = details.totalduration;
				}
	
				this._audioTrackDuration = details.totalduration + details.fragments[0].start;
				this.updateMediaElementDuration();
				this.updateLevelDuration();
			}
		}, {
			key: 'updateLevelDuration',
			value: function updateLevelDuration() {
				if (this.hls.streamCoordinator._audioControllersActive && this._audioTrackDuration && this._audioPlaylistDuration) {
					var start = void 0;
					var end = void 0;
					var duration = void 0;
	
					if (this._levelDuration && this._playlistDuration) {
						end = Math.min(this._levelDuration, this._audioTrackDuration);
						start = Math.max(this._levelDuration - this._playlistDuration, this._audioTrackDuration - this._audioPlaylistDuration);
					} else {
						end = this._audioTrackDuration;
						start = this._audioTrackDuration - this._audioPlaylistDuration;
					}
					duration = end - start;
	
					//logger.log(`updateLevelDuration duration:${duration} totalDuration:${end} start:${start} this._levelDuration:${this._levelDuration} this._audioTrackDuration:${this._audioTrackDuration} this._playlistDuration:${this._playlistDuration} this._audioPlaylistDuration:${this._audioPlaylistDuration}`);
	
					this.hls.trigger(_events2.default.LEVEL_DURATION_UPDATED, { playlistDuration: duration, totalDuration: end });
				} else {
					//logger.log(`updateLevelDuration this._levelDuration:${this._levelDuration} this._audioTrackDuration:${this._audioTrackDuration} this._playlistDuration:${this._playlistDuration} this._audioPlaylistDuration:${this._audioPlaylistDuration}`);
	
					this.hls.trigger(_events2.default.LEVEL_DURATION_UPDATED, { playlistDuration: this._playlistDuration, totalDuration: this._levelDuration });
				}
			}
			//Mactrix additions end
	
			// https://github.com/video-dev/hls.js/issues/355
	
		}, {
			key: 'updateMediaElementDuration',
			value: function updateMediaElementDuration() {
				var media = this.media;
				var mediaSource = this.mediaSource;
				var sourceBuffer = this.sourceBuffer;
				var levelDuration = this._levelDuration;
	
				if (levelDuration === null || !media || !mediaSource || !sourceBuffer || media.readyState === 0 || mediaSource.readyState !== 'open') {
					return;
				}
	
				for (var type in sourceBuffer) {
					if (sourceBuffer[type].updating) {
						// can't set duration whilst a buffer is updating
						return;
					}
				}
	
				if (this._msDuration === null) {
					// initialise to the value that the media source is reporting
					this._msDuration = mediaSource.duration;
				}
	
				var duration = media.duration;
	
				// levelDuration was the last value we set.
				// not using mediaSource.duration as the browser may tweak this value
				// only update mediasource duration if its value increase, this is to avoid
				// flushing already buffered portion when switching between quality level
				if (levelDuration > this._msDuration && levelDuration > duration || duration === Infinity || isNaN(duration)) {
					_logger.logger.log('Updating mediasource duration to ' + levelDuration.toFixed(3));
					this._msDuration = mediaSource.duration = levelDuration;
				}
			}
		}, {
			key: 'doFlush',
			value: function doFlush() {
				var result = undefined;
				var flushComplete = false;
	
				if (this.flushRange) {
					_logger.logger.log('doFlush: ' + this.flushRange.length + ' in queue');
	
					// A successful valid remove will block the sourcebuffer so anything other than nothingToFlush
					// will exit this loop - SIEG
					while (this.flushRange.length && (result === undefined || result.wasUpdating === false && result.didError === false && result.didFlush === false)) {
						var range = this.flushRange[0];
	
						result = this.flushBuffer(range.start, range.end, range.type);
						if (result.didFlush || result.nothingToFlush || result.didError) {
							this.flushRange.shift();
						}
					}
	
					_logger.logger.log('doFlush: Post flush ' + this.flushRange.length + ' in queue');
	
					if (this.flushRange.length === 0 && (result === undefined || result && result.didFlush === false && result.nothingToFlush === true)) {
						// everything flushed and updated
						flushComplete = true;
						_logger.logger.log('doFlush: Flush completed');
					} else if (result && (result.wasUpdating || result.didFlush)) {
						//Flush hasn't finished yet really. Wait for SB update end to retrigger a flush
						this._needsFlush = true;
						_logger.logger.log('doFlush: waiting for last flush to complete');
					} else if (result && result.didError) {
						flushComplete = true;
						_logger.logger.warn('doFlush: Error while flushing');
					} else {
						flushComplete = true;
						_logger.logger.warn('doFlush: Failed to flush');
					}
				} else {
					flushComplete = true;
					_logger.logger.warn('doFlush: queue invalid');
				}
	
				if (flushComplete === true) {
					this._needsFlush = false;
					this.readyForData = true;
					//Clear flush buffer? - SIEG
					this.hls.trigger(_events2.default.BUFFER_FLUSHED);
				}
			}
		}, {
			key: 'doAppending',
			value: function doAppending() {
				var hls = this.hls;
				var sourceBuffer = this.sourceBuffer;
				var segments = this.segments;
	
				if (Object.keys(sourceBuffer).length) {
					if (this.media.error) {
						this.segments = [];
						_logger.logger.log('trying to append although a media error occurred, flush segment and abort');
						return;
					}
					if (this.appending) {
						//logger.log(`sb appending in progress`);
						return;
					}
					if (segments && segments.length) {
						var segment = segments.shift();
						try {
							var type = segment.type;
							var sb = sourceBuffer[type];
	
							if (sb) {
								if (!sb.updating) {
									// reset sourceBuffer ended flag before appending segment
									sb.ended = false;
									//logger.log(`appending ${segment.content} ${type} SB, size:${segment.data.length}, ${segment.parent}`);
	
									if (segment.sn !== undefined) {
										sourceBuffer[type].frags[segment.sn] = {
											level: segment.level,
											maxLevel: hls.autoLevelCapping,
											start: segment.start,
											end: segment.end
										};
									}
	
									this.parent = segment.parent;
									sb.appendBuffer(segment.data);
									this.appendError = 0;
									this.appended++;
									this.appending = true;
								} else {
									segments.unshift(segment);
								}
							} else {
								// in case we don't have any source buffer matching with this segment type,
								// it means that Mediasource fails to create sourcebuffer
								// discard this segment, and trigger update end
								this.onSBUpdateEnd();
							}
						} catch (err) {
							// in case any error occurred while appending, put back segment in segments table
							_logger.logger.warn('error while trying to append buffer:' + err.message);
							segments.unshift(segment);
							var event = { type: _errors.ErrorTypes.MEDIA_ERROR, parent: segment.parent };
							if (err.code !== 22) {
								if (this.appendError) {
									this.appendError++;
								} else {
									this.appendError = 1;
								}
								event.details = _errors.ErrorDetails.BUFFER_APPEND_ERROR;
	
								/*
	       	with UHD content, we could get loop of quota exceeded error until
	       	browser is able to evict some data from sourcebuffer. retrying help recovering this
	       */
	
								if (this.appendError > hls.config.appendErrorMaxRetry) {
									_logger.logger.log('fail ' + hls.config.appendErrorMaxRetry + ' times to append segment in sourceBuffer');
									segments = [];
									event.fatal = true;
									hls.trigger(_events2.default.ERROR, event);
									return;
								} else {
									event.fatal = false;
									hls.trigger(_events2.default.ERROR, event);
								}
							} else {
								// QuotaExceededError: http://www.w3.org/TR/html5/infrastructure.html#quotaexceedederror
								// let's stop appending any segments, and report BUFFER_FULL_ERROR error
								this.segments = [];
								event.details = _errors.ErrorDetails.BUFFER_FULL_ERROR;
								event.fatal = false;
								hls.trigger(_events2.default.ERROR, event);
								return;
							}
						}
					}
				}
			}
	
			/*
	  flush specified buffered range,
	  return true once range has been flushed.
	  as sourceBuffer.remove() is asynchronous, flushBuffer will be retriggered on sourceBuffer update end
	  */
	
		}, {
			key: 'flushBuffer',
			value: function flushBuffer(startOffset, endOffset, typeIn) {
				var sourceBuffer = this.sourceBuffer;
				var didFlush = false;
				var wasUpdating = false;
				var didError = false;
				var nothingToFlush = false;
	
				if (Object.keys(sourceBuffer).length) {
					_logger.logger.log('flushBuffer: pos:' + this.media.currentTime.toFixed(3) + ' start:' + startOffset + ' end:' + endOffset + ' type:' + typeIn);
					var sb = void 0;
	
					for (var type in sourceBuffer) {
						// check if sourcebuffer type is defined (typeIn): if yes, let's only flush this one
						// if no, let's flush all sourcebuffers
						if (typeIn && type !== typeIn) {
							continue;
						}
						sb = sourceBuffer[type];
						// we are going to flush buffer, mark source buffer as 'not ended'
						sb.ended = false;
						if (!sb.updating) {
							try {
								if (sb.buffered.length === 0) {
									nothingToFlush = true;
									_logger.logger.log('flushBuffer: Buffer empty');
								} else {
									var flushStart = startOffset;
									var flushEnd = endOffset;
	
									if (this._rangeByRangeFlush) {
										var rangeFound = this._nextRange(sb, startOffset, endOffset);
	
										if (rangeFound.success) {
											if (this._clampFlush === true && endOffset === Number.POSITIVE_INFINITY) {
												flushStart = rangeFound.start;
												flushEnd = rangeFound.end;
											} else {
												flushStart = Math.max(rangeFound.start, startOffset);
												flushEnd = Math.min(rangeFound.end, endOffset);
											}
										}
									}
	
									if (flushStart === Number.NEGATIVE_INFINITY || flushStart === 0) {
										flushStart = Math.max(sb.buffered.start(0), 0);
									}
									if (flushEnd === Number.POSITIVE_INFINITY) {
										flushEnd = sb.buffered.end(sb.buffered.length - 1);
									}
	
									if (flushEnd - flushStart > 0.01) {
										didFlush = true;
										_logger.logger.log('flushBuffer: requested flush for ' + type + ' [' + flushStart + ',' + flushEnd + '], pos:' + this.media.currentTime);
										sb.remove(flushStart, flushEnd);
									} else {
										nothingToFlush = true;
										_logger.logger.log('flushBuffer: nothing to flush in this range');
									}
								}
							} catch (e) {
								didError = true;
								_logger.logger.warn('flushBuffer: error while accessing sourcebuffer, it might have been removed from MediaSource');
							}
						} else {
							wasUpdating = true;
							_logger.logger.log('flushBuffer: cannot flush, ' + type + ' sb updating in progress');
						}
					}
				} else {
					//Is this even possible?
					nothingToFlush = true;
					_logger.logger.log('flushBuffer: Sourcebuffer has no buffers');
				}
	
				if (!didFlush && !didError && !nothingToFlush && !wasUpdating) {
					didError = true;
					_logger.logger.warn('flushBuffer: Unexpected state while flushing');
				}
	
				var result = { didFlush: didFlush, didError: didError, wasUpdating: wasUpdating, nothingToFlush: nothingToFlush };
	
				return result;
			}
	
			//critera for smart flush:
			//keep currently playing frag and next frag
			//keep anything at or above the current level
			//flush anything 2 or more below current level
			//if 1 below current level, check the max at that time, if at max, flush
	
		}, {
			key: 'flushLevels',
			value: function flushLevels(startOffset, endOffset, currentFrag) {
				var _this2 = this;
	
				_logger.logger.log('flushLevels');
	
				var currentLevel = this.hls.nextLoadLevel;
				var nextRange = { start: undefined, end: undefined };
				this.readyForData = false;
				this.hls.trigger(_events2.default.BUFFER_WAIT);
	
				var _loop = function _loop(type) {
					if (type === 'audio' || type === 'video') {
						_this2.sourceBuffer[type].frags.forEach(function (frag, sn, frags) {
							//we want to leave the current frag and the next alone
							if (Number(sn) === currentFrag || Number(sn) === currentFrag + 1 || Number(sn) === currentFrag - 1) {
								if (nextRange.start !== undefined) {
									_this2.flushRange.push({ start: nextRange.start, end: nextRange.end, type: type });
									nextRange.start = undefined;
									nextRange.end = undefined;
								}
								return;
							}
	
							if (frag === undefined) {
								//we've already flushed this one, ignore
								return;
							}
	
							var flushingFrag = false;
	
							if (frag.end > startOffset && frag.start < endOffset) {
								if (frag.level < currentLevel - 1) {
									//logger.log(`flushing ${sn}`);
									if (nextRange.start === undefined) {
										nextRange.start = frag.start;
									}
									nextRange.end = frag.end;
									flushingFrag = true;
									//this.flushRange.push({ start: frag.start, end: frag.end, type: type });
									frags[sn] = undefined;
								} else if (frag.level === currentLevel - 1) {
									if (frag.level === frag.maxLevel) {
										//logger.log(`flushing ${sn}`);
										if (nextRange.start === undefined) {
											nextRange.start = frag.start;
										}
										nextRange.end = frag.end;
										flushingFrag = true;
										//this.flushRange.push({ start: frag.start, end: frag.end, type: type });
										frags[sn] = undefined;
									}
								}
							}
	
							if (!flushingFrag && nextRange.start !== undefined) {
								_this2.flushRange.push({ start: nextRange.start, end: nextRange.end, type: type });
								nextRange.start = undefined;
								nextRange.end = undefined;
							}
						});
	
						if (nextRange.start !== undefined) {
							_this2.flushRange.push({ start: nextRange.start, end: nextRange.end, type: type });
							nextRange.start = undefined;
							nextRange.end = undefined;
						}
					}
				};
	
				for (var type in this.sourceBuffer) {
					_loop(type);
				}
	
				if (this.flushRange.length > 0) {
					this.doFlush();
				} else {
					this.readyForData = true;
					this.hls.trigger(_events2.default.BUFFER_FLUSHED);
				}
			}
		}, {
			key: 'doDetach',
			value: function doDetach() {
				this.mediaSource.removeEventListener('sourceopen', this.onmso);
				this.mediaSource.removeEventListener('sourceended', this.onmse);
				this.mediaSource.removeEventListener('sourceclose', this.onmsc);
	
				this.doRemoveSourceBuffer();
	
				// Detach properly the MediaSource from the HTMLMediaElement as
				// suggested in https://github.com/w3c/media-source/issues/53.
				if (this.media) {
					URL.revokeObjectURL(this.media.src);
					this.media.removeAttribute('src'); //causes MediaSourceClose
					this.media.load();
				}
				this.mediaSource = null;
	
				this.media = null;
				this.pendingTracks = {};
				this.tracks = {};
				this.flushRange = [];
				this.segments = [];
				this.onmso = this.onmse = this.onmsc = null;
				this.hls.trigger(_events2.default.MEDIA_DETACHED);
	
				this._needsDetach = false;
			}
		}, {
			key: 'doRemoveSourceBuffer',
			value: function doRemoveSourceBuffer() {
				var sourceBuffer = this.sourceBuffer;
				for (var type in sourceBuffer) {
					if (type === 'audio' || type === 'video') {
						var sb = sourceBuffer[type];
						try {
							sb.removeEventListener('updateend', this.onsbue);
							sb.removeEventListener('error', this.onsbe);
							sb.removeEventListener('abort', this.onsba);
							if (this.mediaSource.readyState === 'open' || this.mediaSource.readyState === 'ended') {
								this.mediaSource.removeSourceBuffer(sb);
							} else {
								_logger.logger.warn('doRemoveSourceBuffer: MediaSource is in an invalid state, probably closed. Would error or crash if we attempted to remove source buffer.');
							}
						} catch (err) {
							_logger.logger.error('doRemoveSourceBuffer: ' + err.message + ' while removing SourceBuffer');
						}
					}
				}
				sourceBuffer = {};
				this.sourceBuffer = {};
				this.appending = false;
			}
		}, {
			key: '_nextRange',
			value: function _nextRange(sb, startOffset, endOffset) {
				var i = 0;
				var success = false;
				var start = undefined;
				var end = undefined;
	
				for (i = 0; i < sb.buffered.length; i++) {
					start = sb.buffered.start(i);
					end = sb.buffered.end(i);
	
					start = startOffset;
					end = endOffset;
	
					if (Math.min(end, endOffset) - Math.max(start, startOffset) > 0.01) {
						success = true;
						break;
					}
				}
	
				var result = { success: success, start: start, end: end };
	
				return result;
			}
		}, {
			key: 'readyForData',
			set: function set(value) {
				if (!this.flushRange || this.flushRange && !(this.flushRange.length > 0)) {
					this._readyForData = value;
				} else {
					this._readyForData = false;
				}
			},
			get: function get() {
				return this._readyForData;
			}
		}]);
	
		return BufferController;
	}(_eventHandler2.default);
	
	exports.default = BufferController;
	module.exports = exports['default'];

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _events = __webpack_require__(3);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _eventHandler = __webpack_require__(5);
	
	var _eventHandler2 = _interopRequireDefault(_eventHandler);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * cap stream level to media size dimension controller
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */
	
	var CapLevelController = function (_EventHandler) {
		_inherits(CapLevelController, _EventHandler);
	
		function CapLevelController(hls) {
			_classCallCheck(this, CapLevelController);
	
			return _possibleConstructorReturn(this, (CapLevelController.__proto__ || Object.getPrototypeOf(CapLevelController)).call(this, hls, _events2.default.FPS_DROP_LEVEL_CAPPING, _events2.default.MEDIA_ATTACHING, _events2.default.MANIFEST_PARSED));
		}
	
		_createClass(CapLevelController, [{
			key: 'destroy',
			value: function destroy() {
				if (this.hls.config.capLevelToPlayerSize) {
					this.media = this.restrictedLevels = null;
					this.autoLevelCapping = Number.POSITIVE_INFINITY;
					if (this.timer) {
						this.timer = clearInterval(this.timer);
					}
				}
	
				//memory clean up
				_eventHandler2.default.prototype.destroy.call(this);
				this.hls = null;
			}
		}, {
			key: 'onFpsDropLevelCapping',
			value: function onFpsDropLevelCapping(data) {
				if (!this.restrictedLevels) {
					this.restrictedLevels = [];
				}
				if (!this.isLevelRestricted(data.droppedLevel)) {
					this.restrictedLevels.push(data.droppedLevel);
				}
			}
		}, {
			key: 'onMediaAttaching',
			value: function onMediaAttaching(data) {
				this.media = data.media instanceof HTMLVideoElement ? data.media : null;
			}
		}, {
			key: 'onManifestParsed',
			value: function onManifestParsed(data) {
				var hls = this.hls;
				if (hls.config.capLevelToPlayerSize) {
					this.autoLevelCapping = Number.POSITIVE_INFINITY;
					this.levels = data.levels;
					hls.firstLevel = this.getMaxLevel(data.firstLevel);
					clearInterval(this.timer);
					this.timer = setInterval(this.detectPlayerSize.bind(this), 1000);
					this.detectPlayerSize();
				}
			}
		}, {
			key: 'detectPlayerSize',
			value: function detectPlayerSize() {
				if (this.media) {
					var levelsLength = this.levels ? this.levels.length : 0;
					if (levelsLength) {
						var hls = this.hls;
						hls.autoLevelCapping = this.getMaxLevel(levelsLength - 1);
						if (hls.autoLevelCapping > this.autoLevelCapping) {
							// if auto level capping has a higher value for the previous one, flush the buffer using nextLevelSwitch
							// usually happen when the user go to the fullscreen mode.
							hls.streamController.nextLevelSwitch();
						}
						this.autoLevelCapping = hls.autoLevelCapping;
					}
				}
			}
	
			/*
	  * returns level should be the one with the dimensions equal or greater than the media (player) dimensions (so the video will be downscaled)
	  */
	
		}, {
			key: 'getMaxLevel',
			value: function getMaxLevel(capLevelIndex) {
				var result = 0;
	
				var mediaWidth = this.mediaWidth;
				var mediaHeight = this.mediaHeight;
	
				for (var i = 0; i <= capLevelIndex; i++) {
					var level = this.levels[i];
	
					if (this.isLevelRestricted(i)) {
						break;
					}
					result = i;
	
					if (mediaWidth <= level.width || mediaHeight <= level.height) {
						break;
					}
				}
	
				return result;
			}
		}, {
			key: 'isLevelRestricted',
			value: function isLevelRestricted(level) {
				return !!(this.restrictedLevels && this.restrictedLevels.indexOf(level) !== -1);
			}
		}, {
			key: 'contentScaleFactor',
			get: function get() {
				var pixelRatio = 1;
	
				try {
					pixelRatio = window.devicePixelRatio;
				} catch (e) {}
	
				return pixelRatio;
			}
		}, {
			key: 'mediaWidth',
			get: function get() {
				var width = void 0;
				var media = this.media;
	
				if (media) {
					width = media.width || media.clientWidth || media.offsetWidth;
					width *= this.contentScaleFactor;
				}
	
				return width;
			}
		}, {
			key: 'mediaHeight',
			get: function get() {
				var height = void 0;
				var media = this.media;
	
				if (media) {
					height = media.height || media.clientHeight || media.offsetHeight;
					height *= this.contentScaleFactor;
				}
	
				return height;
			}
		}]);
	
		return CapLevelController;
	}(_eventHandler2.default);
	
	exports.default = CapLevelController;
	module.exports = exports['default'];

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _events = __webpack_require__(3);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _eventHandler = __webpack_require__(5);
	
	var _eventHandler2 = _interopRequireDefault(_eventHandler);
	
	var _logger = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * FPS Controller
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */
	
	var FPSController = function (_EventHandler) {
		_inherits(FPSController, _EventHandler);
	
		function FPSController(hls) {
			_classCallCheck(this, FPSController);
	
			return _possibleConstructorReturn(this, (FPSController.__proto__ || Object.getPrototypeOf(FPSController)).call(this, hls, _events2.default.MEDIA_ATTACHING));
		}
	
		_createClass(FPSController, [{
			key: 'destroy',
			value: function destroy() {
				if (this.timer) {
					clearInterval(this.timer);
				}
	
				_eventHandler2.default.prototype.destroy.call(this); //Mactrix line added, memory clean up
				this.isVideoPlaybackQualityAvailable = false;
				this.hls = null; //Mactrix line added, memory clean up
			}
		}, {
			key: 'onMediaAttaching',
			value: function onMediaAttaching(data) {
				var config = this.hls.config;
	
				if (config.capLevelOnFPSDrop) {
					var video = this.video = data.media instanceof HTMLVideoElement ? data.media : null;
	
					if (typeof video.getVideoPlaybackQuality === 'function') {
						this.isVideoPlaybackQualityAvailable = true;
					}
	
					clearInterval(this.timer);
					this.timer = setInterval(this.checkFPSInterval.bind(this), config.fpsDroppedMonitoringPeriod);
				}
			}
		}, {
			key: 'checkFPS',
			value: function checkFPS(video, decodedFrames, droppedFrames) {
				var currentTime = performance.now();
	
				if (decodedFrames) {
					if (this.lastTime) {
						var currentPeriod = currentTime - this.lastTime;
						var currentDropped = droppedFrames - this.lastDroppedFrames;
						var currentDecoded = decodedFrames - this.lastDecodedFrames;
	
						var droppedFPS = 1000 * currentDropped / currentPeriod;
	
						var hls = this.hls;
	
						hls.trigger(_events2.default.FPS_DROP, {
							currentDropped: currentDropped,
							currentDecoded: currentDecoded,
							totalDroppedFrames: droppedFrames
						});
	
						if (droppedFPS > 0) {
							//logger.log('checkFPS : droppedFPS/decodedFPS:' + droppedFPS/(1000 * currentDecoded / currentPeriod));
							if (currentDropped > hls.config.fpsDroppedMonitoringThreshold * currentDecoded) {
								var currentLevel = hls.currentLevel;
								_logger.logger.warn('drop FPS ratio greater than max allowed value for currentLevel: ' + currentLevel);
								if (currentLevel > 0 && (hls.autoLevelCapping === -1 || hls.autoLevelCapping >= currentLevel)) {
									currentLevel = currentLevel - 1;
									hls.trigger(_events2.default.FPS_DROP_LEVEL_CAPPING, { level: currentLevel, droppedLevel: hls.currentLevel });
									hls.autoLevelCapping = currentLevel;
									hls.streamController.nextLevelSwitch();
								}
							}
						}
					}
					this.lastTime = currentTime;
					this.lastDroppedFrames = droppedFrames;
					this.lastDecodedFrames = decodedFrames;
				}
			}
		}, {
			key: 'checkFPSInterval',
			value: function checkFPSInterval() {
				var video = this.video;
	
				if (video) {
					if (this.isVideoPlaybackQualityAvailable) {
						var videoPlaybackQuality = video.getVideoPlaybackQuality();
						this.checkFPS(video, videoPlaybackQuality.totalVideoFrames, videoPlaybackQuality.droppedVideoFrames);
					} else {
						this.checkFPS(video, video.webkitDecodedFrameCount, video.webkitDroppedFrameCount);
					}
				}
			}
		}]);
	
		return FPSController;
	}(_eventHandler2.default);
	
	exports.default = FPSController;
	module.exports = exports['default'];

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _events = __webpack_require__(3);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _eventHandler = __webpack_require__(5);
	
	var _eventHandler2 = _interopRequireDefault(_eventHandler);
	
	var _logger = __webpack_require__(1);
	
	var _errors = __webpack_require__(4);
	
	var _bufferHelper = __webpack_require__(22);
	
	var _bufferHelper2 = _interopRequireDefault(_bufferHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Level Controller
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */
	
	var LevelController = function (_EventHandler) {
		_inherits(LevelController, _EventHandler);
	
		function LevelController(hls) {
			_classCallCheck(this, LevelController);
	
			var _this = _possibleConstructorReturn(this, (LevelController.__proto__ || Object.getPrototypeOf(LevelController)).call(this, hls, _events2.default.MANIFEST_LOADED, _events2.default.LEVEL_LOADED, _events2.default.FRAG_LOADED, _events2.default.STREAM_ALL_LEVELS_LOADED, _events2.default.ERROR));
	
			_this.ontick = _this.tick.bind(_this);
			_this._manualLevel = -1;
			_this._allLevelsLoaded = false;
			_this._pendingTimer = undefined;
			_this._levelsFailed = 0;
			_this._baseLevelFailed = undefined;
			_this._timersActive = 0;
			return _this;
		}
	
		_createClass(LevelController, [{
			key: 'destroy',
			value: function destroy() {
				this.stopLoad();
				this.clearTimer();
	
				_eventHandler2.default.prototype.destroy.call(this); //Mactrix line added, memory clean up
				this._manualLevel = -1;
	
				//memory clean up
				this._levels = null;
				this.ontick = null;
	
				//this.hls = null;
			}
		}, {
			key: 'clearTimer',
			value: function clearTimer() {
				if (this.timer) {
					clearTimeout(this.timer);
					this.timer = null;
					this._timersActive--;
				}
			}
		}, {
			key: 'incrementTimerCount',
			value: function incrementTimerCount() {
				this._timersActive++;
				if (this._timersActive > 1) {
					_logger.logger.warn('Timer leak in level controller, number of active timers: ' + this._timersActive);
				}
			}
		}, {
			key: 'startLoad',
			value: function startLoad() {
				this.canload = true;
				var levels = this._levels;
	
				// clean up live level details to force reload them, and reset load errors
				if (levels) {
					levels.forEach(function (level) {
						level.loadError = 0;
						var levelDetails = level.details;
						if (levelDetails && levelDetails.live && levels.length > 1) {
							level.details = undefined;
						}
					});
				}
	
				// speed up live playlist refresh if timer exists
				if (this.timer) {
					this.clearTimer();
					this.tick();
				}
			}
		}, {
			key: 'stopLoad',
			value: function stopLoad() {
				//Mactrix additions start
				//stop the tick when we stop loading
				//we only call stopLoad when we need to stop all functionality, so may as well halt timer here
				this.clearTimer();
				//Mactrix additions end
	
				this.canload = false;
			}
	
			//don't start reloading manifests until STREAM_ALL_LEVELS_LOADED
	
		}, {
			key: 'onStreamAllLevelsLoaded',
			value: function onStreamAllLevelsLoaded() {
				this._allLevelsLoaded = true;
				if (this._pendingTimer) {
					this.clearTimer();
					this.timer = setTimeout(this.ontick, this._pendingTimer);
					this.incrementTimerCount();
				}
			}
		}, {
			key: 'onManifestLoaded',
			value: function onManifestLoaded(data) {
				var hls = this.hls;
	
				// https://github.com/video-dev/hls.js/issues/332
				var brokenMp3InMp4 = hls.browChrome || hls.browFirefox;
	
				this._level = undefined; //Mactrix line added, reset level on new manifest
	
				// regroup redundant level together
				var bitrateSet = {};
				var levels0 = [];
				var videoCodecFound = false;
				var audioCodecFound = false;
				data.levels.forEach(function (level) {
					if (level.videoCodec) {
						videoCodecFound = true;
					}
	
					// erase audio codec info if browser does not support mp4a.40.34. demuxer will autodetect codec and fallback to mpeg/audio
					if (brokenMp3InMp4 && level.audioCodec && level.audioCodec.indexOf('mp4a.40.34') !== -1) {
						level.audioCodec = undefined;
					}
	
					if (level.audioCodec || level.attrs && level.attrs.AUDIO) {
						audioCodecFound = true;
					}
	
					var redundantLevelId = bitrateSet[level.bitrate];
					if (redundantLevelId === undefined) {
						bitrateSet[level.bitrate] = levels0.length;
						level.url = [level.url];
						level.urlId = 0;
						levels0.push(level);
					} else {
						levels0[redundantLevelId].url.push(level.url);
					}
				});
	
				// remove audio-only level if we also have levels with audio+video codecs signalled
				var levels = [];
				if (videoCodecFound && audioCodecFound) {
					levels0.forEach(function (level) {
						if (level.videoCodec) {
							levels.push(level);
						}
					});
				} else {
					levels = levels0;
				}
	
				// only keep level with supported audio/video codecs
				levels = levels.filter(function (level) {
					var audioCodec = level.audioCodec;
					var videoCodec = level.videoCodec;
	
					var checkSupported = function checkSupported(type, codec) {
						return MediaSource.isTypeSupported(type + '/mp4;codecs=' + codec);
					};
	
					return (!audioCodec || checkSupported('audio', audioCodec)) && (!videoCodec || checkSupported('video', videoCodec));
				});
	
				if (levels.length) {
					// start bitrate is the first bitrate of the manifest
					var bitrateStart = levels[0].bitrate;
	
					// sort level on bitrate
					levels.sort(function (a, b) {
						return a.bitrate - b.bitrate;
					});
					this._levels = levels;
	
					// find index of first level in sorted levels
					for (var i = 0; i < levels.length; i++) {
						if (levels[i].bitrate === bitrateStart) {
							this._firstLevel = i;
							_logger.logger.log('manifest loaded,' + levels.length + ' level(s) found, first bitrate:' + bitrateStart);
							break;
						}
					}
	
					hls.trigger(_events2.default.MANIFEST_PARSED, {
						levels: levels,
						firstLevel: this._firstLevel,
						stats: data.stats,
						audio: audioCodecFound,
						video: videoCodecFound,
						altAudio: data.audioTracks.length > 0
					});
				} else {
					hls.trigger(_events2.default.ERROR, {
						type: _errors.ErrorTypes.MEDIA_ERROR,
						details: _errors.ErrorDetails.MANIFEST_INCOMPATIBLE_CODECS_ERROR,
						fatal: true,
						url: hls.url,
						reason: 'no level with compatible codecs found in manifest'
					});
				}
			}
		}, {
			key: 'setLevelInternal',
			value: function setLevelInternal(newLevel) {
				var levels = this._levels;
				var hls = this.hls;
				// check if level idx is valid
				if (newLevel >= 0 && newLevel < levels.length) {
					// stopping live reloading timer if any
					this.clearTimer();
					if (this._level !== newLevel) {
						_logger.logger.log('switching to level ' + newLevel);
						this._level = newLevel;
						var levelProperties = levels[newLevel];
						levelProperties.level = newLevel;
	
						hls.trigger(_events2.default.LEVEL_SWITCHING, levelProperties);
					}
	
					var level = levels[newLevel];
					var levelDetails = level.details;
	
					// check if we need to load playlist for this level
	
					//Mactrix line changed, prevent redundant reloads of single manifest live streams
					if (!levelDetails || levelDetails.live === true && levels.length > 1) {
						// level not retrieved yet, or live playlist we need to (re)load it
						var urlId = level.urlId;
	
						hls.trigger(_events2.default.LEVEL_LOADING, {
							url: level.url[urlId],
							level: newLevel,
							id: urlId
						});
					}
				} else {
					// invalid level id given, trigger error
					hls.trigger(_events2.default.ERROR, {
						type: _errors.ErrorTypes.OTHER_ERROR,
						details: _errors.ErrorDetails.LEVEL_SWITCH_ERROR,
						level: newLevel,
						fatal: false,
						reason: 'invalid level idx'
					});
				}
			}
		}, {
			key: 'onError',
			value: function onError(data) {
				if (data.fatal) {
					return;
				}
	
				var details = data.details;
	
				var levelId = void 0;
				var levelError = false;
	
				// try to recover not fatal errors
				switch (details) {
					case _errors.ErrorDetails.FRAG_LOAD_ERROR:
					case _errors.ErrorDetails.FRAG_LOAD_TIMEOUT:
					case _errors.ErrorDetails.FRAG_LOOP_LOADING_ERROR:
					case _errors.ErrorDetails.KEY_LOAD_ERROR:
					case _errors.ErrorDetails.KEY_LOAD_TIMEOUT:
						//Mactix, this error handler doesn't do anything for audio frags
						if (data.frag.type !== 'audio') {
							levelId = data.frag.level;
						}
						break;
	
					case _errors.ErrorDetails.LEVEL_LOAD_ERROR:
					case _errors.ErrorDetails.LEVEL_LOAD_TIMEOUT:
						levelId = data.context.level;
						levelError = true;
						break;
	
					case _errors.ErrorDetails.REMUX_ALLOC_ERROR:
						levelId = data.level;
						break;
	
					default:
						break;
				}
	
				/*
	   	try to switch to a redundant stream if any available.
	   	if no redundant stream available, emergency switch down (if in auto mode and current level not 0)
	   	otherwise, we cannot recover this network error ...
	    */
				if (levelId !== undefined) {
	
					var level = this._levels[levelId];
	
					if (!level.loadError) {
						level.loadError = 1;
					} else {
						level.loadError++;
					}
	
					// if any redundant streams available and if we haven't try them all (level.loadError is reseted on successful frag/level load.
					// if level.loadError reaches nbRedundantLevel it means that we tried them all, no hope => let's switch down
					var nbRedundantLevel = level.url.length;
					if (nbRedundantLevel > 1 && level.loadError < nbRedundantLevel) {
						level.urlId = (level.urlId + 1) % nbRedundantLevel;
						level.details = undefined;
						_logger.logger.warn('level controller,' + details + ' for level ' + levelId + ': switching to redundant stream id ' + level.urlId);
					} else {
						var hls = this.hls;
						var media = hls.media;
						var mediaBuffered = media && _bufferHelper2.default.isBuffered(media, media.currentTime) && _bufferHelper2.default.isBuffered(media, media.currentTime + 0.5);
	
						if (this._levelsFailed === 0) {
							this._baseLevelFailed = levelId;
						}
						this._levelsFailed++;
	
						// we could try to recover if in auto mode and current level not lowest level (0)
						if (this.tryNextVariant(levelId, true)) {
							_logger.logger.warn('level controller,' + details + ': switch variant and retry fragment');
						} else if (this._manualLevel === -1 && details === (_errors.ErrorDetails.FRAG_LOAD_ERROR || details === _errors.ErrorDetails.FRAG_LOAD_TIMEOUT) && this._levelsFailed > 1) {
							//we've tried too many times, turn the frag we've been trying to load into a gap
							if (data.frag) {
								_logger.logger.warn('level controller,' + details + ': marking dead frag');
	
								hls.streamController.addToDeadFragList(data.frag.sn);
							}
						} else if (level && level.details && level.details.live) {
							_logger.logger.warn('level controller,' + details + ' on live stream, discard');
							if (levelError) {
								// reset this._level so that another call to set level() will retrigger a frag load
								this._level = undefined;
							}
							// other errors are handled by stream controller
						} else if (details === _errors.ErrorDetails.LEVEL_LOAD_ERROR || details === _errors.ErrorDetails.LEVEL_LOAD_TIMEOUT) {
	
							// 0.5 : tolerance needed as some browsers stalls playback before reaching buffered end
							if (mediaBuffered) {
								var retryDelay = hls.config.levelLoadingRetryDelay;
								_logger.logger.warn('level controller,' + details + ', but media buffered, retry in ' + retryDelay + 'ms');
								this.clearTimer();
								this.timer = setTimeout(this.ontick, retryDelay);
								this.incrementTimerCount();
							} else {
								_logger.logger.error('cannot recover ' + details + ' error');
								this._level = undefined;
	
								// stopping live reloading timer if any
								this.clearTimer();
	
								// switch error to fatal
								data.fatal = true;
							}
						}
	
						if (!data.fatal) {
							this.tick();
						}
					}
				}
			}
		}, {
			key: 'tryNextVariant',
			value: function tryNextVariant(levelId, calledByErrorHandler) {
				var hls = this.hls;
				var media = hls.media;
				var level = this._levels[levelId];
				var bufferInfo = { end: 0 };
				if (media) {
					bufferInfo = _bufferHelper2.default.bufferInfo(media, media.currentTime, 0);
				}
	
				if (this._baseLevelFailed === undefined) {
					this._baseLevelFailed = levelId;
				}
	
				var nbAllowedLevels = hls.maxAutoLevel - hls.minAutoLevel + 1;
				if (media && level.details && (!calledByErrorHandler || level.details.live || bufferInfo.end - media.currentTime >= level.details.averagetargetduration * 2) && this._manualLevel === -1 && this._levelsFailed < Math.min(nbAllowedLevels, hls.config.levelLoadingMaxRetry)) {
					var targetLevel = levelId;
					if (levelId <= this._baseLevelFailed) {
						//try to switch down
						targetLevel = levelId - 1;
						if (targetLevel < hls.minAutoLevel) {
							//if we have gone down as far as we can, return to the level we originally failed at and start going up
							targetLevel = Math.min(hls.maxAutoLevel, this._baseLevelFailed + 1);
						}
					} else {
						targetLevel = levelId + 1;
						if (targetLevel > hls.maxAutoLevel) {
							//if we have gone up as far as we can, return to the level we originally failed at
							//in general we shouldn't start going down after this - if being done by the error handler we'll have hit the error cap
							//and if being done by stream controller it'll stop switching variants once it realises it's back where it started
							targetLevel = Math.max(hls.minAutoLevel, this._baseLevelFailed);
						}
					}
					hls.nextAutoLevel = targetLevel;
					this.setLevelInternal(hls.nextAutoLevel);
	
					//if this was called by the error handler, the tick will happen later in the handler so we don't need to do it now
					if (!calledByErrorHandler) {
						this.tick();
					}
	
					return true;
				} else {
					//tell caller that we didn't switch variants
					return false;
				}
			}
	
			// reset level load error counter on successful frag loaded
	
		}, {
			key: 'onFragLoaded',
			value: function onFragLoaded(data) {
				var fragLoaded = data.frag;
				if (fragLoaded && fragLoaded.type === 'main') {
					var level = this._levels[fragLoaded.level];
					if (level) {
						level.loadError = 0;
					}
					this._levelsFailed = 0;
					this._baseLevelFailed = undefined;
				}
			}
		}, {
			key: 'onLevelLoaded',
			value: function onLevelLoaded(data) {
				var levelId = data.level;
	
				// only process level loaded events matching with expected level
				if (levelId === this._level) {
					var curLevel = this._levels[levelId];
					//there's not really any point to resetting the error count until we know we can load frags from this level
					//curLevel.loadError = 0;
	
					var newDetails = data.details;
					// if current playlist is a live playlist, arm a timer to reload it
					if (newDetails.live) {
						var reloadInterval = 1000 * (newDetails.averagetargetduration ? newDetails.averagetargetduration : newDetails.targetduration);
						var curDetails = curLevel.details;
						if (curDetails && newDetails.endSN === curDetails.endSN) {
							// follow HLS Spec, If the client reloads a Playlist file and finds that it has not
							// changed then it MUST wait for a period of one-half the target
							// duration before retrying.
							reloadInterval /= 2;
							_logger.logger.log('same live playlist, reload twice faster');
						}
						// decrement reloadInterval with level loading delay
						reloadInterval -= performance.now() - data.stats.trequest;
						// in any case, don't reload more than every second
						reloadInterval = Math.max(1000, Math.round(reloadInterval));
						_logger.logger.log('live playlist, reload in ' + reloadInterval + ' ms');
	
						//Mactrix, don't start reloading manifests until STREAM_ALL_LEVELS_LOADED
						if (this._allLevelsLoaded) {
							this.clearTimer();
							this.timer = setTimeout(this.ontick, reloadInterval);
							this.incrementTimerCount();
						} else {
							_logger.logger.log('delaying arming timer until STREAM_ALL_LEVELS_LOADED');
							this._pendingTimer = reloadInterval;
						}
					} else {
						this.clearTimer();
					}
				}
			}
		}, {
			key: 'tick',
			value: function tick() {
				var levelId = this._level;
				if (this._levels && levelId !== undefined && this.canload) {
					var level = this._levels[levelId];
					var urlId = level.urlId;
	
					this.hls.trigger(_events2.default.LEVEL_LOADING, {
						url: level.url[urlId],
						level: levelId,
						id: urlId
					});
				}
			}
		}, {
			key: 'chunkIDAtTime',
	
	
			//Mactrix addition start
	
			value: function chunkIDAtTime(time) {
				// HlsJs doesn't load in the fragment data for a level until it switches to that level, meaning that if called
				// too quickly after a level switch checking the current level might not work. So we try the current level first,
				// and if that doesn't work, then try every level in sequence
				var levels = this.levels;
				var level = this.level;
	
				if (levels && level) {
					var details = levels[level].details;
					if (details) {
						var fragments = details.fragments;
						var fragCount = fragments.length;
	
						for (var i = 0; i < fragCount; i++) {
							var fragment = fragments[i];
	
							if (time > fragment.start && time < fragment.start + fragment.duration) {
								return i;
							}
						}
					}
				}
	
				var levelsCount = levels.length;
				for (var _i = 0; _i < levelsCount; _i++) {
					var _details = levels[_i].details;
	
					if (_details) {
						var _fragments = _details.fragments;
						var _fragCount = _fragments.length;
	
						for (var j = 0; j < _fragCount; j++) {
							var _fragment = _fragments[j];
	
							if (time > _fragment.start && time < _fragment.start + _fragment.duration) {
								return j;
							}
						}
					}
				}
	
				// if all else fails, return -1
				return -1;
			}
		}, {
			key: 'endOfChunk',
			value: function endOfChunk(chunkID) {
				var levels = this.levels;
				var details = levels[this.level].details;
	
				try {
					if (details) {
						var fragment = void 0;
	
						if (chunkID > details.fragments.length) {
							fragment = details.fragments[details.fragments.length - 1];
						} else {
							fragment = details.fragments[chunkID];
						}
	
						return fragment.start + fragment.duration;
					}
	
					var levelsCount = levels.length;
					for (var i = 0; i < levelsCount; i++) {
						details = levels[i].details;
	
						if (details) {
							var _fragment2 = void 0;
	
							if (chunkID > details.fragments.length) {
								_fragment2 = details.fragments[details.fragments.length - 1];
							} else {
								_fragment2 = details.fragments[chunkID];
							}
	
							return _fragment2.start + _fragment2.duration;
						}
					}
					return 0;
				} catch (err) {
					return 0;
				}
			}
	
			//Mactrix addition end
	
		}, {
			key: 'levels',
			get: function get() {
				return this._levels;
			}
		}, {
			key: 'level',
			get: function get() {
				return this._level;
			},
			set: function set(newLevel) {
				var levels = this._levels;
	
				if (levels && levels.length > newLevel) {
					if (this._level !== newLevel || levels[newLevel].details === undefined) {
						this.setLevelInternal(newLevel);
					}
				}
			}
		}, {
			key: 'manualLevel',
			get: function get() {
				return this._manualLevel;
			},
			set: function set(newLevel) {
				this._manualLevel = newLevel;
				if (this._startLevel === undefined) {
					this._startLevel = newLevel;
				}
				if (newLevel !== -1) {
					this.level = newLevel;
				}
			}
		}, {
			key: 'firstLevel',
			get: function get() {
				return this._firstLevel;
			},
			set: function set(newLevel) {
				this._firstLevel = newLevel;
			}
		}, {
			key: 'startLevel',
			get: function get() {
				// hls.startLevel takes precedence over config.startLevel
				// if none of these values are defined, fallback on this._firstLevel (first quality level appearing in variant manifest)
				if (this._startLevel === undefined) {
					var configStartLevel = this.hls.config.startLevel;
					if (configStartLevel !== undefined) {
						return configStartLevel;
					} else {
						return this._firstLevel;
					}
				} else {
					return this._startLevel;
				}
			},
			set: function set(newLevel) {
				this._startLevel = newLevel;
			}
		}, {
			key: 'nextLoadLevel',
			get: function get() {
				if (this._manualLevel !== -1) {
					return this._manualLevel;
				} else {
					return this.hls.nextAutoLevel;
				}
			},
			set: function set(nextLevel) {
				this.level = nextLevel;
				if (this._manualLevel === -1) {
					this.hls.nextAutoLevel = nextLevel;
				}
			}
		}]);
	
		return LevelController;
	}(_eventHandler2.default);
	
	exports.default = LevelController;
	module.exports = exports['default'];

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _binarySearch = __webpack_require__(135);
	
	var _binarySearch2 = _interopRequireDefault(_binarySearch);
	
	var _bufferHelper = __webpack_require__(22);
	
	var _bufferHelper2 = _interopRequireDefault(_bufferHelper);
	
	var _demuxer = __webpack_require__(70);
	
	var _demuxer2 = _interopRequireDefault(_demuxer);
	
	var _events = __webpack_require__(3);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _eventHandler = __webpack_require__(5);
	
	var _eventHandler2 = _interopRequireDefault(_eventHandler);
	
	var _timeRanges = __webpack_require__(72);
	
	var _timeRanges2 = _interopRequireDefault(_timeRanges);
	
	var _errors = __webpack_require__(4);
	
	var _logger = __webpack_require__(1);
	
	var _muxjs = __webpack_require__(44);
	
	var _muxjs2 = _interopRequireDefault(_muxjs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Stream Controller
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */
	
	//for muxjs.mp4.tools
	
	
	__webpack_require__(78);
	
	var State = {
		STOPPED: 'STOPPED',
		IDLE: 'IDLE',
		KEY_LOADING: 'KEY_LOADING',
		FRAG_LOADING: 'FRAG_LOADING',
		FRAG_LOADING_WAITING_RETRY: 'FRAG_LOADING_WAITING_RETRY',
		WAITING_LEVEL: 'WAITING_LEVEL',
		PARSING: 'PARSING',
		PARSED: 'PARSED',
		BUFFER_FLUSHING: 'BUFFER_FLUSHING',
		ENDED: 'ENDED',
		ERROR: 'ERROR'
	};
	
	var StreamController = function (_EventHandler) {
		_inherits(StreamController, _EventHandler);
	
		function StreamController(hls) {
			_classCallCheck(this, StreamController);
	
			var _this = _possibleConstructorReturn(this, (StreamController.__proto__ || Object.getPrototypeOf(StreamController)).call(this, hls, _events2.default.MEDIA_ATTACHED, _events2.default.MEDIA_DETACHING, _events2.default.MANIFEST_LOADING, _events2.default.MANIFEST_PARSED, _events2.default.LEVEL_LOADED,
			//Mactrix additions start
			_events2.default.STREAM_ALL_LEVELS_LOADED, _events2.default.STREAM_DESYNC,
			//Mactrix additions end
			_events2.default.KEY_LOADED, _events2.default.FRAG_LOADED, _events2.default.FRAG_LOAD_EMERGENCY_ABORTED, _events2.default.FRAG_PARSING_INIT_SEGMENT, _events2.default.FRAG_PARSING_DATA, _events2.default.FRAG_PARSED, _events2.default.ERROR, _events2.default.AUDIO_TRACK_SWITCHING, _events2.default.AUDIO_TRACK_SWITCHED, _events2.default.BUFFER_CREATED, _events2.default.BUFFER_APPENDED, _events2.default.BUFFER_FLUSHED, _events2.default.BUFFER_WAIT, _events2.default.AUDIO_TRACK_UPDATED));
	
			_this.config = hls.config;
			_this._state = State.STOPPED;
			_this._demuxer = undefined;
	
			_this._ticks = 0;
			_this.ontick = _this.tick.bind(_this);
			_this._timer = undefined;
	
			_this._audioCodecSwap = false;
			_this._altAudio = false;
			_this._audioCodecSwitch = false;
	
			_this._endStallOffseter = 0;
			_this._streamTimeoutArmed = false;
			_this._playbackStarted = false;
			_this._fragBufferCount = 0;
			_this._fragLoadError = 0;
			_this._flushOnStoppedBuffering = [];
			/*this._bufferNextDuplicate = false;*/
	
			_this._slowDetachTicks = 0; //Backup if the seek does not complete
	
			_this._lastCurrentTime = undefined;
	
			_this._levels = [];
			_this._level = 0;
			_this._levelLastLoaded = undefined;
			_this._stats = undefined;
			_this._immediateSwitch = false;
	
			_this._startFragRequested = false;
			_this._loadedMetadata = false;
			_this._nextLoadPosition = undefined;
			_this._startPosition = undefined;
	
			_this.forceStopFetching = false;
			_this._fragCurrent = undefined;
			_this._fragPrevious = undefined;
			_this._fragLoadIdx = undefined;
			_this._fragLastKbps = undefined;
			_this._selectByPdt = false; //true;//hls.browSafari;
			_this._clearFragPrevious = false;
	
			_this._previouslyPaused = false;
			_this._stalled = false;
			_this._stallReported = false;
			_this._nudgeRetry = 0;
			_this._skipReloadDelay = false;
	
			_this.liveSyncPosition = 0;
			_this.initialPdt = undefined;
	
			_this._pendingBuffering = false;
			_this._appended = false;
	
			_this._gapCycleBase = undefined;
	
			_this._bufferBeforeSeekingTime = undefined;
			_this._bufferBeforeSeekingApplied = undefined;
			_this._waitForFlush = false;
	
			_this._audioGapSeeking = false;
	
			_this.videoBuffer = null;
	
			_this._parsingDataCount = 0;
			return _this;
		}
	
		_createClass(StreamController, [{
			key: 'destroy',
			value: function destroy() {
				this.stopLoad();
				if (this._timer) {
					clearInterval(this._timer);
					this._timer = null;
				}
				_eventHandler2.default.prototype.destroy.call(this);
				/*
	   this._state = State.STOPPED;
	   */
				//Mactrix changes and additions start
				//memory clean up
				this.config = null;
				this._levels = null;
				this.ontick = null;
				this._stats = null;
				this.videoBuffer = null;
				//this.hls = null;
				//Mactrix additions end
			}
	
			/* mactrix replace - new arguments
	    startLoad(startPosition) {
	  */
	
		}, {
			key: 'startLoad',
			value: function startLoad() {
				//Mactrix line changed, start time and LSSALT are now handled by the coordinator so this doesn't need arguments any more
	
				if (this._levels) {
					var hls = this.hls;
	
					this.stopLoad();
	
					this._level = -1;
					this._fragLoadError = 0;
					if (!this._startFragRequested) {
						// determine load level
						var startLevel = hls.startLevel;
						if (startLevel === -1) {
							// -1 : guess start Level by doing a bitrate test by loading first fragment of lowest quality level
							startLevel = 0;
							this._bitrateTest = true;
						}
						// set new level to playlist loader : this will trigger start level load
						// hls.nextLoadLevel remains until it is set to a new value or until a new frag is successfully loaded
						this._level = hls.nextLoadLevel = startLevel;
						this._loadedMetadata = false;
						hls.trigger(_events2.default.LEVEL_SELECTION_FINISHED);
					}
	
					this.state = State.IDLE;
				}
			}
	
			//Mactrix additions start
			//split load and fetch
	
		}, {
			key: 'onStreamAllLevelsLoaded',
			value: function onStreamAllLevelsLoaded(data) {
				if (!this._timer) {
					this._timer = setInterval(this.ontick, 100);
				}
	
				//Disabling this for now
	
				//resync level as we are now guaranteed to have the base PDT
				//this.adjustStartByBasePdt(this._levels[this._level].details, this.hls.streamCoordinator.basePdt);
	
				this._playbackStarted = false;
				this._streamTimeoutArmed = true;
	
				this._nextLoadPosition = this._startPosition = this._lastCurrentTime = data.startTime;
				this.tick();
	
				_logger.logger.log('onStreamAllLevelsLoaded MAIN this._startPosition: ' + this._startPosition + ' this._lastCurrentTime: ' + this._lastCurrentTime);
			}
	
			//fix desync
	
		}, {
			key: 'onStreamDesync',
			value: function onStreamDesync(data) {
				var i = void 0;
				var fragments = this._levels[this._level].details.fragments;
				var totalDropDuration = 0;
				var duration = fragments[0].manifestDuration;
	
				//sum the total duration that was removed, then sub that from all frags
				for (i = 0; fragments.length > 1 && fragments[0].pdt < data.pdtToAlignTo - data.variance; i++) {
					fragments.splice(0, 1);
					totalDropDuration += duration;
					duration = fragments[0].manifestDuration;
				}
	
				if (i > 0) {
					var j = void 0;
	
					_logger.logger.log('main PDT earlier than audio PDT, adjusting main timestamps');
	
					for (j = 0; j < fragments.length; j++) {
						fragments[j].index = j;
						fragments[j].start -= totalDropDuration;
						fragments[j].pdt -= totalDropDuration * 1000;
						fragments[j].sn -= i;
					}
	
					this._levels[this._level].details.endSN -= i;
				}
			}
			//Mactrix additions end
	
		}, {
			key: 'stopLoad',
			value: function stopLoad() {
				//Mactrix additions start
				//stop the tick when we stop loading
				//we only call stopLoad when we need to stop all functionality, so may as well halt timer here
				//if (this._timer) {
				//	clearInterval(this._timer);
				//	this._timer = null;
				//}
				// Removing this for now. interferes with Slow Detach Timeout
				//Mactrix additions end
	
				var frag = this._fragCurrent;
				if (frag) {
					_logger.logger.log('Video: resetting current frag load count as load was aborted');
					frag.loadCounter = 0;
					if (frag.loader) {
						frag.loader.abort();
					}
					this._fragCurrent = null;
				}
				this._fragPrevious = null;
				if (this._demuxer) {
					this._demuxer.destroy();
					this._demuxer = null;
				}
				this.state = State.STOPPED;
				this.timestampOffset = undefined;
			}
		}, {
			key: 'tick',
			value: function tick() {
				this._ticks++;
				if (this._ticks === 1) {
					this.doTick();
					if (this._ticks > 1) {
						setTimeout(this.tick, 1);
					}
					this._ticks = 0;
				}
			}
		}, {
			key: 'doTick',
			value: function doTick() {
				//Mactrix additions start
				//we're stalling, and have not successfully finished a load for too long, emit a stream timeout
				if (this.media) {
					var media = this.media;
					var mediaBuffered = 0;
					mediaBuffered = media.buffered.length;
	
					if ((this._streamTimeoutArmed || mediaBuffered === 0) && !this.forceStopFetching && (!media.paused && !media.ended || !this._playbackStarted) && (this.hls.streamCoordinator._mainTimedOut || this.hls.streamCoordinator._audioTimedOut)) {
						_logger.logger.error('stream has timed out');
						this.hls.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.NETWORK_ERROR, details: _errors.ErrorDetails.STREAM_TIMEOUT, fatal: true });
						return;
					}
				}
				//Mactrix additions end
	
				switch (this.state) {
					case State.ERROR:
						//don't do anything in error state to avoid breaking further ...
						break;
					case State.BUFFER_FLUSHING:
						// in buffer flushing state, reset fragLoadError counter
						this._fragLoadError = 0;
						break;
					case State.IDLE:
						// when this returns false there was an error and we shall return immediatly
						// from current tick
						if (!this._doTickIdle()) {
							return;
						}
						break;
					case State.WAITING_LEVEL:
						var level = this._levels[this._level];
						// check if playlist is already loaded
						if (level && level.details) {
							this.state = State.IDLE;
						}
						break;
					case State.FRAG_LOADING_WAITING_RETRY:
						var now = performance.now();
						var retryDate = this.retryDate;
						// if current time is gt than retryDate, or if media seeking let's switch to IDLE state to retry loading
						if (!retryDate || now >= retryDate || this.media && this.media.seeking) {
							_logger.logger.log('mediaController: retryDate reached, switch back to IDLE state');
							this.state = State.IDLE;
						}
						break;
					case State.STOPPED:
						// Mactrix addition start
						if (this.hls._inSlowDetach) {
							this._slowDetachTicks++;
							if (this._slowDetachTicks > 10) {
								//The ticks are 100ms. The seek should take under a second to play out. Even setting
								//this at 1 doesn't seem to give false timeouts, so 10 should be very safe.
								_logger.logger.log('slow detach idle');
								this.hls._doCompleteSlowDetach();
							}
						}
						break;
					// Mactrix addition end
					case State.FRAG_LOADING:
					case State.PARSING:
					case State.PARSED:
					case State.ENDED:
						break;
					default:
						break;
				}
				// check buffer
				this._checkBuffer();
			}
	
			// Ironically the "idle" state is the one we do the most logic in it seems ....
			// NOTE: Maybe we could rather schedule a check for buffer length after half of the currently
			//       played segment, or on pause/play/seek instead of naively checking every 100ms?
	
		}, {
			key: '_doTickIdle',
			value: function _doTickIdle() {
				var hls = this.hls;
				var config = hls.config;
				var media = this.media;
	
				// if video not attached AND
				// start fragment already requested OR start frag prefetch disable
				// exit loop
				// => if start level loaded and media not attached but start frag prefetch is enabled and start frag not requested yet, we will not exit loop
				if (this._levelLastLoaded !== undefined && !media && (this._startFragRequested || !config.startFragPrefetch)) {
					return true;
				}
	
				// if we have not yet loaded any fragment, start loading from start position
				var pos = void 0;
				if (this._bufferBeforeSeekingTime !== undefined && this._bufferBeforeSeekingApplied === false) {
					_logger.logger.log('main: using bufferBeforeSeeking');
					this._bufferBeforeSeekingApplied = true;
					pos = this._bufferBeforeSeekingTime;
					this._fragPrevious = null;
				} else if (this._loadedMetadata && this._bufferBeforeSeekingTime === undefined) {
					pos = media.currentTime;
				} else {
					pos = this._nextLoadPosition;
				}
				// determine next load level
				var level = hls.nextLoadLevel;
				var levelInfo = this._levels[level];
				var levelBitrate = levelInfo.bitrate;
				var maxBufLen = void 0;
	
				// compute max Buffer Length that we could get from this load level, based on level bitrate. don't buffer more than 60 MB and more than 30s
				if (levelBitrate) {
					maxBufLen = Math.max(8 * config.maxBufferSize / levelBitrate, config.maxBufferLength);
				} else {
					maxBufLen = config.maxBufferLength;
				}
				maxBufLen = Math.min(maxBufLen, config.maxMaxBufferLength);
	
				// determine next candidate fragment to be loaded, based on current position and end of buffer position
				// ensure up to `config.maxMaxBufferLength` of buffer upfront
	
				var bufferInfo = _bufferHelper2.default.bufferInfo(this.mediaBuffer ? this.mediaBuffer : media, pos, 0);
				var bufferLen = bufferInfo.len;
				// Stay idle if we are still with buffer margins
				if (bufferLen >= maxBufLen && this._bufferBeforeSeekingApplied !== true) {
					//logger.log('stream-controller: Buffer full; do not queue');
					return true;
				}
	
				// if buffer length is less than maxBufLen try to load a new fragment ...
				_logger.logger.trace('buffer length of ' + bufferLen.toFixed(3) + ' is below max of ' + maxBufLen.toFixed(3) + '. checking for more payload ...');
	
				// set next load level : this will trigger a playlist load if needed
				this._level = hls.nextLoadLevel = level;
	
				//stop emitting LEVEL_SELECTION_FINISHED here as we want to wait until after frag selection to update metrics
				//hls.trigger(Event.LEVEL_SELECTION_FINISHED);
	
				var levelDetails = levelInfo.details;
				// if level info not retrieved yet, switch state and wait for level retrieval
				// if live playlist, ensure that new playlist has been refreshed to avoid loading/try to load
				// a useless and outdated fragment (that might even introduce load error if it is already out of the live playlist)
				if (typeof levelDetails === 'undefined' || levelDetails.live && this._levelLastLoaded !== level) {
					this.state = State.WAITING_LEVEL;
					return true;
				}
	
				// we just got done loading the final fragment, check if we need to finalize media stream
				var fragPrevious = this._fragPrevious;
				if (!levelDetails.live && fragPrevious && fragPrevious.sn === levelDetails.endSN) {
	
					/* Mactrix replaced this...
	    		// if everything (almost) til the end is buffered, let's signal eos
	    		// we don't compare exactly media.duration === bufferInfo.end as there could be some subtle media duration difference
	    		// using half frag duration should help cope with these cases.
	    		// also cope with almost zero last frag duration (max last frag duration with 200ms) refer to https://github.com/video-dev/hls.js/pull/657
	    		if (media.duration - Math.max(bufferInfo.end,fragPrevious.start) <= Math.max(0.2,fragPrevious.duration/2)) {
	    with ... */
	
					// Mactrix replacement start
					// This attempts to break the EOS issue internally with no overhead other than at near EOS
					// Not my preferred solution but at the curremt moment the currentTime can around a second different between runs so
					// a cleaner method is difficult.
					if (this._lastCurrentTime === media.currentTime) {
						this._endStallOffseter += 0.2;
						//hls.trigger(Event.ERROR, {type: ErrorTypes.MEDIA_ERROR, details: 'endcheck ' + this._endStallOffseter + ' ' + media.duration +
						//' ' + media.currentTime, fatal: false});
					}
					if (media.duration - Math.max(bufferInfo.end, fragPrevious.start) <= Math.max(0.2, fragPrevious.duration / 2) + this._endStallOffseter || this._levels[this._level].deadFragList.length > 0 || this._levels[this._level].containsGaps) {
						//If we have gaps in the manifest this check isn't reliable
						// Mactrix replacement end
	
						// Finalize the media stream
						var data = {};
						if (this._altAudio) {
							data.type = 'video';
						}
						this.hls.trigger(_events2.default.BUFFER_EOS, data);
						this.state = State.ENDED;
						this._endStallOffseter = 0; // Mactrix addition
						return true;
					}
				}
	
				// if we have the levelDetails for the selected variant, lets continue enrichen our stream (load keys/fragments or trigger EOS, etc..)
				return this._fetchPayloadOrEos(pos, bufferInfo, levelDetails);
			}
		}, {
			key: '_fetchPayloadOrEos',
			value: function _fetchPayloadOrEos(pos, bufferInfo, levelDetails) {
				var level = this._level;
				var fragments = levelDetails.fragments;
				var fragLen = fragments.length;
	
				// empty playlist
				if (fragLen === 0) {
					return false;
				}
	
				// find fragment index, contiguous with end of buffer position
				var start = fragments[0].start;
				var end = fragments[fragLen - 1].start + fragments[fragLen - 1].duration;
				var bufferEnd = bufferInfo.end;
				var frag = void 0;
	
				if (levelDetails.initSegment && !levelDetails.initSegment.data) {
					frag = levelDetails.initSegment;
				} else {
					//Mactrix changes begin: disable for now, Don't think it's correct
					/*
	    if(this.pdtDiff === undefined && this.initialPdt && this.hls.audioStreamController && this.hls.audioStreamController.initialPdt) {
	    	this.pdtDiff = this.initialPdt - this.hls.audioStreamController.initialPdt;
	    		if(this.pdtDiff < 0 && fragments.length > 1) {
	    		this._pdtAlign(fragments, levelDetails);
	    	}
	    }
	    */
					//Mactrix changes end
	
					// in case of live playlist we need to ensure that requested position is not located before playlist start
					if (levelDetails.live) {
						var initialLiveManifestSize = this.config.initialLiveManifestSize;
						if (fragLen < initialLiveManifestSize) {
							_logger.logger.warn('Can not start playback of a level, reason: not enough fragments ' + fragLen + ' < ' + initialLiveManifestSize);
							return false;
						}
	
						/* Mactrix remove: not doing this for now
	     	frag = this._ensureFragmentAtLivePoint(levelDetails, bufferEnd, start, end, fragPrevious, fragments, fragLen);
	     */
	
						// if it explicitely returns null don't load any fragment and exit function now
						if (frag === null) {
							return false;
						}
					} else {
						// VoD playlist: if bufferEnd before start of playlist, load first fragment
						if (bufferEnd < start) {
							frag = fragments[0];
						}
					}
				}
				//Mactrix additions start
				if (this.forceStopFetching === true) {
					return true;
				}
				//Mactrix additions end
				if (!frag) {
					var buffer = this.mediaBuffer;
	
					// After the buffer is created (which is after the initial frag(s) is/are buffered) mediabuffer should be
					// correct for the renditions and in mux cases , but the way it is set should be investigated
					//if (this._altAudio) {
					//	if (this.videoBuffer && buffer !== this.videoBuffer) {
					//		console.log(`corrected buffer before findFragment${this.videoBuffer}`);
					//		buffer = this.videoBuffer;
					//	}
					//}
	
					var findFragResults = this._findFragment(start, this._fragPrevious, fragLen, fragments, bufferEnd, end, levelDetails, pos, this._clearFragPrevious, buffer);
					frag = findFragResults.frag;
					this._clearFragPrevious = findFragResults.clearFragPrevious;
					this._fragPrevious = findFragResults.fragPrevious;
				}
	
				if (frag) {
					//try to level switch around a gap
					//we'll stop switching if
					//- we run out of variants to try
					//- we're too close to the end of the buffer
					//- the level controller is currently in the middle of dropping dead frags
					if (frag.gap && this._gapCycleBase !== this._level && this._fragPrevious && frag.sn !== this._fragPrevious.sn + 1) {
						if (this._gapCycleBase === undefined) {
							this._gapCycleBase = this._level;
						}
	
						if (this.hls.levelController.tryNextVariant(this._level, false)) {
							this.state = State.WAITING_LEVEL;
							return true;
						}
					}
					if (!this._fragPrevious || !this._fragPrevious.pdt || !frag.pdt || this._fragPrevious.pdt !== frag.pdt) {
						/* Mactrix changes begin: flush the next buffered range if the current buffered range will intersect with it
	     	let media = this.media;
	     		if(media && media.buffered.length > 1) {
	     		let i;
	     			for(i = 0; i < media.buffered.length; i++) {
	     			if (bufferEnd + 0.2 + frag.duration >= media.buffered.start(i) && bufferEnd + 0.2 + frag.duration < media.buffered.end(i)) {
	     				//Does this have to be the end of the buffered range, we could just flush start(i) + frag.duration?
	     				//Don't want to run into manifest time v ts time issues and having to do a .2 fudge so leaving it at end(i)
	     				this.hls.trigger(Event.BUFFER_FLUSHING, {startOffset: media.buffered.start(i), endOffset: media.buffered.end(i)});
	     				break;
	     			}
	     		}
	     	}
	     */
						this.hls.trigger(_events2.default.FRAG_START_FOUND, { startPdt: frag.pdt });
						return this._loadFragmentOrKey(frag, level, levelDetails, pos, bufferEnd);
					}
				}
	
				return true;
			}
	
			//Mactrix changes begin: align frags to start from the same pdt when starting a stream
	
		}, {
			key: '_pdtAlign',
			value: function _pdtAlign(fragments, trackDetails) {
				//variance is 1/2 a manifest duration
				//using frag current here always assumes that the video will load first .. is this true??
				//let variance = this.hls.streamController.fragCurrent.manifestDuration * 500;
				//just base this off the first frag audio duration ... not right but should be close enough
				var variance = fragments[0].manifestDuration * 500;
				var i = void 0;
				var pdtToAlignTo = void 0;
				var controller = void 0;
	
				if (fragments[0].type === 'main') {
					pdtToAlignTo = this.hls.audioStreamController.initialPdt;
					controller = this;
				} else {
					pdtToAlignTo = this.initialPdt;
					controller = this.hls.audioStreamController;
				}
	
				//audio is behind video, drop frags until we are inside the 1/2 frag variance
				//if we can't sync, we'll leave one frag in the chamber ... we'll be out of sync ... not much else we can do!
				for (i = 0; fragments.length > 1 && fragments[0].pdt < pdtToAlignTo - variance; i++) {
					controller.initialPdt += fragments[0].manifestDuration * 1000;
					fragments.splice(0, 1);
				}
	
				if (i > 0) {
					//adjust the metadata of the remaining frags
					fragments[0].start = 0;
					fragments[0].index = 0;
					fragments[0].pdt = controller.initialPdt;
					fragments[0].sn -= i;
					trackDetails.endSN -= i;
	
					for (i = 1; i < fragments.length; i++) {
						fragments[i].start = fragments[i - 1].start + fragments[i - 1].duration;
						fragments[i].pdt = fragments[i - 1].pdt + fragments[i - 1].manifestDuration * 1000;
						fragments[i].index = i;
						fragments[i].sn = fragments[i - 1].sn + 1;
					}
				}
			}
			//Mactrix changes end
	
			//Mactrix changes begin: use a sub optimal pdt linear search until binary search is fixed
	
		}, {
			key: '_linearSearch',
			value: function _linearSearch(fragments, fragPrevious, millisTarget, snapToNearestFrag) {
				var frag = void 0;
	
				for (var i = 0; i < fragments.length; i++) {
					var millisCurrent = fragments[i].pdt;
					var millisNext = millisCurrent + fragments[i].manifestDuration * 1000;
	
					if (millisNext <= millisTarget) {
						continue;
					}
	
					var millisMidpoint = (millisCurrent + millisNext) / 2;
	
					if (millisMidpoint < millisTarget && snapToNearestFrag === true) {
						//logger.log(`_linearSearch: millisMidpoint < millisTarget - ${(millisMidpoint - this.initialPdt)} : ${(millisTarget - this.initialPdt)}`);
						continue;
					}
	
					if (fragPrevious && fragPrevious.pdt && fragPrevious.pdt === fragments[i].pdt) {
						continue;
					}
					/*
	    		if (fragPrevious) {
	    			//allow 1/2 a manifest duration to account for any pdt errors
	    			let variance = (fragments[i].manifestDuration * 1000) / 2;
	    
	    			if(fragPrevious.pdt >= fragments[i].pdt - variance && fragPrevious.pdt <= fragments[i].pdt + variance) {
	    				console.log('@@ _linearSearch frag falls within variance, treating as duplicate');
	    				continue;
	    			}
	    		}
	    */
					//logger.log(`_linearSearch: name: ${fragments[i].relurl} millisCurrent: ${(millisCurrent - this.initialPdt)} millisTarget: ${(millisTarget - this.initialPdt)}`);
	
					frag = fragments[i];
					break;
				}
	
				return frag;
			}
			//Mactrix changes
	
		}, {
			key: '_ensureFragmentAtLivePoint',
			value: function _ensureFragmentAtLivePoint(levelDetails, bufferEnd, start, end, fragPrevious, fragments /*, fragLen*/) {
				/* Mactrix line removed - variable no longer used in this function
	   const config = this.hls.config;
	   */
				var media = this.media;
	
				var frag = void 0;
	
				// check if requested position is within seekable boundaries :
				//logger.log(`start/pos/bufEnd/seeking:${start.toFixed(3)}/${pos.toFixed(3)}/${bufferEnd.toFixed(3)}/${this.media.seeking}`);
	
				/*	let maxLatency = config.liveMaxLatencyDuration !== undefined ? config.liveMaxLatencyDuration
	   		: config.liveMaxLatencyDurationCount * levelDetails.targetduration;
	   */
				/* Mactrix lines removed - we want the program invoking BAM HLS to choose how to handle this situation
	   if (bufferEnd < Math.max(start-config.maxFragLookUpTolerance, end - maxLatency)) {
	   	let liveSyncPosition = this.liveSyncPosition = this.computeLivePosition(start, levelDetails);
	   	logger.log(`buffer end: ${bufferEnd.toFixed(3)} is located too far from the end of live sliding playlist, reset currentTime to : ${liveSyncPosition.toFixed(3)}`);
	   	bufferEnd = liveSyncPosition;
	   	if (media && media.readyState && media.duration > liveSyncPosition) {
	   	  media.currentTime = liveSyncPosition;
	   	}
	   }
	   */
	
				// if end of buffer greater than live edge, don't load any fragment
				// this could happen if live playlist intermittently slides in the past.
				// level 1 loaded [182580161,182580167]
				// level 1 loaded [182580162,182580169]
				// Loading 182580168 of [182580162 ,182580169],level 1 ..
				// Loading 182580169 of [182580162 ,182580169],level 1 ..
				// level 1 loaded [182580162,182580168] <============= here we should have bufferEnd > end. in that case break to avoid reloading 182580168
				// level 1 loaded [182580164,182580171]
				//
				// don't return null in case media not loaded yet (readystate === 0)
				if (levelDetails.PTSKnown && bufferEnd > end && media && media.readyState) {
					return null;
				}
	
				if (this._startFragRequested && !levelDetails.PTSKnown) {
					/*
	    	we are switching level on live playlist, but we don't have any PTS info for that quality level ...
	    	try to load frag matching with next SN.
	    	even if SN are not synchronized between playlists, loading this frag will help us
	    	compute playlist sliding and find the right one after in case it was not the right consecutive one
	    */
					if (fragPrevious) {
						//Mactrix changes begin: select the frag based on the pdt if it exists
						if (this._selectByPdt && fragPrevious.pdt !== undefined && fragments[0].pdt !== undefined) {
	
							/* searchByPdt is used by the binary-search
	      	let searchByPdt = (candidate) => {
	      //
	      //	6.2.  Server Responsibilities
	      	//	6.2.4.  Providing Variant Streams
	      	//	If any Media Playlist in a Master Playlist contains an EXT-X
	      //	-PROGRAM-DATE-TIME tag, then all Media Playlists in that Master
	      //	Playlist MUST contain EXT-X-PROGRAM-DATE-TIME tags with consistent
	      //	mappings of date and time to media timestamps.
	      //
	      		if(candidate.pdt !== undefined) {
	      	//we need to search for the candidate which is the first chunk after bufferEnd
	      	//As long as the error between bufferEnd(transport stream time) and the candidate
	      	//pdt (manifest time) is less than 1/2 a chunk duration (which it should be!) then
	      	//we don't need to account for this error since the pdt tolerance of 1/2 a chunk should cover it
	      			let millisDuration = candidate.manifestDuration * 1000;
	      			let millisCurrent = candidate.pdt;
	      			let millisNext = millisCurrent + millisDuration;
	      			let millisTarget = fragPrevious.pdt + fragPrevious.manifestDuration * 1000;
	      				if (millisNext <= millisTarget) {
	      				return 1;
	      			}
	      			else {
	      				let midpointMillis = (millisCurrent + millisNext) / 2;
	      					if(midpointMillis >= millisTarget) {
	      					if(midpointMillis - millisTarget < (millisDuration)) {
	      				//this.previousPdt = candidate.pdt;
	      				//logger.log(`_ensureFragmentAtLivePoint mp > mt searchByPdt - sn: ${candidate.sn} pdt: ${candidate.pdt} name: ${candidate.relurl} mpm ${midpointMillis} mt: ${millisTarget} md: ${millisDuration}`);
	      						return 0;
	      					}
	      					else {
	      						return -1;
	      					}
	      				}
	      				else {
	      			//this.previousPdt = candidate.pdt;
	      			//logger.log(`_ensureFragmentAtLivePoint mp < mt searchByPdt - sn: ${candidate.sn} pdt: ${candidate.pdt} name: ${candidate.relurl}`);
	      						return 1;
	      				}
	      			}
	      		}
	      		else {
	      	//if the previous frag has a pdt then all candidates must have a pdt
	      			logger.warn(`_ensureFragmentAtLivePoint fragPrevious has a pdt but candidate frag does not!`);
	      	//set error and fall back to media sequence
	      			return 0;
	      		}
	      	};
	      		*/
	
							//frag = BinarySearch.search(fragments, searchByPdt);
	
							//use sub optimal linear search until binary search can be fixed
							//once binary search is fixed we can enable pdts across all browsers not just Safari
							frag = this._linearSearch(fragments, fragPrevious, fragPrevious.pdt + fragPrevious.manifestDuration * 1000, true);
						} else {
							//Mactrix changes end
							var targetSN = fragPrevious.sn + 1;
							if (targetSN >= levelDetails.startSN && targetSN <= levelDetails.endSN) {
								frag = fragments[targetSN - levelDetails.startSN];
	
								//Mactrix changes begin
								if (fragPrevious.pdt && frag.pdt && fragPrevious.pdt === frag.pdt) {
									//the selector choose the same frag, either we are at the end of the list ... set it to null
									//or what we really want is the next frag
									if (frag.index < fragments.length - 1) {
										frag = fragments[frag.index + 1];
									} else {
										frag = undefined;
									}
								}
								//Mactrix changes end
								_logger.logger.log('live playlist, switching playlist, load frag with next SN: ' + frag.sn);
							}
							//Mactrix changes begin
						}
						//Mactrix changes end
					} else {
							/*Mactrix remove: Only guess when we have no previous frag
	      		  logger.log('**_ensureFragmentAtLivePoint No frag previous!');
	      	  }
	      	  if (!frag) {
	      */
							/* we have no idea about which fragment should be loaded.
	         so let's load mid fragment. it will help computing playlist sliding and find the right one
	      */
							/*
	      		console.log('@@ live playlist, switching playlist, unknown, load middle frag');
	      		frag = fragments[Math.min(fragLen - 1, Math.round(fragLen / 2))];
	      		logger.log(`live playlist, switching playlist, unknown, load middle frag : ${frag.sn}`);
	      */
						}
				}
				return frag;
			}
	
			//Mactrix changes begin
	
			//this is done by start time .... add a pdt version if required
	
		}, {
			key: 'bufferEndToManifestTimeBrute',
			value: function bufferEndToManifestTimeBrute(fragments, bufferEnd) {
				var myBufferEnd = bufferEnd;
				var count = 0;
	
				for (count = 0; count < fragments.length; count++) {
					//we will clamp the bufferEnd to the startTime of the frag if it is within
					//20% of the manifestDuration
					var variance = fragments[count].manifestDuration / 5;
	
					if (myBufferEnd > fragments[count].start - variance && myBufferEnd < fragments[count].start + variance) {
						myBufferEnd = fragments[count].start;
						break;
					}
				}
	
				return myBufferEnd;
			}
		}, {
			key: 'bufferEndToManifestTimeViaPdt',
			value: function bufferEndToManifestTimeViaPdt(fragments, bufferEnd, targetDuration) {
				//this should give an approx index into the frags array for the frag at the end of the buffered range
				//the closer the targetDuration to the average frag duration the more accurate.
				var index = Math.round(bufferEnd / targetDuration);
				var myBufferEnd = bufferEnd;
	
				if (index >= 0 && index < fragments.length) {
					//we will clamp the bufferEnd to the startTime of the frag if it is within
					//20% of the manifestDuration
					var variance = fragments[index].manifestDuration / 5 * 1000;
					var basePdt = 0;
	
					//should really pass this in
					if (fragments[0].type === 'main') {
						basePdt = new Date(this.hls.streamCoordinator._mainBasePdt).getTime();
					} else {
						basePdt = new Date(this.hls.streamCoordinator._audioBasePdt).getTime();
					}
	
					//convert to pdt
					myBufferEnd = basePdt + bufferEnd * 1000;
	
					if (myBufferEnd > fragments[index].pdt + variance) {
						while (index < fragments.length && myBufferEnd > fragments[index].pdt + variance) {
							//console.log('## fragment[index] too early, moving forward');
							index++;
						}
	
						if (index >= fragments.length) {
							index = fragments.length - 1;
						}
					} else {
						while (index >= 0 && myBufferEnd < fragments[index].pdt - variance) {
							//console.log('## fragment[index] too late, moving backward');
							index--;
						}
	
						if (index < 0) {
							index = 0;
						}
					}
	
					//console.log('## bufferEnd: ' + myBufferEnd + ' manifestEnd: ' + fragments[index].pdt);
					myBufferEnd = fragments[index].start;
				} else {
					if (index === fragments.length) {
						myBufferEnd = fragments[fragments.length - 1].start + fragments[fragments.length - 1].manifestDuration;
					} else {
						//logger.warn(`## streamController: index out of range, bufferEnd of ${myBufferEnd} remains unchanged`);
					}
				}
	
				return myBufferEnd;
			}
		}, {
			key: 'bufferEndToManifestTimeViaStart',
			value: function bufferEndToManifestTimeViaStart(fragments, bufferEnd, targetDuration) {
				//this should give an approx index into the frags array for the frag at the end of the buffered range
				//the closer the targetDuration to the average frag duration the more accurate.
				var index = Math.round(bufferEnd / targetDuration);
				var myBufferEnd = bufferEnd;
				var offset = -fragments[0].start;
	
				if (index >= 0 && index < fragments.length) {
					//we will clamp the bufferEnd to the startTime of the frag if it is within
					//20% of the manifestDuration
					var variance = fragments[index].manifestDuration / 5;
	
					if (myBufferEnd > fragments[index].start + offset + variance) {
						while (index < fragments.length && myBufferEnd > fragments[index].start + offset + variance) {
							//console.log('## fragment[index] too early, moving forward');
							index++;
						}
	
						if (index >= fragments.length) {
							index = fragments.length - 1;
						}
					} else {
						while (index >= 0 && myBufferEnd < fragments[index].start + offset - variance) {
							//console.log('## fragment[index] too late, moving backward');
							index--;
						}
	
						if (index < 0) {
							index = 0;
						}
					}
	
					//console.log('## bufferEnd: ' + myBufferEnd + ' manifestEnd: ' + (fragments[index].start + offset));
	
					myBufferEnd = fragments[index].start + offset;
	
					//
					//this could now be used to pick the next fragment, since the frag we want is the one after bufferEnd - test this
					//	nextFrag = index < fragments.length - 1 ? fragments[index + 1] : null;
					//
				} else {
					if (index === fragments.length) {
						myBufferEnd = fragments[fragments.length - 1].start + fragments[fragments.length - 1].manifestDuration;
					} else {
						//logger.warn(`## streamController: index out of range, bufferEnd of ${myBufferEnd} remains unchanged`);
					}
				}
	
				return myBufferEnd;
			}
		}, {
			key: 'bufferEndToManifestTime',
			value: function bufferEndToManifestTime(fragments, bufferEnd, targetDuration) {
				var myBufferEnd = bufferEnd;
	
				if (this.hls.streamCoordinator._mainBasePdt) {
					myBufferEnd = this.bufferEndToManifestTimeViaPdt(fragments, bufferEnd, targetDuration);
				} else {
					if (fragments[0].start === 0) {
						//not correct with a non-zero offset ... investigate
						myBufferEnd = this.bufferEndToManifestTimeViaStart(fragments, bufferEnd, targetDuration);
					} else {
						//use the brute force version in the non-pdt case until until bufferEndToManifestTimeViaStart is fixed
						myBufferEnd = this.bufferEndToManifestTimeBrute(fragments, bufferEnd);
					}
				}
	
				return myBufferEnd;
			}
			//Mactrix changes end
	
			//Used by both controllers, and ultimately might be better in another module with increased isolation
			//Return value have been changed from a simple frag to a structure so values can be passed back without
			//changing passed in params
	
		}, {
			key: '_findFragment',
			value: function _findFragment(start, fragPreviousIn, fragLen, fragments, desiredTime, end, levelDetails, pos, clearFragPreviousIn, media) {
				var config = this.hls.config;
				var frag = null;
				var foundFrag = false;
				var maxFragLookUpTolerance = config.maxFragLookUpTolerance;
				var bestCandidate = null;
				var fragPrevious = fragPreviousIn;
				var clearFragPrevious = clearFragPreviousIn;
	
				var foundNext = false;
				var foundBinary = false;
				var previouslyNoPrevious = false;
				var noNewFrag = false;
				var endOfPlaylist = false;
				var foundSwitch = false;
				var foundPdtNext = false;
	
				if (fragPrevious) {
					//this.media.currentTime was changed to pos here
					if (!_bufferHelper2.default.isBuffered(media, pos) && (fragPrevious.start > pos || fragPrevious.start + levelDetails.targetduration * 2 < pos) || clearFragPrevious) {
						//got it wrong, try again
						if (fragPrevious.type !== 'audio' || this.isThereAnAudioGap(pos, false) !== undefined) {
							_logger.logger.log('_findFragment: Clearing fragPrevious for ' + fragPrevious.type);
							fragPrevious = null;
							clearFragPrevious = false;
						}
					}
				} else {
					previouslyNoPrevious = true;
				}
	
				//Mactrix changes begin
				//don't do this while seeking .... we shouldn't be searching for fragments while seeking anyway!! problem for another day.
				if (!this.hls.media.seeking) {}
				//map the bufferEnd which is in transport stream time to it's equivalent manifest time - disabling for now, still problematic (#770)
				//bufferEnd = this.bufferEndToManifestTime(fragments, bufferEnd, levelDetails.targetduration);
	
				//Mactrix changes end
	
				var index = void 0;
				if (fragPrevious) {
					index = fragments.findIndex(function (element) {
						return element.sn === fragPrevious.sn;
					});
				}
	
				var fragNext = fragPrevious ? fragments[index + 1] : undefined;
	
				//if (fragNext) {
				//	logger.log(`Potential fragNext.sn ${fragNext.sn} bufferEnd ${bufferEnd} end ${end}`);
				//}
	
				var fragmentWithinToleranceTest = function fragmentWithinToleranceTest(candidate) {
					// offset should be within fragment boundary - config.maxFragLookUpTolerance
					// this is to cope with situations like
					// desiredTime = 9.991
					// frag[Ø] : [0,10]
					// frag[1] : [10,20]
					// desiredTime is within frag[0] range ... although what we are expecting is to return frag[1] here
					//              frag start               frag start+duration
					//                  |-----------------------------|
					//              <--->                         <--->
					//  ...--------><-----------------------------><---------....
					// previous frag         matching fragment         next frag
					//  return -1             return 0                 return 1
					//logger.log(`level/sn/start/end/bufEnd:${level}/${candidate.sn}/${candidate.start}/${(candidate.start+candidate.duration)}/${desiredTime}`);
					// Set the lookup tolerance to be small enough to detect the current segment - ensures we don't skip over very small segments
					var candidateLookupTolerance = Math.min(maxFragLookUpTolerance, candidate.manifestDuration);
					if (candidate.start + candidate.manifestDuration - candidateLookupTolerance <= desiredTime) {
						bestCandidate = candidate;
						return 1;
					} // if maxFragLookUpTolerance will have negative value then don't return -1 for first element
					else if (candidate.start - candidateLookupTolerance > desiredTime && candidate.start) {
							bestCandidate = candidate;
							return -1;
						}
					return 0;
				};
	
				if (desiredTime < end) {
					//Mactrix changes begin
					if (this._selectByPdt && this.initialPdt !== undefined /*fragPrevious && fragPrevious.pdt*/ /*fragNext && fragNext.pdt*/) {
							/*
	      	6.2.  Server Responsibilities
	      		6.2.4.  Providing Variant Streams
	      		If any Media Playlist in a Master Playlist contains an EXT-X
	      	-PROGRAM-DATE-TIME tag, then all Media Playlists in that Master
	      	Playlist MUST contain EXT-X-PROGRAM-DATE-TIME tags with consistent
	      	mappings of date and time to media timestamps.
	      */
	
							/* mactrix: searchByPdt is not used at the moment, because binary search.
	      let searchByPdt = (candidate) => {
	      	if(candidate.pdt !== undefined) {
	      	//we need to search for the candidate which is the first chunk after bufferEnd
	      	//As long as the error between bufferEnd(transport stream time) and the candidate
	      	//pdt (manifest time) is less than 1/2 a chunk duration (which it should be!) then
	      	//we don't need to account for this error since the pdt tolerance of 1/2 a chunk should cover it
	      	let millisTolerance = 0;//200;
	      	let millisDuration = candidate.manifestDuration * 1000;
	      	let millisCurrent = candidate.pdt - this.initialPdt;
	      	let millisNext = millisCurrent + millisDuration;
	      	let millisTarget = bufferEnd * 1000 - millisTolerance;
	      		if (millisNext <= millisTarget ) {
	      		return 1;
	      	}
	      	else {
	      		//due to the fact that millisTarget is in transport stream time
	      		//we can get a false positive when millisTarget is slightly less than millisNext
	      		//when this occurs we want the next chunk
	      		//if (this.previousPdt === candidate.pdt) {
	      		//	return 1;
	      		//}
	      			let midpointMillis = (millisCurrent + millisNext) / 2;
	      			if(midpointMillis >= millisTarget) {
	      			if(midpointMillis - millisTarget < millisDuration) {
	      				//this.previousPdt = candidate.pdt;
	      				//logger.log(`**_findFragment mp > mt searchByPdt - sn: ${candidate.sn} pdt: ${millisCurrent} name: ${candidate.relurl} mpm ${midpointMillis} mt: ${millisTarget} md: ${millisDuration}`);
	      				return 0;
	      			}
	      			else {
	      				return -1;
	      			}
	      		}
	      		else {
	      			//due to the fact that millisTarget is in transport stream time
	      			//we can get a false positive when millisTarget is slightly less than millisNext
	      			//when this occurs we want the next chunk
	      			//if (this.previousPdt === candidate.pdt) {
	      			//	logger.log(`**_findFragment fp searchByPdt - sn: ${candidate.sn} pdt: ${candidate.pdt} name: ${candidate.relurl}`);
	      			//	return 1;
	      			//} else {
	      			//	this.previousPdt = candidate.pdt;
	      			//	logger.log(`**_findFragment mp < mt searchByPdt - sn: ${candidate.sn} pdt: ${candidate.pdt} name: ${candidate.relurl}`);
	      			//	return 0;
	      			return 1;
	      			//}
	      		}
	      	}
	      }
	      else {
	      	//if the previous frag has a pdt then all candidates must have a pdt
	      	logger.warn(`_findFragment fragPrevious has a pdt but candidate frag does not!`);
	      	return 0;
	      }
	      };
	      */
	
							//if(fragNext && searchByPdt(fragNext) === 0) {
							//	console.log('_findFragment: searchByPdt');
							//	foundFrag = fragNext;
							//} else {
							//foundFrag = BinarySearch.search(fragments, searchByPdt);
	
							//use sub optimal linear search until binary search can be fixed
							//once binary search is fixed we can enable pdts across all browsers not just Safari
							var millisTolerance = 0; //200;
							foundFrag = this._linearSearch(fragments, fragPrevious, this.initialPdt + (desiredTime * 1000 - millisTolerance), false);
							_logger.logger.log('_findFragment: _linearSearch pos:' + pos);
							//}
						} else {
						//Mactrix changes end
						maxFragLookUpTolerance = 0.2; //Mactrix line added, turn on frag tolerance for next frag test
						if (desiredTime > end - maxFragLookUpTolerance) {
							maxFragLookUpTolerance = 0;
						}
	
						// Prefer the next fragment if it's within tolerance
						if (fragNext && !fragmentWithinToleranceTest(fragNext)) {
							foundFrag = fragNext;
							foundNext = true;
							_logger.logger.log('_findFragment: Picked next frag');
						} else {
							maxFragLookUpTolerance = 0; //Mactrix line added, turn off frag tolerance
							foundFrag = _binarySearch2.default.search(fragments, fragmentWithinToleranceTest);
							//logger.log(`_findFragment: BinarySearch pos:${pos} desiredTime:${desiredTime}`);
	
							//if we get null here it means that we fallen into a virutal hole in the manifest
							//we shouldn't really be getting null here, this is caused by a mismatch between transport stream time
							//and manifest time, bufferEndToManifestTime isn't really viable, this is probably the best we can do.
							if (foundFrag === null) {
								//logger.log(`_findFragment: Going for the second best choice`);
								//go with the best candidate, the following block should adjust it if it's not quite right
								foundFrag = bestCandidate;
							}
	
							foundBinary = true;
						}
	
						maxFragLookUpTolerance = 0; //Mactrix line added, turn off frag tolerance
						//Mactrix changes begin
						if (fragPrevious && foundFrag && fragPrevious.pdt && foundFrag.pdt) {
							var expectedTime = this.hls.streamCoordinator.basePdt.getTime() + desiredTime * 1000;
							var variance = fragPrevious.manifestDuration * 500; //variance is 1/2 a manifest duration
	
							//if the frag is within +/- 1/2 a fragPrevious manifestDuration, then accept it
	
							if (foundFrag.pdt < expectedTime - variance) {
								while (foundFrag.index < fragments.length - 1 && foundFrag.pdt < expectedTime - variance) {
									foundFrag = fragments[foundFrag.index + 1];
								}
	
								//check to make sure it's valid
								if (levelDetails.live && foundFrag.index === fragments.length - 1 && foundFrag.pdt < expectedTime - variance && foundFrag.type === 'main') {
									//wait for a manifest refresh so we can pick up the next chunk
									if (levelDetails.endSN !== levelDetails.originalEndSN && this._gapCycleBase !== this._level) {
										if (this._gapCycleBase === undefined) {
											this._gapCycleBase = this._level;
										}
	
										if (this.hls.levelController.tryNextVariant(this._level, false)) {
											this.state = State.WAITING_LEVEL;
											foundSwitch = true;
										}
									}
									foundFrag = undefined;
								}
							} else if (foundFrag.pdt - foundFrag.gap > expectedTime + variance) {
								while (foundFrag.index > 0 && foundFrag.pdt > expectedTime + variance) {
									foundFrag = fragments[foundFrag.index - 1];
								}
								//check to make sure it's valid
								if (foundFrag.index === 0 && foundFrag.pdt > expectedTime + variance) {
									//we have fallen off the window ... this is the best we can do
									//foundFrag = undefined;
								}
							}
						} else if (foundFrag) {
							var _expectedTime = 0;
	
							//convert pos to a pdt
							if (foundFrag.type === 'audio') {
								_expectedTime = this.hls.audioStreamController.initialPdt + desiredTime * 1000;
							} else {
								_expectedTime = this.hls.streamController.initialPdt + desiredTime * 1000;
							}
	
							//console.log('# no frag prev, using position: ' + expectedTime);
	
							if (foundFrag.pdt + foundFrag.manifestDuration * 1000 < _expectedTime) {
								//console.log('# foundFrag too early, winding forward');
	
								//foundFrag is too early, wind forward until we find it
								while (foundFrag.index < fragments.length - 1 && foundFrag.pdt + foundFrag.manifestDuration * 1000 < _expectedTime) {
									foundFrag = fragments[foundFrag.index + 1];
								}
	
								//check to make sure it's valid
								if (levelDetails.live && foundFrag.index === fragments.length - 1 && foundFrag.pdt + foundFrag.manifestDuration * 1000 < _expectedTime && foundFrag.type === 'main') {
									//wait for a manifest refresh so we can pick up the next chunk
									if (levelDetails.endSN !== levelDetails.originalEndSN && this._gapCycleBase !== this._level) {
										if (this._gapCycleBase === undefined) {
											this._gapCycleBase = this._level;
										}
	
										if (this.hls.levelController.tryNextVariant(this._level, false)) {
											this.state = State.WAITING_LEVEL;
										}
									}
	
									foundFrag = undefined;
								}
							} else if (foundFrag.pdt > _expectedTime) {
								//console.log('# foundFrag too late, winding backward');
	
								//foundFrag is too early, wind backward until we find it
								while (foundFrag.index > 0 && foundFrag.pdt > _expectedTime) {
									foundFrag = fragments[foundFrag.index - 1];
								}
	
								//check to make sure it's valid
								if (foundFrag.index === 0 && foundFrag.pdt > _expectedTime) {
									//we have fallen off the window ... this is the best we can do
									//foundFrag = undefined;
								}
							}
						}
					}
					//Mactrix changes end
				} else {
	
					endOfPlaylist = true;
					// reach end of playlist
					foundFrag = fragments[fragLen - 1];
					if (levelDetails.endSN !== levelDetails.originalEndSN && this._gapCycleBase !== this._level && foundFrag.type === 'main') {
						if (this._gapCycleBase === undefined) {
							this._gapCycleBase = this._level;
						}
	
						if (this.hls.levelController.tryNextVariant(this._level, false)) {
							this.state = State.WAITING_LEVEL;
							foundSwitch = true;
						}
						foundFrag = undefined;
					} else if (fragPrevious && fragPrevious.pdt) {
						var _expectedTime2 = fragPrevious.pdt + fragPrevious.manifestDuration * 1000;
						var _variance = fragPrevious.manifestDuration * 500; //variance is 1/2 a manifest duration
	
						if (foundFrag.pdt > _expectedTime2 + _variance) {
							while (foundFrag.index > 0 && foundFrag.pdt > _expectedTime2 + _variance) {
								foundFrag = fragments[foundFrag.index - 1];
							}
							//check to make sure it's valid
							if (foundFrag.index === 0 && foundFrag.pdt > _expectedTime2 + _variance) {
								//we have fallen off the window
								foundFrag = undefined;
							}
	
							foundPdtNext = true;
						} else {
							foundFrag = undefined;
						}
					} else {
						foundFrag = undefined;
					}
				}
	
				//Mactrix: I don't think we need this block when using muxjs (EXCEPT TO SET frag = foundFrag, and the
				//		   Mactrix workaround at the end of the block), since muxjs keeps a GOP cache
				//		   and uses it to find a the best candidate for GOP fusion, if it can't find one it
				//		   will drop all frames before the keyframe, then extend the key frame duration by the
				//		   amount of frames dropped. The frag.dropped parameter is always set to false
				//		   in muxjs-inline anyway.
				if (foundFrag) {
					//Mactrix additions start
					//when we fix sync some frags will end up with negative start time
					//we want to skip these as trying to load these will guarantee a sync failure and Chrome doesn't like negative timestamps in the buffer
					if (foundFrag.start < 0) {
						foundFrag = fragments[foundFrag.index + 1];
					}
					//Mactrix additions end
					frag = foundFrag;
	
					//const curSNIdx = frag.sn - levelDetails.startSN;
					/*
	    const sameLevel = fragPrevious && frag.level === fragPrevious.level;
	    const prevFrag = fragments[curSNIdx - 1];
	    	const nextFrag = fragments[curSNIdx + 1];
	    //logger.log('find SN matching with pos:' +  bufferEnd + ':' + frag.sn);
	    if (sameLevel && frag.sn === fragPrevious.sn) {
	    	if (frag.sn < levelDetails.endSN) {
	    		let deltaPTS = fragPrevious.deltaPTS;
	    		// if there is a significant delta between audio and video, larger than max allowed hole,
	    		// and if previous remuxed fragment did not start with a keyframe. (fragPrevious.dropped)
	    		// let's try to load previous fragment again to get last keyframe
	    		// then we will reload again current fragment (that way we should be able to fill the buffer hole ...)
	    		if (deltaPTS && deltaPTS > config.maxBufferHole && fragPrevious.dropped && curSNIdx) {
	    			frag = prevFrag;
	    			logger.warn(`SN just loaded, with large PTS gap between audio and video, maybe frag is not starting with a keyframe ? load previous one to try to overcome this`);
	    			// decrement previous frag load counter to avoid frag loop loading error when next fragment will get reloaded
	    			fragPrevious.loadCounter--;
	    		}
	    		else {
	    			frag = nextFrag;
	    			logger.log(`SN just loaded, load next one: ${frag.sn}`);
	    		}
	    	}
	    	else {
	    		frag = null;
	    	}
	    }
	    else if (frag.dropped && !sameLevel) {
	    	// Only backtrack a max of 1 consecutive fragment to prevent sliding back too far when little or no frags start with keyframes
	    	if (nextFrag && nextFrag.backtracked) {
	    		logger.warn(`Already backtracked from fragment ${curSNIdx + 1}, will not backtrack to fragment ${curSNIdx}. Loading fragment ${curSNIdx + 1}`);
	    		frag = nextFrag;
	    }
	    else {
	    	// If a fragment has dropped frames and it's in a different level/sequence, load the previous fragment to try and find the keyframe
	    	// Reset the dropped count now since it won't be reset until we parse the fragment again,
	    	// which prevents infinite backtracking on the same segment
	    	logger.warn('Loaded fragment with dropped frames, backtracking 1 segment to find a keyframe');
	    	frag.dropped = 0;
	    	if (prevFrag) {
	    		if (prevFrag.loadCounter) {
	    			prevFrag.loadCounter--;
	    		}
	    		frag = prevFrag;
	    	}
	    	else {
	    		frag = null;
	    	}
	    }
	    }
	    */
	
					//Backtrack to previous frag if we're just before the start of a buffered range
					//If this has happened, HlsJs selected the wrong fragment previously, and needs to be corrected
	
					//this.media.currentTime was changed to pos here
	
					if (fragPrevious && media && media.buffered.length && fragments[fragPrevious.sn - levelDetails.startSN - 1] && pos !== 0) {
						//we shouldn't need to do this at currentTime = 0, as we'll be automatically moved to the start of the first frag
						for (var i = 0; i < media.buffered.length; i++) {
							if (pos < media.buffered.start(i) && frag.start > pos && pos > media.buffered.start(i) - levelDetails.averagetargetduration * 1.1 && (i === 0 || media.buffered.start(i) - media.buffered.end(i - 1) > levelDetails.averagetargetduration / 2) && fragments[fragPrevious.sn - levelDetails.startSN - 1].start > pos - levelDetails.averagetargetduration) {
								_logger.logger.warn(fragPrevious.type + ' buffer too far forward, backtracking to fill buffer hole');
								frag = fragments[fragPrevious.sn - levelDetails.startSN - 1];
							}
						}
					}
	
					//if all else fails to get the controller to progress through the manifest, force it onto the next frag
					//unless there's no next frag to go to, in which case return undefined to avoid frag loop errors
					if (fragPrevious && frag.sn === fragPrevious.sn) {
						if (fragments[frag.index + 1]) {
							frag = fragments[frag.index + 1];
						} else {
							frag = undefined;
						}
					}
				} else {
					noNewFrag = true;
				}
	
				//if (!noNewFrag && !foundNext && !foundBinary && !foundPdtNext) {
				//	logger.log(`_findFragment not sure how this one was found`);
				//}
				//logger.log(`_findfragment END foundNext:${foundNext} foundBinary:${foundBinary} foundSwitch:${foundSwitch} endOfPlaylist:${endOfPlaylist} noNewFrag:${noNewFrag} previouslyNoPrevious:${previouslyNoPrevious}`);
				//if (fragPrevious) {
				//	logger.log(`_findfragment END type:${fragPrevious.type}`);
				//}
	
				var results = {
					frag: frag,
					fragPrevious: fragPrevious,
					clearFragPrevious: clearFragPrevious,
					foundNext: foundNext,
					foundBinary: foundBinary,
					foundPdtNext: foundPdtNext,
					foundSwitch: foundSwitch,
					endOfPlaylist: endOfPlaylist,
					noNewFrag: noNewFrag,
					previouslyNoPrevious: previouslyNoPrevious
				};
	
				return results;
			}
		}, {
			key: '_loadFragmentOrKey',
			value: function _loadFragmentOrKey(frag, level, levelDetails, pos, bufferEnd) {
				var hls = this.hls;
				var config = hls.config;
	
				//logger.log('loading frag ' + i +',pos/bufEnd:' + pos.toFixed(3) + '/' + bufferEnd.toFixed(3));
				if (frag.decryptdata && frag.decryptdata.uri != null && frag.decryptdata.key == null) {
					_logger.logger.log('Main loading key for ' + frag.sn + ' of [' + levelDetails.startSN + ' ,' + levelDetails.endSN + '],level ' + level);
					this.state = State.KEY_LOADING;
	
					//Not the best logic, but with the way the selector works it needs to do again if there's a key needed
					//Might look into changing the selector concept at a latter date to avoid the double selecting
					if (this._bufferBeforeSeekingApplied === true) {
						this._bufferBeforeSeekingApplied = false;
						_logger.logger.log('_loadFragmentOrKey: bufferBeforeSeeking key reset');
					}
					hls.trigger(_events2.default.KEY_LOADING, { frag: frag });
				} else {
					//Mactrix remove line: I don't see the point in running the main loop twice for key load and frag parse ... doing it in the one call
					/*
	    logger.log(`Loading ${frag.sn} of [${levelDetails.startSN} ,${levelDetails.endSN}],level ${level}, currentTime:${pos.toFixed(3)},bufferEnd:${bufferEnd.toFixed(3)}`);
	    */
	
					//Mactrix changes begin, handle cases where pos/bufferEnd are null or undefined
					//TODO: fix what is causing pos to be null/undefined, as that shouldn't be happening
					try {
						if (!this.hls.browIE && !this.hls.browTizen2) {
							//Number.isFinite() isn't supported in IE or Tizen 2, and global isFinite() returns true on null, which we don't want
							if (Number.isFinite(pos) && Number.isFinite(bufferEnd)) {
								_logger.logger.log('Main loading ' + frag.sn + ' of [' + levelDetails.startSN + ' ,' + levelDetails.endSN + '],level ' + level + ', pos:' + pos.toFixed(3) + ',bufferEnd:' + bufferEnd.toFixed(3));
							} else {
								_logger.logger.log('Main loading ' + frag.sn + ' of [' + levelDetails.startSN + ' ,' + levelDetails.endSN + '],level ' + level + ', pos:' + pos + ',bufferEnd:' + bufferEnd);
							}
						} else {
							_logger.logger.log('Main loading ' + frag.sn + ' of [' + levelDetails.startSN + ' ,' + levelDetails.endSN + '],level ' + level + ', pos:' + pos + ',bufferEnd:' + bufferEnd);
						}
					} catch (err) {
						_logger.logger.warn('error occurred while logging start of frag load');
					}
	
					if (frag.dateRange !== undefined) {
						hls.trigger(_events2.default.FRAG_DATERANGE_UPDATE, { dateRange: frag.dateRange, startTime: frag.start });
					}
	
					//Mactrix changes end
					// ensure that we are not reloading the same fragments in loop ...
					if (this._fragLoadIdx !== undefined) {
						this._fragLoadIdx++;
					} else {
						this._fragLoadIdx = 0;
					}
					if (frag.loadCounter) {
						frag.loadCounter++;
						var maxThreshold = config.fragLoadingLoopThreshold;
						// if this frag has already been loaded 3 times, and if it has been reloaded recently
						if (frag.loadCounter > maxThreshold && Math.abs(this._fragLoadIdx - frag.loadIdx) < maxThreshold) {
							hls.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.MEDIA_ERROR, details: _errors.ErrorDetails.FRAG_LOOP_LOADING_ERROR, fatal: false, frag: frag });
							return false;
						}
					} else {
						frag.loadCounter = 1;
					}
					frag.loadIdx = this._fragLoadIdx;
					this._fragCurrent = frag;
					this._startFragRequested = true;
					if (!isNaN(frag.sn)) {
						this._nextLoadPosition = frag.start + frag.duration;
					}
					frag.autoLevel = hls.autoLevelEnabled;
					frag.bitrateTest = this._bitrateTest;
					hls.trigger(_events2.default.FRAG_LOADING, { frag: frag });
					// lazy demuxer init, as this could take some time ... do it during frag loading
					if (!this._demuxer) {
						this._demuxer = new _demuxer2.default(hls, 'main');
					}
					this.state = State.FRAG_LOADING;
					return true;
				} //Mactrix remove line: performing key load if required and frag load in the one call
	
				return true; //Mactrix line added: need a general return value - getting here isn't indicative of an error so return true
			}
		}, {
			key: 'getBufferedFrag',
			value: function getBufferedFrag(position) {
				return _binarySearch2.default.search(this._bufferedFrags, function (frag) {
					if (position < frag.startPTS) {
						return -1;
					} else if (position > frag.endPTS) {
						return 1;
					}
					return 0;
				});
			}
		}, {
			key: 'followingBufferedFrag',
			value: function followingBufferedFrag(frag) {
				if (frag) {
					// try to get range of next fragment (500ms after this range)
					return this.getBufferedFrag(frag.endPTS + 0.5);
				}
				return null;
			}
		}, {
			key: 'immediateLevelSwitch',
	
	
			/*
	  on immediate level switch :
	  - pause playback if playing
	  - cancel any pending load request
	  - and trigger a buffer flush
	  */
			value: function immediateLevelSwitch() {
				_logger.logger.log('immediateLevelSwitch');
				if (!this._immediateSwitch) {
					this._immediateSwitch = true;
					var media = this.media;
					var previouslyPaused = void 0;
	
					if (media) {
						previouslyPaused = media.paused;
						media.pause();
					} else {
						// don't restart playback after instant level switch in case media not attached
						previouslyPaused = true;
					}
					this._previouslyPaused = previouslyPaused;
				}
				var fragCurrent = this._fragCurrent;
				if (fragCurrent && fragCurrent.loader) {
					fragCurrent.loader.abort();
				}
				this._fragCurrent = null;
				// increase fragment load Index to avoid frag loop loading error after buffer flush
				this._fragLoadIdx += 2 * this.config.fragLoadingLoopThreshold;
				// flush everything
				this.flushMainBuffer(0, Number.POSITIVE_INFINITY);
			}
	
			/*
	  on immediate level switch end, after new fragment has been buffered :
	   - nudge video decoder by slightly adjusting video currentTime (if currentTime buffered)
	   - resume the playback if needed
	  */
	
		}, {
			key: 'immediateLevelSwitchEnd',
			value: function immediateLevelSwitchEnd() {
				var media = this.media;
				if (media && media.buffered.length) {
					this._immediateSwitch = false;
					if (_bufferHelper2.default.isBuffered(media, media.currentTime)) {
						// only nudge if currentTime is buffered
						media.currentTime -= 0.0001;
					}
					if (!this._previouslyPaused) {
						media.play();
					}
				}
			}
		}, {
			key: 'nextLevelSwitch',
			value: function nextLevelSwitch() {
				/* try to switch ASAP without breaking video playback :
	      in order to ensure smooth but quick level switching,
	     we need to find the next flushable buffer range
	     we should take into account new segment fetch time
	   */
				var media = this.media;
				// ensure that media is defined and that metadata are available (to retrieve currentTime)
				if (media && media.readyState) {
					var fetchdelay = void 0;
					var fragPlayingCurrent = void 0;
					var nextBufferedFrag = void 0;
					// increase fragment load Index to avoid frag loop loading error after buffer flush
					this._fragLoadIdx += 2 * this.config.fragLoadingLoopThreshold;
					fragPlayingCurrent = this.getBufferedFrag(media.currentTime);
					if (fragPlayingCurrent && fragPlayingCurrent.startPTS > 1) {
						// flush buffer preceding current fragment (flush until current fragment start offset)
						// minus 1s to avoid video freezing, that could happen if we flush keyframe of current video ...
						this.flushMainBuffer(0, fragPlayingCurrent.startPTS - 1);
					}
					if (!media.paused) {
						// add a safety delay of 1s
						var nextLevelId = this.hls.nextLoadLevel;
						var nextLevel = this._levels[nextLevelId];
						var fragLastKbps = this._fragLastKbps;
	
						if (fragLastKbps && this._fragCurrent) {
							fetchdelay = this._fragCurrent.duration * nextLevel.bitrate / (1000 * fragLastKbps) + 1;
						} else {
							fetchdelay = 0;
						}
					} else {
						fetchdelay = 0;
					}
	
					//logger.log('fetchdelay:'+fetchdelay);
					// find buffer range that will be reached once new fragment will be fetched
					nextBufferedFrag = this.getBufferedFrag(media.currentTime + fetchdelay);
					if (nextBufferedFrag) {
						// we can flush buffer range following this one without stalling playback
						nextBufferedFrag = this.followingBufferedFrag(nextBufferedFrag);
						if (nextBufferedFrag) {
							// if we are here, we can also cancel any loading/demuxing in progress, as they are useless
							var fragCurrent = this._fragCurrent;
							if (fragCurrent && fragCurrent.loader) {
								fragCurrent.loader.abort();
							}
							this._fragCurrent = null;
							// flush position is the start position of this new buffer
							this.flushMainBuffer(nextBufferedFrag.startPTS, Number.POSITIVE_INFINITY);
						}
					}
				}
			}
		}, {
			key: 'flushMainBuffer',
			value: function flushMainBuffer(startOffset, endOffset) {
				this.state = State.BUFFER_FLUSHING;
				var flushScope = { startOffset: startOffset, endOffset: endOffset };
				// if alternate audio tracks are used, only flush video, otherwise flush everything
				if (this._altAudio) {
					flushScope.type = 'video';
				}
				this.hls.trigger(_events2.default.BUFFER_FLUSHING, flushScope);
			}
		}, {
			key: 'onMediaAttached',
			value: function onMediaAttached(data) {
				var media = this.media = this.mediaBuffer = data.media;
				this.videoBuffer = null;
				this.onvseeking = this.onMediaSeeking.bind(this);
				this.onvseeked = this.onMediaSeeked.bind(this);
				this.onvended = this.onMediaEnded.bind(this);
				this.onvcanplaythrough = this.onMediaCanPlayThrough.bind(this);
				media.addEventListener('seeking', this.onvseeking);
				media.addEventListener('seeked', this.onvseeked);
				media.addEventListener('ended', this.onvended);
				media.addEventListener('canplaythrough', this.onvcanplaythrough);
				var config = this.config;
				if (this._levels && config.autoStartLoad) {
					this.hls.startLoad(config.startPosition);
				}
			}
		}, {
			key: 'onMediaDetaching',
			value: function onMediaDetaching() {
				var media = this.media;
				if (media && media.ended) {
					_logger.logger.log('MSE detaching and video ended, reset startPosition');
					this._startPosition = this._lastCurrentTime = 0;
				}
	
				// reset fragment loading counter on MSE detaching to avoid reporting FRAG_LOOP_LOADING_ERROR after error recovery
				var levels = this._levels;
				if (levels) {
					// reset fragment load counter
					levels.forEach(function (level) {
						if (level.details) {
							level.details.fragments.forEach(function (fragment) {
								fragment.loadCounter = undefined;
								fragment.backtracked = undefined;
							});
						}
					});
				}
				// remove video listeners
				if (media) {
					media.removeEventListener('seeking', this.onvseeking);
					media.removeEventListener('seeked', this.onvseeked);
					media.removeEventListener('ended', this.onvended);
					this.onvseeking = this.onvseeked = this.onvended = null;
				}
				this.media = this.mediaBuffer = this.videoBuffer = null;
				this._loadedMetadata = false;
				//Mactrix changes begin
				this.initialPdt = undefined;
				//Mactrix changes end
				this.stopLoad();
			}
		}, {
			key: 'onMediaSeeking',
			value: function onMediaSeeking() {
				var media = this.media;
				var currentTime = media ? media.currentTime : undefined;
				var config = this.config;
				_logger.logger.log('media seeking to: ' + currentTime.toFixed(3));
	
				this.seekOverNearbyAudioGap(false);
	
				if (this.state === State.FRAG_LOADING) {
					var mediaBuffer = this.mediaBuffer ? this.mediaBuffer : media;
					var bufferInfo = _bufferHelper2.default.bufferInfo(mediaBuffer, currentTime, this.config.maxBufferHole);
					var fragCurrent = this._fragCurrent;
					// check if we are seeking to a unbuffered area AND if frag loading is in progress
					if (bufferInfo.len === 0 && fragCurrent) {
						var tolerance = config.maxFragLookUpTolerance;
						var fragStartOffset = fragCurrent.start - tolerance;
						var fragEndOffset = fragCurrent.start + fragCurrent.duration + tolerance;
	
						// check if we seek position will be out of currently loaded frag range : if out cancel frag load, if in, don't do anything
						if (currentTime < fragStartOffset || currentTime > fragEndOffset) {
							if (fragCurrent.loader) {
								_logger.logger.log('seeking outside of buffer while fragment load in progress, cancel fragment load');
								fragCurrent.loader.abort();
							}
							this._fragCurrent = null;
							this._fragPrevious = null;
							// switch to IDLE state to load new fragment
							this.state = State.IDLE;
						} else {
							_logger.logger.log('seeking outside of buffer but within currently loaded fragment range');
						}
					}
				} else if (this.state === State.ENDED) {
					//clear fragPrevious, to prevent an immediate switch back to ENDED if loading fails
					this._fragPrevious = null;
					// switch to IDLE state to check for potential new fragment
					this.state = State.IDLE;
					//Mactrix changes begin: not having this causes the buffered range tests to fail
					//disabled as this is no longer needed and is causing issues with startup in IE/Edge
					/*
	    	} else if (this._state === State.WAITING_LEVEL) {
	    		this._fragPrevious = null;*/
				}
				//Mactrix changes end
				if (media) {
					this._lastCurrentTime = currentTime;
	
					if (this._playbackStarted && this.state !== State.PARSING) {
						this._fragPrevious = null;
						this.state = State.IDLE;
					}
				}
				// avoid reporting fragment loop loading error in case user is seeking several times on same position
				if (this.state !== State.FRAG_LOADING && this._fragLoadIdx !== undefined) {
					this._fragLoadIdx += 2 * config.fragLoadingLoopThreshold;
				}
				// in case seeking occurs although no media buffered, adjust startPosition and nextLoadPosition to seek target
				if (!this._loadedMetadata) {
					this._nextLoadPosition = this._startPosition = currentTime;
				}
				this.hls.trigger(_events2.default.BUFFER_SOURCE_SEEKING); //Mactrix addition
				// tick to speed up processing
				this.tick();
			}
		}, {
			key: 'onAudioTrackUpdated',
			value: function onAudioTrackUpdated() {
				this.seekOverNearbyAudioGap(false);
			}
		}, {
			key: 'isThereAnAudioGap',
			value: function isThereAnAudioGap(time, increaseRange) {
				var gapEnd = undefined;
	
				if (!this._audioGapSeeking && this._altAudio) {
					var audioController = this.hls.audioStreamController;
					var track = audioController.tracks[audioController.trackId];
	
					if (track) {
						if (track.gapList.length > 0) {
							var offset = increaseRange ? track.details.averagetargetduration : 0;
							for (var i = 0; i < track.gapList.length; i++) {
								if (!this._audioGapSeeking && time < track.gapList[i].end && time > track.gapList[i].start - offset) {
									gapEnd = track.gapList[i].end;
								}
							}
						}
					}
				}
	
				return gapEnd;
			}
		}, {
			key: 'seekOverNearbyAudioGap',
			value: function seekOverNearbyAudioGap(increaseRange) {
				if (this.media) {
					var currTime = this.media.currentTime;
					var gapEndToSeekTo = this.isThereAnAudioGap(currTime, increaseRange);
	
					if (!this._audioGapSeeking && gapEndToSeekTo !== undefined) {
						var nudgeTime = gapEndToSeekTo + 0.001;
						//nudge a bit further than end of gap, as Chrome's lack of rounding on seeks may cause us to fall into the gap again
	
						_logger.logger.warn('adjusting currentTime from ' + currTime + ' to ' + nudgeTime + ' due to audio gap');
						if (this.hls._preBufferSeeks === false) {
							this.media.currentTime = nudgeTime;
						} else {
							this.hls.bufferBeforeSeeking = nudgeTime;
						}
						this._audioGapSeeking = true;
					}
				}
			}
		}, {
			key: 'onMediaSeeked',
			value: function onMediaSeeked() {
				_logger.logger.log('media seeked to ' + this.media.currentTime.toFixed(3));
	
				if (this.hls.browTizen3) {
					this._clearFragPrevious = true;
				}
				/* Mactrix replace start
	   	// tick to speed up FRAGMENT_PLAYING triggering
	   	this.tick();
	   Mactrix replace end */
				//Mactrix replacement start
				if (!this.hls._inSlowDetach) {
					this.tick();
				} else {
					_logger.logger.log('slow detach seek finished');
	
					if (this.hls.streamCoordinator.checkReadyForDispose(true, undefined)) {
						this.hls._doCompleteSlowDetach();
					}
				}
	
				this._audioGapSeeking = false;
				//Mactrix replacement end
			}
		}, {
			key: 'onMediaEnded',
			value: function onMediaEnded() {
				_logger.logger.log('media ended');
				// reset startPosition and lastCurrentTime to restart playback @ stream beginning
				this._startPosition = this._lastCurrentTime = 0;
			}
		}, {
			key: 'onMediaCanPlayThrough',
			value: function onMediaCanPlayThrough() {
				this._playbackStarted = true;
			}
		}, {
			key: 'onManifestLoading',
			value: function onManifestLoading() {
				// reset buffer on manifest loading
				_logger.logger.log('trigger BUFFER_RESET');
				this.hls.trigger(_events2.default.BUFFER_RESET);
				this._bufferedFrags = [];
				this._stalled = false;
				this._startPosition = this._lastCurrentTime = 0;
				this._altAudio = false; //Mactrix line added, reset usage of audio stream controller
				this._fragBufferCount = 0;
				this.cmaf = false;
			}
		}, {
			key: 'onManifestParsed',
			value: function onManifestParsed(data) {
				var aac = false;
				var heaac = false;
				var codec = void 0;
	
				data.levels.forEach(function (level) {
					// detect if we have different kind of audio codecs used amongst playlists
					codec = level.audioCodec;
					if (codec) {
						if (codec.indexOf('mp4a.40.2') !== -1) {
							aac = true;
						}
						if (codec.indexOf('mp4a.40.5') !== -1) {
							heaac = true;
						}
					}
	
					level.deadFragList = [];
					level.containsGaps = false;
				});
				this._audioCodecSwitch = aac && heaac;
				if (this._audioCodecSwitch) {
					_logger.logger.log('both AAC/HE-AAC audio found in levels; declaring level codec as HE-AAC');
				}
				this._levels = data.levels;
				this._startFragRequested = false;
	
				var config = this.config;
				if (config.autoStartLoad) {
					this.hls.startLoad(config.startPosition);
				}
			}
		}, {
			key: 'adjustStartBySlidingOffset',
			value: function adjustStartBySlidingOffset(curDetails, newDetails) {
				var delta = newDetails.startSN - curDetails.startSN;
				var curFrags = curDetails.fragments;
	
				if (delta >= 0 && delta < curFrags.length) {
					// adjust start by sliding offset
					var sliding = curFrags[delta].start;
					var newFrags = newDetails.fragments;
					var newFragsCount = newFrags.length;
					for (var i = 0; i < newFragsCount; i++) {
						newFrags[i].start += sliding;
					}
				}
			}
		}, {
			key: 'adjustStartByBasePdt',
			value: function adjustStartByBasePdt(newDetails, pdt) {
				var date = void 0;
				//logger.log(`adjustStartByBasePdt offset pdt : ${pdt}`);
				var newFrags = newDetails.fragments;
				var newFragsCount = newFrags.length;
				for (var i = 0; i < newFragsCount; i++) {
					var frag = newFrags[i];
					if (frag.rawProgramDateTime) {
						date = new Date(new Date(frag.rawProgramDateTime).valueOf() - frag.start * 1000);
						_logger.logger.log('raw PDT: ' + date);
						break;
					}
				}
	
				if (date !== undefined) {
					var offset = date.getTime() - pdt.getTime();
					var offsetBasePdt = newFrags[0].pdt - offset;
	
					for (var _i = 0; _i < newFragsCount; _i++) {
						var _frag = newFrags[_i];
						_frag.start = (_frag.pdt - offsetBasePdt) / 1000;
					}
				}
			}
		}, {
			key: 'onLevelLoaded',
			value: function onLevelLoaded(data) {
				var _this2 = this;
	
				var newDetails = data.details;
				var newLevelId = data.level;
				var curLevel = this._levels[newLevelId];
				var duration = newDetails.totalduration;
				var sliding = 0;
	
				/* mactrix replace
	   	logger.log(`level ${newLevelId} loaded [${newDetails.startSN},${newDetails.endSN}],duration:${duration}`);
	   */
				_logger.logger.log('X level ' + newLevelId + ' loaded [' + newDetails.startSN + ',' + newDetails.endSN + '],duration:' + duration + ' live:' + newDetails.live); //Mactrix line changed, live added
				this._levelLastLoaded = newLevelId;
	
				//Mactrix changes begin: store the base pdt ... this would cause problems if pdts were to appear mid stream .. shouldn't happen
				if (this.initialPdt === undefined && newDetails.fragments[0].pdt) {
					this.initialPdt = newDetails.fragments[0].pdt;
				}
				//Mactrix changes end
	
				if (newDetails.live) {
					var curDetails = curLevel.details;
					if (curDetails && newDetails.fragments.length > 0) {
						// we already have details for that level, merge them
						//Mactrix changes begin
						if (this.hls.streamCoordinator.basePdt) {
							this.adjustStartByBasePdt(newDetails, this.hls.streamCoordinator.basePdt);
						} else {
							//This case shouldn't hit, but it will on startup. Often it's not an issue as it'll just do a no-offset
							//as needed, but in a sliding live recovery it's bad. Since we're creating PDTs always now this whole
							//case probably can be deleted and just make the no-PDT case do no adjustment, but more testing is required. - SIEG
							_logger.logger.log('onLevelLoaded adjustStartBySlidingOffset NO BASEPDT YET');
							this.adjustStartBySlidingOffset(curDetails, newDetails);
						}
						//Mactrix changes end
						sliding = newDetails.fragments[0].start;
						this.liveSyncPosition = this.computeLivePosition(sliding, curDetails);
						if (newDetails.PTSKnown) {
							//this is now never true. Probably should remove PTSKnown and rework - SIEG
							_logger.logger.log('live X playlist sliding :' + sliding.toFixed(3));
						} else {
							_logger.logger.log('live X playlist - outdated PTS, unknown sliding');
						}
					} else {
						//Mactrix additions start
						//if we know the base PDT we can sync and determine sliding
						if (this.hls.streamCoordinator.basePdt) {
							_logger.logger.log('live X playlist - first load, calculating slide by syncing to base PDT');
							this.adjustStartByBasePdt(newDetails, this.hls.streamCoordinator.basePdt);
							sliding = newDetails.fragments[0].start;
							_logger.logger.log('basePDT live X playlist sliding:' + sliding.toFixed(3));
						} else {
							//Mactrix additions end
							newDetails.PTSKnown = false;
							_logger.logger.log('live X playlist - first load, unknown sliding');
						} //Mactrix line added
					}
				} else {
					//Mactrix additions start
					//resync VODs, if needed
					if (this.hls.streamCoordinator.basePdt) {
						this.adjustStartByBasePdt(newDetails, this.hls.streamCoordinator.basePdt);
					}
					//Mactrix additions end
					newDetails.PTSKnown = false;
				}
	
				newDetails.fragments.forEach(function (frag, index) {
					if (frag.tagList.includes('GAP')) {
						_this2.removeDeadFrag(index, newDetails.fragments);
						curLevel.containsGaps = true;
	
						//check the frag that we just moved into this index
						while (newDetails.fragments[index] && newDetails.fragments[index].tagList.includes('GAP')) {
							_this2.removeDeadFrag(index, newDetails.fragments);
						}
					}
				});
	
				curLevel.deadFragList.forEach(function (deadSn) {
					var index = newDetails.fragments.findIndex(function (element) {
						return element.sn === deadSn;
					});
	
					if (index !== -1) {
						_this2.removeDeadFrag(index, newDetails.fragments);
					}
				});
	
				//reconfirm first and last SN, in case there are dead frags at start or end
				newDetails.startSN = newDetails.fragments[0].sn;
				newDetails.originalEndSN = newDetails.endSN;
				newDetails.endSN = newDetails.fragments[newDetails.fragments.length - 1].sn;
	
				// override level info
				curLevel.details = newDetails;
				/* mactrix replace
	   	this.hls.trigger(Event.LEVEL_UPDATED, { details: newDetails, level: newLevelId });
	   */
				//Mactrix change start
				// sje: beneficial to have sliding outside.
				this.hls.trigger(_events2.default.LEVEL_UPDATED, { details: newDetails, level: newLevelId, sliding: sliding }); // mactrix: added sliding
				//Mactrix change end
	
				if (this._startFragRequested === false) {
					// compute start position if set to -1. use it straight away if value is defined
					if (this._startPosition === -1 || this._lastCurrentTime === -1) {
						// first, check if start time offset has been set in playlist, if yes, use this value
						var startTimeOffset = newDetails.startTimeOffset;
						if (!isNaN(startTimeOffset)) {
							if (startTimeOffset < 0) {
								_logger.logger.log('negative start time offset ' + startTimeOffset + ', count from end of last fragment');
								startTimeOffset = sliding + duration + startTimeOffset;
							}
							_logger.logger.log('start time offset found in playlist, adjust startPosition to ' + startTimeOffset);
							this._startPosition = startTimeOffset;
						} else {
							// if live playlist, set start position to be fragment N-this.config.liveSyncDurationCount (usually 3)
							if (newDetails.live) {
								this._startPosition = this.computeLivePosition(sliding, newDetails);
								_logger.logger.log('configure startPosition to ' + this._startPosition);
							} else {
								this._startPosition = 0;
							}
						}
						this._lastCurrentTime = this._startPosition;
					}
					this._nextLoadPosition = this._startPosition;
				}
				// only switch batck to IDLE state if we were waiting for level to start downloading a new fragment
				if (this.state === State.WAITING_LEVEL) {
					this.state = State.IDLE;
				}
				//trigger handler right now
				/*Mactrix remove: when dealing with renditions we need to wait for the audio track to load so we can deal with pdt sync ... hopefully this won't
	   				  //stall the pipeline
	   	this.tick();
	   */
			}
		}, {
			key: 'onKeyLoaded',
			value: function onKeyLoaded() {
				if (this.state === State.KEY_LOADING) {
					this.state = State.IDLE;
					this.tick();
				}
			}
		}, {
			key: 'isCMAF',
			value: function isCMAF(buffer) {
				var initSegment = new DataView(buffer);
				var ftyp = 0x66747970;
				var cmaf = false;
	
				if (initSegment.getUint32(4) === ftyp) {
					cmaf = true;
				}
	
				//if we find the ftyp atom we assume cmaf otherwise ts
				//if ((initSegment[4] === 'f'.charCodeAt(0)) &&
				//	(initSegment[5] === 't'.charCodeAt(0)) &&
				//	(initSegment[6] === 'y'.charCodeAt(0)) &&
				//	(initSegment[7] === 'p'.charCodeAt(0))) {
				//	cmaf = true;
				//}
	
				return cmaf;
			}
	
			//this function is quickly hacked and needs to be revised in a number of ways .... TODO
	
		}, {
			key: 'insertPssh',
			value: function insertPssh(initSegment, initFrag) {
				var i = void 0;
				var newInitSegment = null;
				var base64str = null;
				var format = null;
				var levelkey = null;
	
				//
				if (this.hls.browChrome || this.hls.browFirefox) {
					format = 'urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed';
				} else if (this.hls.browIE || this.hls.browEdge || this.hls.browTizen2 || this.hls.browTizen3) {
					format = 'com.microsoft.playready';
				}
				/*
	   		else if (this.hls.browSafari) {
	   			if (initFrag.levelkeys[i].format === 'com.apple.streamingkeydelivery') {
	   				levelkey = initFrag.levelkeys[i];
	   				//get everything after the skd://
	   				//need to add a check for the ; and add that as the sub string end paramter
	   				base64str = levelkey.reluri.substring(6);
	   				break;
	   			}
	   		}
	   */
				//if(levelkey.format === 'SAMPLE-AES' || levelkey.format === 'SAMPLE-AES-CTR')
				//(['AES-128', 'SAMPLE-AES', 'ISO-23001-7', 'SAMPLE-AES-CTR', 'SAMPLE-AES-CENC'].indexOf(decryptmethod) >= 0)) {
	
				//a short cut method for extracting the base64 from the uri, it doesn't pay attention to any other uri parameters
				if (format !== null) {
					for (i = 0; i < initFrag.levelkeys.length && base64str === null; i++) {
						levelkey = initFrag.levelkeys[i];
	
						if (levelkey.format === format) {
							var base64IndexStart = levelkey.reluri.indexOf('base64,');
	
							if (base64IndexStart >= 0) {
								var str = levelkey.reluri.substring(base64IndexStart);
								var base64IndexEnd = str.indexOf(';');
	
								if (base64IndexEnd < 0) {
									base64IndexEnd = str.length;
								}
	
								base64str = str.substring(7, base64IndexEnd);
							} else {
								//we didn't find 'base64,', emit an error as we can't decrypt this
	
								//maybe as a last resort we can search the init segment for the pssh, if we don't find it then emit an error as we can't decrypt this
							}
						}
					}
				}
	
				if (base64str) {
					var decodedStr = atob(base64str);
					var pssh = null;
					var count = void 0;
					var offset = 0;
					var fourcc = 0;
					var buffer = void 0;
					var dv = void 0;
					var moov = 0x6D6F6F76;
	
					if (format === 'com.microsoft.playready') {
						/*
	     	if we are PlayReady then the decodedStr just contains the PlayReady Object (PRO), we need to build the pssh and append the PRO
	     */
						var psshArray = new ArrayBuffer(decodedStr.length + 32); //32 - version zero pssh length
						dv = new DataView(psshArray);
	
						//pssh length
						dv.setUint32(0, psshArray.byteLength);
						dv.setUint32(4, 0x70737368); //'pssh'
						dv.setUint32(8, 0x00000000); //version
						dv.setUint32(12, 0x9A04F079); //drm guid
						dv.setUint32(16, 0x98404286);
						dv.setUint32(20, 0xAB92E65B);
						dv.setUint32(24, 0xE0885F95);
						dv.setUint32(28, decodedStr.length); //custom data length
	
						//insert the decoded string as the custom data at the end of the pssh
						offset = 32;
	
						pssh = new Uint8Array(psshArray);
					} else {
						//the decodedStr is the pssh
						pssh = new Uint8Array(decodedStr.length);
					}
	
					for (count = 0; count < decodedStr.length; count++) {
						pssh[count + offset] = decodedStr.charCodeAt(count);
					}
	
					//1. append the pssh to the end of the newInitSegment
					//newInitSegment = new Uint8Array(initSegment.byteLength + pssh.length);
					newInitSegment = new ArrayBuffer(initSegment.byteLength + pssh.length);
					dv = new DataView(newInitSegment);
					buffer = new Uint8Array(newInitSegment);
					buffer.set(new Uint8Array(initSegment), 0);
					buffer.set(pssh, initSegment.byteLength);
	
					//reset the offset for moov length changes
					offset = 0;
	
					//2. modify the moov length - search for the moov atom and increase its size by the pssh length
					do {
						var len = dv.getUint32(offset);
						fourcc = dv.getUint32(offset + 4);
	
						if (fourcc === moov) {
							dv.setUint32(offset, len + pssh.length);
						} else {
							offset += len;
						}
					} while (fourcc !== moov && offset < buffer.length);
	
					if (offset >= buffer.length - 8) {
						//bad init segment - emit error
					}
				} else if (levelkey && (levelkey.method === 'SAMPLE-AES' || levelkey.method === 'SAMPLE-AES-CTR' || levelkey.method === 'SAMPLE-AES-CENC')) {
					//clear key
	
					//we need a version one pssh with all the kids, no custom data
	
					//need to search for tenc to extact the kids
	
					var _psshArray = new ArrayBuffer(52); //52 - version one pssh length with one kid
					var _dv = new DataView(_psshArray);
					var _buffer = void 0;
					var _offset = 0;
					var _fourcc = void 0;
					var _moov = 0x6D6F6F76;
	
					//pssh length
					_dv.setUint32(0, _psshArray.byteLength);
					_dv.setUint32(4, 0x70737368); //'pssh'
					_dv.setUint32(8, 0x01000000); //version
					_dv.setUint32(12, 0x1077EFEC); //drm guid
					_dv.setUint32(16, 0xC0B24D02);
					_dv.setUint32(20, 0xACE33C1E);
					_dv.setUint32(24, 0x52E2FB4B);
					_dv.setUint32(28, 0x00000001); //number of kids
					_dv.setUint32(32, 0x30303030);
					_dv.setUint32(34, 0x30303030);
					_dv.setUint32(40, 0x30303030);
					_dv.setUint32(44, 0x30303030);
					_dv.setUint32(48, 0x00000000); //custom data length
	
					newInitSegment = new ArrayBuffer(initSegment.byteLength + _psshArray.byteLength);
	
					_dv = new DataView(newInitSegment);
					_buffer = new Uint8Array(newInitSegment);
					_buffer.set(new Uint8Array(initSegment), 0);
					_buffer.set(new Uint8Array(_psshArray), initSegment.byteLength);
	
					//2. modify the moov length - search for the moov atom and increase its size by the pssh length
					do {
						var _len = _dv.getUint32(_offset);
						_fourcc = _dv.getUint32(_offset + 4);
	
						if (_fourcc === _moov) {
							_dv.setUint32(_offset, _len + _psshArray.byteLength);
						} else {
							_offset += _len;
						}
					} while (_fourcc !== _moov && _offset < _buffer.length);
	
					if (_offset >= _buffer.length - 8) {
						//bad init segment - emit error
					}
				} else {
					newInitSegment = initSegment;
				}
	
				return newInitSegment;
			}
	
			//this should be moved to the demuxer along with all other CMAF related functions
	
		}, {
			key: 'getTimeScale',
			value: function getTimeScale(data) {
				var frag = _muxjs2.default.mp4.tools.inspect(new Uint8Array(data));
				var timeScale = void 0;
				var i = void 0;
				var j = void 0;
				var k = void 0;
				var l = void 0;
	
				for (i = 0; i < frag.length && timeScale === undefined; i++) {
					if (frag[i].type === 'moov') {
						for (j = 0; j < frag[i].boxes.length && timeScale === undefined; j++) {
							if (frag[i].boxes[j].type === 'mvhd') {
								timeScale = frag[i].boxes[j].timescale;
							} else if (frag[i].boxes[j].type === 'trak') {
								for (k = 0; k < frag[i].boxes[j].boxes.length && timeScale === undefined; k++) {
									if (frag[i].boxes[j].boxes[k].type === 'mdia') {
										for (l = 0; l < frag[i].boxes[j].boxes[k].boxes.length && timeScale === undefined; l++) {
											if (frag[i].boxes[j].boxes[k].boxes[l].type === 'mdhd') {
												timeScale = frag[i].boxes[j].boxes[k].boxes[l].timescale;
											}
										}
									}
								}
							}
						}
					}
				}
	
				if (timeScale === undefined) {
					_logger.logger.warn('getTimeScale: No valid getTimeScale found, using the default getTimeScale of 30000');
					timeScale = 30000;
				}
	
				return timeScale;
			}
	
			//this should be moved to the demuxer along with all other CMAF related functions
	
		}, {
			key: 'getTimestampOffset',
			value: function getTimestampOffset(data, timeScale) {
				var frag = _muxjs2.default.mp4.tools.inspect(new Uint8Array(data));
				var ts = timeScale;
				var timestampOffset = void 0;
				var i = void 0;
				var j = void 0;
				var k = void 0;
	
				if (ts <= 0) {
					_logger.logger.warn('getTimestampOffset: Invalid timeScale found, using the default value of 30000');
					ts = 30000;
				}
	
				for (i = 0; i < frag.length && timestampOffset === undefined; i++) {
					if (frag[i].type === 'moof') {
						for (j = 0; j < frag[i].boxes.length && timestampOffset === undefined; j++) {
							if (frag[i].boxes[j].type === 'traf') {
								for (k = 0; k < frag[i].boxes[j].boxes.length && timestampOffset === undefined; k++) {
									if (frag[i].boxes[j].boxes[k].type === 'tfdt') {
										timestampOffset = frag[i].boxes[j].boxes[k].baseMediaDecodeTime / ts;
									}
								}
							}
						}
					}
				}
	
				if (timestampOffset === undefined) {
					_logger.logger.warn('getTimestampOffset: No valid timestampOffset found, using the default timestampOffset of 0');
					timestampOffset = 0;
				}
	
				return -timestampOffset;
			}
		}, {
			key: 'onFragLoaded',
			value: function onFragLoaded(data) {
				var fragCurrent = this._fragCurrent;
				var fragLoaded = data.frag;
	
				if (this.state === State.FRAG_LOADING && fragCurrent && fragLoaded.type === 'main' && fragLoaded.level === fragCurrent.level && fragLoaded.sn === fragCurrent.sn) {
					var stats = data.stats;
					var currentLevel = this._levels[fragCurrent.level];
					var details = currentLevel.details;
	
					this._flushOnStoppedBuffering = [];
	
					_logger.logger.log('onFragLoaded: Loaded main ' + fragCurrent.sn + ' of [' + details.startSN + ' ,' + details.endSN + '], level ' + fragCurrent.level + ', size ' + stats.loaded + ' bytes, load time ' + (stats.tload - stats.tfirst) + 'ms, latency ' + (stats.tfirst - stats.trequest) + 'ms');
					// reset frag bitrate test in any case after frag loaded event
					this._bitrateTest = false;
					this._stats = stats;
					// if this frag was loaded to perform a bitrate test AND if hls.nextLoadLevel is greater than 0
					// then this means that we should be able to load a fragment at a higher quality level
					if (fragLoaded.bitrateTest === true && this.hls.nextLoadLevel) {
						// switch back to IDLE state ... we just loaded a fragment to determine adequate start bitrate and initialize autoswitch algo
						this.state = State.IDLE;
						this._startFragRequested = false;
						stats.tparsed = stats.tbuffered = performance.now();
						this.hls.trigger(_events2.default.FRAG_BUFFERED, { stats: stats, frag: fragCurrent, id: 'main' });
						this.tick();
					} else if (this._waitForFlush) {
						_logger.logger.log('main aborting parse due to flush');
						this._checkIfBufferReady();
					} else if (fragLoaded.sn === 'initSegment') {
						this.state = State.IDLE;
						stats.tparsed = stats.tbuffered = performance.now();
						//details.initSegment.data = data.payload;
						details.initSegment.data = this.insertPssh(data.payload, details.initSegment);
						//details.isCMAF = this.isCMAF(details.initSegment.data);
						this.cmaf = this.isCMAF(details.initSegment.data);
						this.hls.trigger(_events2.default.FRAG_BUFFERED, { stats: stats, frag: fragCurrent, id: 'main' });
						this.tick();
					} else {
						this.state = State.PARSING;
						// transmux the MPEG-TS data to ISO-BMFF segments
						var duration = details.totalduration;
						var level = fragCurrent.level;
						var sn = fragCurrent.sn;
						var audioCodec = this.config.defaultAudioCodec || currentLevel.audioCodec;
	
						if (this._audioCodecSwap) {
							_logger.logger.log('swapping playlist audio codec');
							if (audioCodec === undefined) {
								audioCodec = this.lastAudioCodec;
							}
							if (audioCodec) {
								if (audioCodec.indexOf('mp4a.40.5') !== -1) {
									audioCodec = 'mp4a.40.2';
								} else {
									audioCodec = 'mp4a.40.5';
								}
							}
						}
						this._pendingBuffering = true;
						this._appended = false;
						_logger.logger.log('Parsing ' + sn + ' of [' + details.startSN + ' ,' + details.endSN + '],level ' + level + ', cc ' + fragCurrent.cc);
						// time Offset is accurate if level PTS is known, or if playlist is not sliding (not live)
						// and if media is not seeking (this is to overcome potential timestamp drifts between playlists and fragments)
						var media = this.media;
						var mediaSeeking = media && media.seeking;
						var accurateTimeOffset = !mediaSeeking && (details.PTSKnown || !details.live);
						var initSegmentData = details.initSegment ? details.initSegment.data : [];
	
						if (this.cmaf /*details.isCMAF*/) {
								if (details.initSegment.data) {
									var tracks = {};
									var initData = { tracks: tracks };
									initData.frag = fragLoaded;
									initData.id = 'main';
	
									//if audioCodec is present in the currentLevel but no videoCodec this would indicate audio only
									//need to test audio only
									if (currentLevel.videoCodec) {
										tracks.video = {
											container: 'video/mp4',
											codec: currentLevel.videoCodec,
											initSegment: details.initSegment.data,
											metadata: {
												width: currentLevel.width,
												height: currentLevel.height
											},
											//temporary hack for fairplay - DO NOT rely on this as it will be removed!
											levelkeys: details.initSegment.levelkeys
										};
									} else {
										tracks.audio = {
											container: 'audio/mp4',
											codec: currentLevel.audioCodec,
											initSegment: details.initSegment.data,
											metadata: {
												channelCount: 2 //get the correct value!
											},
											//temporary hack for fairplay - DO NOT rely on this as it will be removed!
											levelkeys: details.initSegment.levelkeys
										};
									}
	
									if (!this.timestampOffset) {
										var timeScale = this.getTimeScale(details.initSegment.data);
										this.timestampOffset = this.getTimestampOffset(data.payload, timeScale);
									}
	
									this.onFragParsingInitSegment(initData);
	
									//only do this once per init segment
									//details.initSegment.data = null;
								}
	
								var payload = {
									data1: new Int8Array(data.payload),
									data2: null, //is ignored
									startPTS: fragCurrent.startDTS / 90e3,
									endPTS: fragCurrent.nextDTS / 90e3,
									startDTS: fragCurrent.startDTS / 90e3,
									endDTS: fragCurrent.nextDTS / 90e3,
									type: currentLevel.videoCodec ? 'video' : 'audio',
									nb: fragCurrent.frames,
									dropped: 0, //dropped
									duplicate: false, //would need to keep track of the last startDTS
									dts: fragCurrent.startDTS,
									frag: fragCurrent,
									id: 'main'
								};
	
								this.onFragParsingData(payload);
								this.onFragParsed(payload);
							} else {
							var demuxer = this._demuxer;
							if (!demuxer) {
								demuxer = this._demuxer = new _demuxer2.default(this.hls, 'main');
							}
	
							var deliberateGap = false;
							//we need to keep the gap value for later, in case we end up seeking into the gap
							if (fragCurrent.unmodifiedGap && fragCurrent.unmodifiedGap !== fragCurrent.gap) {
								fragCurrent.gap = fragCurrent.unmodifiedGap;
							} else {
								fragCurrent.unmodifiedGap = fragCurrent.gap ? fragCurrent.gap : 0;
							}
	
							if (this._fragPrevious && fragCurrent.gap) {
								var fragPrevious = this._fragPrevious;
								var tolerance = this._levels[level].details.averagetargetduration / 2;
								//if the start of this frag (minus the gap) is close to the end of the previous one, tell muxjs that this is contiguous
								if (fragCurrent.start - fragCurrent.gap / 1000 > fragPrevious.start + tolerance && fragCurrent.start - fragCurrent.gap / 1000 < fragPrevious.start + tolerance * 3) {
									deliberateGap = true;
								}
	
								//If there's no alt audio, we can just remove the gap entirely
								//Otherwise, if we're buffered inside the gap, we got the frag from another variant and don't need to fill it in
								if (!this._altAudio || _bufferHelper2.default.isBuffered(media, fragCurrent.start - fragCurrent.gap / (1000 * 2))) {
									//1000 to convert to seconds, 2 to get halfway into the gap
									fragCurrent.gap = 0;
								}
							}
	
							demuxer.push(data.payload, initSegmentData, audioCodec, currentLevel.videoCodec, fragCurrent, duration, accurateTimeOffset, this.fragAborted, deliberateGap);
							this.fragAborted = false;
							this._parsingDataCount = 0;
						}
					}
				}
				this._fragLoadError = 0;
				this._gapCycleBase = undefined;
			}
		}, {
			key: 'onFragParsingInitSegment',
			value: function onFragParsingInitSegment(data) {
				var hls = this.hls;
				var fragCurrent = this._fragCurrent;
				var fragNew = data.frag;
				if (fragCurrent && data.id === 'main' && fragNew.sn === fragCurrent.sn && fragNew.level === fragCurrent.level && this.state === State.PARSING) {
					var tracks = data.tracks;
					var trackName = void 0;
					var track = void 0;
	
					// if audio track is expected to come from audio stream controller, discard any coming from main
					if (tracks.audio && this._altAudio) {
						delete tracks.audio;
					}
					// include levelCodec in audio and video tracks
					track = tracks.audio;
					if (track) {
						/* mactrix replace
	     				var audioCodec = this._levels[this._level].audioCodec,
	     				ua = navigator.userAgent.toLowerCase();
	     */
						var audioCodec = this._levels[this._level].audioCodec; // mactrix change: new browser detection, remove ua, and trailing comma
						if (audioCodec && this._audioCodecSwap) {
							_logger.logger.log('swapping playlist audio codec');
							if (audioCodec.indexOf('mp4a.40.5') !== -1) {
								audioCodec = 'mp4a.40.2';
							} else {
								audioCodec = 'mp4a.40.5';
							}
						}
						// in case AAC and HE-AAC audio codecs are signalled in manifest
						// force HE-AAC , as it seems that most browsers prefers that way,
						// except for mono streams OR on FF
						// these conditions might need to be reviewed ...
						if (this._audioCodecSwitch) {
							// don't force HE-AAC if mono stream
							if (track.metadata.channelCount !== 1 &&
							// don't force HE-AAC if firefox
							hls.browFirefox === true) {
								// mactrix change: new browser detection
								audioCodec = 'mp4a.40.5';
							}
						}
						// HE-AAC is broken on Android, always signal audio codec as AAC even if variant manifest states otherwise
						/* mactrix replace
	     		if(ua.indexOf('android') !== -1 && track.container !== 'audio/mpeg') { // Exclude mpeg audio
	     */
						if (hls.browAndroid === true && track.container !== 'audio/mpeg') {
							// Exclude mpeg audio - mactrix change: new browser detection.
							audioCodec = 'mp4a.40.2';
							_logger.logger.log('Android: force audio codec to ' + audioCodec);
						}
						track.levelCodec = audioCodec;
						track.id = data.id;
					}
					track = tracks.video;
					if (track) {
						track.levelCodec = this._levels[this._level].videoCodec;
						track.id = data.id;
					}
					hls.trigger(_events2.default.BUFFER_CODECS, tracks);
					// loop through tracks that are going to be provided to bufferController
					for (trackName in tracks) {
						//eslint-disable-line guard-for-in
						track = tracks[trackName];
						_logger.logger.log('main track:' + trackName + ',container:' + track.container + ',codecs[level/parsed]=[' + track.levelCodec + '/' + track.codec + ']');
						var initSegment = track.initSegment;
						if (initSegment) {
							this._appended = true;
							// arm pending Buffering flag before appending a segment
							this._pendingBuffering = true;
	
							hls.trigger(_events2.default.BUFFER_APPENDING, {
								type: trackName,
								data: initSegment,
								parent: 'main',
								content: 'initSegment',
								sn: fragCurrent.sn
							});
						}
					}
					//trigger handler right now
					this.tick();
				}
			}
		}, {
			key: 'onFragParsingData',
			value: function onFragParsingData(data) {
				var _this3 = this;
	
				var fragCurrent = this._fragCurrent;
				var fragNew = data.frag;
				if (fragCurrent && data.id === 'main' && fragNew.sn === fragCurrent.sn && fragNew.level === fragCurrent.level && !(data.type === 'audio' && this._altAudio) && // filter out main audio if audio track is loaded through audio stream controller
				this.state === State.PARSING) {
					//Mactrix changes begin: don't do anything besides tick() if this is a duplicate
					if (!data.duplicate /*|| this._bufferNextDuplicate*/) {
							/*this._bufferNextDuplicate = false;*/
							//Mactrix changes end
							var level = this._levels[this._level];
							//let frag = fragCurrent;
	
							if (isNaN(data.endPTS)) {
								data.endPTS = data.startPTS + fragCurrent.duration;
								data.endDTS = data.startDTS + fragCurrent.duration;
							}
	
							this._flushOnStoppedBuffering.push({ type: data.type, start: data.startPTS, end: data.endPTS });
							//Mactrix line addded, keep chunk time info so we can flush half-buffered frags if the buffering process is interrupted
	
							_logger.logger.log('onFragParsingData Main Parsed ' + data.type + ' ' + data.frag.sn + ',PTS:[' + data.startPTS.toFixed(3) + ',' + data.endPTS.toFixed(3) + '],DTS:[' + data.startDTS.toFixed(3) + '/' + data.endDTS.toFixed(3) + '],nb:' + data.nb + ',dropped:' + (data.dropped || 0));
	
							// Detect gaps in a fragment  and try to fix it by finding a keyframe in the previous fragment (see _findFragments)
							/*Mactrix remove: muxjs keeps a gop cache and does key frame extending to handle this ... data.dropped should always be false
	      		  if(data.type === 'video') {
	      			frag.dropped = data.dropped;
	      			if (frag.dropped) {
	      			if (!frag.backtracked) {
	      				// Return back to the IDLE state without appending to buffer
	      				// Causes findFragments to backtrack a segment and find the keyframe
	      				// Audio fragments arriving before video sets the nextLoadPosition, causing _findFragments to skip the backtracked fragment
	      				frag.backtracked = true;
	      				this._nextLoadPosition = data.startPTS;
	      				this._state = State.IDLE;
	      				this.tick();
	      				return;
	      			} else {
	      				logger.warn('Already backtracked on this fragment, appending with the gap');
	      			}
	      			} else {
	      			// Only reset the backtracked flag if we've loaded the frag without any dropped frames
	      			frag.backtracked = false;
	      			}
	      		}
	      */
							var hls = this.hls;
	
							if (this._waitForFlush) {
								_logger.logger.log('main aborting append due to flush');
								this._checkIfBufferReady();
	
								this.fragAborted = true;
							} else {
								hls.trigger(_events2.default.LEVEL_PTS_UPDATED, { details: level.details, level: this._level,
									drift: 0, type: data.type, start: data.startPTS, end: data.endPTS });
	
								// has remuxer dropped video frames located before first keyframe ?
								[data.data1, data.data2].forEach(function (buffer) {
									// only append in PARSING state (rationale is that an appending error could happen synchronously on first segment appending)
									// in that case it is useless to append following segments
									if (buffer && buffer.length && _this3.state === State.PARSING) {
										_this3._appended = true;
										// arm pending Buffering flag before appending a segment
										_this3._pendingBuffering = true;
	
										hls.trigger(_events2.default.BUFFER_APPENDING, {
											type: data.type,
											data: buffer,
											parent: 'main',
											content: 'data',
											sn: data.frag.sn,
											level: data.frag.level,
											start: data.startPTS,
											end: data.endPTS,
											dts: data.dts,
											targetDuration: data.frag.duration
										});
										_this3._parsingDataCount++;
									}
								});
							}
						}
					//trigger handler right now
					this.tick();
				}
			}
		}, {
			key: 'onFragParsed',
			value: function onFragParsed(data) {
				var fragCurrent = this._fragCurrent;
				var fragNew = data.frag;
				if (fragCurrent && data.id === 'main' && fragNew.sn === fragCurrent.sn && fragNew.level === fragCurrent.level && this.state === State.PARSING && this._parsingDataCount > 0) {
					this._stats.tparsed = performance.now();
					this.state = State.PARSED;
					this._parsingDataCount = 0;
					this._checkAppendedParsed();
				} else if (fragCurrent && data.id === 'main' && fragNew.sn === fragCurrent.sn && fragNew.level === fragCurrent.level && this.state === State.PARSING && this._parsingDataCount === 0) {
					this.state = State.IDLE;
					this._fragCurrent = null;
					this._fragPrevious = null;
				}
			}
		}, {
			key: 'onAudioTrackSwitching',
			value: function onAudioTrackSwitching(data) {
				// if any URL found on new audio track, it is an alternate audio track
				this.forceStopFetching = true; //Mactrix line added, stop frag selector from operating in the middle of a track switch
				var altAudio = !!data.url;
				var trackId = data.id;
	
				//Mactrix additions start
				//clear load counter on track switch to prevent false fragLoopLoadingErrors
				var levels = this._levels;
				if (levels) {
					// reset fragment load counter
					levels.forEach(function (level) {
						if (level.details) {
							level.details.fragments.forEach(function (fragment) {
								fragment.loadCounter = undefined;
								fragment.backtracked = undefined;
							});
						}
					});
				}
				//Mactrix additions end
	
				// if we switch on main audio, ensure that main fragment scheduling is synced with media.buffered
				// don't do anything if we switch to alt audio: audio stream controller is handling it.
				// we will just have to change buffer scheduling on audioTrackSwitched
				if (!altAudio) {
					if (this.mediaBuffer !== this.media) {
						_logger.logger.log('switching on main audio, use media.buffered to schedule main fragment loading');
						this.mediaBuffer = this.media;
						var fragCurrent = this._fragCurrent;
						// we need to refill audio buffer from main: cancel any frag loading to speed up audio switch
						if (fragCurrent.loader) {
							_logger.logger.log('switching to main audio track, cancel main fragment load');
							fragCurrent.loader.abort();
						}
						this._fragCurrent = null;
						this._fragPrevious = null;
						// destroy demuxer to force init segment generation (following audio switch)
						if (this._demuxer) {
							this._demuxer.destroy();
							this._demuxer = null;
						}
						// switch to IDLE state to load new fragment
						this.state = State.IDLE;
					}
					var hls = this.hls;
					// switching to main audio, flush all audio and trigger track switched
					/* Mactrix line removed, this has been moved to hls.js due to issue where audio buffer would not flush on change if audio buffer is full
	    	hls.trigger(Event.BUFFER_FLUSHING, {startOffset: 0 , endOffset: Number.POSITIVE_INFINITY, type : 'audio'});
	    */
					hls.trigger(_events2.default.AUDIO_TRACK_SWITCHED, { id: trackId });
					this._altAudio = false;
				}
				//Mactrix additions start, prevent race condition when starting on latebound audio in Safari
				else {
						this._altAudio = true;
					}
				//Mactrix additions end
			}
		}, {
			key: 'onAudioTrackSwitched',
			value: function onAudioTrackSwitched(data) {
				var hls = this.hls;
				/*
	   var trackId = data.id,
	   altAudio = !!this.hls.audioTracks[trackId].url;
	   */
				//Mactrix changes begin
				//add audio rendition group support
				var trackId = data.id;
				var rendition = hls.audioTrackController.getRenditionNumber(trackId);
				var altAudio = !!hls.audioTracks[trackId].renditions[rendition].url;
				//Mactrix changes end
				if (altAudio) {
					var videoBuffer = this.videoBuffer;
					// if we switched on alternate audio, ensure that main fragment scheduling is synced with video sourcebuffer buffered
					if (videoBuffer && this.mediaBuffer !== videoBuffer) {
						_logger.logger.log('switching on alternate audio, use video.buffered to schedule main fragment loading');
						this.mediaBuffer = videoBuffer;
					}
				}
				this._altAudio = altAudio;
				this.forceStopFetching = false; //Mactrix line added, stop frag selector from operating in the middle of a track switch
				this.tick();
			}
		}, {
			key: 'onBufferCreated',
			value: function onBufferCreated(data) {
				var tracks = data.tracks;
				var mediaTrack = void 0;
				var name = void 0;
				var alternate = false;
	
				for (var type in tracks) {
					if (type === 'video' || type === 'audio') {
						var track = tracks[type];
						if (track.id === 'main') {
							name = type;
							mediaTrack = track;
							// keep video source buffer reference
							if (type === 'video') {
								this.videoBuffer = tracks[type].buffer;
	
								if (this.timestampOffset) {
									this.videoBuffer.timestampOffset = this.timestampOffset;
								}
							}
						} else {
							alternate = true;
						}
					}
				}
				if (alternate && mediaTrack) {
					_logger.logger.log('alternate track found, use ' + name + '.buffered to schedule main fragment loading');
					this.mediaBuffer = mediaTrack.buffer;
	
					if (this.timestampOffset) {
						this.mediaBuffer.timestampOffset = this.timestampOffset;
					}
				} else {
					this.mediaBuffer = this.media;
				}
			}
		}, {
			key: 'onBufferAppended',
			value: function onBufferAppended(data) {
				if (data.parent === 'main') {
					this._fragBufferCount++;
					var state = this.state;
					if (state === State.PARSING || state === State.PARSED) {
						// check if all buffers have been appended
						this._pendingBuffering = data.pending > 0;
						this._checkAppendedParsed();
					}
				}
			}
		}, {
			key: '_checkAppendedParsed',
			value: function _checkAppendedParsed() {
				//trigger handler right now
				if (this.state === State.PARSED && (!this._appended || !this._pendingBuffering)) {
					var frag = this._fragCurrent;
					if (frag) {
						var media = this.mediaBuffer ? this.mediaBuffer : this.media;
						try {
							_logger.logger.log('main buffered : ' + _timeRanges2.default.toString(media.buffered) + ' sn : ' + frag.sn);
						} catch (err) {
							_logger.logger.log('main buffered : {TimeRanges.toString(media.buffered)} failed. err ' + err.message);
						}
						// filter fragments potentially evicted from buffer. this is to avoid memleak on live streams
						var bufferedFrags = this._bufferedFrags.filter(function (filterFrag) {
							return _bufferHelper2.default.isBuffered(media, (filterFrag.startPTS + filterFrag.endPTS) / 2);
						});
						// push new range
						bufferedFrags.push(frag);
						// sort frags, as we use BinarySearch for lookup in getBufferedFrag ...
						this._bufferedFrags = bufferedFrags.sort(function (a, b) {
							return a.startPTS - b.startPTS;
						});
						this._fragPrevious = frag;
						var stats = this._stats;
						stats.tbuffered = performance.now();
						// we should get rid of this._fragLastKbps
						this._fragLastKbps = Math.round(8 * stats.total / (stats.tbuffered - stats.tfirst));
						this.hls.trigger(_events2.default.FRAG_BUFFERED, { stats: stats, frag: frag, id: 'main' });
						if (this._bufferBeforeSeekingTime !== undefined && this._bufferBeforeSeekingApplied) {
							if (_bufferHelper2.default.isBuffered(this.media, this._bufferBeforeSeekingTime)) {
								var bufferedTime = this._bufferBeforeSeekingTime;
	
								this._bufferBeforeSeekingTime = undefined;
								this._bufferBeforeSeekingApplied = undefined;
	
								_logger.logger.log('bufferBeforeSeeking: Ready.');
								this.hls.trigger(_events2.default.SEEK_READY, { time: bufferedTime });
							} else {
								var tryAgain = true;
	
								if (this.hls.streamCoordinator.checkIfRenditionsAreActive && this.hls.audioStreamController.bufferBeforeSeeking !== undefined) {
									tryAgain = false;
								}
								if (tryAgain) {
									var targetTime = this._bufferBeforeSeekingTime + 1;
	
									_logger.logger.log('bufferBeforeSeeking: Buffered main but desired time not found. Pushing forward target time to ' + targetTime + '.');
	
									this.hls.bufferBeforeSeeking = targetTime;
								} else {
									_logger.logger.log('bufferBeforeSeeking: Not ready.');
								}
							}
						}
						if (frag.unmodifiedGap && !_bufferHelper2.default.isBuffered(media, this.media.currentTime)) {
							if (this.media.currentTime < frag.start && this.media.currentTime > frag.start - frag.unmodifiedGap) {
								_logger.logger.warn('seeked into a gap, seeking to start of frag');
								//Safari freezes when trying to seek to the exact end of the seekable range
								//The extra millisecond still causes a media element error but at least it recovers
								this.media.currentTime = frag.start + 0.001;
							}
						}
						this.state = State.IDLE;
					}
					this.tick();
				}
			}
		}, {
			key: 'onError',
			value: function onError(data) {
				var _this4 = this;
	
				var frag = data.frag || this._fragCurrent;
				// don't handle frag error not related to main fragment
				if (frag && frag.type !== 'main') {
					return;
				}
				var media = this.media;
				// 0.5 : tolerance needed as some browsers stalls playback before reaching buffered end
	
				var desiredPlayPoint = this._bufferBeforeSeekingTime;
				if (desiredPlayPoint === undefined && this.media) {
					desiredPlayPoint = this.media.currentTime;
				}
	
				var mediaBuffered = media && _bufferHelper2.default.isBuffered(media, desiredPlayPoint) && _bufferHelper2.default.isBuffered(media, desiredPlayPoint + 0.5);
	
				switch (data.details) {
					case _errors.ErrorDetails.FRAG_LOAD_ERROR:
					case _errors.ErrorDetails.FRAG_LOAD_TIMEOUT:
					case _errors.ErrorDetails.KEY_LOAD_ERROR:
					case _errors.ErrorDetails.KEY_LOAD_TIMEOUT:
						if (!data.fatal) {
							var loadError = this._fragLoadError;
							if (loadError) {
								loadError++;
							} else {
								loadError = 1;
							}
							var config = this.config;
							// keep retrying / don't raise fatal network error if current position is buffered or if in automode with current level not 0
							if (loadError < 2 || this._fragBufferCount !== 0) {
								this._fragLoadError = loadError;
								// reset load counter to avoid frag loop loading error
								frag.loadCounter = 0;
								// exponential backoff capped to config.fragLoadingMaxRetryTimeout
								var delay = Math.min(Math.pow(2, loadError - 1) * config.fragLoadingRetryDelay, config.fragLoadingMaxRetryTimeout);
								if (this._skipReloadDelay) {
									delay = 0;
									this._skipReloadDelay = false;
								}
								_logger.logger.warn('mediaController: frag loading failed, retry in ' + delay + ' ms');
								this.retryDate = performance.now() + delay;
								// retry loading state
								// if loadedmetadata is not set, it means that we are emergency switch down on first frag
								// in that case, reset startFragRequested flag
								if (!this._loadedMetadata) {
									this._startFragRequested = false;
									this._nextLoadPosition = this._startPosition;
								}
								this.state = State.FRAG_LOADING_WAITING_RETRY;
							} else {
								_logger.logger.error('mediaController: ' + data.details + ' reaches max retry, redispatch as fatal ...');
								// switch error to fatal
								data.fatal = true;
								this.state = State.ERROR;
							}
						}
						break;
					case _errors.ErrorDetails.FRAG_LOOP_LOADING_ERROR:
						if (!data.fatal) {
							// if buffer is not empty
							if (mediaBuffered) {
								// try to reduce max buffer length : rationale is that we could get
								// frag loop loading error because of buffer eviction
								this._reduceMaxBufferLength(frag.duration);
								this.state = State.IDLE;
								/* Mactrix lines removed, this isn't a good check for if a frag loop is fatal, as audio track changes may accidentally trigger it
	        } else {
	       // buffer empty. report as fatal if in manual mode or if lowest level.
	       // level controller takes care of emergency switch down logic
	       if (!frag.autoLevel || frag.level === 0) {
	         // switch error to fatal
	         data.fatal = true;
	         this._state = State.ERROR;
	       }
	       */
							}
						}
						break;
					case _errors.ErrorDetails.LEVEL_LOAD_ERROR:
					case _errors.ErrorDetails.LEVEL_LOAD_TIMEOUT:
						if (this.state !== State.ERROR) {
							if (data.fatal) {
								// if fatal error, stop processing
								this.state = State.ERROR;
								_logger.logger.warn('streamController: ' + data.details + ',switch to ' + this.state + ' state ...');
							} else {
								// in cas of non fatal error while waiting level load to be completed, switch back to IDLE
								if (this.state === State.WAITING_LEVEL) {
									this.state = State.IDLE;
								}
							}
						}
						break;
					case _errors.ErrorDetails.BUFFER_FULL_ERROR:
						// if in appending state
						if (data.parent === 'main' && (this.state === State.PARSING || this.state === State.PARSED)) {
							// reduce max buf len if current position is buffered
							if (mediaBuffered) {
								this._reduceMaxBufferLength(this.config.maxBufferLength);
								//Mactrix additions start
								//its possible for one buffer to succeed and the other to fail, which can cause problems with timestamp calculations in Edge
								//this flushes the half-buffered frag, which corrects the timestamps on the next load attempt
								this._flushOnStoppedBuffering.forEach(function (fragInfo) {
									_this4.hls.trigger(_events2.default.BUFFER_FLUSHING, { startOffset: fragInfo.start, endOffset: fragInfo.end, type: fragInfo.type });
								});
								//Mactrix additions end
								this.state = State.IDLE;
							} else {
								// current position is not buffered, but browser is still complaining about buffer full error
								// this happens on IE/Edge, refer to https://github.com/video-dev/hls.js/pull/708
								// in that case flush the whole buffer to recover
								_logger.logger.warn('buffer full error also desired time is not buffered, flush everything');
								this._fragCurrent = null;
								// flush everything
								this.flushMainBuffer(0, Number.POSITIVE_INFINITY);
							}
						}
						if (this._bufferBeforeSeekingApplied === true) {
							this._bufferBeforeSeekingApplied = false;
							_logger.logger.log('Main: onBufferFull Rescheduling bufferBeforeSeeking');
						}
	
						break;
					default:
						break;
				}
			}
		}, {
			key: '_reduceMaxBufferLength',
			value: function _reduceMaxBufferLength(minLength) {
				var config = this.config;
				if (config.maxMaxBufferLength >= minLength) {
					// reduce max buffer length as it might be too high. we do this to avoid loop flushing ...
					config.maxMaxBufferLength /= 2;
					_logger.logger.warn('main:reduce max buffer length to ' + config.maxMaxBufferLength + 's');
					// increase fragment load Index to avoid frag loop loading error after buffer flush
					this._fragLoadIdx += 2 * config.fragLoadingLoopThreshold;
				}
			}
		}, {
			key: '_checkBuffer',
			value: function _checkBuffer() {
				var media = this.media;
	
				// if ready state different from HAVE_NOTHING (numeric value 0), we are allowed to seek
				if (media && media.readyState && !media.error && (this.hls.bufferController.mediaSource.readyState === 'open' || this.hls.bufferController.mediaSource.readyState === 'ended')) {
					var hls = this.hls;
	
					var currentTime = media.currentTime;
					var mediaBuffer = this.mediaBuffer ? this.mediaBuffer : media;
					var buffered = mediaBuffer.buffered;
	
					// adjust currentTime to start position on loaded metadata
					if (!this._loadedMetadata && buffered.length) {
						this._loadedMetadata = true;
						// only adjust currentTime if different from startPosition or if startPosition not buffered
						// at that stage, there should be only one buffered range, as we reach that code after first fragment has been buffered
						var startPosition = media.seeking ? currentTime : this._startPosition;
						var startPositionBuffered = _bufferHelper2.default.isBuffered(mediaBuffer, startPosition);
						// if currentTime not matching with expected startPosition or startPosition not buffered
						if (currentTime !== startPosition || !startPositionBuffered) {
							_logger.logger.log('target start position:' + startPosition);
							// if startPosition not buffered, let's seek to buffered.start(0)
							if (!startPositionBuffered || startPosition < buffered.start(0)) {
								startPosition = buffered.start(0);
								_logger.logger.warn('target start position not buffered, seek to buffered.start(0) ' + startPosition);
							}
							_logger.logger.log('adjust currentTime from ' + currentTime + ' to ' + startPosition);
							if (!this.hls.browTizen3 || this._levels[this._level].videoCodec !== undefined) {
								//we only need to delay this seek on audio only
								media.currentTime = startPosition;
							}
						}
						hls.trigger(_events2.default.START_POSITION_SET, { startPosition: startPosition }); //Mactrix line added, fix race condition when determining start time
					} else if (this._immediateSwitch) {
						this.immediateLevelSwitchEnd();
					} else {
						var bufferInfo = _bufferHelper2.default.bufferInfo(media, currentTime, 0);
						var expectedPlaying = !(media.paused || // not playing when media is paused
						media.ended || // not playing when media is ended
						hls._inSlowDetach || media.buffered.length === 0); // not playing if nothing buffered
						var jumpThreshold = 0.5; // tolerance needed as some browsers stalls playback before reaching buffered range end
						var playheadMoving = currentTime !== this._lastCurrentTime;
						var config = this.config;
	
						if (playheadMoving) {
							// played moving, but was previously stalled => now not stuck anymore
							if (this._stallReported) {
								_logger.logger.warn('playback not stuck anymore @' + currentTime + ', after ' + Math.round(performance.now() - this._stalled) + 'ms');
								this._stallReported = false;
							}
							this._stalled = undefined;
							this._nudgeRetry = 0;
							this._streamTimeoutArmed = false; //Mactrix line added
							//this._playbackStarted = true;
						} else {
							// playhead not moving
							/*
	      	if(expectedPlaying) {
	      */
							if (expectedPlaying && config.nudgeOnStall) {
								//Mactrix line changed, add ability to turn off stall detection
								// playhead not moving BUT media expected to play
								var tnow = performance.now();
								if (!this._stalled) {
									// stall just detected, store current time
									this._stalled = tnow;
									this._stallReported = false;
								} else {
									// playback already stalled, check stalling duration
									// if stalling for more than a given threshold, let's try to recover
									var stalledDuration = tnow - this._stalled;
									var bufferLen = bufferInfo.len;
									var nudgeRetry = this._nudgeRetry || 0;
									// have we reached stall deadline ?
									if (bufferLen <= jumpThreshold && stalledDuration > config.lowBufferWatchdogPeriod * 1000) {
										// report stalled error once
										if (!this._stallReported) {
											this._stallReported = true;
											_logger.logger.warn('playback stalling in low buffer @' + currentTime);
											hls.trigger(_events2.default.ERROR, {
												type: _errors.ErrorTypes.MEDIA_ERROR,
												details: _errors.ErrorDetails.BUFFER_STALLED_ERROR,
												fatal: false,
												buffer: bufferLen
											});
										}
										// if buffer len is below threshold, try to jump to start of next buffer range if close
										// no buffer available @ currentTime, check if next buffer is close (within a config.maxSeekHole second range)
										var nextBufferStart = bufferInfo.nextStart;
										var delta = nextBufferStart - currentTime;
	
										if (nextBufferStart && delta < config.maxSeekHole && delta > 0) {
											this._nudgeRetry = ++nudgeRetry;
											var nudgeOffset = nudgeRetry * config.nudgeOffset;
											// next buffer is close ! adjust currentTime to nextBufferStart
											// this will ensure effective video decoding
											_logger.logger.log('adjust currentTime from ' + media.currentTime + ' to next buffered @ ' + nextBufferStart + ' + nudge ' + nudgeOffset);
											media.currentTime = nextBufferStart + nudgeOffset;
											// reset stalled so to rearm watchdog timer
											this._stalled = undefined;
											hls.trigger(_events2.default.ERROR, {
												type: _errors.ErrorTypes.MEDIA_ERROR,
												details: _errors.ErrorDetails.BUFFER_SEEK_OVER_HOLE,
												fatal: false,
												hole: nextBufferStart + nudgeOffset - currentTime
											});
										}
									} else if (bufferLen > jumpThreshold && stalledDuration > config.highBufferWatchdogPeriod * 1000) {
										// report stalled error once
										if (!this._stallReported) {
											this._stallReported = true;
											_logger.logger.warn('playback stalling in high buffer @' + currentTime);
											hls.trigger(_events2.default.ERROR, {
												type: _errors.ErrorTypes.MEDIA_ERROR,
												details: _errors.ErrorDetails.BUFFER_STALLED_ERROR,
												fatal: false,
												buffer: bufferLen
											});
										}
										// reset stalled so to rearm watchdog timer
										this._stalled = undefined;
										this._nudgeRetry = ++nudgeRetry;
										if (nudgeRetry < config.nudgeMaxRetry) {
											var oldCurrentTime = media.currentTime;
											var targetTime = currentTime + nudgeRetry * config.nudgeOffset;
											_logger.logger.log('adjust currentTime from ' + oldCurrentTime + ' to ' + targetTime);
											// playback stalled in buffered area ... let's nudge currentTime to try to overcome this
											media.currentTime = targetTime;
											hls.trigger(_events2.default.ERROR, {
												type: _errors.ErrorTypes.MEDIA_ERROR,
												details: _errors.ErrorDetails.BUFFER_NUDGE_ON_STALL,
												fatal: false
											});
										} else {
											_logger.logger.error('still stuck in high buffer @' + currentTime + ' after ' + config.nudgeMaxRetry + ', raise fatal error');
											hls.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.MEDIA_ERROR, details: _errors.ErrorDetails.BUFFER_STALLED_ERROR, fatal: true });
										}
									}
								}
							}
							//Mactrix additions start
							//we still want to receive the buffer stall error if the nudge functionality is disabled, as we use it to tell when we enter the buffered state
							else if (expectedPlaying && !this.hls.config.nudgeOnStall) {
									var _tnow = performance.now();
									if (!this._stalled) {
										this._stalled = _tnow;
										this._stallReported = false;
									} else {
										var _stalledDuration = _tnow - this._stalled;
										var _bufferLen = bufferInfo.len;
										if (_stalledDuration > config.lowBufferWatchdogPeriod * 1000) {
											//THIS IS A WORKAROUND, REMOVE ONCE AUDIO GAP SUPPORT IS FULLY IMPLEMENTED
											//if latebound audio is known to have gaps, jump over buffer holes
											if (this._altAudio) {
												this.seekOverNearbyAudioGap(true);
											}
	
											if (!this._stallReported && !this._audioGapSeeking) {
												this._stallReported = true;
												_logger.logger.warn('playback stalling @' + currentTime);
	
												if (_bufferLen <= jumpThreshold) {
													hls.trigger(_events2.default.ERROR, {
														type: _errors.ErrorTypes.MEDIA_ERROR,
														details: _errors.ErrorDetails.BUFFER_STALLED_ERROR,
														fatal: false,
														buffer: _bufferLen
													});
												}
	
												this._streamTimeoutArmed = true;
											}
										}
									}
								}
							//Mactrix additions end
						}
					}
	
					this._lastCurrentTime = currentTime;
				}
			}
		}, {
			key: 'onFragLoadEmergencyAborted',
			value: function onFragLoadEmergencyAborted() {
				this.state = State.IDLE;
				// if loadedmetadata is not set, it means that we are emergency switch down on first frag
				// in that case, reset startFragRequested flag
				if (!this._loadedMetadata) {
					this._startFragRequested = false;
					this._nextLoadPosition = this._startPosition;
				}
				this.tick();
			}
		}, {
			key: 'onBufferFlushed',
			value: function onBufferFlushed() {
				var _this5 = this;
	
				/* after successful buffer flushing, filter flushed fragments from bufferedFrags
	     use mediaBuffered instead of media (so that we will check against video.buffered ranges in case of alt audio track)
	   */
				var media = this.mediaBuffer ? this.mediaBuffer : this.media;
				this._bufferedFrags = this._bufferedFrags.filter(function (frag) {
					return _bufferHelper2.default.isBuffered(media, (frag.startPTS + frag.endPTS) / 2);
				});
	
				// reset reference to frag
				this._fragPrevious = null;
	
				// increase fragment load Index to avoid frag loop loading error after buffer flush
				this._fragLoadIdx += 2 * this.config.fragLoadingLoopThreshold;
				// move to IDLE once flush complete. this should trigger new fragment loading
				if (this.state === State.BUFFER_FLUSHING && this.hls.bufferController.readyForData === true) {
					this.endBufferWait();
					this.state = State.IDLE;
				} else if (this.state === State.PARSED) {
					this.state = State.BUFFER_FLUSHING;
					/*this._bufferNextDuplicate = true;*/
					this._flushOnStoppedBuffering.forEach(function (fragInfo) {
						_this5.hls.trigger(_events2.default.BUFFER_FLUSHING, { startOffset: fragInfo.start, endOffset: fragInfo.end, type: fragInfo.type });
					});
				} else {
					// move to IDLE once flush complete. this should trigger new fragment loading
					this.state = State.IDLE;
					this.tick();
				}
			}
		}, {
			key: 'onBufferWait',
			value: function onBufferWait() {
				var frag = this._fragCurrent;
	
				_logger.logger.log('Main: BufferWait');
	
				if (frag) {
					if (frag.loader) {
						frag.loader.abort();
					}
					this._fragCurrent = null;
	
					if (this._bufferBeforeSeekingApplied === true) {
						this._bufferBeforeSeekingApplied = false;
						_logger.logger.log('Main: Rescheduling bufferBeforeSeeking');
					}
				}
	
				//All other cases should switch to FLUSHING
				if (this.state === State.FRAG_LOADING || this.state === State.KEY_LOADING || this.state === State.FRAG_LOADING_WAITING_RETRY) {
					this.state = State.BUFFER_FLUSHING;
				}
	
				if (this._waitForFlush) {
					_logger.logger.warn('Main: onBufferWait Already waiting');
				}
				this._waitForFlush = true; //Should only set it to true here
			}
		}, {
			key: 'endBufferWait',
			value: function endBufferWait() {
				if (this._waitForFlush) {
					_logger.logger.log('Main: end BufferWait No longer waiting');
				}
				this._waitForFlush = false; //Should only set it to false here
			}
		}, {
			key: '_checkIfBufferReady',
			value: function _checkIfBufferReady() {
				if (this.hls.bufferController.readyForData === true) {
					this.endBufferWait();
					this.state = State.IDLE;
				} else {
					this.state = State.BUFFER_FLUSHING;
				}
			}
		}, {
			key: 'swapAudioCodec',
			value: function swapAudioCodec() {
				this._audioCodecSwap = !this._audioCodecSwap;
			}
		}, {
			key: 'computeLivePosition',
			value: function computeLivePosition(sliding, levelDetails) {
				var targetLatency = this.config.liveSyncDuration !== undefined ? this.config.liveSyncDuration : this.config.liveSyncDurationCount * levelDetails.targetduration;
	
				return sliding + Math.max(0, levelDetails.totalduration - targetLatency);
			}
		}, {
			key: 'addToDeadFragList',
			value: function addToDeadFragList(deadSn) {
				if (this._levels[this._level]) {
					this._levels[this._level].deadFragList.push(deadSn);
				}
	
				//we mark the dead frag before we set the delay for next frag load, so when marking a dead frag, tell controller to set delay to 0
				this._skipReloadDelay = true;
			}
		}, {
			key: 'removeDeadFrag',
			value: function removeDeadFrag(index, fragList) {
				if (fragList[index + 1]) {
					//adjust the gap of the next frag
					if (fragList[index].gap === undefined) {
						fragList[index].gap = 0;
					}
					if (fragList[index + 1].gap === undefined) {
						fragList[index + 1].gap = 0;
					}
					fragList[index + 1].gap += fragList[index].gap + (fragList[index + 1].pdt - fragList[index].pdt);
					fragList.splice(index, 1);
	
					//alter fragList.index values so that frag selector won't enter an infinite loop
					for (var i = index; i < fragList.length; i++) {
						fragList[i].index--;
					}
				} else if (fragList[index]) {
					//no next frag, just truncate. endSN will be fixed in onLevelLoaded
					fragList.splice(index, 1);
				}
			}
		}, {
			key: 'state',
			set: function set(nextState) {
				if (this._state !== nextState) {
					var previousState = this._state;
					this._state = nextState;
					_logger.logger.log('main stream state:' + previousState + '->' + nextState);
					this.hls.trigger(_events2.default.STREAM_STATE_TRANSITION, { previousState: previousState, nextState: nextState });
				}
			},
			get: function get() {
				return this._state;
			}
		}, {
			key: 'currentLevel',
			get: function get() {
				var media = this.media;
				if (media) {
					var frag = this.getBufferedFrag(media.currentTime);
					if (frag) {
						return frag.level;
					}
				}
				return -1;
			}
		}, {
			key: 'nextBufferedFrag',
			get: function get() {
				var media = this.media;
				if (media) {
					// first get end range of current fragment
					return this.followingBufferedFrag(this.getBufferedFrag(media.currentTime));
				} else {
					return null;
				}
			}
		}, {
			key: 'nextLevel',
			get: function get() {
				var frag = this.nextBufferedFrag;
				if (frag) {
					return frag.level;
				} else {
					return -1;
				}
			}
		}, {
			key: 'bufferBeforeSeeking',
			set: function set(time) {
				_logger.logger.log('main bufferBeforeSeeking set to ' + time);
				this._bufferBeforeSeekingTime = time;
				this._bufferBeforeSeekingApplied = false;
	
				if (this._fragCurrent && this._fragCurrent.loader) {
					this._fragCurrent.loader.abort();
				}
				this._fragCurrent = null;
				this._fragPrevious = null;
				this.state = State.IDLE;
			},
			get: function get() {
				return this._bufferBeforeSeekingTime;
			}
		}, {
			key: 'liveSyncPosition',
			get: function get() {
				return this._liveSyncPosition;
			},
			set: function set(value) {
				this._liveSyncPosition = value;
			}
		}]);
	
		return StreamController;
	}(_eventHandler2.default);
	
	exports.default = StreamController;
	module.exports = exports['default'];

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _events = __webpack_require__(3);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _eventHandler = __webpack_require__(5);
	
	var _eventHandler2 = _interopRequireDefault(_eventHandler);
	
	var _logger = __webpack_require__(1);
	
	var _bufferHelper = __webpack_require__(22);
	
	var _bufferHelper2 = _interopRequireDefault(_bufferHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import { ErrorTypes, ErrorDetails } from '../errors';
	
	
	var StreamCoordinator = function (_EventHandler) {
		_inherits(StreamCoordinator, _EventHandler);
	
		function StreamCoordinator(hls) {
			_classCallCheck(this, StreamCoordinator);
	
			/*
	  	There are three pairs of controllers:
	  	main(video/in-mux audio/in-mux subtitles/audio only streams) - level-controller and stream-controller
	  	(in-mux subtitles are parsed by timeline-controller but the main pair handles loading)
	  	audio(latebound audio) - audio-track-controller and audio-stream-controller
	  	subtitle(latebound subtitles) - subtitle-track-controller and subtitle-stream-controller
	  		In all cases all three pairs will emit their manifest parsed event. Future events depend on if latebound audio/subtitles are active
	  */
	
			var _this = _possibleConstructorReturn(this, (StreamCoordinator.__proto__ || Object.getPrototypeOf(StreamCoordinator)).call(this, hls, _events2.default.MEDIA_ATTACHED, _events2.default.MEDIA_DETACHING, _events2.default.MANIFEST_LOADING, _events2.default.MANIFEST_PARSED, //main manifest parsed
			_events2.default.AUDIO_TRACKS_UPDATED, //audio manifest parsed
			_events2.default.SUBTITLE_TRACKS_UPDATED, //subtitle manifest parsed
			_events2.default.LEVEL_UPDATED, //main level parsed
			_events2.default.AUDIO_TRACK_UPDATED, //audio level parsed
			_events2.default.SUBTITLE_TRACK_UPDATED, //subtitle level parsed
			_events2.default.AUDIO_TRACK_SWITCHING, _events2.default.STREAM_DESYNC, _events2.default.FRAG_BUFFERED, _events2.default.BUFFER_FLUSHING, _events2.default.ERROR));
	
			_this.config = _this.hls.config;
			_this.media = null;
	
			_this._monitorMainControllers = false;
			_this._monitorAudioControllers = false;
			_this._monitorSubtitleControllers = false;
			_this._controllersParsed = 0;
			_this._activeControllers = 0;
			_this._mainControllersReady = false;
			_this._audioControllersReady = false;
			_this._subtitleControllersReady = false;
			_this._allReady = false;
			_this._audioControllersActive = false; //when a stream has both in-mux and latebound audio, we want to stop listening to the audio controller on in-mux
	
			_this._mainLiveTime = undefined;
			_this._audioLiveTime = undefined;
			_this._mainLevelStartTime = undefined;
			_this._mainLevelEndTime = undefined;
			_this._audioLevelStartTime = undefined;
			_this._audioLevelEndTime = undefined;
			_this._combinedLiveTime = undefined;
			_this._mainBasePdt = undefined;
			_this._audioBasePdt = undefined;
			_this._basePdt = undefined;
			_this._startPdt = undefined;
			_this._resumeBasePdt = undefined;
	
			_this._mainLive = true;
			_this._audioLive = true;
			_this._startTime = -1;
			_this._liveStreamsStartAtLiveTime = true;
	
			_this._mainStreamTimeoutTimer = null;
			_this._audioStreamTimeoutTimer = null;
			_this._mainTimedOut = false;
			_this._audioTimedOut = false;
			_this._audioForcedUnpause = false;
			_this._vidReadyForDispose = false;
			_this._audReadyForDispose = false;
			_this._defaultTimeout = 30000;
	
			_this._targetDuration = undefined;
			return _this;
		}
	
		_createClass(StreamCoordinator, [{
			key: 'dispose',
			value: function dispose() {
				this.disarmMainStreamTimeout();
				this.disarmAudioStreamTimeout();
	
				this.config = null;
				this.media = null;
				this.hls = null;
			}
		}, {
			key: 'onMediaAttached',
			value: function onMediaAttached(data) {
				this.media = data.media;
				this.onvseeking = this.onMediaSeeking.bind(this);
				this.onvended = this.onMediaEnded.bind(this);
				this.media.addEventListener('seeking', this.onvseeking);
				this.media.addEventListener('ended', this.onvended);
				this.resetStreamTimeout();
			}
		}, {
			key: 'onMediaDetaching',
			value: function onMediaDetaching() {
				if (this.media) {
					this.media.removeEventListener('seeking', this.onvseeking);
					this.media.removeEventListener('ended', this.onvended);
				}
			}
		}, {
			key: 'resetStreamTimeout',
			value: function resetStreamTimeout() {
				if (this._mainStreamTimeoutTimer) {
					this.disarmMainStreamTimeout();
					this.armMainStreamTimeout();
				}
				if (this._audioStreamTimeoutTimer) {
					this.disarmAudioStreamTimeout();
					this.armAudioStreamTimeout();
				}
			}
		}, {
			key: 'onMediaSeeking',
			value: function onMediaSeeking() {
				this.resetStreamTimeout();
			}
		}, {
			key: 'onBufferFlushing',
			value: function onBufferFlushing() {
				this.resetStreamTimeout();
			}
		}, {
			key: 'onMediaEnded',
			value: function onMediaEnded() {
				this.disarmMainStreamTimeout();
				this.disarmAudioStreamTimeout();
			}
		}, {
			key: 'onManifestLoading',
			value: function onManifestLoading() {
				//reset everything
				this._monitorMainControllers = false;
				this._monitorAudioControllers = false;
				this._monitorSubtitleControllers = false;
				this._controllersParsed = 0;
				this._activeControllers = 0;
				this._mainControllersReady = false;
				this._audioControllersReady = false;
				this._subtitleControllersReady = false;
				this._allReady = false;
				this._audioControllersActive = false;
	
				this._mainLiveTime = undefined;
				this._audioLiveTime = undefined;
				this._mainLevelStartTime = undefined;
				this._mainLevelEndTime = undefined;
				this._audioLevelStartTime = undefined;
				this._audioLevelEndTime = undefined;
				this._combinedLiveTime = undefined;
				this._mainBasePdt = undefined;
				this._audioBasePdt = undefined;
				this._basePdt = undefined;
				this._startPdt = undefined;
	
				this._mainLive = true;
				this._audioLive = true;
				this._startTime = -1;
				this._liveStreamsStartAtLiveTime = true;
	
				this.disarmMainStreamTimeout();
				this.disarmAudioStreamTimeout();
				this._mainTimedOut = false;
				this._audioTimedOut = false;
				this._defaultTimeout = 30000;
				this._vidReadyForDispose = false;
				this._audReadyForDispose = false;
	
				this._targetDuration = undefined;
			}
		}, {
			key: 'onManifestParsed',
			value: function onManifestParsed(data) {
				if (data.levels.length > 0) {
					this._monitorMainControllers = true;
				}
	
				this.checkParsingFinished();
			}
		}, {
			key: 'onAudioTracksUpdated',
			value: function onAudioTracksUpdated(data) {
				if (data.audioTracks.length > 0) {
					this._monitorAudioControllers = true;
				}
	
				this.checkParsingFinished();
			}
		}, {
			key: 'onSubtitleTracksUpdated',
			value: function onSubtitleTracksUpdated(data) {
				if (data.subtitleTracks.length > 0) {
					this._monitorSubtitleControllers = true;
				}
	
				this.checkParsingFinished();
			}
		}, {
			key: 'onLevelUpdated',
			value: function onLevelUpdated(data) {
				this._mainLive = data.details.live;
				this._mainLiveTime = this.determineLiveTime(data.details, data.sliding, 'main');
				this._mainLevelStartTime = data.details.fragments[0].start;
				this._mainLevelEndTime = data.details.totalduration;
				this.determineCombinedLiveTime();
	
				if (this._monitorMainControllers && !this._mainControllersReady && !this._allReady) {
					this._targetDuration = data.details.averagetargetduration;
					this._defaultTimeout = data.details.averagetargetduration * 3000;
					this._mainBasePdt = this.determineBasePdt(data.details, 'main');
					this._mainControllersReady = true;
	
					this.checkReady();
				}
			}
		}, {
			key: 'onAudioTrackUpdated',
			value: function onAudioTrackUpdated(data) {
				this._audioLive = data.details.live;
				this._audioLiveTime = this.determineLiveTime(data.details, data.sliding, 'audio');
				this._audioLevelStartTime = data.details.fragments[0].start;
				this._audioLevelEndTime = data.details.totalduration;
				this.determineCombinedLiveTime();
	
				if (this._monitorAudioControllers && !this._audioControllersReady && !this._allReady) {
					this._audioBasePdt = this.determineBasePdt(data.details, 'audio');
					this._audioControllersReady = true;
	
					this.checkReady();
				}
			}
		}, {
			key: 'onSubtitleTrackUpdated',
			value: function onSubtitleTrackUpdated() /*data*/{
				if (this._monitorSubtitleControllers && !this._subtitleControllersReady && !this._allReady) {
					this._subtitleControllersReady = true;
	
					this.checkReady();
				}
			}
		}, {
			key: 'onAudioTrackSwitching',
			value: function onAudioTrackSwitching() {
				var trackId = this.hls.audioTrack;
				var rendition = this.hls.audioTrackController.getRenditionNumber(trackId);
				var altAudio = !!this.hls.audioTracks[trackId].renditions[rendition].url;
	
				if (this._audioControllersActive && this.hls.audioStreamController.pausedTimer) {
					this.hls.audioStreamController.unpauseController();
				}
	
				if (altAudio) {
					this._audioControllersActive = true;
					this.armAudioStreamTimeout();
				} else {
					this._audioControllersActive = false;
					this.disarmAudioStreamTimeout();
				}
			}
		}, {
			key: 'onStreamDesync',
			value: function onStreamDesync(data) {
				var desync = data.desync / 1000;
				if (desync < 0) {
					//negative desync - main PDT is earlier than audio PDT
					this._mainLevelStartTime += desync;
					this._mainLevelEndTime += desync;
					this._mainLiveTime += desync;
				} else if (desync > 0) {
					//positive desync - audio PDT is earlier than main PDT
					this._audioLevelStartTime -= desync;
					this._audioLevelEndTime -= desync;
					this._audioLiveTime -= desync;
				}
			}
		}, {
			key: 'onFragBuffered',
			value: function onFragBuffered(data) {
				if (data.frag.type === 'main') {
					this.disarmMainStreamTimeout();
					this.armMainStreamTimeout();
				} else if (data.frag.type === 'audio') {
					this.disarmAudioStreamTimeout();
					this.armAudioStreamTimeout();
				}
	
				if (this._audioControllersActive) {
					var audioStreamController = this.hls.audioStreamController;
					var mainStreamController = this.hls.streamController;
					var audioGapTolerance = 0.2;
					var desiredPlayPoint = mainStreamController.bufferBeforeSeeking;
	
					if (desiredPlayPoint === undefined && this.media) {
						desiredPlayPoint = this.media.currentTime;
					}
	
					//if we have a known audio gap, make the gap tolerance in the buffer check longer
					//this prevents the audio stream controller getting stuck on unpaused after loading past an audio gap
					if (audioStreamController.tracks[audioStreamController.trackId].containsGaps) {
						audioGapTolerance = this._targetDuration * 1.1; //make it slightly longer than one target duration
					}
					//The 0.2 allows small gaps to be ingnored. Otherwise the audio buffer is left paused when it's behind. Possibly could be bigger.
					var mainBufferEnd = _bufferHelper2.default.bufferInfo(mainStreamController.videoBuffer, desiredPlayPoint, 0.2).end;
					var audioBufferEnd = _bufferHelper2.default.bufferInfo(audioStreamController.mediaBuffer, desiredPlayPoint, audioGapTolerance).end;
	
					if (audioStreamController.pausedTimer && audioBufferEnd - mainBufferEnd < this._targetDuration / 2) {
						audioStreamController.unpauseController();
						_logger.logger.log('onFragBuffered audio processing resumed');
					} else if (!audioStreamController.pausedTimer && audioBufferEnd - mainBufferEnd > this._targetDuration / 2 && _bufferHelper2.default.isBuffered(audioStreamController.mediaBuffer, this.media.currentTime + this._targetDuration * 2)) {
						audioStreamController.pauseController();
						_logger.logger.log('onFragBuffered audio processing paused');
					}
				}
			}
		}, {
			key: 'onError',
			value: function onError(data) {
				if (data.fatal) {
					//hlsJs is about to be halted, don't need the timeouts any more
					this.disarmMainStreamTimeout();
					this.disarmAudioStreamTimeout();
				}
			}
		}, {
			key: 'armMainStreamTimeout',
			value: function armMainStreamTimeout() {
				var _this2 = this;
	
				if (this._mainStreamTimeoutTimer === null) {
					this._mainStreamTimeoutTimer = setTimeout(function () {
						_this2._mainTimedOut = true;
						_logger.logger.log('main stream timeout timer expired');
					}, this.getTimeoutValue());
	
					_logger.logger.log('main stream timeout timer armed');
				}
			}
		}, {
			key: 'armAudioStreamTimeout',
			value: function armAudioStreamTimeout() {
				var _this3 = this;
	
				if (this._audioStreamTimeoutTimer === null) {
					this._audioStreamTimeoutTimer = setTimeout(function () {
						if (_this3._audioControllersActive && _this3.hls.audioStreamController.pausedTimer && !_this3._audioForcedUnpause) {
							_this3._audioForcedUnpause = true;
							_this3.hls.audioStreamController.unpauseController();
							_logger.logger.log('audio stream timeout force unpause');
	
							//Timer is not rearmed. Not sure how to re-arm it right now; the below should work but not sure if it's safe...
							//this._audioStreamTimeoutTimer = null;
							//this.armAudioStreamTimeout();
						} else {
							_this3._audioTimedOut = true;
							_logger.logger.log('audio stream timeout timer expired');
						}
					}, this.getTimeoutValue());
	
					_logger.logger.log('audio stream timeout timer armed');
				}
			}
		}, {
			key: 'disarmMainStreamTimeout',
			value: function disarmMainStreamTimeout() {
				if (this._mainStreamTimeoutTimer) {
					clearTimeout(this._mainStreamTimeoutTimer);
					this._mainStreamTimeoutTimer = null;
					_logger.logger.log('main stream timeout timer disarmed');
				}
				this._mainTimedOut = false;
			}
		}, {
			key: 'disarmAudioStreamTimeout',
			value: function disarmAudioStreamTimeout() {
				if (this._audioStreamTimeoutTimer) {
					clearTimeout(this._audioStreamTimeoutTimer);
					this._audioStreamTimeoutTimer = null;
					_logger.logger.log('audio stream timeout timer disarmed');
				}
				this._audioTimedOut = false;
				this._audioForcedUnpause = false;
			}
		}, {
			key: 'getTimeoutValue',
			value: function getTimeoutValue() {
				var timeout = this._defaultTimeout;
				var configTimeout = 0;
	
				if (this.config) {
					configTimeout = this.config.streamTimeOut;
				}
				timeout = Math.max(timeout, configTimeout);
	
				return timeout;
			}
		}, {
			key: 'checkParsingFinished',
			value: function checkParsingFinished() {
				this._controllersParsed++;
	
				if (this._controllersParsed === 3) {
					this._controllersParsed = 0;
					this._activeControllers = this._monitorMainControllers + this._monitorAudioControllers + this._monitorSubtitleControllers;
					_logger.logger.log('all manifest parsed events received, number of active controllers: ' + this._activeControllers);
					this.hls.trigger(_events2.default.STREAM_ALL_LEVELS_PARSED, { main: this._monitorMainControllers, audio: this._monitorAudioControllers,
						subtitle: this._monitorSubtitleControllers });
				}
			}
		}, {
			key: 'checkIfRenditionsExist',
			value: function checkIfRenditionsExist() {
				return this._monitorAudioControllers;
			}
		}, {
			key: 'checkIfRenditionsAreActive',
			value: function checkIfRenditionsAreActive() {
				return this._audioControllersActive;
			}
		}, {
			key: 'checkReady',
			value: function checkReady() {
				var expectedLoads = this._activeControllers;
	
				if (this._monitorAudioControllers && !this._audioControllersActive) {
					//If we're starting on in-mux, we won't get an AUDIO_TRACK_LOADED
					expectedLoads -= 1;
				}
	
				if (this._mainControllersReady + this._audioControllersReady + this._subtitleControllersReady === expectedLoads) {
					if (this._mainBasePdt && this._audioBasePdt) {
						var mainBasePdt = this._mainBasePdt.getTime();
						var audioBasePdt = this._audioBasePdt.getTime();
						var mainTd = this.hls.levels[this.hls.loadLevel].details.targetduration * 1000;
						var audioTd = this.hls.audioStreamController.tracks[this.hls.audioStreamController.trackId].details.targetduration * 1000;
						var variance = (mainTd + audioTd) / 4;
	
						//sometimes we can get a mismatch where the pdts are slightly different but in actual fact are really the same,
						//so we will only trigger this if we are out by factor of the average of 1/2 the target duration of both streams
						if (mainBasePdt < audioBasePdt - variance || mainBasePdt > audioBasePdt + variance) {
							var desync = mainBasePdt - audioBasePdt;
							_logger.logger.log('base pdt desync: ' + desync);
							//this.hls.trigger(Event.STREAM_DESYNC, { desync });
							this.hls.trigger(_events2.default.STREAM_DESYNC, { desync: desync, pdtToAlignTo: desync > 0 ? mainBasePdt : audioBasePdt, variance: variance });
						}
					}
					this._basePdt = this.determineCombinedBasePdt();
					//This event signals we're ready to do PDT based calculations
					//once we emit it, bam-hls will send the start PDT to hlsJs, if it has one
					this.hls.trigger(_events2.default.STREAM_BASEPDT_FOUND, { basePdt: this._basePdt });
	
					this.armMainStreamTimeout();
					if (this._audioControllersActive) {
						this.armAudioStreamTimeout();
					}
	
					this._allReady = true;
					var startTime = this.determineStartTime();
					_logger.logger.log('all expected level loaded events received, start time: ' + startTime + ', expected loads: ' + expectedLoads);
					this.hls.trigger(_events2.default.STREAM_ALL_LEVELS_LOADED, { startTime: startTime });
				}
			}
		}, {
			key: 'checkReadyForDispose',
			value: function checkReadyForDispose(videoTrackReady, audioTrackReady) {
				var toDispose = this._activeControllers;
				var haveDisposed = 0;
				var readyForDispose = false;
	
				_logger.logger.log('checkReadyForDispose Count ' + toDispose);
	
				if (this._monitorAudioControllers && !this._audioControllersActive) {
					_logger.logger.log('checkReadyForDispose Not using renditions');
					toDispose -= 1;
				}
	
				if (videoTrackReady !== undefined) {
					_logger.logger.log('checkReadyForDispose Video');
					this._vidReadyForDispose = videoTrackReady;
				}
				if (audioTrackReady !== undefined) {
					_logger.logger.log('checkReadyForDispose Audio');
					this._audReadyForDispose = audioTrackReady;
				}
	
				if (this._vidReadyForDispose) {
					haveDisposed += 1;
				}
				if (this._audReadyForDispose) {
					haveDisposed += 1;
				}
	
				if (toDispose === haveDisposed) {
					readyForDispose = true;
				}
	
				_logger.logger.log('checkReadyForDispose ' + readyForDispose);
	
				return readyForDispose;
			}
		}, {
			key: 'determineLiveTime',
			value: function determineLiveTime(details, sliding, type) {
				var liveSyncTime = void 0;
				//seconds mode
				if (this.config.liveSyncDuration !== undefined) {
					//get the target time
					var targetTime = details.totalduration + sliding - this.config.liveSyncDuration;
					//if start of frag 0 is later than target time, set live sync time to start of frag 0
					if (targetTime < details.fragments[0].start) {
						_logger.logger.warn('StreamCoordinator::determineLiveTime: current manifest for ' + type + ' shorter than liveSyncDuration, setting to start of manifest');
						liveSyncTime = details.fragments[0].start;
					} else {
						//look for the last frag in the manifest that starts before the target time
						for (var i = details.fragments.length - 1; i >= 0; i--) {
							if (details.fragments[i].start <= targetTime) {
								liveSyncTime = details.fragments[i].start;
								break;
							}
						}
					}
				}
				//frag count mode
				else if (this.config.liveSyncDurationCount !== undefined) {
						//check if there are enough frags in the manifest, if not, set live sync time to start of frag 0
						if (details.fragments.length < this.config.liveSyncDurationCount) {
							_logger.logger.warn('StreamCoordinator::determineLiveTime: current manifest for ' + type + ' has less frags than liveSyncDurationCount, setting to start of manifest');
							liveSyncTime = details.fragments[0].start;
						} else {
							liveSyncTime = details.fragments[details.fragments.length - this.config.liveSyncDurationCount].start;
						}
					}
					//neither live sync config setting has been defined - this should not be possible
					else {
							throw new Error('StreamCoordinator::determineLiveTime: No live sync offset found');
						}
	
				_logger.logger.log(type + ' live sync time: ' + liveSyncTime);
				return liveSyncTime;
			}
		}, {
			key: 'determineCombinedLiveTime',
			value: function determineCombinedLiveTime() {
				var liveTime = void 0;
				//if the audio controllers are currently inactive, the live time is the main live time
				if (!this._monitorAudioControllers || !this._audioControllersActive) {
					liveTime = this._mainLiveTime;
				}
				//combined live time is the earliest of the two live times
				//if this time is before one of the manifest starts, that manifest start becomes the live time
				else if (this._mainLiveTime && this._audioLiveTime) {
						liveTime = Math.min(this._mainLiveTime, this._audioLiveTime);
						liveTime = Math.max(liveTime, this._mainLevelStartTime, this._audioLevelStartTime);
					}
				//live time should only ever increase, if the new live time is greater than the old one, emit an event and update
				if (liveTime && (liveTime > this._combinedLiveTime || this._combinedLiveTime === undefined)) {
					var lastLiveTime = this._combinedLiveTime;
					this._combinedLiveTime = liveTime;
					_logger.logger.log('combined live sync time: ' + liveTime);
					this.hls.trigger(_events2.default.STREAM_LIVETIME_CHANGED, { liveTime: liveTime, lastLiveTime: lastLiveTime });
				}
			}
		}, {
			key: 'determineStartTime',
			value: function determineStartTime() {
				//LSSALT takes priority if it is true and stream is live
				//if we've got both main and audio active, check both are live, as if one isn't that likely means the other one is going to stop being live next load
				var liveStream = this._mainLive;
	
				if (liveStream && this._monitorAudioControllers && this._audioControllersActive) {
					liveStream = this._mainLive && this._audioLive;
				}
	
				if (liveStream && this._liveStreamsStartAtLiveTime) {
					_logger.logger.log('live stream with LSSALT enabled, setting live time as start time');
					return this._combinedLiveTime;
				}
				//if we have a start PDT, calculate the position for that PDT and make that the new start time
				//if it lands in a disco/gap, go ahead to the start of the next frag
				var startTime = void 0;
	
				if (this._startPdt) {
					startTime = this.getTimeForPdt(this._startPdt);
				}
	
				if (!startTime) {
					startTime = this._startTime;
				}
				//if we're at this point, we're not live
				//use startTime, after adjusting to make sure startTime is not outside allowable range
				if (!this._monitorAudioControllers || !this._audioControllersActive) {
					startTime = Math.max(startTime, this._mainLevelStartTime);
					startTime = Math.min(startTime, this._mainLevelEndTime);
				} else {
					startTime = Math.max(startTime, this._mainLevelStartTime, this._audioLevelStartTime);
					startTime = Math.min(startTime, this._mainLevelEndTime, this._audioLevelEndTime);
				}
	
				if (liveStream) {
					startTime = Math.min(startTime, this._combinedLiveTime);
				}
	
				return startTime;
			}
		}, {
			key: 'determineBasePdt',
			value: function determineBasePdt(details, type) {
				var fragments = details.fragments;
				var fragCount = fragments.length;
				for (var i = 0; i < fragCount; i++) {
					var frag = fragments[i];
					var rawPdt = frag.rawProgramDateTime;
					if (rawPdt) {
						var date = new Date(new Date(rawPdt).valueOf() - frag.start * 1000);
						_logger.logger.log(type + ' base PDT: ' + date);
						return date;
					}
				}
	
				_logger.logger.log('no base PDT for ' + type);
				return null;
			}
		}, {
			key: 'determineCombinedBasePdt',
			value: function determineCombinedBasePdt() {
				var basePdt = void 0;
				// Needed only to force unified pdt ASAP in recovery cases
				// If timing is changed this may not be needed in the future
				if (this._resumeBasePdt) {
					basePdt = this._resumeBasePdt;
				} else if (this._mainBasePdt && this._audioBasePdt) {
					if (this._mainBasePdt.getTime() >= this._audioBasePdt.getTime()) {
						basePdt = this._mainBasePdt;
					} else {
						basePdt = this._audioBasePdt;
					}
				} else if (this._mainBasePdt) {
					basePdt = this._mainBasePdt;
				} else {
					basePdt = null;
				}
	
				return basePdt;
			}
		}, {
			key: '_findFragList',
			value: function _findFragList() {
				var fragList = void 0;
	
				var hls = this.hls;
	
				var levels = hls.levels;
				var details = levels[hls.loadLevel].details;
				if (details) {
					fragList = details.fragments;
				} else {
					var levelsCount = levels.length;
					for (var i = 0; i < levelsCount; i++) {
						details = levels[i].details;
						if (details) {
							fragList = details.fragments;
							break;
						}
					}
				}
	
				return fragList;
			}
		}, {
			key: 'getTimeForPdt',
			value: function getTimeForPdt(pdt) {
				var baseTime = pdt.getTime();
				var fragList = this._findFragList();
	
				//look for a frag that has a pdt range that contains the frag we're looking for
				var fragCount = fragList.length;
				for (var i = 0; i < fragCount; i++) {
					var frag = fragList[i];
					var fragPdt = frag.pdt;
					var fragEndPdt = fragPdt + frag.duration * 1000;
	
					if (baseTime >= fragPdt && baseTime <= fragEndPdt) {
						//calculate difference between frag PDT and start PDT, then add that to frag start to get our start time
						return Number((frag.start + (baseTime - fragPdt) / 1000).toFixed(6));
					} else if (baseTime < fragEndPdt) {
						//if we're here, then the previous frag ends before the start PDT but this frag starts after the start PDT
						//when we have a gap, use the start of the frag after the start PDT
						return Number(frag.start.toFixed(6));
					}
					// this could be done as a post-check of the loop...
					else if (i === fragCount - 1) {
							return Number((frag.start + (baseTime - fragPdt) / 1000).toFixed(6));
						}
				}
	
				return null;
			}
		}, {
			key: 'getPdtForTime',
			value: function getPdtForTime(time) {
	
				var fragList = this._findFragList();
	
				if (time < fragList[0].start) {
					//before first frag
					var offset = fragList[0].start - time;
					return new Date(fragList[0].pdt - offset * 1000);
				}
	
				var gapTotal = 0;
				var nextGapTotal = 0;
	
				var fragCount = fragList.length;
				for (var i = 0; i < fragCount; i++) {
					if (i === fragCount - 1) {
						//last frag, just calculate from this start time
						var _offset = time - (fragList[i].start - gapTotal / 1000);
						return new Date(fragList[i].pdt + _offset * 1000);
					} else {
						var nextFrag = fragList[i + 1];
						if (nextFrag.gap > 0 && !this._audioControllersActive) {
							nextGapTotal += nextFrag.gap;
						}
	
						var thisFrag = fragList[i];
						if (thisFrag.start - gapTotal / 1000 < time && nextFrag.start - nextGapTotal / 1000 > time) {
							//time falls within this frag, use this one
							var _offset2 = time - (thisFrag.start - gapTotal / 1000);
							return new Date(thisFrag.pdt + _offset2 * 1000);
						}
						gapTotal = nextGapTotal;
					}
				}
	
				return null;
			}
		}, {
			key: 'startTime',
			set: function set(value) {
				this._startTime = value;
			}
		}, {
			key: 'liveStreamsStartAtLiveTime',
			set: function set(value) {
				this._liveStreamsStartAtLiveTime = !!value;
			}
		}, {
			key: 'startPdt',
			set: function set(value) {
				this._startPdt = value;
			}
		}, {
			key: 'basePdt',
			get: function get() {
				var basePdt = this._basePdt;
	
				if (this._resumeBasePdt) {
					basePdt = this._resumeBasePdt; //Need this ASAP to avoid timeline confusion
				}
				return basePdt;
			}
		}, {
			key: 'resumeBasePdt',
			get: function get() {
				return this._resumeBasePdt;
			},
			set: function set(value) {
	
				_logger.logger.log('StreamCoordinator: resumeBasePdt set to ' + value);
	
				this._resumeBasePdt = value;
			}
		}]);
	
		return StreamCoordinator;
	}(_eventHandler2.default);
	
	exports.default = StreamCoordinator;
	module.exports = exports['default'];

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _events = __webpack_require__(3);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _eventHandler = __webpack_require__(5);
	
	var _eventHandler2 = _interopRequireDefault(_eventHandler);
	
	var _logger = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Subtitle Stream Controller
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */
	
	var SubtitleStreamController = function (_EventHandler) {
		_inherits(SubtitleStreamController, _EventHandler);
	
		function SubtitleStreamController(hls) {
			_classCallCheck(this, SubtitleStreamController);
	
			var _this = _possibleConstructorReturn(this, (SubtitleStreamController.__proto__ || Object.getPrototypeOf(SubtitleStreamController)).call(this, hls, _events2.default.ERROR, _events2.default.SUBTITLE_TRACKS_UPDATED, _events2.default.SUBTITLE_TRACK_SWITCH, _events2.default.SUBTITLE_TRACK_LOADED, _events2.default.SUBTITLE_FRAG_PROCESSED));
	
			_this.config = hls.config;
			_this.vttFragSNsProcessed = {};
			_this.vttFragQueues = undefined;
			_this.currentlyProcessing = null;
			_this.currentTrackId = -1;
			return _this;
		}
	
		_createClass(SubtitleStreamController, [{
			key: 'destroy',
			value: function destroy() {
				_eventHandler2.default.prototype.destroy.call(this);
				//Mactrix additions start
				//memory clean up
				this.config = null;
				this.tracks = null;
				this.vttFragQueues = null;
				this.vttFragSNsProcessed = null;
				this.hls = null;
				//Mactrix additions end
			}
	
			// Remove all queued items and create a new, empty queue for each track.
	
		}, {
			key: 'clearVttFragQueues',
			value: function clearVttFragQueues() {
				var _this2 = this;
	
				this.vttFragQueues = {};
				this.tracks.forEach(function (track) {
					_this2.vttFragQueues[track.id] = [];
				});
			}
	
			// If no frag is being processed and queue isn't empty, initiate processing of next frag in line.
	
		}, {
			key: 'nextFrag',
			value: function nextFrag() {
				if (this.currentlyProcessing === null && this.currentTrackId > -1 && this.vttFragQueues[this.currentTrackId].length) {
					var frag = this.currentlyProcessing = this.vttFragQueues[this.currentTrackId].shift();
					this.hls.trigger(_events2.default.FRAG_LOADING, { frag: frag });
				}
			}
	
			// When fragment has finished processing, add sn to list of completed if successful.
	
		}, {
			key: 'onSubtitleFragProcessed',
			value: function onSubtitleFragProcessed(data) {
				if (data.success) {
					this.vttFragSNsProcessed[data.frag.trackId].push(data.frag.sn);
				}
				this.currentlyProcessing = null;
				this.nextFrag();
			}
	
			// If something goes wrong, procede to next frag, if we were processing one.
	
		}, {
			key: 'onError',
			value: function onError(data) {
				var frag = data.frag;
				// don't handle frag error not related to subtitle fragment
				if (frag && frag.type !== 'subtitle') {
					return;
				}
				if (this.currentlyProcessing) {
					this.currentlyProcessing = null;
					this.nextFrag();
				}
			}
	
			// Got all new subtitle tracks.
	
		}, {
			key: 'onSubtitleTracksUpdated',
			value: function onSubtitleTracksUpdated(data) {
				var _this3 = this;
	
				_logger.logger.log('subtitle tracks updated');
				this.tracks = data.subtitleTracks;
				this.clearVttFragQueues();
				this.vttFragSNsProcessed = {};
				this.tracks.forEach(function (track) {
					_this3.vttFragSNsProcessed[track.id] = [];
				});
			}
		}, {
			key: 'onSubtitleTrackSwitch',
			value: function onSubtitleTrackSwitch(data) {
				this.currentTrackId = data.id;
				this.clearVttFragQueues();
			}
	
			// Got a new set of subtitle fragments.
	
		}, {
			key: 'onSubtitleTrackLoaded',
			value: function onSubtitleTrackLoaded(data) {
				var processedFragSNs = this.vttFragSNsProcessed[data.id];
				var fragQueue = this.vttFragQueues[data.id];
				var currentFragSN = !!this.currentlyProcessing ? this.currentlyProcessing.sn : -1;
	
				var alreadyProcessed = function alreadyProcessed(frag) {
					return processedFragSNs.indexOf(frag.sn) > -1;
				};
	
				var alreadyInQueue = function alreadyInQueue(frag) {
					return fragQueue.some(function (fragInQueue) {
						return fragInQueue.sn === frag.sn;
					});
				};
	
				// Add all fragments that haven't been, aren't currently being and aren't waiting to be processed, to queue.
				data.details.fragments.forEach(function (frag) {
					if (!(alreadyProcessed(frag) || frag.sn === currentFragSN || alreadyInQueue(frag))) {
						// Frags don't know their subtitle track ID, so let's just add that...
						frag.trackId = data.id;
						fragQueue.push(frag);
					}
				});
	
				this.hls.trigger(_events2.default.SUBTITLE_TRACK_UPDATED, { details: data.details, track: data.id }); //Mactrix line added, log end of track parse
	
				this.nextFrag();
			}
		}]);
	
		return SubtitleStreamController;
	}(_eventHandler2.default);
	
	exports.default = SubtitleStreamController;
	module.exports = exports['default'];

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _events = __webpack_require__(3);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _eventHandler = __webpack_require__(5);
	
	var _eventHandler2 = _interopRequireDefault(_eventHandler);
	
	var _logger = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * audio track controller
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */
	
	var SubtitleTrackController = function (_EventHandler) {
		_inherits(SubtitleTrackController, _EventHandler);
	
		function SubtitleTrackController(hls) {
			_classCallCheck(this, SubtitleTrackController);
	
			var _this = _possibleConstructorReturn(this, (SubtitleTrackController.__proto__ || Object.getPrototypeOf(SubtitleTrackController)).call(this, hls, _events2.default.MEDIA_ATTACHED, _events2.default.MEDIA_DETACHING, _events2.default.MANIFEST_LOADING, _events2.default.MANIFEST_LOADED, _events2.default.SUBTITLE_TRACK_LOADED));
	
			_this.tracks = [];
			_this.trackId = -1;
			_this.media = undefined;
			return _this;
		}
	
		_createClass(SubtitleTrackController, [{
			key: 'destroy',
			value: function destroy() {
				_eventHandler2.default.prototype.destroy.call(this);
				//Mactrix additions start
				//memory clean up
				this.tracks = null;
				this.hls = null;
				//Mactrix additions end
			}
	
			// Listen for subtitle track change, then extract the current track ID.
	
		}, {
			key: 'onMediaAttached',
			value: function onMediaAttached(data) {
				var _this2 = this;
	
				this.media = data.media;
				if (!this.media) {
					return;
				}
	
				this.media.textTracks.addEventListener('change', function () {
					// Media is undefined when switching streams via loadSource()
					if (!_this2.media) {
						return;
					}
	
					var trackId = -1;
					var tracks = _this2.media.textTracks;
					for (var id = 0; id < tracks.length; id++) {
						if (tracks[id].mode === 'showing') {
							trackId = id;
						}
					}
					// Setting current subtitleTrack will invoke code.
					_this2.subtitleTrack = trackId;
				});
			}
		}, {
			key: 'onMediaDetaching',
			value: function onMediaDetaching() {
				// TODO: Remove event listeners.
				this.media = undefined;
			}
	
			// Reset subtitle tracks on manifest loading
	
		}, {
			key: 'onManifestLoading',
			value: function onManifestLoading() {
				this.tracks = [];
				this.trackId = -1;
			}
	
			// Fired whenever a new manifest is loaded.
	
		}, {
			key: 'onManifestLoaded',
			value: function onManifestLoaded(data) {
				var _this3 = this;
	
				var tracks = data.subtitles || [];
				//	let defaultFound = false;
				this.tracks = tracks;
				this.trackId = -1;
				this.hls.trigger(_events2.default.SUBTITLE_TRACKS_UPDATED, { subtitleTracks: tracks });
	
				// loop through available subtitle tracks and autoselect default if needed
				// TODO: improve selection logic to handle forced, etc
				tracks.forEach(function (track) {
					if (track.default) {
						_this3.subtitleTrack = track.id;
						//		defaultFound = true;
					}
				});
			}
	
			// Trigger subtitle track playlist reload.
	
		}, {
			key: 'onTick',
			value: function onTick() {
				if (!this.tracks) {
					return;
				}
				var trackId = this.trackId;
				var subtitleTrack = this.tracks[trackId];
				if (!subtitleTrack) {
					return;
				}
	
				var details = subtitleTrack.details;
				// check if we need to load playlist for this subtitle Track
				if (details === undefined || details.live === true) {
					// track not retrieved yet, or live playlist we need to (re)load it
					_logger.logger.log('(re)loading playlist for subtitle track ' + trackId);
					this.hls.trigger(_events2.default.SUBTITLE_TRACK_LOADING, { url: subtitleTrack.url, id: trackId });
				}
			}
		}, {
			key: 'onSubtitleTrackLoaded',
			value: function onSubtitleTrackLoaded(data) {
				var _this4 = this;
	
				if (data.id < this.tracks.length) {
					_logger.logger.log('subtitle track ' + data.id + ' loaded');
					this.tracks[data.id].details = data.details;
					// check if current playlist is a live playlist
					if (data.details.live && !this.timer) {
						// if live playlist we will have to reload it periodically
						// set reload period to playlist target duration
						this.timer = setInterval(function () {
							_this4.onTick();
						}, 1000 * data.details.targetduration, this);
					}
					if (!data.details.live && this.timer) {
						// playlist is not live and timer is armed : stopping it
						clearInterval(this.timer);
						this.timer = null;
					}
				}
			}
	
			/** get alternate subtitle tracks list from playlist **/
	
		}, {
			key: 'setSubtitleTrackInternal',
			value: function setSubtitleTrackInternal(newId) {
				// check if level idx is valid
				if (newId >= 0 && newId < this.tracks.length) {
					// stopping live reloading timer if any
					if (this.timer) {
						clearInterval(this.timer);
						this.timer = null;
					}
					this.trackId = newId;
					_logger.logger.log('switching to subtitle track ' + newId);
					var subtitleTrack = this.tracks[newId];
					this.hls.trigger(_events2.default.SUBTITLE_TRACK_SWITCH, { id: newId });
					// check if we need to load playlist for this subtitle Track
					var details = subtitleTrack.details;
					if (details === undefined || details.live === true) {
						// track not retrieved yet, or live playlist we need to (re)load it
						_logger.logger.log('(re)loading playlist for subtitle track ' + newId);
						this.hls.trigger(_events2.default.SUBTITLE_TRACK_LOADING, { url: subtitleTrack.url, id: newId });
					}
				}
			}
		}, {
			key: 'subtitleTracks',
			get: function get() {
				return this.tracks;
			}
	
			/** get index of the selected subtitle track (index in subtitle track lists) **/
	
		}, {
			key: 'subtitleTrack',
			get: function get() {
				return this.trackId;
			}
	
			/** select a subtitle track, based on its index in subtitle track lists**/
			,
			set: function set(subtitleTrackId) {
				if (this.trackId !== subtitleTrackId) {
					// || this.tracks[subtitleTrackId].details === undefined) {
					this.setSubtitleTrackInternal(subtitleTrackId);
				}
			}
		}]);
	
		return SubtitleTrackController;
	}(_eventHandler2.default);
	
	exports.default = SubtitleTrackController;
	module.exports = exports['default'];

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _events = __webpack_require__(3);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _eventHandler = __webpack_require__(5);
	
	var _eventHandler2 = _interopRequireDefault(_eventHandler);
	
	var _cea608Parser = __webpack_require__(136);
	
	var _cea608Parser2 = _interopRequireDefault(_cea608Parser);
	
	var _webvttParser = __webpack_require__(141);
	
	var _webvttParser2 = _interopRequireDefault(_webvttParser);
	
	var _logger = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Timeline Controller
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */
	
	function clearCurrentCues(track) {
		if (track && track.cues) {
			while (track.cues.length > 0) {
				track.removeCue(track.cues[0]);
			}
		}
	}
	
	function reuseVttTextTrack(inUseTrack, manifestTrack) {
		return inUseTrack && inUseTrack.label === manifestTrack.name && !(inUseTrack.textTrack1 || inUseTrack.textTrack2);
	}
	
	function intersection(x1, x2, y1, y2) {
		return Math.min(x2, y2) - Math.max(x1, y1);
	}
	
	var TimelineController = function (_EventHandler) {
		_inherits(TimelineController, _EventHandler);
	
		function TimelineController(hls) {
			_classCallCheck(this, TimelineController);
	
			var _this = _possibleConstructorReturn(this, (TimelineController.__proto__ || Object.getPrototypeOf(TimelineController)).call(this, hls, _events2.default.MEDIA_ATTACHING, _events2.default.MEDIA_ATTACHED, //Mactrix line added, temp fix for caption loss on backwards seek
			_events2.default.MEDIA_DETACHING, _events2.default.FRAG_PARSING_USERDATA, _events2.default.MANIFEST_LOADING, _events2.default.MANIFEST_LOADED, _events2.default.FRAG_LOADED, _events2.default.LEVEL_SWITCHING, _events2.default.TEXT_TRACK_CHANGED, // mactrix addition: add TEXT_TRACK_CHANGED
			_events2.default.INIT_PTS_FOUND));
	
			_this.hls = hls;
			_this.config = hls.config;
			_this.enabled = true;
			_this.Cues = hls.config.cueHandler;
			_this.textTracks = [];
			_this.tracks = [];
			_this.unparsedVttFrags = [];
			_this.initPTS = undefined;
			_this.cueRanges = [];
			_this.preFlushed = false;
	
			_this.captionsOnSeekWorkaround = _this.hls.browIE || _this.hls.browEdge; //Mactrix line added, temp fix for caption loss on backwards seek
	
			if (_this.config.enableCEA708Captions) {
				var self = _this;
				var sendAddTrackEvent = function sendAddTrackEvent(track, media) {
					var e = null;
					try {
						e = new window.Event('addtrack');
					} catch (err) {
						//for IE11
						e = document.createEvent('Event');
						e.initEvent('addtrack', false, false);
					}
					e.track = track;
					media.dispatchEvent(e);
				};
	
				var channel1 = {
					newCue: function newCue(startTime, endTime, screen) {
						if (!self.textTrack1) {
							//Enable reuse of existing text track.
							var existingTrack1 = self.getExistingTrack('1');
							if (!existingTrack1) {
								var textTrack1 = self.createTextTrack('captions', self.config.captionsTextTrack1Label, self.config.captionsTextTrack1LanguageCode);
								if (textTrack1) {
									textTrack1.textTrack1 = true;
									self.textTrack1 = textTrack1;
								}
							} else {
								self.textTrack1 = existingTrack1;
								clearCurrentCues(self.textTrack1);
	
								sendAddTrackEvent(self.textTrack1, self.media);
							}
	
							//mactrix insertion: Needed to track text track additions
							//we can't put this event in sendAddTrackEvent as that only runs if reusing an existing track
							self.hls.trigger(_events2.default.TEXT_TRACK_ADDED, { track: self.textTrack1 });
							// end mactrix change
						}
						self.addCues('textTrack1', startTime, endTime, screen);
					}
				};
	
				var channel2 = {
					newCue: function newCue(startTime, endTime, screen) {
						if (!self.textTrack2) {
							//Enable reuse of existing text track.
							var existingTrack2 = self.getExistingTrack('2');
							if (!existingTrack2) {
								var textTrack2 = self.createTextTrack('captions', self.config.captionsTextTrack2Label, self.config.captionsTextTrack1LanguageCode);
								if (textTrack2) {
									textTrack2.textTrack2 = true;
									self.textTrack2 = textTrack2;
								}
							} else {
								self.textTrack2 = existingTrack2;
								clearCurrentCues(self.textTrack2);
	
								sendAddTrackEvent(self.textTrack2, self.media);
							}
	
							//mactrix insertion: Needed to track text track additions
							self.hls.trigger(_events2.default.TEXT_TRACK_ADDED, { track: self.textTrack2 });
						}
						self.addCues('textTrack2', startTime, endTime, screen);
					}
				};
	
				_this.cea608Parser = new _cea608Parser2.default(0, channel1, channel2);
			}
			return _this;
		}
	
		_createClass(TimelineController, [{
			key: 'addCues',
			value: function addCues(channel, startTime, endTime, screen) {
				//Mactrix additions start
				//at certain parts of the frag load/parse process, seeking will cause the player to decide to just finish parsing the currently loading frag anyway
				//if we're seeking backwards, this adds future caption cues, causing errors in IE/Edge when we try to add current cues
				//as such, we need to do a check and, if needed, clear before adding cues
				//the buffer flush done as part of the backwards seek can't be done here, as the timing would cause an infinte frag loading loop
				if (this.captionsOnSeekWorkaround && this.media.textTracks.length) {
					if (this.media.textTracks[0].cues.length) {
						if (this.media.textTracks[0].cues[this.media.textTracks[0].cues.length - 1].endTime > startTime) {
							this.clearAllCues();
						}
					}
				}
				//Mactrix additions end
				// skip cues which overlap more than 50% with previously parsed time ranges
				var ranges = this.cueRanges;
				var merged = false;
				for (var i = ranges.length; i--;) {
					var cueRange = ranges[i];
					var overlap = intersection(cueRange[0], cueRange[1], startTime, endTime);
					if (overlap >= 0) {
						cueRange[0] = Math.min(cueRange[0], startTime);
						cueRange[1] = Math.max(cueRange[1], endTime);
						merged = true;
						if (overlap / (endTime - startTime) > 0.5) {
							return;
						}
					}
				}
				if (!merged) {
					ranges.push([startTime, endTime]);
				}
				this.Cues.newCue(this[channel], startTime, endTime, screen);
			}
	
			// Triggered when an initial PTS is found; used for synchronisation of WebVTT.
	
		}, {
			key: 'onInitPtsFound',
			value: function onInitPtsFound(data) {
				var _this2 = this;
	
				if (typeof this.initPTS === 'undefined') {
					this.initPTS = data.initPTS;
				}
	
				// Due to asynchrony, initial PTS may arrive later than the first VTT fragments are loaded.
				// Parse any unparsed fragments upon receiving the initial PTS.
				if (this.unparsedVttFrags.length) {
					this.unparsedVttFrags.forEach(function (frag) {
						_this2.onFragLoaded(frag);
					});
					this.unparsedVttFrags = [];
				}
			}
	
			//Mactix addition start
			//clears cues in both text tracks
			//we did this in several places so making a separate func for it
	
		}, {
			key: 'clearAllCues',
			value: function clearAllCues() {
				clearCurrentCues(this.textTrack1);
				clearCurrentCues(this.textTrack2);
				this.cueRanges = [];
			}
			//Mactrix addition end
	
		}, {
			key: 'getExistingTrack',
			value: function getExistingTrack(channelNumber) {
				var media = this.media;
				if (media) {
					for (var i = 0; i < media.textTracks.length; i++) {
						var textTrack = media.textTracks[i];
						var propName = 'textTrack' + channelNumber;
						if (textTrack[propName] === true) {
							return textTrack;
						}
					}
				}
				return null;
			}
		}, {
			key: 'createTextTrack',
			value: function createTextTrack(kind, label, lang) {
				var media = this.media;
				if (media) {
					return media.addTextTrack(kind, label, lang);
				}
				return null; //Mactrix line added
			}
		}, {
			key: 'destroy',
			value: function destroy() {
				this.clearAllCues(); //Mactrix line added, clear text tracks
				_eventHandler2.default.prototype.destroy.call(this);
				//Mactrix additions start
				//memory clean up
				this.Cues = null;
				this.cea608Parser = null;
				this.config = null;
				this.cueRanges = null;
				this.onvseeking = null;
				if (this.textTrack1) {
					this.textTrack1 = null;
				}
				if (this.textTrack2) {
					this.textTrack2 = null;
				}
				this.textTracks = null;
				this.tracks = null;
				this.unparsedVttFrags = null;
				this.vttCCs = null;
				this.hls = null;
				//Mactrix additions end
			}
		}, {
			key: 'onMediaAttaching',
			value: function onMediaAttaching(data) {
				this.media = data.media;
			}
	
			/*
	  onMediaDetaching() {
	  clearCurrentCues(this.textTrack1);
	  clearCurrentCues(this.textTrack2);
	  }
	  */
	
			//Mactrix changes and additions start
			//Temporary fix for loss of captions when seeking backwards on IE/Edge
			//Clearing out the caption cues stops the error that was causing us to lose captions completely
			//It's not a perfect solution however, as sometimes active subtitle cues get stuck on screen for a while when we do this
	
		}, {
			key: 'onMediaAttached',
			value: function onMediaAttached() {
				this.onvseeking = this.onMediaSeeking.bind(this);
				if (this.captionsOnSeekWorkaround) {
					this.media.addEventListener('seeking', this.onvseeking);
				}
	
				if (this.hls.browTizen2 && !this.textTrack1) {
					var textTrack1 = this.createTextTrack('captions', this.config.captionsTextTrack1Label, this.config.captionsTextTrack1LanguageCode);
					if (textTrack1) {
						textTrack1.textTrack1 = true;
						this.textTrack1 = textTrack1;
	
						this.hls.trigger(_events2.default.TEXT_TRACK_ADDED, { track: this.textTrack1 });
					}
				}
			}
		}, {
			key: 'onMediaDetaching',
			value: function onMediaDetaching() {
				if (this.media && this.captionsOnSeekWorkaround) {
					this.media.removeEventListener('seeking', this.onvseeking);
				}
				clearCurrentCues(this.textTrack1);
				clearCurrentCues(this.textTrack2);
			}
		}, {
			key: 'onMediaSeeking',
			value: function onMediaSeeking() {
				var media = this.media;
				var levelController = this.hls.levelController;
				var preFlushed = this.preFlushed;
				this.preFlushed = false;
	
				if (media) {
					if (media.textTracks.length) {
						if (media.textTracks[0].cues.length) {
							if (media.textTracks[0].cues[media.textTracks[0].cues.length - 1].endTime > media.currentTime && levelController.chunkIDAtTime(media.textTracks[0].cues[media.textTracks[0].cues.length - 1].endTime) !== levelController.chunkIDAtTime(media.currentTime)) {
								//we don't need to flush if the two compared times are in the same frag
								if (!preFlushed) {
									this.hls.trigger(_events2.default.BUFFER_FLUSHING, { startOffset: 0, endOffset: Number.POSITIVE_INFINITY }); //add negative buffer?
								}
								this.clearAllCues();
							}
						}
					}
				}
			}
			//Mactrix changes and additions end
	
		}, {
			key: 'onManifestLoading',
			value: function onManifestLoading() {
				this.lastSn = -1; // Detect discontiguity in fragment parsing
				this.prevCC = -1;
				this.vttCCs = { ccOffset: 0, presentationOffset: 0 }; // Detect discontinuity in subtitle manifests
	
				// clear outdated subtitles
				var media = this.media;
				if (media) {
					var textTracks = media.textTracks;
					if (textTracks) {
						for (var i = 0; i < textTracks.length; i++) {
							clearCurrentCues(textTracks[i]);
						}
					}
				}
			}
		}, {
			key: 'onManifestLoaded',
			value: function onManifestLoaded(data) {
				var _this3 = this;
	
				this.textTracks = [];
				this.unparsedVttFrags = this.unparsedVttFrags || [];
				this.initPTS = undefined;
				this.cueRanges = [];
	
				if (this.config.enableWebVTT) {
					this.tracks = data.subtitles || [];
					var inUseTracks = this.media ? this.media.textTracks : [];
	
					this.tracks.forEach(function (track, index) {
						var textTrack = void 0;
						var inUseTrack = inUseTracks[index];
						// Reuse tracks with the same label, but do not reuse 608/708 tracks
						if (reuseVttTextTrack(inUseTrack, track)) {
							textTrack = inUseTrack;
						} else {
							textTrack = _this3.createTextTrack('subtitles', track.name, track.lang);
						}
						if (textTrack) {
							//Mactrix line added
							textTrack.mode = track.default ? 'showing' : 'hidden';
							_this3.textTracks.push(textTrack);
						} //Mactrix line added
					});
				}
			}
		}, {
			key: 'onLevelSwitching',
			value: function onLevelSwitching() {
				this.enabled = this.hls.currentLevel.closedCaptions !== 'NONE';
			}
		}, {
			key: 'onFragLoaded',
			value: function onFragLoaded(data) {
				var frag = data.frag;
				var payload = data.payload;
	
				if (frag.type === 'main') {
					var sn = frag.sn;
					// if this frag isn't contiguous, clear the parser so cues with bad start/end times aren't added to the textTrack
					if (sn !== this.lastSn + 1) {
						this.cea608Parser.reset();
					}
					this.lastSn = sn;
				}
				// If fragment is subtitle type, parse as WebVTT.
				else if (frag.type === 'subtitle') {
						if (payload.byteLength) {
							// We need an initial synchronisation PTS. Store fragments as long as none has arrived.
							if (typeof this.initPTS === 'undefined') {
								this.unparsedVttFrags.push(data);
								return;
							}
							var vttCCs = this.vttCCs;
							if (!vttCCs[frag.cc]) {
								vttCCs[frag.cc] = { start: frag.start, prevCC: this.prevCC, new: true };
								this.prevCC = frag.cc;
							}
							var textTracks = this.textTracks;
							var hls = this.hls;
	
							// Parse the WebVTT file contents.
							_webvttParser2.default.parse(payload, this.initPTS, vttCCs, frag.cc, function (cues) {
								// Add cues and trigger event with success true.
								cues.forEach(function (cue) {
									textTracks[frag.trackId].addCue(cue);
								});
								hls.trigger(_events2.default.SUBTITLE_FRAG_PROCESSED, { success: true, frag: frag });
							}, function (e) {
								// Something went wrong while parsing. Trigger event with success false.
								_logger.logger.log('Failed to parse VTT cue: ' + e);
								hls.trigger(_events2.default.SUBTITLE_FRAG_PROCESSED, { success: false, frag: frag });
							});
						} else {
							// In case there is no payload, finish unsuccessfully.
							this.hls.trigger(_events2.default.SUBTITLE_FRAG_PROCESSED, { success: false, frag: frag });
						}
					}
			}
	
			//Mactrix addition start
	
		}, {
			key: 'onTextTrackChanged',
			value: function onTextTrackChanged() /*data*/{
				this.clearAllCues();
			}
			//Mactrix addition end
	
		}, {
			key: 'onFragParsingUserdata',
			value: function onFragParsingUserdata(data) {
				// push all of the CEA-708 messages into the interpreter
				// immediately. It will create the proper timestamps based on our PTS value
				if (this.enabled && this.config.enableCEA708Captions) {
					for (var i = 0; i < data.samples.length; i++) {
						var ccdatas = this.extractCea608Data(data.samples[i].bytes);
						this.cea608Parser.addData(data.samples[i].pts, ccdatas);
					}
				}
			}
		}, {
			key: 'extractCea608Data',
			value: function extractCea608Data(byteArray) {
				var count = byteArray[0] & 31;
				var position = 2;
	
				var tmpByte = void 0;
				var ccbyte1 = void 0;
				var ccbyte2 = void 0;
				var ccValid = void 0;
				var ccType = void 0;
				var actualCCBytes = [];
	
				for (var j = 0; j < count; j++) {
					tmpByte = byteArray[position++];
					ccbyte1 = 0x7F & byteArray[position++];
					ccbyte2 = 0x7F & byteArray[position++];
					ccValid = (4 & tmpByte) !== 0;
					ccType = 3 & tmpByte;
	
					if (ccbyte1 === 0 && ccbyte2 === 0) {
						continue;
					}
	
					if (ccValid) {
						if (ccType === 0) /*|| ccType === 1*/{
								actualCCBytes.push(ccbyte1);
								actualCCBytes.push(ccbyte2);
							}
					}
				}
				return actualCCBytes;
			}
		}]);
	
		return TimelineController;
	}(_eventHandler2.default);
	
	exports.default = TimelineController;
	module.exports = exports['default'];

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * HLS interface
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); //Mactrix line added, add stream coordinator
	
	//Mactrix additions start
	
	
	var _events = __webpack_require__(3);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _errors = __webpack_require__(4);
	
	var _playlistLoader = __webpack_require__(133);
	
	var _playlistLoader2 = _interopRequireDefault(_playlistLoader);
	
	var _fragmentLoader = __webpack_require__(132);
	
	var _fragmentLoader2 = _interopRequireDefault(_fragmentLoader);
	
	var _keyLoader = __webpack_require__(71);
	
	var _keyLoader2 = _interopRequireDefault(_keyLoader);
	
	var _streamController = __webpack_require__(126);
	
	var _streamController2 = _interopRequireDefault(_streamController);
	
	var _levelController = __webpack_require__(125);
	
	var _levelController2 = _interopRequireDefault(_levelController);
	
	var _streamCoordinator = __webpack_require__(127);
	
	var _streamCoordinator2 = _interopRequireDefault(_streamCoordinator);
	
	var _LicenseManager = __webpack_require__(116);
	
	var _LicenseManager2 = _interopRequireDefault(_LicenseManager);
	
	var _logger = __webpack_require__(1);
	
	var _events3 = __webpack_require__(60);
	
	var _events4 = _interopRequireDefault(_events3);
	
	var _config = __webpack_require__(118);
	
	var _HlsUtils = __webpack_require__(6);
	
	var _HlsUtils2 = _interopRequireDefault(_HlsUtils);
	
	var _bufferHelper = __webpack_require__(22);
	
	var _bufferHelper2 = _interopRequireDefault(_bufferHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	//Mactrix additions end
	
	var Hls = function () {
		_createClass(Hls, null, [{
			key: 'isSupported',
			value: function isSupported() {
				window.MediaSource = window.MediaSource || window.WebKitMediaSource;
				return window.MediaSource && typeof window.MediaSource.isTypeSupported === 'function' && window.MediaSource.isTypeSupported('video/mp4; codecs="avc1.42E01E,mp4a.40.2"');
			}
		}, {
			key: 'version',
			get: function get() {
				// replaced with browserify-versionify transform
				return '__VERSION__';
			}
		}, {
			key: 'Events',
			get: function get() {
				return _events2.default;
			}
		}, {
			key: 'ErrorTypes',
			get: function get() {
				return _errors.ErrorTypes;
			}
		}, {
			key: 'ErrorDetails',
			get: function get() {
				return _errors.ErrorDetails;
			}
		}, {
			key: 'DefaultConfig',
			get: function get() {
				if (!Hls.defaultConfig) {
					return _config.hlsDefaultConfig;
				}
				return Hls.defaultConfig;
			},
			set: function set(defaultConfig) {
				Hls.defaultConfig = defaultConfig;
			}
		}]);
	
		function Hls() {
			var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
			_classCallCheck(this, Hls);
	
			var defaultConfig = Hls.DefaultConfig;
	
			if ((config.liveSyncDurationCount || config.liveMaxLatencyDurationCount) && (config.liveSyncDuration || config.liveMaxLatencyDuration)) {
				throw new Error('Illegal hls.js config: don\'t mix up liveSyncDurationCount/liveMaxLatencyDurationCount and liveSyncDuration/liveMaxLatencyDuration');
			}
	
			for (var prop in defaultConfig) {
				if (prop in config) {
					continue;
				}
				config[prop] = defaultConfig[prop];
			}
	
			if (config.liveMaxLatencyDurationCount !== undefined && config.liveMaxLatencyDurationCount <= config.liveSyncDurationCount) {
				throw new Error('Illegal hls.js config: "liveMaxLatencyDurationCount" must be gt "liveSyncDurationCount"');
			}
	
			if (config.liveMaxLatencyDuration !== undefined && (config.liveMaxLatencyDuration <= config.liveSyncDuration || config.liveSyncDuration === undefined)) {
				throw new Error('Illegal hls.js config: "liveMaxLatencyDuration" must be gt "liveSyncDuration"');
			}
	
			(0, _logger.enableLogs)(config.debug);
			this.config = config;
			this._autoLevelCapping = -1;
			this._minAutoBitrate = this.config.minAutoBitrate; //Mactrix line added, exposing variable so we can change it
			// observer setup
			var observer = this.observer = new _events4.default();
			observer.trigger = function trigger(event) {
				for (var _len = arguments.length, data = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
					data[_key - 1] = arguments[_key];
				}
	
				observer.emit.apply(observer, [event, event].concat(data));
			};
	
			observer.off = function off(event) {
				for (var _len2 = arguments.length, data = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
					data[_key2 - 1] = arguments[_key2];
				}
	
				observer.removeListener.apply(observer, [event].concat(data));
			};
			this.on = observer.on.bind(observer);
			this.off = observer.off.bind(observer);
			this.trigger = observer.trigger.bind(observer);
	
			this.browChrome = _HlsUtils2.default.isChromium();
			this.browEdge = _HlsUtils2.default.isEdge();
			this.browIE = _HlsUtils2.default.isIE();
			this.browIE81 = _HlsUtils2.default.isIEWin8Point1();
			this.browFirefox = _HlsUtils2.default.isFirefox();
			this.browSafari = _HlsUtils2.default.isSafari();
			this.browTizen2 = _HlsUtils2.default.isTizen2();
			this.browTizen3 = _HlsUtils2.default.isTizen3();
	
			this._useSlowDetach = false;
			this._inSlowDetach = false;
			if (this.browSafari) {
				this._useSlowDetach = true;
			}
			this._preBufferSeeks = false;
			if (this.browIE81) {
				this._preBufferSeeks = true;
			}
	
			// core controllers and network loaders
			var abrController = this.abrController = new config.abrController(this);
			var bufferController = this.bufferController = new config.bufferController(this);
			var capLevelController = new config.capLevelController(this);
			var fpsController = new config.fpsController(this);
			var playListLoader = new _playlistLoader2.default(this);
			var fragmentLoader = new _fragmentLoader2.default(this);
			var keyLoader = this.keyLoader = new _keyLoader2.default(this);
	
			// network controllers
			var levelController = this.levelController = new _levelController2.default(this);
			var streamController = this.streamController = new _streamController2.default(this);
			var networkControllers = [levelController, streamController];
	
			var streamCoordinator = this.streamCoordinator = new _streamCoordinator2.default(this);
	
			if (config.obtainKeySystemConfigCallback) {
				var licenseManager = this.licenseManager = new _LicenseManager2.default(this, config.obtainKeySystemConfigCallback);
			}
	
			// optional audio stream controller
			var Controller = config.audioStreamController;
			if (Controller) {
				this.audioStreamController = new Controller(this);
				networkControllers.push(this.audioStreamController);
			}
			this.networkControllers = networkControllers;
	
			var coreComponents = [playListLoader, fragmentLoader, /* keyLoader,*/abrController, bufferController, capLevelController, fpsController];
	
			// optional controllers
			Controller = config.audioTrackController;
			if (Controller) {
				var audioTrackController = new Controller(this);
				this.audioTrackController = audioTrackController;
				coreComponents.push(audioTrackController);
			}
			Controller = config.subtitleTrackController;
			if (Controller) {
				var subtitleTrackController = new Controller(this);
				this.subtitleTrackController = subtitleTrackController;
				coreComponents.push(subtitleTrackController);
			}
			Controller = config.subtitleStreamController;
			if (Controller) {
				var subtitleStreamController = new Controller(this);
				coreComponents.push(subtitleStreamController);
			}
			Controller = config.timelineController;
			if (Controller) {
				var timelineController = new Controller(this);
				this.timelineController = timelineController;
				coreComponents.push(timelineController);
			}
	
			this.coreComponents = coreComponents;
		}
	
		_createClass(Hls, [{
			key: 'destroy',
			value: function destroy() {
				_logger.logger.log('hlsjs destroy');
				this.trigger(_events2.default.DESTROYING);
				this.detachMedia();
				this.coreComponents.push(this.keyLoader); // mactrix adddition: add keyLoader for destruction
				this.coreComponents.concat(this.networkControllers).forEach(function (component) {
					component.destroy();
				});
				this.streamCoordinator.dispose(); //Mactrix line added, destroy stream coordinator
				this.url = null;
				this.observer.removeAllListeners();
				this._autoLevelCapping = -1;
			}
		}, {
			key: 'attachMedia',
			value: function attachMedia(media) {
				_logger.logger.log('hlsjs attachMedia');
				this.media = media instanceof HTMLMediaElement ? media : null;
	
				// if we have a valid Media Element call attaching, otherwise we're detached.
				this.trigger(this.media ? _events2.default.MEDIA_ATTACHING : _events2.default.MEDIA_DETACHED, { media: this.media });
			}
		}, {
			key: 'detachMedia',
			value: function detachMedia() {
				_logger.logger.log('hlsjs detachMedia');
				// Mactrix addition start
				if (!this._useSlowDetach || !this.media || this.media.buffered.length === 0 || this.media.buffered.end(this.media.buffered.length - 1) + 1.0 < this.media.currentTime) {
					// Mactrix addition end
					this.trigger(_events2.default.MEDIA_DETACHING);
					this.media = null;
					// Mactrix addition start
				} else if (!this._inSlowDetach) {
					_logger.logger.log('slow detach start');
					this._inSlowDetach = true;
					this.stopFetch();
					this.stopLoad();
					this.media.currentTime = this.media.buffered.end(this.media.buffered.length - 1) - 0.5;
				}
				// Mactrix addition end
			}
		}, {
			key: 'loadSource',
			value: function loadSource(url) {
				//logger.log(`loadSource:${url}`);
				this.url = url;
				// when attaching to a source URL, trigger a playlist load
				this.trigger(_events2.default.MANIFEST_LOADING, { url: url });
			}
	
			/* mactrix replace
	  startLoad(startPosition=-1) {
	  	logger.log(`startLoad(${startPosition})`);
	  	this.networkControllers.forEach(controller => {controller.startLoad(startPosition);});
	  }
	  */
			// mactrix additions begin
			// we need to pass in liveStreamsStartAtLiveTime into lower levels to enable our enhanced liveStream startPosition functionality.
	
		}, {
			key: 'startLoad',
			value: function startLoad() {
				var startPosition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
				var liveStreamsStartAtLiveTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
				_logger.logger.log('startLoad(' + startPosition + ', LSSALT: ' + liveStreamsStartAtLiveTime + ')');
				//pass start time information to stream coordinator
				this.streamCoordinator.startTime = startPosition;
				this.streamCoordinator.liveStreamsStartAtLiveTime = liveStreamsStartAtLiveTime;
				this.networkControllers.forEach(function (controller) {
					controller.startLoad();
				});
			}
			// mactrix additions end
	
		}, {
			key: 'stopLoad',
			value: function stopLoad() {
				_logger.logger.log('stopLoad');
				this.networkControllers.forEach(function (controller) {
					controller.stopLoad();
				});
				//Mactrix additions start
				//stop audio track reloading on stopLoad
				if (this.audioTrackController) {
					this.audioTrackController.stopLoad();
				}
				//Mactrix additions end
			}
	
			//Mactrix additions begin
			//We want to be able to stop/start fetching chunks without stopping fetching variants
	
		}, {
			key: 'stopFetch',
			value: function stopFetch() {
				_logger.logger.log('stopFetch');
				this.streamController.forceStopFetching = true;
				if (this.audioStreamController) {
					this.audioStreamController.forceStopFetching = true;
				}
			}
		}, {
			key: 'resumeFetch',
			value: function resumeFetch() {
				var resumePosition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
	
				_logger.logger.log('resumeFetch');
				this.streamCoordinator.resetStreamTimeout();
				this.streamController.forceStopFetching = false;
				if (this.audioStreamController) {
					this.audioStreamController.forceStopFetching = false;
				}
			}
			//Mactrix additions end
	
		}, {
			key: 'swapAudioCodec',
			value: function swapAudioCodec() {
				_logger.logger.log('swapAudioCodec');
				this.streamController.swapAudioCodec();
			}
		}, {
			key: 'recoverMediaError',
			value: function recoverMediaError() {
				_logger.logger.log('recoverMediaError');
				var media = this.media;
				this.detachMedia();
				this.attachMedia(media);
			}
	
			//Mactrix additions start
			// FIXME: will need to be checked.
	
		}, {
			key: 'flushBuffers',
			value: function flushBuffers(levelFlush) {
				if (this.media) {
					if (this.levelController.chunkIDAtTime(this.media.currentTime) !== -1) {
						//Win8.1 IE needs more room after a flush or it will try to reload the current frag and cause a lot of graphical glitches
						if (this.browIE81) {
							if (_bufferHelper2.default.isBuffered(this.media, this.levelController.endOfChunk(this.levelController.chunkIDAtTime(this.media.currentTime) + 3) - 1)) {
								this.trigger(_events2.default.BUFFER_FLUSHING, {
									startOffset: this.levelController.endOfChunk(this.levelController.chunkIDAtTime(this.media.currentTime) + 3),
									endOffset: Number.POSITIVE_INFINITY
								});
							} else {
								_logger.logger.log('skipped flush buffers: nothing to flush');
							}
						}
						//Safari can't use the level-based flush, it tends to crash the media element if it encounters a buffer hole
						else if (levelFlush && !this.browSafari) {
								this.loadLevel = -1; //force a level switch
								this.bufferController.flushLevels(0, Number.POSITIVE_INFINITY, this.levelController.chunkIDAtTime(this.media.currentTime));
							} else {
								this.trigger(_events2.default.BUFFER_FLUSHING, {
									startOffset: this.levelController.endOfChunk(this.levelController.chunkIDAtTime(this.media.currentTime) + 1),
									endOffset: Number.POSITIVE_INFINITY
								});
								if (this.browFirefox) {
									this.trigger(_events2.default.BUFFER_FLUSHING, {
										startOffset: 0,
										endOffset: this.levelController.endOfChunk(this.levelController.chunkIDAtTime(this.media.currentTime) - 1)
									});
								} else {
									this.trigger(_events2.default.BUFFER_FLUSHING, {
										startOffset: Number.NEGATIVE_INFINITY,
										endOffset: this.levelController.endOfChunk(this.levelController.chunkIDAtTime(this.media.currentTime) - 1)
									});
								}
							}
	
						return true;
					} else {
						_logger.logger.log('cannot flush buffers: cannot find chunk timestamps');
	
						return false;
					}
				} else {
					_logger.logger.log('cannot flush buffers: media not attached');
	
					return false;
				}
			}
			//Mactrix additions end
	
			/** Return all quality levels **/
	
		}, {
			key: 'startPositionPdt',
			value: function startPositionPdt(value) {
				this.streamCoordinator.startPdt = value;
			}
		}, {
			key: '_doCompleteSlowDetach',
			value: function _doCompleteSlowDetach() {
				this.trigger(_events2.default.MEDIA_DETACHING);
				this.media = null;
				this.resumeFetch();
				this._inSlowDetach = false;
			}
		}, {
			key: 'getTimeForPdt',
			value: function getTimeForPdt(pdt) {
				return this.streamCoordinator.getTimeForPdt(pdt);
			}
		}, {
			key: 'getPdtForTime',
			value: function getPdtForTime(time) {
				return this.streamCoordinator.getPdtForTime(time);
			}
		}, {
			key: 'getCdmListAsync',
			value: function getCdmListAsync() {
				return this.licenseManager.drmCapabilities;
			}
	
			//Mactrix additions end
	
		}, {
			key: 'levels',
			get: function get() {
				return this.levelController.levels;
			}
	
			/** Return current playback quality level **/
	
		}, {
			key: 'currentLevel',
			get: function get() {
				return this.streamController.currentLevel;
			}
	
			/* set quality level immediately (-1 for automatic level selection) */
			,
			set: function set(newLevel) {
				_logger.logger.log('set currentLevel:' + newLevel);
				this.loadLevel = newLevel;
				this.streamController.immediateLevelSwitch();
			}
	
			/** Return next playback quality level (quality level of next fragment) **/
	
		}, {
			key: 'nextLevel',
			get: function get() {
				return this.streamController.nextLevel;
			}
	
			/* set quality level for next fragment (-1 for automatic level selection) */
			,
			set: function set(newLevel) {
				_logger.logger.log('set nextLevel:' + newLevel);
				this.levelController.manualLevel = newLevel;
				this.streamController.nextLevelSwitch();
			}
	
			/** Return the quality level of current/last loaded fragment **/
	
		}, {
			key: 'loadLevel',
			get: function get() {
				return this.levelController.level;
			}
	
			/* set quality level for current/next loaded fragment (-1 for automatic level selection) */
			,
			set: function set(newLevel) {
				_logger.logger.log('set loadLevel:' + newLevel);
				this.levelController.manualLevel = newLevel;
			}
	
			/** Return the quality level of next loaded fragment **/
	
		}, {
			key: 'nextLoadLevel',
			get: function get() {
				return this.levelController.nextLoadLevel;
			}
	
			/** set quality level of next loaded fragment **/
			,
			set: function set(level) {
				this.levelController.nextLoadLevel = level;
			}
	
			/** Return first level (index of first level referenced in manifest)
	   **/
	
		}, {
			key: 'firstLevel',
			get: function get() {
				return Math.max(this.levelController.firstLevel, this.minAutoLevel);
			}
	
			/** set first level (index of first level referenced in manifest)
	   **/
			,
			set: function set(newLevel) {
				_logger.logger.log('set firstLevel:' + newLevel);
				this.levelController.firstLevel = newLevel;
			}
	
			/** Return start level (level of first fragment that will be played back)
	  	 if not overrided by user, first level appearing in manifest will be used as start level
	  	if -1 : automatic start level selection, playback will start from level matching download bandwidth (determined from download of first segment)
	  **/
	
		}, {
			key: 'startLevel',
			get: function get() {
				return this.levelController.startLevel;
			}
	
			/** set  start level (level of first fragment that will be played back)
	  	 if not overrided by user, first level appearing in manifest will be used as start level
	  	if -1 : automatic start level selection, playback will start from level matching download bandwidth (determined from download of first segment)
	  **/
			,
			set: function set(newLevel) {
				_logger.logger.log('set startLevel:' + newLevel);
				var hls = this;
				// if not in automatic start level detection, ensure startLevel is greater than minAutoLevel
				if (newLevel !== -1) {
					newLevel = Math.max(newLevel, hls.minAutoLevel);
				}
				hls.levelController.startLevel = newLevel;
			}
	
			/** Return the capping/max level value that could be used by automatic level selection algorithm **/
	
		}, {
			key: 'autoLevelCapping',
			get: function get() {
				return this._autoLevelCapping;
			}
	
			/** set the capping/max level value that could be used by automatic level selection algorithm **/
			,
			set: function set(newLevel) {
				_logger.logger.log('set autoLevelCapping:' + newLevel);
				this._autoLevelCapping = newLevel;
			}
	
			//Mactrix additions start
			//Expose the minimum level constraint for use, as directly altering the config doesn't work any more
	
		}, {
			key: 'minAutoBitrate',
			get: function get() {
				return this._minAutoBitrate;
			},
			set: function set(newBitrate) {
				_logger.logger.log('set minAutoBitrate:' + newBitrate);
				this._minAutoBitrate = newBitrate;
			}
			//Mactrix additions end
	
			/* check if we are in automatic level selection mode */
	
		}, {
			key: 'autoLevelEnabled',
			get: function get() {
				return this.levelController.manualLevel === -1;
			}
	
			/* return manual level */
	
		}, {
			key: 'manualLevel',
			get: function get() {
				return this.levelController.manualLevel;
			}
	
			/* return min level selectable in auto mode according to config.minAutoBitrate */
	
		}, {
			key: 'minAutoLevel',
			get: function get() {
				/*
	   let hls = this, levels = hls.levels, minAutoBitrate = hls.config.minAutoBitrate, len = levels ? levels.length : 0;
	   */
				var hls = this,
				    levels = hls.levels,
				    minAutoBitrate = hls.minAutoBitrate,
				    len = levels ? levels.length : 0;
				for (var i = 0; i < len; i++) {
					var levelNextBitrate = levels[i].realBitrate ? Math.max(levels[i].realBitrate, levels[i].bitrate) : levels[i].bitrate;
					if (levelNextBitrate > minAutoBitrate) {
						return i;
					}
				}
				return 0;
			}
	
			/* return max level selectable in auto mode according to autoLevelCapping */
	
		}, {
			key: 'maxAutoLevel',
			get: function get() {
				var hls = this;
				var levels = hls.levels;
				var autoLevelCapping = hls.autoLevelCapping;
				var maxAutoLevel = void 0;
				if (autoLevelCapping === -1 && levels && levels.length) {
					maxAutoLevel = levels.length - 1;
				} else {
					maxAutoLevel = autoLevelCapping;
				}
				return maxAutoLevel;
			}
	
			// return next auto level
	
		}, {
			key: 'nextAutoLevel',
			get: function get() {
				var hls = this;
				// ensure next auto level is between  min and max auto level
				return Math.min(Math.max(hls.abrController.nextAutoLevel, hls.minAutoLevel), hls.maxAutoLevel);
			}
	
			// this setter is used to force next auto level
			// this is useful to force a switch down in auto mode : in case of load error on level N, hls.js can set nextAutoLevel to N-1 for example)
			// forced value is valid for one fragment. upon succesful frag loading at forced level, this value will be resetted to -1 by ABR controller
			,
			set: function set(nextLevel) {
				var hls = this;
				hls.abrController.nextAutoLevel = Math.max(hls.minAutoLevel, nextLevel);
			}
	
			/** get alternate audio tracks list from playlist **/
	
		}, {
			key: 'audioTracks',
			get: function get() {
				var audioTrackController = this.audioTrackController;
				return audioTrackController ? audioTrackController.audioTracks : [];
			}
	
			/** get index of the selected audio track (index in audio track lists) **/
	
		}, {
			key: 'audioTrack',
			get: function get() {
				var audioTrackController = this.audioTrackController;
				return audioTrackController ? audioTrackController.audioTrack : -1;
			}
	
			/** select an audio track, based on its index in audio track lists**/
			,
			set: function set(audioTrackId) {
				var audioTrackController = this.audioTrackController;
				if (audioTrackController) {
					audioTrackController.audioTrack = audioTrackId;
				}
				//Mactrix additions start
				//guarantee a buffer flush on audio track change
				if (this.bufferController.sourceBuffer['audio']) {
					if (this.browSafari) {
						this.trigger(_events2.default.BUFFER_FLUSHING, { startOffset: 0, endOffset: Number.POSITIVE_INFINITY });
					} else {
						this.trigger(_events2.default.BUFFER_FLUSHING, { startOffset: 0, endOffset: Number.POSITIVE_INFINITY, type: 'audio' });
					}
				}
				//Mactrix additions end
			}
		}, {
			key: 'liveSyncPosition',
			get: function get() {
				return this.streamController.liveSyncPosition;
			}
	
			/** get alternate subtitle tracks list from playlist **/
	
		}, {
			key: 'subtitleTracks',
			get: function get() {
				var subtitleTrackController = this.subtitleTrackController;
				return subtitleTrackController ? subtitleTrackController.subtitleTracks : [];
			}
	
			/** get index of the selected subtitle track (index in subtitle track lists) **/
	
		}, {
			key: 'subtitleTrack',
			get: function get() {
				var subtitleTrackController = this.subtitleTrackController;
				return subtitleTrackController ? subtitleTrackController.subtitleTrack : -1;
			}
	
			/** select an subtitle track, based on its index in subtitle track lists**/
			,
			set: function set(subtitleTrackId) {
				var subtitleTrackController = this.subtitleTrackController;
				if (subtitleTrackController) {
					subtitleTrackController.subtitleTrack = subtitleTrackId;
				}
			}
	
			//Mactrix additions start
	
		}, {
			key: 'subtitleIndex',
			set: function set(value) {
				this.trigger(_events2.default.TEXT_TRACK_CHANGED, { index: value });
			}
		}, {
			key: 'resumeBasePdt',
			set: function set(value) {
				this.streamCoordinator.resumeBasePdt = value;
			}
		}, {
			key: 'timeouts',
			set: function set(value) {
				this.config.manifestLoadingTimeOut = value.manifestTimeout;
				this.config.manifestLoadingMaxRetryTimeout = value.manifestTimeoutMax;
				this.config.levelLoadingTimeOut = value.variantTimeout;
				this.config.levelLoadingMaxRetryTimeout = value.variantTimeoutMax;
				this.config.fragLoadingTimeOut = value.chunkTimeout;
				this.config.fragLoadingMaxRetryTimeout = value.chunkTimeoutMax;
				this.config.streamTimeOut = value.streamTimeout;
			}
		}, {
			key: 'bufferBeforeSeeking',
			set: function set(seconds) {
				if (this.streamController.bufferBeforeSeeking === undefined) {
					this.timelineController.preFlushed = true;
					this.trigger(_events2.default.BUFFER_FLUSHING, { startOffset: 0, endOffset: Number.POSITIVE_INFINITY });
					if (!this.browFirefox) {
						this.trigger(_events2.default.BUFFER_FLUSHING, { startOffset: Number.NEGATIVE_INFINITY, endOffset: 0 });
					}
				}
	
				this.streamController.bufferBeforeSeeking = seconds;
				if (this.streamCoordinator.checkIfRenditionsAreActive) {
					this.audioStreamController.bufferBeforeSeeking = seconds;
				}
			}
		}]);
	
		return Hls;
	}();
	
	exports.default = Hls;
	module.exports = exports['default'];

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _events = __webpack_require__(3);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _eventHandler = __webpack_require__(5);
	
	var _eventHandler2 = _interopRequireDefault(_eventHandler);
	
	var _errors = __webpack_require__(4);
	
	var _dataTypes = __webpack_require__(36);
	
	var _dataTypes2 = _interopRequireDefault(_dataTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Fragment Loader
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */
	
	//import { logger } from '../utils/logger';
	
	
	//Mactrix line added - datatypes are used to describe the type of object fetched via XHR
	
	var FragmentLoader = function (_EventHandler) {
		_inherits(FragmentLoader, _EventHandler);
	
		function FragmentLoader(hls) {
			_classCallCheck(this, FragmentLoader);
	
			var _this = _possibleConstructorReturn(this, (FragmentLoader.__proto__ || Object.getPrototypeOf(FragmentLoader)).call(this, hls, _events2.default.FRAG_LOADING, _events2.default.ERROR));
	
			_this.loaders = {};
			return _this;
		}
	
		_createClass(FragmentLoader, [{
			key: 'destroy',
			value: function destroy() {
				var loaders = this.loaders;
				for (var loaderName in loaders) {
					// eslint-disable-line guard-for-in
					var loader = loaders[loaderName];
					if (loader) {
						loader.destroy();
					}
				}
				this.loaders = {};
				_eventHandler2.default.prototype.destroy.call(this);
			}
	
			//Mactrix additions start
			//on fatal error, abort all loaders
	
		}, {
			key: 'onError',
			value: function onError(data) {
				if (data.fatal) {
					for (var loaderName in this.loaders) {
						if (this.loaders[loaderName]) {
							this.loaders[loaderName].abort();
						}
					}
				}
			}
			//Mactrix additions end
	
		}, {
			key: 'onFragLoading',
			value: function onFragLoading(data) {
				var frag = data.frag;
				var type = frag.type;
				var loader = this.loaders[type];
				var config = this.hls.config;
	
				frag.loaded = 0;
				if (loader) {
					//logger.warn(`abort previous fragment loader for type:${type}`);
					loader.abort();
				} else {
					loader = this.loaders[type] = frag.loader = typeof config.fLoader !== 'undefined' ? new config.fLoader(config) : new config.loader(config);
				}
	
				frag.loader = loader;
	
				var loaderContext = void 0;
				var loaderConfig = void 0;
				var loaderCallbacks = void 0;
				/* mactrix replace
	   	loaderContext = { url : frag.url, frag : frag, responseType : 'arraybuffer', progressData : false};
	   */
				loaderContext = {
					url: frag.url,
					frag: frag,
					responseType: 'arraybuffer',
					progressData: false,
					dataType: _dataTypes2.default.CHUNK
				}; //Mactrix above line changed, added dataType
	
				var start = frag.byteRangeStartOffset;
				var end = frag.byteRangeEndOffset;
	
				if (!isNaN(start) && !isNaN(end)) {
					loaderContext.rangeStart = start;
					loaderContext.rangeEnd = end;
				}
	
				loaderConfig = { timeout: config.fragLoadingTimeOut, maxRetry: 0, retryDelay: 0, maxRetryDelay: config.fragLoadingMaxRetryTimeout };
				loaderCallbacks = {
					onSuccess: this.loadsuccess.bind(this),
					onError: this.loaderror.bind(this),
					onTimeout: this.loadtimeout.bind(this),
					onProgress: this.loadprogress.bind(this)
				};
	
				loader.load(loaderContext, loaderConfig, loaderCallbacks);
			}
		}, {
			key: 'loadsuccess',
			value: function loadsuccess(response, stats, context) {
				var payload = response.data;
				var frag = context.frag;
				// detach fragment loader on load success
				frag.loader = undefined;
				//this.loaders[frag.type] = undefined;
				this.hls.trigger(_events2.default.FRAG_LOADED, { payload: payload, frag: frag, stats: stats });
			}
		}, {
			key: 'loaderror',
			value: function loaderror(response, context) {
				var loader = context.loader;
				if (loader) {
					loader.abort();
				}
	
				//this.loaders[context.type] = undefined;
				this.hls.trigger(_events2.default.ERROR, {
					type: _errors.ErrorTypes.NETWORK_ERROR,
					details: _errors.ErrorDetails.FRAG_LOAD_ERROR,
					fatal: false,
					frag: context.frag,
					response: response
				});
			}
		}, {
			key: 'loadtimeout',
			value: function loadtimeout(stats, context) {
				var loader = context.loader;
				if (loader) {
					loader.abort();
				}
				//this.loaders[context.type] = undefined;
				this.hls.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.NETWORK_ERROR, details: _errors.ErrorDetails.FRAG_LOAD_TIMEOUT, fatal: false, frag: context.frag });
			}
	
			// data will be used for progressive parsing
	
		}, {
			key: 'loadprogress',
			value: function loadprogress(stats, context, data) {
				// eslint-disable-line no-unused-vars
				var frag = context.frag;
				frag.loaded = stats.loaded;
				this.hls.trigger(_events2.default.FRAG_LOAD_PROGRESS, { frag: frag, stats: stats });
			}
		}]);
	
		return FragmentLoader;
	}(_eventHandler2.default);
	
	exports.default = FragmentLoader;
	module.exports = exports['default'];

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Playlist Loader
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     */
	
	//Mactrix line added
	
	
	var _urlToolkit = __webpack_require__(217);
	
	var _urlToolkit2 = _interopRequireDefault(_urlToolkit);
	
	var _events = __webpack_require__(3);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _eventHandler = __webpack_require__(5);
	
	var _eventHandler2 = _interopRequireDefault(_eventHandler);
	
	var _errors = __webpack_require__(4);
	
	var _attrList = __webpack_require__(134);
	
	var _attrList2 = _interopRequireDefault(_attrList);
	
	var _logger = __webpack_require__(1);
	
	var _dataTypes = __webpack_require__(36);
	
	var _dataTypes2 = _interopRequireDefault(_dataTypes);
	
	var _hlsDateRange = __webpack_require__(165);
	
	var _hlsDateRange2 = _interopRequireDefault(_hlsDateRange);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// https://regex101.com is your friend
	var MASTER_PLAYLIST_REGEX = /#EXT-X-STREAM-INF:([^\n\r]*)[\r\n]+([^\r\n]+)/g;
	var MASTER_PLAYLIST_MEDIA_REGEX = /#EXT-X-MEDIA:(.*)/g;
	
	//Mactric Replaced start
	//const LEVEL_PLAYLIST_REGEX_FAST = /#EXTINF:(\d*(?:\.\d+)?)(?:,(.*))?|(?!#)(\S.+)|#EXT-X-BYTERANGE: *(.+)|#EXT-X-PROGRAM-DATE-TIME:(.+)|#.*/g;
	//Mactric Replaced end
	//Mactrix replacement start
	var LEVEL_PLAYLIST_REGEX_FAST = /#EXTINF:(\d*(?:\.\d+)?)(?:,(.*))?|(?!#)(\S.+)|#EXT-X-BYTERANGE: *(.+)|#EXT-X-PROGRAM-DATE-TIME:(.+)|#EXT-X-DATERANGE: *(.+)|#.*/g;
	//Mactix replacment end
	
	var LEVEL_PLAYLIST_REGEX_SLOW = /(?:(?:#(EXTM3U))|(?:#EXT-X-(PLAYLIST-TYPE):(.+))|(?:#EXT-X-(MEDIA-SEQUENCE): *(\d+))|(?:#EXT-X-(TARGETDURATION): *(\d+))|(?:#EXT-X-(KEY):(.+))|(?:#EXT-X-(START):(.+))|(?:#EXT-X-(ENDLIST))|(?:#EXT-X-(DISCONTINUITY-SEQ)UENCE:(\d+))|(?:#EXT-X-(DIS)CONTINUITY))|(?:#EXT-X-(VERSION):(\d+))|(?:#EXT-X-(MAP):(.+))|(?:#EXT-X-(GAP))|(?:(#)(.*):(.*))|(?:(#)(.*))(?:.*)\r?\n?/;
	
	var LevelKey = function () {
		function LevelKey() {
			_classCallCheck(this, LevelKey);
	
			this.method = null;
			this.key = null;
			this.iv = null;
			this._uri = null;
		}
	
		_createClass(LevelKey, [{
			key: 'uri',
			get: function get() {
				if (!this._uri && this.reluri) {
					this._uri = _urlToolkit2.default.buildAbsoluteURL(this.baseuri, this.reluri, { alwaysNormalize: true });
				}
				return this._uri;
			}
		}]);
	
		return LevelKey;
	}();
	
	var Fragment = function () {
		function Fragment() {
			_classCallCheck(this, Fragment);
	
			this._url = null;
			this._byteRange = null;
			this._decryptdata = null;
			this.tagList = [];
		}
	
		_createClass(Fragment, [{
			key: 'createInitializationVector',
	
	
			/**
	   * Utility method for parseLevelPlaylist to create an initialization vector for a given segment
	   * @returns {Uint8Array}
	   */
			value: function createInitializationVector(segmentNumber) {
				var uint8View = new Uint8Array(16);
	
				for (var i = 12; i < 16; i++) {
					uint8View[i] = segmentNumber >> 8 * (15 - i) & 0xff;
				}
	
				return uint8View;
			}
	
			/**
	   * Utility method for parseLevelPlaylist to get a fragment's decryption data from the currently parsed encryption key data
	   * @param levelkey - a playlist's encryption info
	   * @param segmentNumber - the fragment's segment number
	   * @returns {*} - an object to be applied as a fragment's decryptdata
	   */
	
		}, {
			key: 'fragmentDecryptdataFromLevelkey',
			value: function fragmentDecryptdataFromLevelkey(levelkey, segmentNumber) {
				var decryptdata = levelkey;
	
				if (levelkey.method && levelkey.uri && !levelkey.iv) {
					decryptdata = new LevelKey();
					decryptdata.method = levelkey.method;
					decryptdata.baseuri = levelkey.baseuri;
					decryptdata.reluri = levelkey.reluri;
					decryptdata.iv = this.createInitializationVector(segmentNumber);
				}
	
				return decryptdata;
			}
		}, {
			key: 'cloneObj',
			value: function cloneObj(obj) {
				return JSON.parse(JSON.stringify(obj));
			}
		}, {
			key: 'url',
			get: function get() {
				if (!this._url && this.relurl) {
					this._url = _urlToolkit2.default.buildAbsoluteURL(this.baseurl, this.relurl, { alwaysNormalize: true });
				}
				return this._url;
			},
			set: function set(value) {
				this._url = value;
			}
		}, {
			key: 'programDateTime',
			get: function get() {
				if (!this._programDateTime && this.rawProgramDateTime) {
					this._programDateTime = new Date(Date.parse(this.rawProgramDateTime));
				}
				return this._programDateTime;
			}
		}, {
			key: 'byteRange',
			get: function get() {
				if (!this._byteRange) {
					var byteRange = this._byteRange = [];
					if (this.rawByteRange) {
						var params = this.rawByteRange.split('@', 2);
						if (params.length === 1) {
							var lastByteRangeEndOffset = this.lastByteRangeEndOffset;
							byteRange[0] = lastByteRangeEndOffset || 0;
						} else {
							byteRange[0] = parseInt(params[1], 10);
						}
						byteRange[1] = parseInt(params[0], 10) + byteRange[0];
					}
				}
				return this._byteRange;
			}
		}, {
			key: 'byteRangeStartOffset',
			get: function get() {
				return this.byteRange[0];
			}
		}, {
			key: 'byteRangeEndOffset',
			get: function get() {
				return this.byteRange[1];
			}
		}, {
			key: 'decryptdata',
			get: function get() {
				if (!this._decryptdata) {
					if (!this.levelkeys) {
						if (this.levelkey && this.levelkey.method !== 'SAMPLE-AES' && this.levelkey.method !== 'ISO-23001-7' && this.levelkey.method !== 'SAMPLE-AES-CTR' && this.levelkey.method !== 'SAMPLE-AES-CENC') {
							this._decryptdata = this.fragmentDecryptdataFromLevelkey(this.levelkey, this.sn);
						}
					}
				}
				return this._decryptdata;
			}
		}]);
	
		return Fragment;
	}();
	
	var PlaylistLoader = function (_EventHandler) {
		_inherits(PlaylistLoader, _EventHandler);
	
		function PlaylistLoader(hls) {
			_classCallCheck(this, PlaylistLoader);
	
			var _this = _possibleConstructorReturn(this, (PlaylistLoader.__proto__ || Object.getPrototypeOf(PlaylistLoader)).call(this, hls, _events2.default.ERROR, //Mactrix line added
			_events2.default.MANIFEST_LOADING, _events2.default.LEVEL_LOADING, _events2.default.AUDIO_TRACK_LOADING, _events2.default.SUBTITLE_TRACK_LOADING));
	
			_this.loaders = {};
			_this.lastGap = {}; //Mactix line added, track found discos
			return _this;
		}
	
		_createClass(PlaylistLoader, [{
			key: 'destroy',
			value: function destroy() {
				for (var loaderName in this.loaders) {
					//eslint-disable-line guard-for-in
					var loader = this.loaders[loaderName];
					if (loader) {
						loader.destroy();
					}
				}
				this.loaders = {};
				this.lastGap = {}; //Mactrix line added
				_eventHandler2.default.prototype.destroy.call(this);
			}
		}, {
			key: 'onManifestLoading',
			value: function onManifestLoading(data) {
				this.load(data.url, { type: 'manifest' });
			}
		}, {
			key: 'onLevelLoading',
			value: function onLevelLoading(data) {
				this.load(data.url, { type: 'level', level: data.level, id: data.id });
			}
		}, {
			key: 'onAudioTrackLoading',
			value: function onAudioTrackLoading(data) {
				this.load(data.url, { type: 'audioTrack', id: data.id });
			}
		}, {
			key: 'onSubtitleTrackLoading',
			value: function onSubtitleTrackLoading(data) {
				this.load(data.url, { type: 'subtitleTrack', id: data.id });
			}
	
			//Mactrix additions start
			//on fatal error, abort all loaders
	
		}, {
			key: 'onError',
			value: function onError(data) {
				if (data.fatal) {
					for (var loaderName in this.loaders) {
						if (this.loaders[loaderName]) {
							this.loaders[loaderName].abort();
						}
					}
				}
			}
			//Mactrix additions end
	
		}, {
			key: 'load',
			value: function load(url, context) {
				var loader = this.loaders[context.type];
				var config = this.hls.config;
				var retry = void 0;
				var timeout = void 0;
				var retryDelay = void 0;
				var maxRetryDelay = void 0;
	
				if (loader) {
					/*let loaderContext = loader.context;
	    if (loaderContext && loaderContext.url === url) {
	    	logger.trace(`playlist request ongoing`);
	    	return;
	    }
	    else {
	    	logger.warn(`abort previous loader for type:${context.type}`);*/
					loader.abort();
					//}
				} else {
					loader = this.loaders[context.type] = context.loader = typeof config.pLoader !== 'undefined' ? new config.pLoader(config) : new config.loader(config);
				}
	
				if (context.type === 'manifest') {
					retry = config.manifestLoadingMaxRetry;
					timeout = config.manifestLoadingTimeOut;
					retryDelay = config.manifestLoadingRetryDelay;
					maxRetryDelay = config.manifestLoadingMaxRetryTimeout;
				} else {
					retry = config.levelLoadingMaxRetry;
					timeout = config.levelLoadingTimeOut;
					retryDelay = config.levelLoadingRetryDelay;
					maxRetryDelay = config.levelLoadingMaxRetryTimeout;
					_logger.logger.log('loading playlist for ' + context.type + ' ' + (context.level || context.id));
				}
				context.url = url;
				context.responseType = '';
				context.dataType = _dataTypes2.default.MANIFEST; //Mactrix line added, add data type
	
				var loaderConfig = void 0;
				var loaderCallbacks = void 0;
	
				loaderConfig = { timeout: timeout, maxRetry: retry, retryDelay: retryDelay, maxRetryDelay: maxRetryDelay };
				loaderCallbacks = { onSuccess: this.loadsuccess.bind(this), onError: this.loaderror.bind(this), onTimeout: this.loadtimeout.bind(this) };
				loader.load(context, loaderConfig, loaderCallbacks);
			}
		}, {
			key: 'resolve',
			value: function resolve(url, baseUrl) {
				return _urlToolkit2.default.buildAbsoluteURL(baseUrl, url, { alwaysNormalize: true });
			}
		}, {
			key: 'parseMasterPlaylist',
			value: function parseMasterPlaylist(string, baseurl) {
				var levels = [];
				var result = void 0;
	
				MASTER_PLAYLIST_REGEX.lastIndex = 0;
				//se: poor form.
				while ((result = MASTER_PLAYLIST_REGEX.exec(string)) != null) {
					//eslint-disable-line no-cond-assign
					var level = {};
	
					var attrs = level.attrs = new _attrList2.default(result[1]);
					level.url = this.resolve(result[2], baseurl);
	
					var resolution = attrs.decimalResolution('RESOLUTION');
					if (resolution) {
						level.width = resolution.width;
						level.height = resolution.height;
					}
					level.bitrate = attrs.decimalInteger('AVERAGE-BANDWIDTH') || attrs.decimalInteger('BANDWIDTH');
					level.name = attrs.NAME;
	
					//Mactrix additions start
					level.audioGroup = attrs.AUDIO; //add audio rendition group support
	
					//add default level support
					if (levels.length === 0) {
						level.default = true;
					} else {
						level.default = false;
					}
					//Mactrix additions end
	
					var codecs = attrs.CODECS;
					if (codecs) {
						codecs = codecs.split(/[ ,]+/);
						for (var i = 0; i < codecs.length; i++) {
							var codec = codecs[i];
							if (codec.indexOf('avc1') !== -1) {
								level.videoCodec = this.avc1toavcoti(codec);
							} else {
								level.audioCodec = codec;
							}
						}
					}
	
					levels.push(level);
				}
				return levels;
			}
		}, {
			key: 'parseMasterPlaylistMedia',
			value: function parseMasterPlaylistMedia(string, baseurl, type) {
				var result = void 0;
				var medias = [];
				var id = 0;
	
				MASTER_PLAYLIST_MEDIA_REGEX.lastIndex = 0;
				//se: poor form.
				while ((result = MASTER_PLAYLIST_MEDIA_REGEX.exec(string)) != null) {
					//eslint-disable-line no-cond-assign
					var media = {};
					var attrs = new _attrList2.default(result[1]);
					if (attrs.TYPE === type) {
						media.groupId = attrs['GROUP-ID'];
						media.name = attrs.NAME;
						media.type = type;
						media.default = attrs.DEFAULT === 'YES';
						media.autoselect = attrs.AUTOSELECT === 'YES';
						media.forced = attrs.FORCED === 'YES';
						if (attrs.URI) {
							media.url = this.resolve(attrs.URI, baseurl);
						}
						media.lang = attrs.LANGUAGE;
						if (!media.name) {
							media.name = media.lang;
						}
						media.id = id++;
						medias.push(media);
					}
				}
				return medias;
			}
	
			//Mactrix additions begin
			//alternate renditions parser designed to support rendition groups
	
		}, {
			key: 'parseMasterPlaylistMediaGrouped',
			value: function parseMasterPlaylistMediaGrouped(string, baseurl, type) {
				var result = void 0;
				var medias = [];
				var id = 0;
	
				MASTER_PLAYLIST_MEDIA_REGEX.lastIndex = 0;
				//se: poor form.
				while ((result = MASTER_PLAYLIST_MEDIA_REGEX.exec(string)) != null) {
					//eslint-disable-line no-cond-assign
					var rendition = {};
					var attrs = new _attrList2.default(result[1]);
					if (attrs.TYPE === type) {
						rendition.groupId = attrs['GROUP-ID'];
						if (attrs.URI) {
							rendition.url = this.resolve(attrs.URI, baseurl);
						}
						var added = false;
						for (var i = 0; i < medias.length; i++) {
							if (medias[i].name === attrs.NAME) {
								medias[i].renditions.push(rendition);
								added = true;
							}
						}
						if (!added) {
							var media = {};
							media.name = attrs.NAME;
							media.type = type;
							media.default = attrs.DEFAULT === 'YES';
							media.autoselect = attrs.AUTOSELECT === 'YES';
							media.forced = attrs.FORCED === 'YES';
							media.lang = attrs.LANGUAGE;
							if (!media.name) {
								media.name = media.lang;
							}
							media.id = id++;
							media.renditions = [rendition];
							medias.push(media);
						}
					}
				}
				return medias;
			}
			//Mactrix additions end
	
		}, {
			key: 'avc1toavcoti',
			value: function avc1toavcoti(codec) {
				var result = void 0;
				var avcdata = codec.split('.');
	
				if (avcdata.length > 2) {
					result = avcdata.shift() + '.';
					result += parseInt(avcdata.shift(), 10).toString(16);
					result += ('000' + parseInt(avcdata.shift(), 10).toString(16)).substr(-4);
				} else {
					result = codec;
				}
				return result;
			}
		}, {
			key: 'parseLevelPlaylist',
			value: function parseLevelPlaylist(string, baseurl, id, type) {
				var currentSN = 0;
				var totalduration = 0;
				var level = { type: null, version: null, url: baseurl, fragments: [], live: true, startSN: 0 };
				var levelkeys = [];
				var cc = 0;
				var prevFrag = null;
				var frag = new Fragment();
				var result = void 0;
				//Mactrix changes begin: store the frag index
				var index = 0;
				var clearKeys = false;
				//Mactrix changes end
	
				LEVEL_PLAYLIST_REGEX_FAST.lastIndex = 0;
	
				//se: poor form.
				while ((result = LEVEL_PLAYLIST_REGEX_FAST.exec(string)) !== null) {
					//eslint-disable-line no-cond-assign
					var duration = result[1];
					if (duration) {
						// INF
						frag.duration = parseFloat(duration);
	
						//Mactrix changes begin: frag.duration is overwritten with transport stream duration
						//						 the pdt calculation is based of the manifest duration NOT the
						//						 transport stream duration
						//						 we need to cache the manifest duration otherwise when comparing
						//						 pdts across track switches we get a mismatch where we end up
						//						 comparing the transport stream time of the previous frag with the
						//						 manifest time (because we haven't read the next chunk yet, hence
						//						 frag.duration has not been overwritten) of the current frag
						//						 which can result in an incorrect chunk being selected
						frag.manifestDuration = frag.duration;
						//Mactrix changes end
	
						// avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
						var title = (' ' + result[2]).slice(1);
						frag.title = title || null;
						frag.tagList.push(title ? ['INF', duration, title] : ['INF', duration]);
	
						if (result[2]) {
							var pairs = result[2].split(',');
							var i = void 0;
	
							for (i = 0; i < pairs.length; i++) {
								var pair = pairs[i].split('=');
								pair[0] = pair[0].trim();
	
								if (pair[0] === 'startDTS') {
									frag.startDTS = parseInt(pair[1], 10);
								} else if (pair[0] === 'nextDTS') {
									frag.nextDTS = parseInt(pair[1], 10);
								} else if (pair[0] === 'frames') {
									frag.frames = parseInt(pair[1], 10);
								}
							}
						}
					} else if (result[3]) {
						// url
						if (!isNaN(frag.duration)) {
							var sn = currentSN++;
							//Mactrix changes begin
							var length = void 0;
							frag.index = index++;
							//Mactrix changes end
							frag.type = type;
							frag.start = totalduration;
							if (levelkeys && levelkeys.length) {
								frag.levelkey = levelkeys[levelkeys.length - 1];
							}
							frag.sn = sn;
							frag.level = id;
							frag.cc = cc;
							frag.baseurl = baseurl;
							// avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
							frag.relurl = (' ' + result[3]).slice(1);
	
							level.fragments.push(frag);
	
							//Mactrix changes begin: keep track of the pdt of each frag
							length = level.fragments.length;
	
							if (frag.rawProgramDateTime) {
								var _i = void 0;
								frag.pdt = Date.parse(frag.rawProgramDateTime);
	
								if (length > 1) {
									//determine if there is a gap
									if (level.fragments[length - 2].pdt && level.fragments[length - 2].pdt + level.fragments[length - 2].manifestDuration * 1000 < level.fragments[length - 1].pdt - level.fragments[length - 1].manifestDuration * 500) {
										//there is a gap in the manifest - this is approximate
										//we will use this value to determine whether or a not a gap exists, then make it correct in the tranmux
	
										/*
	         	We are going to extend (in the case of video) the duration of the first frame of the next fragment.
	         	Ideally (from a user perspective) it would be more desirable to extend the last frame of the current
	         	fragment (level.fragments[length - 2].gap).
	         	However, this relies on us trusting that the gap calculated via the pdts is frame accurate (which I don't), hence I've
	         	chosen the safer option.
	         */
										level.fragments[length - 1].gap = level.fragments[length - 1].pdt - (level.fragments[length - 2].pdt + level.fragments[length - 2].manifestDuration * 1000);
	
										//TODO: once we implement EXT-X-GAP, those are expected gaps and should not require an error
										var identifier = type + id;
										if (this.lastGap[identifier] === undefined || this.lastGap[identifier] < level.fragments[length - 1].pdt) {
											this.lastGap[identifier] = level.fragments[length - 1].pdt;
											var data = {
												type: _errors.ErrorTypes.MUX_ERROR,
												details: _errors.ErrorDetails.LEVEL_UNEXPECTED_GAP_ERROR,
												fatal: false,
												playlistType: type,
												level: id,
												gapTime: level.fragments[length - 1].start,
												gapStartPdt: level.fragments[length - 2].pdt + level.fragments[length - 2].duration * 1000,
												gapEndPdt: level.fragments[length - 1].pdt,
												gapDuration: level.fragments[length - 1].gap
											};
	
											_logger.logger.warn('gap detected in ' + type + ', level ' + id + ', time ' + data.gapTime + ', length ' + data.gapDuration / 1000);
											this.hls.trigger(_events2.default.ERROR, data);
										}
	
										if (this.hls.streamController.altAudio === true) {
											totalduration += level.fragments[length - 1].gap / 1000;
										}
	
										//extend the manifest duration to account for the gap, ideally we would also set the gap here too, but instead set this gap in
										//the next fragment (see block comment above)
										level.fragments[length - 2].manifestDuration += level.fragments[length - 1].gap / 1000;
									}
	
									/*
	        	6.3.3.  Playing the Media Playlist file
	        		If the first EXT-X-PROGRAM-DATE-TIME tag in a Playlist appears after
	        	one or more media segment URIs, the client SHOULD extrapolate
	        	backward from that tag (using EXTINF durations and/or media
	        	timestamps) to associate dates with those segments.
	        */
									for (_i = length - 2; _i >= 0 && level.fragments[_i].pdt === undefined; _i--) {
										level.fragments[_i].pdt = level.fragments[_i + 1].pdt - level.fragments[_i].manifestDuration * 1000;
									}
								}
							} else {
								/*
	       	6.3.3.  Playing the Media Playlist file
	       		To associate a
	       	date with any other media segment that does not have an EXT-X
	       	   -PROGRAM-DATE-TIME tag applied to it directly , the client SHOULD
	       	   extrapolate forward from the last EXT-X-PROGRAM-DATE-TIME tag
	       	   appearing before that segment in the Playlist.
	       */
								if (length > 1) {
									if (level.fragments[length - 2].pdt) {
										level.fragments[length - 1].pdt = level.fragments[length - 2].pdt + level.fragments[length - 2].duration * 1000;
									}
								}
							}
							//Mactrix changes end
	
							prevFrag = frag;
							totalduration += frag.duration;
	
							frag = new Fragment();
						}
	
						//Any level keys loaded prior to this applies to this fragment.
						//When we load the next set of level keys we need to clear the old ones.
						clearKeys = true;
					} else if (result[4]) {
						// X-BYTERANGE
						frag.rawByteRange = (' ' + result[4]).slice(1);
						if (prevFrag) {
							var lastByteRangeEndOffset = prevFrag.byteRangeEndOffset;
							if (lastByteRangeEndOffset) {
								frag.lastByteRangeEndOffset = lastByteRangeEndOffset;
							}
						}
						//Mactrix addition start
					} else if (result[6]) {
						// DATERANGE
						var thisRange = new _hlsDateRange2.default(result[6]);
						frag.dateRange = thisRange;
						frag.tagList.push(['DATERANGE', frag.dateRange]);
						//Mactrix addition end
					} else if (result[5]) {
						// PROGRAM-DATE-TIME
						// avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
						frag.rawProgramDateTime = (' ' + result[5]).slice(1);
						frag.tagList.push(['PROGRAM-DATE-TIME', frag.rawProgramDateTime]);
					} else {
						var _i2 = void 0;
						result = result[0].match(LEVEL_PLAYLIST_REGEX_SLOW);
						for (_i2 = 1; _i2 < result.length; _i2++) {
							if (result[_i2] !== undefined) {
								break;
							}
						}
	
						// avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
						var value1 = (' ' + result[_i2 + 1]).slice(1);
						var value2 = (' ' + result[_i2 + 2]).slice(1);
	
						switch (result[_i2]) {
							case '#':
								frag.tagList.push(value2 ? [value1, value2] : [value1]);
								break;
							case 'PLAYLIST-TYPE':
								level.type = value1.toUpperCase();
								break;
							case 'MEDIA-SEQUENCE':
								currentSN = level.startSN = parseInt(value1, 10);
								break;
							case 'TARGETDURATION':
								level.targetduration = parseFloat(value1);
								break;
							case 'VERSION':
								level.version = parseInt(value1, 10);
								break;
							case 'EXTM3U':
								break;
							case 'ENDLIST':
								level.live = false;
								break;
							case 'DIS':
								cc++;
								frag.tagList.push(['DIS']);
								break;
							case 'DISCONTINUITY-SEQ':
								cc = parseInt(value1, 10);
								break;
							case 'GAP':
								frag.tagList.push('GAP');
								break;
							case 'KEY':
								{
									// https://tools.ietf.org/html/draft-pantos-http-live-streaming-08#section-3.4.4
									var decryptparams = value1;
									var keyAttrs = new _attrList2.default(decryptparams);
									var decryptmethod = keyAttrs.enumeratedString('METHOD');
									var decrypturi = keyAttrs.URI;
									var decryptiv = keyAttrs.hexadecimalInteger('IV');
									var decryptkid = null;
									var decryptFormat = 'identity';
									var decryptFormatVersions = '1';
	
									//prepend trailing 0x and strip out hyphens if required
									if (keyAttrs['X-MLB-KEYID']) {
										var value = keyAttrs['X-MLB-KEYID'];
	
										if (value[0] !== '0' || value[1] !== 'x') {
											value = '0x' + value;
										}
	
										value = value.replace(/-/g, '');
										keyAttrs['X-MLB-KEYID'] = value;
										decryptkid = keyAttrs.hexadecimalInteger('X-MLB-KEYID');
									}
	
									if (keyAttrs.enumeratedString('KEYFORMAT')) {
										decryptFormat = keyAttrs.enumeratedString('KEYFORMAT');
									}
	
									if (keyAttrs.enumeratedString('KEYFORMATVERSIONS')) {
										decryptFormatVersions = keyAttrs.enumeratedString('KEYFORMATVERSIONS');
									}
	
									if (decryptmethod) {
										if (clearKeys) {
											//we are loading a new set of level keys for the next set of fragments, clear the old ones.
											//logger.log(`# Clearing old level keys`);
											levelkeys = [];
											clearKeys = false;
										}
	
										//logger.log(`# Creating levelKey for decryption method ${decryptmethod}`);
										var levelkey = new LevelKey();
	
										if (decrypturi && ['AES-128', 'SAMPLE-AES', 'ISO-23001-7', 'SAMPLE-AES-CTR', 'SAMPLE-AES-CENC'].indexOf(decryptmethod) >= 0) {
											levelkey.method = decryptmethod;
											// URI to get the key
											levelkey.baseuri = baseurl;
											levelkey.reluri = decrypturi;
											levelkey.key = null;
											// Initialization Vector (IV)
											levelkey.iv = decryptiv;
											levelkey.kid = decryptkid;
											levelkey.format = decryptFormat;
											levelkey.formatVersions = decryptFormatVersions;
										}
	
										levelkeys.push(levelkey);
									}
								}
								break;
							case 'START':
								{
									var startParams = value1;
									var startAttrs = new _attrList2.default(startParams);
									var startTimeOffset = startAttrs.decimalFloatingPoint('TIME-OFFSET');
									//TIME-OFFSET can be 0
									if (!isNaN(startTimeOffset)) {
										level.startTimeOffset = startTimeOffset;
									}
								}
								break;
							case 'MAP':
								{
									var mapAttrs = new _attrList2.default(value1);
									var initFrag = new Fragment();
									initFrag.relurl = mapAttrs.URI;
									initFrag.rawByteRange = mapAttrs.BYTERANGE;
									initFrag.baseurl = baseurl;
									initFrag.level = id;
									initFrag.type = type;
									initFrag.sn = 'initSegment';
									initFrag.levelkeys = levelkeys;
									level.initSegment = initFrag;
								}
								break;
	
							default:
								_logger.logger.warn('line parsed but not handled: ' + result);
								break;
						}
					}
				}
				frag = prevFrag;
				//logger.log('found ' + level.fragments.length + ' fragments');
				if (frag && !frag.relurl) {
					level.fragments.pop();
					totalduration -= frag.duration;
				}
	
				if (level.fragments.length && !level.fragments[0].pdt) {
					var _i3 = void 0;
	
					//this stream has no pdt, lets make one up
					//should be fine for vods, sliding windows ....
					level.fragments[0].rawProgramDateTime = '1997-08-29T00:00:00+00:00';
					level.fragments[0].pdt = Date.parse(level.fragments[0].rawProgramDateTime);
	
					for (_i3 = 1; _i3 < level.fragments.length; _i3++) {
						level.fragments[_i3].pdt = level.fragments[_i3 - 1].pdt + level.fragments[_i3 - 1].manifestDuration * 1000;
					}
				}
	
				level.totalduration = totalduration;
				level.averagetargetduration = totalduration / level.fragments.length;
				level.endSN = currentSN - 1;
				return level;
			}
		}, {
			key: 'loadsuccess',
			value: function loadsuccess(response, stats, context) {
				var string = response.data;
				var url = response.url;
				var type = context.type;
				var id = context.id;
				var level = context.level;
				var hls = this.hls;
	
				//this.loaders[type] = undefined;
				// responseURL not supported on some browsers (it is used to detect URL redirection)
				// data-uri mode also not supported (but no need to detect redirection)
				if (url === undefined || url.indexOf('data:') === 0) {
					// fallback to initial URL
					url = context.url;
				}
				stats.tload = performance.now();
				//stats.mtime = new Date(target.getResponseHeader('Last-Modified'));
				if (string.indexOf('#EXTM3U') === 0) {
					if (string.indexOf('#EXTINF:') > 0) {
						var isLevel = type !== 'audioTrack' && type !== 'subtitleTrack';
						var levelId = !isNaN(level) ? level : !isNaN(id) ? id : 0; // eslint-disable-line no-nested-ternary
						var levelDetails = this.parseLevelPlaylist(string, url, levelId, type === 'audioTrack' ? 'audio' : type === 'subtitleTrack' ? 'subtitle' : 'main' // eslint-disable-line no-nested-ternary
						);
	
						levelDetails.tload = stats.tload;
						if (type === 'manifest') {
							// first request, stream manifest (no master playlist), fire manifest loaded event with level details
							hls.trigger(_events2.default.MANIFEST_LOADED, { levels: [{ url: url, details: levelDetails }], audioTracks: [], url: url, stats: stats });
						}
						stats.tparsed = performance.now();
						if (levelDetails.targetduration) {
							if (isLevel) {
								hls.trigger(_events2.default.LEVEL_LOADED, { details: levelDetails, level: level || 0, id: id || 0, stats: stats });
							} else {
								if (type === 'audioTrack') {
									hls.trigger(_events2.default.AUDIO_TRACK_LOADED, { details: levelDetails, id: id, stats: stats });
								} else if (type === 'subtitleTrack') {
									hls.trigger(_events2.default.SUBTITLE_TRACK_LOADED, { details: levelDetails, id: id, stats: stats });
								}
							}
						} else {
							hls.trigger(_events2.default.ERROR, {
								type: _errors.ErrorTypes.NETWORK_ERROR,
								details: _errors.ErrorDetails.MANIFEST_PARSING_ERROR,
								fatal: true,
								url: url,
								reason: 'invalid targetduration'
							});
						}
					} else {
						var levels = this.parseMasterPlaylist(string, url);
						// multi level playlist, parse level info
						if (levels.length) {
							/*
	      let audioTracks = this.parseMasterPlaylistMedia(string, url, 'AUDIO');
	      */
							var audioTracks = this.parseMasterPlaylistMediaGrouped(string, url, 'AUDIO'); //Mactrix line changed, add rendition group support to audio tracks
							var subtitles = this.parseMasterPlaylistMedia(string, url, 'SUBTITLES');
	
							if (audioTracks.length) {
								// check if we have found an audio track embedded in main playlist (audio track without URI attribute)
								var embeddedAudioFound = false;
								audioTracks.forEach(function (audioTrack) {
									if (!audioTrack.url) {
										embeddedAudioFound = true;
									}
								});
	
								// if no embedded audio track defined, but audio codec signaled in quality level, we need to signal this main audio track
								// this could happen with playlists with alt audio rendition in which quality levels (main) contains both audio+video. but with mixed audio track not signaled
								if (embeddedAudioFound === false && levels[0].audioCodec && !levels[0].attrs.AUDIO) {
									_logger.logger.log('audio codec signaled in quality level, but no embedded audio track signaled, create one');
									audioTracks.unshift({ type: 'main', name: 'main' });
								}
							}
							hls.trigger(_events2.default.MANIFEST_LOADED, { levels: levels, audioTracks: audioTracks, subtitles: subtitles, url: url, stats: stats });
						} else {
							hls.trigger(_events2.default.ERROR, {
								type: _errors.ErrorTypes.NETWORK_ERROR,
								details: _errors.ErrorDetails.MANIFEST_PARSING_ERROR,
								fatal: true,
								url: url,
								reason: 'no level found in manifest'
							});
						}
					}
				} else {
					hls.trigger(_events2.default.ERROR, {
						type: _errors.ErrorTypes.NETWORK_ERROR,
						details: _errors.ErrorDetails.MANIFEST_PARSING_ERROR,
						fatal: true,
						url: url,
						reason: 'no EXTM3U delimiter'
					});
				}
			}
		}, {
			key: 'loaderror',
			value: function loaderror(response, context) {
				var details = void 0;
				var fatal = void 0;
				var loader = context.loader;
	
				switch (context.type) {
					case 'manifest':
						details = _errors.ErrorDetails.MANIFEST_LOAD_ERROR;
						fatal = true;
						break;
					case 'level':
						details = _errors.ErrorDetails.LEVEL_LOAD_ERROR;
						fatal = false;
						break;
					case 'audioTrack':
						details = _errors.ErrorDetails.AUDIO_TRACK_LOAD_ERROR;
						fatal = false;
						break;
				}
				if (loader) {
					loader.abort();
					//this.loaders[context.type] = undefined;
					this.hls.trigger(_events2.default.ERROR, {
						type: _errors.ErrorTypes.NETWORK_ERROR,
						details: details,
						fatal: fatal,
						url: loader.url,
						loader: loader,
						response: response,
						context: context
					});
				} else {
					this.hls.trigger(_events2.default.ERROR, {
						type: _errors.ErrorTypes.NETWORK_ERROR,
						details: details,
						fatal: fatal,
						response: response,
						context: context
					});
				}
			}
		}, {
			key: 'loadtimeout',
			value: function loadtimeout(stats, context) {
				var details = void 0;
				var fatal = void 0;
				var loader = context.loader;
	
				switch (context.type) {
					case 'manifest':
						details = _errors.ErrorDetails.MANIFEST_LOAD_TIMEOUT;
						fatal = true;
						break;
					case 'level':
						details = _errors.ErrorDetails.LEVEL_LOAD_TIMEOUT;
						fatal = false;
						break;
					case 'audioTrack':
						details = _errors.ErrorDetails.AUDIO_TRACK_LOAD_TIMEOUT;
						fatal = false;
						break;
				}
				if (loader) {
					loader.abort();
					//this.loaders[context.type] = undefined;
					this.hls.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.NETWORK_ERROR, details: details, fatal: fatal, url: loader.url, loader: loader, context: context });
				} else {
					this.hls.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.NETWORK_ERROR, details: details, fatal: fatal, context: context });
				}
			}
		}]);
	
		return PlaylistLoader;
	}(_eventHandler2.default);
	
	exports.default = PlaylistLoader;
	module.exports = exports['default'];

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MAX_SAFE_INTEGER = __webpack_require__(215); //Mactrix line added - max-safe-integer ponyfill
	
	var DECIMAL_RESOLUTION_REGEX = /^(\d+)x(\d+)$/;
	var ATTR_LIST_REGEX = /\s*(.+?)\s*=((?:".*?")|.*?)(?:,|$)/g;
	
	// adapted from https://github.com/kanongil/node-m3u8parse/blob/master/attrlist.js
	
	var AttrList = function () {
		function AttrList(attrs) {
			_classCallCheck(this, AttrList);
	
			var myAttrs = attrs;
	
			if (typeof myAttrs === 'string') {
				myAttrs = AttrList.parseAttrList(myAttrs);
			}
			for (var attr in myAttrs) {
				if (myAttrs.hasOwnProperty(attr)) {
					this[attr] = myAttrs[attr];
				}
			}
		}
	
		_createClass(AttrList, [{
			key: 'decimalInteger',
			value: function decimalInteger(attrName) {
				var intValue = parseInt(this[attrName], 10);
				/* mactrix replace
	   if (intValue > Number.MAX_SAFE_INTEGER) {
	   */
				if (intValue > MAX_SAFE_INTEGER) {
					// Mactrix: SJE: Number.MAX_SAFE_INTEGER is not available on PhantomJS or IE
					return Infinity;
				}
				return intValue;
			}
		}, {
			key: 'hexadecimalInteger',
			value: function hexadecimalInteger(attrName) {
				if (this[attrName]) {
					var stringValue = (this[attrName] || '0x').slice(2);
					stringValue = (stringValue.length & 1 ? '0' : '') + stringValue;
	
					var value = new Uint8Array(stringValue.length / 2);
					for (var i = 0; i < stringValue.length / 2; i++) {
						value[i] = parseInt(stringValue.slice(i * 2, i * 2 + 2), 16);
					}
					return value;
				} else {
					return null;
				}
			}
		}, {
			key: 'hexadecimalIntegerAsNumber',
			value: function hexadecimalIntegerAsNumber(attrName) {
				var intValue = parseInt(this[attrName], 16);
				/* mactrix replace
	   if (intValue > Number.MAX_SAFE_INTEGER) {
	   */
				if (intValue > MAX_SAFE_INTEGER) {
					// Mactrix: SJE
					return Infinity;
				}
				return intValue;
			}
		}, {
			key: 'decimalFloatingPoint',
			value: function decimalFloatingPoint(attrName) {
				return parseFloat(this[attrName]);
			}
		}, {
			key: 'enumeratedString',
			value: function enumeratedString(attrName) {
				return this[attrName];
			}
		}, {
			key: 'decimalResolution',
			value: function decimalResolution(attrName) {
				var res = DECIMAL_RESOLUTION_REGEX.exec(this[attrName]);
				if (res === null) {
					return undefined;
				}
				return {
					width: parseInt(res[1], 10),
					height: parseInt(res[2], 10)
				};
			}
		}], [{
			key: 'parseAttrList',
			value: function parseAttrList(input) {
				var match = void 0;
				var attrs = {};
				var quote = '"';
	
				ATTR_LIST_REGEX.lastIndex = 0;
				while ((match = ATTR_LIST_REGEX.exec(input)) !== null) {
					// eslint-disable-line no-cond-assign
					var value = match[2];
	
					if (value.indexOf(quote) === 0 && value.lastIndexOf(quote) === value.length - 1) {
						value = value.slice(1, -1);
					}
					attrs[match[1]] = value;
				}
	
				return attrs;
			}
		}]);
	
		return AttrList;
	}();
	
	exports.default = AttrList;
	module.exports = exports['default'];

/***/ }),
/* 135 */
/***/ (function(module, exports) {

	"use strict";
	
	var BinarySearch = {
		/**
	  * Searches for an item in an array which matches a certain condition.
	  * This requires the condition to only match one item in the array,
	  * and for the array to be ordered.
	  *
	  * @param {Array} list The array to search.
	  * @param {Function} comparisonFunction
	  *      Called and provided a candidate item as the first argument.
	  *      Should return:
	  *          > -1 if the item should be located at a lower index than the provided item.
	  *          > 1 if the item should be located at a higher index than the provided item.
	  *          > 0 if the item is the item you're looking for.
	  *
	  * @return {*} The object if it is found or null otherwise.
	  */
		search: function search(list, comparisonFunction) {
			var minIndex = 0;
			var maxIndex = list.length - 1;
			var currentIndex = null;
			var currentElement = null;
	
			while (minIndex <= maxIndex) {
				currentIndex = (minIndex + maxIndex) / 2 | 0;
				currentElement = list[currentIndex];
	
				var comparisonResult = comparisonFunction(currentElement);
				if (comparisonResult > 0) {
					minIndex = currentIndex + 1;
				} else if (comparisonResult < 0) {
					maxIndex = currentIndex - 1;
				} else {
					return currentElement;
				}
			}
	
			return null;
		}
	};
	
	module.exports = BinarySearch;

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _logger = __webpack_require__(1);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	//Mactrix line added
	/**
	 *
	 * This code was ported from the dash.js project at:
	 *   https://github.com/Dash-Industry-Forum/dash.js/blob/development/externals/cea608-parser.js
	 *   https://github.com/Dash-Industry-Forum/dash.js/commit/8269b26a761e0853bb21d78780ed945144ecdd4d#diff-71bc295a2d6b6b7093a1d3290d53a4b2
	 *
	 * The original copyright appears below:
	 *
	 * The copyright in this software is being made available under the BSD License,
	 * included below. This software may be subject to other third party and contributor
	 * rights, including patent rights, and no such rights are granted under this license.
	 *
	 * Copyright (c) 2015-2016, DASH Industry Forum.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without modification,
	 * are permitted provided that the following conditions are met:
	 *  1. Redistributions of source code must retain the above copyright notice, this
	 *  list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above copyright notice,
	 *  this list of conditions and the following disclaimer in the documentation and/or
	 *  other materials provided with the distribution.
	 *  2. Neither the name of Dash Industry Forum nor the names of its
	 *  contributors may be used to endorse or promote products derived from this software
	 *  without specific prior written permission.
	 *
	 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
	 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
	 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
	 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
	 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
	 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
	 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
	 *  POSSIBILITY OF SUCH DAMAGE.
	 */
	/**
	 *  Exceptions from regular ASCII. CodePoints are mapped to UTF-16 codes
	 */
	
	var specialCea608CharsCodes = {
		0x2a: 0xe1, // lowercase a, acute accent
		0x5c: 0xe9, // lowercase e, acute accent
		0x5e: 0xed, // lowercase i, acute accent
		0x5f: 0xf3, // lowercase o, acute accent
		0x60: 0xfa, // lowercase u, acute accent
		0x7b: 0xe7, // lowercase c with cedilla
		0x7c: 0xf7, // division symbol
		0x7d: 0xd1, // uppercase N tilde
		0x7e: 0xf1, // lowercase n tilde
		0x7f: 0x2588, // Full block
		// THIS BLOCK INCLUDES THE 16 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
		// THAT COME FROM HI BYTE=0x11 AND LOW BETWEEN 0x30 AND 0x3F
		// THIS MEANS THAT \x50 MUST BE ADDED TO THE VALUES
		0x80: 0xae, // Registered symbol (R)
		0x81: 0xb0, // degree sign
		0x82: 0xbd, // 1/2 symbol
		0x83: 0xbf, // Inverted (open) question mark
		0x84: 0x2122, // Trademark symbol (TM)
		0x85: 0xa2, // Cents symbol
		0x86: 0xa3, // Pounds sterling
		0x87: 0x266a, // Music 8'th note
		0x88: 0xe0, // lowercase a, grave accent
		0x89: 0x20, // transparent space (regular)
		0x8a: 0xe8, // lowercase e, grave accent
		0x8b: 0xe2, // lowercase a, circumflex accent
		0x8c: 0xea, // lowercase e, circumflex accent
		0x8d: 0xee, // lowercase i, circumflex accent
		0x8e: 0xf4, // lowercase o, circumflex accent
		0x8f: 0xfb, // lowercase u, circumflex accent
		// THIS BLOCK INCLUDES THE 32 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
		// THAT COME FROM HI BYTE=0x12 AND LOW BETWEEN 0x20 AND 0x3F
		0x90: 0xc1, // capital letter A with acute
		0x91: 0xc9, // capital letter E with acute
		0x92: 0xd3, // capital letter O with acute
		0x93: 0xda, // capital letter U with acute
		0x94: 0xdc, // capital letter U with diaresis
		0x95: 0xfc, // lowercase letter U with diaeresis
		0x96: 0x2018, // opening single quote
		0x97: 0xa1, // inverted exclamation mark
		0x98: 0x2a, // asterisk
		0x99: 0x2019, // closing single quote
		0x9a: 0x2501, // box drawings heavy horizontal
		0x9b: 0xa9, // copyright sign
		0x9c: 0x2120, // Service mark
		0x9d: 0x2022, // (round) bullet
		0x9e: 0x201c, // Left double quotation mark
		0x9f: 0x201d, // Right double quotation mark
		0xa0: 0xc0, // uppercase A, grave accent
		0xa1: 0xc2, // uppercase A, circumflex
		0xa2: 0xc7, // uppercase C with cedilla
		0xa3: 0xc8, // uppercase E, grave accent
		0xa4: 0xca, // uppercase E, circumflex
		0xa5: 0xcb, // capital letter E with diaresis
		0xa6: 0xeb, // lowercase letter e with diaresis
		0xa7: 0xce, // uppercase I, circumflex
		0xa8: 0xcf, // uppercase I, with diaresis
		0xa9: 0xef, // lowercase i, with diaresis
		0xaa: 0xd4, // uppercase O, circumflex
		0xab: 0xd9, // uppercase U, grave accent
		0xac: 0xf9, // lowercase u, grave accent
		0xad: 0xdb, // uppercase U, circumflex
		0xae: 0xab, // left-pointing double angle quotation mark
		0xaf: 0xbb, // right-pointing double angle quotation mark
		// THIS BLOCK INCLUDES THE 32 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
		// THAT COME FROM HI BYTE=0x13 AND LOW BETWEEN 0x20 AND 0x3F
		0xb0: 0xc3, // Uppercase A, tilde
		0xb1: 0xe3, // Lowercase a, tilde
		0xb2: 0xcd, // Uppercase I, acute accent
		0xb3: 0xcc, // Uppercase I, grave accent
		0xb4: 0xec, // Lowercase i, grave accent
		0xb5: 0xd2, // Uppercase O, grave accent
		0xb6: 0xf2, // Lowercase o, grave accent
		0xb7: 0xd5, // Uppercase O, tilde
		0xb8: 0xf5, // Lowercase o, tilde
		0xb9: 0x7b, // Open curly brace
		0xba: 0x7d, // Closing curly brace
		0xbb: 0x5c, // Backslash
		0xbc: 0x5e, // Caret
		0xbd: 0x5f, // Underscore
		0xbe: 0x7c, // Pipe (vertical line)
		0xbf: 0x223c, // Tilde operator
		0xc0: 0xc4, // Uppercase A, umlaut
		0xc1: 0xe4, // Lowercase A, umlaut
		0xc2: 0xd6, // Uppercase O, umlaut
		0xc3: 0xf6, // Lowercase o, umlaut
		0xc4: 0xdf, // Esszett (sharp S)
		0xc5: 0xa5, // Yen symbol
		0xc6: 0xa4, // Generic currency sign
		0xc7: 0x2503, // Box drawings heavy vertical
		0xc8: 0xc5, // Uppercase A, ring
		0xc9: 0xe5, // Lowercase A, ring
		0xca: 0xd8, // Uppercase O, stroke
		0xcb: 0xf8, // Lowercase o, strok
		0xcc: 0x250f, // Box drawings heavy down and right
		0xcd: 0x2513, // Box drawings heavy down and left
		0xce: 0x2517, // Box drawings heavy up and right
		0xcf: 0x251b // Box drawings heavy up and left
	};
	
	/**
	 * Utils
	 */
	var getCharForByte = function getCharForByte(byte) {
		var charCode = byte;
		if (specialCea608CharsCodes.hasOwnProperty(byte)) {
			charCode = specialCea608CharsCodes[byte];
		}
		return String.fromCharCode(charCode);
	};
	
	var NR_ROWS = 15;
	var NR_COLS = 100;
	// Tables to look up row from PAC data
	var rowsLowCh1 = { 0x11: 1, 0x12: 3, 0x15: 5, 0x16: 7, 0x17: 9, 0x10: 11, 0x13: 12, 0x14: 14 };
	var rowsHighCh1 = { 0x11: 2, 0x12: 4, 0x15: 6, 0x16: 8, 0x17: 10, 0x13: 13, 0x14: 15 };
	var rowsLowCh2 = { 0x19: 1, 0x1A: 3, 0x1D: 5, 0x1E: 7, 0x1F: 9, 0x18: 11, 0x1B: 12, 0x1C: 14 };
	var rowsHighCh2 = { 0x19: 2, 0x1A: 4, 0x1D: 6, 0x1E: 8, 0x1F: 10, 0x1B: 13, 0x1C: 15 };
	
	var backgroundColors = ['white', 'green', 'blue', 'cyan', 'red', 'yellow', 'magenta', 'black', 'transparent'];
	
	/**
	 * Simple logger class to be able to write with time-stamps and filter on level.
	 */
	var logger = {
		verboseFilter: { DATA: 3, DEBUG: 3, INFO: 2, WARNING: 2, TEXT: 1, ERROR: 0 },
		time: null,
		verboseLevel: 0, // Only write errors
		setTime: function setTime(newTime) {
			this.time = newTime;
		},
		log: function log(severity, msg) {
			var minLevel = this.verboseFilter[severity];
			if (this.verboseLevel >= minLevel) {
				/*
	   console.log(this.time + ' [' + severity + '] ' + msg);
	   */
				_logger.logger.log(this.time + ' [' + severity + '] ' + msg); //Mactrix line changed
			}
		}
	};
	
	var numArrayToHexArray = function numArrayToHexArray(numArray) {
		var hexArray = [];
		for (var j = 0; j < numArray.length; j++) {
			hexArray.push(numArray[j].toString(16));
		}
		return hexArray;
	};
	
	var PenState = function () {
		function PenState(foreground, underline, italics, background, flash) {
			_classCallCheck(this, PenState);
	
			this.foreground = foreground || 'white';
			this.underline = underline || false;
			this.italics = italics || false;
			this.background = background || 'black';
			this.flash = flash || false;
		}
	
		_createClass(PenState, [{
			key: 'reset',
			value: function reset() {
				this.foreground = 'white';
				this.underline = false;
				this.italics = false;
				this.background = 'black';
				this.flash = false;
			}
		}, {
			key: 'setStyles',
			value: function setStyles(styles) {
				var attribs = ['foreground', 'underline', 'italics', 'background', 'flash'];
				for (var i = 0; i < attribs.length; i++) {
					var style = attribs[i];
					if (styles.hasOwnProperty(style)) {
						this[style] = styles[style];
					}
				}
			}
		}, {
			key: 'isDefault',
			value: function isDefault() {
				return this.foreground === 'white' && !this.underline && !this.italics && this.background === 'black' && !this.flash;
			}
		}, {
			key: 'equals',
			value: function equals(other) {
				return this.foreground === other.foreground && this.underline === other.underline && this.italics === other.italics && this.background === other.background && this.flash === other.flash;
			}
		}, {
			key: 'copy',
			value: function copy(newPenState) {
				this.foreground = newPenState.foreground;
				this.underline = newPenState.underline;
				this.italics = newPenState.italics;
				this.background = newPenState.background;
				this.flash = newPenState.flash;
			}
		}, {
			key: 'toString',
			value: function toString() {
				return 'color=' + this.foreground + ', underline=' + this.underline + ', italics=' + this.italics + ', background=' + this.background + ', flash=' + this.flash;
			}
		}]);
	
		return PenState;
	}();
	
	/**
	 * Unicode character with styling and background.
	 * @constructor
	 */
	
	
	var StyledUnicodeChar = function () {
		function StyledUnicodeChar(uchar, foreground, underline, italics, background, flash) {
			_classCallCheck(this, StyledUnicodeChar);
	
			this.uchar = uchar || ' '; // unicode character
			this.penState = new PenState(foreground, underline, italics, background, flash);
		}
	
		_createClass(StyledUnicodeChar, [{
			key: 'reset',
			value: function reset() {
				this.uchar = ' ';
				this.penState.reset();
			}
		}, {
			key: 'setChar',
			value: function setChar(uchar, newPenState) {
				this.uchar = uchar;
				this.penState.copy(newPenState);
			}
		}, {
			key: 'setPenState',
			value: function setPenState(newPenState) {
				this.penState.copy(newPenState);
			}
		}, {
			key: 'equals',
			value: function equals(other) {
				return this.uchar === other.uchar && this.penState.equals(other.penState);
			}
		}, {
			key: 'copy',
			value: function copy(newChar) {
				this.uchar = newChar.uchar;
				this.penState.copy(newChar.penState);
			}
		}, {
			key: 'isEmpty',
			value: function isEmpty() {
				return this.uchar === ' ' && this.penState.isDefault();
			}
		}]);
	
		return StyledUnicodeChar;
	}();
	
	/**
	 * CEA-608 row consisting of NR_COLS instances of StyledUnicodeChar.
	 * @constructor
	 */
	
	
	var Row = function () {
		function Row() {
			_classCallCheck(this, Row);
	
			this.chars = [];
			for (var i = 0; i < NR_COLS; i++) {
				this.chars.push(new StyledUnicodeChar());
			}
			this.pos = 0;
			this.currPenState = new PenState();
		}
	
		_createClass(Row, [{
			key: 'equals',
			value: function equals(other) {
				var equal = true;
				for (var i = 0; i < NR_COLS; i++) {
					if (!this.chars[i].equals(other.chars[i])) {
						equal = false;
						break;
					}
				}
				return equal;
			}
		}, {
			key: 'copy',
			value: function copy(other) {
				for (var i = 0; i < NR_COLS; i++) {
					this.chars[i].copy(other.chars[i]);
				}
			}
		}, {
			key: 'isEmpty',
			value: function isEmpty() {
				var empty = true;
				for (var i = 0; i < NR_COLS; i++) {
					if (!this.chars[i].isEmpty()) {
						empty = false;
						break;
					}
				}
				return empty;
			}
	
			/**
	   *  Set the cursor to a valid column.
	   */
	
		}, {
			key: 'setCursor',
			value: function setCursor(absPos) {
				if (this.pos !== absPos) {
					this.pos = absPos;
				}
				/*
	   		if (this.pos < 0) {
	   			logger.log('ERROR', 'Negative cursor position ' + this.pos);
	   			this.pos = 0;
	   		} else if (this.pos > NR_COLS) {
	   			logger.log('ERROR', 'Too large cursor position ' + this.pos);
	   			this.pos = NR_COLS;
	   		}
	   */
				//Mactrix changes start
				if (this.pos < 0) {
					logger.log('WARN', 'Negative cursor position ' + this.pos);
					this.pos = 0;
				} else if (this.pos > NR_COLS) {
					logger.log('WARN', 'Too large cursor position ' + this.pos);
					this.pos = NR_COLS;
				}
				//Mactrix changes end
			}
	
			/**
	   * Move the cursor relative to current position.
	   */
	
		}, {
			key: 'moveCursor',
			value: function moveCursor(relPos) {
				var newPos = this.pos + relPos;
				if (relPos > 1) {
					for (var i = this.pos + 1; i < newPos + 1; i++) {
						/*
	     this.chars[i].setPenState(this.currPenState);
	     */
						//Mactrix changes start
						var currChar = this.chars[i];
						if (currChar !== undefined && currChar !== null) {
							currChar.setPenState(this.currPenState);
						} else {
							logger.log('WARN', 'Cannnot set PenState; char ' + currChar);
						}
						//Mactrix changes end
					}
				}
				this.setCursor(newPos);
			}
	
			/**
	   * Backspace, move one step back and clear character.
	   */
	
		}, {
			key: 'backSpace',
			value: function backSpace() {
				this.moveCursor(-1);
				this.chars[this.pos].setChar(' ', this.currPenState);
			}
		}, {
			key: 'insertChar',
			value: function insertChar(byte) {
				if (byte >= 0x90) {
					//Extended char
					this.backSpace();
				}
				var char = getCharForByte(byte);
				if (this.pos >= NR_COLS) {
					/*
	    			logger.log('ERROR', 'Cannot insert ' + byte.toString(16) +
	    						' (' + char + ') at position ' + this.pos + '. Skipping it!');
	    */
					//Mactrix changes start
					logger.log('WARN', 'Cannot insert ' + byte.toString(16) + ' (' + char + ') at position ' + this.pos + '. Skipping it!');
					//Mactrix changes end
					return;
				}
				this.chars[this.pos].setChar(char, this.currPenState);
				this.moveCursor(1);
			}
		}, {
			key: 'clearFromPos',
			value: function clearFromPos(startPos) {
				var i;
				for (i = startPos; i < NR_COLS; i++) {
					this.chars[i].reset();
				}
			}
		}, {
			key: 'clear',
			value: function clear() {
				this.clearFromPos(0);
				this.pos = 0;
				this.currPenState.reset();
			}
		}, {
			key: 'clearToEndOfRow',
			value: function clearToEndOfRow() {
				this.clearFromPos(this.pos);
			}
		}, {
			key: 'getTextString',
			value: function getTextString() {
				var chars = [];
				var empty = true;
				for (var i = 0; i < NR_COLS; i++) {
					var char = this.chars[i].uchar;
					if (char !== ' ') {
						empty = false;
					}
					chars.push(char);
				}
				if (empty) {
					return '';
				} else {
					return chars.join('');
				}
			}
		}, {
			key: 'setPenStyles',
			value: function setPenStyles(styles) {
				this.currPenState.setStyles(styles);
				var currChar = this.chars[this.pos];
				/*
	   currChar.setPenState(this.currPenState);
	   */
				//Mactrix changes start
				if (currChar !== undefined && currChar !== null) {
					currChar.setPenState(this.currPenState);
				} else {
					logger.log('ERROR', 'Cannnot set PenState; char ' + currChar);
				}
				//Mactrix changes end
			}
		}]);
	
		return Row;
	}();
	
	/**
	 * Keep a CEA-608 screen of 32x15 styled characters
	 * @constructor
	*/
	
	
	var CaptionScreen = function () {
		function CaptionScreen() {
			_classCallCheck(this, CaptionScreen);
	
			this.rows = [];
			for (var i = 0; i < NR_ROWS; i++) {
				this.rows.push(new Row()); // Note that we use zero-based numbering (0-14)
			}
			this.currRow = NR_ROWS - 1;
			this.nrRollUpRows = null;
			this.reset();
		}
	
		_createClass(CaptionScreen, [{
			key: 'reset',
			value: function reset() {
				for (var i = 0; i < NR_ROWS; i++) {
					this.rows[i].clear();
				}
				this.currRow = NR_ROWS - 1;
			}
		}, {
			key: 'equals',
			value: function equals(other) {
				var equal = true;
				for (var i = 0; i < NR_ROWS; i++) {
					if (!this.rows[i].equals(other.rows[i])) {
						equal = false;
						break;
					}
				}
				return equal;
			}
		}, {
			key: 'copy',
			value: function copy(other) {
				for (var i = 0; i < NR_ROWS; i++) {
					this.rows[i].copy(other.rows[i]);
				}
			}
		}, {
			key: 'isEmpty',
			value: function isEmpty() {
				var empty = true;
				for (var i = 0; i < NR_ROWS; i++) {
					if (!this.rows[i].isEmpty()) {
						empty = false;
						break;
					}
				}
				return empty;
			}
		}, {
			key: 'backSpace',
			value: function backSpace() {
				var row = this.rows[this.currRow];
				row.backSpace();
			}
		}, {
			key: 'clearToEndOfRow',
			value: function clearToEndOfRow() {
				var row = this.rows[this.currRow];
				row.clearToEndOfRow();
			}
	
			/**
	   * Insert a character (without styling) in the current row.
	   */
	
		}, {
			key: 'insertChar',
			value: function insertChar(char) {
				var row = this.rows[this.currRow];
				row.insertChar(char);
			}
		}, {
			key: 'setPen',
			value: function setPen(styles) {
				var row = this.rows[this.currRow];
				row.setPenStyles(styles);
			}
		}, {
			key: 'moveCursor',
			value: function moveCursor(relPos) {
				var row = this.rows[this.currRow];
				row.moveCursor(relPos);
			}
		}, {
			key: 'setCursor',
			value: function setCursor(absPos) {
				logger.log('INFO', 'setCursor: ' + absPos);
				var row = this.rows[this.currRow];
				row.setCursor(absPos);
			}
		}, {
			key: 'setPAC',
			value: function setPAC(pacData) {
				logger.log('INFO', 'pacData = ' + JSON.stringify(pacData));
				var newRow = pacData.row - 1;
				if (this.nrRollUpRows && newRow < this.nrRollUpRows - 1) {
					newRow = this.nrRollUpRows - 1;
				}
	
				//Make sure this only affects Roll-up Captions by checking this.nrRollUpRows
				if (this.nrRollUpRows && this.currRow !== newRow) {
					//clear all rows first
					for (var i = 0; i < NR_ROWS; i++) {
						this.rows[i].clear();
					}
	
					//Copy this.nrRollUpRows rows from lastOutputScreen and place it in the newRow location
					//topRowIndex - the start of rows to copy (inclusive index)
					var topRowIndex = this.currRow + 1 - this.nrRollUpRows;
					//We only copy if the last position was already shown.
					//We use the cueStartTime value to check this.
					var lastOutputScreen = this.lastOutputScreen;
					if (lastOutputScreen) {
						var prevLineTime = lastOutputScreen.rows[topRowIndex].cueStartTime;
						if (prevLineTime && prevLineTime < logger.time) {
							for (var _i = 0; _i < this.nrRollUpRows; _i++) {
								this.rows[newRow - this.nrRollUpRows + _i + 1].copy(lastOutputScreen.rows[topRowIndex + _i]);
							}
						}
					}
				}
	
				this.currRow = newRow;
				var row = this.rows[this.currRow];
				if (pacData.indent !== null) {
					var indent = pacData.indent;
					var prevPos = Math.max(indent - 1, 0);
					row.setCursor(pacData.indent);
					pacData.color = row.chars[prevPos].penState.foreground;
				}
				var styles = { foreground: pacData.color, underline: pacData.underline, italics: pacData.italics, background: 'black', flash: false };
				this.setPen(styles);
			}
	
			/**
	   * Set background/extra foreground, but first do back_space, and then insert space (backwards compatibility).
	   */
	
		}, {
			key: 'setBkgData',
			value: function setBkgData(bkgData) {
	
				logger.log('INFO', 'bkgData = ' + JSON.stringify(bkgData));
				this.backSpace();
				this.setPen(bkgData);
				this.insertChar(0x20); //Space
			}
		}, {
			key: 'setRollUpRows',
			value: function setRollUpRows(nrRows) {
				this.nrRollUpRows = nrRows;
			}
		}, {
			key: 'rollUp',
			value: function rollUp() {
				if (this.nrRollUpRows === null) {
					logger.log('DEBUG', 'roll_up but nrRollUpRows not set yet');
					return; //Not properly setup
				}
				logger.log('TEXT', this.getDisplayText());
				var topRowIndex = this.currRow + 1 - this.nrRollUpRows;
				var topRow = this.rows.splice(topRowIndex, 1)[0];
				topRow.clear();
				this.rows.splice(this.currRow, 0, topRow);
				logger.log('INFO', 'Rolling up');
				//logger.log('TEXT', this.get_display_text())
			}
	
			/**
	  * Get all non-empty rows with as unicode text.
	  */
	
		}, {
			key: 'getDisplayText',
			value: function getDisplayText(asOneRow) {
				var myAsOneRow = asOneRow || false;
				var displayText = [];
				var text = '';
				var rowNr = -1;
				for (var i = 0; i < NR_ROWS; i++) {
					var rowText = this.rows[i].getTextString();
					if (rowText) {
						rowNr = i + 1;
						if (myAsOneRow) {
							displayText.push('Row ' + rowNr + ': \'' + rowText + '\'');
						} else {
							displayText.push(rowText.trim());
						}
					}
				}
				if (displayText.length > 0) {
					if (myAsOneRow) {
						text = '[' + displayText.join(' | ') + ']';
					} else {
						text = displayText.join('\n');
					}
				}
				return text;
			}
		}, {
			key: 'getTextAndFormat',
			value: function getTextAndFormat() {
				return this.rows;
			}
		}]);
	
		return CaptionScreen;
	}();
	
	//var modes = ['MODE_ROLL-UP', 'MODE_POP-ON', 'MODE_PAINT-ON', 'MODE_TEXT'];
	
	var Cea608Channel = function () {
		function Cea608Channel(channelNumber, outputFilter) {
			_classCallCheck(this, Cea608Channel);
	
			this.chNr = channelNumber;
			this.outputFilter = outputFilter;
			this.mode = null;
			this.verbose = 0;
			this.displayedMemory = new CaptionScreen();
			this.nonDisplayedMemory = new CaptionScreen();
			this.lastOutputScreen = new CaptionScreen();
			this.currRollUpRow = this.displayedMemory.rows[NR_ROWS - 1];
			this.writeScreen = this.displayedMemory;
			this.mode = null;
			this.cueStartTime = null; // Keeps track of where a cue started.
		}
	
		_createClass(Cea608Channel, [{
			key: 'reset',
			value: function reset() {
				this.mode = null;
				this.displayedMemory.reset();
				this.nonDisplayedMemory.reset();
				this.lastOutputScreen.reset();
				this.currRollUpRow = this.displayedMemory.rows[NR_ROWS - 1];
				this.writeScreen = this.displayedMemory;
				this.mode = null;
				this.cueStartTime = null;
				this.lastCueEndTime = null;
			}
		}, {
			key: 'getHandler',
			value: function getHandler() {
				return this.outputFilter;
			}
		}, {
			key: 'setHandler',
			value: function setHandler(newHandler) {
				this.outputFilter = newHandler;
			}
		}, {
			key: 'setPAC',
			value: function setPAC(pacData) {
				this.writeScreen.setPAC(pacData);
			}
		}, {
			key: 'setBkgData',
			value: function setBkgData(bkgData) {
				this.writeScreen.setBkgData(bkgData);
			}
		}, {
			key: 'setMode',
			value: function setMode(newMode) {
				if (newMode === this.mode) {
					return;
				}
				this.mode = newMode;
				logger.log('INFO', 'MODE=' + newMode);
				if (this.mode === 'MODE_POP-ON') {
					this.writeScreen = this.nonDisplayedMemory;
				} else {
					this.writeScreen = this.displayedMemory;
					this.writeScreen.reset();
				}
				if (this.mode !== 'MODE_ROLL-UP') {
					this.displayedMemory.nrRollUpRows = null;
					this.nonDisplayedMemory.nrRollUpRows = null;
				}
				this.mode = newMode;
			}
		}, {
			key: 'insertChars',
			value: function insertChars(chars) {
				for (var i = 0; i < chars.length; i++) {
					this.writeScreen.insertChar(chars[i]);
				}
				var screen = this.writeScreen === this.displayedMemory ? 'DISP' : 'NON_DISP';
				logger.log('INFO', screen + ': ' + this.writeScreen.getDisplayText(true));
				if (this.mode === 'MODE_PAINT-ON' || this.mode === 'MODE_ROLL-UP') {
					logger.log('TEXT', 'DISPLAYED: ' + this.displayedMemory.getDisplayText(true));
					this.outputDataUpdate();
				}
			}
		}, {
			key: 'ccRCL',
			value: function ccRCL() {
				// Resume Caption Loading (switch mode to Pop On)
				logger.log('INFO', 'RCL - Resume Caption Loading');
				this.setMode('MODE_POP-ON');
			}
		}, {
			key: 'ccBS',
			value: function ccBS() {
				// BackSpace
				logger.log('INFO', 'BS - BackSpace');
				if (this.mode === 'MODE_TEXT') {
					return;
				}
				this.writeScreen.backSpace();
				if (this.writeScreen === this.displayedMemory) {
					this.outputDataUpdate();
				}
			}
		}, {
			key: 'ccAOF',
			value: function ccAOF() {
				// Reserved (formerly Alarm Off)
				return;
			}
		}, {
			key: 'ccAON',
			value: function ccAON() {
				// Reserved (formerly Alarm On)
				return;
			}
		}, {
			key: 'ccDER',
			value: function ccDER() {
				// Delete to End of Row
				logger.log('INFO', 'DER- Delete to End of Row');
				this.writeScreen.clearToEndOfRow();
				this.outputDataUpdate();
			}
		}, {
			key: 'ccRU',
			value: function ccRU(nrRows) {
				//Roll-Up Captions-2,3,or 4 Rows
				logger.log('INFO', 'RU(' + nrRows + ') - Roll Up');
				this.writeScreen = this.displayedMemory;
				this.setMode('MODE_ROLL-UP');
				this.writeScreen.setRollUpRows(nrRows);
			}
		}, {
			key: 'ccFON',
			value: function ccFON() {
				//Flash On
				logger.log('INFO', 'FON - Flash On');
				this.writeScreen.setPen({ flash: true });
			}
		}, {
			key: 'ccRDC',
			value: function ccRDC() {
				// Resume Direct Captioning (switch mode to PaintOn)
				logger.log('INFO', 'RDC - Resume Direct Captioning');
				this.setMode('MODE_PAINT-ON');
			}
		}, {
			key: 'ccTR',
			value: function ccTR() {
				// Text Restart in text mode (not supported, however)
				logger.log('INFO', 'TR');
				this.setMode('MODE_TEXT');
			}
		}, {
			key: 'ccRTD',
			value: function ccRTD() {
				// Resume Text Display in Text mode (not supported, however)
				logger.log('INFO', 'RTD');
				this.setMode('MODE_TEXT');
			}
		}, {
			key: 'ccEDM',
			value: function ccEDM() {
				// Erase Displayed Memory
				logger.log('INFO', 'EDM - Erase Displayed Memory');
				this.displayedMemory.reset();
				this.outputDataUpdate();
			}
		}, {
			key: 'ccCR',
			value: function ccCR() {
				// Carriage Return
				logger.log('CR - Carriage Return');
				this.writeScreen.rollUp();
				this.outputDataUpdate();
			}
		}, {
			key: 'ccENM',
			value: function ccENM() {
				//Erase Non-Displayed Memory
				logger.log('INFO', 'ENM - Erase Non-displayed Memory');
				this.nonDisplayedMemory.reset();
			}
		}, {
			key: 'ccEOC',
			value: function ccEOC() {
				//End of Caption (Flip Memories)
				logger.log('INFO', 'EOC - End Of Caption');
				if (this.mode === 'MODE_POP-ON') {
					var tmp = this.displayedMemory;
					this.displayedMemory = this.nonDisplayedMemory;
					this.nonDisplayedMemory = tmp;
					this.writeScreen = this.nonDisplayedMemory;
					logger.log('TEXT', 'DISP: ' + this.displayedMemory.getDisplayText());
				}
				this.outputDataUpdate();
			}
		}, {
			key: 'ccTO',
			value: function ccTO(nrCols) {
				// Tab Offset 1,2, or 3 columns
				logger.log('INFO', 'TO(' + nrCols + ') - Tab Offset');
				this.writeScreen.moveCursor(nrCols);
			}
		}, {
			key: 'ccMIDROW',
			value: function ccMIDROW(secondByte) {
				// Parse MIDROW command
				var styles = { flash: false };
				styles.underline = secondByte % 2 === 1;
				styles.italics = secondByte >= 0x2e;
				if (!styles.italics) {
					var colorIndex = Math.floor(secondByte / 2) - 0x10;
					var colors = ['white', 'green', 'blue', 'cyan', 'red', 'yellow', 'magenta'];
					styles.foreground = colors[colorIndex];
				} else {
					styles.foreground = 'white';
				}
				logger.log('INFO', 'MIDROW: ' + JSON.stringify(styles));
				this.writeScreen.setPen(styles);
			}
		}, {
			key: 'outputDataUpdate',
			value: function outputDataUpdate() {
				var t = logger.time;
				if (t === null) {
					return;
				}
				if (this.outputFilter) {
					if (this.outputFilter.updateData) {
						this.outputFilter.updateData(t, this.displayedMemory);
					}
					if (this.cueStartTime === null && !this.displayedMemory.isEmpty()) {
						// Start of a new cue
						this.cueStartTime = t;
					} else {
						if (!this.displayedMemory.equals(this.lastOutputScreen)) {
							if (this.outputFilter.newCue) {
								this.outputFilter.newCue(this.cueStartTime, t, this.lastOutputScreen);
							}
							this.cueStartTime = this.displayedMemory.isEmpty() ? null : t;
						}
					}
					this.lastOutputScreen.copy(this.displayedMemory);
				}
			}
		}, {
			key: 'cueSplitAtTime',
			value: function cueSplitAtTime(t) {
				if (this.outputFilter) {
					if (!this.displayedMemory.isEmpty()) {
						if (this.outputFilter.newCue) {
							this.outputFilter.newCue(this.cueStartTime, t, this.displayedMemory);
						}
						this.cueStartTime = t;
					}
				}
			}
		}]);
	
		return Cea608Channel;
	}();
	
	var Cea608Parser = function () {
		function Cea608Parser(field, out1, out2) {
			_classCallCheck(this, Cea608Parser);
	
			this.field = field || 1;
			this.outputs = [out1, out2];
			this.channels = [new Cea608Channel(1, out1), new Cea608Channel(2, out2)];
			this.currChNr = -1; // Will be 1 or 2
			this.lastCmdA = null; // First byte of last command
			this.lastCmdB = null; // Second byte of last command
			this.bufferedData = [];
			this.startTime = null;
			this.lastTime = null;
			this.dataCounters = { padding: 0, char: 0, cmd: 0, other: 0 };
		}
	
		_createClass(Cea608Parser, [{
			key: 'getHandler',
			value: function getHandler(index) {
				return this.channels[index].getHandler();
			}
		}, {
			key: 'setHandler',
			value: function setHandler(index, newHandler) {
				this.channels[index].setHandler(newHandler);
			}
	
			/**
	   * Add data for time t in forms of list of bytes (unsigned ints). The bytes are treated as pairs.
	   */
	
		}, {
			key: 'addData',
			value: function addData(t, byteList) {
				try {
					//Mactrix line added - need a try/catch - tabbing wonky so we don't stuff up the embedded code.
					var cmdFound = void 0;
					var a = void 0;
					var b = void 0;
					var charsFound = false;
	
					this.lastTime = t;
					logger.setTime(t);
	
					for (var i = 0; i < byteList.length; i += 2) {
						a = byteList[i] & 0x7f;
						b = byteList[i + 1] & 0x7f;
						if (a === 0 && b === 0) {
							this.dataCounters.padding += 2;
							continue;
						} else {
							logger.log('DATA', '[' + numArrayToHexArray([byteList[i], byteList[i + 1]]) + '] -> (' + numArrayToHexArray([a, b]) + ')');
						}
						cmdFound = this.parseCmd(a, b);
						if (!cmdFound) {
							cmdFound = this.parseMidrow(a, b);
						}
						if (!cmdFound) {
							cmdFound = this.parsePAC(a, b);
						}
						if (!cmdFound) {
							cmdFound = this.parseBackgroundAttributes(a, b);
						}
						if (!cmdFound) {
							charsFound = this.parseChars(a, b);
							if (charsFound) {
								if (this.currChNr && this.currChNr >= 0) {
									var channel = this.channels[this.currChNr - 1];
									channel.insertChars(charsFound);
								} else {
									logger.log('WARNING', 'No channel found yet. TEXT-MODE?');
								}
							}
						}
						if (cmdFound) {
							this.dataCounters.cmd += 2;
						} else if (charsFound) {
							this.dataCounters.char += 2;
						} else {
							this.dataCounters.other += 2;
							logger.log('WARNING', 'Couldn\'t parse cleaned data ' + numArrayToHexArray([a, b]) + ' orig: ' + numArrayToHexArray([byteList[i], byteList[i + 1]]));
						}
					}
					//Mactrix additions begin
					// NOTE: we added the try/catch without affecting the tabbing upstairs. so the tabbing is wonky.
					//swallow syntax errors
				} catch (err) {
					if (err.message === 'SyntaxError') {
						logger.log('WARNING', 'Syntax error while parsing');
					} else {
						throw err;
					}
				}
				//Mactrix additions end
			}
	
			/**
	   * Parse Command.
	   * @returns {Boolean} Tells if a command was found
	   */
	
		}, {
			key: 'parseCmd',
			value: function parseCmd(a, b) {
				var chNr = null;
	
				var cond1 = (a === 0x14 || a === 0x1C) && b >= 0x20 && b <= 0x2F;
				var cond2 = (a === 0x17 || a === 0x1F) && b >= 0x21 && b <= 0x23;
				if (!(cond1 || cond2)) {
					return false;
				}
	
				if (a === this.lastCmdA && b === this.lastCmdB) {
					this.lastCmdA = null;
					this.lastCmdB = null; // Repeated commands are dropped (once)
					logger.log('DEBUG', 'Repeated command (' + numArrayToHexArray([a, b]) + ') is dropped');
					return true;
				}
	
				if (a === 0x14 || a === 0x17) {
					chNr = 1;
				} else {
					chNr = 2; // (a === 0x1C || a=== 0x1f)
				}
	
				var channel = this.channels[chNr - 1];
	
				if (a === 0x14 || a === 0x1C) {
					if (b === 0x20) {
						channel.ccRCL();
					} else if (b === 0x21) {
						channel.ccBS();
					} else if (b === 0x22) {
						channel.ccAOF();
					} else if (b === 0x23) {
						channel.ccAON();
					} else if (b === 0x24) {
						channel.ccDER();
					} else if (b === 0x25) {
						channel.ccRU(2);
					} else if (b === 0x26) {
						channel.ccRU(3);
					} else if (b === 0x27) {
						channel.ccRU(4);
					} else if (b === 0x28) {
						channel.ccFON();
					} else if (b === 0x29) {
						channel.ccRDC();
					} else if (b === 0x2A) {
						channel.ccTR();
					} else if (b === 0x2B) {
						channel.ccRTD();
					} else if (b === 0x2C) {
						channel.ccEDM();
					} else if (b === 0x2D) {
						channel.ccCR();
					} else if (b === 0x2E) {
						channel.ccENM();
					} else if (b === 0x2F) {
						channel.ccEOC();
					}
				} else {
					//a == 0x17 || a == 0x1F
					channel.ccTO(b - 0x20);
				}
				this.lastCmdA = a;
				this.lastCmdB = b;
				this.currChNr = chNr;
				return true;
			}
	
			/**
	   * Parse midrow styling command
	   * @returns {Boolean}
	   */
	
		}, {
			key: 'parseMidrow',
			value: function parseMidrow(a, b) {
				var chNr = null;
	
				if ((a === 0x11 || a === 0x19) && b >= 0x20 && b <= 0x2f) {
					if (a === 0x11) {
						chNr = 1;
					} else {
						chNr = 2;
					}
					if (chNr !== this.currChNr) {
						logger.log('ERROR', 'Mismatch channel in midrow parsing');
						return false;
					}
					var channel = this.channels[chNr - 1];
					channel.ccMIDROW(b);
					logger.log('DEBUG', 'MIDROW (' + numArrayToHexArray([a, b]) + ')');
					return true;
				}
				return false;
			}
			/**
	   * Parse Preable Access Codes (Table 53).
	   * @returns {Boolean} Tells if PAC found
	   */
	
		}, {
			key: 'parsePAC',
			value: function parsePAC(a, b) {
	
				var chNr = null;
				var row = null;
	
				var case1 = (a >= 0x11 && a <= 0x17 || a >= 0x19 && a <= 0x1F) && b >= 0x40 && b <= 0x7F;
				var case2 = (a === 0x10 || a === 0x18) && b >= 0x40 && b <= 0x5F;
				if (!(case1 || case2)) {
					return false;
				}
	
				if (a === this.lastCmdA && b === this.lastCmdB) {
					this.lastCmdA = null;
					this.lastCmdB = null;
					return true; // Repeated commands are dropped (once)
				}
	
				chNr = a <= 0x17 ? 1 : 2;
	
				if (b >= 0x40 && b <= 0x5F) {
					row = chNr === 1 ? rowsLowCh1[a] : rowsLowCh2[a];
				} else {
					// 0x60 <= b <= 0x7F
					row = chNr === 1 ? rowsHighCh1[a] : rowsHighCh2[a];
				}
				var pacData = this.interpretPAC(row, b);
				var channel = this.channels[chNr - 1];
				channel.setPAC(pacData);
				this.lastCmdA = a;
				this.lastCmdB = b;
				this.currChNr = chNr;
				return true;
			}
	
			/**
	   * Interpret the second byte of the pac, and return the information.
	   * @returns {Object} pacData with style parameters.
	   */
	
		}, {
			key: 'interpretPAC',
			value: function interpretPAC(row, byte) {
				var pacIndex = byte;
				var pacData = { color: null, italics: false, indent: null, underline: false, row: row };
	
				if (byte > 0x5F) {
					pacIndex = byte - 0x60;
				} else {
					pacIndex = byte - 0x40;
				}
				pacData.underline = (pacIndex & 1) === 1;
				if (pacIndex <= 0xd) {
					pacData.color = ['white', 'green', 'blue', 'cyan', 'red', 'yellow', 'magenta', 'white'][Math.floor(pacIndex / 2)];
				} else if (pacIndex <= 0xf) {
					pacData.italics = true;
					pacData.color = 'white';
				} else {
					pacData.indent = Math.floor((pacIndex - 0x10) / 2) * 4;
				}
				return pacData; // Note that row has zero offset. The spec uses 1.
			}
	
			/**
	   * Parse characters.
	   * @returns An array with 1 to 2 codes corresponding to chars, if found. null otherwise.
	   */
	
		}, {
			key: 'parseChars',
			value: function parseChars(a, b) {
	
				var channelNr = null;
				var charCodes = null;
				var charCode1 = null;
	
				if (a >= 0x19) {
					channelNr = 2;
					charCode1 = a - 8;
				} else {
					channelNr = 1;
					charCode1 = a;
				}
				if (charCode1 >= 0x11 && charCode1 <= 0x13) {
					// Special character
					var oneCode = b;
					if (charCode1 === 0x11) {
						oneCode = b + 0x50;
					} else if (charCode1 === 0x12) {
						oneCode = b + 0x70;
					} else {
						oneCode = b + 0x90;
					}
					logger.log('INFO', 'Special char \'' + getCharForByte(oneCode) + '\' in channel ' + channelNr);
					charCodes = [oneCode];
				} else if (a >= 0x20 && a <= 0x7f) {
					charCodes = b === 0 ? [a] : [a, b];
				}
				if (charCodes) {
					var hexCodes = numArrayToHexArray(charCodes);
					logger.log('DEBUG', 'Char codes =  ' + hexCodes.join(','));
					this.lastCmdA = null;
					this.lastCmdB = null;
				}
				return charCodes;
			}
	
			/**
	  * Parse extended background attributes as well as new foreground color black.
	  * @returns{Boolean} Tells if background attributes are found
	  */
	
		}, {
			key: 'parseBackgroundAttributes',
			value: function parseBackgroundAttributes(a, b) {
				var bkgData = void 0;
				var index = void 0;
				var chNr = void 0;
				var channel = void 0;
	
				var case1 = (a === 0x10 || a === 0x18) && b >= 0x20 && b <= 0x2f;
				var case2 = (a === 0x17 || a === 0x1f) && b >= 0x2d && b <= 0x2f;
				if (!(case1 || case2)) {
					return false;
				}
				bkgData = {};
				if (a === 0x10 || a === 0x18) {
					index = Math.floor((b - 0x20) / 2);
					bkgData.background = backgroundColors[index];
					if (b % 2 === 1) {
						bkgData.background = bkgData.background + '_semi';
					}
				} else if (b === 0x2d) {
					bkgData.background = 'transparent';
				} else {
					bkgData.foreground = 'black';
					if (b === 0x2f) {
						bkgData.underline = true;
					}
				}
				chNr = a < 0x18 ? 1 : 2;
				channel = this.channels[chNr - 1];
				channel.setBkgData(bkgData);
				this.lastCmdA = null;
				this.lastCmdB = null;
				return true;
			}
	
			/**
	   * Reset state of parser and its channels.
	   */
	
		}, {
			key: 'reset',
			value: function reset() {
				for (var i = 0; i < this.channels.length; i++) {
					if (this.channels[i]) {
						this.channels[i].reset();
					}
				}
				this.lastCmdA = null;
				this.lastCmdB = null;
			}
	
			/**
	   * Trigger the generation of a cue, and the start of a new one if displayScreens are not empty.
	   */
	
		}, {
			key: 'cueSplitAtTime',
			value: function cueSplitAtTime(t) {
				for (var i = 0; i < this.channels.length; i++) {
					if (this.channels[i]) {
						this.channels[i].cueSplitAtTime(t);
					}
				}
			}
		}]);
	
		return Cea608Parser;
	}();
	
	exports.default = Cea608Parser;
	module.exports = exports['default'];

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vttparser = __webpack_require__(73);
	
	var _detectBrowser = __webpack_require__(47);
	
	var _detectBrowser2 = _interopRequireDefault(_detectBrowser);
	
	var _semver = __webpack_require__(99);
	
	var _semver2 = _interopRequireDefault(_semver);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Cues = {
	
		newCue: function newCue(track, startTime, endTime, captionScreen) {
			var myEndTime = endTime;
			var row;
			var cue;
			var indenting;
			var indent;
			var text;
			var VTTCue = window.VTTCue || window.TextTrackCue;
			var browDetected = _detectBrowser2.default; //Mactrix line added, improved browser detection --Ideally we'd pass this in; I'll try to improve this later - SIEG
	
			for (var r = 0; r < captionScreen.rows.length; r++) {
				row = captionScreen.rows[r];
				indenting = true;
				indent = 0;
				text = '';
	
				if (!row.isEmpty()) {
					for (var c = 0; c < row.chars.length; c++) {
						if (row.chars[c].uchar.match(/\s/) && indenting) {
							indent++;
						} else {
							text += row.chars[c].uchar;
							indenting = false;
						}
					}
					//To be used for cleaning-up orphaned roll-up captions
					row.cueStartTime = startTime;
	
					// Give a slight bump to the myEndTime if it's equal to startTime to avoid a SyntaxError in IE
					if (startTime === myEndTime) {
						myEndTime += 0.0001;
					}
	
					//Mactrix changes begin: new VTTCue can throw, for example, startTime is NaN
					try {
						//Mactrix changes end
						cue = new VTTCue(startTime, myEndTime, (0, _vttparser.fixLineBreaks)(text.trim()));
	
						if (indent >= 16) {
							indent--;
						} else {
							indent++;
						}
	
						// VTTCue.line get's flakey when using controls, so let's now include line 13&14
						// also, drop line 1 since it's to close to the top
						if (browDetected.name === 'firefox') {
							cue.line = r + 1;
						} else {
							cue.line = r > 7 ? r - 2 : r + 1;
						}
						/*
	     cue.align = 'left';
	     */
						//Mactrix changes start
						//this line throws a syntax error in Tizen 2.3
						if (browDetected.name !== 'tizen' || !_semver2.default.satisfies(browDetected.version, '2.x.x')) {
							cue.align = 'left';
	
							// Clamp the position between 0 and 100 - if out of these bounds, Firefox throws an exception and captions break
							//Tizen 2.3 doesn't seem to like this either, captions get bunched up on the left side of the video with this enabled
							cue.position = Math.max(0, Math.min(100, 100 * (indent / 32) + (browDetected.name === 'firefox' ? 50 : 0)));
						}
					} catch (err) {}
					//logger.warn(err + ' StartTime: ' + startTime + ', EndTime: ' + myEndTime);
	
					//Mactrix changes end
	
					/* mactrix replace
	    		track.addCue(cue);
	    */
					try {
						track.addCue(cue); //Mactrix above line changed, added try/catch
					} catch (err) {}
				}
			}
		}
	
	};
	
	module.exports = Cues;

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * EWMA Bandwidth Estimator
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  - heavily inspired from shaka-player
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Tracks bandwidth samples and estimates available bandwidth.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Based on the minimum of two exponentially-weighted moving averages with
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * different half-lives.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	var _ewma = __webpack_require__(139);
	
	var _ewma2 = _interopRequireDefault(_ewma);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EwmaBandWidthEstimator = function () {
		function EwmaBandWidthEstimator(hls, slow, fast, defaultEstimate) {
			_classCallCheck(this, EwmaBandWidthEstimator);
	
			this.hls = hls;
			this.defaultEstimate_ = defaultEstimate;
			this.minWeight_ = 0.001;
			this.minDelayMs_ = 50;
			this.slow_ = new _ewma2.default(slow);
			this.fast_ = new _ewma2.default(fast);
		}
	
		_createClass(EwmaBandWidthEstimator, [{
			key: 'sample',
			value: function sample(durationMs, numBytes) {
				var myDurationMs = Math.max(durationMs, this.minDelayMs_);
				var bandwidth = 8000 * numBytes / myDurationMs;
				//console.log('instant bw:'+ Math.round(bandwidth));
				// we weight sample using loading duration....
				var weight = myDurationMs / 1000;
				this.fast_.sample(weight, bandwidth);
				this.slow_.sample(weight, bandwidth);
			}
		}, {
			key: 'canEstimate',
			value: function canEstimate() {
				var fast = this.fast_;
				return fast && fast.getTotalWeight() >= this.minWeight_;
			}
		}, {
			key: 'getEstimate',
			value: function getEstimate() {
				if (this.canEstimate()) {
					//console.log('slow estimate:'+ Math.round(this.slow_.getEstimate()));
					//console.log('fast estimate:'+ Math.round(this.fast_.getEstimate()));
					// Take the minimum of these two estimates.  This should have the effect of
					// adapting down quickly, but up more slowly.
					return Math.min(this.fast_.getEstimate(), this.slow_.getEstimate());
				} else {
					return this.defaultEstimate_;
				}
			}
		}, {
			key: 'destroy',
			value: function destroy() {
				//Mactrix additions start
				//memory clean up
				this.slow_ = null;
				this.fast_ = null;
				//Mactrix additions end
			}
		}]);
	
		return EwmaBandWidthEstimator;
	}();
	
	exports.default = EwmaBandWidthEstimator;
	module.exports = exports['default'];

/***/ }),
/* 139 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/*
	 * compute an Exponential Weighted moving average
	 * - https://en.wikipedia.org/wiki/Moving_average#Exponential_moving_average
	 *  - heavily inspired from shaka-player
	 */
	
	var EWMA = function () {
	
		//  About half of the estimated value will be from the last |halfLife| samples by weight.
		function EWMA(halfLife) {
			_classCallCheck(this, EWMA);
	
			// Larger values of alpha expire historical data more slowly.
			this.alpha_ = halfLife ? Math.exp(Math.log(0.5) / halfLife) : 0;
			this.estimate_ = 0;
			this.totalWeight_ = 0;
		}
	
		_createClass(EWMA, [{
			key: "sample",
			value: function sample(weight, value) {
				var adjAlpha = Math.pow(this.alpha_, weight);
				this.estimate_ = value * (1 - adjAlpha) + adjAlpha * this.estimate_;
				this.totalWeight_ += weight;
			}
		}, {
			key: "getTotalWeight",
			value: function getTotalWeight() {
				return this.totalWeight_;
			}
		}, {
			key: "getEstimate",
			value: function getEstimate() {
				if (this.alpha_) {
					var zeroFactor = 1 - Math.pow(this.alpha_, this.totalWeight_);
					return this.estimate_ / zeroFactor;
				} else {
					return this.estimate_;
				}
			}
		}]);
	
		return EWMA;
	}();
	
	exports.default = EWMA;
	module.exports = exports["default"];

/***/ }),
/* 140 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	/**
	 * Copyright 2013 vtt.js Contributors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	exports.default = function () {
		if (typeof window !== 'undefined' && window.VTTCue) {
			return window.VTTCue;
		}
	
		var autoKeyword = 'auto';
		var directionSetting = {
			'': true,
			lr: true,
			rl: true
		};
		var alignSetting = {
			start: true,
			middle: true,
			end: true,
			left: true,
			right: true
		};
	
		function findDirectionSetting(value) {
			if (typeof value !== 'string') {
				return false;
			}
			var dir = directionSetting[value.toLowerCase()];
			return dir ? value.toLowerCase() : false;
		}
	
		function findAlignSetting(value) {
			if (typeof value !== 'string') {
				return false;
			}
			var align = alignSetting[value.toLowerCase()];
			return align ? value.toLowerCase() : false;
		}
	
		function extend(obj) {
			var i = 1;
			for (; i < arguments.length; i++) {
				var cobj = arguments[i];
	
				// se: poor form.
				for (var p in cobj) {
					//eslint-disable-line guard-for-in
					obj[p] = cobj[p];
				}
			}
	
			return obj;
		}
	
		function VTTCue(startTime, endTime, text) {
			var cue = this;
			var isIE8 = function () {
				if (typeof navigator === 'undefined') {
					return;
				}
				// se: poor form
				return (/MSIE\s8\.0/.test(navigator.userAgent)
				); // eslint-disable-line consistent-return
			}();
			var baseObj = {};
	
			if (isIE8) {
				cue = document.createElement('custom');
			} else {
				baseObj.enumerable = true;
			}
	
			/**
	   * Shim implementation specific properties. These properties are not in
	   * the spec.
	   */
	
			// Lets us know when the VTTCue's data has changed in such a way that we need
			// to recompute its display state. This lets us compute its display state
			// lazily.
			cue.hasBeenReset = false;
	
			/**
	   * VTTCue and TextTrackCue properties
	   * http://dev.w3.org/html5/webvtt/#vttcue-interface
	   */
	
			var _id = '';
			var _pauseOnExit = false;
			var _startTime = startTime;
			var _endTime = endTime;
			var _text = text;
			var _region = null;
			var _vertical = '';
			var _snapToLines = true;
			var _line = 'auto';
			var _lineAlign = 'start';
			var _position = 50;
			var _positionAlign = 'middle';
			var _size = 50;
			var _align = 'middle';
	
			Object.defineProperty(cue, 'id', extend({}, baseObj, {
				get: function get() {
					return _id;
				},
				set: function set(value) {
					_id = '' + value;
				}
			}));
	
			Object.defineProperty(cue, 'pauseOnExit', extend({}, baseObj, {
				get: function get() {
					return _pauseOnExit;
				},
				set: function set(value) {
					_pauseOnExit = !!value;
				}
			}));
	
			Object.defineProperty(cue, 'startTime', extend({}, baseObj, {
				get: function get() {
					return _startTime;
				},
				set: function set(value) {
					if (typeof value !== 'number') {
						throw new TypeError('Start time must be set to a number.');
					}
					_startTime = value;
					this.hasBeenReset = true;
				}
			}));
	
			Object.defineProperty(cue, 'endTime', extend({}, baseObj, {
				get: function get() {
					return _endTime;
				},
				set: function set(value) {
					if (typeof value !== 'number') {
						throw new TypeError('End time must be set to a number.');
					}
					_endTime = value;
					this.hasBeenReset = true;
				}
			}));
	
			Object.defineProperty(cue, 'text', extend({}, baseObj, {
				get: function get() {
					return _text;
				},
				set: function set(value) {
					_text = '' + value;
					this.hasBeenReset = true;
				}
			}));
	
			Object.defineProperty(cue, 'region', extend({}, baseObj, {
				get: function get() {
					return _region;
				},
				set: function set(value) {
					_region = value;
					this.hasBeenReset = true;
				}
			}));
	
			Object.defineProperty(cue, 'vertical', extend({}, baseObj, {
				get: function get() {
					return _vertical;
				},
				set: function set(value) {
					var setting = findDirectionSetting(value);
					// Have to check for false because the setting an be an empty string.
					if (setting === false) {
						throw new SyntaxError('An invalid or illegal string was specified.');
					}
					_vertical = setting;
					this.hasBeenReset = true;
				}
			}));
	
			Object.defineProperty(cue, 'snapToLines', extend({}, baseObj, {
				get: function get() {
					return _snapToLines;
				},
				set: function set(value) {
					_snapToLines = !!value;
					this.hasBeenReset = true;
				}
			}));
	
			Object.defineProperty(cue, 'line', extend({}, baseObj, {
				get: function get() {
					return _line;
				},
				set: function set(value) {
					if (typeof value !== 'number' && value !== autoKeyword) {
						throw new SyntaxError('An invalid number or illegal string was specified.');
					}
					_line = value;
					this.hasBeenReset = true;
				}
			}));
	
			Object.defineProperty(cue, 'lineAlign', extend({}, baseObj, {
				get: function get() {
					return _lineAlign;
				},
				set: function set(value) {
					var setting = findAlignSetting(value);
					if (!setting) {
						throw new SyntaxError('An invalid or illegal string was specified.');
					}
					_lineAlign = setting;
					this.hasBeenReset = true;
				}
			}));
	
			Object.defineProperty(cue, 'position', extend({}, baseObj, {
				get: function get() {
					return _position;
				},
				set: function set(value) {
					if (value < 0 || value > 100) {
						throw new Error('Position must be between 0 and 100.');
					}
					_position = value;
					this.hasBeenReset = true;
				}
			}));
	
			Object.defineProperty(cue, 'positionAlign', extend({}, baseObj, {
				get: function get() {
					return _positionAlign;
				},
				set: function set(value) {
					var setting = findAlignSetting(value);
					if (!setting) {
						throw new SyntaxError('An invalid or illegal string was specified.');
					}
					_positionAlign = setting;
					this.hasBeenReset = true;
				}
			}));
	
			Object.defineProperty(cue, 'size', extend({}, baseObj, {
				get: function get() {
					return _size;
				},
				set: function set(value) {
					if (value < 0 || value > 100) {
						throw new Error('Size must be between 0 and 100.');
					}
					_size = value;
					this.hasBeenReset = true;
				}
			}));
	
			Object.defineProperty(cue, 'align', extend({}, baseObj, {
				get: function get() {
					return _align;
				},
				set: function set(value) {
					var setting = findAlignSetting(value);
					if (!setting) {
						throw new SyntaxError('An invalid or illegal string was specified.');
					}
					_align = setting;
					this.hasBeenReset = true;
				}
			}));
	
			/**
	   * Other <track> spec defined properties
	   */
	
			// http://www.whatwg.org/specs/web-apps/current-work/multipage/the-video-element.html#text-track-cue-display-state
			cue.displayState = undefined;
	
			if (isIE8) {
				return cue;
			}
		}
	
		/**
	  * VTTCue methods
	  */
	
		VTTCue.prototype.getCueAsHTML = function () {
			// Assume WebVTT.convertCueToDOMTree is on the global.
			var WebVTT = window.WebVTT;
			return WebVTT.convertCueToDOMTree(window, this.text);
		};
	
		return VTTCue;
	}();
	
	module.exports = exports['default'];

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vttparser = __webpack_require__(73);
	
	var _vttparser2 = _interopRequireDefault(_vttparser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cueString2millis = function cueString2millis(timeString) {
		var ts = parseInt(timeString.substr(-3), 10);
		var secs = parseInt(timeString.substr(-6, 2), 10);
		var mins = parseInt(timeString.substr(-9, 2), 10);
		var hours = timeString.length > 9 ? parseInt(timeString.substr(0, timeString.indexOf(':')), 10) : 0;
	
		if (isNaN(ts) || isNaN(secs) || isNaN(mins) || isNaN(hours)) {
			return -1;
		}
	
		ts += 1000 * secs;
		ts += 60 * 1000 * mins;
		ts += 60 * 60 * 1000 * hours;
	
		return ts;
	};
	
	var calculateOffset = function calculateOffset(vttCCs, cc, presentationTime) {
		var currCC = vttCCs[cc];
		var prevCC = vttCCs[currCC.prevCC];
	
		// This is the first discontinuity or cues have been processed since the last discontinuity
		// Offset = current discontinuity time
		if (!prevCC || !prevCC.new && currCC.new) {
			vttCCs.ccOffset = vttCCs.presentationOffset = currCC.start;
			currCC.new = false;
			return;
		}
	
		// There have been discontinuities since cues were last parsed.
		// Offset = time elapsed
		while (prevCC && prevCC.new) {
			vttCCs.ccOffset += currCC.start - prevCC.start;
			currCC.new = false;
			currCC = prevCC;
			prevCC = vttCCs[currCC.prevCC];
		}
	
		vttCCs.presentationOffset = presentationTime;
	};
	
	var WebVTTParser = {
		parse: function parse(vttByteArray, syncPTS, vttCCs, cc, callBack, errorCallBack) {
			// Convert byteArray into string, replacing any somewhat exotic linefeeds with "\n", then split on that character.
			var re = /\r\n|\n\r|\n|\r/g;
			var vttLines = String.fromCharCode.apply(null, new Uint8Array(vttByteArray)).trim().replace(re, '\n').split('\n');
			var cueTime = '00:00.000';
			var mpegTs = 0;
			var localTime = 0;
			var presentationTime = 0;
			var cues = [];
			var parsingError = void 0;
			var inHeader = true;
			// let VTTCue = VTTCue || window.TextTrackCue;
	
			// Create parser object using VTTCue with TextTrackCue fallback on certain browsers.
			var parser = new _vttparser2.default();
	
			parser.oncue = function (cue) {
				// Adjust cue timing; clamp cues to start no earlier than - and drop cues that don't end after - 0 on timeline.
				var currCC = vttCCs[cc];
				var cueOffset = vttCCs.ccOffset;
	
				// Update offsets for new discontinuities
				if (currCC && currCC.new) {
					if (localTime) {
						// When local time is provided, offset = discontinuity start time - local time
						cueOffset = vttCCs.ccOffset = currCC.start;
					} else {
						calculateOffset(vttCCs, cc, presentationTime);
					}
				}
	
				if (presentationTime && !localTime) {
					// If we have MPEGTS but no LOCAL time, offset = presentation time + discontinuity offset
					cueOffset = presentationTime + vttCCs.ccOffset - vttCCs.presentationOffset;
				}
	
				cue.startTime += cueOffset - localTime;
				cue.endTime += cueOffset - localTime;
	
				// Fix encoding of special characters. TODO: Test with all sorts of weird characters.
				cue.text = decodeURIComponent(escape(cue.text));
				if (cue.endTime > 0) {
					cues.push(cue);
				}
			};
	
			parser.onparsingerror = function (e) {
				parsingError = e;
			};
	
			parser.onflush = function () {
				if (parsingError && errorCallBack) {
					errorCallBack(parsingError);
					return;
				}
				callBack(cues);
			};
	
			// Go through contents line by line.
			vttLines.forEach(function (line) {
				if (inHeader) {
					// Look for X-TIMESTAMP-MAP in header.
					if (line.startsWith('X-TIMESTAMP-MAP=')) {
						// Once found, no more are allowed anyway, so stop searching.
						inHeader = false;
						// Extract LOCAL and MPEGTS.
						line.substr(16).split(',').forEach(function (timestamp) {
							if (timestamp.startsWith('LOCAL:')) {
								cueTime = timestamp.substr(6);
							} else if (timestamp.startsWith('MPEGTS:')) {
								mpegTs = parseInt(timestamp.substr(7), 10);
							}
						});
						try {
							// Calculate subtitle offset in milliseconds.
							// If sync PTS is less than zero, we have a 33-bit wraparound, which is fixed by adding 2^33 = 8589934592.
							//
							// se: poor form. not sure if the argument modification behaviour is relied on.
							syncPTS = syncPTS < 0 ? syncPTS + 8589934592 : syncPTS; //eslint-disable-line no-param-reassign
							// Adjust MPEGTS by sync PTS.
							mpegTs -= syncPTS;
							// Convert cue time to seconds
							localTime = cueString2millis(cueTime) / 1000;
							// Convert MPEGTS to seconds from 90kHz.
							presentationTime = mpegTs / 90000;
	
							if (localTime === -1) {
								parsingError = new Error('Malformed X-TIMESTAMP-MAP: ' + line);
							}
						} catch (e) {
							parsingError = new Error('Malformed X-TIMESTAMP-MAP: ' + line);
						}
						// Return without parsing X-TIMESTAMP-MAP line.
						return;
					} else if (line === '') {
						inHeader = false;
					}
				}
				// Parse line by default.
				parser.parse(line + '\n');
			});
	
			parser.flush();
		}
	};
	
	module.exports = WebVTTParser;

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * XHR based logger
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     */
	
	var _logger = __webpack_require__(1);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var XhrLoader = function () {
		function XhrLoader(config) {
			_classCallCheck(this, XhrLoader);
	
			if (config && config.xhrSetup) {
				this.xhrSetup = config.xhrSetup;
			}
		}
	
		_createClass(XhrLoader, [{
			key: 'destroy',
			value: function destroy() {
				this.abort();
				this.loader = null;
			}
		}, {
			key: 'abort',
			value: function abort() {
				var loader = this.loader;
				if (loader && loader.readyState !== 4) {
					this.stats.aborted = true;
					loader.abort();
				}
	
				window.clearTimeout(this.requestTimeout);
				this.requestTimeout = null;
				window.clearTimeout(this.retryTimeout);
				this.retryTimeout = null;
			}
		}, {
			key: 'load',
			value: function load(context, config, callbacks) {
				this.context = context;
				this.config = config;
				this.callbacks = callbacks;
				this.stats = { trequest: performance.now(), retry: 0, aborted: false };
				this.retryDelay = config.retryDelay;
				this.loadInternal();
			}
		}, {
			key: 'loadInternal',
			value: function loadInternal() {
				var xhr = void 0;
				var context = this.context;
	
				if (typeof XDomainRequest !== 'undefined') {
					xhr = this.loader = new XDomainRequest();
				} else {
					xhr = this.loader = new XMLHttpRequest();
				}
				var stats = this.stats;
				stats.tfirst = 0;
				stats.loaded = 0;
				if (this.xhrSetup) {
					/* mactrix replace
	    	  this.xhrSetup(xhr, context.url);
	    */
					this.xhrSetup(xhr, context.url, context.dataType); //Mactrix above line changed, added dataType
				}
	
				if (!xhr.readyState) {
					xhr.open('GET', context.url, true);
				}
				if (context.rangeEnd) {
					xhr.setRequestHeader('Range', 'bytes=' + context.rangeStart + '-' + (context.rangeEnd - 1));
				}
	
				xhr.onreadystatechange = this.readystatechange.bind(this);
				xhr.onprogress = this.loadprogress.bind(this);
				xhr.responseType = context.responseType;
	
				// setup timeout before we perform request
				this.requestTimeout = window.setTimeout(this.loadtimeout.bind(this), this.config.timeout);
				xhr.send();
			}
		}, {
			key: 'readystatechange',
			value: function readystatechange(event) {
				var xhr = event.currentTarget;
				var readyState = xhr.readyState;
				var stats = this.stats;
				var context = this.context;
				var config = this.config;
	
				// don't proceed if xhr has been aborted
				if (stats.aborted) {
					return;
				}
	
				// >= HEADERS_RECEIVED
				if (readyState >= 2) {
					// clear xhr timeout and rearm it if readyState less than 4
					window.clearTimeout(this.requestTimeout);
					if (stats.tfirst === 0) {
						stats.tfirst = Math.max(performance.now(), stats.trequest);
					}
					if (readyState === 4) {
						var status = xhr.status;
						// http status between 200 to 299 are all successful
						if (status >= 200 && status < 300) {
							stats.tload = Math.max(stats.tfirst, performance.now());
							var data = void 0;
							var len = void 0;
	
							if (context.responseType === 'arraybuffer') {
								data = xhr.response;
								len = data.byteLength;
							} else {
								data = xhr.responseText;
								len = data.length;
							}
							stats.loaded = stats.total = len;
							var response = { url: xhr.responseURL, data: data };
							this.callbacks.onSuccess(response, stats, context);
						} else {
							// if max nb of retries reached or if http status between 400 and 499 (such error cannot be recovered, retrying is useless), return error
							if (stats.retry >= config.maxRetry || status >= 400 && status < 499) {
								_logger.logger.error(status + ' while loading ' + context.url);
								this.callbacks.onError({ code: status, text: xhr.statusText }, context);
							} else {
								// retry
								_logger.logger.warn(status + ' while loading ' + context.url + ', retrying in ' + this.retryDelay + '...');
								// aborts and resets internal state
								this.destroy();
								// schedule retry
								this.retryTimeout = window.setTimeout(this.loadInternal.bind(this), this.retryDelay);
								// set exponential backoff
								this.retryDelay = Math.min(2 * this.retryDelay, config.maxRetryDelay);
								stats.retry++;
							}
						}
					} else {
						// readyState >= 2 AND readyState !==4 (readyState = HEADERS_RECEIVED || LOADING) rearm timeout as xhr not finished yet
						this.requestTimeout = window.setTimeout(this.loadtimeout.bind(this), config.timeout);
					}
				}
			}
		}, {
			key: 'loadtimeout',
			value: function loadtimeout() {
				_logger.logger.warn('timeout while loading ' + this.context.url);
				this.callbacks.onTimeout(this.stats, this.context);
			}
		}, {
			key: 'loadprogress',
			value: function loadprogress(event) {
				var stats = this.stats;
				stats.loaded = event.loaded;
				if (event.lengthComputable) {
					stats.total = event.total;
				}
				var onProgress = this.callbacks.onProgress;
				if (onProgress) {
					// last args is to provide on progress data
					onProgress(stats, this.context, null);
				}
			}
		}]);
	
		return XhrLoader;
	}();
	
	exports.default = XhrLoader;
	module.exports = exports['default'];

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * mux.js
	 *
	 * Copyright (c) 2016 Brightcove
	 * All rights reserved.
	 *
	 * A stream-based aac to mp4 converter. This utility can be used to
	 * deliver mp4s to a SourceBuffer on platforms that support native
	 * Media Source Extensions.
	 */
	'use strict';
	
	var Stream = __webpack_require__(11);
	
	// Constants
	var _AacStream;
	
	/**
	 * Splits an incoming stream of binary data into ADTS and ID3 Frames.
	 */
	
	_AacStream = function AacStream() {
	  var
	  /*
	  everything = new Uint8Array(),
	  */
	  everything = new Uint8Array(0),
	      //mactrix line changed, default constructor breaks when using babel-polyfill
	  timeStamp = 0;
	
	  _AacStream.prototype.init.call(this);
	
	  this.setTimestamp = function (timestamp) {
	    timeStamp = timestamp;
	  };
	
	  this.parseId3TagSize = function (header, byteIndex) {
	    var returnSize = header[byteIndex + 6] << 21 | header[byteIndex + 7] << 14 | header[byteIndex + 8] << 7 | header[byteIndex + 9],
	        flags = header[byteIndex + 5],
	        footerPresent = (flags & 16) >> 4;
	
	    if (footerPresent) {
	      return returnSize + 20;
	    }
	    return returnSize + 10;
	  };
	
	  this.parseAdtsSize = function (header, byteIndex) {
	    var lowThree = (header[byteIndex + 5] & 0xE0) >> 5,
	        middle = header[byteIndex + 4] << 3,
	        highTwo = header[byteIndex + 3] & 0x3 << 11;
	
	    return highTwo | middle | lowThree;
	  };
	
	  this.push = function (bytes) {
	    var frameSize = 0,
	        byteIndex = 0,
	        bytesLeft,
	        chunk,
	        packet,
	        tempLength;
	
	    // If there are bytes remaining from the last segment, prepend them to the
	    // bytes that were pushed in
	    if (everything.length) {
	      tempLength = everything.length;
	      everything = new Uint8Array(bytes.byteLength + tempLength);
	      everything.set(everything.subarray(0, tempLength));
	      everything.set(bytes, tempLength);
	    } else {
	      everything = bytes;
	    }
	
	    while (everything.length - byteIndex >= 3) {
	      if (everything[byteIndex] === 'I'.charCodeAt(0) && everything[byteIndex + 1] === 'D'.charCodeAt(0) && everything[byteIndex + 2] === '3'.charCodeAt(0)) {
	
	        // Exit early because we don't have enough to parse
	        // the ID3 tag header
	        if (everything.length - byteIndex < 10) {
	          break;
	        }
	
	        // check framesize
	        frameSize = this.parseId3TagSize(everything, byteIndex);
	
	        // Exit early if we don't have enough in the buffer
	        // to emit a full packet
	        if (frameSize > everything.length) {
	          break;
	        }
	        chunk = {
	          type: 'timed-metadata',
	          data: everything.subarray(byteIndex, byteIndex + frameSize)
	        };
	        this.trigger('data', chunk);
	        byteIndex += frameSize;
	        continue;
	      } else if (everything[byteIndex] & 0xff === 0xff && (everything[byteIndex + 1] & 0xf0) === 0xf0) {
	
	        // Exit early because we don't have enough to parse
	        // the ADTS frame header
	        if (everything.length - byteIndex < 7) {
	          break;
	        }
	
	        frameSize = this.parseAdtsSize(everything, byteIndex);
	
	        // Exit early if we don't have enough in the buffer
	        // to emit a full packet
	        if (frameSize > everything.length) {
	          break;
	        }
	
	        packet = {
	          type: 'audio',
	          data: everything.subarray(byteIndex, byteIndex + frameSize),
	          pts: timeStamp,
	          dts: timeStamp
	        };
	        this.trigger('data', packet);
	        byteIndex += frameSize;
	        continue;
	      }
	      byteIndex++;
	    }
	    bytesLeft = everything.length - byteIndex;
	
	    if (bytesLeft > 0) {
	      everything = everything.subarray(byteIndex);
	    } else {
	      /*
	      everything = new Uint8Array();
	      */
	      everything = new Uint8Array(0); //mactrix line changed, default constructor breaks when using babel-polyfill
	    }
	  };
	};
	
	_AacStream.prototype = new Stream();
	
	module.exports = _AacStream;

/***/ }),
/* 144 */
/***/ (function(module, exports) {

	/**
	 * mux.js
	 *
	 * Copyright (c) 2016 Brightcove
	 * All rights reserved.
	 *
	 * Utilities to detect basic properties and metadata about Aac data.
	 */
	'use strict';
	
	var ADTS_SAMPLING_FREQUENCIES = [96000, 88200, 64000, 48000, 44100, 32000, 24000, 22050, 16000, 12000, 11025, 8000, 7350];
	
	var parseSyncSafeInteger = function parseSyncSafeInteger(data) {
	  return data[0] << 21 | data[1] << 14 | data[2] << 7 | data[3];
	};
	
	// return a percent-encoded representation of the specified byte range
	// @see http://en.wikipedia.org/wiki/Percent-encoding
	var percentEncode = function percentEncode(bytes, start, end) {
	  var i,
	      result = '';
	  for (i = start; i < end; i++) {
	    result += '%' + ('00' + bytes[i].toString(16)).slice(-2);
	  }
	  return result;
	};
	
	// return the string representation of the specified byte range,
	// interpreted as ISO-8859-1.
	var parseIso88591 = function parseIso88591(bytes, start, end) {
	  return unescape(percentEncode(bytes, start, end)); // jshint ignore:line
	};
	
	var parseId3TagSize = function parseId3TagSize(header, byteIndex) {
	  var returnSize = header[byteIndex + 6] << 21 | header[byteIndex + 7] << 14 | header[byteIndex + 8] << 7 | header[byteIndex + 9],
	      flags = header[byteIndex + 5],
	      footerPresent = (flags & 16) >> 4;
	
	  if (footerPresent) {
	    return returnSize + 20;
	  }
	  return returnSize + 10;
	};
	
	var parseAdtsSize = function parseAdtsSize(header, byteIndex) {
	  var lowThree = (header[byteIndex + 5] & 0xE0) >> 5,
	      middle = header[byteIndex + 4] << 3,
	      highTwo = header[byteIndex + 3] & 0x3 << 11;
	
	  return highTwo | middle | lowThree;
	};
	
	var parseType = function parseType(header, byteIndex) {
	  if (header[byteIndex] === 'I'.charCodeAt(0) && header[byteIndex + 1] === 'D'.charCodeAt(0) && header[byteIndex + 2] === '3'.charCodeAt(0)) {
	    return 'timed-metadata';
	  } else if (header[byteIndex] & 0xff === 0xff && (header[byteIndex + 1] & 0xf0) === 0xf0) {
	    return 'audio';
	  }
	  return null;
	};
	
	var parseSampleRate = function parseSampleRate(packet) {
	  var i = 0;
	
	  while (i + 5 < packet.length) {
	    if (packet[i] !== 0xFF || (packet[i + 1] & 0xF6) !== 0xF0) {
	      // If a valid header was not found,  jump one forward and attempt to
	      // find a valid ADTS header starting at the next byte
	      i++;
	      continue;
	    }
	    return ADTS_SAMPLING_FREQUENCIES[(packet[i + 2] & 0x3c) >>> 2];
	  }
	
	  return null;
	};
	
	var parseAacTimestamp = function parseAacTimestamp(packet) {
	  var frameStart, frameSize, frame, frameHeader;
	
	  // find the start of the first frame and the end of the tag
	  frameStart = 10;
	  if (packet[5] & 0x40) {
	    // advance the frame start past the extended header
	    frameStart += 4; // header size field
	    frameStart += parseSyncSafeInteger(packet.subarray(10, 14));
	  }
	
	  // parse one or more ID3 frames
	  // http://id3.org/id3v2.3.0#ID3v2_frame_overview
	  do {
	    // determine the number of bytes in this frame
	    frameSize = parseSyncSafeInteger(packet.subarray(frameStart + 4, frameStart + 8));
	    if (frameSize < 1) {
	      return null;
	    }
	    frameHeader = String.fromCharCode(packet[frameStart], packet[frameStart + 1], packet[frameStart + 2], packet[frameStart + 3]);
	
	    if (frameHeader === 'PRIV') {
	      frame = packet.subarray(frameStart + 10, frameStart + frameSize + 10);
	
	      for (var i = 0; i < frame.byteLength; i++) {
	        if (frame[i] === 0) {
	          var owner = parseIso88591(frame, 0, i);
	          if (owner === 'com.apple.streaming.transportStreamTimestamp') {
	            var d = frame.subarray(i + 1);
	            var size = (d[3] & 0x01) << 30 | d[4] << 22 | d[5] << 14 | d[6] << 6 | d[7] >>> 2;
	            size *= 4;
	            size += d[7] & 0x03;
	
	            return size;
	          }
	          break;
	        }
	      }
	    }
	
	    frameStart += 10; // advance past the frame header
	    frameStart += frameSize; // advance past the frame body
	  } while (frameStart < packet.byteLength);
	  return null;
	};
	
	module.exports = {
	  parseId3TagSize: parseId3TagSize,
	  parseAdtsSize: parseAdtsSize,
	  parseType: parseType,
	  parseSampleRate: parseSampleRate,
	  parseAacTimestamp: parseAacTimestamp
	};

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = {
	  adts: __webpack_require__(41),
	  h264: __webpack_require__(42)
	};

/***/ }),
/* 146 */
/***/ (function(module, exports) {

	"use strict";
	
	var highPrefix = [33, 16, 5, 32, 164, 27];
	var lowPrefix = [33, 65, 108, 84, 1, 2, 4, 8, 168, 2, 4, 8, 17, 191, 252];
	var zeroFill = function zeroFill(count) {
	  var a = [];
	  while (count--) {
	    a.push(0);
	  }
	  return a;
	};
	
	var makeTable = function makeTable(metaTable) {
	  return Object.keys(metaTable).reduce(function (obj, key) {
	    obj[key] = new Uint8Array(metaTable[key].reduce(function (arr, part) {
	      return arr.concat(part);
	    }, []));
	    return obj;
	  }, {});
	};
	
	// Frames-of-silence to use for filling in missing AAC frames
	var coneOfSilence = {
	  96000: [highPrefix, [227, 64], zeroFill(154), [56]],
	  88200: [highPrefix, [231], zeroFill(170), [56]],
	  64000: [highPrefix, [248, 192], zeroFill(240), [56]],
	  48000: [highPrefix, [255, 192], zeroFill(268), [55, 148, 128], zeroFill(54), [112]],
	  44100: [highPrefix, [255, 192], zeroFill(268), [55, 163, 128], zeroFill(84), [112]],
	  32000: [highPrefix, [255, 192], zeroFill(268), [55, 234], zeroFill(226), [112]],
	  24000: [highPrefix, [255, 192], zeroFill(268), [55, 255, 128], zeroFill(268), [111, 112], zeroFill(126), [224]],
	  16000: [highPrefix, [255, 192], zeroFill(268), [55, 255, 128], zeroFill(268), [111, 255], zeroFill(269), [223, 108], zeroFill(195), [1, 192]],
	  12000: [lowPrefix, zeroFill(268), [3, 127, 248], zeroFill(268), [6, 255, 240], zeroFill(268), [13, 255, 224], zeroFill(268), [27, 253, 128], zeroFill(259), [56]],
	  11025: [lowPrefix, zeroFill(268), [3, 127, 248], zeroFill(268), [6, 255, 240], zeroFill(268), [13, 255, 224], zeroFill(268), [27, 255, 192], zeroFill(268), [55, 175, 128], zeroFill(108), [112]],
	  8000: [lowPrefix, zeroFill(268), [3, 121, 16], zeroFill(47), [7]]
	};
	
	module.exports = makeTable(coneOfSilence);

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Stream = __webpack_require__(11);
	
	/**
	 * The final stage of the transmuxer that emits the flv tags
	 * for audio, video, and metadata. Also tranlates in time and
	 * outputs caption data and id3 cues.
	 */
	var CoalesceStream = function CoalesceStream(options) {
	  // Number of Tracks per output segment
	  // If greater than 1, we combine multiple
	  // tracks into a single segment
	  this.numberOfTracks = 0;
	  this.metadataStream = options.metadataStream;
	
	  this.videoTags = [];
	  this.audioTags = [];
	  this.videoTrack = null;
	  this.audioTrack = null;
	  this.pendingCaptions = [];
	  this.pendingMetadata = [];
	  this.pendingTracks = 0;
	  this.processedTracks = 0;
	
	  CoalesceStream.prototype.init.call(this);
	
	  // Take output from multiple
	  this.push = function (output) {
	    // buffer incoming captions until the associated video segment
	    // finishes
	    if (output.text) {
	      return this.pendingCaptions.push(output);
	    }
	    // buffer incoming id3 tags until the final flush
	    if (output.frames) {
	      return this.pendingMetadata.push(output);
	    }
	
	    if (output.track.type === 'video') {
	      this.videoTrack = output.track;
	      this.videoTags = output.tags;
	      this.pendingTracks++;
	    }
	    if (output.track.type === 'audio') {
	      this.audioTrack = output.track;
	      this.audioTags = output.tags;
	      this.pendingTracks++;
	    }
	  };
	};
	
	CoalesceStream.prototype = new Stream();
	CoalesceStream.prototype.flush = function (flushSource) {
	  var id3,
	      caption,
	      i,
	      timelineStartPts,
	      event = {
	    tags: {},
	    captions: [],
	    metadata: []
	  };
	
	  if (this.pendingTracks < this.numberOfTracks) {
	    if (flushSource !== 'VideoSegmentStream' && flushSource !== 'AudioSegmentStream') {
	      // Return because we haven't received a flush from a data-generating
	      // portion of the segment (meaning that we have only recieved meta-data
	      // or captions.)
	      return;
	    } else if (this.pendingTracks === 0) {
	      // In the case where we receive a flush without any data having been
	      // received we consider it an emitted track for the purposes of coalescing
	      // `done` events.
	      // We do this for the case where there is an audio and video track in the
	      // segment but no audio data. (seen in several playlists with alternate
	      // audio tracks and no audio present in the main TS segments.)
	      this.processedTracks++;
	
	      if (this.processedTracks < this.numberOfTracks) {
	        return;
	      }
	    }
	  }
	
	  this.processedTracks += this.pendingTracks;
	  this.pendingTracks = 0;
	
	  if (this.processedTracks < this.numberOfTracks) {
	    return;
	  }
	
	  if (this.videoTrack) {
	    timelineStartPts = this.videoTrack.timelineStartInfo.pts;
	  } else if (this.audioTrack) {
	    timelineStartPts = this.audioTrack.timelineStartInfo.pts;
	  }
	
	  event.tags.videoTags = this.videoTags;
	  event.tags.audioTags = this.audioTags;
	
	  // Translate caption PTS times into second offsets into the
	  // video timeline for the segment
	  for (i = 0; i < this.pendingCaptions.length; i++) {
	    caption = this.pendingCaptions[i];
	    caption.startTime = caption.startPts - timelineStartPts;
	    caption.startTime /= 90e3;
	    caption.endTime = caption.endPts - timelineStartPts;
	    caption.endTime /= 90e3;
	    event.captions.push(caption);
	  }
	
	  // Translate ID3 frame PTS times into second offsets into the
	  // video timeline for the segment
	  for (i = 0; i < this.pendingMetadata.length; i++) {
	    id3 = this.pendingMetadata[i];
	    id3.cueTime = id3.pts - timelineStartPts;
	    id3.cueTime /= 90e3;
	    event.metadata.push(id3);
	  }
	  // We add this to every single emitted segment even though we only need
	  // it for the first
	  event.metadata.dispatchType = this.metadataStream.dispatchType;
	
	  // Reset stream state
	  this.videoTrack = null;
	  this.audioTrack = null;
	  this.videoTags = [];
	  this.audioTags = [];
	  this.pendingCaptions.length = 0;
	  this.pendingMetadata.length = 0;
	  this.pendingTracks = 0;
	  this.processedTracks = 0;
	
	  // Emit the final segment
	  this.trigger('data', event);
	
	  this.trigger('done');
	};
	
	module.exports = CoalesceStream;

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var FlvTag = __webpack_require__(43);
	
	// For information on the FLV format, see
	// http://download.macromedia.com/f4v/video_file_format_spec_v10_1.pdf.
	// Technically, this function returns the header and a metadata FLV tag
	// if duration is greater than zero
	// duration in seconds
	// @return {object} the bytes of the FLV header as a Uint8Array
	var getFlvHeader = function getFlvHeader(duration, audio, video) {
	  // :ByteArray {
	  var headBytes = new Uint8Array(3 + 1 + 1 + 4),
	      head = new DataView(headBytes.buffer),
	      metadata,
	      result,
	      metadataLength;
	
	  // default arguments
	  duration = duration || 0;
	  audio = audio === undefined ? true : audio;
	  video = video === undefined ? true : video;
	
	  // signature
	  head.setUint8(0, 0x46); // 'F'
	  head.setUint8(1, 0x4c); // 'L'
	  head.setUint8(2, 0x56); // 'V'
	
	  // version
	  head.setUint8(3, 0x01);
	
	  // flags
	  head.setUint8(4, (audio ? 0x04 : 0x00) | (video ? 0x01 : 0x00));
	
	  // data offset, should be 9 for FLV v1
	  head.setUint32(5, headBytes.byteLength);
	
	  // init the first FLV tag
	  if (duration <= 0) {
	    // no duration available so just write the first field of the first
	    // FLV tag
	    result = new Uint8Array(headBytes.byteLength + 4);
	    result.set(headBytes);
	    result.set([0, 0, 0, 0], headBytes.byteLength);
	    return result;
	  }
	
	  // write out the duration metadata tag
	  metadata = new FlvTag(FlvTag.METADATA_TAG);
	  metadata.pts = metadata.dts = 0;
	  metadata.writeMetaDataDouble('duration', duration);
	  metadataLength = metadata.finalize().length;
	  result = new Uint8Array(headBytes.byteLength + metadataLength);
	  result.set(headBytes);
	  result.set(head.byteLength, metadataLength);
	
	  return result;
	};
	
	module.exports = getFlvHeader;

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = {
	  tag: __webpack_require__(43),
	  Transmuxer: __webpack_require__(151),
	  getFlvHeader: __webpack_require__(148)
	};

/***/ }),
/* 150 */
/***/ (function(module, exports) {

	'use strict';
	
	var TagList = function TagList() {
	  var self = this;
	
	  this.list = [];
	
	  this.push = function (tag) {
	    this.list.push({
	      bytes: tag.bytes,
	      dts: tag.dts,
	      pts: tag.pts,
	      keyFrame: tag.keyFrame,
	      metaDataTag: tag.metaDataTag
	    });
	  };
	
	  Object.defineProperty(this, 'length', {
	    get: function get() {
	      return self.list.length;
	    }
	  });
	};
	
	module.exports = TagList;

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Stream = __webpack_require__(11);
	var FlvTag = __webpack_require__(43);
	var m2ts = __webpack_require__(45);
	var AdtsStream = __webpack_require__(41);
	var H264Stream = __webpack_require__(42).H264Stream;
	var CoalesceStream = __webpack_require__(147);
	var TagList = __webpack_require__(150);
	
	var _Transmuxer, _VideoSegmentStream, _AudioSegmentStream, collectTimelineInfo, metaDataTag, extraDataTag;
	
	/**
	 * Store information about the start and end of the tracka and the
	 * duration for each frame/sample we process in order to calculate
	 * the baseMediaDecodeTime
	 */
	collectTimelineInfo = function collectTimelineInfo(track, data) {
	  if (typeof data.pts === 'number') {
	    if (track.timelineStartInfo.pts === undefined) {
	      track.timelineStartInfo.pts = data.pts;
	    } else {
	      track.timelineStartInfo.pts = Math.min(track.timelineStartInfo.pts, data.pts);
	    }
	  }
	
	  if (typeof data.dts === 'number') {
	    if (track.timelineStartInfo.dts === undefined) {
	      track.timelineStartInfo.dts = data.dts;
	    } else {
	      track.timelineStartInfo.dts = Math.min(track.timelineStartInfo.dts, data.dts);
	    }
	  }
	};
	
	metaDataTag = function metaDataTag(track, pts) {
	  var tag = new FlvTag(FlvTag.METADATA_TAG); // :FlvTag
	
	  tag.dts = pts;
	  tag.pts = pts;
	
	  tag.writeMetaDataDouble('videocodecid', 7);
	  tag.writeMetaDataDouble('width', track.width);
	  tag.writeMetaDataDouble('height', track.height);
	
	  return tag;
	};
	
	extraDataTag = function extraDataTag(track, pts) {
	  var i,
	      tag = new FlvTag(FlvTag.VIDEO_TAG, true);
	
	  tag.dts = pts;
	  tag.pts = pts;
	
	  tag.writeByte(0x01); // version
	  tag.writeByte(track.profileIdc); // profile
	  tag.writeByte(track.profileCompatibility); // compatibility
	  tag.writeByte(track.levelIdc); // level
	  tag.writeByte(0xFC | 0x03); // reserved (6 bits), NULA length size - 1 (2 bits)
	  tag.writeByte(0xE0 | 0x01); // reserved (3 bits), num of SPS (5 bits)
	  tag.writeShort(track.sps[0].length); // data of SPS
	  tag.writeBytes(track.sps[0]); // SPS
	
	  tag.writeByte(track.pps.length); // num of PPS (will there ever be more that 1 PPS?)
	  for (i = 0; i < track.pps.length; ++i) {
	    tag.writeShort(track.pps[i].length); // 2 bytes for length of PPS
	    tag.writeBytes(track.pps[i]); // data of PPS
	  }
	
	  return tag;
	};
	
	/**
	 * Constructs a single-track, media segment from AAC data
	 * events. The output of this stream can be fed to flash.
	 */
	_AudioSegmentStream = function AudioSegmentStream(track) {
	  var adtsFrames = [],
	      oldExtraData;
	
	  _AudioSegmentStream.prototype.init.call(this);
	
	  this.push = function (data) {
	    collectTimelineInfo(track, data);
	
	    if (track && track.channelcount === undefined) {
	      track.audioobjecttype = data.audioobjecttype;
	      track.channelcount = data.channelcount;
	      track.samplerate = data.samplerate;
	      track.samplingfrequencyindex = data.samplingfrequencyindex;
	      track.samplesize = data.samplesize;
	      track.extraData = track.audioobjecttype << 11 | track.samplingfrequencyindex << 7 | track.channelcount << 3;
	    }
	
	    data.pts = Math.round(data.pts / 90);
	    data.dts = Math.round(data.dts / 90);
	
	    // buffer audio data until end() is called
	    adtsFrames.push(data);
	  };
	
	  this.flush = function () {
	    var currentFrame,
	        adtsFrame,
	        lastMetaPts,
	        tags = new TagList();
	    // return early if no audio data has been observed
	    if (adtsFrames.length === 0) {
	      this.trigger('done', 'AudioSegmentStream');
	      return;
	    }
	
	    lastMetaPts = -Infinity;
	
	    while (adtsFrames.length) {
	      currentFrame = adtsFrames.shift();
	
	      // write out metadata tags every 1 second so that the decoder
	      // is re-initialized quickly after seeking into a different
	      // audio configuration
	      if (track.extraData !== oldExtraData || currentFrame.pts - lastMetaPts >= 1000) {
	        adtsFrame = new FlvTag(FlvTag.METADATA_TAG);
	        adtsFrame.pts = currentFrame.pts;
	        adtsFrame.dts = currentFrame.dts;
	
	        // AAC is always 10
	        adtsFrame.writeMetaDataDouble('audiocodecid', 10);
	        adtsFrame.writeMetaDataBoolean('stereo', track.channelcount === 2);
	        adtsFrame.writeMetaDataDouble('audiosamplerate', track.samplerate);
	        // Is AAC always 16 bit?
	        adtsFrame.writeMetaDataDouble('audiosamplesize', 16);
	
	        tags.push(adtsFrame.finalize());
	
	        oldExtraData = track.extraData;
	
	        adtsFrame = new FlvTag(FlvTag.AUDIO_TAG, true);
	        // For audio, DTS is always the same as PTS. We want to set the DTS
	        // however so we can compare with video DTS to determine approximate
	        // packet order
	        adtsFrame.pts = currentFrame.pts;
	        adtsFrame.dts = currentFrame.dts;
	
	        adtsFrame.view.setUint16(adtsFrame.position, track.extraData);
	        adtsFrame.position += 2;
	        adtsFrame.length = Math.max(adtsFrame.length, adtsFrame.position);
	
	        tags.push(adtsFrame.finalize());
	
	        lastMetaPts = currentFrame.pts;
	      }
	      adtsFrame = new FlvTag(FlvTag.AUDIO_TAG);
	      adtsFrame.pts = currentFrame.pts;
	      adtsFrame.dts = currentFrame.dts;
	
	      adtsFrame.writeBytes(currentFrame.data);
	
	      tags.push(adtsFrame.finalize());
	    }
	
	    oldExtraData = null;
	    this.trigger('data', { track: track, tags: tags.list });
	
	    this.trigger('done', 'AudioSegmentStream');
	  };
	};
	_AudioSegmentStream.prototype = new Stream();
	
	/**
	 * Store FlvTags for the h264 stream
	 * @param track {object} track metadata configuration
	 */
	_VideoSegmentStream = function VideoSegmentStream(track) {
	  var nalUnits = [],
	      config,
	      h264Frame;
	  _VideoSegmentStream.prototype.init.call(this);
	
	  this.finishFrame = function (tags, frame) {
	    if (!frame) {
	      return;
	    }
	    // Check if keyframe and the length of tags.
	    // This makes sure we write metadata on the first frame of a segment.
	    if (config && track && track.newMetadata && (frame.keyFrame || tags.length === 0)) {
	      // Push extra data on every IDR frame in case we did a stream change + seek
	      var metaTag = metaDataTag(config, frame.dts).finalize();
	      var extraTag = extraDataTag(track, frame.dts).finalize();
	
	      metaTag.metaDataTag = extraTag.metaDataTag = true;
	
	      tags.push(metaTag);
	      tags.push(extraTag);
	      track.newMetadata = false;
	    }
	
	    frame.endNalUnit();
	    tags.push(frame.finalize());
	    h264Frame = null;
	  };
	
	  this.push = function (data) {
	    collectTimelineInfo(track, data);
	
	    data.pts = Math.round(data.pts / 90);
	    data.dts = Math.round(data.dts / 90);
	
	    // buffer video until flush() is called
	    nalUnits.push(data);
	  };
	
	  this.flush = function () {
	    var currentNal,
	        tags = new TagList();
	
	    // Throw away nalUnits at the start of the byte stream until we find
	    // the first AUD
	    while (nalUnits.length) {
	      if (nalUnits[0].nalUnitType === 'access_unit_delimiter_rbsp') {
	        break;
	      }
	      nalUnits.shift();
	    }
	
	    // return early if no video data has been observed
	    if (nalUnits.length === 0) {
	      this.trigger('done', 'VideoSegmentStream');
	      return;
	    }
	
	    while (nalUnits.length) {
	      currentNal = nalUnits.shift();
	
	      // record the track config
	      if (currentNal.nalUnitType === 'seq_parameter_set_rbsp') {
	        track.newMetadata = true;
	        config = currentNal.config;
	        track.width = config.width;
	        track.height = config.height;
	        track.sps = [currentNal.data];
	        track.profileIdc = config.profileIdc;
	        track.levelIdc = config.levelIdc;
	        track.profileCompatibility = config.profileCompatibility;
	        h264Frame.endNalUnit();
	      } else if (currentNal.nalUnitType === 'pic_parameter_set_rbsp') {
	        track.newMetadata = true;
	        track.pps = [currentNal.data];
	        h264Frame.endNalUnit();
	      } else if (currentNal.nalUnitType === 'access_unit_delimiter_rbsp') {
	        if (h264Frame) {
	          this.finishFrame(tags, h264Frame);
	        }
	        h264Frame = new FlvTag(FlvTag.VIDEO_TAG);
	        h264Frame.pts = currentNal.pts;
	        h264Frame.dts = currentNal.dts;
	      } else {
	        if (currentNal.nalUnitType === 'slice_layer_without_partitioning_rbsp_idr') {
	          // the current sample is a key frame
	          h264Frame.keyFrame = true;
	        }
	        h264Frame.endNalUnit();
	      }
	      h264Frame.startNalUnit();
	      h264Frame.writeBytes(currentNal.data);
	    }
	    if (h264Frame) {
	      this.finishFrame(tags, h264Frame);
	    }
	
	    this.trigger('data', { track: track, tags: tags.list });
	
	    // Continue with the flush process now
	    this.trigger('done', 'VideoSegmentStream');
	  };
	};
	
	_VideoSegmentStream.prototype = new Stream();
	
	/**
	 * An object that incrementally transmuxes MPEG2 Trasport Stream
	 * chunks into an FLV.
	 */
	_Transmuxer = function Transmuxer(options) {
	  var self = this,
	      packetStream,
	      parseStream,
	      elementaryStream,
	      videoTimestampRolloverStream,
	      audioTimestampRolloverStream,
	      timedMetadataTimestampRolloverStream,
	      adtsStream,
	      h264Stream,
	      videoSegmentStream,
	      audioSegmentStream,
	      captionStream,
	      coalesceStream;
	
	  _Transmuxer.prototype.init.call(this);
	
	  options = options || {};
	
	  // expose the metadata stream
	  this.metadataStream = new m2ts.MetadataStream();
	
	  options.metadataStream = this.metadataStream;
	
	  // set up the parsing pipeline
	  packetStream = new m2ts.TransportPacketStream();
	  parseStream = new m2ts.TransportParseStream();
	  elementaryStream = new m2ts.ElementaryStream();
	  videoTimestampRolloverStream = new m2ts.TimestampRolloverStream('video');
	  audioTimestampRolloverStream = new m2ts.TimestampRolloverStream('audio');
	  timedMetadataTimestampRolloverStream = new m2ts.TimestampRolloverStream('timed-metadata');
	
	  adtsStream = new AdtsStream();
	  h264Stream = new H264Stream();
	  coalesceStream = new CoalesceStream(options);
	
	  // disassemble MPEG2-TS packets into elementary streams
	  packetStream.pipe(parseStream).pipe(elementaryStream);
	
	  // !!THIS ORDER IS IMPORTANT!!
	  // demux the streams
	  elementaryStream.pipe(videoTimestampRolloverStream).pipe(h264Stream);
	  elementaryStream.pipe(audioTimestampRolloverStream).pipe(adtsStream);
	
	  elementaryStream.pipe(timedMetadataTimestampRolloverStream).pipe(this.metadataStream).pipe(coalesceStream);
	  // if CEA-708 parsing is available, hook up a caption stream
	  captionStream = new m2ts.CaptionStream();
	  h264Stream.pipe(captionStream).pipe(coalesceStream);
	
	  // hook up the segment streams once track metadata is delivered
	  elementaryStream.on('data', function (data) {
	    var i, videoTrack, audioTrack;
	
	    if (data.type === 'metadata') {
	      i = data.tracks.length;
	
	      // scan the tracks listed in the metadata
	      while (i--) {
	        if (data.tracks[i].type === 'video') {
	          videoTrack = data.tracks[i];
	        } else if (data.tracks[i].type === 'audio') {
	          audioTrack = data.tracks[i];
	        }
	      }
	
	      // hook up the video segment stream to the first track with h264 data
	      if (videoTrack && !videoSegmentStream) {
	        coalesceStream.numberOfTracks++;
	        videoSegmentStream = new _VideoSegmentStream(videoTrack);
	
	        // Set up the final part of the video pipeline
	        h264Stream.pipe(videoSegmentStream).pipe(coalesceStream);
	      }
	
	      if (audioTrack && !audioSegmentStream) {
	        // hook up the audio segment stream to the first track with aac data
	        coalesceStream.numberOfTracks++;
	        audioSegmentStream = new _AudioSegmentStream(audioTrack);
	
	        // Set up the final part of the audio pipeline
	        adtsStream.pipe(audioSegmentStream).pipe(coalesceStream);
	      }
	    }
	  });
	
	  // feed incoming data to the front of the parsing pipeline
	  this.push = function (data) {
	    packetStream.push(data);
	  };
	
	  // flush any buffered data
	  this.flush = function () {
	    // Start at the top of the pipeline and flush all pending work
	    packetStream.flush();
	  };
	
	  // Re-emit any data coming from the coalesce stream to the outside world
	  coalesceStream.on('data', function (event) {
	    self.trigger('data', event);
	  });
	
	  // Let the consumer know we have finished flushing the entire pipeline
	  coalesceStream.on('done', function () {
	    self.trigger('done');
	  });
	};
	_Transmuxer.prototype = new Stream();
	
	// forward compatibility
	module.exports = _Transmuxer;

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * mux.js
	 *
	 * Copyright (c) 2015 Brightcove
	 * All rights reserved.
	 *
	 * Reads in-band caption information from a video elementary
	 * stream. Captions must follow the CEA-708 standard for injection
	 * into an MPEG-2 transport streams.
	 * @see https://en.wikipedia.org/wiki/CEA-708
	 */
	
	'use strict';
	
	// -----------------
	// Link To Transport
	// -----------------
	
	// Supplemental enhancement information (SEI) NAL units have a
	// payload type field to indicate how they are to be
	// interpreted. CEAS-708 caption content is always transmitted with
	// payload type 0x04.
	
	var USER_DATA_REGISTERED_ITU_T_T35 = 4,
	    RBSP_TRAILING_BITS = 128,
	    Stream = __webpack_require__(11);
	
	/**
	  * Parse a supplemental enhancement information (SEI) NAL unit.
	  * Stops parsing once a message of type ITU T T35 has been found.
	  *
	  * @param bytes {Uint8Array} the bytes of a SEI NAL unit
	  * @return {object} the parsed SEI payload
	  * @see Rec. ITU-T H.264, 7.3.2.3.1
	  */
	var parseSei = function parseSei(bytes) {
	  var i = 0,
	      result = {
	    payloadType: -1,
	    payloadSize: 0
	  },
	      payloadType = 0,
	      payloadSize = 0;
	
	  // go through the sei_rbsp parsing each each individual sei_message
	  while (i < bytes.byteLength) {
	    // stop once we have hit the end of the sei_rbsp
	    if (bytes[i] === RBSP_TRAILING_BITS) {
	      break;
	    }
	
	    // Parse payload type
	    while (bytes[i] === 0xFF) {
	      payloadType += 255;
	      i++;
	    }
	    payloadType += bytes[i++];
	
	    // Parse payload size
	    while (bytes[i] === 0xFF) {
	      payloadSize += 255;
	      i++;
	    }
	    payloadSize += bytes[i++];
	
	    // this sei_message is a 608/708 caption so save it and break
	    // there can only ever be one caption message in a frame's sei
	    if (!result.payload && payloadType === USER_DATA_REGISTERED_ITU_T_T35) {
	      result.payloadType = payloadType;
	      result.payloadSize = payloadSize;
	      result.payload = bytes.subarray(i, i + payloadSize);
	      break;
	    }
	
	    // skip the payload and parse the next message
	    i += payloadSize;
	    payloadType = 0;
	    payloadSize = 0;
	  }
	
	  return result;
	};
	
	// see ANSI/SCTE 128-1 (2013), section 8.1
	var parseUserData = function parseUserData(sei) {
	  // itu_t_t35_contry_code must be 181 (United States) for
	  // captions
	  if (sei.payload[0] !== 181) {
	    return null;
	  }
	
	  // itu_t_t35_provider_code should be 49 (ATSC) for captions
	  if ((sei.payload[1] << 8 | sei.payload[2]) !== 49) {
	    return null;
	  }
	
	  // the user_identifier should be "GA94" to indicate ATSC1 data
	  if (String.fromCharCode(sei.payload[3], sei.payload[4], sei.payload[5], sei.payload[6]) !== 'GA94') {
	    return null;
	  }
	
	  // finally, user_data_type_code should be 0x03 for caption data
	  if (sei.payload[7] !== 0x03) {
	    return null;
	  }
	
	  // return the user_data_type_structure and strip the trailing
	  // marker bits
	  return sei.payload.subarray(8, sei.payload.length - 1);
	};
	
	// see CEA-708-D, section 4.4
	var parseCaptionPackets = function parseCaptionPackets(pts, userData) {
	  var results = [],
	      i,
	      count,
	      offset,
	      data;
	
	  // if this is just filler, return immediately
	  if (!(userData[0] & 0x40)) {
	    return results;
	  }
	
	  // parse out the cc_data_1 and cc_data_2 fields
	  count = userData[0] & 0x1f;
	  for (i = 0; i < count; i++) {
	    offset = i * 3;
	    data = {
	      type: userData[offset + 2] & 0x03,
	      pts: pts
	    };
	
	    // capture cc data when cc_valid is 1
	    if (userData[offset + 2] & 0x04) {
	      data.ccData = userData[offset + 3] << 8 | userData[offset + 4];
	      results.push(data);
	    }
	  }
	  return results;
	};
	
	var CaptionStream = function CaptionStream() {
	  CaptionStream.prototype.init.call(this);
	
	  this.captionPackets_ = [];
	
	  this.field1_ = new Cea608Stream(); // eslint-disable-line no-use-before-define
	
	  // forward data and done events from field1_ to this CaptionStream
	  this.field1_.on('data', this.trigger.bind(this, 'data'));
	  this.field1_.on('done', this.trigger.bind(this, 'done'));
	};
	CaptionStream.prototype = new Stream();
	CaptionStream.prototype.push = function (event) {
	  var sei, userData;
	
	  // only examine SEI NALs
	  if (event.nalUnitType !== 'sei_rbsp') {
	    return;
	  }
	
	  // parse the sei
	  sei = parseSei(event.escapedRBSP);
	
	  // ignore everything but user_data_registered_itu_t_t35
	  if (sei.payloadType !== USER_DATA_REGISTERED_ITU_T_T35) {
	    return;
	  }
	
	  // parse out the user data payload
	  userData = parseUserData(sei);
	
	  // ignore unrecognized userData
	  if (!userData) {
	    return;
	  }
	
	  /*Mactrix replace
	    // parse out CC data packets and save them for later
	    this.captionPackets_ = this.captionPackets_.concat(parseCaptionPackets(event.pts, userData));
	  */
	  //Mactrix changes begin: sending back the sei userData so it can be decoded externally
	  var captionPacket = { bytes: userData, pts: event.pts, type: sei.payloadType };
	  this.captionPackets_.push(captionPacket);
	  //Mactrix changes end
	};
	
	/*Mactrix replace
	CaptionStream.prototype.flush = function() {
	  // make sure we actually parsed captions before proceeding
	  if (!this.captionPackets_.length) {
	    this.field1_.flush();
	    return;
	  }
	
	  // In Chrome, the Array#sort function is not stable so add a
	  // presortIndex that we can use to ensure we get a stable-sort
	  this.captionPackets_.forEach(function(elem, idx) {
	    elem.presortIndex = idx;
	  });
	
	  // sort caption byte-pairs based on their PTS values
	  this.captionPackets_.sort(function(a, b) {
	    if (a.pts === b.pts) {
	      return a.presortIndex - b.presortIndex;
	    }
	    return a.pts - b.pts;
	  });
	
	  // Push each caption into Cea608Stream
	  this.captionPackets_.forEach(this.field1_.push, this.field1_);
	
	  this.captionPackets_.length = 0;
	  this.field1_.flush();
	  return;
	};
	*/
	//Mactrix changes begin: bypassing caption decoding
	CaptionStream.prototype.flush = function () {
	  if (!this.captionPackets_.length) {
	    return;
	  }
	
	  // In Chrome, the Array#sort function is not stable so add a
	  // presortIndex that we can use to ensure we get a stable-sort
	  this.captionPackets_.forEach(function (elem, idx) {
	    elem.presortIndex = idx;
	  });
	
	  // sort caption byte-pairs based on their PTS values
	  this.captionPackets_.sort(function (a, b) {
	    if (a.pts === b.pts) {
	      return a.presortIndex - b.presortIndex;
	    }
	    return a.pts - b.pts;
	  });
	
	  if (this.captionPackets_.length > 0) {
	    this.trigger('data', {
	      userData: this.captionPackets_,
	      text: 'captions'
	    });
	  }
	
	  this.captionPackets_.length = 0;
	};
	//Mactrix changes end
	
	// ----------------------
	// Session to Application
	// ----------------------
	
	var BASIC_CHARACTER_TRANSLATION = {
	  0x2a: 0xe1,
	  0x5c: 0xe9,
	  0x5e: 0xed,
	  0x5f: 0xf3,
	  0x60: 0xfa,
	  0x7b: 0xe7,
	  0x7c: 0xf7,
	  0x7d: 0xd1,
	  0x7e: 0xf1,
	  0x7f: 0x2588
	};
	
	var getCharFromCode = function getCharFromCode(code) {
	  if (code === null) {
	    return '';
	  }
	  code = BASIC_CHARACTER_TRANSLATION[code] || code;
	  return String.fromCharCode(code);
	};
	
	// Constants for the byte codes recognized by Cea608Stream. This
	// list is not exhaustive. For a more comprehensive listing and
	// semantics see
	// http://www.gpo.gov/fdsys/pkg/CFR-2010-title47-vol1/pdf/CFR-2010-title47-vol1-sec15-119.pdf
	var PADDING = 0x0000,
	
	
	// Pop-on Mode
	RESUME_CAPTION_LOADING = 0x1420,
	    END_OF_CAPTION = 0x142f,
	
	
	// Roll-up Mode
	ROLL_UP_2_ROWS = 0x1425,
	    ROLL_UP_3_ROWS = 0x1426,
	    ROLL_UP_4_ROWS = 0x1427,
	    CARRIAGE_RETURN = 0x142d,
	
	// Erasure
	BACKSPACE = 0x1421,
	    ERASE_DISPLAYED_MEMORY = 0x142c,
	    ERASE_NON_DISPLAYED_MEMORY = 0x142e;
	
	// the index of the last row in a CEA-608 display buffer
	var BOTTOM_ROW = 14;
	// CEA-608 captions are rendered onto a 34x15 matrix of character
	// cells. The "bottom" row is the last element in the outer array.
	var createDisplayBuffer = function createDisplayBuffer() {
	  var result = [],
	      i = BOTTOM_ROW + 1;
	  while (i--) {
	    result.push('');
	  }
	  return result;
	};
	
	var Cea608Stream = function Cea608Stream() {
	  Cea608Stream.prototype.init.call(this);
	
	  this.mode_ = 'popOn';
	  // When in roll-up mode, the index of the last row that will
	  // actually display captions. If a caption is shifted to a row
	  // with a lower index than this, it is cleared from the display
	  // buffer
	  this.topRow_ = 0;
	  this.startPts_ = 0;
	  this.displayed_ = createDisplayBuffer();
	  this.nonDisplayed_ = createDisplayBuffer();
	  this.lastControlCode_ = null;
	
	  this.push = function (packet) {
	    // Ignore other channels
	    if (packet.type !== 0) {
	      return;
	    }
	    var data, swap, char0, char1;
	    // remove the parity bits
	    data = packet.ccData & 0x7f7f;
	
	    // ignore duplicate control codes
	    if (data === this.lastControlCode_) {
	      this.lastControlCode_ = null;
	      return;
	    }
	
	    // Store control codes
	    if ((data & 0xf000) === 0x1000) {
	      this.lastControlCode_ = data;
	    } else {
	      this.lastControlCode_ = null;
	    }
	
	    switch (data) {
	      case PADDING:
	        break;
	      case RESUME_CAPTION_LOADING:
	        this.mode_ = 'popOn';
	        break;
	      case END_OF_CAPTION:
	        // if a caption was being displayed, it's gone now
	        this.flushDisplayed(packet.pts);
	
	        // flip memory
	        swap = this.displayed_;
	        this.displayed_ = this.nonDisplayed_;
	        this.nonDisplayed_ = swap;
	
	        // start measuring the time to display the caption
	        this.startPts_ = packet.pts;
	        break;
	
	      case ROLL_UP_2_ROWS:
	        this.topRow_ = BOTTOM_ROW - 1;
	        this.mode_ = 'rollUp';
	        break;
	      case ROLL_UP_3_ROWS:
	        this.topRow_ = BOTTOM_ROW - 2;
	        this.mode_ = 'rollUp';
	        break;
	      case ROLL_UP_4_ROWS:
	        this.topRow_ = BOTTOM_ROW - 3;
	        this.mode_ = 'rollUp';
	        break;
	      case CARRIAGE_RETURN:
	        this.flushDisplayed(packet.pts);
	        this.shiftRowsUp_();
	        this.startPts_ = packet.pts;
	        break;
	
	      case BACKSPACE:
	        if (this.mode_ === 'popOn') {
	          this.nonDisplayed_[BOTTOM_ROW] = this.nonDisplayed_[BOTTOM_ROW].slice(0, -1);
	        } else {
	          this.displayed_[BOTTOM_ROW] = this.displayed_[BOTTOM_ROW].slice(0, -1);
	        }
	        break;
	      case ERASE_DISPLAYED_MEMORY:
	        this.flushDisplayed(packet.pts);
	        this.displayed_ = createDisplayBuffer();
	        break;
	      case ERASE_NON_DISPLAYED_MEMORY:
	        this.nonDisplayed_ = createDisplayBuffer();
	        break;
	      default:
	        char0 = data >>> 8;
	        char1 = data & 0xff;
	
	        // Look for a Channel 1 Preamble Address Code
	        if (char0 >= 0x10 && char0 <= 0x17 && char1 >= 0x40 && char1 <= 0x7F && (char0 !== 0x10 || char1 < 0x60)) {
	          // Follow Safari's lead and replace the PAC with a space
	          char0 = 0x20;
	          // we only want one space so make the second character null
	          // which will get become '' in getCharFromCode
	          char1 = null;
	        }
	
	        // Look for special character sets
	        if ((char0 === 0x11 || char0 === 0x19) && char1 >= 0x30 && char1 <= 0x3F) {
	          // Put in eigth note and space
	          char0 = 0x266A;
	          char1 = '';
	        }
	
	        // ignore unsupported control codes
	        if ((char0 & 0xf0) === 0x10) {
	          return;
	        }
	
	        // remove null chars
	        if (char0 === 0x00) {
	          char0 = null;
	        }
	        if (char1 === 0x00) {
	          char1 = null;
	        }
	
	        // character handling is dependent on the current mode
	        this[this.mode_](packet.pts, char0, char1);
	        break;
	    }
	  };
	};
	Cea608Stream.prototype = new Stream();
	// Trigger a cue point that captures the current state of the
	// display buffer
	Cea608Stream.prototype.flushDisplayed = function (pts) {
	  var content = this.displayed_
	  // remove spaces from the start and end of the string
	  .map(function (row) {
	    return row.trim();
	  })
	  // remove empty rows
	  .filter(function (row) {
	    return row.length;
	  })
	  // combine all text rows to display in one cue
	  .join('\n');
	
	  if (content.length) {
	    this.trigger('data', {
	      startPts: this.startPts_,
	      endPts: pts,
	      text: content
	    });
	  }
	};
	
	// Mode Implementations
	Cea608Stream.prototype.popOn = function (pts, char0, char1) {
	  var baseRow = this.nonDisplayed_[BOTTOM_ROW];
	
	  // buffer characters
	  baseRow += getCharFromCode(char0);
	  baseRow += getCharFromCode(char1);
	  this.nonDisplayed_[BOTTOM_ROW] = baseRow;
	};
	
	Cea608Stream.prototype.rollUp = function (pts, char0, char1) {
	  var baseRow = this.displayed_[BOTTOM_ROW];
	  if (baseRow === '') {
	    // we're starting to buffer new display input, so flush out the
	    // current display
	    this.flushDisplayed(pts);
	
	    this.startPts_ = pts;
	  }
	
	  baseRow += getCharFromCode(char0);
	  baseRow += getCharFromCode(char1);
	
	  this.displayed_[BOTTOM_ROW] = baseRow;
	};
	Cea608Stream.prototype.shiftRowsUp_ = function () {
	  var i;
	  // clear out inactive rows
	  for (i = 0; i < this.topRow_; i++) {
	    this.displayed_[i] = '';
	  }
	  // shift displayed rows up
	  for (i = this.topRow_; i < BOTTOM_ROW; i++) {
	    this.displayed_[i] = this.displayed_[i + 1];
	  }
	  // clear out the bottom row
	  this.displayed_[BOTTOM_ROW] = '';
	};
	
	// exports
	module.exports = {
	  CaptionStream: CaptionStream,
	  Cea608Stream: Cea608Stream
	};

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(45);

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _logger = __webpack_require__(1);
	
	//Mactrix line added
	/**
	 * Accepts program elementary stream (PES) data events and parses out
	 * ID3 metadata from them, if present.
	 * @see http://id3.org/id3v2.3.0
	 */
	'use strict';
	var Stream = __webpack_require__(11),
	    StreamTypes = __webpack_require__(26),
	
	// return a percent-encoded representation of the specified byte range
	// @see http://en.wikipedia.org/wiki/Percent-encoding
	percentEncode = function percentEncode(bytes, start, end) {
	  var i,
	      result = '';
	  for (i = start; i < end; i++) {
	    result += '%' + ('00' + bytes[i].toString(16)).slice(-2);
	  }
	  return result;
	},
	
	// return the string representation of the specified byte range,
	// interpreted as UTf-8.
	parseUtf8 = function parseUtf8(bytes, start, end) {
	  return decodeURIComponent(percentEncode(bytes, start, end));
	},
	
	// return the string representation of the specified byte range,
	// interpreted as ISO-8859-1.
	parseIso88591 = function parseIso88591(bytes, start, end) {
	  return unescape(percentEncode(bytes, start, end)); // jshint ignore:line
	},
	    parseSyncSafeInteger = function parseSyncSafeInteger(data) {
	  return data[0] << 21 | data[1] << 14 | data[2] << 7 | data[3];
	},
	    tagParsers = {
	  TXXX: function TXXX(tag) {
	    var i;
	    if (tag.data[0] !== 3) {
	      // ignore frames with unrecognized character encodings
	      return;
	    }
	
	    for (i = 1; i < tag.data.length; i++) {
	      if (tag.data[i] === 0) {
	        // parse the text fields
	        tag.description = parseUtf8(tag.data, 1, i);
	        // do not include the null terminator in the tag value
	        tag.value = parseUtf8(tag.data, i + 1, tag.data.length - 1);
	        break;
	      }
	    }
	    tag.data = tag.value;
	  },
	  WXXX: function WXXX(tag) {
	    var i;
	    if (tag.data[0] !== 3) {
	      // ignore frames with unrecognized character encodings
	      return;
	    }
	
	    for (i = 1; i < tag.data.length; i++) {
	      if (tag.data[i] === 0) {
	        // parse the description and URL fields
	        tag.description = parseUtf8(tag.data, 1, i);
	        tag.url = parseUtf8(tag.data, i + 1, tag.data.length);
	        break;
	      }
	    }
	  },
	  PRIV: function PRIV(tag) {
	    var i;
	
	    for (i = 0; i < tag.data.length; i++) {
	      if (tag.data[i] === 0) {
	        // parse the description and URL fields
	        tag.owner = parseIso88591(tag.data, 0, i);
	        break;
	      }
	    }
	    tag.privateData = tag.data.subarray(i + 1);
	    tag.data = tag.privateData;
	  }
	},
	    _MetadataStream;
	
	_MetadataStream = function MetadataStream(options) {
	  var settings = {
	    debug: !!(options && options.debug),
	
	    // the bytes of the program-level descriptor field in MP2T
	    // see ISO/IEC 13818-1:2013 (E), section 2.6 "Program and
	    // program element descriptors"
	    descriptor: options && options.descriptor
	  },
	
	  // the total size in bytes of the ID3 tag being parsed
	  tagSize = 0,
	
	  // tag data that is not complete enough to be parsed
	  buffer = [],
	
	  // the total number of bytes currently in the buffer
	  bufferSize = 0,
	      i;
	
	  _MetadataStream.prototype.init.call(this);
	
	  // calculate the text track in-band metadata track dispatch type
	  // https://html.spec.whatwg.org/multipage/embedded-content.html#steps-to-expose-a-media-resource-specific-text-track
	  this.dispatchType = StreamTypes.METADATA_STREAM_TYPE.toString(16);
	  if (settings.descriptor) {
	    for (i = 0; i < settings.descriptor.length; i++) {
	      this.dispatchType += ('00' + settings.descriptor[i].toString(16)).slice(-2);
	    }
	  }
	
	  this.push = function (chunk) {
	    var tag, frameStart, frameSize, frame, i, frameHeader;
	    if (chunk.type !== 'timed-metadata') {
	      return;
	    }
	
	    // if data_alignment_indicator is set in the PES header,
	    // we must have the start of a new ID3 tag. Assume anything
	    // remaining in the buffer was malformed and throw it out
	    if (chunk.dataAlignmentIndicator) {
	      bufferSize = 0;
	      buffer.length = 0;
	    }
	
	    // ignore events that don't look like ID3 data
	    if (buffer.length === 0 && (chunk.data.length < 10 || chunk.data[0] !== 'I'.charCodeAt(0) || chunk.data[1] !== 'D'.charCodeAt(0) || chunk.data[2] !== '3'.charCodeAt(0))) {
	      if (settings.debug) {
	        /*
	              // eslint-disable-next-line no-console
	              console.log('Skipping unrecognized metadata packet');
	        */
	        _logger.logger.log('Skipping unrecognized metadata packet'); //Mactrix line changed
	      }
	      return;
	    }
	
	    // add this chunk to the data we've collected so far
	
	    buffer.push(chunk);
	    bufferSize += chunk.data.byteLength;
	
	    // grab the size of the entire frame from the ID3 header
	    if (buffer.length === 1) {
	      // the frame size is transmitted as a 28-bit integer in the
	      // last four bytes of the ID3 header.
	      // The most significant bit of each byte is dropped and the
	      // results concatenated to recover the actual value.
	      tagSize = parseSyncSafeInteger(chunk.data.subarray(6, 10));
	
	      // ID3 reports the tag size excluding the header but it's more
	      // convenient for our comparisons to include it
	      tagSize += 10;
	    }
	
	    // if the entire frame has not arrived, wait for more data
	    if (bufferSize < tagSize) {
	      return;
	    }
	
	    // collect the entire frame so it can be parsed
	    tag = {
	      data: new Uint8Array(tagSize),
	      frames: [],
	      pts: buffer[0].pts,
	      dts: buffer[0].dts
	    };
	    for (i = 0; i < tagSize;) {
	      tag.data.set(buffer[0].data.subarray(0, tagSize - i), i);
	      i += buffer[0].data.byteLength;
	      bufferSize -= buffer[0].data.byteLength;
	      buffer.shift();
	    }
	
	    // find the start of the first frame and the end of the tag
	    frameStart = 10;
	    if (tag.data[5] & 0x40) {
	      // advance the frame start past the extended header
	      frameStart += 4; // header size field
	      frameStart += parseSyncSafeInteger(tag.data.subarray(10, 14));
	
	      // clip any padding off the end
	      tagSize -= parseSyncSafeInteger(tag.data.subarray(16, 20));
	    }
	
	    // parse one or more ID3 frames
	    // http://id3.org/id3v2.3.0#ID3v2_frame_overview
	    do {
	      // determine the number of bytes in this frame
	      frameSize = parseSyncSafeInteger(tag.data.subarray(frameStart + 4, frameStart + 8));
	      if (frameSize < 1) {
	        /*
	               // eslint-disable-next-line no-console
	              return console.log('Malformed ID3 frame encountered. Skipping metadata parsing.');
	        */
	        return _logger.logger.log('Malformed ID3 frame encountered. Skipping metadata parsing.'); //Mactrix line changed
	      }
	      frameHeader = String.fromCharCode(tag.data[frameStart], tag.data[frameStart + 1], tag.data[frameStart + 2], tag.data[frameStart + 3]);
	
	      frame = {
	        id: frameHeader,
	        data: tag.data.subarray(frameStart + 10, frameStart + frameSize + 10)
	      };
	      frame.key = frame.id;
	      if (tagParsers[frame.id]) {
	        tagParsers[frame.id](frame);
	
	        // handle the special PRIV frame used to indicate the start
	        // time for raw AAC data
	        if (frame.owner === 'com.apple.streaming.transportStreamTimestamp') {
	          var d = frame.data,
	              size = (d[3] & 0x01) << 30 | d[4] << 22 | d[5] << 14 | d[6] << 6 | d[7] >>> 2;
	
	          size *= 4;
	          size += d[7] & 0x03;
	          frame.timeStamp = size;
	          // in raw AAC, all subsequent data will be timestamped based
	          // on the value of this frame
	          // we couldn't have known the appropriate pts and dts before
	          // parsing this ID3 tag so set those values now
	          if (tag.pts === undefined && tag.dts === undefined) {
	            tag.pts = frame.timeStamp;
	            tag.dts = frame.timeStamp;
	          }
	          this.trigger('timestamp', frame);
	        }
	      }
	      tag.frames.push(frame);
	
	      frameStart += 10; // advance past the frame header
	      frameStart += frameSize; // advance past the frame body
	    } while (frameStart < tagSize);
	
	    //These are more for syncing the stream, no need to output
	    if (frame.owner !== 'com.apple.streaming.transportStreamTimestamp') {
	      this.trigger('data', tag);
	    }
	  };
	};
	_MetadataStream.prototype = new Stream();
	
	module.exports = _MetadataStream;

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * mux.js
	 *
	 * Copyright (c) 2016 Brightcove
	 * All rights reserved.
	 *
	 * Utilities to detect basic properties and metadata about TS Segments.
	 */
	'use strict';
	
	var StreamTypes = __webpack_require__(26);
	
	var parsePid = function parsePid(packet) {
	  var pid = packet[1] & 0x1f;
	  pid <<= 8;
	  pid |= packet[2];
	  return pid;
	};
	
	var parsePayloadUnitStartIndicator = function parsePayloadUnitStartIndicator(packet) {
	  return !!(packet[1] & 0x40);
	};
	
	var parseAdaptionField = function parseAdaptionField(packet) {
	  var offset = 0;
	  // if an adaption field is present, its length is specified by the
	  // fifth byte of the TS packet header. The adaptation field is
	  // used to add stuffing to PES packets that don't fill a complete
	  // TS packet, and to specify some forms of timing and control data
	  // that we do not currently use.
	  if ((packet[3] & 0x30) >>> 4 > 0x01) {
	    offset += packet[4] + 1;
	  }
	  return offset;
	};
	
	var parseType = function parseType(packet, pmtPid) {
	  var pid = parsePid(packet);
	  if (pid === 0) {
	    return 'pat';
	  } else if (pid === pmtPid) {
	    return 'pmt';
	  } else if (pmtPid) {
	    return 'pes';
	  }
	  return null;
	};
	
	var parsePat = function parsePat(packet) {
	  var pusi = parsePayloadUnitStartIndicator(packet);
	  var offset = 4 + parseAdaptionField(packet);
	
	  if (pusi) {
	    offset += packet[offset] + 1;
	  }
	
	  return (packet[offset + 10] & 0x1f) << 8 | packet[offset + 11];
	};
	
	var parsePmt = function parsePmt(packet) {
	  var programMapTable = {};
	  var pusi = parsePayloadUnitStartIndicator(packet);
	  var payloadOffset = 4 + parseAdaptionField(packet);
	
	  if (pusi) {
	    payloadOffset += packet[payloadOffset] + 1;
	  }
	
	  // PMTs can be sent ahead of the time when they should actually
	  // take effect. We don't believe this should ever be the case
	  // for HLS but we'll ignore "forward" PMT declarations if we see
	  // them. Future PMT declarations have the current_next_indicator
	  // set to zero.
	  if (!(packet[payloadOffset + 5] & 0x01)) {
	    return;
	  }
	
	  var sectionLength, tableEnd, programInfoLength;
	  // the mapping table ends at the end of the current section
	  sectionLength = (packet[payloadOffset + 1] & 0x0f) << 8 | packet[payloadOffset + 2];
	  tableEnd = 3 + sectionLength - 4;
	
	  // to determine where the table is, we have to figure out how
	  // long the program info descriptors are
	  programInfoLength = (packet[payloadOffset + 10] & 0x0f) << 8 | packet[payloadOffset + 11];
	
	  // advance the offset to the first entry in the mapping table
	  var offset = 12 + programInfoLength;
	  while (offset < tableEnd) {
	    var i = payloadOffset + offset;
	    // add an entry that maps the elementary_pid to the stream_type
	    programMapTable[(packet[i + 1] & 0x1F) << 8 | packet[i + 2]] = packet[i];
	
	    // move to the next table entry
	    // skip past the elementary stream descriptors, if present
	    offset += ((packet[i + 3] & 0x0F) << 8 | packet[i + 4]) + 5;
	  }
	  return programMapTable;
	};
	
	var parsePesType = function parsePesType(packet, programMapTable) {
	  var pid = parsePid(packet);
	  var type = programMapTable[pid];
	  switch (type) {
	    case StreamTypes.H264_STREAM_TYPE:
	      return 'video';
	    case StreamTypes.ADTS_STREAM_TYPE:
	      return 'audio';
	    case StreamTypes.METADATA_STREAM_TYPE:
	      return 'timed-metadata';
	    default:
	      return null;
	  }
	};
	
	var parsePesTime = function parsePesTime(packet) {
	  var pusi = parsePayloadUnitStartIndicator(packet);
	  if (!pusi) {
	    return null;
	  }
	
	  var offset = 4 + parseAdaptionField(packet);
	
	  var pes = {};
	  var ptsDtsFlags;
	
	  // PES packets may be annotated with a PTS value, or a PTS value
	  // and a DTS value. Determine what combination of values is
	  // available to work with.
	  ptsDtsFlags = packet[offset + 7];
	
	  // PTS and DTS are normally stored as a 33-bit number.  Javascript
	  // performs all bitwise operations on 32-bit integers but javascript
	  // supports a much greater range (52-bits) of integer using standard
	  // mathematical operations.
	  // We construct a 31-bit value using bitwise operators over the 31
	  // most significant bits and then multiply by 4 (equal to a left-shift
	  // of 2) before we add the final 2 least significant bits of the
	  // timestamp (equal to an OR.)
	  if (ptsDtsFlags & 0xC0) {
	    // the PTS and DTS are not written out directly. For information
	    // on how they are encoded, see
	    // http://dvd.sourceforge.net/dvdinfo/pes-hdr.html
	    pes.pts = (packet[offset + 9] & 0x0E) << 27 | (packet[offset + 10] & 0xFF) << 20 | (packet[offset + 11] & 0xFE) << 12 | (packet[offset + 12] & 0xFF) << 5 | (packet[offset + 13] & 0xFE) >>> 3;
	    pes.pts *= 4; // Left shift by 2
	    pes.pts += (packet[offset + 13] & 0x06) >>> 1; // OR by the two LSBs
	    pes.dts = pes.pts;
	    if (ptsDtsFlags & 0x40) {
	      pes.dts = (packet[offset + 14] & 0x0E) << 27 | (packet[offset + 15] & 0xFF) << 20 | (packet[offset + 16] & 0xFE) << 12 | (packet[offset + 17] & 0xFF) << 5 | (packet[offset + 18] & 0xFE) >>> 3;
	      pes.dts *= 4; // Left shift by 2
	      pes.dts += (packet[offset + 18] & 0x06) >>> 1; // OR by the two LSBs
	    }
	  }
	  return pes;
	};
	
	var parseNalUnitType = function parseNalUnitType(type) {
	  switch (type) {
	    case 0x05:
	      return 'slice_layer_without_partitioning_rbsp_idr';
	    case 0x06:
	      return 'sei_rbsp';
	    case 0x07:
	      return 'seq_parameter_set_rbsp';
	    case 0x08:
	      return 'pic_parameter_set_rbsp';
	    case 0x09:
	      return 'access_unit_delimiter_rbsp';
	    default:
	      return null;
	  }
	};
	
	var videoPacketContainsKeyFrame = function videoPacketContainsKeyFrame(packet) {
	  var offset = 4 + parseAdaptionField(packet);
	  var frameBuffer = packet.subarray(offset);
	  var frameI = 0;
	  var frameSyncPoint = 0;
	  var foundKeyFrame = false;
	  var nalType;
	
	  // advance the sync point to a NAL start, if necessary
	  for (; frameSyncPoint < frameBuffer.byteLength - 3; frameSyncPoint++) {
	    if (frameBuffer[frameSyncPoint + 2] === 1) {
	      // the sync point is properly aligned
	      frameI = frameSyncPoint + 5;
	      break;
	    }
	  }
	
	  while (frameI < frameBuffer.byteLength) {
	    // look at the current byte to determine if we've hit the end of
	    // a NAL unit boundary
	    switch (frameBuffer[frameI]) {
	      case 0:
	        // skip past non-sync sequences
	        if (frameBuffer[frameI - 1] !== 0) {
	          frameI += 2;
	          break;
	        } else if (frameBuffer[frameI - 2] !== 0) {
	          frameI++;
	          break;
	        }
	
	        if (frameSyncPoint + 3 !== frameI - 2) {
	          nalType = parseNalUnitType(frameBuffer[frameSyncPoint + 3] & 0x1f);
	          if (nalType === 'slice_layer_without_partitioning_rbsp_idr') {
	            foundKeyFrame = true;
	          }
	        }
	
	        // drop trailing zeroes
	        do {
	          frameI++;
	        } while (frameBuffer[frameI] !== 1 && frameI < frameBuffer.length);
	        frameSyncPoint = frameI - 2;
	        frameI += 3;
	        break;
	      case 1:
	        // skip past non-sync sequences
	        if (frameBuffer[frameI - 1] !== 0 || frameBuffer[frameI - 2] !== 0) {
	          frameI += 3;
	          break;
	        }
	
	        nalType = parseNalUnitType(frameBuffer[frameSyncPoint + 3] & 0x1f);
	        if (nalType === 'slice_layer_without_partitioning_rbsp_idr') {
	          foundKeyFrame = true;
	        }
	        frameSyncPoint = frameI - 2;
	        frameI += 3;
	        break;
	      default:
	        // the current byte isn't a one or zero, so it cannot be part
	        // of a sync sequence
	        frameI += 3;
	        break;
	    }
	  }
	  frameBuffer = frameBuffer.subarray(frameSyncPoint);
	  frameI -= frameSyncPoint;
	  frameSyncPoint = 0;
	  // parse the final nal
	  if (frameBuffer && frameBuffer.byteLength > 3) {
	    nalType = parseNalUnitType(frameBuffer[frameSyncPoint + 3] & 0x1f);
	    if (nalType === 'slice_layer_without_partitioning_rbsp_idr') {
	      foundKeyFrame = true;
	    }
	  }
	
	  return foundKeyFrame;
	};
	
	module.exports = {
	  parseType: parseType,
	  parsePat: parsePat,
	  parsePmt: parsePmt,
	  parsePayloadUnitStartIndicator: parsePayloadUnitStartIndicator,
	  parsePesType: parsePesType,
	  parsePesTime: parsePesTime,
	  videoPacketContainsKeyFrame: videoPacketContainsKeyFrame
	};

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = {
	  generator: __webpack_require__(77),
	  Transmuxer: __webpack_require__(46).Transmuxer,
	  AudioSegmentStream: __webpack_require__(46).AudioSegmentStream,
	  VideoSegmentStream: __webpack_require__(46).VideoSegmentStream
	};

/***/ }),
/* 157 */
/***/ (function(module, exports) {

	/**
	 * mux.js
	 *
	 * Copyright (c) 2015 Brightcove
	 * All rights reserved.
	 *
	 * Utilities to detect basic properties and metadata about MP4s.
	 */
	'use strict';
	
	var _findBox, parseType, timescale, startTime;
	
	// Find the data for a box specified by its path
	_findBox = function findBox(data, path) {
	  var results = [],
	      i,
	      size,
	      type,
	      end,
	      subresults;
	
	  if (!path.length) {
	    // short-circuit the search for empty paths
	    return null;
	  }
	
	  for (i = 0; i < data.byteLength;) {
	    size = data[i] << 24;
	    size |= data[i + 1] << 16;
	    size |= data[i + 2] << 8;
	    size |= data[i + 3];
	
	    type = parseType(data.subarray(i + 4, i + 8));
	
	    end = size > 1 ? i + size : data.byteLength;
	
	    if (type === path[0]) {
	      if (path.length === 1) {
	        // this is the end of the path and we've found the box we were
	        // looking for
	        results.push(data.subarray(i + 8, end));
	      } else {
	        // recursively search for the next box along the path
	        subresults = _findBox(data.subarray(i + 8, end), path.slice(1));
	        if (subresults.length) {
	          results = results.concat(subresults);
	        }
	      }
	    }
	    i = end;
	  }
	
	  // we've finished searching all of data
	  return results;
	};
	
	/**
	 * Returns the string representation of an ASCII encoded four byte buffer.
	 * @param buffer {Uint8Array} a four-byte buffer to translate
	 * @return {string} the corresponding string
	 */
	parseType = function parseType(buffer) {
	  var result = '';
	  result += String.fromCharCode(buffer[0]);
	  result += String.fromCharCode(buffer[1]);
	  result += String.fromCharCode(buffer[2]);
	  result += String.fromCharCode(buffer[3]);
	  return result;
	};
	
	/**
	 * Parses an MP4 initialization segment and extracts the timescale
	 * values for any declared tracks. Timescale values indicate the
	 * number of clock ticks per second to assume for time-based values
	 * elsewhere in the MP4.
	 *
	 * To determine the start time of an MP4, you need two pieces of
	 * information: the timescale unit and the earliest base media decode
	 * time. Multiple timescales can be specified within an MP4 but the
	 * base media decode time is always expressed in the timescale from
	 * the media header box for the track:
	 * ```
	 * moov > trak > mdia > mdhd.timescale
	 * ```
	 * @param init {Uint8Array} the bytes of the init segment
	 * @return {object} a hash of track ids to timescale values or null if
	 * the init segment is malformed.
	 */
	timescale = function timescale(init) {
	  var result = {},
	      traks = _findBox(init, ['moov', 'trak']);
	
	  // mdhd timescale
	  return traks.reduce(function (result, trak) {
	    var tkhd, version, index, id, mdhd;
	
	    tkhd = _findBox(trak, ['tkhd'])[0];
	    if (!tkhd) {
	      return null;
	    }
	    version = tkhd[0];
	    index = version === 0 ? 12 : 20;
	    id = tkhd[index] << 24 | tkhd[index + 1] << 16 | tkhd[index + 2] << 8 | tkhd[index + 3];
	
	    mdhd = _findBox(trak, ['mdia', 'mdhd'])[0];
	    if (!mdhd) {
	      return null;
	    }
	    version = mdhd[0];
	    index = version === 0 ? 12 : 20;
	    result[id] = mdhd[index] << 24 | mdhd[index + 1] << 16 | mdhd[index + 2] << 8 | mdhd[index + 3];
	    return result;
	  }, result);
	};
	
	/**
	 * Determine the base media decode start time, in seconds, for an MP4
	 * fragment. If multiple fragments are specified, the earliest time is
	 * returned.
	 *
	 * The base media decode time can be parsed from track fragment
	 * metadata:
	 * ```
	 * moof > traf > tfdt.baseMediaDecodeTime
	 * ```
	 * It requires the timescale value from the mdhd to interpret.
	 *
	 * @param timescale {object} a hash of track ids to timescale values.
	 * @return {number} the earliest base media decode start time for the
	 * fragment, in seconds
	 */
	startTime = function startTime(timescale, fragment) {
	  var trafs, baseTimes, result;
	
	  // we need info from two childrend of each track fragment box
	  trafs = _findBox(fragment, ['moof', 'traf']);
	
	  // determine the start times for each track
	  baseTimes = [].concat.apply([], trafs.map(function (traf) {
	    return _findBox(traf, ['tfhd']).map(function (tfhd) {
	      var id, scale, baseTime;
	
	      // get the track id from the tfhd
	      id = tfhd[4] << 24 | tfhd[5] << 16 | tfhd[6] << 8 | tfhd[7];
	      // assume a 90kHz clock if no timescale was specified
	      scale = timescale[id] || 90e3;
	
	      // get the base media decode time from the tfdt
	      baseTime = _findBox(traf, ['tfdt']).map(function (tfdt) {
	        var version, result;
	
	        version = tfdt[0];
	        result = tfdt[4] << 24 | tfdt[5] << 16 | tfdt[6] << 8 | tfdt[7];
	        if (version === 1) {
	          result *= Math.pow(2, 32);
	          result += tfdt[8] << 24 | tfdt[9] << 16 | tfdt[10] << 8 | tfdt[11];
	        }
	        return result;
	      })[0];
	      baseTime = baseTime || Infinity;
	
	      // convert base time to seconds
	      return baseTime / scale;
	    });
	  }));
	
	  // return the minimum
	  result = Math.min.apply(null, baseTimes);
	  return isFinite(result) ? result : 0;
	};
	
	module.exports = {
	  parseType: parseType,
	  timescale: timescale,
	  startTime: startTime
	};

/***/ }),
/* 158 */
/***/ (function(module, exports) {

	'use strict';
	
	var tagTypes = {
	  0x08: 'audio',
	  0x09: 'video',
	  0x12: 'metadata'
	},
	    hex = function hex(val) {
	  return '0x' + ('00' + val.toString(16)).slice(-2).toUpperCase();
	},
	    hexStringList = function hexStringList(data) {
	  var arr = [],
	      i;
	
	  while (data.byteLength > 0) {
	    i = 0;
	    arr.push(hex(data[i++]));
	    data = data.subarray(i);
	  }
	  return arr.join(' ');
	},
	    parseAVCTag = function parseAVCTag(tag, obj) {
	  var avcPacketTypes = ['AVC Sequence Header', 'AVC NALU', 'AVC End-of-Sequence'],
	      compositionTime = tag[1] & parseInt('01111111', 2) << 16 | tag[2] << 8 | tag[3];
	
	  obj = obj || {};
	
	  obj.avcPacketType = avcPacketTypes[tag[0]];
	  obj.CompositionTime = tag[1] & parseInt('10000000', 2) ? -compositionTime : compositionTime;
	
	  if (tag[0] === 1) {
	    obj.nalUnitTypeRaw = hexStringList(tag.subarray(4, 100));
	  } else {
	    obj.data = hexStringList(tag.subarray(4));
	  }
	
	  return obj;
	},
	    parseVideoTag = function parseVideoTag(tag, obj) {
	  var frameTypes = ['Unknown', 'Keyframe (for AVC, a seekable frame)', 'Inter frame (for AVC, a nonseekable frame)', 'Disposable inter frame (H.263 only)', 'Generated keyframe (reserved for server use only)', 'Video info/command frame'],
	      codecID = tag[0] & parseInt('00001111', 2);
	
	  obj = obj || {};
	
	  obj.frameType = frameTypes[(tag[0] & parseInt('11110000', 2)) >>> 4];
	  obj.codecID = codecID;
	
	  if (codecID === 7) {
	    return parseAVCTag(tag.subarray(1), obj);
	  }
	  return obj;
	},
	    parseAACTag = function parseAACTag(tag, obj) {
	  var packetTypes = ['AAC Sequence Header', 'AAC Raw'];
	
	  obj = obj || {};
	
	  obj.aacPacketType = packetTypes[tag[0]];
	  obj.data = hexStringList(tag.subarray(1));
	
	  return obj;
	},
	    parseAudioTag = function parseAudioTag(tag, obj) {
	  var formatTable = ['Linear PCM, platform endian', 'ADPCM', 'MP3', 'Linear PCM, little endian', 'Nellymoser 16-kHz mono', 'Nellymoser 8-kHz mono', 'Nellymoser', 'G.711 A-law logarithmic PCM', 'G.711 mu-law logarithmic PCM', 'reserved', 'AAC', 'Speex', 'MP3 8-Khz', 'Device-specific sound'],
	      samplingRateTable = ['5.5-kHz', '11-kHz', '22-kHz', '44-kHz'],
	      soundFormat = (tag[0] & parseInt('11110000', 2)) >>> 4;
	
	  obj = obj || {};
	
	  obj.soundFormat = formatTable[soundFormat];
	  obj.soundRate = samplingRateTable[(tag[0] & parseInt('00001100', 2)) >>> 2];
	  obj.soundSize = (tag[0] & parseInt('00000010', 2)) >>> 1 ? '16-bit' : '8-bit';
	  obj.soundType = tag[0] & parseInt('00000001', 2) ? 'Stereo' : 'Mono';
	
	  if (soundFormat === 10) {
	    return parseAACTag(tag.subarray(1), obj);
	  }
	  return obj;
	},
	    parseGenericTag = function parseGenericTag(tag) {
	  return {
	    tagType: tagTypes[tag[0]],
	    dataSize: tag[1] << 16 | tag[2] << 8 | tag[3],
	    timestamp: tag[7] << 24 | tag[4] << 16 | tag[5] << 8 | tag[6],
	    streamID: tag[8] << 16 | tag[9] << 8 | tag[10]
	  };
	},
	    inspectFlvTag = function inspectFlvTag(tag) {
	  var header = parseGenericTag(tag);
	  switch (tag[0]) {
	    case 0x08:
	      parseAudioTag(tag.subarray(11), header);
	      break;
	    case 0x09:
	      parseVideoTag(tag.subarray(11), header);
	      break;
	    case 0x12:
	  }
	  return header;
	},
	    inspectFlv = function inspectFlv(bytes) {
	  var i = 9,
	      // header
	  dataSize,
	      parsedResults = [],
	      tag;
	
	  // traverse the tags
	  i += 4; // skip previous tag size
	  while (i < bytes.byteLength) {
	    dataSize = bytes[i + 1] << 16;
	    dataSize |= bytes[i + 2] << 8;
	    dataSize |= bytes[i + 3];
	    dataSize += 11;
	
	    tag = bytes.subarray(i, i + dataSize);
	    parsedResults.push(inspectFlvTag(tag));
	    i += dataSize + 4;
	  }
	  return parsedResults;
	},
	    textifyFlv = function textifyFlv(flvTagArray) {
	  return JSON.stringify(flvTagArray, null, 2);
	};
	
	module.exports = {
	  inspectTag: inspectFlvTag,
	  inspect: inspectFlv,
	  textify: textifyFlv
	};

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * mux.js
	 *
	 * Copyright (c) 2015 Brightcove
	 * All rights reserved.
	 *
	 * Parse the internal MP4 structure into an equivalent javascript
	 * object.
	 */
	'use strict';
	
	var inspectMp4,
	    _textifyMp,
	    parseType = __webpack_require__(157).parseType,
	    parseMp4Date = function parseMp4Date(seconds) {
	  return new Date(seconds * 1000 - 2082844800000);
	},
	    parseSampleFlags = function parseSampleFlags(flags) {
	  return {
	    isLeading: (flags[0] & 0x0c) >>> 2,
	    dependsOn: flags[0] & 0x03,
	    isDependedOn: (flags[1] & 0xc0) >>> 6,
	    hasRedundancy: (flags[1] & 0x30) >>> 4,
	    paddingValue: (flags[1] & 0x0e) >>> 1,
	    isNonSyncSample: flags[1] & 0x01,
	    degradationPriority: flags[2] << 8 | flags[3]
	  };
	},
	    nalParse = function nalParse(avcStream) {
	  var avcView = new DataView(avcStream.buffer, avcStream.byteOffset, avcStream.byteLength),
	      result = [],
	      i,
	      length;
	  for (i = 0; i + 4 < avcStream.length; i += length) {
	    length = avcView.getUint32(i);
	    i += 4;
	
	    // bail if this doesn't appear to be an H264 stream
	    if (length <= 0) {
	      result.push('<span style=\'color:red;\'>MALFORMED DATA</span>');
	      continue;
	    }
	
	    switch (avcStream[i] & 0x1F) {
	      case 0x01:
	        result.push('slice_layer_without_partitioning_rbsp');
	        break;
	      case 0x05:
	        result.push('slice_layer_without_partitioning_rbsp_idr');
	        break;
	      case 0x06:
	        result.push('sei_rbsp');
	        break;
	      case 0x07:
	        result.push('seq_parameter_set_rbsp');
	        break;
	      case 0x08:
	        result.push('pic_parameter_set_rbsp');
	        break;
	      case 0x09:
	        result.push('access_unit_delimiter_rbsp');
	        break;
	      default:
	        result.push('UNKNOWN NAL - ' + avcStream[i] & 0x1F);
	        break;
	    }
	  }
	  return result;
	},
	
	
	// registry of handlers for individual mp4 box types
	parse = {
	  // codingname, not a first-class box type. stsd entries share the
	  // same format as real boxes so the parsing infrastructure can be
	  // shared
	  avc1: function avc1(data) {
	    var view = new DataView(data.buffer, data.byteOffset, data.byteLength);
	    return {
	      dataReferenceIndex: view.getUint16(6),
	      width: view.getUint16(24),
	      height: view.getUint16(26),
	      horizresolution: view.getUint16(28) + view.getUint16(30) / 16,
	      vertresolution: view.getUint16(32) + view.getUint16(34) / 16,
	      frameCount: view.getUint16(40),
	      depth: view.getUint16(74),
	      config: inspectMp4(data.subarray(78, data.byteLength))
	    };
	  },
	  avcC: function avcC(data) {
	    var view = new DataView(data.buffer, data.byteOffset, data.byteLength),
	        result = {
	      configurationVersion: data[0],
	      avcProfileIndication: data[1],
	      profileCompatibility: data[2],
	      avcLevelIndication: data[3],
	      lengthSizeMinusOne: data[4] & 0x03,
	      sps: [],
	      pps: []
	    },
	        numOfSequenceParameterSets = data[5] & 0x1f,
	        numOfPictureParameterSets,
	        nalSize,
	        offset,
	        i;
	
	    // iterate past any SPSs
	    offset = 6;
	    for (i = 0; i < numOfSequenceParameterSets; i++) {
	      nalSize = view.getUint16(offset);
	      offset += 2;
	      result.sps.push(new Uint8Array(data.subarray(offset, offset + nalSize)));
	      offset += nalSize;
	    }
	    // iterate past any PPSs
	    numOfPictureParameterSets = data[offset];
	    offset++;
	    for (i = 0; i < numOfPictureParameterSets; i++) {
	      nalSize = view.getUint16(offset);
	      offset += 2;
	      result.pps.push(new Uint8Array(data.subarray(offset, offset + nalSize)));
	      offset += nalSize;
	    }
	    return result;
	  },
	  btrt: function btrt(data) {
	    var view = new DataView(data.buffer, data.byteOffset, data.byteLength);
	    return {
	      bufferSizeDB: view.getUint32(0),
	      maxBitrate: view.getUint32(4),
	      avgBitrate: view.getUint32(8)
	    };
	  },
	  esds: function esds(data) {
	    return {
	      version: data[0],
	      flags: new Uint8Array(data.subarray(1, 4)),
	      esId: data[6] << 8 | data[7],
	      streamPriority: data[8] & 0x1f,
	      decoderConfig: {
	        objectProfileIndication: data[11],
	        streamType: data[12] >>> 2 & 0x3f,
	        bufferSize: data[13] << 16 | data[14] << 8 | data[15],
	        maxBitrate: data[16] << 24 | data[17] << 16 | data[18] << 8 | data[19],
	        avgBitrate: data[20] << 24 | data[21] << 16 | data[22] << 8 | data[23],
	        decoderConfigDescriptor: {
	          tag: data[24],
	          length: data[25],
	          audioObjectType: data[26] >>> 3 & 0x1f,
	          samplingFrequencyIndex: (data[26] & 0x07) << 1 | data[27] >>> 7 & 0x01,
	          channelConfiguration: data[27] >>> 3 & 0x0f
	        }
	      }
	    };
	  },
	  ftyp: function ftyp(data) {
	    var view = new DataView(data.buffer, data.byteOffset, data.byteLength),
	        result = {
	      majorBrand: parseType(data.subarray(0, 4)),
	      minorVersion: view.getUint32(4),
	      compatibleBrands: []
	    },
	        i = 8;
	    while (i < data.byteLength) {
	      result.compatibleBrands.push(parseType(data.subarray(i, i + 4)));
	      i += 4;
	    }
	    return result;
	  },
	  dinf: function dinf(data) {
	    return {
	      boxes: inspectMp4(data)
	    };
	  },
	  dref: function dref(data) {
	    return {
	      version: data[0],
	      flags: new Uint8Array(data.subarray(1, 4)),
	      dataReferences: inspectMp4(data.subarray(8))
	    };
	  },
	  hdlr: function hdlr(data) {
	    var view = new DataView(data.buffer, data.byteOffset, data.byteLength),
	        result = {
	      version: view.getUint8(0),
	      flags: new Uint8Array(data.subarray(1, 4)),
	      handlerType: parseType(data.subarray(8, 12)),
	      name: ''
	    },
	        i = 8;
	
	    // parse out the name field
	    for (i = 24; i < data.byteLength; i++) {
	      if (data[i] === 0x00) {
	        // the name field is null-terminated
	        i++;
	        break;
	      }
	      result.name += String.fromCharCode(data[i]);
	    }
	    // decode UTF-8 to javascript's internal representation
	    // see http://ecmanaut.blogspot.com/2006/07/encoding-decoding-utf8-in-javascript.html
	    result.name = decodeURIComponent(global.escape(result.name));
	
	    return result;
	  },
	  mdat: function mdat(data) {
	    return {
	      byteLength: data.byteLength,
	      nals: nalParse(data)
	    };
	  },
	  mdhd: function mdhd(data) {
	    var view = new DataView(data.buffer, data.byteOffset, data.byteLength),
	        i = 4,
	        language,
	        result = {
	      version: view.getUint8(0),
	      flags: new Uint8Array(data.subarray(1, 4)),
	      language: ''
	    };
	    if (result.version === 1) {
	      i += 4;
	      result.creationTime = parseMp4Date(view.getUint32(i)); // truncating top 4 bytes
	      i += 8;
	      result.modificationTime = parseMp4Date(view.getUint32(i)); // truncating top 4 bytes
	      i += 4;
	      result.timescale = view.getUint32(i);
	      i += 8;
	      result.duration = view.getUint32(i); // truncating top 4 bytes
	    } else {
	      result.creationTime = parseMp4Date(view.getUint32(i));
	      i += 4;
	      result.modificationTime = parseMp4Date(view.getUint32(i));
	      i += 4;
	      result.timescale = view.getUint32(i);
	      i += 4;
	      result.duration = view.getUint32(i);
	    }
	    i += 4;
	    // language is stored as an ISO-639-2/T code in an array of three 5-bit fields
	    // each field is the packed difference between its ASCII value and 0x60
	    language = view.getUint16(i);
	    result.language += String.fromCharCode((language >> 10) + 0x60);
	    result.language += String.fromCharCode(((language & 0x03c0) >> 5) + 0x60);
	    result.language += String.fromCharCode((language & 0x1f) + 0x60);
	
	    return result;
	  },
	  mdia: function mdia(data) {
	    return {
	      boxes: inspectMp4(data)
	    };
	  },
	  mfhd: function mfhd(data) {
	    return {
	      version: data[0],
	      flags: new Uint8Array(data.subarray(1, 4)),
	      sequenceNumber: data[4] << 24 | data[5] << 16 | data[6] << 8 | data[7]
	    };
	  },
	  minf: function minf(data) {
	    return {
	      boxes: inspectMp4(data)
	    };
	  },
	  // codingname, not a first-class box type. stsd entries share the
	  // same format as real boxes so the parsing infrastructure can be
	  // shared
	  mp4a: function mp4a(data) {
	    var view = new DataView(data.buffer, data.byteOffset, data.byteLength),
	        result = {
	      // 6 bytes reserved
	      dataReferenceIndex: view.getUint16(6),
	      // 4 + 4 bytes reserved
	      channelcount: view.getUint16(16),
	      samplesize: view.getUint16(18),
	      // 2 bytes pre_defined
	      // 2 bytes reserved
	      samplerate: view.getUint16(24) + view.getUint16(26) / 65536
	    };
	
	    // if there are more bytes to process, assume this is an ISO/IEC
	    // 14496-14 MP4AudioSampleEntry and parse the ESDBox
	    if (data.byteLength > 28) {
	      result.streamDescriptor = inspectMp4(data.subarray(28))[0];
	    }
	    return result;
	  },
	  moof: function moof(data) {
	    return {
	      boxes: inspectMp4(data)
	    };
	  },
	  moov: function moov(data) {
	    return {
	      boxes: inspectMp4(data)
	    };
	  },
	  mvex: function mvex(data) {
	    return {
	      boxes: inspectMp4(data)
	    };
	  },
	  mvhd: function mvhd(data) {
	    var view = new DataView(data.buffer, data.byteOffset, data.byteLength),
	        i = 4,
	        result = {
	      version: view.getUint8(0),
	      flags: new Uint8Array(data.subarray(1, 4))
	    };
	
	    if (result.version === 1) {
	      i += 4;
	      result.creationTime = parseMp4Date(view.getUint32(i)); // truncating top 4 bytes
	      i += 8;
	      result.modificationTime = parseMp4Date(view.getUint32(i)); // truncating top 4 bytes
	      i += 4;
	      result.timescale = view.getUint32(i);
	      i += 8;
	      result.duration = view.getUint32(i); // truncating top 4 bytes
	    } else {
	      result.creationTime = parseMp4Date(view.getUint32(i));
	      i += 4;
	      result.modificationTime = parseMp4Date(view.getUint32(i));
	      i += 4;
	      result.timescale = view.getUint32(i);
	      i += 4;
	      result.duration = view.getUint32(i);
	    }
	    i += 4;
	
	    // convert fixed-point, base 16 back to a number
	    result.rate = view.getUint16(i) + view.getUint16(i + 2) / 16;
	    i += 4;
	    result.volume = view.getUint8(i) + view.getUint8(i + 1) / 8;
	    i += 2;
	    i += 2;
	    i += 2 * 4;
	    result.matrix = new Uint32Array(data.subarray(i, i + 9 * 4));
	    i += 9 * 4;
	    i += 6 * 4;
	    result.nextTrackId = view.getUint32(i);
	    return result;
	  },
	  pdin: function pdin(data) {
	    var view = new DataView(data.buffer, data.byteOffset, data.byteLength);
	    return {
	      version: view.getUint8(0),
	      flags: new Uint8Array(data.subarray(1, 4)),
	      rate: view.getUint32(4),
	      initialDelay: view.getUint32(8)
	    };
	  },
	  sdtp: function sdtp(data) {
	    var result = {
	      version: data[0],
	      flags: new Uint8Array(data.subarray(1, 4)),
	      samples: []
	    },
	        i;
	
	    for (i = 4; i < data.byteLength; i++) {
	      result.samples.push({
	        dependsOn: (data[i] & 0x30) >> 4,
	        isDependedOn: (data[i] & 0x0c) >> 2,
	        hasRedundancy: data[i] & 0x03
	      });
	    }
	    return result;
	  },
	  sidx: function sidx(data) {
	    var view = new DataView(data.buffer, data.byteOffset, data.byteLength),
	        result = {
	      version: data[0],
	      flags: new Uint8Array(data.subarray(1, 4)),
	      references: [],
	      referenceId: view.getUint32(4),
	      timescale: view.getUint32(8),
	      earliestPresentationTime: view.getUint32(12),
	      firstOffset: view.getUint32(16)
	    },
	        referenceCount = view.getUint16(22),
	        i;
	
	    for (i = 24; referenceCount; i += 12, referenceCount--) {
	      result.references.push({
	        referenceType: (data[i] & 0x80) >>> 7,
	        referencedSize: view.getUint32(i) & 0x7FFFFFFF,
	        subsegmentDuration: view.getUint32(i + 4),
	        startsWithSap: !!(data[i + 8] & 0x80),
	        sapType: (data[i + 8] & 0x70) >>> 4,
	        sapDeltaTime: view.getUint32(i + 8) & 0x0FFFFFFF
	      });
	    }
	
	    return result;
	  },
	  smhd: function smhd(data) {
	    return {
	      version: data[0],
	      flags: new Uint8Array(data.subarray(1, 4)),
	      balance: data[4] + data[5] / 256
	    };
	  },
	  stbl: function stbl(data) {
	    return {
	      boxes: inspectMp4(data)
	    };
	  },
	  stco: function stco(data) {
	    var view = new DataView(data.buffer, data.byteOffset, data.byteLength),
	        result = {
	      version: data[0],
	      flags: new Uint8Array(data.subarray(1, 4)),
	      chunkOffsets: []
	    },
	        entryCount = view.getUint32(4),
	        i;
	    for (i = 8; entryCount; i += 4, entryCount--) {
	      result.chunkOffsets.push(view.getUint32(i));
	    }
	    return result;
	  },
	  stsc: function stsc(data) {
	    var view = new DataView(data.buffer, data.byteOffset, data.byteLength),
	        entryCount = view.getUint32(4),
	        result = {
	      version: data[0],
	      flags: new Uint8Array(data.subarray(1, 4)),
	      sampleToChunks: []
	    },
	        i;
	    for (i = 8; entryCount; i += 12, entryCount--) {
	      result.sampleToChunks.push({
	        firstChunk: view.getUint32(i),
	        samplesPerChunk: view.getUint32(i + 4),
	        sampleDescriptionIndex: view.getUint32(i + 8)
	      });
	    }
	    return result;
	  },
	  stsd: function stsd(data) {
	    return {
	      version: data[0],
	      flags: new Uint8Array(data.subarray(1, 4)),
	      sampleDescriptions: inspectMp4(data.subarray(8))
	    };
	  },
	  stsz: function stsz(data) {
	    var view = new DataView(data.buffer, data.byteOffset, data.byteLength),
	        result = {
	      version: data[0],
	      flags: new Uint8Array(data.subarray(1, 4)),
	      sampleSize: view.getUint32(4),
	      entries: []
	    },
	        i;
	    for (i = 12; i < data.byteLength; i += 4) {
	      result.entries.push(view.getUint32(i));
	    }
	    return result;
	  },
	  stts: function stts(data) {
	    var view = new DataView(data.buffer, data.byteOffset, data.byteLength),
	        result = {
	      version: data[0],
	      flags: new Uint8Array(data.subarray(1, 4)),
	      timeToSamples: []
	    },
	        entryCount = view.getUint32(4),
	        i;
	
	    for (i = 8; entryCount; i += 8, entryCount--) {
	      result.timeToSamples.push({
	        sampleCount: view.getUint32(i),
	        sampleDelta: view.getUint32(i + 4)
	      });
	    }
	    return result;
	  },
	  styp: function styp(data) {
	    return parse.ftyp(data);
	  },
	  tfdt: function tfdt(data) {
	    var ab = new ArrayBuffer(4);
	    var dv = new DataView(ab);
	    var bmdt = new Uint8Array(ab);
	    bmdt.set([data[4], data[5], data[6], data[7]]);
	
	    var result = {
	      version: data[0],
	      flags: new Uint8Array(data.subarray(1, 4)),
	      //baseMediaDecodeTime: data[4] << 24 | data[5] << 16 | data[6] << 8 | data[7]
	      baseMediaDecodeTime: dv.getUint32(0)
	    };
	    if (result.version === 1) {
	      result.baseMediaDecodeTime *= Math.pow(2, 32);
	      //result.baseMediaDecodeTime += ((data[8] << 24) & 0xFF) | data[9] << 16 | data[10] << 8 | data[11];
	      bmdt.set([data[8], data[9], data[10], data[11]]);
	      result.baseMediaDecodeTime += dv.getUint32(0);
	    }
	    return result;
	  },
	  tfhd: function tfhd(data) {
	    var view = new DataView(data.buffer, data.byteOffset, data.byteLength),
	        result = {
	      version: data[0],
	      flags: new Uint8Array(data.subarray(1, 4)),
	      trackId: view.getUint32(4)
	    },
	        baseDataOffsetPresent = result.flags[2] & 0x01,
	        sampleDescriptionIndexPresent = result.flags[2] & 0x02,
	        defaultSampleDurationPresent = result.flags[2] & 0x08,
	        defaultSampleSizePresent = result.flags[2] & 0x10,
	        defaultSampleFlagsPresent = result.flags[2] & 0x20,
	        i;
	
	    i = 8;
	    if (baseDataOffsetPresent) {
	      i += 4; // truncate top 4 bytes
	      result.baseDataOffset = view.getUint32(12);
	      i += 4;
	    }
	    if (sampleDescriptionIndexPresent) {
	      result.sampleDescriptionIndex = view.getUint32(i);
	      i += 4;
	    }
	    if (defaultSampleDurationPresent) {
	      result.defaultSampleDuration = view.getUint32(i);
	      i += 4;
	    }
	    if (defaultSampleSizePresent) {
	      result.defaultSampleSize = view.getUint32(i);
	      i += 4;
	    }
	    if (defaultSampleFlagsPresent) {
	      result.defaultSampleFlags = view.getUint32(i);
	    }
	    return result;
	  },
	  tkhd: function tkhd(data) {
	    var view = new DataView(data.buffer, data.byteOffset, data.byteLength),
	        i = 4,
	        result = {
	      version: view.getUint8(0),
	      flags: new Uint8Array(data.subarray(1, 4))
	    };
	    if (result.version === 1) {
	      i += 4;
	      result.creationTime = parseMp4Date(view.getUint32(i)); // truncating top 4 bytes
	      i += 8;
	      result.modificationTime = parseMp4Date(view.getUint32(i)); // truncating top 4 bytes
	      i += 4;
	      result.trackId = view.getUint32(i);
	      i += 4;
	      i += 8;
	      result.duration = view.getUint32(i); // truncating top 4 bytes
	    } else {
	      result.creationTime = parseMp4Date(view.getUint32(i));
	      i += 4;
	      result.modificationTime = parseMp4Date(view.getUint32(i));
	      i += 4;
	      result.trackId = view.getUint32(i);
	      i += 4;
	      i += 4;
	      result.duration = view.getUint32(i);
	    }
	    i += 4;
	    i += 2 * 4;
	    result.layer = view.getUint16(i);
	    i += 2;
	    result.alternateGroup = view.getUint16(i);
	    i += 2;
	    // convert fixed-point, base 16 back to a number
	    result.volume = view.getUint8(i) + view.getUint8(i + 1) / 8;
	    i += 2;
	    i += 2;
	    result.matrix = new Uint32Array(data.subarray(i, i + 9 * 4));
	    i += 9 * 4;
	    result.width = view.getUint16(i) + view.getUint16(i + 2) / 16;
	    i += 4;
	    result.height = view.getUint16(i) + view.getUint16(i + 2) / 16;
	    return result;
	  },
	  traf: function traf(data) {
	    return {
	      boxes: inspectMp4(data)
	    };
	  },
	  trak: function trak(data) {
	    return {
	      boxes: inspectMp4(data)
	    };
	  },
	  trex: function trex(data) {
	    var view = new DataView(data.buffer, data.byteOffset, data.byteLength);
	    return {
	      version: data[0],
	      flags: new Uint8Array(data.subarray(1, 4)),
	      trackId: view.getUint32(4),
	      defaultSampleDescriptionIndex: view.getUint32(8),
	      defaultSampleDuration: view.getUint32(12),
	      defaultSampleSize: view.getUint32(16),
	      sampleDependsOn: data[20] & 0x03,
	      sampleIsDependedOn: (data[21] & 0xc0) >> 6,
	      sampleHasRedundancy: (data[21] & 0x30) >> 4,
	      samplePaddingValue: (data[21] & 0x0e) >> 1,
	      sampleIsDifferenceSample: !!(data[21] & 0x01),
	      sampleDegradationPriority: view.getUint16(22)
	    };
	  },
	  trun: function trun(data) {
	    var result = {
	      version: data[0],
	      flags: new Uint8Array(data.subarray(1, 4)),
	      samples: []
	    },
	        view = new DataView(data.buffer, data.byteOffset, data.byteLength),
	        dataOffsetPresent = result.flags[2] & 0x01,
	        firstSampleFlagsPresent = result.flags[2] & 0x04,
	        sampleDurationPresent = result.flags[1] & 0x01,
	        sampleSizePresent = result.flags[1] & 0x02,
	        sampleFlagsPresent = result.flags[1] & 0x04,
	        sampleCompositionTimeOffsetPresent = result.flags[1] & 0x08,
	        sampleCount = view.getUint32(4),
	        offset = 8,
	        sample;
	
	    if (dataOffsetPresent) {
	      result.dataOffset = view.getUint32(offset);
	      offset += 4;
	    }
	
	    if (firstSampleFlagsPresent && sampleCount) {
	      sample = {
	        flags: parseSampleFlags(data.subarray(offset, offset + 4))
	      };
	      offset += 4;
	      if (sampleDurationPresent) {
	        sample.duration = view.getUint32(offset);
	        offset += 4;
	      }
	      if (sampleSizePresent) {
	        sample.size = view.getUint32(offset);
	        offset += 4;
	      }
	      if (sampleCompositionTimeOffsetPresent) {
	        sample.compositionTimeOffset = view.getUint32(offset);
	        offset += 4;
	      }
	      result.samples.push(sample);
	      sampleCount--;
	    }
	
	    while (sampleCount--) {
	      sample = {};
	      if (sampleDurationPresent) {
	        sample.duration = view.getUint32(offset);
	        offset += 4;
	      }
	      if (sampleSizePresent) {
	        sample.size = view.getUint32(offset);
	        offset += 4;
	      }
	      if (sampleFlagsPresent) {
	        sample.flags = parseSampleFlags(data.subarray(offset, offset + 4));
	        offset += 4;
	      }
	      if (sampleCompositionTimeOffsetPresent) {
	        sample.compositionTimeOffset = view.getUint32(offset);
	        offset += 4;
	      }
	      result.samples.push(sample);
	    }
	    return result;
	  },
	  'url ': function url(data) {
	    return {
	      version: data[0],
	      flags: new Uint8Array(data.subarray(1, 4))
	    };
	  },
	  vmhd: function vmhd(data) {
	    var view = new DataView(data.buffer, data.byteOffset, data.byteLength);
	    return {
	      version: data[0],
	      flags: new Uint8Array(data.subarray(1, 4)),
	      graphicsmode: view.getUint16(4),
	      opcolor: new Uint16Array([view.getUint16(6), view.getUint16(8), view.getUint16(10)])
	    };
	  }
	};
	
	/**
	 * Return a javascript array of box objects parsed from an ISO base
	 * media file.
	 * @param data {Uint8Array} the binary data of the media to be inspected
	 * @return {array} a javascript array of potentially nested box objects
	 */
	inspectMp4 = function inspectMp4(data) {
	  var i = 0,
	      result = [],
	      view,
	      size,
	      type,
	      end,
	      box;
	
	  // Convert data from Uint8Array to ArrayBuffer, to follow Dataview API
	  var ab = new ArrayBuffer(data.length);
	  var v = new Uint8Array(ab);
	  for (var z = 0; z < data.length; ++z) {
	    v[z] = data[z];
	  }
	  view = new DataView(ab);
	
	  while (i < data.byteLength) {
	    // parse box data
	    size = view.getUint32(i);
	    type = parseType(data.subarray(i + 4, i + 8));
	    end = size > 1 ? i + size : data.byteLength;
	
	    // parse type-specific data
	    box = (parse[type] || function (data) {
	      return {
	        data: data
	      };
	    })(data.subarray(i + 8, end));
	    box.size = size;
	    box.type = type;
	
	    // store this box and move to the next
	    result.push(box);
	    i = end;
	  }
	  return result;
	};
	
	/**
	 * Returns a textual representation of the javascript represtentation
	 * of an MP4 file. You can use it as an alternative to
	 * JSON.stringify() to compare inspected MP4s.
	 * @param inspectedMp4 {array} the parsed array of boxes in an MP4
	 * file
	 * @param depth {number} (optional) the number of ancestor boxes of
	 * the elements of inspectedMp4. Assumed to be zero if unspecified.
	 * @return {string} a text representation of the parsed MP4
	 */
	_textifyMp = function textifyMp4(inspectedMp4, depth) {
	  var indent;
	  depth = depth || 0;
	  indent = new Array(depth * 2 + 1).join(' ');
	
	  // iterate over all the boxes
	  return inspectedMp4.map(function (box, index) {
	
	    // list the box type first at the current indentation level
	    return indent + box.type + '\n' +
	
	    // the type is already included and handle child boxes separately
	    Object.keys(box).filter(function (key) {
	      return key !== 'type' && key !== 'boxes';
	
	      // output all the box properties
	    }).map(function (key) {
	      var prefix = indent + '  ' + key + ': ',
	          value = box[key];
	
	      // print out raw bytes as hexademical
	      if (value instanceof Uint8Array || value instanceof Uint32Array) {
	        var bytes = Array.prototype.slice.call(new Uint8Array(value.buffer, value.byteOffset, value.byteLength)).map(function (byte) {
	          return ' ' + ('00' + byte.toString(16)).slice(-2);
	        }).join('').match(/.{1,24}/g);
	        if (!bytes) {
	          return prefix + '<>';
	        }
	        if (bytes.length === 1) {
	          return prefix + '<' + bytes.join('').slice(1) + '>';
	        }
	        return prefix + '<\n' + bytes.map(function (line) {
	          return indent + '  ' + line;
	        }).join('\n') + '\n' + indent + '  >';
	      }
	
	      // stringify generic objects
	      return prefix + JSON.stringify(value, null, 2).split('\n').map(function (line, index) {
	        if (index === 0) {
	          return line;
	        }
	        return indent + '  ' + line;
	      }).join('\n');
	    }).join('\n') + (
	
	    // recursively textify the child boxes
	    box.boxes ? '\n' + _textifyMp(box.boxes, depth + 1) : '');
	  }).join('\n');
	};
	
	module.exports = {
	  inspect: inspectMp4,
	  textify: _textifyMp
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * mux.js
	 *
	 * Copyright (c) 2016 Brightcove
	 * All rights reserved.
	 *
	 * Parse mpeg2 transport stream packets to extract basic timing information
	 */
	'use strict';
	
	var StreamTypes = __webpack_require__(26);
	var handleRollover = __webpack_require__(76).handleRollover;
	var probe = {};
	probe.ts = __webpack_require__(155);
	probe.aac = __webpack_require__(144);
	
	var PES_TIMESCALE = 90000,
	    MP2T_PACKET_LENGTH = 188,
	    // bytes
	SYNC_BYTE = 0x47;
	
	var isLikelyAacData = function isLikelyAacData(data) {
	  if (data[0] === 'I'.charCodeAt(0) && data[1] === 'D'.charCodeAt(0) && data[2] === '3'.charCodeAt(0)) {
	    return true;
	  }
	  return false;
	};
	
	/**
	 * walks through segment data looking for pat and pmt packets to parse out
	 * program map table information
	 */
	var parsePsi_ = function parsePsi_(bytes, pmt) {
	  var startIndex = 0,
	      endIndex = MP2T_PACKET_LENGTH,
	      packet,
	      type;
	
	  while (endIndex < bytes.byteLength) {
	    // Look for a pair of start and end sync bytes in the data..
	    if (bytes[startIndex] === SYNC_BYTE && bytes[endIndex] === SYNC_BYTE) {
	      // We found a packet
	      packet = bytes.subarray(startIndex, endIndex);
	      type = probe.ts.parseType(packet, pmt.pid);
	
	      switch (type) {
	        case 'pat':
	          if (!pmt.pid) {
	            pmt.pid = probe.ts.parsePat(packet);
	          }
	          break;
	        case 'pmt':
	          if (!pmt.table) {
	            pmt.table = probe.ts.parsePmt(packet);
	          }
	          break;
	        default:
	          break;
	      }
	
	      // Found the pat and pmt, we can stop walking the segment
	      if (pmt.pid && pmt.table) {
	        return;
	      }
	
	      startIndex += MP2T_PACKET_LENGTH;
	      endIndex += MP2T_PACKET_LENGTH;
	      continue;
	    }
	
	    // If we get here, we have somehow become de-synchronized and we need to step
	    // forward one byte at a time until we find a pair of sync bytes that denote
	    // a packet
	    startIndex++;
	    endIndex++;
	  }
	};
	
	/**
	 * walks through the segment data from the start and end to get timing information
	 * for the first and last audio pes packets
	 */
	var parseAudioPes_ = function parseAudioPes_(bytes, pmt, result) {
	  var startIndex = 0,
	      endIndex = MP2T_PACKET_LENGTH,
	      packet,
	      type,
	      pesType,
	      pusi,
	      parsed;
	
	  var endLoop = false;
	
	  // Start walking from start of segment to get first audio packet
	  while (endIndex < bytes.byteLength) {
	    // Look for a pair of start and end sync bytes in the data..
	    if (bytes[startIndex] === SYNC_BYTE && bytes[endIndex] === SYNC_BYTE) {
	      // We found a packet
	      packet = bytes.subarray(startIndex, endIndex);
	      type = probe.ts.parseType(packet, pmt.pid);
	
	      switch (type) {
	        case 'pes':
	          pesType = probe.ts.parsePesType(packet, pmt.table);
	          pusi = probe.ts.parsePayloadUnitStartIndicator(packet);
	          if (pesType === 'audio' && pusi) {
	            parsed = probe.ts.parsePesTime(packet);
	            parsed.type = 'audio';
	            result.audio.push(parsed);
	            endLoop = true;
	          }
	          break;
	        default:
	          break;
	      }
	
	      if (endLoop) {
	        break;
	      }
	
	      startIndex += MP2T_PACKET_LENGTH;
	      endIndex += MP2T_PACKET_LENGTH;
	      continue;
	    }
	
	    // If we get here, we have somehow become de-synchronized and we need to step
	    // forward one byte at a time until we find a pair of sync bytes that denote
	    // a packet
	    startIndex++;
	    endIndex++;
	  }
	
	  // Start walking from end of segment to get last audio packet
	  endIndex = bytes.byteLength;
	  startIndex = endIndex - MP2T_PACKET_LENGTH;
	  endLoop = false;
	  while (startIndex >= 0) {
	    // Look for a pair of start and end sync bytes in the data..
	    if (bytes[startIndex] === SYNC_BYTE && bytes[endIndex] === SYNC_BYTE) {
	      // We found a packet
	      packet = bytes.subarray(startIndex, endIndex);
	      type = probe.ts.parseType(packet, pmt.pid);
	
	      switch (type) {
	        case 'pes':
	          pesType = probe.ts.parsePesType(packet, pmt.table);
	          pusi = probe.ts.parsePayloadUnitStartIndicator(packet);
	          if (pesType === 'audio' && pusi) {
	            parsed = probe.ts.parsePesTime(packet);
	            parsed.type = 'audio';
	            result.audio.push(parsed);
	            endLoop = true;
	          }
	          break;
	        default:
	          break;
	      }
	
	      if (endLoop) {
	        break;
	      }
	
	      startIndex -= MP2T_PACKET_LENGTH;
	      endIndex -= MP2T_PACKET_LENGTH;
	      continue;
	    }
	
	    // If we get here, we have somehow become de-synchronized and we need to step
	    // forward one byte at a time until we find a pair of sync bytes that denote
	    // a packet
	    startIndex--;
	    endIndex--;
	  }
	};
	
	/**
	 * walks through the segment data from the start and end to get timing information
	 * for the first and last video pes packets as well as timing information for the first
	 * key frame.
	 */
	var parseVideoPes_ = function parseVideoPes_(bytes, pmt, result) {
	  var startIndex = 0,
	      endIndex = MP2T_PACKET_LENGTH,
	      packet,
	      type,
	      pesType,
	      pusi,
	      parsed,
	      frame,
	      i,
	      pes;
	
	  var endLoop = false;
	
	  var currentFrame = {
	    data: [],
	    size: 0
	  };
	
	  // Start walking from start of segment to get first video packet
	  while (endIndex < bytes.byteLength) {
	    // Look for a pair of start and end sync bytes in the data..
	    if (bytes[startIndex] === SYNC_BYTE && bytes[endIndex] === SYNC_BYTE) {
	      // We found a packet
	      packet = bytes.subarray(startIndex, endIndex);
	      type = probe.ts.parseType(packet, pmt.pid);
	
	      switch (type) {
	        case 'pes':
	          pesType = probe.ts.parsePesType(packet, pmt.table);
	          pusi = probe.ts.parsePayloadUnitStartIndicator(packet);
	          if (pesType === 'video') {
	            if (pusi && !endLoop) {
	              parsed = probe.ts.parsePesTime(packet);
	              parsed.type = 'video';
	              result.video.push(parsed);
	              endLoop = true;
	            }
	            if (!result.firstKeyFrame) {
	              if (pusi) {
	                if (currentFrame.size !== 0) {
	                  frame = new Uint8Array(currentFrame.size);
	                  i = 0;
	                  while (currentFrame.data.length) {
	                    pes = currentFrame.data.shift();
	                    frame.set(pes, i);
	                    i += pes.byteLength;
	                  }
	                  if (probe.ts.videoPacketContainsKeyFrame(frame)) {
	                    result.firstKeyFrame = probe.ts.parsePesTime(frame);
	                    result.firstKeyFrame.type = 'video';
	                  }
	                  currentFrame.size = 0;
	                }
	              }
	              currentFrame.data.push(packet);
	              currentFrame.size += packet.byteLength;
	            }
	          }
	          break;
	        default:
	          break;
	      }
	
	      if (endLoop && result.firstKeyFrame) {
	        break;
	      }
	
	      startIndex += MP2T_PACKET_LENGTH;
	      endIndex += MP2T_PACKET_LENGTH;
	      continue;
	    }
	
	    // If we get here, we have somehow become de-synchronized and we need to step
	    // forward one byte at a time until we find a pair of sync bytes that denote
	    // a packet
	    startIndex++;
	    endIndex++;
	  }
	
	  // Start walking from end of segment to get last video packet
	  endIndex = bytes.byteLength;
	  startIndex = endIndex - MP2T_PACKET_LENGTH;
	  endLoop = false;
	  while (startIndex >= 0) {
	    // Look for a pair of start and end sync bytes in the data..
	    if (bytes[startIndex] === SYNC_BYTE && bytes[endIndex] === SYNC_BYTE) {
	      // We found a packet
	      packet = bytes.subarray(startIndex, endIndex);
	      type = probe.ts.parseType(packet, pmt.pid);
	
	      switch (type) {
	        case 'pes':
	          pesType = probe.ts.parsePesType(packet, pmt.table);
	          pusi = probe.ts.parsePayloadUnitStartIndicator(packet);
	          if (pesType === 'video' && pusi) {
	            parsed = probe.ts.parsePesTime(packet);
	            parsed.type = 'video';
	            result.video.push(parsed);
	            endLoop = true;
	          }
	          break;
	        default:
	          break;
	      }
	
	      if (endLoop) {
	        break;
	      }
	
	      startIndex -= MP2T_PACKET_LENGTH;
	      endIndex -= MP2T_PACKET_LENGTH;
	      continue;
	    }
	
	    // If we get here, we have somehow become de-synchronized and we need to step
	    // forward one byte at a time until we find a pair of sync bytes that denote
	    // a packet
	    startIndex--;
	    endIndex--;
	  }
	};
	
	/**
	 * Adjusts the timestamp information for the segment to account for
	 * rollover and convert to seconds based on pes packet timescale (90khz clock)
	 */
	var adjustTimestamp_ = function adjustTimestamp_(segmentInfo, baseTimestamp) {
	  if (segmentInfo.audio && segmentInfo.audio.length) {
	    var audioBaseTimestamp = baseTimestamp;
	    if (typeof audioBaseTimestamp === 'undefined') {
	      audioBaseTimestamp = segmentInfo.audio[0].dts;
	    }
	    segmentInfo.audio.forEach(function (info) {
	      info.dts = handleRollover(info.dts, audioBaseTimestamp);
	      info.pts = handleRollover(info.pts, audioBaseTimestamp);
	      // time in seconds
	      info.dtsTime = info.dts / PES_TIMESCALE;
	      info.ptsTime = info.pts / PES_TIMESCALE;
	    });
	  }
	
	  if (segmentInfo.video && segmentInfo.video.length) {
	    var videoBaseTimestamp = baseTimestamp;
	    if (typeof videoBaseTimestamp === 'undefined') {
	      videoBaseTimestamp = segmentInfo.video[0].dts;
	    }
	    segmentInfo.video.forEach(function (info) {
	      info.dts = handleRollover(info.dts, videoBaseTimestamp);
	      info.pts = handleRollover(info.pts, videoBaseTimestamp);
	      // time in seconds
	      info.dtsTime = info.dts / PES_TIMESCALE;
	      info.ptsTime = info.pts / PES_TIMESCALE;
	    });
	    if (segmentInfo.firstKeyFrame) {
	      var frame = segmentInfo.firstKeyFrame;
	      frame.dts = handleRollover(frame.dts, videoBaseTimestamp);
	      frame.pts = handleRollover(frame.pts, videoBaseTimestamp);
	      // time in seconds
	      frame.dtsTime = frame.dts / PES_TIMESCALE;
	      frame.ptsTime = frame.dts / PES_TIMESCALE;
	    }
	  }
	};
	
	/**
	 * inspects the aac data stream for start and end time information
	 */
	var inspectAac_ = function inspectAac_(bytes) {
	  var endLoop = false,
	      audioCount = 0,
	      sampleRate = null,
	      timestamp = null,
	      frameSize = 0,
	      byteIndex = 0,
	      packet;
	
	  while (bytes.length - byteIndex >= 3) {
	    var type = probe.aac.parseType(bytes, byteIndex);
	    switch (type) {
	      case 'timed-metadata':
	        // Exit early because we don't have enough to parse
	        // the ID3 tag header
	        if (bytes.length - byteIndex < 10) {
	          endLoop = true;
	          break;
	        }
	
	        frameSize = probe.aac.parseId3TagSize(bytes, byteIndex);
	
	        // Exit early if we don't have enough in the buffer
	        // to emit a full packet
	        if (frameSize > bytes.length) {
	          endLoop = true;
	          break;
	        }
	        if (timestamp === null) {
	          packet = bytes.subarray(byteIndex, byteIndex + frameSize);
	          timestamp = probe.aac.parseAacTimestamp(packet);
	        }
	        byteIndex += frameSize;
	        break;
	      case 'audio':
	        // Exit early because we don't have enough to parse
	        // the ADTS frame header
	        if (bytes.length - byteIndex < 7) {
	          endLoop = true;
	          break;
	        }
	
	        frameSize = probe.aac.parseAdtsSize(bytes, byteIndex);
	
	        // Exit early if we don't have enough in the buffer
	        // to emit a full packet
	        if (frameSize > bytes.length) {
	          endLoop = true;
	          break;
	        }
	        if (sampleRate === null) {
	          packet = bytes.subarray(byteIndex, byteIndex + frameSize);
	          sampleRate = probe.aac.parseSampleRate(packet);
	        }
	        audioCount++;
	        byteIndex += frameSize;
	        break;
	      default:
	        byteIndex++;
	        break;
	    }
	    if (endLoop) {
	      return null;
	    }
	  }
	  if (sampleRate === null || timestamp === null) {
	    return null;
	  }
	
	  var audioTimescale = PES_TIMESCALE / sampleRate;
	
	  var result = {
	    audio: [{
	      type: 'audio',
	      dts: timestamp,
	      pts: timestamp
	    }, {
	      type: 'audio',
	      dts: timestamp + audioCount * 1024 * audioTimescale,
	      pts: timestamp + audioCount * 1024 * audioTimescale
	    }]
	  };
	
	  return result;
	};
	
	/**
	 * inspects the transport stream segment data for start and end time information
	 * of the audio and video tracks (when present) as well as the first key frame's
	 * start time.
	 */
	var inspectTs_ = function inspectTs_(bytes) {
	  var pmt = {
	    pid: null,
	    table: null
	  };
	
	  var result = {};
	
	  parsePsi_(bytes, pmt);
	
	  for (var pid in pmt.table) {
	    if (pmt.table.hasOwnProperty(pid)) {
	      var type = pmt.table[pid];
	      switch (type) {
	        case StreamTypes.H264_STREAM_TYPE:
	          result.video = [];
	          parseVideoPes_(bytes, pmt, result);
	          if (result.video.length === 0) {
	            delete result.video;
	          }
	          break;
	        case StreamTypes.ADTS_STREAM_TYPE:
	          result.audio = [];
	          parseAudioPes_(bytes, pmt, result);
	          if (result.audio.length === 0) {
	            delete result.audio;
	          }
	          break;
	        default:
	          break;
	      }
	    }
	  }
	  return result;
	};
	
	/**
	 * Inspects segment byte data and returns an object with start and end timing information
	 *
	 * @param {Uint8Array} bytes The segment byte data
	 * @param {Number} baseTimestamp Relative reference timestamp used when adjusting frame
	 *  timestamps for rollover. This value must be in 90khz clock.
	 * @return {Object} Object containing start and end frame timing info of segment.
	 */
	var inspect = function inspect(bytes, baseTimestamp) {
	  var isAacData = isLikelyAacData(bytes);
	
	  var result;
	
	  if (isAacData) {
	    result = inspectAac_(bytes);
	  } else {
	    result = inspectTs_(bytes);
	  }
	
	  if (!result || !result.audio && !result.video) {
	    return null;
	  }
	
	  adjustTimestamp_(result, baseTimestamp);
	
	  return result;
	};
	
	module.exports = {
	  inspect: inspect
	};

/***/ }),
/* 161 */
/***/ (function(module, exports) {

	"use strict";
	
	var ONE_SECOND_IN_TS = 90000,
	    // 90kHz clock
	secondsToVideoTs,
	    secondsToAudioTs,
	    videoTsToSeconds,
	    audioTsToSeconds,
	    audioTsToVideoTs,
	    videoTsToAudioTs;
	
	secondsToVideoTs = function secondsToVideoTs(seconds) {
	  return seconds * ONE_SECOND_IN_TS;
	};
	
	secondsToAudioTs = function secondsToAudioTs(seconds, sampleRate) {
	  return seconds * sampleRate;
	};
	
	videoTsToSeconds = function videoTsToSeconds(timestamp) {
	  return timestamp / ONE_SECOND_IN_TS;
	};
	
	audioTsToSeconds = function audioTsToSeconds(timestamp, sampleRate) {
	  return timestamp / sampleRate;
	};
	
	audioTsToVideoTs = function audioTsToVideoTs(timestamp, sampleRate) {
	  return secondsToVideoTs(audioTsToSeconds(timestamp, sampleRate));
	};
	
	videoTsToAudioTs = function videoTsToAudioTs(timestamp, sampleRate) {
	  return secondsToAudioTs(videoTsToSeconds(timestamp), sampleRate);
	};
	
	module.exports = {
	  secondsToVideoTs: secondsToVideoTs,
	  secondsToAudioTs: secondsToAudioTs,
	  videoTsToSeconds: videoTsToSeconds,
	  audioTsToSeconds: audioTsToSeconds,
	  audioTsToVideoTs: audioTsToVideoTs,
	  videoTsToAudioTs: videoTsToAudioTs
	};

/***/ }),
/* 162 */
/***/ (function(module, exports) {

	'use strict';
	
	var ExpGolomb;
	
	/**
	 * Parser for exponential Golomb codes, a variable-bitwidth number encoding
	 * scheme used by h264.
	 */
	ExpGolomb = function ExpGolomb(workingData) {
	  var
	  // the number of bytes left to examine in workingData
	  workingBytesAvailable = workingData.byteLength,
	
	
	  // the current word being examined
	  workingWord = 0,
	      // :uint
	
	  // the number of bits left to examine in the current word
	  workingBitsAvailable = 0; // :uint;
	
	  // ():uint
	  this.length = function () {
	    return 8 * workingBytesAvailable;
	  };
	
	  // ():uint
	  this.bitsAvailable = function () {
	    return 8 * workingBytesAvailable + workingBitsAvailable;
	  };
	
	  // ():void
	  this.loadWord = function () {
	    var position = workingData.byteLength - workingBytesAvailable,
	        workingBytes = new Uint8Array(4),
	        availableBytes = Math.min(4, workingBytesAvailable);
	
	    if (availableBytes === 0) {
	      throw new Error('no bytes available');
	    }
	
	    workingBytes.set(workingData.subarray(position, position + availableBytes));
	    workingWord = new DataView(workingBytes.buffer).getUint32(0);
	
	    // track the amount of workingData that has been processed
	    workingBitsAvailable = availableBytes * 8;
	    workingBytesAvailable -= availableBytes;
	  };
	
	  // (count:int):void
	  this.skipBits = function (count) {
	    var skipBytes; // :int
	    if (workingBitsAvailable > count) {
	      workingWord <<= count;
	      workingBitsAvailable -= count;
	    } else {
	      count -= workingBitsAvailable;
	      skipBytes = Math.floor(count / 8);
	
	      count -= skipBytes * 8;
	      workingBytesAvailable -= skipBytes;
	
	      this.loadWord();
	
	      workingWord <<= count;
	      workingBitsAvailable -= count;
	    }
	  };
	
	  // (size:int):uint
	  this.readBits = function (size) {
	    var bits = Math.min(workingBitsAvailable, size),
	        // :uint
	    valu = workingWord >>> 32 - bits; // :uint
	    // if size > 31, handle error
	    workingBitsAvailable -= bits;
	    if (workingBitsAvailable > 0) {
	      workingWord <<= bits;
	    } else if (workingBytesAvailable > 0) {
	      this.loadWord();
	    }
	
	    bits = size - bits;
	    if (bits > 0) {
	      return valu << bits | this.readBits(bits);
	    }
	    return valu;
	  };
	
	  // ():uint
	  this.skipLeadingZeros = function () {
	    var leadingZeroCount; // :uint
	    for (leadingZeroCount = 0; leadingZeroCount < workingBitsAvailable; ++leadingZeroCount) {
	      if ((workingWord & 0x80000000 >>> leadingZeroCount) !== 0) {
	        // the first bit of working word is 1
	        workingWord <<= leadingZeroCount;
	        workingBitsAvailable -= leadingZeroCount;
	        return leadingZeroCount;
	      }
	    }
	
	    // we exhausted workingWord and still have not found a 1
	    this.loadWord();
	    return leadingZeroCount + this.skipLeadingZeros();
	  };
	
	  // ():void
	  this.skipUnsignedExpGolomb = function () {
	    this.skipBits(1 + this.skipLeadingZeros());
	  };
	
	  // ():void
	  this.skipExpGolomb = function () {
	    this.skipBits(1 + this.skipLeadingZeros());
	  };
	
	  // ():uint
	  this.readUnsignedExpGolomb = function () {
	    var clz = this.skipLeadingZeros(); // :uint
	    return this.readBits(clz + 1) - 1;
	  };
	
	  // ():int
	  this.readExpGolomb = function () {
	    var valu = this.readUnsignedExpGolomb(); // :int
	    if (0x01 & valu) {
	      // the number is odd if the low order bit is set
	      return 1 + valu >>> 1; // add 1 to make it even, and divide by 2
	    }
	    return -1 * (valu >>> 1); // divide by two then make it negative
	  };
	
	  // Some convenience functions
	  // :Boolean
	  this.readBoolean = function () {
	    return this.readBits(1) === 1;
	  };
	
	  // ():int
	  this.readUnsignedByte = function () {
	    return this.readBits(8);
	  };
	
	  this.loadWord();
	};
	
	module.exports = ExpGolomb;

/***/ }),
/* 163 */
/***/ (function(module, exports) {

	'use strict';
	
	if (typeof Object.assign !== 'function') {
		Object.assign = function (target, varArgs) {
			//eslint-disable-line no-unused-vars
			'use strict';
	
			if (target === null) {
				// TypeError if undefined or null
				throw new TypeError('Cannot convert undefined or null to object');
			}
	
			var to = Object(target);
	
			for (var index = 1; index < arguments.length; index++) {
				var nextSource = arguments[index];
	
				if (nextSource !== null) {
					// Skip over if undefined or null
					for (var nextKey in nextSource) {
						// Avoid bugs when hasOwnProperty is shadowed
						if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
							to[nextKey] = nextSource[nextKey];
						}
					}
				}
			}
			return to;
		};
	}

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * OrderedArray - Implements an array which maintains a permanent order
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(61);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * OrderedArray is an array sorted by a comparator. Order is always maintained. Inserts are
	 * performed by binary-search and then an insert at the correct location. Duplicates are allowed.
	 *
	 * @access internal
	 */
	var OrderedArray = function () {
	
		/**
	  * Constructs an instance of an OrderedArray
	  *
	  * @param {Array} [contents] - the initial contents of the array (faster if sorted)
	  * @param {function} [iteratee] - a function that when given an element, returns the sorting parameter
	  */
		function OrderedArray() {
			var contents = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
			var iteratee = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _lodash2.default.identity;
	
			_classCallCheck(this, OrderedArray);
	
			this._values = [];
			this._iteratee = iteratee;
	
			if (_lodash2.default.isArray(contents)) {
				this.insertList(contents);
			} else {
				throw new Error('OrderedArray, initial contents must be an array');
			}
		}
	
		/**
	     * number of values
	  */
	
	
		_createClass(OrderedArray, [{
			key: 'at',
	
	
			/**
	   *  value at n
	   */
			value: function at(n) {
				return this._values[n];
			}
	
			/**
	   *  extracts first value (minimum)
	   */
	
		}, {
			key: 'shift',
			value: function shift() {
				return this._values.shift();
			}
	
			/**
	   *  extracts last value (maximum)
	   */
	
		}, {
			key: 'pop',
			value: function pop() {
				return this._values.pop();
			}
		}, {
			key: 'clear',
			value: function clear() {
				this.extract();
			}
	
			/**
	   * removes count values from start and returns them
	   */
	
		}, {
			key: 'extract',
			value: function extract() {
				var start = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
				var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.length - start;
	
				return this._values.splice(start, count);
			}
	
			/**
	   * scans count values from start, removes all which pass the filter, and returns them
	   */
	
		}, {
			key: 'extractWithFilter',
			value: function extractWithFilter(start, count, filter) {
				if (!filter) {
					throw new Error('OrderedArray.extractWithFilter requires a filter');
				}
	
				var extracted = [];
	
				// limit is the lesser of remaining or count
				var limit = this.length - start;
				if (count < limit) {
					limit = count;
				}
	
				var inRun = false;
				var startOfRun = void 0;
				var runLength = void 0;
	
				for (var i = 0, next = start; i < limit; i++) {
					if (filter(this._values[next])) {
						// value should be extracted
						if (!inRun) {
							// beginning a run
							startOfRun = next;
							runLength = 0;
							inRun = true;
						}
						// continuing a run
						runLength++;
					} else {
						// value should be skipped
						if (inRun) {
							// switching out of a run, extract the values
							extracted = extracted.concat(this._values.splice(startOfRun, runLength));
							inRun = false;
	
							// need to backtrack on next since we just removed a bunch of values.
							next -= runLength;
						}
					}
	
					next++;
				}
	
				if (inRun) {
					// ended during a run, extract remaining values
					extracted = extracted.concat(this._values.splice(startOfRun, runLength));
				}
	
				return extracted;
			}
	
			/**
	   * finds a range {start,end} given start/end values
	   */
	
		}, {
			key: 'rangeByValue',
			value: function rangeByValue(startValue) {
				var endValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : startValue;
	
				var minValue = void 0;
				var maxValue = void 0;
	
				if (this._iteratee(startValue) <= this._iteratee(endValue)) {
					minValue = startValue;
					maxValue = endValue;
				} else {
					minValue = endValue;
					maxValue = startValue;
				}
	
				var start = this.indexStart(minValue);
				var end = this.indexAfter(maxValue);
	
				return { start: start, end: end };
			}
	
			/**
	   * extract values by value. inclusive.
	   */
	
		}, {
			key: 'extractByValue',
			value: function extractByValue(startValue) {
				var endValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : startValue;
	
				var _rangeByValue = this.rangeByValue(startValue, endValue),
				    start = _rangeByValue.start,
				    end = _rangeByValue.end;
	
				return this.extract(start, end - start);
			}
	
			/**
	   * extracts all values between startValue and endValue which pass the filter. inclusive.
	   */
	
		}, {
			key: 'extractByValueWithFilter',
			value: function extractByValueWithFilter(startValue, endValue, filter) {
				var _rangeByValue2 = this.rangeByValue(startValue, endValue),
				    start = _rangeByValue2.start,
				    end = _rangeByValue2.end;
	
				return this.extractWithFilter(start, end - start, filter);
			}
	
			/**
	  	 * returns a range of values
	  	 */
	
		}, {
			key: 'slice',
			value: function slice() {
				var start = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
				var end = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.length;
	
				return this._values.slice(start, end);
			}
	
			/**
	   * returns values by value. inclusive
	   */
	
		}, {
			key: 'sliceByValue',
			value: function sliceByValue(startValue) {
				var endValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : startValue;
	
				var _rangeByValue3 = this.rangeByValue(startValue, endValue),
				    start = _rangeByValue3.start,
				    end = _rangeByValue3.end;
	
				return this.slice(start, end);
			}
	
			/**
	   *  gets the index where the value starts (or would start)
	   */
	
		}, {
			key: 'indexStart',
			value: function indexStart(value) {
				return _lodash2.default.sortedIndexBy(this._values, value, this._iteratee);
			}
	
			/**
	   *  this is like getIndex instead, if the found value is NOT the same value,
	   *  then it returns -1 (like indexOf)
	   */
	
		}, {
			key: 'indexOf',
			value: function indexOf(value) {
				var pos = this.indexStart(value);
	
				if (this._iteratee(this._values[pos]) !== this._iteratee(value)) {
					pos = -1;
				}
	
				return pos;
			}
	
			/**
	   * gets the first index which is AFTER the value specified.
	   */
	
		}, {
			key: 'indexAfter',
			value: function indexAfter(value) {
				return _lodash2.default.sortedLastIndexBy(this._values, value, this._iteratee);
			}
	
			/**
	   *  values matching existing values are inserted after the existing values.
	   */
	
		}, {
			key: 'insert',
			value: function insert(value) {
				var pos = this.indexAfter(value);
	
				this._values.splice(pos, 0, value);
			}
	
			/**
	   * inserts a list of values and maintains order. values do not need to be sorted.
	   */
	
		}, {
			key: 'insertList',
			value: function insertList(values) {
				var _this = this;
	
				if (!_lodash2.default.isArray(values)) {
					throw new Error('OrderedArray.insertMultiples requires an array as input : {' + values);
				}
	
				// TODO: we could optimize this by assuming values are sparse and sorted. ie
				// if we inserted a value, then if the next value is >= and if the next value in the
				// array is greater than or equal, then insert, otherwise we have to fallback.
				// it may even be worth while to verify if the input values are sorted, and then we can determine
				// if they can be spliced in one go, or just appended, etc. Otherwise we have multiple
				// binary searches to perform
				values.forEach(function (value) {
					return _this.insert(value);
				});
			}
		}, {
			key: 'length',
			get: function get() {
				return this._values.length;
			}
	
			/**
	   * sorted shallow-copy of all values
	   */
	
		}, {
			key: 'values',
			get: function get() {
				return this._values.slice();
			}
		}]);
	
		return OrderedArray;
	}();
	
	exports.default = OrderedArray;
	module.exports = exports['default'];

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * HlsDateRange
	 *
	 *  processes Hls DateRanges
	 *
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _HlsUtils = __webpack_require__(6);
	
	var _HlsUtils2 = _interopRequireDefault(_HlsUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	* @access internal
	*/
	var HlsDateRange = function () {
		function HlsDateRange(dateRange) {
			_classCallCheck(this, HlsDateRange);
	
			this._rawDateRange = dateRange;
			this._parse();
		}
	
		_createClass(HlsDateRange, [{
			key: 'dispose',
			value: function dispose() {}
		}, {
			key: 'set',
			value: function set(dateRange) {
				this._rawDateRange = dateRange;
	
				this._parse();
			}
		}, {
			key: 'clearValues',
			value: function clearValues() {
				this._id = undefined;
				this._startDate = undefined;
				this._bamcmd = undefined;
				this._plannedDuration = undefined;
				this._duration = undefined;
			}
		}, {
			key: '_parse',
			value: function _parse() {
				if (this._rawDateRange != null && _HlsUtils2.default.isString(this._rawDateRange)) {
					this._split = this._rawDateRange.split(',');
					var splitLen = this._split.length;
	
					//console.log(this._split);
	
					for (var i = 0; i < splitLen; i++) {
						var innerSplit = this._split[i].split('=');
						if (innerSplit.length > 1) {
	
							var value = innerSplit[1].replace(/^"(.*)"$/, '$1');
	
							if (innerSplit[0] === 'ID') {
								this._id = value;
							} else if (innerSplit[0] === 'START-DATE') {
								this._startDate = value;
							} else if (innerSplit[0] === 'PLANNED-DURATION') {
								this._plannedDuration = value;
							} else if (innerSplit[0] === 'DURATION') {
								this._duration = value;
							} else if (innerSplit[0] === 'X-BAM-CMD') {
								this._bamcmd = value;
							}
						}
					}
				} else {
					this.clearValues();
				}
			}
		}, {
			key: 'id',
			get: function get() {
				return this._id;
			}
		}, {
			key: 'startDate',
			get: function get() {
				return this._startDate;
			}
		}, {
			key: 'plannedDuration',
			get: function get() {
				return this._plannedDuration;
			}
		}, {
			key: 'duration',
			get: function get() {
				return this._duration;
			}
		}, {
			key: 'bamcmd',
			get: function get() {
				return this._bamcmd;
			}
		}, {
			key: 'rawDateRange',
			get: function get() {
				return this._rawDateRange;
			}
		}]);
	
		return HlsDateRange;
	}();
	
	exports.default = HlsDateRange;
	module.exports = exports['default'];

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * hlsKey
	 *
	 *  ...secure key managment
	 *
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _HlsUtils = __webpack_require__(6);
	
	var _HlsUtils2 = _interopRequireDefault(_HlsUtils);
	
	__webpack_require__(163);
	
	var _lodash = __webpack_require__(61);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _detectBrowser = __webpack_require__(47);
	
	var _detectBrowser2 = _interopRequireDefault(_detectBrowser);
	
	var _dataTypes = __webpack_require__(36);
	
	var _dataTypes2 = _interopRequireDefault(_dataTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _hlsKeyRef = null;
	/**
	* @access internal
	*/
	
	var HlsKey = function () {
		function HlsKey(downloader) {
			var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
			_classCallCheck(this, HlsKey);
	
			this._downloader = downloader;
			this._keys = [];
			this._pendedLoads = [];
			this._inLoad = false;
			this._browDetected = _detectBrowser2.default;
	
			if (this._browDetected.name === 'node') {
				this._transType = 'array';
			} else {
				this._transType = 'arraybuffer';
			}
	
			_HlsUtils2.default.applyConfig(this, config);
	
			_hlsKeyRef = this;
		}
	
		_createClass(HlsKey, [{
			key: 'dispose',
			value: function dispose() {}
		}, {
			key: 'destroy',
			value: function destroy() {}
		}, {
			key: '_getCypher',
			value: function _getCypher(url) {
				var foundkey = undefined;
				var returnval = undefined;
	
				var gettingFind = function gettingFind(x) {
					return x.url === url;
				};
	
				foundkey = _lodash2.default.find(this._keys, gettingFind);
	
				if (foundkey === undefined) {
					var getCypherThat = this;
	
					//console.log( url + ' not in cache. Starting load ***************************************************');
	
					var cypher = new Promise(function (resolve, reject) {
	
						var cypherGot = function cypherGot(response) {
							getCypherThat._inLoad = false;
							//console.log( response.url + ' cypherGot ***************************************************');
							if (response === undefined) reject(-1);else resolve(response.data);
	
							//console.log( getCypherThat._pendedLoads.length + ' pended loads ***************************************************');
	
							if (getCypherThat._pendedLoads.length !== 0) {
								var pendedLoad = getCypherThat._pendedLoads.shift();
	
								//console.log( pendedLoad.url + ' load now ***************************************************');
	
								getCypherThat.loadKeyIn(pendedLoad.url, pendedLoad.finishedCallback, pendedLoad.timeoutCallback, pendedLoad.getCypherThat);
							}
						};
	
						var cypherTimeout = function cypherTimeout() {
							getCypherThat._inLoad = false;
							//console.log( ' cypherTimeout ***************************************************');
							reject(-1);
						};
	
						getCypherThat.loadKeyIn(url, cypherGot, cypherTimeout, getCypherThat);
					});
	
					this._keys.push({
						url: url,
						cypher: cypher
					});
	
					returnval = cypher;
				} else {
					//console.log(this._keys.length + ' keys in cache, Found! ***************************************************');
					returnval = foundkey.cypher;
				}
	
				return returnval;
			}
		}, {
			key: 'getCypher',
			value: function getCypher(url) {
	
				var getCypherThat = this;
	
				var gettingCypher = new Promise(function (resolve, reject) {
	
					getCypherThat._getCypher(url).then(function (data) {
						return resolve(data);
					}).catch(function (err) {
						return reject(err);
					});
	
					//			if (returnval === undefined) reject(-1);  //this is only checking if the passed back promise is one
					//			else resolve(returnval);
				});
	
				return gettingCypher;
			}
		}, {
			key: 'hlsKeyLoadCallback',
			value: function hlsKeyLoadCallback(context, callbacks) {
	
				//console.log('hlsKeyLoadCallback ' + context.url + '***************************************************');
	
				_hlsKeyRef.getCypher(context.url).then(function (data) {
					return callbacks.onSuccess(data);
				}).catch(function (err) {
					return callbacks.onError(null, new Error('Could not load key ' + err));
				});
			}
		}, {
			key: 'loadKeyIn',
			value: function loadKeyIn(url, finishedCallback, timeoutCallback, getCypherThat) {
	
				if (!getCypherThat._inLoad) {
					getCypherThat._inLoad = true;
	
					//console.log( getCypherThat._downloader );
	
					//console.log( url + ' loadKeyIn ***************************************************');
	
					var loaderContext = { url: url, responseType: getCypherThat._transType, dataType: _dataTypes2.default.KEY };
					var loaderConfig = {
						timeout: 10000 //config.fragLoadingTimeOut,
						//				maxRetry : config.fragLoadingMaxRetry,
						//				retryDelay : config.fragLoadingRetryDelay,
						//				maxRetryDelay : config.fragLoadingMaxRetryTimeout,
					};
	
					var loaderCallbacks = { onSuccess: finishedCallback.bind(getCypherThat), onTimeout: timeoutCallback.bind(getCypherThat) };
					//, onError :this.loaderror.bind(getCypherThat), onTimeout : this.loadtimeout.bind(getCypherThat)
	
	
					//console.log( 'downloader *********************' + getCypherThat._downloader );
	
					getCypherThat._downloader.load(loaderContext, loaderConfig, loaderCallbacks);
				} else {
					//console.log( url + ' pended loadKeyIn ***************************************************');
	
					getCypherThat._pendedLoads.push({
						url: url,
						finishedCallback: finishedCallback,
						timeoutCallback: timeoutCallback,
						getCypherThat: getCypherThat
					});
				}
			}
		}, {
			key: 'downloader',
			get: function get() {
				return this._downloader;
			},
			set: function set(downloader) {
				this._downloader = downloader;
				return this._downloader;
			}
		}, {
			key: 'length',
			get: function get() {
				return this._keys.length;
			}
		}]);
	
		return HlsKey;
	}();
	
	exports.default = HlsKey;
	module.exports = exports['default'];

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * instanceCounter
	 *
	 *  ...for tracking and logging
	 *
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _HlsUtils = __webpack_require__(6);
	
	var _HlsUtils2 = _interopRequireDefault(_HlsUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	* @access internal
	*/
	var InstanceCounter = function () {
		function InstanceCounter() {
			var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
			_classCallCheck(this, InstanceCounter);
	
			this._lastNumber = 0;
			this._totalActive = 0;
	
			_HlsUtils2.default.applyConfig(this, config);
		}
	
		_createClass(InstanceCounter, [{
			key: 'dispose',
			value: function dispose() {}
	
			//increment active and last number, return new last number
	
		}, {
			key: 'increment',
			value: function increment() {
				this._lastNumber++;
				this._totalActive++;
	
				return this._lastNumber;
			}
	
			//decrement active total, return new value
	
		}, {
			key: 'decrement',
			value: function decrement() {
				this._totalActive--;
				return this._totalActive;
			}
	
			//return active total
	
		}, {
			key: 'active',
			value: function active() {
				return this._totalActive;
			}
	
			//return last number, which is the same as the total count given
	
		}, {
			key: 'total',
			value: function total() {
				return this._lastNumber;
			}
		}]);
	
		return InstanceCounter;
	}();
	
	exports.default = InstanceCounter;
	module.exports = exports['default'];

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * logTube
	 *
	 *  ...Console.log tunneling
	 *
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _HlsUtils = __webpack_require__(6);
	
	var _HlsUtils2 = _interopRequireDefault(_HlsUtils);
	
	var _HlsEvents = __webpack_require__(14);
	
	var _HlsEvents2 = _interopRequireDefault(_HlsEvents);
	
	var _eventemitter = __webpack_require__(33);
	
	var _eventemitter2 = _interopRequireDefault(_eventemitter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	* @access internal
	*/
	var LogTube = function () {
		function LogTube() {
			var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
			var di = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
			_classCallCheck(this, LogTube);
	
			this._emitter = di.eventEmitter || new _eventemitter2.default();
			this._event = _HlsEvents2.default.LOGTUBE_LOG;
			_HlsUtils2.default.applyConfig(this, config);
		}
	
		_createClass(LogTube, [{
			key: 'dispose',
			value: function dispose() {
				this._emitter = null;
			}
		}, {
			key: 'log',
			value: function log(message) {
				if (this._debug) {
					if (this._emitter.trigger !== undefined) {
						this._emitter.trigger(this._event, { message: message });
					} else {
						this._emitter.emit(this._event, { message: message });
					}
				}
			}
		}, {
			key: 'debug',
			get: function get() {
				return this._debug;
			},
			set: function set(value) {
				this._debug = !!value;
			}
		}, {
			key: 'event',
			get: function get() {
				return this._event;
			},
			set: function set(value) {
				this._event = value;
			}
		}]);
	
		return LogTube;
	}();
	
	exports.default = LogTube;
	module.exports = exports['default'];

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * MarkerM
	 *
	 *  id based markers
	 *
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _HlsUtils = __webpack_require__(6);
	
	var _HlsUtils2 = _interopRequireDefault(_HlsUtils);
	
	var _OrderedArray = __webpack_require__(164);
	
	var _OrderedArray2 = _interopRequireDefault(_OrderedArray);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	* @access internal
	*/
	var MarkerM = function () {
		function MarkerM() {
			var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
			_classCallCheck(this, MarkerM);
	
			this._markers = new _OrderedArray2.default([], function (x) {
				return x.time;
			});
			this._lastTime = -Infinity;
			this._nextMarkerId = 1;
	
			_HlsUtils2.default.applyConfig(this, config);
		}
	
		_createClass(MarkerM, [{
			key: 'dispose',
			value: function dispose() {
				this._markers = null;
			}
		}, {
			key: 'addMarker',
			value: function addMarker(time) {
				var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
				var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
				var markerId = this._nextMarkerId;
	
				_HlsUtils2.default.checkNotFiniteAndThrow(time, 'MarkerM.addMarker: time');
	
				this._nextMarkerId++;
				if (callback) {
					if (!_HlsUtils2.default.isFunction(callback)) {
						throw new Error('MarkerM.addMarker: callback must be a function if specified');
					}
				}
				//The OrderedArray is set to use time as the sorter so we need to require time
				var marker = { time: time, data: data, callback: callback, markerId: markerId };
	
				if (marker !== undefined && marker !== null && marker.time !== undefined) {
					this._markers.insert(marker);
				} else {
					markerId = 0;
				}
	
				return markerId;
			}
		}, {
			key: 'clearAllMarkers',
			value: function clearAllMarkers() {
				this._markers.clear();
			}
		}, {
			key: 'removeMarkerRange',
			value: function removeMarkerRange(start, end, filter) {
				this._markers.extractByValueWithFilter(start, end, filter);
			}
		}, {
			key: 'removeMarker',
			value: function removeMarker(markerId) {
				var total = this._count;
				this._markers.extractWithFilter(0, total, function (v) {
					return v.markerId === markerId;
				});
			}
		}, {
			key: 'seekMarkers',
			value: function seekMarkers(time) {
				this._lastTime = time;
			}
		}, {
			key: '_triggerMarker',
			value: function _triggerMarker(marker) {
				var callback = marker.callback;
	
				if (callback) {
					callback(marker.time, marker.data, marker.markerId);
				}
			}
		}, {
			key: '_triggerMarkers',
			value: function _triggerMarkers(markers) {
				var _this = this;
	
				markers.forEach(function (marker) {
					return _this._triggerMarker(marker);
				});
			}
		}, {
			key: 'timeUpdate',
			value: function timeUpdate(timeNow) {
				if (this._markers.length) {
					var pickedMarkers = this._markers.sliceByValue({ time: this._lastTime }, { time: timeNow });
	
					this._triggerMarkers(pickedMarkers);
				}
			}
		}, {
			key: 'timeUpdateWithExtract',
			value: function timeUpdateWithExtract(timeNow, filter) {
				if (this._markers.length) {
					var pickedMarkers = this._markers.extractByValueWithFilter({ time: this._lastTime }, { time: timeNow }, filter);
	
					this._triggerMarkers(pickedMarkers);
				}
			}
		}, {
			key: 'count',
			get: function get() {
				return this._markers.length;
			}
		}]);
	
		return MarkerM;
	}();
	
	exports.default = MarkerM;
	module.exports = exports['default'];

/***/ }),
/* 170 */
/***/ (function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	var toObject = __webpack_require__(12);
	var toAbsoluteIndex = __webpack_require__(39);
	var toLength = __webpack_require__(9);
	
	module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
	  var O = toObject(this);
	  var len = toLength(O.length);
	  var to = toAbsoluteIndex(target, len);
	  var from = toAbsoluteIndex(start, len);
	  var end = arguments.length > 2 ? arguments[2] : undefined;
	  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
	  var inc = 1;
	  if (from < to && to < from + count) {
	    inc = -1;
	    from += count - 1;
	    to += count - 1;
	  }
	  while (count-- > 0) {
	    if (from in O) O[to] = O[from];
	    else delete O[to];
	    to += inc;
	    from += inc;
	  } return O;
	};


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(12);
	var toAbsoluteIndex = __webpack_require__(39);
	var toLength = __webpack_require__(9);
	module.exports = function fill(value /* , start = 0, end = @length */) {
	  var O = toObject(this);
	  var length = toLength(O.length);
	  var aLen = arguments.length;
	  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
	  var end = aLen > 2 ? arguments[2] : undefined;
	  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
	  while (endPos > index) O[index++] = value;
	  return O;
	};


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(20);
	var isArray = __webpack_require__(54);
	var SPECIES = __webpack_require__(7)('species');
	
	module.exports = function (original) {
	  var C;
	  if (isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(19);
	var call = __webpack_require__(85);
	var isArrayIter = __webpack_require__(84);
	var anObject = __webpack_require__(16);
	var toLength = __webpack_require__(9);
	var getIterFn = __webpack_require__(96);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(27) && !__webpack_require__(24)(function () {
	  return Object.defineProperty(__webpack_require__(52)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 176 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(180);
	var descriptor = __webpack_require__(56);
	var setToStringTag = __webpack_require__(57);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(25)(IteratorPrototype, __webpack_require__(7)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 178 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(8);
	var macrotask = __webpack_require__(95).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(23)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    var promise = Promise.resolve();
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(16);
	var dPs = __webpack_require__(181);
	var enumBugKeys = __webpack_require__(82);
	var IE_PROTO = __webpack_require__(58)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(52)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(53).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(29);
	var anObject = __webpack_require__(16);
	var getKeys = __webpack_require__(89);
	
	module.exports = __webpack_require__(27) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(37);
	var toObject = __webpack_require__(12);
	var IE_PROTO = __webpack_require__(58)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(37);
	var toIObject = __webpack_require__(32);
	var arrayIndexOf = __webpack_require__(48)(false);
	var IE_PROTO = __webpack_require__(58)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(30);
	module.exports = function (target, src, safe) {
	  for (var key in src) redefine(target, key, src[key], safe);
	  return target;
	};


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(31);
	var defined = __webpack_require__(51);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(20);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(2);
	
	$export($export.P, 'Array', { copyWithin: __webpack_require__(171) });
	
	__webpack_require__(13)('copyWithin');


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $every = __webpack_require__(17)(4);
	
	$export($export.P + $export.F * !__webpack_require__(10)([].every, true), 'Array', {
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn /* , thisArg */) {
	    return $every(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(2);
	
	$export($export.P, 'Array', { fill: __webpack_require__(172) });
	
	__webpack_require__(13)('fill');


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $filter = __webpack_require__(17)(2);
	
	$export($export.P + $export.F * !__webpack_require__(10)([].filter, true), 'Array', {
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn /* , thisArg */) {
	    return $filter(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(2);
	var $find = __webpack_require__(17)(6);
	var KEY = 'findIndex';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(13)(KEY);


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(2);
	var $find = __webpack_require__(17)(5);
	var KEY = 'find';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(13)(KEY);


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $forEach = __webpack_require__(17)(0);
	var STRICT = __webpack_require__(10)([].forEach, true);
	
	$export($export.P + $export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */) {
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(19);
	var $export = __webpack_require__(2);
	var toObject = __webpack_require__(12);
	var call = __webpack_require__(85);
	var isArrayIter = __webpack_require__(84);
	var toLength = __webpack_require__(9);
	var createProperty = __webpack_require__(81);
	var getIterFn = __webpack_require__(96);
	
	$export($export.S + $export.F * !__webpack_require__(87)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $indexOf = __webpack_require__(48)(false);
	var $native = [].indexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(10)($native)), 'Array', {
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? $native.apply(this, arguments) || 0
	      : $indexOf(this, searchElement, arguments[1]);
	  }
	});


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Array', { isArray: __webpack_require__(54) });


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.13 Array.prototype.join(separator)
	var $export = __webpack_require__(2);
	var toIObject = __webpack_require__(32);
	var arrayJoin = [].join;
	
	// fallback for not array-like strings
	$export($export.P + $export.F * (__webpack_require__(38) != Object || !__webpack_require__(10)(arrayJoin)), 'Array', {
	  join: function join(separator) {
	    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
	  }
	});


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var toIObject = __webpack_require__(32);
	var toInteger = __webpack_require__(31);
	var toLength = __webpack_require__(9);
	var $native = [].lastIndexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(10)($native)), 'Array', {
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
	    // convert -0 to +0
	    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
	    var O = toIObject(this);
	    var length = toLength(O.length);
	    var index = length - 1;
	    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
	    if (index < 0) index = length + index;
	    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
	    return -1;
	  }
	});


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $map = __webpack_require__(17)(1);
	
	$export($export.P + $export.F * !__webpack_require__(10)([].map, true), 'Array', {
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn /* , thisArg */) {
	    return $map(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var createProperty = __webpack_require__(81);
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(24)(function () {
	  function F() { /* empty */ }
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */) {
	    var index = 0;
	    var aLen = arguments.length;
	    var result = new (typeof this == 'function' ? this : Array)(aLen);
	    while (aLen > index) createProperty(result, index, arguments[index++]);
	    result.length = aLen;
	    return result;
	  }
	});


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $reduce = __webpack_require__(80);
	
	$export($export.P + $export.F * !__webpack_require__(10)([].reduceRight, true), 'Array', {
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
	  }
	});


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $reduce = __webpack_require__(80);
	
	$export($export.P + $export.F * !__webpack_require__(10)([].reduce, true), 'Array', {
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: function reduce(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
	  }
	});


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var html = __webpack_require__(53);
	var cof = __webpack_require__(23);
	var toAbsoluteIndex = __webpack_require__(39);
	var toLength = __webpack_require__(9);
	var arraySlice = [].slice;
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * __webpack_require__(24)(function () {
	  if (html) arraySlice.call(html);
	}), 'Array', {
	  slice: function slice(begin, end) {
	    var len = toLength(this.length);
	    var klass = cof(this);
	    end = end === undefined ? len : end;
	    if (klass == 'Array') return arraySlice.call(this, begin, end);
	    var start = toAbsoluteIndex(begin, len);
	    var upTo = toAbsoluteIndex(end, len);
	    var size = toLength(upTo - start);
	    var cloned = new Array(size);
	    var i = 0;
	    for (; i < size; i++) cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $some = __webpack_require__(17)(3);
	
	$export($export.P + $export.F * !__webpack_require__(10)([].some, true), 'Array', {
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn /* , thisArg */) {
	    return $some(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var aFunction = __webpack_require__(15);
	var toObject = __webpack_require__(12);
	var fails = __webpack_require__(24);
	var $sort = [].sort;
	var test = [1, 2, 3];
	
	$export($export.P + $export.F * (fails(function () {
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function () {
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__(10)($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn) {
	    return comparefn === undefined
	      ? $sort.call(toObject(this))
	      : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(92)('Array');


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(50);
	var test = {};
	test[__webpack_require__(7)('toStringTag')] = 'z';
	if (test + '' != '[object z]') {
	  __webpack_require__(30)(Object.prototype, 'toString', function toString() {
	    return '[object ' + classof(this) + ']';
	  }, true);
	}


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(88);
	var global = __webpack_require__(8);
	var ctx = __webpack_require__(19);
	var classof = __webpack_require__(50);
	var $export = __webpack_require__(2);
	var isObject = __webpack_require__(20);
	var aFunction = __webpack_require__(15);
	var anInstance = __webpack_require__(170);
	var forOf = __webpack_require__(174);
	var speciesConstructor = __webpack_require__(94);
	var task = __webpack_require__(95).set;
	var microtask = __webpack_require__(179)();
	var newPromiseCapabilityModule = __webpack_require__(55);
	var perform = __webpack_require__(90);
	var promiseResolve = __webpack_require__(91);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(7)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(184)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(57)($Promise, PROMISE);
	__webpack_require__(92)(PROMISE);
	Wrapper = __webpack_require__(18)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(87)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
	var $export = __webpack_require__(2);
	var flattenIntoArray = __webpack_require__(83);
	var toObject = __webpack_require__(12);
	var toLength = __webpack_require__(9);
	var aFunction = __webpack_require__(15);
	var arraySpeciesCreate = __webpack_require__(49);
	
	$export($export.P, 'Array', {
	  flatMap: function flatMap(callbackfn /* , thisArg */) {
	    var O = toObject(this);
	    var sourceLen, A;
	    aFunction(callbackfn);
	    sourceLen = toLength(O.length);
	    A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
	    return A;
	  }
	});
	
	__webpack_require__(13)('flatMap');


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
	var $export = __webpack_require__(2);
	var flattenIntoArray = __webpack_require__(83);
	var toObject = __webpack_require__(12);
	var toLength = __webpack_require__(9);
	var toInteger = __webpack_require__(31);
	var arraySpeciesCreate = __webpack_require__(49);
	
	$export($export.P, 'Array', {
	  flatten: function flatten(/* depthArg = 1 */) {
	    var depthArg = arguments[0];
	    var O = toObject(this);
	    var sourceLen = toLength(O.length);
	    var A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
	    return A;
	  }
	});
	
	__webpack_require__(13)('flatten');


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/Array.prototype.includes
	var $export = __webpack_require__(2);
	var $includes = __webpack_require__(48)(true);
	
	$export($export.P, 'Array', {
	  includes: function includes(el /* , fromIndex = 0 */) {
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(13)('includes');


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(2);
	var core = __webpack_require__(18);
	var global = __webpack_require__(8);
	var speciesConstructor = __webpack_require__(94);
	var promiseResolve = __webpack_require__(91);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(2);
	var newPromiseCapability = __webpack_require__(55);
	var perform = __webpack_require__(90);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	var $iterators = __webpack_require__(97);
	var getKeys = __webpack_require__(89);
	var redefine = __webpack_require__(30);
	var global = __webpack_require__(8);
	var hide = __webpack_require__(25);
	var Iterators = __webpack_require__(28);
	var wks = __webpack_require__(7);
	var ITERATOR = wks('iterator');
	var TO_STRING_TAG = wks('toStringTag');
	var ArrayValues = Iterators.Array;
	
	var DOMIterables = {
	  CSSRuleList: true, // TODO: Not spec compliant, should be false.
	  CSSStyleDeclaration: false,
	  CSSValueList: false,
	  ClientRectList: false,
	  DOMRectList: false,
	  DOMStringList: false,
	  DOMTokenList: true,
	  DataTransferItemList: false,
	  FileList: false,
	  HTMLAllCollection: false,
	  HTMLCollection: false,
	  HTMLFormElement: false,
	  HTMLSelectElement: false,
	  MediaList: true, // TODO: Not spec compliant, should be false.
	  MimeTypeArray: false,
	  NamedNodeMap: false,
	  NodeList: true,
	  PaintRequestList: false,
	  Plugin: false,
	  PluginArray: false,
	  SVGLengthList: false,
	  SVGNumberList: false,
	  SVGPathSegList: false,
	  SVGPointList: false,
	  SVGStringList: false,
	  SVGTransformList: false,
	  SourceBufferList: false,
	  StyleSheetList: true, // TODO: Not spec compliant, should be false.
	  TextTrackCueList: false,
	  TextTrackList: false,
	  TouchList: false
	};
	
	for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
	  var NAME = collections[i];
	  var explicit = DOMIterables[NAME];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  var key;
	  if (proto) {
	    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
	    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
	  }
	}


/***/ }),
/* 215 */
/***/ (function(module, exports) {

	'use strict';
	module.exports = 9007199254740991;


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.typeDetect = factory());
	}(this, (function () { 'use strict';
	
	/* !
	 * type-detect
	 * Copyright(c) 2013 jake luer <jake@alogicalparadox.com>
	 * MIT Licensed
	 */
	var promiseExists = typeof Promise === 'function';
	
	/* eslint-disable no-undef */
	var globalObject = typeof self === 'object' ? self : global; // eslint-disable-line id-blacklist
	
	var symbolExists = typeof Symbol !== 'undefined';
	var mapExists = typeof Map !== 'undefined';
	var setExists = typeof Set !== 'undefined';
	var weakMapExists = typeof WeakMap !== 'undefined';
	var weakSetExists = typeof WeakSet !== 'undefined';
	var dataViewExists = typeof DataView !== 'undefined';
	var symbolIteratorExists = symbolExists && typeof Symbol.iterator !== 'undefined';
	var symbolToStringTagExists = symbolExists && typeof Symbol.toStringTag !== 'undefined';
	var setEntriesExists = setExists && typeof Set.prototype.entries === 'function';
	var mapEntriesExists = mapExists && typeof Map.prototype.entries === 'function';
	var setIteratorPrototype = setEntriesExists && Object.getPrototypeOf(new Set().entries());
	var mapIteratorPrototype = mapEntriesExists && Object.getPrototypeOf(new Map().entries());
	var arrayIteratorExists = symbolIteratorExists && typeof Array.prototype[Symbol.iterator] === 'function';
	var arrayIteratorPrototype = arrayIteratorExists && Object.getPrototypeOf([][Symbol.iterator]());
	var stringIteratorExists = symbolIteratorExists && typeof String.prototype[Symbol.iterator] === 'function';
	var stringIteratorPrototype = stringIteratorExists && Object.getPrototypeOf(''[Symbol.iterator]());
	var toStringLeftSliceLength = 8;
	var toStringRightSliceLength = -1;
	/**
	 * ### typeOf (obj)
	 *
	 * Uses `Object.prototype.toString` to determine the type of an object,
	 * normalising behaviour across engine versions & well optimised.
	 *
	 * @param {Mixed} object
	 * @return {String} object type
	 * @api public
	 */
	function typeDetect(obj) {
	  /* ! Speed optimisation
	   * Pre:
	   *   string literal     x 3,039,035 ops/sec ±1.62% (78 runs sampled)
	   *   boolean literal    x 1,424,138 ops/sec ±4.54% (75 runs sampled)
	   *   number literal     x 1,653,153 ops/sec ±1.91% (82 runs sampled)
	   *   undefined          x 9,978,660 ops/sec ±1.92% (75 runs sampled)
	   *   function           x 2,556,769 ops/sec ±1.73% (77 runs sampled)
	   * Post:
	   *   string literal     x 38,564,796 ops/sec ±1.15% (79 runs sampled)
	   *   boolean literal    x 31,148,940 ops/sec ±1.10% (79 runs sampled)
	   *   number literal     x 32,679,330 ops/sec ±1.90% (78 runs sampled)
	   *   undefined          x 32,363,368 ops/sec ±1.07% (82 runs sampled)
	   *   function           x 31,296,870 ops/sec ±0.96% (83 runs sampled)
	   */
	  var typeofObj = typeof obj;
	  if (typeofObj !== 'object') {
	    return typeofObj;
	  }
	
	  /* ! Speed optimisation
	   * Pre:
	   *   null               x 28,645,765 ops/sec ±1.17% (82 runs sampled)
	   * Post:
	   *   null               x 36,428,962 ops/sec ±1.37% (84 runs sampled)
	   */
	  if (obj === null) {
	    return 'null';
	  }
	
	  /* ! Spec Conformance
	   * Test: `Object.prototype.toString.call(window)``
	   *  - Node === "[object global]"
	   *  - Chrome === "[object global]"
	   *  - Firefox === "[object Window]"
	   *  - PhantomJS === "[object Window]"
	   *  - Safari === "[object Window]"
	   *  - IE 11 === "[object Window]"
	   *  - IE Edge === "[object Window]"
	   * Test: `Object.prototype.toString.call(this)``
	   *  - Chrome Worker === "[object global]"
	   *  - Firefox Worker === "[object DedicatedWorkerGlobalScope]"
	   *  - Safari Worker === "[object DedicatedWorkerGlobalScope]"
	   *  - IE 11 Worker === "[object WorkerGlobalScope]"
	   *  - IE Edge Worker === "[object WorkerGlobalScope]"
	   */
	  if (obj === globalObject) {
	    return 'global';
	  }
	
	  /* ! Speed optimisation
	   * Pre:
	   *   array literal      x 2,888,352 ops/sec ±0.67% (82 runs sampled)
	   * Post:
	   *   array literal      x 22,479,650 ops/sec ±0.96% (81 runs sampled)
	   */
	  if (
	    Array.isArray(obj) &&
	    (symbolToStringTagExists === false || !(Symbol.toStringTag in obj))
	  ) {
	    return 'Array';
	  }
	
	  // Not caching existence of `window` and related properties due to potential
	  // for `window` to be unset before tests in quasi-browser environments.
	  if (typeof window === 'object' && window !== null) {
	    /* ! Spec Conformance
	     * (https://html.spec.whatwg.org/multipage/browsers.html#location)
	     * WhatWG HTML$7.7.3 - The `Location` interface
	     * Test: `Object.prototype.toString.call(window.location)``
	     *  - IE <=11 === "[object Object]"
	     *  - IE Edge <=13 === "[object Object]"
	     */
	    if (typeof window.location === 'object' && obj === window.location) {
	      return 'Location';
	    }
	
	    /* ! Spec Conformance
	     * (https://html.spec.whatwg.org/#document)
	     * WhatWG HTML$3.1.1 - The `Document` object
	     * Note: Most browsers currently adher to the W3C DOM Level 2 spec
	     *       (https://www.w3.org/TR/DOM-Level-2-HTML/html.html#ID-26809268)
	     *       which suggests that browsers should use HTMLTableCellElement for
	     *       both TD and TH elements. WhatWG separates these.
	     *       WhatWG HTML states:
	     *         > For historical reasons, Window objects must also have a
	     *         > writable, configurable, non-enumerable property named
	     *         > HTMLDocument whose value is the Document interface object.
	     * Test: `Object.prototype.toString.call(document)``
	     *  - Chrome === "[object HTMLDocument]"
	     *  - Firefox === "[object HTMLDocument]"
	     *  - Safari === "[object HTMLDocument]"
	     *  - IE <=10 === "[object Document]"
	     *  - IE 11 === "[object HTMLDocument]"
	     *  - IE Edge <=13 === "[object HTMLDocument]"
	     */
	    if (typeof window.document === 'object' && obj === window.document) {
	      return 'Document';
	    }
	
	    if (typeof window.navigator === 'object') {
	      /* ! Spec Conformance
	       * (https://html.spec.whatwg.org/multipage/webappapis.html#mimetypearray)
	       * WhatWG HTML$8.6.1.5 - Plugins - Interface MimeTypeArray
	       * Test: `Object.prototype.toString.call(navigator.mimeTypes)``
	       *  - IE <=10 === "[object MSMimeTypesCollection]"
	       */
	      if (typeof window.navigator.mimeTypes === 'object' &&
	          obj === window.navigator.mimeTypes) {
	        return 'MimeTypeArray';
	      }
	
	      /* ! Spec Conformance
	       * (https://html.spec.whatwg.org/multipage/webappapis.html#pluginarray)
	       * WhatWG HTML$8.6.1.5 - Plugins - Interface PluginArray
	       * Test: `Object.prototype.toString.call(navigator.plugins)``
	       *  - IE <=10 === "[object MSPluginsCollection]"
	       */
	      if (typeof window.navigator.plugins === 'object' &&
	          obj === window.navigator.plugins) {
	        return 'PluginArray';
	      }
	    }
	
	    if ((typeof window.HTMLElement === 'function' ||
	        typeof window.HTMLElement === 'object') &&
	        obj instanceof window.HTMLElement) {
	      /* ! Spec Conformance
	      * (https://html.spec.whatwg.org/multipage/webappapis.html#pluginarray)
	      * WhatWG HTML$4.4.4 - The `blockquote` element - Interface `HTMLQuoteElement`
	      * Test: `Object.prototype.toString.call(document.createElement('blockquote'))``
	      *  - IE <=10 === "[object HTMLBlockElement]"
	      */
	      if (obj.tagName === 'BLOCKQUOTE') {
	        return 'HTMLQuoteElement';
	      }
	
	      /* ! Spec Conformance
	       * (https://html.spec.whatwg.org/#htmltabledatacellelement)
	       * WhatWG HTML$4.9.9 - The `td` element - Interface `HTMLTableDataCellElement`
	       * Note: Most browsers currently adher to the W3C DOM Level 2 spec
	       *       (https://www.w3.org/TR/DOM-Level-2-HTML/html.html#ID-82915075)
	       *       which suggests that browsers should use HTMLTableCellElement for
	       *       both TD and TH elements. WhatWG separates these.
	       * Test: Object.prototype.toString.call(document.createElement('td'))
	       *  - Chrome === "[object HTMLTableCellElement]"
	       *  - Firefox === "[object HTMLTableCellElement]"
	       *  - Safari === "[object HTMLTableCellElement]"
	       */
	      if (obj.tagName === 'TD') {
	        return 'HTMLTableDataCellElement';
	      }
	
	      /* ! Spec Conformance
	       * (https://html.spec.whatwg.org/#htmltableheadercellelement)
	       * WhatWG HTML$4.9.9 - The `td` element - Interface `HTMLTableHeaderCellElement`
	       * Note: Most browsers currently adher to the W3C DOM Level 2 spec
	       *       (https://www.w3.org/TR/DOM-Level-2-HTML/html.html#ID-82915075)
	       *       which suggests that browsers should use HTMLTableCellElement for
	       *       both TD and TH elements. WhatWG separates these.
	       * Test: Object.prototype.toString.call(document.createElement('th'))
	       *  - Chrome === "[object HTMLTableCellElement]"
	       *  - Firefox === "[object HTMLTableCellElement]"
	       *  - Safari === "[object HTMLTableCellElement]"
	       */
	      if (obj.tagName === 'TH') {
	        return 'HTMLTableHeaderCellElement';
	      }
	    }
	  }
	
	  /* ! Speed optimisation
	  * Pre:
	  *   Float64Array       x 625,644 ops/sec ±1.58% (80 runs sampled)
	  *   Float32Array       x 1,279,852 ops/sec ±2.91% (77 runs sampled)
	  *   Uint32Array        x 1,178,185 ops/sec ±1.95% (83 runs sampled)
	  *   Uint16Array        x 1,008,380 ops/sec ±2.25% (80 runs sampled)
	  *   Uint8Array         x 1,128,040 ops/sec ±2.11% (81 runs sampled)
	  *   Int32Array         x 1,170,119 ops/sec ±2.88% (80 runs sampled)
	  *   Int16Array         x 1,176,348 ops/sec ±5.79% (86 runs sampled)
	  *   Int8Array          x 1,058,707 ops/sec ±4.94% (77 runs sampled)
	  *   Uint8ClampedArray  x 1,110,633 ops/sec ±4.20% (80 runs sampled)
	  * Post:
	  *   Float64Array       x 7,105,671 ops/sec ±13.47% (64 runs sampled)
	  *   Float32Array       x 5,887,912 ops/sec ±1.46% (82 runs sampled)
	  *   Uint32Array        x 6,491,661 ops/sec ±1.76% (79 runs sampled)
	  *   Uint16Array        x 6,559,795 ops/sec ±1.67% (82 runs sampled)
	  *   Uint8Array         x 6,463,966 ops/sec ±1.43% (85 runs sampled)
	  *   Int32Array         x 5,641,841 ops/sec ±3.49% (81 runs sampled)
	  *   Int16Array         x 6,583,511 ops/sec ±1.98% (80 runs sampled)
	  *   Int8Array          x 6,606,078 ops/sec ±1.74% (81 runs sampled)
	  *   Uint8ClampedArray  x 6,602,224 ops/sec ±1.77% (83 runs sampled)
	  */
	  var stringTag = (symbolToStringTagExists && obj[Symbol.toStringTag]);
	  if (typeof stringTag === 'string') {
	    return stringTag;
	  }
	
	  var objPrototype = Object.getPrototypeOf(obj);
	  /* ! Speed optimisation
	  * Pre:
	  *   regex literal      x 1,772,385 ops/sec ±1.85% (77 runs sampled)
	  *   regex constructor  x 2,143,634 ops/sec ±2.46% (78 runs sampled)
	  * Post:
	  *   regex literal      x 3,928,009 ops/sec ±0.65% (78 runs sampled)
	  *   regex constructor  x 3,931,108 ops/sec ±0.58% (84 runs sampled)
	  */
	  if (objPrototype === RegExp.prototype) {
	    return 'RegExp';
	  }
	
	  /* ! Speed optimisation
	  * Pre:
	  *   date               x 2,130,074 ops/sec ±4.42% (68 runs sampled)
	  * Post:
	  *   date               x 3,953,779 ops/sec ±1.35% (77 runs sampled)
	  */
	  if (objPrototype === Date.prototype) {
	    return 'Date';
	  }
	
	  /* ! Spec Conformance
	   * (http://www.ecma-international.org/ecma-262/6.0/index.html#sec-promise.prototype-@@tostringtag)
	   * ES6$25.4.5.4 - Promise.prototype[@@toStringTag] should be "Promise":
	   * Test: `Object.prototype.toString.call(Promise.resolve())``
	   *  - Chrome <=47 === "[object Object]"
	   *  - Edge <=20 === "[object Object]"
	   *  - Firefox 29-Latest === "[object Promise]"
	   *  - Safari 7.1-Latest === "[object Promise]"
	   */
	  if (promiseExists && objPrototype === Promise.prototype) {
	    return 'Promise';
	  }
	
	  /* ! Speed optimisation
	  * Pre:
	  *   set                x 2,222,186 ops/sec ±1.31% (82 runs sampled)
	  * Post:
	  *   set                x 4,545,879 ops/sec ±1.13% (83 runs sampled)
	  */
	  if (setExists && objPrototype === Set.prototype) {
	    return 'Set';
	  }
	
	  /* ! Speed optimisation
	  * Pre:
	  *   map                x 2,396,842 ops/sec ±1.59% (81 runs sampled)
	  * Post:
	  *   map                x 4,183,945 ops/sec ±6.59% (82 runs sampled)
	  */
	  if (mapExists && objPrototype === Map.prototype) {
	    return 'Map';
	  }
	
	  /* ! Speed optimisation
	  * Pre:
	  *   weakset            x 1,323,220 ops/sec ±2.17% (76 runs sampled)
	  * Post:
	  *   weakset            x 4,237,510 ops/sec ±2.01% (77 runs sampled)
	  */
	  if (weakSetExists && objPrototype === WeakSet.prototype) {
	    return 'WeakSet';
	  }
	
	  /* ! Speed optimisation
	  * Pre:
	  *   weakmap            x 1,500,260 ops/sec ±2.02% (78 runs sampled)
	  * Post:
	  *   weakmap            x 3,881,384 ops/sec ±1.45% (82 runs sampled)
	  */
	  if (weakMapExists && objPrototype === WeakMap.prototype) {
	    return 'WeakMap';
	  }
	
	  /* ! Spec Conformance
	   * (http://www.ecma-international.org/ecma-262/6.0/index.html#sec-dataview.prototype-@@tostringtag)
	   * ES6$24.2.4.21 - DataView.prototype[@@toStringTag] should be "DataView":
	   * Test: `Object.prototype.toString.call(new DataView(new ArrayBuffer(1)))``
	   *  - Edge <=13 === "[object Object]"
	   */
	  if (dataViewExists && objPrototype === DataView.prototype) {
	    return 'DataView';
	  }
	
	  /* ! Spec Conformance
	   * (http://www.ecma-international.org/ecma-262/6.0/index.html#sec-%mapiteratorprototype%-@@tostringtag)
	   * ES6$23.1.5.2.2 - %MapIteratorPrototype%[@@toStringTag] should be "Map Iterator":
	   * Test: `Object.prototype.toString.call(new Map().entries())``
	   *  - Edge <=13 === "[object Object]"
	   */
	  if (mapExists && objPrototype === mapIteratorPrototype) {
	    return 'Map Iterator';
	  }
	
	  /* ! Spec Conformance
	   * (http://www.ecma-international.org/ecma-262/6.0/index.html#sec-%setiteratorprototype%-@@tostringtag)
	   * ES6$23.2.5.2.2 - %SetIteratorPrototype%[@@toStringTag] should be "Set Iterator":
	   * Test: `Object.prototype.toString.call(new Set().entries())``
	   *  - Edge <=13 === "[object Object]"
	   */
	  if (setExists && objPrototype === setIteratorPrototype) {
	    return 'Set Iterator';
	  }
	
	  /* ! Spec Conformance
	   * (http://www.ecma-international.org/ecma-262/6.0/index.html#sec-%arrayiteratorprototype%-@@tostringtag)
	   * ES6$22.1.5.2.2 - %ArrayIteratorPrototype%[@@toStringTag] should be "Array Iterator":
	   * Test: `Object.prototype.toString.call([][Symbol.iterator]())``
	   *  - Edge <=13 === "[object Object]"
	   */
	  if (arrayIteratorExists && objPrototype === arrayIteratorPrototype) {
	    return 'Array Iterator';
	  }
	
	  /* ! Spec Conformance
	   * (http://www.ecma-international.org/ecma-262/6.0/index.html#sec-%stringiteratorprototype%-@@tostringtag)
	   * ES6$21.1.5.2.2 - %StringIteratorPrototype%[@@toStringTag] should be "String Iterator":
	   * Test: `Object.prototype.toString.call(''[Symbol.iterator]())``
	   *  - Edge <=13 === "[object Object]"
	   */
	  if (stringIteratorExists && objPrototype === stringIteratorPrototype) {
	    return 'String Iterator';
	  }
	
	  /* ! Speed optimisation
	  * Pre:
	  *   object from null   x 2,424,320 ops/sec ±1.67% (76 runs sampled)
	  * Post:
	  *   object from null   x 5,838,000 ops/sec ±0.99% (84 runs sampled)
	  */
	  if (objPrototype === null) {
	    return 'Object';
	  }
	
	  return Object
	    .prototype
	    .toString
	    .call(obj)
	    .slice(toStringLeftSliceLength, toStringRightSliceLength);
	}
	
	return typeDetect;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	// see https://tools.ietf.org/html/rfc1808
	
	/* jshint ignore:start */
	(function(root) { 
	/* jshint ignore:end */
	
	  var URL_REGEX = /^((?:[a-zA-Z0-9+\-.]+:)?)(\/\/[^\/\;?#]*)?(.*?)??(;.*?)?(\?.*?)?(#.*?)?$/;
	  var FIRST_SEGMENT_REGEX = /^([^\/;?#]*)(.*)$/;
	  var SLASH_DOT_REGEX = /(?:\/|^)\.(?=\/)/g;
	  var SLASH_DOT_DOT_REGEX = /(?:\/|^)\.\.\/(?!\.\.\/).*?(?=\/)/g;
	
	  var URLToolkit = { // jshint ignore:line
	    // If opts.alwaysNormalize is true then the path will always be normalized even when it starts with / or //
	    // E.g
	    // With opts.alwaysNormalize = false (default, spec compliant)
	    // http://a.com/b/cd + /e/f/../g => http://a.com/e/f/../g
	    // With opts.alwaysNormalize = true (not spec compliant)
	    // http://a.com/b/cd + /e/f/../g => http://a.com/e/g
	    buildAbsoluteURL: function(baseURL, relativeURL, opts) {
	      opts = opts || {};
	      // remove any remaining space and CRLF
	      baseURL = baseURL.trim();
	      relativeURL = relativeURL.trim();
	      if (!relativeURL) {
	        // 2a) If the embedded URL is entirely empty, it inherits the
	        // entire base URL (i.e., is set equal to the base URL)
	        // and we are done.
	        if (!opts.alwaysNormalize) {
	          return baseURL;
	        }
	        var basePartsForNormalise = URLToolkit.parseURL(baseURL);
	        if (!basePartsForNormalise) {
	          throw new Error('Error trying to parse base URL.');
	        }
	        basePartsForNormalise.path = URLToolkit.normalizePath(basePartsForNormalise.path);
	        return URLToolkit.buildURLFromParts(basePartsForNormalise);
	      }
	      var relativeParts = URLToolkit.parseURL(relativeURL);
	      if (!relativeParts) {
	        throw new Error('Error trying to parse relative URL.');
	      }
	      if (relativeParts.scheme) {
	        // 2b) If the embedded URL starts with a scheme name, it is
	        // interpreted as an absolute URL and we are done.
	        if (!opts.alwaysNormalize) {
	          return relativeURL;
	        }
	        relativeParts.path = URLToolkit.normalizePath(relativeParts.path);
	        return URLToolkit.buildURLFromParts(relativeParts);
	      }
	      var baseParts = URLToolkit.parseURL(baseURL);
	      if (!baseParts) {
	        throw new Error('Error trying to parse base URL.');
	      }
	      if (!baseParts.netLoc && baseParts.path && baseParts.path[0] !== '/') {
	        // If netLoc missing and path doesn't start with '/', assume everthing before the first '/' is the netLoc
	        // This causes 'example.com/a' to be handled as '//example.com/a' instead of '/example.com/a'
	        var pathParts = FIRST_SEGMENT_REGEX.exec(baseParts.path);
	        baseParts.netLoc = pathParts[1];
	        baseParts.path = pathParts[2];
	      }
	      if (baseParts.netLoc && !baseParts.path) {
	        baseParts.path = '/';
	      }
	      var builtParts = {
	        // 2c) Otherwise, the embedded URL inherits the scheme of
	        // the base URL.
	        scheme: baseParts.scheme,
	        netLoc: relativeParts.netLoc,
	        path: null,
	        params: relativeParts.params,
	        query: relativeParts.query,
	        fragment: relativeParts.fragment
	      };
	      if (!relativeParts.netLoc) {
	        // 3) If the embedded URL's <net_loc> is non-empty, we skip to
	        // Step 7.  Otherwise, the embedded URL inherits the <net_loc>
	        // (if any) of the base URL.
	        builtParts.netLoc = baseParts.netLoc;
	        // 4) If the embedded URL path is preceded by a slash "/", the
	        // path is not relative and we skip to Step 7.
	        if (relativeParts.path[0] !== '/') {
	          if (!relativeParts.path) {
	            // 5) If the embedded URL path is empty (and not preceded by a
	            // slash), then the embedded URL inherits the base URL path
	            builtParts.path = baseParts.path;
	            // 5a) if the embedded URL's <params> is non-empty, we skip to
	            // step 7; otherwise, it inherits the <params> of the base
	            // URL (if any) and
	            if (!relativeParts.params) {
	              builtParts.params = baseParts.params;
	              // 5b) if the embedded URL's <query> is non-empty, we skip to
	              // step 7; otherwise, it inherits the <query> of the base
	              // URL (if any) and we skip to step 7.
	              if (!relativeParts.query) {
	                builtParts.query = baseParts.query;
	              }
	            }
	          } else {
	            // 6) The last segment of the base URL's path (anything
	            // following the rightmost slash "/", or the entire path if no
	            // slash is present) is removed and the embedded URL's path is
	            // appended in its place.
	            var baseURLPath = baseParts.path;
	            var newPath = baseURLPath.substring(0, baseURLPath.lastIndexOf('/') + 1) + relativeParts.path;
	            builtParts.path = URLToolkit.normalizePath(newPath);
	          }
	        }
	      }
	      if (builtParts.path === null) {
	        builtParts.path = opts.alwaysNormalize ? URLToolkit.normalizePath(relativeParts.path) : relativeParts.path;
	      }
	      return URLToolkit.buildURLFromParts(builtParts);
	    },
	    parseURL: function(url) {
	      var parts = URL_REGEX.exec(url);
	      if (!parts) {
	        return null;
	      }
	      return {
	        scheme: parts[1] || '',
	        netLoc: parts[2] || '',
	        path: parts[3] || '',
	        params: parts[4] || '',
	        query: parts[5] || '',
	        fragment: parts[6] || ''
	      };
	    },
	    normalizePath: function(path) {
	      // The following operations are
	      // then applied, in order, to the new path:
	      // 6a) All occurrences of "./", where "." is a complete path
	      // segment, are removed.
	      // 6b) If the path ends with "." as a complete path segment,
	      // that "." is removed.
	      path = path.split('').reverse().join('').replace(SLASH_DOT_REGEX, '');
	      // 6c) All occurrences of "<segment>/../", where <segment> is a
	      // complete path segment not equal to "..", are removed.
	      // Removal of these path segments is performed iteratively,
	      // removing the leftmost matching pattern on each iteration,
	      // until no matching pattern remains.
	      // 6d) If the path ends with "<segment>/..", where <segment> is a
	      // complete path segment not equal to "..", that
	      // "<segment>/.." is removed.
	      while (path.length !== (path = path.replace(SLASH_DOT_DOT_REGEX, '')).length) {} // jshint ignore:line
	      return path.split('').reverse().join('');
	    },
	    buildURLFromParts: function(parts) {
	      return parts.scheme + parts.netLoc + parts.path + parts.params + parts.query + parts.fragment;
	    }
	  };
	
	/* jshint ignore:start */
	  if(true)
	    module.exports = URLToolkit;
	  else if(typeof define === 'function' && define.amd)
	    define([], function() { return URLToolkit; });
	  else if(typeof exports === 'object')
	    exports["URLToolkit"] = URLToolkit;
	  else
	    root["URLToolkit"] = URLToolkit;
	})(this);
	/* jshint ignore:end */


/***/ }),
/* 218 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	function webpackBootstrapFunc (modules) {
	/******/  // The module cache
	/******/  var installedModules = {};
	
	/******/  // The require function
	/******/  function __webpack_require__(moduleId) {
	
	/******/    // Check if module is in cache
	/******/    if(installedModules[moduleId])
	/******/      return installedModules[moduleId].exports;
	
	/******/    // Create a new module (and put it into the cache)
	/******/    var module = installedModules[moduleId] = {
	/******/      i: moduleId,
	/******/      l: false,
	/******/      exports: {}
	/******/    };
	
	/******/    // Execute the module function
	/******/    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/    // Flag the module as loaded
	/******/    module.l = true;
	
	/******/    // Return the exports of the module
	/******/    return module.exports;
	/******/  }
	
	/******/  // expose the modules object (__webpack_modules__)
	/******/  __webpack_require__.m = modules;
	
	/******/  // expose the module cache
	/******/  __webpack_require__.c = installedModules;
	
	/******/  // identity function for calling harmony imports with the correct context
	/******/  __webpack_require__.i = function(value) { return value; };
	
	/******/  // define getter function for harmony exports
	/******/  __webpack_require__.d = function(exports, name, getter) {
	/******/    if(!__webpack_require__.o(exports, name)) {
	/******/      Object.defineProperty(exports, name, {
	/******/        configurable: false,
	/******/        enumerable: true,
	/******/        get: getter
	/******/      });
	/******/    }
	/******/  };
	
	/******/  // define __esModule on exports
	/******/  __webpack_require__.r = function(exports) {
	/******/    Object.defineProperty(exports, '__esModule', { value: true });
	/******/  };
	
	/******/  // getDefaultExport function for compatibility with non-harmony modules
	/******/  __webpack_require__.n = function(module) {
	/******/    var getter = module && module.__esModule ?
	/******/      function getDefault() { return module['default']; } :
	/******/      function getModuleExports() { return module; };
	/******/    __webpack_require__.d(getter, 'a', getter);
	/******/    return getter;
	/******/  };
	
	/******/  // Object.prototype.hasOwnProperty.call
	/******/  __webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	
	/******/  // __webpack_public_path__
	/******/  __webpack_require__.p = "/";
	
	/******/  // on error function for async loading
	/******/  __webpack_require__.oe = function(err) { console.error(err); throw err; };
	
	  var f = __webpack_require__(__webpack_require__.s = ENTRY_MODULE)
	  return f.default || f // try to call default if defined to also support babel esmodule exports
	}
	
	var moduleNameReqExp = '[\\.|\\-|\\+|\\w|\/|@]+'
	var dependencyRegExp = '\\((\/\\*.*?\\*\/)?\s?.*?(' + moduleNameReqExp + ').*?\\)' // additional chars when output.pathinfo is true
	
	// http://stackoverflow.com/a/2593661/130442
	function quoteRegExp (str) {
	  return (str + '').replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&')
	}
	
	function getModuleDependencies (sources, module, queueName) {
	  var retval = {}
	  retval[queueName] = []
	
	  var fnString = module.toString()
	  var wrapperSignature = fnString.match(/^function\s?\(\w+,\s*\w+,\s*(\w+)\)/)
	  if (!wrapperSignature) return retval
	  var webpackRequireName = wrapperSignature[1]
	
	  // main bundle deps
	  var re = new RegExp('(\\\\n|\\W)' + quoteRegExp(webpackRequireName) + dependencyRegExp, 'g')
	  var match
	  while ((match = re.exec(fnString))) {
	    if (match[3] === 'dll-reference') continue
	    retval[queueName].push(match[3])
	  }
	
	  // dll deps
	  re = new RegExp('\\(' + quoteRegExp(webpackRequireName) + '\\("(dll-reference\\s(' + moduleNameReqExp + '))"\\)\\)' + dependencyRegExp, 'g')
	  while ((match = re.exec(fnString))) {
	    if (!sources[match[2]]) {
	      retval[queueName].push(match[1])
	      sources[match[2]] = __webpack_require__(match[1]).m
	    }
	    retval[match[2]] = retval[match[2]] || []
	    retval[match[2]].push(match[4])
	  }
	
	  return retval
	}
	
	function hasValuesInQueues (queues) {
	  var keys = Object.keys(queues)
	  return keys.reduce(function (hasValues, key) {
	    return hasValues || queues[key].length > 0
	  }, false)
	}
	
	function getRequiredModules (sources, moduleId) {
	  var modulesQueue = {
	    main: [moduleId]
	  }
	  var requiredModules = {
	    main: []
	  }
	  var seenModules = {
	    main: {}
	  }
	
	  while (hasValuesInQueues(modulesQueue)) {
	    var queues = Object.keys(modulesQueue)
	    for (var i = 0; i < queues.length; i++) {
	      var queueName = queues[i]
	      var queue = modulesQueue[queueName]
	      var moduleToCheck = queue.pop()
	      seenModules[queueName] = seenModules[queueName] || {}
	      if (seenModules[queueName][moduleToCheck] || !sources[queueName][moduleToCheck]) continue
	      seenModules[queueName][moduleToCheck] = true
	      requiredModules[queueName] = requiredModules[queueName] || []
	      requiredModules[queueName].push(moduleToCheck)
	      var newModules = getModuleDependencies(sources, sources[queueName][moduleToCheck], queueName)
	      var newModulesKeys = Object.keys(newModules)
	      for (var j = 0; j < newModulesKeys.length; j++) {
	        modulesQueue[newModulesKeys[j]] = modulesQueue[newModulesKeys[j]] || []
	        modulesQueue[newModulesKeys[j]] = modulesQueue[newModulesKeys[j]].concat(newModules[newModulesKeys[j]])
	      }
	    }
	  }
	
	  return requiredModules
	}
	
	module.exports = function (moduleId, options) {
	  options = options || {}
	  var sources = {
	    main: __webpack_require__.m
	  }
	
	  var requiredModules = options.all ? { main: Object.keys(sources) } : getRequiredModules(sources, moduleId)
	
	  var src = ''
	
	  Object.keys(requiredModules).filter(function (m) { return m !== 'main' }).forEach(function (module) {
	    var entryModule = 0
	    while (requiredModules[module][entryModule]) {
	      entryModule++
	    }
	    requiredModules[module].push(entryModule)
	    sources[module][entryModule] = '(function(module, exports, __webpack_require__) { module.exports = __webpack_require__; })'
	    src = src + 'var ' + module + ' = (' + webpackBootstrapFunc.toString().replace('ENTRY_MODULE', JSON.stringify(entryModule)) + ')({' + requiredModules[module].map(function (id) { return '' + JSON.stringify(id) + ': ' + sources[module][id].toString() }).join(',') + '});\n'
	  })
	
	  src = src + '(' + webpackBootstrapFunc.toString().replace('ENTRY_MODULE', JSON.stringify(moduleId)) + ')({' + requiredModules.main.map(function (id) { return '' + JSON.stringify(id) + ': ' + sources.main[id].toString() }).join(',') + '})(self);'
	
	  var blob = new window.Blob([src], { type: 'text/javascript' })
	  if (options.bare) { return blob }
	
	  var URL = window.URL || window.webkitURL || window.mozURL || window.msURL
	
	  var workerUrl = URL.createObjectURL(blob)
	  var worker = new window.Worker(workerUrl)
	  worker.objectURL = workerUrl
	
	  return worker
	}


/***/ }),
/* 220 */
/***/ (function(module, exports) {

	var bundleFn = arguments[3];
	var sources = arguments[4];
	var cache = arguments[5];
	
	var stringify = JSON.stringify;
	
	module.exports = function (fn, options) {
	    var wkey;
	    var cacheKeys = Object.keys(cache);
	
	    for (var i = 0, l = cacheKeys.length; i < l; i++) {
	        var key = cacheKeys[i];
	        var exp = cache[key].exports;
	        // Using babel as a transpiler to use esmodule, the export will always
	        // be an object with the default export as a property of it. To ensure
	        // the existing api and babel esmodule exports are both supported we
	        // check for both
	        if (exp === fn || exp && exp.default === fn) {
	            wkey = key;
	            break;
	        }
	    }
	
	    if (!wkey) {
	        wkey = Math.floor(Math.pow(16, 8) * Math.random()).toString(16);
	        var wcache = {};
	        for (var i = 0, l = cacheKeys.length; i < l; i++) {
	            var key = cacheKeys[i];
	            wcache[key] = key;
	        }
	        sources[wkey] = [
	            'function(require,module,exports){' + fn + '(self); }',
	            wcache
	        ];
	    }
	    var skey = Math.floor(Math.pow(16, 8) * Math.random()).toString(16);
	
	    var scache = {}; scache[wkey] = wkey;
	    sources[skey] = [
	        'function(require,module,exports){' +
	            // try to call default if defined to also support babel esmodule exports
	            'var f = require(' + stringify(wkey) + ');' +
	            '(f.default ? f.default : f)(self);' +
	        '}',
	        scache
	    ];
	
	    var workerSources = {};
	    resolveSources(skey);
	
	    function resolveSources(key) {
	        workerSources[key] = true;
	
	        for (var depPath in sources[key][1]) {
	            var depKey = sources[key][1][depPath];
	            if (!workerSources[depKey]) {
	                resolveSources(depKey);
	            }
	        }
	    }
	
	    var src = '(' + bundleFn + ')({'
	        + Object.keys(workerSources).map(function (key) {
	            return stringify(key) + ':['
	                + sources[key][0]
	                + ',' + stringify(sources[key][1]) + ']'
	            ;
	        }).join(',')
	        + '},{},[' + stringify(skey) + '])'
	    ;
	
	    var URL = window.URL || window.webkitURL || window.mozURL || window.msURL;
	
	    var blob = new Blob([src], { type: 'text/javascript' });
	    if (options && options.bare) { return blob; }
	    var workerUrl = URL.createObjectURL(blob);
	    var worker = new Worker(workerUrl);
	    worker.objectURL = workerUrl;
	    return worker;
	};


/***/ })
/******/ ])
});
;


// WEBPACK FOOTER //
// bam-hls.js